App.filter('mainCareLocationFromZipCode', function () {

    var mainCareLocationByZipCode = {
        "00001": "WARSZAWA",
        "00002": "WARSZAWA",
        "00003": "WARSZAWA",
        "00004": "WARSZAWA",
        "00005": "WARSZAWA",
        "00006": "WARSZAWA",
        "00007": "WARSZAWA",
        "00008": "WARSZAWA",
        "00009": "WARSZAWA",
        "00010": "WARSZAWA",
        "00011": "WARSZAWA",
        "00012": "WARSZAWA",
        "00013": "WARSZAWA",
        "00014": "WARSZAWA",
        "00015": "WARSZAWA",
        "00016": "WARSZAWA",
        "00017": "WARSZAWA",
        "00018": "WARSZAWA",
        "00019": "WARSZAWA",
        "00020": "WARSZAWA",
        "00021": "WARSZAWA",
        "00022": "WARSZAWA",
        "00023": "WARSZAWA",
        "00024": "WARSZAWA",
        "00025": "WARSZAWA",
        "00026": "WARSZAWA",
        "00027": "WARSZAWA",
        "00028": "WARSZAWA",
        "00029": "WARSZAWA",
        "00030": "WARSZAWA",
        "00031": "WARSZAWA",
        "00032": "WARSZAWA",
        "00033": "WARSZAWA",
        "00034": "WARSZAWA",
        "00035": "WARSZAWA",
        "00036": "WARSZAWA",
        "00037": "WARSZAWA",
        "00038": "WARSZAWA",
        "00039": "WARSZAWA",
        "00040": "WARSZAWA",
        "00041": "WARSZAWA",
        "00042": "WARSZAWA",
        "00043": "WARSZAWA",
        "00044": "WARSZAWA",
        "00046": "WARSZAWA",
        "00047": "WARSZAWA",
        "00048": "WARSZAWA",
        "00049": "WARSZAWA",
        "00050": "WARSZAWA",
        "00051": "WARSZAWA",
        "00052": "WARSZAWA",
        "00054": "WARSZAWA",
        "00055": "WARSZAWA",
        "00056": "WARSZAWA",
        "00057": "WARSZAWA",
        "00058": "WARSZAWA",
        "00059": "WARSZAWA",
        "00060": "WARSZAWA",
        "00061": "WARSZAWA",
        "00062": "WARSZAWA",
        "00063": "WARSZAWA",
        "00064": "WARSZAWA",
        "00065": "WARSZAWA",
        "00066": "WARSZAWA",
        "00067": "WARSZAWA",
        "00068": "WARSZAWA",
        "00070": "WARSZAWA",
        "00071": "WARSZAWA",
        "00072": "WARSZAWA",
        "00073": "WARSZAWA",
        "00074": "WARSZAWA",
        "00075": "WARSZAWA",
        "00076": "WARSZAWA",
        "00077": "WARSZAWA",
        "00078": "WARSZAWA",
        "00079": "WARSZAWA",
        "00080": "WARSZAWA",
        "00081": "WARSZAWA",
        "00082": "WARSZAWA",
        "00083": "WARSZAWA",
        "00084": "WARSZAWA",
        "00085": "WARSZAWA",
        "00086": "WARSZAWA",
        "00087": "WARSZAWA",
        "00088": "WARSZAWA",
        "00089": "WARSZAWA",
        "00090": "WARSZAWA",
        "00091": "WARSZAWA",
        "00092": "WARSZAWA",
        "00093": "WARSZAWA",
        "00094": "WARSZAWA",
        "00095": "WARSZAWA",
        "00096": "WARSZAWA",
        "00097": "WARSZAWA",
        "00098": "WARSZAWA",
        "00099": "WARSZAWA",
        "00100": "WARSZAWA",
        "00102": "WARSZAWA",
        "00103": "WARSZAWA",
        "00104": "WARSZAWA",
        "00105": "WARSZAWA",
        "00107": "WARSZAWA",
        "00108": "WARSZAWA",
        "00109": "WARSZAWA",
        "00110": "WARSZAWA",
        "00111": "WARSZAWA",
        "00112": "WARSZAWA",
        "00113": "WARSZAWA",
        "00114": "WARSZAWA",
        "00115": "WARSZAWA",
        "00116": "WARSZAWA",
        "00117": "WARSZAWA",
        "00118": "WARSZAWA",
        "00119": "WARSZAWA",
        "00120": "WARSZAWA",
        "00121": "WARSZAWA",
        "00123": "WARSZAWA",
        "00124": "WARSZAWA",
        "00125": "WARSZAWA",
        "00126": "WARSZAWA",
        "00127": "WARSZAWA",
        "00130": "WARSZAWA",
        "00131": "WARSZAWA",
        "00132": "WARSZAWA",
        "00133": "WARSZAWA",
        "00135": "WARSZAWA",
        "00136": "WARSZAWA",
        "00137": "WARSZAWA",
        "00138": "WARSZAWA",
        "00139": "WARSZAWA",
        "00140": "WARSZAWA",
        "00141": "WARSZAWA",
        "00142": "WARSZAWA",
        "00143": "WARSZAWA",
        "00144": "WARSZAWA",
        "00145": "WARSZAWA",
        "00146": "WARSZAWA",
        "00147": "WARSZAWA",
        "00148": "WARSZAWA",
        "00149": "WARSZAWA",
        "00150": "WARSZAWA",
        "00151": "WARSZAWA",
        "00152": "WARSZAWA",
        "00153": "WARSZAWA",
        "00154": "WARSZAWA",
        "00155": "WARSZAWA",
        "00156": "WARSZAWA",
        "00157": "WARSZAWA",
        "00158": "WARSZAWA",
        "00159": "WARSZAWA",
        "00160": "WARSZAWA",
        "00161": "WARSZAWA",
        "00162": "WARSZAWA",
        "00163": "WARSZAWA",
        "00164": "WARSZAWA",
        "00165": "WARSZAWA",
        "00166": "WARSZAWA",
        "00167": "WARSZAWA",
        "00168": "WARSZAWA",
        "00169": "WARSZAWA",
        "00170": "WARSZAWA",
        "00171": "WARSZAWA",
        "00172": "WARSZAWA",
        "00173": "WARSZAWA",
        "00174": "WARSZAWA",
        "00175": "WARSZAWA",
        "00176": "WARSZAWA",
        "00177": "WARSZAWA",
        "00178": "WARSZAWA",
        "00179": "WARSZAWA",
        "00180": "WARSZAWA",
        "00181": "WARSZAWA",
        "00182": "WARSZAWA",
        "00183": "WARSZAWA",
        "00184": "WARSZAWA",
        "00185": "WARSZAWA",
        "00186": "WARSZAWA",
        "00187": "WARSZAWA",
        "00188": "WARSZAWA",
        "00189": "WARSZAWA",
        "00190": "WARSZAWA",
        "00191": "WARSZAWA",
        "00192": "WARSZAWA",
        "00193": "WARSZAWA",
        "00194": "WARSZAWA",
        "00195": "WARSZAWA",
        "00196": "WARSZAWA",
        "00197": "WARSZAWA",
        "00198": "WARSZAWA",
        "00199": "WARSZAWA",
        "00200": "WARSZAWA",
        "00201": "WARSZAWA",
        "00202": "WARSZAWA",
        "00203": "WARSZAWA",
        "00204": "WARSZAWA",
        "00205": "WARSZAWA",
        "00206": "WARSZAWA",
        "00207": "WARSZAWA",
        "00208": "WARSZAWA",
        "00209": "WARSZAWA",
        "00210": "WARSZAWA",
        "00211": "WARSZAWA",
        "00213": "WARSZAWA",
        "00214": "WARSZAWA",
        "00215": "WARSZAWA",
        "00216": "WARSZAWA",
        "00217": "WARSZAWA",
        "00218": "WARSZAWA",
        "00219": "WARSZAWA",
        "00220": "WARSZAWA",
        "00221": "WARSZAWA",
        "00222": "WARSZAWA",
        "00223": "WARSZAWA",
        "00224": "WARSZAWA",
        "00225": "WARSZAWA",
        "00227": "WARSZAWA",
        "00228": "WARSZAWA",
        "00229": "WARSZAWA",
        "00230": "WARSZAWA",
        "00231": "WARSZAWA",
        "00232": "WARSZAWA",
        "00233": "WARSZAWA",
        "00234": "WARSZAWA",
        "00235": "WARSZAWA",
        "00236": "WARSZAWA",
        "00237": "WARSZAWA",
        "00238": "WARSZAWA",
        "00240": "WARSZAWA",
        "00241": "WARSZAWA",
        "00242": "WARSZAWA",
        "00243": "WARSZAWA",
        "00244": "WARSZAWA",
        "00245": "WARSZAWA",
        "00246": "WARSZAWA",
        "00248": "WARSZAWA",
        "00249": "WARSZAWA",
        "00251": "WARSZAWA",
        "00252": "WARSZAWA",
        "00253": "WARSZAWA",
        "00254": "WARSZAWA",
        "00255": "WARSZAWA",
        "00256": "WARSZAWA",
        "00257": "WARSZAWA",
        "00258": "WARSZAWA",
        "00259": "WARSZAWA",
        "00260": "WARSZAWA",
        "00261": "WARSZAWA",
        "00262": "WARSZAWA",
        "00263": "WARSZAWA",
        "00264": "WARSZAWA",
        "00265": "WARSZAWA",
        "00266": "WARSZAWA",
        "00267": "WARSZAWA",
        "00268": "WARSZAWA",
        "00270": "WARSZAWA",
        "00271": "WARSZAWA",
        "00272": "WARSZAWA",
        "00273": "WARSZAWA",
        "00274": "WARSZAWA",
        "00275": "WARSZAWA",
        "00277": "WARSZAWA",
        "00278": "WARSZAWA",
        "00279": "WARSZAWA",
        "00280": "WARSZAWA",
        "00281": "WARSZAWA",
        "00282": "WARSZAWA",
        "00283": "WARSZAWA",
        "00284": "WARSZAWA",
        "00285": "WARSZAWA",
        "00286": "WARSZAWA",
        "00287": "WARSZAWA",
        "00288": "WARSZAWA",
        "00301": "WARSZAWA",
        "00302": "WARSZAWA",
        "00303": "WARSZAWA",
        "00304": "WARSZAWA",
        "00305": "WARSZAWA",
        "00306": "WARSZAWA",
        "00307": "WARSZAWA",
        "00308": "WARSZAWA",
        "00309": "WARSZAWA",
        "00310": "WARSZAWA",
        "00311": "WARSZAWA",
        "00312": "WARSZAWA",
        "00313": "WARSZAWA",
        "00314": "WARSZAWA",
        "00315": "WARSZAWA",
        "00316": "WARSZAWA",
        "00317": "WARSZAWA",
        "00318": "WARSZAWA",
        "00319": "WARSZAWA",
        "00321": "WARSZAWA",
        "00322": "WARSZAWA",
        "00324": "WARSZAWA",
        "00325": "WARSZAWA",
        "00327": "WARSZAWA",
        "00328": "WARSZAWA",
        "00330": "WARSZAWA",
        "00331": "WARSZAWA",
        "00332": "WARSZAWA",
        "00333": "WARSZAWA",
        "00334": "WARSZAWA",
        "00335": "WARSZAWA",
        "00336": "WARSZAWA",
        "00337": "WARSZAWA",
        "00338": "WARSZAWA",
        "00339": "WARSZAWA",
        "00340": "WARSZAWA",
        "00341": "WARSZAWA",
        "00342": "WARSZAWA",
        "00343": "WARSZAWA",
        "00344": "WARSZAWA",
        "00345": "WARSZAWA",
        "00346": "WARSZAWA",
        "00347": "WARSZAWA",
        "00348": "WARSZAWA",
        "00349": "WARSZAWA",
        "00350": "WARSZAWA",
        "00351": "WARSZAWA",
        "00353": "WARSZAWA",
        "00354": "WARSZAWA",
        "00355": "WARSZAWA",
        "00356": "WARSZAWA",
        "00357": "WARSZAWA",
        "00358": "WARSZAWA",
        "00359": "WARSZAWA",
        "00360": "WARSZAWA",
        "00362": "WARSZAWA",
        "00363": "WARSZAWA",
        "00364": "WARSZAWA",
        "00365": "WARSZAWA",
        "00366": "WARSZAWA",
        "00367": "WARSZAWA",
        "00368": "WARSZAWA",
        "00369": "WARSZAWA",
        "00370": "WARSZAWA",
        "00372": "WARSZAWA",
        "00373": "WARSZAWA",
        "00374": "WARSZAWA",
        "00375": "WARSZAWA",
        "00377": "WARSZAWA",
        "00378": "WARSZAWA",
        "00379": "WARSZAWA",
        "00380": "WARSZAWA",
        "00381": "WARSZAWA",
        "00382": "WARSZAWA",
        "00384": "WARSZAWA",
        "00385": "WARSZAWA",
        "00386": "WARSZAWA",
        "00388": "WARSZAWA",
        "00389": "WARSZAWA",
        "00390": "WARSZAWA",
        "00391": "WARSZAWA",
        "00392": "WARSZAWA",
        "00393": "WARSZAWA",
        "00394": "WARSZAWA",
        "00400": "WARSZAWA",
        "00401": "WARSZAWA",
        "00402": "WARSZAWA",
        "00403": "WARSZAWA",
        "00404": "WARSZAWA",
        "00405": "WARSZAWA",
        "00406": "WARSZAWA",
        "00407": "WARSZAWA",
        "00408": "WARSZAWA",
        "00409": "WARSZAWA",
        "00410": "WARSZAWA",
        "00411": "WARSZAWA",
        "00412": "WARSZAWA",
        "00413": "WARSZAWA",
        "00414": "WARSZAWA",
        "00415": "WARSZAWA",
        "00416": "WARSZAWA",
        "00417": "WARSZAWA",
        "00418": "WARSZAWA",
        "00419": "WARSZAWA",
        "00420": "WARSZAWA",
        "00421": "WARSZAWA",
        "00422": "WARSZAWA",
        "00423": "WARSZAWA",
        "00424": "WARSZAWA",
        "00425": "WARSZAWA",
        "00427": "WARSZAWA",
        "00428": "WARSZAWA",
        "00429": "WARSZAWA",
        "00430": "WARSZAWA",
        "00431": "WARSZAWA",
        "00432": "WARSZAWA",
        "00433": "WARSZAWA",
        "00434": "WARSZAWA",
        "00435": "WARSZAWA",
        "00436": "WARSZAWA",
        "00438": "WARSZAWA",
        "00439": "WARSZAWA",
        "00440": "WARSZAWA",
        "00441": "WARSZAWA",
        "00442": "WARSZAWA",
        "00443": "WARSZAWA",
        "00444": "WARSZAWA",
        "00446": "WARSZAWA",
        "00447": "WARSZAWA",
        "00448": "WARSZAWA",
        "00449": "WARSZAWA",
        "00450": "WARSZAWA",
        "00451": "WARSZAWA",
        "00452": "WARSZAWA",
        "00453": "WARSZAWA",
        "00454": "WARSZAWA",
        "00455": "WARSZAWA",
        "00456": "WARSZAWA",
        "00457": "WARSZAWA",
        "00458": "WARSZAWA",
        "00459": "WARSZAWA",
        "00460": "WARSZAWA",
        "00461": "WARSZAWA",
        "00462": "WARSZAWA",
        "00463": "WARSZAWA",
        "00464": "WARSZAWA",
        "00465": "WARSZAWA",
        "00466": "WARSZAWA",
        "00467": "WARSZAWA",
        "00468": "WARSZAWA",
        "00477": "WARSZAWA",
        "00478": "WARSZAWA",
        "00479": "WARSZAWA",
        "00480": "WARSZAWA",
        "00481": "WARSZAWA",
        "00482": "WARSZAWA",
        "00483": "WARSZAWA",
        "00484": "WARSZAWA",
        "00485": "WARSZAWA",
        "00486": "WARSZAWA",
        "00487": "WARSZAWA",
        "00488": "WARSZAWA",
        "00489": "WARSZAWA",
        "00490": "WARSZAWA",
        "00491": "WARSZAWA",
        "00492": "WARSZAWA",
        "00493": "WARSZAWA",
        "00495": "WARSZAWA",
        "00496": "WARSZAWA",
        "00497": "WARSZAWA",
        "00498": "WARSZAWA",
        "00499": "WARSZAWA",
        "00501": "WARSZAWA",
        "00502": "WARSZAWA",
        "00503": "WARSZAWA",
        "00504": "WARSZAWA",
        "00505": "WARSZAWA",
        "00507": "WARSZAWA",
        "00508": "WARSZAWA",
        "00509": "WARSZAWA",
        "00510": "WARSZAWA",
        "00511": "WARSZAWA",
        "00512": "WARSZAWA",
        "00513": "WARSZAWA",
        "00514": "WARSZAWA",
        "00515": "WARSZAWA",
        "00516": "WARSZAWA",
        "00517": "WARSZAWA",
        "00518": "WARSZAWA",
        "00519": "WARSZAWA",
        "00521": "WARSZAWA",
        "00522": "WARSZAWA",
        "00524": "WARSZAWA",
        "00525": "WARSZAWA",
        "00526": "WARSZAWA",
        "00527": "WARSZAWA",
        "00528": "WARSZAWA",
        "00529": "WARSZAWA",
        "00530": "WARSZAWA",
        "00532": "WARSZAWA",
        "00533": "WARSZAWA",
        "00534": "WARSZAWA",
        "00535": "WARSZAWA",
        "00536": "WARSZAWA",
        "00537": "WARSZAWA",
        "00538": "WARSZAWA",
        "00539": "WARSZAWA",
        "00540": "WARSZAWA",
        "00541": "WARSZAWA",
        "00542": "WARSZAWA",
        "00543": "WARSZAWA",
        "00544": "WARSZAWA",
        "00545": "WARSZAWA",
        "00546": "WARSZAWA",
        "00547": "WARSZAWA",
        "00548": "WARSZAWA",
        "00549": "WARSZAWA",
        "00550": "WARSZAWA",
        "00551": "WARSZAWA",
        "00552": "WARSZAWA",
        "00553": "WARSZAWA",
        "00554": "WARSZAWA",
        "00555": "WARSZAWA",
        "00556": "WARSZAWA",
        "00557": "WARSZAWA",
        "00558": "WARSZAWA",
        "00559": "WARSZAWA",
        "00560": "WARSZAWA",
        "00561": "WARSZAWA",
        "00562": "WARSZAWA",
        "00563": "WARSZAWA",
        "00564": "WARSZAWA",
        "00565": "WARSZAWA",
        "00566": "WARSZAWA",
        "00567": "WARSZAWA",
        "00568": "WARSZAWA",
        "00569": "WARSZAWA",
        "00570": "WARSZAWA",
        "00571": "WARSZAWA",
        "00572": "WARSZAWA",
        "00573": "WARSZAWA",
        "00574": "WARSZAWA",
        "00575": "WARSZAWA",
        "00576": "WARSZAWA",
        "00577": "WARSZAWA",
        "00578": "WARSZAWA",
        "00580": "WARSZAWA",
        "00581": "WARSZAWA",
        "00582": "WARSZAWA",
        "00583": "WARSZAWA",
        "00584": "WARSZAWA",
        "00585": "WARSZAWA",
        "00586": "WARSZAWA",
        "00587": "WARSZAWA",
        "00588": "WARSZAWA",
        "00589": "WARSZAWA",
        "00590": "WARSZAWA",
        "00591": "WARSZAWA",
        "00592": "WARSZAWA",
        "00594": "WARSZAWA",
        "00605": "WARSZAWA",
        "00608": "WARSZAWA",
        "00609": "WARSZAWA",
        "00610": "WARSZAWA",
        "00611": "WARSZAWA",
        "00613": "WARSZAWA",
        "00614": "WARSZAWA",
        "00620": "WARSZAWA",
        "00621": "WARSZAWA",
        "00622": "WARSZAWA",
        "00623": "WARSZAWA",
        "00624": "WARSZAWA",
        "00625": "WARSZAWA",
        "00626": "WARSZAWA",
        "00627": "WARSZAWA",
        "00628": "WARSZAWA",
        "00629": "WARSZAWA",
        "00630": "WARSZAWA",
        "00631": "WARSZAWA",
        "00632": "WARSZAWA",
        "00633": "WARSZAWA",
        "00634": "WARSZAWA",
        "00635": "WARSZAWA",
        "00636": "WARSZAWA",
        "00637": "WARSZAWA",
        "00638": "WARSZAWA",
        "00639": "WARSZAWA",
        "00640": "WARSZAWA",
        "00641": "WARSZAWA",
        "00642": "WARSZAWA",
        "00643": "WARSZAWA",
        "00644": "WARSZAWA",
        "00645": "WARSZAWA",
        "00646": "WARSZAWA",
        "00647": "WARSZAWA",
        "00648": "WARSZAWA",
        "00649": "WARSZAWA",
        "00650": "WARSZAWA",
        "00651": "WARSZAWA",
        "00653": "WARSZAWA",
        "00654": "WARSZAWA",
        "00655": "WARSZAWA",
        "00656": "WARSZAWA",
        "00657": "WARSZAWA",
        "00658": "WARSZAWA",
        "00659": "WARSZAWA",
        "00660": "WARSZAWA",
        "00661": "WARSZAWA",
        "00662": "WARSZAWA",
        "00663": "WARSZAWA",
        "00664": "WARSZAWA",
        "00665": "WARSZAWA",
        "00666": "WARSZAWA",
        "00667": "WARSZAWA",
        "00668": "WARSZAWA",
        "00669": "WARSZAWA",
        "00670": "WARSZAWA",
        "00671": "WARSZAWA",
        "00672": "WARSZAWA",
        "00673": "WARSZAWA",
        "00674": "WARSZAWA",
        "00675": "WARSZAWA",
        "00676": "WARSZAWA",
        "00677": "WARSZAWA",
        "00678": "WARSZAWA",
        "00679": "WARSZAWA",
        "00680": "WARSZAWA",
        "00681": "WARSZAWA",
        "00682": "WARSZAWA",
        "00683": "WARSZAWA",
        "00684": "WARSZAWA",
        "00685": "WARSZAWA",
        "00686": "WARSZAWA",
        "00687": "WARSZAWA",
        "00688": "WARSZAWA",
        "00689": "WARSZAWA",
        "00691": "WARSZAWA",
        "00692": "WARSZAWA",
        "00693": "WARSZAWA",
        "00694": "WARSZAWA",
        "00695": "WARSZAWA",
        "00696": "WARSZAWA",
        "00697": "WARSZAWA",
        "00698": "WARSZAWA",
        "00699": "WARSZAWA",
        "00701": "WARSZAWA",
        "00702": "WARSZAWA",
        "00703": "WARSZAWA",
        "00704": "WARSZAWA",
        "00705": "WARSZAWA",
        "00706": "WARSZAWA",
        "00707": "WARSZAWA",
        "00708": "WARSZAWA",
        "00709": "WARSZAWA",
        "00710": "WARSZAWA",
        "00711": "WARSZAWA",
        "00712": "WARSZAWA",
        "00713": "WARSZAWA",
        "00714": "WARSZAWA",
        "00715": "WARSZAWA",
        "00716": "WARSZAWA",
        "00717": "WARSZAWA",
        "00718": "WARSZAWA",
        "00719": "WARSZAWA",
        "00720": "WARSZAWA",
        "00721": "WARSZAWA",
        "00722": "WARSZAWA",
        "00723": "WARSZAWA",
        "00724": "WARSZAWA",
        "00725": "WARSZAWA",
        "00726": "WARSZAWA",
        "00727": "WARSZAWA",
        "00728": "WARSZAWA",
        "00730": "WARSZAWA",
        "00731": "WARSZAWA",
        "00732": "WARSZAWA",
        "00733": "WARSZAWA",
        "00734": "WARSZAWA",
        "00735": "WARSZAWA",
        "00736": "WARSZAWA",
        "00737": "WARSZAWA",
        "00738": "WARSZAWA",
        "00739": "WARSZAWA",
        "00740": "WARSZAWA",
        "00741": "WARSZAWA",
        "00742": "WARSZAWA",
        "00743": "WARSZAWA",
        "00745": "WARSZAWA",
        "00746": "WARSZAWA",
        "00747": "WARSZAWA",
        "00748": "WARSZAWA",
        "00749": "WARSZAWA",
        "00750": "WARSZAWA",
        "00752": "WARSZAWA",
        "00753": "WARSZAWA",
        "00754": "WARSZAWA",
        "00758": "WARSZAWA",
        "00759": "WARSZAWA",
        "00761": "WARSZAWA",
        "00762": "WARSZAWA",
        "00763": "WARSZAWA",
        "00764": "WARSZAWA",
        "00765": "WARSZAWA",
        "00766": "WARSZAWA",
        "00767": "WARSZAWA",
        "00768": "WARSZAWA",
        "00769": "WARSZAWA",
        "00770": "WARSZAWA",
        "00771": "WARSZAWA",
        "00772": "WARSZAWA",
        "00773": "WARSZAWA",
        "00774": "WARSZAWA",
        "00775": "WARSZAWA",
        "00777": "WARSZAWA",
        "00778": "WARSZAWA",
        "00780": "WARSZAWA",
        "00781": "WARSZAWA",
        "00782": "WARSZAWA",
        "00783": "WARSZAWA",
        "00784": "WARSZAWA",
        "00785": "WARSZAWA",
        "00787": "WARSZAWA",
        "00788": "WARSZAWA",
        "00789": "WARSZAWA",
        "00790": "WARSZAWA",
        "00791": "WARSZAWA",
        "00792": "WARSZAWA",
        "00793": "WARSZAWA",
        "00794": "WARSZAWA",
        "00795": "WARSZAWA",
        "00800": "WARSZAWA",
        "00801": "WARSZAWA",
        "00802": "WARSZAWA",
        "00803": "WARSZAWA",
        "00804": "WARSZAWA",
        "00805": "WARSZAWA",
        "00806": "WARSZAWA",
        "00807": "WARSZAWA",
        "00808": "WARSZAWA",
        "00809": "WARSZAWA",
        "00810": "WARSZAWA",
        "00811": "WARSZAWA",
        "00812": "WARSZAWA",
        "00813": "WARSZAWA",
        "00814": "WARSZAWA",
        "00815": "WARSZAWA",
        "00816": "WARSZAWA",
        "00817": "WARSZAWA",
        "00818": "WARSZAWA",
        "00819": "WARSZAWA",
        "00820": "WARSZAWA",
        "00821": "WARSZAWA",
        "00822": "WARSZAWA",
        "00823": "WARSZAWA",
        "00824": "WARSZAWA",
        "00825": "WARSZAWA",
        "00826": "WARSZAWA",
        "00827": "WARSZAWA",
        "00828": "WARSZAWA",
        "00830": "WARSZAWA",
        "00831": "WARSZAWA",
        "00832": "WARSZAWA",
        "00833": "WARSZAWA",
        "00834": "WARSZAWA",
        "00835": "WARSZAWA",
        "00836": "WARSZAWA",
        "00837": "WARSZAWA",
        "00838": "WARSZAWA",
        "00839": "WARSZAWA",
        "00840": "WARSZAWA",
        "00841": "WARSZAWA",
        "00842": "WARSZAWA",
        "00844": "WARSZAWA",
        "00845": "WARSZAWA",
        "00846": "WARSZAWA",
        "00847": "WARSZAWA",
        "00848": "WARSZAWA",
        "00849": "WARSZAWA",
        "00850": "WARSZAWA",
        "00851": "WARSZAWA",
        "00852": "WARSZAWA",
        "00853": "WARSZAWA",
        "00854": "WARSZAWA",
        "00855": "WARSZAWA",
        "00862": "WARSZAWA",
        "00863": "WARSZAWA",
        "00864": "WARSZAWA",
        "00865": "WARSZAWA",
        "00866": "WARSZAWA",
        "00867": "WARSZAWA",
        "00868": "WARSZAWA",
        "00869": "WARSZAWA",
        "00870": "WARSZAWA",
        "00871": "WARSZAWA",
        "00872": "WARSZAWA",
        "00873": "WARSZAWA",
        "00874": "WARSZAWA",
        "00875": "WARSZAWA",
        "00876": "WARSZAWA",
        "00877": "WARSZAWA",
        "00878": "WARSZAWA",
        "00879": "WARSZAWA",
        "00888": "WARSZAWA",
        "00890": "WARSZAWA",
        "00891": "WARSZAWA",
        "00892": "WARSZAWA",
        "00893": "WARSZAWA",
        "00894": "WARSZAWA",
        "00895": "WARSZAWA",
        "00896": "WARSZAWA",
        "00897": "WARSZAWA",
        "00898": "WARSZAWA",
        "00899": "WARSZAWA",
        "00900": "WARSZAWA",
        "00901": "WARSZAWA",
        "00902": "WARSZAWA",
        "00903": "WARSZAWA",
        "00904": "WARSZAWA",
        "00905": "WARSZAWA",
        "00906": "WARSZAWA",
        "00908": "WARSZAWA",
        "00909": "WARSZAWA",
        "00910": "WARSZAWA",
        "00911": "WARSZAWA",
        "00912": "WARSZAWA",
        "00914": "WARSZAWA",
        "00915": "WARSZAWA",
        "00916": "WARSZAWA",
        "00917": "WARSZAWA",
        "00918": "WARSZAWA",
        "00919": "WARSZAWA",
        "00920": "WARSZAWA",
        "00921": "WARSZAWA",
        "00922": "WARSZAWA",
        "00923": "WARSZAWA",
        "00924": "WARSZAWA",
        "00925": "WARSZAWA",
        "00926": "WARSZAWA",
        "00927": "WARSZAWA",
        "00928": "WARSZAWA",
        "00929": "WARSZAWA",
        "00930": "WARSZAWA",
        "00931": "WARSZAWA",
        "00932": "WARSZAWA",
        "00933": "WARSZAWA",
        "00934": "WARSZAWA",
        "00937": "WARSZAWA",
        "00939": "WARSZAWA",
        "00940": "WARSZAWA",
        "00941": "WARSZAWA",
        "00942": "WARSZAWA",
        "00943": "WARSZAWA",
        "00944": "WARSZAWA",
        "00945": "WARSZAWA",
        "00950": "WARSZAWA",
        "00951": "WARSZAWA",
        "00952": "WARSZAWA",
        "00953": "WARSZAWA",
        "00954": "WARSZAWA",
        "00955": "WARSZAWA",
        "00956": "WARSZAWA",
        "00957": "WARSZAWA",
        "00958": "WARSZAWA",
        "00959": "WARSZAWA",
        "00960": "WARSZAWA",
        "00961": "WARSZAWA",
        "00962": "WARSZAWA",
        "00963": "WARSZAWA",
        "00964": "WARSZAWA",
        "00965": "WARSZAWA",
        "00967": "WARSZAWA",
        "00968": "WARSZAWA",
        "00970": "WARSZAWA",
        "00971": "WARSZAWA",
        "00972": "WARSZAWA",
        "00973": "WARSZAWA",
        "00974": "WARSZAWA",
        "00975": "WARSZAWA",
        "00976": "WARSZAWA",
        "00977": "WARSZAWA",
        "00978": "WARSZAWA",
        "00979": "WARSZAWA",
        "00980": "WARSZAWA",
        "00981": "WARSZAWA",
        "00982": "WARSZAWA",
        "00983": "WARSZAWA",
        "00984": "WARSZAWA",
        "00986": "WARSZAWA",
        "00987": "WARSZAWA",
        "00988": "WARSZAWA",
        "00989": "WARSZAWA",
        "00991": "WARSZAWA",
        "00992": "WARSZAWA",
        "00993": "WARSZAWA",
        "00996": "WARSZAWA",
        "00997": "WARSZAWA",
        "00998": "WARSZAWA",
        "00999": "WARSZAWA",
        "01001": "WARSZAWA",
        "01002": "WARSZAWA",
        "01003": "WARSZAWA",
        "01004": "WARSZAWA",
        "01005": "WARSZAWA",
        "01006": "WARSZAWA",
        "01007": "WARSZAWA",
        "01008": "WARSZAWA",
        "01009": "WARSZAWA",
        "01010": "WARSZAWA",
        "01011": "WARSZAWA",
        "01012": "WARSZAWA",
        "01013": "WARSZAWA",
        "01014": "WARSZAWA",
        "01015": "WARSZAWA",
        "01016": "WARSZAWA",
        "01017": "WARSZAWA",
        "01018": "WARSZAWA",
        "01019": "WARSZAWA",
        "01020": "WARSZAWA",
        "01021": "WARSZAWA",
        "01022": "WARSZAWA",
        "01023": "WARSZAWA",
        "01024": "WARSZAWA",
        "01025": "WARSZAWA",
        "01026": "WARSZAWA",
        "01027": "WARSZAWA",
        "01029": "WARSZAWA",
        "01030": "WARSZAWA",
        "01031": "WARSZAWA",
        "01032": "WARSZAWA",
        "01033": "WARSZAWA",
        "01034": "WARSZAWA",
        "01036": "WARSZAWA",
        "01037": "WARSZAWA",
        "01038": "WARSZAWA",
        "01039": "WARSZAWA",
        "01040": "WARSZAWA",
        "01041": "WARSZAWA",
        "01042": "WARSZAWA",
        "01043": "WARSZAWA",
        "01044": "WARSZAWA",
        "01045": "WARSZAWA",
        "01046": "WARSZAWA",
        "01047": "WARSZAWA",
        "01048": "WARSZAWA",
        "01049": "WARSZAWA",
        "01050": "WARSZAWA",
        "01051": "WARSZAWA",
        "01052": "WARSZAWA",
        "01053": "WARSZAWA",
        "01054": "WARSZAWA",
        "01056": "WARSZAWA",
        "01057": "WARSZAWA",
        "01058": "WARSZAWA",
        "01059": "WARSZAWA",
        "01060": "WARSZAWA",
        "01061": "WARSZAWA",
        "01063": "WARSZAWA",
        "01064": "WARSZAWA",
        "01065": "WARSZAWA",
        "01066": "WARSZAWA",
        "01067": "WARSZAWA",
        "01068": "WARSZAWA",
        "01100": "WARSZAWA",
        "01101": "WARSZAWA",
        "01102": "WARSZAWA",
        "01103": "WARSZAWA",
        "01104": "WARSZAWA",
        "01105": "WARSZAWA",
        "01106": "WARSZAWA",
        "01107": "WARSZAWA",
        "01108": "WARSZAWA",
        "01109": "WARSZAWA",
        "01110": "WARSZAWA",
        "01111": "WARSZAWA",
        "01112": "WARSZAWA",
        "01113": "WARSZAWA",
        "01114": "WARSZAWA",
        "01115": "WARSZAWA",
        "01116": "WARSZAWA",
        "01117": "WARSZAWA",
        "01118": "WARSZAWA",
        "01119": "WARSZAWA",
        "01120": "WARSZAWA",
        "01121": "WARSZAWA",
        "01122": "WARSZAWA",
        "01123": "WARSZAWA",
        "01124": "WARSZAWA",
        "01125": "WARSZAWA",
        "01126": "WARSZAWA",
        "01127": "WARSZAWA",
        "01128": "WARSZAWA",
        "01129": "WARSZAWA",
        "01130": "WARSZAWA",
        "01131": "WARSZAWA",
        "01132": "WARSZAWA",
        "01133": "WARSZAWA",
        "01134": "WARSZAWA",
        "01135": "WARSZAWA",
        "01136": "WARSZAWA",
        "01137": "WARSZAWA",
        "01138": "WARSZAWA",
        "01139": "WARSZAWA",
        "01140": "WARSZAWA",
        "01141": "WARSZAWA",
        "01142": "WARSZAWA",
        "01143": "WARSZAWA",
        "01144": "WARSZAWA",
        "01145": "WARSZAWA",
        "01146": "WARSZAWA",
        "01147": "WARSZAWA",
        "01148": "WARSZAWA",
        "01149": "WARSZAWA",
        "01150": "WARSZAWA",
        "01151": "WARSZAWA",
        "01152": "WARSZAWA",
        "01153": "WARSZAWA",
        "01154": "WARSZAWA",
        "01155": "WARSZAWA",
        "01156": "WARSZAWA",
        "01157": "WARSZAWA",
        "01158": "WARSZAWA",
        "01159": "WARSZAWA",
        "01160": "WARSZAWA",
        "01161": "WARSZAWA",
        "01162": "WARSZAWA",
        "01163": "WARSZAWA",
        "01164": "WARSZAWA",
        "01165": "WARSZAWA",
        "01166": "WARSZAWA",
        "01167": "WARSZAWA",
        "01168": "WARSZAWA",
        "01169": "WARSZAWA",
        "01170": "WARSZAWA",
        "01171": "WARSZAWA",
        "01172": "WARSZAWA",
        "01173": "WARSZAWA",
        "01174": "WARSZAWA",
        "01175": "WARSZAWA",
        "01176": "WARSZAWA",
        "01177": "WARSZAWA",
        "01178": "WARSZAWA",
        "01179": "WARSZAWA",
        "01180": "WARSZAWA",
        "01181": "WARSZAWA",
        "01182": "WARSZAWA",
        "01183": "WARSZAWA",
        "01184": "WARSZAWA",
        "01186": "WARSZAWA",
        "01187": "WARSZAWA",
        "01188": "WARSZAWA",
        "01189": "WARSZAWA",
        "01190": "WARSZAWA",
        "01191": "WARSZAWA",
        "01192": "WARSZAWA",
        "01193": "WARSZAWA",
        "01194": "WARSZAWA",
        "01195": "WARSZAWA",
        "01196": "WARSZAWA",
        "01197": "WARSZAWA",
        "01198": "WARSZAWA",
        "01199": "WARSZAWA",
        "01201": "WARSZAWA",
        "01202": "WARSZAWA",
        "01203": "WARSZAWA",
        "01204": "WARSZAWA",
        "01205": "WARSZAWA",
        "01206": "WARSZAWA",
        "01207": "WARSZAWA",
        "01208": "WARSZAWA",
        "01209": "WARSZAWA",
        "01210": "WARSZAWA",
        "01211": "WARSZAWA",
        "01212": "WARSZAWA",
        "01213": "WARSZAWA",
        "01214": "WARSZAWA",
        "01216": "WARSZAWA",
        "01217": "WARSZAWA",
        "01218": "WARSZAWA",
        "01219": "WARSZAWA",
        "01220": "WARSZAWA",
        "01221": "WARSZAWA",
        "01222": "WARSZAWA",
        "01223": "WARSZAWA",
        "01224": "WARSZAWA",
        "01225": "WARSZAWA",
        "01226": "WARSZAWA",
        "01227": "WARSZAWA",
        "01228": "WARSZAWA",
        "01229": "WARSZAWA",
        "01230": "WARSZAWA",
        "01231": "WARSZAWA",
        "01232": "WARSZAWA",
        "01233": "WARSZAWA",
        "01234": "WARSZAWA",
        "01235": "WARSZAWA",
        "01236": "WARSZAWA",
        "01237": "WARSZAWA",
        "01238": "WARSZAWA",
        "01239": "WARSZAWA",
        "01240": "WARSZAWA",
        "01241": "WARSZAWA",
        "01242": "WARSZAWA",
        "01243": "WARSZAWA",
        "01244": "WARSZAWA",
        "01245": "WARSZAWA",
        "01246": "WARSZAWA",
        "01247": "WARSZAWA",
        "01248": "WARSZAWA",
        "01249": "WARSZAWA",
        "01250": "WARSZAWA",
        "01251": "WARSZAWA",
        "01252": "WARSZAWA",
        "01253": "WARSZAWA",
        "01254": "WARSZAWA",
        "01255": "WARSZAWA",
        "01258": "WARSZAWA",
        "01259": "WARSZAWA",
        "01260": "WARSZAWA",
        "01261": "WARSZAWA",
        "01262": "WARSZAWA",
        "01263": "WARSZAWA",
        "01264": "WARSZAWA",
        "01265": "WARSZAWA",
        "01266": "WARSZAWA",
        "01267": "WARSZAWA",
        "01301": "WARSZAWA",
        "01302": "WARSZAWA",
        "01303": "WARSZAWA",
        "01304": "WARSZAWA",
        "01305": "WARSZAWA",
        "01306": "WARSZAWA",
        "01307": "WARSZAWA",
        "01308": "WARSZAWA",
        "01309": "WARSZAWA",
        "01310": "WARSZAWA",
        "01312": "WARSZAWA",
        "01313": "WARSZAWA",
        "01314": "WARSZAWA",
        "01315": "WARSZAWA",
        "01317": "WARSZAWA",
        "01318": "WARSZAWA",
        "01319": "WARSZAWA",
        "01320": "WARSZAWA",
        "01321": "WARSZAWA",
        "01323": "WARSZAWA",
        "01327": "WARSZAWA",
        "01328": "WARSZAWA",
        "01329": "WARSZAWA",
        "01330": "WARSZAWA",
        "01336": "WARSZAWA",
        "01337": "WARSZAWA",
        "01338": "WARSZAWA",
        "01339": "WARSZAWA",
        "01340": "WARSZAWA",
        "01341": "WARSZAWA",
        "01342": "WARSZAWA",
        "01343": "WARSZAWA",
        "01345": "WARSZAWA",
        "01346": "WARSZAWA",
        "01347": "WARSZAWA",
        "01348": "WARSZAWA",
        "01349": "WARSZAWA",
        "01350": "WARSZAWA",
        "01351": "WARSZAWA",
        "01352": "WARSZAWA",
        "01353": "WARSZAWA",
        "01354": "WARSZAWA",
        "01355": "WARSZAWA",
        "01356": "WARSZAWA",
        "01357": "WARSZAWA",
        "01358": "WARSZAWA",
        "01359": "WARSZAWA",
        "01360": "WARSZAWA",
        "01361": "WARSZAWA",
        "01362": "WARSZAWA",
        "01364": "WARSZAWA",
        "01365": "WARSZAWA",
        "01366": "WARSZAWA",
        "01367": "WARSZAWA",
        "01368": "WARSZAWA",
        "01373": "WARSZAWA",
        "01374": "WARSZAWA",
        "01376": "WARSZAWA",
        "01377": "WARSZAWA",
        "01378": "WARSZAWA",
        "01380": "WARSZAWA",
        "01381": "WARSZAWA",
        "01382": "WARSZAWA",
        "01383": "WARSZAWA",
        "01384": "WARSZAWA",
        "01385": "WARSZAWA",
        "01386": "WARSZAWA",
        "01387": "WARSZAWA",
        "01388": "WARSZAWA",
        "01389": "WARSZAWA",
        "01390": "WARSZAWA",
        "01391": "WARSZAWA",
        "01392": "WARSZAWA",
        "01401": "WARSZAWA",
        "01402": "WARSZAWA",
        "01405": "WARSZAWA",
        "01406": "WARSZAWA",
        "01407": "WARSZAWA",
        "01408": "WARSZAWA",
        "01409": "WARSZAWA",
        "01410": "WARSZAWA",
        "01411": "WARSZAWA",
        "01413": "WARSZAWA",
        "01416": "WARSZAWA",
        "01417": "WARSZAWA",
        "01418": "WARSZAWA",
        "01419": "WARSZAWA",
        "01420": "WARSZAWA",
        "01421": "WARSZAWA",
        "01422": "WARSZAWA",
        "01423": "WARSZAWA",
        "01424": "WARSZAWA",
        "01425": "WARSZAWA",
        "01426": "WARSZAWA",
        "01428": "WARSZAWA",
        "01429": "WARSZAWA",
        "01431": "WARSZAWA",
        "01432": "WARSZAWA",
        "01433": "WARSZAWA",
        "01434": "WARSZAWA",
        "01436": "WARSZAWA",
        "01437": "WARSZAWA",
        "01438": "WARSZAWA",
        "01439": "WARSZAWA",
        "01441": "WARSZAWA",
        "01442": "WARSZAWA",
        "01443": "WARSZAWA",
        "01444": "WARSZAWA",
        "01445": "WARSZAWA",
        "01446": "WARSZAWA",
        "01447": "WARSZAWA",
        "01448": "WARSZAWA",
        "01449": "WARSZAWA",
        "01450": "WARSZAWA",
        "01451": "WARSZAWA",
        "01452": "WARSZAWA",
        "01456": "WARSZAWA",
        "01457": "WARSZAWA",
        "01458": "WARSZAWA",
        "01459": "WARSZAWA",
        "01460": "WARSZAWA",
        "01461": "WARSZAWA",
        "01462": "WARSZAWA",
        "01464": "WARSZAWA",
        "01465": "WARSZAWA",
        "01466": "WARSZAWA",
        "01467": "WARSZAWA",
        "01468": "WARSZAWA",
        "01469": "WARSZAWA",
        "01470": "WARSZAWA",
        "01471": "WARSZAWA",
        "01472": "WARSZAWA",
        "01473": "WARSZAWA",
        "01474": "WARSZAWA",
        "01475": "WARSZAWA",
        "01476": "WARSZAWA",
        "01477": "WARSZAWA",
        "01478": "WARSZAWA",
        "01479": "WARSZAWA",
        "01480": "WARSZAWA",
        "01481": "WARSZAWA",
        "01482": "WARSZAWA",
        "01483": "WARSZAWA",
        "01485": "WARSZAWA",
        "01486": "WARSZAWA",
        "01487": "WARSZAWA",
        "01488": "WARSZAWA",
        "01489": "WARSZAWA",
        "01490": "WARSZAWA",
        "01491": "WARSZAWA",
        "01492": "WARSZAWA",
        "01493": "WARSZAWA",
        "01494": "WARSZAWA",
        "01495": "WARSZAWA",
        "01496": "WARSZAWA",
        "01497": "WARSZAWA",
        "01498": "WARSZAWA",
        "01499": "WARSZAWA",
        "01501": "WARSZAWA",
        "01502": "WARSZAWA",
        "01503": "WARSZAWA",
        "01504": "WARSZAWA",
        "01505": "WARSZAWA",
        "01506": "WARSZAWA",
        "01507": "WARSZAWA",
        "01508": "WARSZAWA",
        "01510": "WARSZAWA",
        "01511": "WARSZAWA",
        "01512": "WARSZAWA",
        "01513": "WARSZAWA",
        "01514": "WARSZAWA",
        "01515": "WARSZAWA",
        "01517": "WARSZAWA",
        "01518": "WARSZAWA",
        "01519": "WARSZAWA",
        "01520": "WARSZAWA",
        "01521": "WARSZAWA",
        "01522": "WARSZAWA",
        "01523": "WARSZAWA",
        "01524": "WARSZAWA",
        "01526": "WARSZAWA",
        "01527": "WARSZAWA",
        "01528": "WARSZAWA",
        "01529": "WARSZAWA",
        "01530": "WARSZAWA",
        "01531": "WARSZAWA",
        "01532": "WARSZAWA",
        "01533": "WARSZAWA",
        "01534": "WARSZAWA",
        "01535": "WARSZAWA",
        "01536": "WARSZAWA",
        "01537": "WARSZAWA",
        "01538": "WARSZAWA",
        "01539": "WARSZAWA",
        "01540": "WARSZAWA",
        "01541": "WARSZAWA",
        "01542": "WARSZAWA",
        "01543": "WARSZAWA",
        "01547": "WARSZAWA",
        "01548": "WARSZAWA",
        "01549": "WARSZAWA",
        "01551": "WARSZAWA",
        "01552": "WARSZAWA",
        "01553": "WARSZAWA",
        "01554": "WARSZAWA",
        "01555": "WARSZAWA",
        "01556": "WARSZAWA",
        "01557": "WARSZAWA",
        "01558": "WARSZAWA",
        "01559": "WARSZAWA",
        "01560": "WARSZAWA",
        "01562": "WARSZAWA",
        "01563": "WARSZAWA",
        "01564": "WARSZAWA",
        "01565": "WARSZAWA",
        "01566": "WARSZAWA",
        "01567": "WARSZAWA",
        "01568": "WARSZAWA",
        "01569": "WARSZAWA",
        "01570": "WARSZAWA",
        "01571": "WARSZAWA",
        "01572": "WARSZAWA",
        "01573": "WARSZAWA",
        "01574": "WARSZAWA",
        "01576": "WARSZAWA",
        "01577": "WARSZAWA",
        "01578": "WARSZAWA",
        "01579": "WARSZAWA",
        "01580": "WARSZAWA",
        "01581": "WARSZAWA",
        "01582": "WARSZAWA",
        "01583": "WARSZAWA",
        "01584": "WARSZAWA",
        "01585": "WARSZAWA",
        "01586": "WARSZAWA",
        "01587": "WARSZAWA",
        "01588": "WARSZAWA",
        "01589": "WARSZAWA",
        "01590": "WARSZAWA",
        "01592": "WARSZAWA",
        "01593": "WARSZAWA",
        "01594": "WARSZAWA",
        "01595": "WARSZAWA",
        "01601": "WARSZAWA",
        "01602": "WARSZAWA",
        "01603": "WARSZAWA",
        "01604": "WARSZAWA",
        "01605": "WARSZAWA",
        "01606": "WARSZAWA",
        "01607": "WARSZAWA",
        "01608": "WARSZAWA",
        "01609": "WARSZAWA",
        "01610": "WARSZAWA",
        "01611": "WARSZAWA",
        "01612": "WARSZAWA",
        "01613": "WARSZAWA",
        "01614": "WARSZAWA",
        "01615": "WARSZAWA",
        "01616": "WARSZAWA",
        "01617": "WARSZAWA",
        "01618": "WARSZAWA",
        "01619": "WARSZAWA",
        "01620": "WARSZAWA",
        "01621": "WARSZAWA",
        "01622": "WARSZAWA",
        "01623": "WARSZAWA",
        "01624": "WARSZAWA",
        "01625": "WARSZAWA",
        "01626": "WARSZAWA",
        "01627": "WARSZAWA",
        "01628": "WARSZAWA",
        "01629": "WARSZAWA",
        "01630": "WARSZAWA",
        "01631": "WARSZAWA",
        "01632": "WARSZAWA",
        "01633": "WARSZAWA",
        "01634": "WARSZAWA",
        "01635": "WARSZAWA",
        "01636": "WARSZAWA",
        "01637": "WARSZAWA",
        "01638": "WARSZAWA",
        "01639": "WARSZAWA",
        "01640": "WARSZAWA",
        "01641": "WARSZAWA",
        "01643": "WARSZAWA",
        "01644": "WARSZAWA",
        "01645": "WARSZAWA",
        "01646": "WARSZAWA",
        "01647": "WARSZAWA",
        "01648": "WARSZAWA",
        "01649": "WARSZAWA",
        "01650": "WARSZAWA",
        "01651": "WARSZAWA",
        "01652": "WARSZAWA",
        "01654": "WARSZAWA",
        "01656": "WARSZAWA",
        "01658": "WARSZAWA",
        "01659": "WARSZAWA",
        "01664": "WARSZAWA",
        "01665": "WARSZAWA",
        "01669": "WARSZAWA",
        "01670": "WARSZAWA",
        "01673": "WARSZAWA",
        "01674": "WARSZAWA",
        "01677": "WARSZAWA",
        "01678": "WARSZAWA",
        "01679": "WARSZAWA",
        "01680": "WARSZAWA",
        "01681": "WARSZAWA",
        "01682": "WARSZAWA",
        "01683": "WARSZAWA",
        "01684": "WARSZAWA",
        "01685": "WARSZAWA",
        "01687": "WARSZAWA",
        "01688": "WARSZAWA",
        "01689": "WARSZAWA",
        "01690": "WARSZAWA",
        "01691": "WARSZAWA",
        "01692": "WARSZAWA",
        "01693": "WARSZAWA",
        "01694": "WARSZAWA",
        "01695": "WARSZAWA",
        "01696": "WARSZAWA",
        "01697": "WARSZAWA",
        "01698": "WARSZAWA",
        "01699": "WARSZAWA",
        "01702": "WARSZAWA",
        "01703": "WARSZAWA",
        "01707": "WARSZAWA",
        "01708": "WARSZAWA",
        "01709": "WARSZAWA",
        "01710": "WARSZAWA",
        "01711": "WARSZAWA",
        "01715": "WARSZAWA",
        "01716": "WARSZAWA",
        "01727": "WARSZAWA",
        "01728": "WARSZAWA",
        "01730": "WARSZAWA",
        "01735": "WARSZAWA",
        "01736": "WARSZAWA",
        "01737": "WARSZAWA",
        "01738": "WARSZAWA",
        "01739": "WARSZAWA",
        "01740": "WARSZAWA",
        "01741": "WARSZAWA",
        "01742": "WARSZAWA",
        "01743": "WARSZAWA",
        "01745": "WARSZAWA",
        "01747": "WARSZAWA",
        "01748": "WARSZAWA",
        "01749": "WARSZAWA",
        "01755": "WARSZAWA",
        "01756": "WARSZAWA",
        "01769": "WARSZAWA",
        "01770": "WARSZAWA",
        "01771": "WARSZAWA",
        "01772": "WARSZAWA",
        "01773": "WARSZAWA",
        "01779": "WARSZAWA",
        "01780": "WARSZAWA",
        "01783": "WARSZAWA",
        "01784": "WARSZAWA",
        "01785": "WARSZAWA",
        "01786": "WARSZAWA",
        "01787": "WARSZAWA",
        "01792": "WARSZAWA",
        "01793": "WARSZAWA",
        "01794": "WARSZAWA",
        "01796": "WARSZAWA",
        "01797": "WARSZAWA",
        "01798": "WARSZAWA",
        "01800": "WARSZAWA",
        "01801": "WARSZAWA",
        "01802": "WARSZAWA",
        "01803": "WARSZAWA",
        "01804": "WARSZAWA",
        "01805": "WARSZAWA",
        "01806": "WARSZAWA",
        "01807": "WARSZAWA",
        "01808": "WARSZAWA",
        "01809": "WARSZAWA",
        "01810": "WARSZAWA",
        "01811": "WARSZAWA",
        "01812": "WARSZAWA",
        "01813": "WARSZAWA",
        "01815": "WARSZAWA",
        "01817": "WARSZAWA",
        "01818": "WARSZAWA",
        "01819": "WARSZAWA",
        "01820": "WARSZAWA",
        "01821": "WARSZAWA",
        "01822": "WARSZAWA",
        "01823": "WARSZAWA",
        "01824": "WARSZAWA",
        "01825": "WARSZAWA",
        "01826": "WARSZAWA",
        "01827": "WARSZAWA",
        "01828": "WARSZAWA",
        "01829": "WARSZAWA",
        "01830": "WARSZAWA",
        "01831": "WARSZAWA",
        "01832": "WARSZAWA",
        "01833": "WARSZAWA",
        "01834": "WARSZAWA",
        "01835": "WARSZAWA",
        "01836": "WARSZAWA",
        "01837": "WARSZAWA",
        "01838": "WARSZAWA",
        "01839": "WARSZAWA",
        "01840": "WARSZAWA",
        "01841": "WARSZAWA",
        "01842": "WARSZAWA",
        "01843": "WARSZAWA",
        "01844": "WARSZAWA",
        "01845": "WARSZAWA",
        "01846": "WARSZAWA",
        "01847": "WARSZAWA",
        "01848": "WARSZAWA",
        "01849": "WARSZAWA",
        "01850": "WARSZAWA",
        "01851": "WARSZAWA",
        "01852": "WARSZAWA",
        "01853": "WARSZAWA",
        "01854": "WARSZAWA",
        "01855": "WARSZAWA",
        "01856": "WARSZAWA",
        "01857": "WARSZAWA",
        "01858": "WARSZAWA",
        "01859": "WARSZAWA",
        "01860": "WARSZAWA",
        "01861": "WARSZAWA",
        "01862": "WARSZAWA",
        "01863": "WARSZAWA",
        "01864": "WARSZAWA",
        "01865": "WARSZAWA",
        "01866": "WARSZAWA",
        "01867": "WARSZAWA",
        "01868": "WARSZAWA",
        "01869": "WARSZAWA",
        "01870": "WARSZAWA",
        "01871": "WARSZAWA",
        "01872": "WARSZAWA",
        "01873": "WARSZAWA",
        "01874": "WARSZAWA",
        "01875": "WARSZAWA",
        "01876": "WARSZAWA",
        "01877": "WARSZAWA",
        "01880": "WARSZAWA",
        "01881": "WARSZAWA",
        "01882": "WARSZAWA",
        "01883": "WARSZAWA",
        "01884": "WARSZAWA",
        "01885": "WARSZAWA",
        "01886": "WARSZAWA",
        "01887": "WARSZAWA",
        "01888": "WARSZAWA",
        "01890": "WARSZAWA",
        "01891": "WARSZAWA",
        "01892": "WARSZAWA",
        "01893": "WARSZAWA",
        "01900": "WARSZAWA",
        "01903": "WARSZAWA",
        "01904": "WARSZAWA",
        "01905": "WARSZAWA",
        "01906": "WARSZAWA",
        "01908": "WARSZAWA",
        "01909": "WARSZAWA",
        "01910": "WARSZAWA",
        "01911": "WARSZAWA",
        "01912": "WARSZAWA",
        "01913": "WARSZAWA",
        "01914": "WARSZAWA",
        "01915": "WARSZAWA",
        "01916": "WARSZAWA",
        "01917": "WARSZAWA",
        "01918": "WARSZAWA",
        "01919": "WARSZAWA",
        "01920": "WARSZAWA",
        "01921": "WARSZAWA",
        "01922": "WARSZAWA",
        "01923": "WARSZAWA",
        "01924": "WARSZAWA",
        "01925": "WARSZAWA",
        "01926": "WARSZAWA",
        "01927": "WARSZAWA",
        "01928": "WARSZAWA",
        "01929": "WARSZAWA",
        "01930": "WARSZAWA",
        "01931": "WARSZAWA",
        "01932": "WARSZAWA",
        "01934": "WARSZAWA",
        "01935": "WARSZAWA",
        "01936": "WARSZAWA",
        "01937": "WARSZAWA",
        "01938": "WARSZAWA",
        "01939": "WARSZAWA",
        "01940": "WARSZAWA",
        "01941": "WARSZAWA",
        "01942": "WARSZAWA",
        "01943": "WARSZAWA",
        "01944": "WARSZAWA",
        "01945": "WARSZAWA",
        "01946": "WARSZAWA",
        "01947": "WARSZAWA",
        "01948": "WARSZAWA",
        "01949": "WARSZAWA",
        "01950": "WARSZAWA",
        "01951": "WARSZAWA",
        "01952": "WARSZAWA",
        "01953": "WARSZAWA",
        "01954": "WARSZAWA",
        "01956": "WARSZAWA",
        "01957": "WARSZAWA",
        "01958": "WARSZAWA",
        "01960": "WARSZAWA",
        "01961": "WARSZAWA",
        "01962": "WARSZAWA",
        "01963": "WARSZAWA",
        "01964": "WARSZAWA",
        "01966": "WARSZAWA",
        "01968": "WARSZAWA",
        "01969": "WARSZAWA",
        "01970": "WARSZAWA",
        "01971": "WARSZAWA",
        "01972": "WARSZAWA",
        "01973": "WARSZAWA",
        "01974": "WARSZAWA",
        "01975": "WARSZAWA",
        "01976": "WARSZAWA",
        "01977": "WARSZAWA",
        "01978": "WARSZAWA",
        "01979": "WARSZAWA",
        "01980": "WARSZAWA",
        "01981": "WARSZAWA",
        "01982": "WARSZAWA",
        "01983": "WARSZAWA",
        "01985": "WARSZAWA",
        "01986": "WARSZAWA",
        "01987": "WARSZAWA",
        "01988": "WARSZAWA",
        "01989": "WARSZAWA",
        "01990": "WARSZAWA",
        "01991": "WARSZAWA",
        "01992": "WARSZAWA",
        "01993": "WARSZAWA",
        "01994": "WARSZAWA",
        "01995": "WARSZAWA",
        "01999": "WARSZAWA",
        "02001": "WARSZAWA",
        "02002": "WARSZAWA",
        "02004": "WARSZAWA",
        "02005": "WARSZAWA",
        "02006": "WARSZAWA",
        "02007": "WARSZAWA",
        "02008": "WARSZAWA",
        "02009": "WARSZAWA",
        "02010": "WARSZAWA",
        "02011": "WARSZAWA",
        "02012": "WARSZAWA",
        "02013": "WARSZAWA",
        "02014": "WARSZAWA",
        "02015": "WARSZAWA",
        "02017": "WARSZAWA",
        "02018": "WARSZAWA",
        "02019": "WARSZAWA",
        "02020": "WARSZAWA",
        "02021": "WARSZAWA",
        "02022": "WARSZAWA",
        "02023": "WARSZAWA",
        "02024": "WARSZAWA",
        "02025": "WARSZAWA",
        "02026": "WARSZAWA",
        "02027": "WARSZAWA",
        "02028": "WARSZAWA",
        "02029": "WARSZAWA",
        "02030": "WARSZAWA",
        "02031": "WARSZAWA",
        "02032": "WARSZAWA",
        "02033": "WARSZAWA",
        "02034": "WARSZAWA",
        "02035": "WARSZAWA",
        "02036": "WARSZAWA",
        "02038": "WARSZAWA",
        "02040": "WARSZAWA",
        "02041": "WARSZAWA",
        "02042": "WARSZAWA",
        "02044": "WARSZAWA",
        "02045": "WARSZAWA",
        "02046": "WARSZAWA",
        "02047": "WARSZAWA",
        "02048": "WARSZAWA",
        "02049": "WARSZAWA",
        "02050": "WARSZAWA",
        "02051": "WARSZAWA",
        "02052": "WARSZAWA",
        "02053": "WARSZAWA",
        "02054": "WARSZAWA",
        "02055": "WARSZAWA",
        "02056": "WARSZAWA",
        "02057": "WARSZAWA",
        "02059": "WARSZAWA",
        "02061": "WARSZAWA",
        "02062": "WARSZAWA",
        "02063": "WARSZAWA",
        "02064": "WARSZAWA",
        "02065": "WARSZAWA",
        "02066": "WARSZAWA",
        "02067": "WARSZAWA",
        "02068": "WARSZAWA",
        "02069": "WARSZAWA",
        "02070": "WARSZAWA",
        "02071": "WARSZAWA",
        "02072": "WARSZAWA",
        "02073": "WARSZAWA",
        "02074": "WARSZAWA",
        "02075": "WARSZAWA",
        "02078": "WARSZAWA",
        "02079": "WARSZAWA",
        "02080": "WARSZAWA",
        "02081": "WARSZAWA",
        "02082": "WARSZAWA",
        "02083": "WARSZAWA",
        "02084": "WARSZAWA",
        "02085": "WARSZAWA",
        "02086": "WARSZAWA",
        "02087": "WARSZAWA",
        "02089": "WARSZAWA",
        "02090": "WARSZAWA",
        "02091": "WARSZAWA",
        "02092": "WARSZAWA",
        "02093": "WARSZAWA",
        "02094": "WARSZAWA",
        "02095": "WARSZAWA",
        "02096": "WARSZAWA",
        "02097": "WARSZAWA",
        "02098": "WARSZAWA",
        "02100": "WARSZAWA",
        "02101": "WARSZAWA",
        "02102": "WARSZAWA",
        "02103": "WARSZAWA",
        "02104": "WARSZAWA",
        "02105": "WARSZAWA",
        "02106": "WARSZAWA",
        "02107": "WARSZAWA",
        "02108": "WARSZAWA",
        "02109": "WARSZAWA",
        "02110": "WARSZAWA",
        "02111": "WARSZAWA",
        "02112": "WARSZAWA",
        "02113": "WARSZAWA",
        "02114": "WARSZAWA",
        "02115": "WARSZAWA",
        "02116": "WARSZAWA",
        "02117": "WARSZAWA",
        "02118": "WARSZAWA",
        "02119": "WARSZAWA",
        "02120": "WARSZAWA",
        "02121": "WARSZAWA",
        "02122": "WARSZAWA",
        "02123": "WARSZAWA",
        "02124": "WARSZAWA",
        "02126": "WARSZAWA",
        "02127": "WARSZAWA",
        "02128": "WARSZAWA",
        "02129": "WARSZAWA",
        "02130": "WARSZAWA",
        "02131": "WARSZAWA",
        "02132": "WARSZAWA",
        "02133": "WARSZAWA",
        "02134": "WARSZAWA",
        "02135": "WARSZAWA",
        "02136": "WARSZAWA",
        "02137": "WARSZAWA",
        "02138": "WARSZAWA",
        "02139": "WARSZAWA",
        "02140": "WARSZAWA",
        "02141": "WARSZAWA",
        "02142": "WARSZAWA",
        "02143": "WARSZAWA",
        "02144": "WARSZAWA",
        "02145": "WARSZAWA",
        "02146": "WARSZAWA",
        "02147": "WARSZAWA",
        "02148": "WARSZAWA",
        "02149": "WARSZAWA",
        "02150": "WARSZAWA",
        "02151": "WARSZAWA",
        "02152": "WARSZAWA",
        "02153": "WARSZAWA",
        "02154": "WARSZAWA",
        "02155": "WARSZAWA",
        "02156": "WARSZAWA",
        "02157": "WARSZAWA",
        "02158": "WARSZAWA",
        "02159": "WARSZAWA",
        "02160": "WARSZAWA",
        "02161": "WARSZAWA",
        "02162": "WARSZAWA",
        "02163": "WARSZAWA",
        "02164": "WARSZAWA",
        "02165": "WARSZAWA",
        "02166": "WARSZAWA",
        "02168": "WARSZAWA",
        "02169": "WARSZAWA",
        "02170": "WARSZAWA",
        "02172": "WARSZAWA",
        "02173": "WARSZAWA",
        "02174": "WARSZAWA",
        "02175": "WARSZAWA",
        "02176": "WARSZAWA",
        "02177": "WARSZAWA",
        "02178": "WARSZAWA",
        "02179": "WARSZAWA",
        "02180": "WARSZAWA",
        "02181": "WARSZAWA",
        "02182": "WARSZAWA",
        "02183": "WARSZAWA",
        "02184": "WARSZAWA",
        "02186": "WARSZAWA",
        "02187": "WARSZAWA",
        "02188": "WARSZAWA",
        "02189": "WARSZAWA",
        "02190": "WARSZAWA",
        "02191": "WARSZAWA",
        "02192": "WARSZAWA",
        "02194": "WARSZAWA",
        "02195": "WARSZAWA",
        "02196": "WARSZAWA",
        "02197": "WARSZAWA",
        "02198": "WARSZAWA",
        "02200": "WARSZAWA",
        "02201": "WARSZAWA",
        "02202": "WARSZAWA",
        "02203": "WARSZAWA",
        "02204": "WARSZAWA",
        "02205": "WARSZAWA",
        "02206": "WARSZAWA",
        "02207": "WARSZAWA",
        "02208": "WARSZAWA",
        "02209": "WARSZAWA",
        "02210": "WARSZAWA",
        "02211": "WARSZAWA",
        "02212": "WARSZAWA",
        "02213": "WARSZAWA",
        "02214": "WARSZAWA",
        "02215": "WARSZAWA",
        "02216": "WARSZAWA",
        "02217": "WARSZAWA",
        "02218": "WARSZAWA",
        "02219": "WARSZAWA",
        "02220": "WARSZAWA",
        "02221": "WARSZAWA",
        "02222": "WARSZAWA",
        "02223": "WARSZAWA",
        "02224": "WARSZAWA",
        "02225": "WARSZAWA",
        "02226": "WARSZAWA",
        "02227": "WARSZAWA",
        "02228": "WARSZAWA",
        "02229": "WARSZAWA",
        "02230": "WARSZAWA",
        "02231": "WARSZAWA",
        "02232": "WARSZAWA",
        "02233": "WARSZAWA",
        "02234": "WARSZAWA",
        "02235": "WARSZAWA",
        "02236": "WARSZAWA",
        "02237": "WARSZAWA",
        "02238": "WARSZAWA",
        "02239": "WARSZAWA",
        "02240": "WARSZAWA",
        "02241": "WARSZAWA",
        "02242": "WARSZAWA",
        "02243": "WARSZAWA",
        "02244": "WARSZAWA",
        "02246": "WARSZAWA",
        "02247": "WARSZAWA",
        "02248": "WARSZAWA",
        "02249": "WARSZAWA",
        "02250": "WARSZAWA",
        "02251": "WARSZAWA",
        "02252": "WARSZAWA",
        "02253": "WARSZAWA",
        "02254": "WARSZAWA",
        "02255": "WARSZAWA",
        "02256": "WARSZAWA",
        "02257": "WARSZAWA",
        "02258": "WARSZAWA",
        "02259": "WARSZAWA",
        "02260": "WARSZAWA",
        "02261": "WARSZAWA",
        "02262": "WARSZAWA",
        "02263": "WARSZAWA",
        "02264": "WARSZAWA",
        "02265": "WARSZAWA",
        "02266": "WARSZAWA",
        "02267": "WARSZAWA",
        "02268": "WARSZAWA",
        "02269": "WARSZAWA",
        "02270": "WARSZAWA",
        "02271": "WARSZAWA",
        "02272": "WARSZAWA",
        "02273": "WARSZAWA",
        "02274": "WARSZAWA",
        "02275": "WARSZAWA",
        "02276": "WARSZAWA",
        "02277": "WARSZAWA",
        "02278": "WARSZAWA",
        "02279": "WARSZAWA",
        "02280": "WARSZAWA",
        "02281": "WARSZAWA",
        "02282": "WARSZAWA",
        "02283": "WARSZAWA",
        "02284": "WARSZAWA",
        "02285": "WARSZAWA",
        "02286": "WARSZAWA",
        "02287": "WARSZAWA",
        "02288": "WARSZAWA",
        "02290": "WARSZAWA",
        "02291": "WARSZAWA",
        "02292": "WARSZAWA",
        "02293": "WARSZAWA",
        "02294": "WARSZAWA",
        "02295": "WARSZAWA",
        "02296": "WARSZAWA",
        "02298": "WARSZAWA",
        "02299": "WARSZAWA",
        "02301": "WARSZAWA",
        "02302": "WARSZAWA",
        "02303": "WARSZAWA",
        "02304": "WARSZAWA",
        "02305": "WARSZAWA",
        "02306": "WARSZAWA",
        "02307": "WARSZAWA",
        "02308": "WARSZAWA",
        "02309": "WARSZAWA",
        "02310": "WARSZAWA",
        "02311": "WARSZAWA",
        "02312": "WARSZAWA",
        "02313": "WARSZAWA",
        "02314": "WARSZAWA",
        "02315": "WARSZAWA",
        "02316": "WARSZAWA",
        "02317": "WARSZAWA",
        "02318": "WARSZAWA",
        "02319": "WARSZAWA",
        "02320": "WARSZAWA",
        "02321": "WARSZAWA",
        "02322": "WARSZAWA",
        "02323": "WARSZAWA",
        "02324": "WARSZAWA",
        "02325": "WARSZAWA",
        "02326": "WARSZAWA",
        "02327": "WARSZAWA",
        "02334": "WARSZAWA",
        "02335": "WARSZAWA",
        "02336": "WARSZAWA",
        "02337": "WARSZAWA",
        "02338": "WARSZAWA",
        "02339": "WARSZAWA",
        "02340": "WARSZAWA",
        "02341": "WARSZAWA",
        "02342": "WARSZAWA",
        "02343": "WARSZAWA",
        "02344": "WARSZAWA",
        "02345": "WARSZAWA",
        "02346": "WARSZAWA",
        "02347": "WARSZAWA",
        "02348": "WARSZAWA",
        "02349": "WARSZAWA",
        "02350": "WARSZAWA",
        "02351": "WARSZAWA",
        "02352": "WARSZAWA",
        "02353": "WARSZAWA",
        "02354": "WARSZAWA",
        "02356": "WARSZAWA",
        "02359": "WARSZAWA",
        "02360": "WARSZAWA",
        "02361": "WARSZAWA",
        "02362": "WARSZAWA",
        "02363": "WARSZAWA",
        "02364": "WARSZAWA",
        "02365": "WARSZAWA",
        "02366": "WARSZAWA",
        "02367": "WARSZAWA",
        "02368": "WARSZAWA",
        "02369": "WARSZAWA",
        "02370": "WARSZAWA",
        "02371": "WARSZAWA",
        "02372": "WARSZAWA",
        "02373": "WARSZAWA",
        "02374": "WARSZAWA",
        "02375": "WARSZAWA",
        "02376": "WARSZAWA",
        "02377": "WARSZAWA",
        "02378": "WARSZAWA",
        "02379": "WARSZAWA",
        "02380": "WARSZAWA",
        "02381": "WARSZAWA",
        "02382": "WARSZAWA",
        "02383": "WARSZAWA",
        "02384": "WARSZAWA",
        "02385": "WARSZAWA",
        "02386": "WARSZAWA",
        "02387": "WARSZAWA",
        "02388": "WARSZAWA",
        "02389": "WARSZAWA",
        "02390": "WARSZAWA",
        "02391": "WARSZAWA",
        "02392": "WARSZAWA",
        "02393": "WARSZAWA",
        "02394": "WARSZAWA",
        "02395": "WARSZAWA",
        "02396": "WARSZAWA",
        "02397": "WARSZAWA",
        "02398": "WARSZAWA",
        "02400": "WARSZAWA",
        "02401": "WARSZAWA",
        "02402": "WARSZAWA",
        "02403": "WARSZAWA",
        "02404": "WARSZAWA",
        "02405": "WARSZAWA",
        "02406": "WARSZAWA",
        "02407": "WARSZAWA",
        "02408": "WARSZAWA",
        "02409": "WARSZAWA",
        "02410": "WARSZAWA",
        "02411": "WARSZAWA",
        "02412": "WARSZAWA",
        "02413": "WARSZAWA",
        "02414": "WARSZAWA",
        "02415": "WARSZAWA",
        "02416": "WARSZAWA",
        "02417": "WARSZAWA",
        "02419": "WARSZAWA",
        "02421": "WARSZAWA",
        "02422": "WARSZAWA",
        "02423": "WARSZAWA",
        "02424": "WARSZAWA",
        "02425": "WARSZAWA",
        "02426": "WARSZAWA",
        "02427": "WARSZAWA",
        "02428": "WARSZAWA",
        "02430": "WARSZAWA",
        "02431": "WARSZAWA",
        "02432": "WARSZAWA",
        "02433": "WARSZAWA",
        "02434": "WARSZAWA",
        "02435": "WARSZAWA",
        "02436": "WARSZAWA",
        "02437": "WARSZAWA",
        "02438": "WARSZAWA",
        "02439": "WARSZAWA",
        "02440": "WARSZAWA",
        "02441": "WARSZAWA",
        "02442": "WARSZAWA",
        "02443": "WARSZAWA",
        "02445": "WARSZAWA",
        "02446": "WARSZAWA",
        "02447": "WARSZAWA",
        "02448": "WARSZAWA",
        "02449": "WARSZAWA",
        "02450": "WARSZAWA",
        "02451": "WARSZAWA",
        "02452": "WARSZAWA",
        "02453": "WARSZAWA",
        "02454": "WARSZAWA",
        "02455": "WARSZAWA",
        "02456": "WARSZAWA",
        "02457": "WARSZAWA",
        "02458": "WARSZAWA",
        "02459": "WARSZAWA",
        "02460": "WARSZAWA",
        "02461": "WARSZAWA",
        "02462": "WARSZAWA",
        "02463": "WARSZAWA",
        "02464": "WARSZAWA",
        "02465": "WARSZAWA",
        "02466": "WARSZAWA",
        "02467": "WARSZAWA",
        "02468": "WARSZAWA",
        "02469": "WARSZAWA",
        "02470": "WARSZAWA",
        "02471": "WARSZAWA",
        "02472": "WARSZAWA",
        "02473": "WARSZAWA",
        "02474": "WARSZAWA",
        "02477": "WARSZAWA",
        "02479": "WARSZAWA",
        "02480": "WARSZAWA",
        "02481": "WARSZAWA",
        "02482": "WARSZAWA",
        "02483": "WARSZAWA",
        "02484": "WARSZAWA",
        "02485": "WARSZAWA",
        "02486": "WARSZAWA",
        "02487": "WARSZAWA",
        "02488": "WARSZAWA",
        "02489": "WARSZAWA",
        "02490": "WARSZAWA",
        "02491": "WARSZAWA",
        "02492": "WARSZAWA",
        "02493": "WARSZAWA",
        "02494": "WARSZAWA",
        "02495": "WARSZAWA",
        "02496": "WARSZAWA",
        "02497": "WARSZAWA",
        "02498": "WARSZAWA",
        "02501": "WARSZAWA",
        "02502": "WARSZAWA",
        "02503": "WARSZAWA",
        "02504": "WARSZAWA",
        "02505": "WARSZAWA",
        "02506": "WARSZAWA",
        "02507": "WARSZAWA",
        "02508": "WARSZAWA",
        "02509": "WARSZAWA",
        "02510": "WARSZAWA",
        "02511": "WARSZAWA",
        "02512": "WARSZAWA",
        "02513": "WARSZAWA",
        "02514": "WARSZAWA",
        "02515": "WARSZAWA",
        "02516": "WARSZAWA",
        "02517": "WARSZAWA",
        "02518": "WARSZAWA",
        "02519": "WARSZAWA",
        "02520": "WARSZAWA",
        "02521": "WARSZAWA",
        "02522": "WARSZAWA",
        "02523": "WARSZAWA",
        "02524": "WARSZAWA",
        "02525": "WARSZAWA",
        "02526": "WARSZAWA",
        "02527": "WARSZAWA",
        "02528": "WARSZAWA",
        "02529": "WARSZAWA",
        "02530": "WARSZAWA",
        "02531": "WARSZAWA",
        "02532": "WARSZAWA",
        "02533": "WARSZAWA",
        "02534": "WARSZAWA",
        "02535": "WARSZAWA",
        "02536": "WARSZAWA",
        "02537": "WARSZAWA",
        "02538": "WARSZAWA",
        "02539": "WARSZAWA",
        "02540": "WARSZAWA",
        "02541": "WARSZAWA",
        "02543": "WARSZAWA",
        "02544": "WARSZAWA",
        "02545": "WARSZAWA",
        "02546": "WARSZAWA",
        "02547": "WARSZAWA",
        "02548": "WARSZAWA",
        "02549": "WARSZAWA",
        "02550": "WARSZAWA",
        "02551": "WARSZAWA",
        "02552": "WARSZAWA",
        "02553": "WARSZAWA",
        "02554": "WARSZAWA",
        "02555": "WARSZAWA",
        "02556": "WARSZAWA",
        "02557": "WARSZAWA",
        "02558": "WARSZAWA",
        "02559": "WARSZAWA",
        "02560": "WARSZAWA",
        "02561": "WARSZAWA",
        "02562": "WARSZAWA",
        "02563": "WARSZAWA",
        "02564": "WARSZAWA",
        "02566": "WARSZAWA",
        "02567": "WARSZAWA",
        "02568": "WARSZAWA",
        "02569": "WARSZAWA",
        "02570": "WARSZAWA",
        "02571": "WARSZAWA",
        "02572": "WARSZAWA",
        "02574": "WARSZAWA",
        "02575": "WARSZAWA",
        "02577": "WARSZAWA",
        "02578": "WARSZAWA",
        "02579": "WARSZAWA",
        "02581": "WARSZAWA",
        "02582": "WARSZAWA",
        "02583": "WARSZAWA",
        "02584": "WARSZAWA",
        "02585": "WARSZAWA",
        "02586": "WARSZAWA",
        "02587": "WARSZAWA",
        "02588": "WARSZAWA",
        "02589": "WARSZAWA",
        "02590": "WARSZAWA",
        "02591": "WARSZAWA",
        "02592": "WARSZAWA",
        "02593": "WARSZAWA",
        "02594": "WARSZAWA",
        "02595": "WARSZAWA",
        "02598": "WARSZAWA",
        "02600": "WARSZAWA",
        "02601": "WARSZAWA",
        "02602": "WARSZAWA",
        "02603": "WARSZAWA",
        "02604": "WARSZAWA",
        "02605": "WARSZAWA",
        "02606": "WARSZAWA",
        "02607": "WARSZAWA",
        "02608": "WARSZAWA",
        "02609": "WARSZAWA",
        "02610": "WARSZAWA",
        "02611": "WARSZAWA",
        "02612": "WARSZAWA",
        "02613": "WARSZAWA",
        "02614": "WARSZAWA",
        "02615": "WARSZAWA",
        "02616": "WARSZAWA",
        "02617": "WARSZAWA",
        "02618": "WARSZAWA",
        "02619": "WARSZAWA",
        "02620": "WARSZAWA",
        "02621": "WARSZAWA",
        "02622": "WARSZAWA",
        "02624": "WARSZAWA",
        "02625": "WARSZAWA",
        "02626": "WARSZAWA",
        "02627": "WARSZAWA",
        "02628": "WARSZAWA",
        "02629": "WARSZAWA",
        "02630": "WARSZAWA",
        "02631": "WARSZAWA",
        "02632": "WARSZAWA",
        "02633": "WARSZAWA",
        "02634": "WARSZAWA",
        "02635": "WARSZAWA",
        "02636": "WARSZAWA",
        "02637": "WARSZAWA",
        "02638": "WARSZAWA",
        "02639": "WARSZAWA",
        "02640": "WARSZAWA",
        "02641": "WARSZAWA",
        "02642": "WARSZAWA",
        "02643": "WARSZAWA",
        "02644": "WARSZAWA",
        "02645": "WARSZAWA",
        "02646": "WARSZAWA",
        "02647": "WARSZAWA",
        "02648": "WARSZAWA",
        "02649": "WARSZAWA",
        "02650": "WARSZAWA",
        "02651": "WARSZAWA",
        "02652": "WARSZAWA",
        "02653": "WARSZAWA",
        "02654": "WARSZAWA",
        "02655": "WARSZAWA",
        "02656": "WARSZAWA",
        "02657": "WARSZAWA",
        "02658": "WARSZAWA",
        "02659": "WARSZAWA",
        "02660": "WARSZAWA",
        "02661": "WARSZAWA",
        "02662": "WARSZAWA",
        "02663": "WARSZAWA",
        "02664": "WARSZAWA",
        "02665": "WARSZAWA",
        "02666": "WARSZAWA",
        "02668": "WARSZAWA",
        "02669": "WARSZAWA",
        "02670": "WARSZAWA",
        "02671": "WARSZAWA",
        "02672": "WARSZAWA",
        "02673": "WARSZAWA",
        "02674": "WARSZAWA",
        "02675": "WARSZAWA",
        "02676": "WARSZAWA",
        "02677": "WARSZAWA",
        "02678": "WARSZAWA",
        "02679": "WARSZAWA",
        "02680": "WARSZAWA",
        "02681": "WARSZAWA",
        "02682": "WARSZAWA",
        "02683": "WARSZAWA",
        "02684": "WARSZAWA",
        "02685": "WARSZAWA",
        "02690": "WARSZAWA",
        "02691": "WARSZAWA",
        "02692": "WARSZAWA",
        "02693": "WARSZAWA",
        "02694": "WARSZAWA",
        "02695": "WARSZAWA",
        "02696": "WARSZAWA",
        "02697": "WARSZAWA",
        "02698": "WARSZAWA",
        "02699": "WARSZAWA",
        "02700": "WARSZAWA",
        "02701": "WARSZAWA",
        "02702": "WARSZAWA",
        "02703": "WARSZAWA",
        "02704": "WARSZAWA",
        "02705": "WARSZAWA",
        "02707": "WARSZAWA",
        "02708": "WARSZAWA",
        "02709": "WARSZAWA",
        "02710": "WARSZAWA",
        "02711": "WARSZAWA",
        "02712": "WARSZAWA",
        "02713": "WARSZAWA",
        "02714": "WARSZAWA",
        "02715": "WARSZAWA",
        "02716": "WARSZAWA",
        "02717": "WARSZAWA",
        "02718": "WARSZAWA",
        "02720": "WARSZAWA",
        "02721": "WARSZAWA",
        "02722": "WARSZAWA",
        "02724": "WARSZAWA",
        "02725": "WARSZAWA",
        "02726": "WARSZAWA",
        "02727": "WARSZAWA",
        "02728": "WARSZAWA",
        "02729": "WARSZAWA",
        "02730": "WARSZAWA",
        "02732": "WARSZAWA",
        "02733": "WARSZAWA",
        "02735": "WARSZAWA",
        "02736": "WARSZAWA",
        "02737": "WARSZAWA",
        "02738": "WARSZAWA",
        "02739": "WARSZAWA",
        "02740": "WARSZAWA",
        "02741": "WARSZAWA",
        "02743": "WARSZAWA",
        "02744": "WARSZAWA",
        "02745": "WARSZAWA",
        "02746": "WARSZAWA",
        "02747": "WARSZAWA",
        "02748": "WARSZAWA",
        "02749": "WARSZAWA",
        "02750": "WARSZAWA",
        "02751": "WARSZAWA",
        "02752": "WARSZAWA",
        "02755": "WARSZAWA",
        "02756": "WARSZAWA",
        "02757": "WARSZAWA",
        "02758": "WARSZAWA",
        "02759": "WARSZAWA",
        "02760": "WARSZAWA",
        "02761": "WARSZAWA",
        "02762": "WARSZAWA",
        "02763": "WARSZAWA",
        "02764": "WARSZAWA",
        "02765": "WARSZAWA",
        "02766": "WARSZAWA",
        "02767": "WARSZAWA",
        "02768": "WARSZAWA",
        "02769": "WARSZAWA",
        "02770": "WARSZAWA",
        "02775": "WARSZAWA",
        "02776": "WARSZAWA",
        "02777": "WARSZAWA",
        "02778": "WARSZAWA",
        "02780": "WARSZAWA",
        "02781": "WARSZAWA",
        "02783": "WARSZAWA",
        "02784": "WARSZAWA",
        "02785": "WARSZAWA",
        "02786": "WARSZAWA",
        "02787": "WARSZAWA",
        "02788": "WARSZAWA",
        "02790": "WARSZAWA",
        "02791": "WARSZAWA",
        "02792": "WARSZAWA",
        "02793": "WARSZAWA",
        "02794": "WARSZAWA",
        "02795": "WARSZAWA",
        "02796": "WARSZAWA",
        "02797": "WARSZAWA",
        "02798": "WARSZAWA",
        "02799": "WARSZAWA",
        "02800": "WARSZAWA",
        "02801": "WARSZAWA",
        "02802": "WARSZAWA",
        "02803": "WARSZAWA",
        "02804": "WARSZAWA",
        "02805": "WARSZAWA",
        "02806": "WARSZAWA",
        "02807": "WARSZAWA",
        "02808": "WARSZAWA",
        "02809": "WARSZAWA",
        "02811": "WARSZAWA",
        "02812": "WARSZAWA",
        "02814": "WARSZAWA",
        "02815": "WARSZAWA",
        "02816": "WARSZAWA",
        "02817": "WARSZAWA",
        "02818": "WARSZAWA",
        "02819": "WARSZAWA",
        "02820": "WARSZAWA",
        "02821": "WARSZAWA",
        "02822": "WARSZAWA",
        "02823": "WARSZAWA",
        "02824": "WARSZAWA",
        "02825": "WARSZAWA",
        "02826": "WARSZAWA",
        "02827": "WARSZAWA",
        "02828": "WARSZAWA",
        "02829": "WARSZAWA",
        "02830": "WARSZAWA",
        "02831": "WARSZAWA",
        "02832": "WARSZAWA",
        "02833": "WARSZAWA",
        "02834": "WARSZAWA",
        "02835": "WARSZAWA",
        "02836": "WARSZAWA",
        "02837": "WARSZAWA",
        "02838": "WARSZAWA",
        "02840": "WARSZAWA",
        "02841": "WARSZAWA",
        "02842": "WARSZAWA",
        "02843": "WARSZAWA",
        "02844": "WARSZAWA",
        "02845": "WARSZAWA",
        "02846": "WARSZAWA",
        "02847": "WARSZAWA",
        "02849": "WARSZAWA",
        "02850": "WARSZAWA",
        "02851": "WARSZAWA",
        "02852": "WARSZAWA",
        "02853": "WARSZAWA",
        "02854": "WARSZAWA",
        "02855": "WARSZAWA",
        "02856": "WARSZAWA",
        "02857": "WARSZAWA",
        "02858": "WARSZAWA",
        "02859": "WARSZAWA",
        "02860": "WARSZAWA",
        "02862": "WARSZAWA",
        "02863": "WARSZAWA",
        "02867": "WARSZAWA",
        "02868": "WARSZAWA",
        "02869": "WARSZAWA",
        "02870": "WARSZAWA",
        "02871": "WARSZAWA",
        "02872": "WARSZAWA",
        "02873": "WARSZAWA",
        "02874": "WARSZAWA",
        "02875": "WARSZAWA",
        "02876": "WARSZAWA",
        "02877": "WARSZAWA",
        "02878": "WARSZAWA",
        "02879": "WARSZAWA",
        "02881": "WARSZAWA",
        "02882": "WARSZAWA",
        "02884": "WARSZAWA",
        "02885": "WARSZAWA",
        "02886": "WARSZAWA",
        "02887": "WARSZAWA",
        "02888": "WARSZAWA",
        "02889": "WARSZAWA",
        "02890": "WARSZAWA",
        "02891": "WARSZAWA",
        "02892": "WARSZAWA",
        "02893": "WARSZAWA",
        "02900": "WARSZAWA",
        "02901": "WARSZAWA",
        "02902": "WARSZAWA",
        "02903": "WARSZAWA",
        "02904": "WARSZAWA",
        "02905": "WARSZAWA",
        "02906": "WARSZAWA",
        "02907": "WARSZAWA",
        "02908": "WARSZAWA",
        "02909": "WARSZAWA",
        "02910": "WARSZAWA",
        "02911": "WARSZAWA",
        "02912": "WARSZAWA",
        "02913": "WARSZAWA",
        "02914": "WARSZAWA",
        "02915": "WARSZAWA",
        "02916": "WARSZAWA",
        "02917": "WARSZAWA",
        "02918": "WARSZAWA",
        "02919": "WARSZAWA",
        "02920": "WARSZAWA",
        "02921": "WARSZAWA",
        "02922": "WARSZAWA",
        "02923": "WARSZAWA",
        "02924": "WARSZAWA",
        "02925": "WARSZAWA",
        "02926": "WARSZAWA",
        "02927": "WARSZAWA",
        "02928": "WARSZAWA",
        "02929": "WARSZAWA",
        "02930": "WARSZAWA",
        "02931": "WARSZAWA",
        "02932": "WARSZAWA",
        "02933": "WARSZAWA",
        "02934": "WARSZAWA",
        "02935": "WARSZAWA",
        "02936": "WARSZAWA",
        "02937": "WARSZAWA",
        "02938": "WARSZAWA",
        "02939": "WARSZAWA",
        "02940": "WARSZAWA",
        "02941": "WARSZAWA",
        "02942": "WARSZAWA",
        "02943": "WARSZAWA",
        "02944": "WARSZAWA",
        "02945": "WARSZAWA",
        "02946": "WARSZAWA",
        "02947": "WARSZAWA",
        "02948": "WARSZAWA",
        "02949": "WARSZAWA",
        "02950": "WARSZAWA",
        "02951": "WARSZAWA",
        "02952": "WARSZAWA",
        "02953": "WARSZAWA",
        "02954": "WARSZAWA",
        "02955": "WARSZAWA",
        "02956": "WARSZAWA",
        "02957": "WARSZAWA",
        "02958": "WARSZAWA",
        "02959": "WARSZAWA",
        "02960": "WARSZAWA",
        "02961": "WARSZAWA",
        "02962": "WARSZAWA",
        "02963": "WARSZAWA",
        "02964": "WARSZAWA",
        "02965": "WARSZAWA",
        "02966": "WARSZAWA",
        "02967": "WARSZAWA",
        "02968": "WARSZAWA",
        "02969": "WARSZAWA",
        "02970": "WARSZAWA",
        "02971": "WARSZAWA",
        "02972": "WARSZAWA",
        "02973": "WARSZAWA",
        "02975": "WARSZAWA",
        "02977": "WARSZAWA",
        "02978": "WARSZAWA",
        "02979": "WARSZAWA",
        "02980": "WARSZAWA",
        "02981": "WARSZAWA",
        "02982": "WARSZAWA",
        "02983": "WARSZAWA",
        "02984": "WARSZAWA",
        "02985": "WARSZAWA",
        "02986": "WARSZAWA",
        "02987": "WARSZAWA",
        "02988": "WARSZAWA",
        "02989": "WARSZAWA",
        "02990": "WARSZAWA",
        "02991": "WARSZAWA",
        "02992": "WARSZAWA",
        "02993": "WARSZAWA",
        "02994": "WARSZAWA",
        "02995": "WARSZAWA",
        "02996": "WARSZAWA",
        "02997": "WARSZAWA",
        "02998": "WARSZAWA",
        "02999": "WARSZAWA",
        "03001": "WARSZAWA",
        "03002": "WARSZAWA",
        "03003": "WARSZAWA",
        "03004": "WARSZAWA",
        "03005": "WARSZAWA",
        "03007": "WARSZAWA",
        "03008": "WARSZAWA",
        "03009": "WARSZAWA",
        "03011": "WARSZAWA",
        "03012": "WARSZAWA",
        "03013": "WARSZAWA",
        "03015": "WARSZAWA",
        "03016": "WARSZAWA",
        "03017": "WARSZAWA",
        "03018": "WARSZAWA",
        "03019": "WARSZAWA",
        "03020": "WARSZAWA",
        "03021": "WARSZAWA",
        "03022": "WARSZAWA",
        "03023": "WARSZAWA",
        "03024": "WARSZAWA",
        "03025": "WARSZAWA",
        "03026": "WARSZAWA",
        "03028": "WARSZAWA",
        "03029": "WARSZAWA",
        "03030": "WARSZAWA",
        "03031": "WARSZAWA",
        "03032": "WARSZAWA",
        "03033": "WARSZAWA",
        "03034": "WARSZAWA",
        "03035": "WARSZAWA",
        "03036": "WARSZAWA",
        "03037": "WARSZAWA",
        "03041": "WARSZAWA",
        "03042": "WARSZAWA",
        "03043": "WARSZAWA",
        "03044": "WARSZAWA",
        "03046": "WARSZAWA",
        "03050": "WARSZAWA",
        "03051": "WARSZAWA",
        "03052": "WARSZAWA",
        "03053": "WARSZAWA",
        "03054": "WARSZAWA",
        "03055": "WARSZAWA",
        "03059": "WARSZAWA",
        "03061": "WARSZAWA",
        "03062": "WARSZAWA",
        "03063": "WARSZAWA",
        "03064": "WARSZAWA",
        "03068": "WARSZAWA",
        "03069": "WARSZAWA",
        "03071": "WARSZAWA",
        "03074": "WARSZAWA",
        "03075": "WARSZAWA",
        "03076": "WARSZAWA",
        "03077": "WARSZAWA",
        "03079": "WARSZAWA",
        "03081": "WARSZAWA",
        "03082": "WARSZAWA",
        "03083": "WARSZAWA",
        "03085": "WARSZAWA",
        "03087": "WARSZAWA",
        "03088": "WARSZAWA",
        "03089": "WARSZAWA",
        "03090": "WARSZAWA",
        "03092": "WARSZAWA",
        "03093": "WARSZAWA",
        "03100": "WARSZAWA",
        "03101": "WARSZAWA",
        "03102": "WARSZAWA",
        "03103": "WARSZAWA",
        "03104": "WARSZAWA",
        "03105": "WARSZAWA",
        "03106": "WARSZAWA",
        "03107": "WARSZAWA",
        "03108": "WARSZAWA",
        "03109": "WARSZAWA",
        "03110": "WARSZAWA",
        "03111": "WARSZAWA",
        "03112": "WARSZAWA",
        "03113": "WARSZAWA",
        "03114": "WARSZAWA",
        "03115": "WARSZAWA",
        "03116": "WARSZAWA",
        "03117": "WARSZAWA",
        "03118": "WARSZAWA",
        "03119": "WARSZAWA",
        "03120": "WARSZAWA",
        "03122": "WARSZAWA",
        "03123": "WARSZAWA",
        "03125": "WARSZAWA",
        "03126": "WARSZAWA",
        "03127": "WARSZAWA",
        "03128": "WARSZAWA",
        "03129": "WARSZAWA",
        "03130": "WARSZAWA",
        "03131": "WARSZAWA",
        "03133": "WARSZAWA",
        "03134": "WARSZAWA",
        "03135": "WARSZAWA",
        "03136": "WARSZAWA",
        "03137": "WARSZAWA",
        "03138": "WARSZAWA",
        "03139": "WARSZAWA",
        "03140": "WARSZAWA",
        "03141": "WARSZAWA",
        "03142": "WARSZAWA",
        "03143": "WARSZAWA",
        "03144": "WARSZAWA",
        "03145": "WARSZAWA",
        "03146": "WARSZAWA",
        "03147": "WARSZAWA",
        "03148": "WARSZAWA",
        "03149": "WARSZAWA",
        "03151": "WARSZAWA",
        "03152": "WARSZAWA",
        "03153": "WARSZAWA",
        "03154": "WARSZAWA",
        "03155": "WARSZAWA",
        "03156": "WARSZAWA",
        "03157": "WARSZAWA",
        "03158": "WARSZAWA",
        "03159": "WARSZAWA",
        "03160": "WARSZAWA",
        "03161": "WARSZAWA",
        "03162": "WARSZAWA",
        "03163": "WARSZAWA",
        "03164": "WARSZAWA",
        "03165": "WARSZAWA",
        "03166": "WARSZAWA",
        "03167": "WARSZAWA",
        "03168": "WARSZAWA",
        "03170": "WARSZAWA",
        "03171": "WARSZAWA",
        "03172": "WARSZAWA",
        "03173": "WARSZAWA",
        "03174": "WARSZAWA",
        "03175": "WARSZAWA",
        "03176": "WARSZAWA",
        "03178": "WARSZAWA",
        "03179": "WARSZAWA",
        "03180": "WARSZAWA",
        "03181": "WARSZAWA",
        "03182": "WARSZAWA",
        "03183": "WARSZAWA",
        "03184": "WARSZAWA",
        "03185": "WARSZAWA",
        "03186": "WARSZAWA",
        "03187": "WARSZAWA",
        "03188": "WARSZAWA",
        "03189": "WARSZAWA",
        "03190": "WARSZAWA",
        "03191": "WARSZAWA",
        "03192": "WARSZAWA",
        "03193": "WARSZAWA",
        "03194": "WARSZAWA",
        "03195": "WARSZAWA",
        "03196": "WARSZAWA",
        "03197": "WARSZAWA",
        "03198": "WARSZAWA",
        "03199": "WARSZAWA",
        "03200": "WARSZAWA",
        "03201": "WARSZAWA",
        "03202": "WARSZAWA",
        "03203": "WARSZAWA",
        "03204": "WARSZAWA",
        "03206": "WARSZAWA",
        "03207": "WARSZAWA",
        "03208": "WARSZAWA",
        "03209": "WARSZAWA",
        "03213": "WARSZAWA",
        "03214": "WARSZAWA",
        "03215": "WARSZAWA",
        "03216": "WARSZAWA",
        "03219": "WARSZAWA",
        "03226": "WARSZAWA",
        "03228": "WARSZAWA",
        "03230": "WARSZAWA",
        "03231": "WARSZAWA",
        "03233": "WARSZAWA",
        "03236": "WARSZAWA",
        "03237": "WARSZAWA",
        "03238": "WARSZAWA",
        "03239": "WARSZAWA",
        "03241": "WARSZAWA",
        "03242": "WARSZAWA",
        "03243": "WARSZAWA",
        "03244": "WARSZAWA",
        "03246": "WARSZAWA",
        "03249": "WARSZAWA",
        "03251": "WARSZAWA",
        "03252": "WARSZAWA",
        "03253": "WARSZAWA",
        "03254": "WARSZAWA",
        "03255": "WARSZAWA",
        "03256": "WARSZAWA",
        "03257": "WARSZAWA",
        "03259": "WARSZAWA",
        "03260": "WARSZAWA",
        "03262": "WARSZAWA",
        "03264": "WARSZAWA",
        "03265": "WARSZAWA",
        "03266": "WARSZAWA",
        "03267": "WARSZAWA",
        "03270": "WARSZAWA",
        "03272": "WARSZAWA",
        "03274": "WARSZAWA",
        "03276": "WARSZAWA",
        "03279": "WARSZAWA",
        "03281": "WARSZAWA",
        "03284": "WARSZAWA",
        "03285": "WARSZAWA",
        "03286": "WARSZAWA",
        "03287": "WARSZAWA",
        "03288": "WARSZAWA",
        "03289": "WARSZAWA",
        "03290": "WARSZAWA",
        "03291": "WARSZAWA",
        "03294": "WARSZAWA",
        "03295": "WARSZAWA",
        "03299": "WARSZAWA",
        "03301": "WARSZAWA",
        "03302": "WARSZAWA",
        "03303": "WARSZAWA",
        "03305": "WARSZAWA",
        "03307": "WARSZAWA",
        "03308": "WARSZAWA",
        "03309": "WARSZAWA",
        "03310": "WARSZAWA",
        "03312": "WARSZAWA",
        "03314": "WARSZAWA",
        "03315": "WARSZAWA",
        "03316": "WARSZAWA",
        "03317": "WARSZAWA",
        "03318": "WARSZAWA",
        "03320": "WARSZAWA",
        "03321": "WARSZAWA",
        "03322": "WARSZAWA",
        "03324": "WARSZAWA",
        "03325": "WARSZAWA",
        "03329": "WARSZAWA",
        "03331": "WARSZAWA",
        "03332": "WARSZAWA",
        "03333": "WARSZAWA",
        "03334": "WARSZAWA",
        "03335": "WARSZAWA",
        "03337": "WARSZAWA",
        "03338": "WARSZAWA",
        "03340": "WARSZAWA",
        "03341": "WARSZAWA",
        "03343": "WARSZAWA",
        "03345": "WARSZAWA",
        "03346": "WARSZAWA",
        "03347": "WARSZAWA",
        "03348": "WARSZAWA",
        "03349": "WARSZAWA",
        "03350": "WARSZAWA",
        "03352": "WARSZAWA",
        "03353": "WARSZAWA",
        "03355": "WARSZAWA",
        "03356": "WARSZAWA",
        "03357": "WARSZAWA",
        "03358": "WARSZAWA",
        "03359": "WARSZAWA",
        "03360": "WARSZAWA",
        "03361": "WARSZAWA",
        "03362": "WARSZAWA",
        "03363": "WARSZAWA",
        "03365": "WARSZAWA",
        "03367": "WARSZAWA",
        "03368": "WARSZAWA",
        "03369": "WARSZAWA",
        "03370": "WARSZAWA",
        "03371": "WARSZAWA",
        "03372": "WARSZAWA",
        "03373": "WARSZAWA",
        "03374": "WARSZAWA",
        "03375": "WARSZAWA",
        "03376": "WARSZAWA",
        "03377": "WARSZAWA",
        "03378": "WARSZAWA",
        "03379": "WARSZAWA",
        "03380": "WARSZAWA",
        "03381": "WARSZAWA",
        "03382": "WARSZAWA",
        "03383": "WARSZAWA",
        "03384": "WARSZAWA",
        "03385": "WARSZAWA",
        "03387": "WARSZAWA",
        "03388": "WARSZAWA",
        "03390": "WARSZAWA",
        "03391": "WARSZAWA",
        "03392": "WARSZAWA",
        "03393": "WARSZAWA",
        "03394": "WARSZAWA",
        "03395": "WARSZAWA",
        "03396": "WARSZAWA",
        "03397": "WARSZAWA",
        "03401": "WARSZAWA",
        "03402": "WARSZAWA",
        "03403": "WARSZAWA",
        "03404": "WARSZAWA",
        "03405": "WARSZAWA",
        "03406": "WARSZAWA",
        "03407": "WARSZAWA",
        "03408": "WARSZAWA",
        "03409": "WARSZAWA",
        "03410": "WARSZAWA",
        "03411": "WARSZAWA",
        "03412": "WARSZAWA",
        "03414": "WARSZAWA",
        "03415": "WARSZAWA",
        "03416": "WARSZAWA",
        "03417": "WARSZAWA",
        "03418": "WARSZAWA",
        "03419": "WARSZAWA",
        "03420": "WARSZAWA",
        "03421": "WARSZAWA",
        "03422": "WARSZAWA",
        "03423": "WARSZAWA",
        "03424": "WARSZAWA",
        "03425": "WARSZAWA",
        "03426": "WARSZAWA",
        "03427": "WARSZAWA",
        "03428": "WARSZAWA",
        "03429": "WARSZAWA",
        "03430": "WARSZAWA",
        "03431": "WARSZAWA",
        "03432": "WARSZAWA",
        "03433": "WARSZAWA",
        "03435": "WARSZAWA",
        "03436": "WARSZAWA",
        "03437": "WARSZAWA",
        "03438": "WARSZAWA",
        "03439": "WARSZAWA",
        "03440": "WARSZAWA",
        "03441": "WARSZAWA",
        "03442": "WARSZAWA",
        "03443": "WARSZAWA",
        "03444": "WARSZAWA",
        "03445": "WARSZAWA",
        "03446": "WARSZAWA",
        "03447": "WARSZAWA",
        "03448": "WARSZAWA",
        "03450": "WARSZAWA",
        "03451": "WARSZAWA",
        "03452": "WARSZAWA",
        "03453": "WARSZAWA",
        "03454": "WARSZAWA",
        "03455": "WARSZAWA",
        "03456": "WARSZAWA",
        "03458": "WARSZAWA",
        "03459": "WARSZAWA",
        "03460": "WARSZAWA",
        "03461": "WARSZAWA",
        "03462": "WARSZAWA",
        "03463": "WARSZAWA",
        "03464": "WARSZAWA",
        "03465": "WARSZAWA",
        "03468": "WARSZAWA",
        "03469": "WARSZAWA",
        "03470": "WARSZAWA",
        "03471": "WARSZAWA",
        "03472": "WARSZAWA",
        "03473": "WARSZAWA",
        "03474": "WARSZAWA",
        "03475": "WARSZAWA",
        "03476": "WARSZAWA",
        "03477": "WARSZAWA",
        "03478": "WARSZAWA",
        "03480": "WARSZAWA",
        "03481": "WARSZAWA",
        "03482": "WARSZAWA",
        "03483": "WARSZAWA",
        "03484": "WARSZAWA",
        "03485": "WARSZAWA",
        "03486": "WARSZAWA",
        "03488": "WARSZAWA",
        "03489": "WARSZAWA",
        "03490": "WARSZAWA",
        "03501": "WARSZAWA",
        "03502": "WARSZAWA",
        "03503": "WARSZAWA",
        "03504": "WARSZAWA",
        "03505": "WARSZAWA",
        "03506": "WARSZAWA",
        "03507": "WARSZAWA",
        "03509": "WARSZAWA",
        "03510": "WARSZAWA",
        "03511": "WARSZAWA",
        "03512": "WARSZAWA",
        "03514": "WARSZAWA",
        "03515": "WARSZAWA",
        "03516": "WARSZAWA",
        "03517": "WARSZAWA",
        "03518": "WARSZAWA",
        "03519": "WARSZAWA",
        "03521": "WARSZAWA",
        "03522": "WARSZAWA",
        "03523": "WARSZAWA",
        "03524": "WARSZAWA",
        "03525": "WARSZAWA",
        "03526": "WARSZAWA",
        "03527": "WARSZAWA",
        "03528": "WARSZAWA",
        "03529": "WARSZAWA",
        "03530": "WARSZAWA",
        "03531": "WARSZAWA",
        "03532": "WARSZAWA",
        "03533": "WARSZAWA",
        "03534": "WARSZAWA",
        "03535": "WARSZAWA",
        "03536": "WARSZAWA",
        "03538": "WARSZAWA",
        "03539": "WARSZAWA",
        "03540": "WARSZAWA",
        "03541": "WARSZAWA",
        "03542": "WARSZAWA",
        "03543": "WARSZAWA",
        "03544": "WARSZAWA",
        "03545": "WARSZAWA",
        "03546": "WARSZAWA",
        "03547": "WARSZAWA",
        "03548": "WARSZAWA",
        "03549": "WARSZAWA",
        "03550": "WARSZAWA",
        "03551": "WARSZAWA",
        "03552": "WARSZAWA",
        "03553": "WARSZAWA",
        "03554": "WARSZAWA",
        "03556": "WARSZAWA",
        "03557": "WARSZAWA",
        "03558": "WARSZAWA",
        "03560": "WARSZAWA",
        "03561": "WARSZAWA",
        "03562": "WARSZAWA",
        "03563": "WARSZAWA",
        "03564": "WARSZAWA",
        "03565": "WARSZAWA",
        "03566": "WARSZAWA",
        "03567": "WARSZAWA",
        "03569": "WARSZAWA",
        "03571": "WARSZAWA",
        "03572": "WARSZAWA",
        "03573": "WARSZAWA",
        "03574": "WARSZAWA",
        "03575": "WARSZAWA",
        "03576": "WARSZAWA",
        "03577": "WARSZAWA",
        "03578": "WARSZAWA",
        "03579": "WARSZAWA",
        "03580": "WARSZAWA",
        "03581": "WARSZAWA",
        "03582": "WARSZAWA",
        "03583": "WARSZAWA",
        "03584": "WARSZAWA",
        "03585": "WARSZAWA",
        "03586": "WARSZAWA",
        "03587": "WARSZAWA",
        "03588": "WARSZAWA",
        "03589": "WARSZAWA",
        "03590": "WARSZAWA",
        "03592": "WARSZAWA",
        "03593": "WARSZAWA",
        "03594": "WARSZAWA",
        "03595": "WARSZAWA",
        "03596": "WARSZAWA",
        "03597": "WARSZAWA",
        "03598": "WARSZAWA",
        "03599": "WARSZAWA",
        "03601": "WARSZAWA",
        "03602": "WARSZAWA",
        "03603": "WARSZAWA",
        "03604": "WARSZAWA",
        "03605": "WARSZAWA",
        "03606": "WARSZAWA",
        "03607": "WARSZAWA",
        "03608": "WARSZAWA",
        "03609": "WARSZAWA",
        "03610": "WARSZAWA",
        "03611": "WARSZAWA",
        "03612": "WARSZAWA",
        "03613": "WARSZAWA",
        "03614": "WARSZAWA",
        "03616": "WARSZAWA",
        "03617": "WARSZAWA",
        "03618": "WARSZAWA",
        "03619": "WARSZAWA",
        "03620": "WARSZAWA",
        "03621": "WARSZAWA",
        "03622": "WARSZAWA",
        "03623": "WARSZAWA",
        "03624": "WARSZAWA",
        "03625": "WARSZAWA",
        "03626": "WARSZAWA",
        "03627": "WARSZAWA",
        "03628": "WARSZAWA",
        "03629": "WARSZAWA",
        "03630": "WARSZAWA",
        "03631": "WARSZAWA",
        "03632": "WARSZAWA",
        "03633": "WARSZAWA",
        "03634": "WARSZAWA",
        "03636": "WARSZAWA",
        "03637": "WARSZAWA",
        "03638": "WARSZAWA",
        "03639": "WARSZAWA",
        "03640": "WARSZAWA",
        "03641": "WARSZAWA",
        "03642": "WARSZAWA",
        "03643": "WARSZAWA",
        "03644": "WARSZAWA",
        "03645": "WARSZAWA",
        "03646": "WARSZAWA",
        "03647": "WARSZAWA",
        "03648": "WARSZAWA",
        "03649": "WARSZAWA",
        "03650": "WARSZAWA",
        "03652": "WARSZAWA",
        "03653": "WARSZAWA",
        "03654": "WARSZAWA",
        "03655": "WARSZAWA",
        "03656": "WARSZAWA",
        "03657": "WARSZAWA",
        "03658": "WARSZAWA",
        "03659": "WARSZAWA",
        "03660": "WARSZAWA",
        "03661": "WARSZAWA",
        "03662": "WARSZAWA",
        "03663": "WARSZAWA",
        "03664": "WARSZAWA",
        "03665": "WARSZAWA",
        "03666": "WARSZAWA",
        "03667": "WARSZAWA",
        "03668": "WARSZAWA",
        "03671": "WARSZAWA",
        "03672": "WARSZAWA",
        "03673": "WARSZAWA",
        "03674": "WARSZAWA",
        "03675": "WARSZAWA",
        "03676": "WARSZAWA",
        "03677": "WARSZAWA",
        "03678": "WARSZAWA",
        "03679": "WARSZAWA",
        "03680": "WARSZAWA",
        "03681": "WARSZAWA",
        "03682": "WARSZAWA",
        "03683": "WARSZAWA",
        "03684": "WARSZAWA",
        "03685": "WARSZAWA",
        "03686": "WARSZAWA",
        "03687": "WARSZAWA",
        "03688": "WARSZAWA",
        "03689": "WARSZAWA",
        "03690": "WARSZAWA",
        "03691": "WARSZAWA",
        "03692": "WARSZAWA",
        "03693": "WARSZAWA",
        "03694": "WARSZAWA",
        "03695": "WARSZAWA",
        "03696": "WARSZAWA",
        "03697": "WARSZAWA",
        "03698": "WARSZAWA",
        "03699": "WARSZAWA",
        "03700": "WARSZAWA",
        "03701": "WARSZAWA",
        "03703": "WARSZAWA",
        "03704": "WARSZAWA",
        "03705": "WARSZAWA",
        "03707": "WARSZAWA",
        "03708": "WARSZAWA",
        "03709": "WARSZAWA",
        "03710": "WARSZAWA",
        "03711": "WARSZAWA",
        "03712": "WARSZAWA",
        "03713": "WARSZAWA",
        "03714": "WARSZAWA",
        "03715": "WARSZAWA",
        "03716": "WARSZAWA",
        "03717": "WARSZAWA",
        "03718": "WARSZAWA",
        "03719": "WARSZAWA",
        "03720": "WARSZAWA",
        "03721": "WARSZAWA",
        "03722": "WARSZAWA",
        "03724": "WARSZAWA",
        "03725": "WARSZAWA",
        "03726": "WARSZAWA",
        "03727": "WARSZAWA",
        "03728": "WARSZAWA",
        "03729": "WARSZAWA",
        "03730": "WARSZAWA",
        "03731": "WARSZAWA",
        "03732": "WARSZAWA",
        "03733": "WARSZAWA",
        "03734": "WARSZAWA",
        "03735": "WARSZAWA",
        "03736": "WARSZAWA",
        "03737": "WARSZAWA",
        "03738": "WARSZAWA",
        "03739": "WARSZAWA",
        "03740": "WARSZAWA",
        "03741": "WARSZAWA",
        "03742": "WARSZAWA",
        "03743": "WARSZAWA",
        "03744": "WARSZAWA",
        "03745": "WARSZAWA",
        "03746": "WARSZAWA",
        "03747": "WARSZAWA",
        "03748": "WARSZAWA",
        "03749": "WARSZAWA",
        "03750": "WARSZAWA",
        "03751": "WARSZAWA",
        "03752": "WARSZAWA",
        "03753": "WARSZAWA",
        "03754": "WARSZAWA",
        "03755": "WARSZAWA",
        "03756": "WARSZAWA",
        "03757": "WARSZAWA",
        "03758": "WARSZAWA",
        "03759": "WARSZAWA",
        "03761": "WARSZAWA",
        "03762": "WARSZAWA",
        "03763": "WARSZAWA",
        "03764": "WARSZAWA",
        "03766": "WARSZAWA",
        "03767": "WARSZAWA",
        "03768": "WARSZAWA",
        "03769": "WARSZAWA",
        "03770": "WARSZAWA",
        "03771": "WARSZAWA",
        "03772": "WARSZAWA",
        "03774": "WARSZAWA",
        "03775": "WARSZAWA",
        "03778": "WARSZAWA",
        "03779": "WARSZAWA",
        "03780": "WARSZAWA",
        "03781": "WARSZAWA",
        "03782": "WARSZAWA",
        "03784": "WARSZAWA",
        "03785": "WARSZAWA",
        "03786": "WARSZAWA",
        "03787": "WARSZAWA",
        "03788": "WARSZAWA",
        "03789": "WARSZAWA",
        "03790": "WARSZAWA",
        "03791": "WARSZAWA",
        "03792": "WARSZAWA",
        "03793": "WARSZAWA",
        "03794": "WARSZAWA",
        "03795": "WARSZAWA",
        "03796": "WARSZAWA",
        "03797": "WARSZAWA",
        "03798": "WARSZAWA",
        "03799": "WARSZAWA",
        "03801": "WARSZAWA",
        "03802": "WARSZAWA",
        "03803": "WARSZAWA",
        "03804": "WARSZAWA",
        "03805": "WARSZAWA",
        "03806": "WARSZAWA",
        "03807": "WARSZAWA",
        "03808": "WARSZAWA",
        "03809": "WARSZAWA",
        "03810": "WARSZAWA",
        "03811": "WARSZAWA",
        "03812": "WARSZAWA",
        "03813": "WARSZAWA",
        "03814": "WARSZAWA",
        "03815": "WARSZAWA",
        "03816": "WARSZAWA",
        "03821": "WARSZAWA",
        "03822": "WARSZAWA",
        "03823": "WARSZAWA",
        "03824": "WARSZAWA",
        "03825": "WARSZAWA",
        "03826": "WARSZAWA",
        "03828": "WARSZAWA",
        "03829": "WARSZAWA",
        "03831": "WARSZAWA",
        "03832": "WARSZAWA",
        "03833": "WARSZAWA",
        "03834": "WARSZAWA",
        "03835": "WARSZAWA",
        "03836": "WARSZAWA",
        "03838": "WARSZAWA",
        "03839": "WARSZAWA",
        "03840": "WARSZAWA",
        "03841": "WARSZAWA",
        "03842": "WARSZAWA",
        "03844": "WARSZAWA",
        "03846": "WARSZAWA",
        "03847": "WARSZAWA",
        "03849": "WARSZAWA",
        "03850": "WARSZAWA",
        "03851": "WARSZAWA",
        "03866": "WARSZAWA",
        "03867": "WARSZAWA",
        "03868": "WARSZAWA",
        "03869": "WARSZAWA",
        "03870": "WARSZAWA",
        "03871": "WARSZAWA",
        "03872": "WARSZAWA",
        "03873": "WARSZAWA",
        "03874": "WARSZAWA",
        "03875": "WARSZAWA",
        "03876": "WARSZAWA",
        "03877": "WARSZAWA",
        "03878": "WARSZAWA",
        "03879": "WARSZAWA",
        "03885": "WARSZAWA",
        "03886": "WARSZAWA",
        "03887": "WARSZAWA",
        "03888": "WARSZAWA",
        "03889": "WARSZAWA",
        "03890": "WARSZAWA",
        "03891": "WARSZAWA",
        "03892": "WARSZAWA",
        "03893": "WARSZAWA",
        "03900": "WARSZAWA",
        "03901": "WARSZAWA",
        "03902": "WARSZAWA",
        "03903": "WARSZAWA",
        "03904": "WARSZAWA",
        "03905": "WARSZAWA",
        "03906": "WARSZAWA",
        "03907": "WARSZAWA",
        "03908": "WARSZAWA",
        "03909": "WARSZAWA",
        "03910": "WARSZAWA",
        "03911": "WARSZAWA",
        "03912": "WARSZAWA",
        "03913": "WARSZAWA",
        "03914": "WARSZAWA",
        "03915": "WARSZAWA",
        "03916": "WARSZAWA",
        "03917": "WARSZAWA",
        "03918": "WARSZAWA",
        "03919": "WARSZAWA",
        "03920": "WARSZAWA",
        "03921": "WARSZAWA",
        "03922": "WARSZAWA",
        "03923": "WARSZAWA",
        "03924": "WARSZAWA",
        "03925": "WARSZAWA",
        "03926": "WARSZAWA",
        "03927": "WARSZAWA",
        "03928": "WARSZAWA",
        "03929": "WARSZAWA",
        "03930": "WARSZAWA",
        "03931": "WARSZAWA",
        "03932": "WARSZAWA",
        "03933": "WARSZAWA",
        "03934": "WARSZAWA",
        "03935": "WARSZAWA",
        "03936": "WARSZAWA",
        "03937": "WARSZAWA",
        "03938": "WARSZAWA",
        "03939": "WARSZAWA",
        "03940": "WARSZAWA",
        "03941": "WARSZAWA",
        "03942": "WARSZAWA",
        "03943": "WARSZAWA",
        "03944": "WARSZAWA",
        "03945": "WARSZAWA",
        "03946": "WARSZAWA",
        "03947": "WARSZAWA",
        "03948": "WARSZAWA",
        "03949": "WARSZAWA",
        "03952": "WARSZAWA",
        "03953": "WARSZAWA",
        "03954": "WARSZAWA",
        "03955": "WARSZAWA",
        "03956": "WARSZAWA",
        "03957": "WARSZAWA",
        "03963": "WARSZAWA",
        "03964": "WARSZAWA",
        "03965": "WARSZAWA",
        "03966": "WARSZAWA",
        "03967": "WARSZAWA",
        "03968": "WARSZAWA",
        "03969": "WARSZAWA",
        "03970": "WARSZAWA",
        "03971": "WARSZAWA",
        "03972": "WARSZAWA",
        "03973": "WARSZAWA",
        "03974": "WARSZAWA",
        "03975": "WARSZAWA",
        "03976": "WARSZAWA",
        "03977": "WARSZAWA",
        "03978": "WARSZAWA",
        "03979": "WARSZAWA",
        "03980": "WARSZAWA",
        "03982": "WARSZAWA",
        "03983": "WARSZAWA",
        "03984": "WARSZAWA",
        "03985": "WARSZAWA",
        "03986": "WARSZAWA",
        "03987": "WARSZAWA",
        "03988": "WARSZAWA",
        "03989": "WARSZAWA",
        "03990": "WARSZAWA",
        "03991": "WARSZAWA",
        "03992": "WARSZAWA",
        "03993": "WARSZAWA",
        "03994": "WARSZAWA",
        "03995": "WARSZAWA",
        "03996": "WARSZAWA",
        "03998": "WARSZAWA",
        "04001": "WARSZAWA",
        "04002": "WARSZAWA",
        "04003": "WARSZAWA",
        "04004": "WARSZAWA",
        "04005": "WARSZAWA",
        "04007": "WARSZAWA",
        "04008": "WARSZAWA",
        "04009": "WARSZAWA",
        "04010": "WARSZAWA",
        "04011": "WARSZAWA",
        "04013": "WARSZAWA",
        "04014": "WARSZAWA",
        "04015": "WARSZAWA",
        "04016": "WARSZAWA",
        "04017": "WARSZAWA",
        "04019": "WARSZAWA",
        "04020": "WARSZAWA",
        "04022": "WARSZAWA",
        "04023": "WARSZAWA",
        "04024": "WARSZAWA",
        "04025": "WARSZAWA",
        "04026": "WARSZAWA",
        "04027": "WARSZAWA",
        "04028": "WARSZAWA",
        "04029": "WARSZAWA",
        "04030": "WARSZAWA",
        "04031": "WARSZAWA",
        "04032": "WARSZAWA",
        "04033": "WARSZAWA",
        "04034": "WARSZAWA",
        "04035": "WARSZAWA",
        "04036": "WARSZAWA",
        "04038": "WARSZAWA",
        "04039": "WARSZAWA",
        "04040": "WARSZAWA",
        "04041": "WARSZAWA",
        "04042": "WARSZAWA",
        "04043": "WARSZAWA",
        "04044": "WARSZAWA",
        "04045": "WARSZAWA",
        "04046": "WARSZAWA",
        "04047": "WARSZAWA",
        "04048": "WARSZAWA",
        "04049": "WARSZAWA",
        "04050": "WARSZAWA",
        "04051": "WARSZAWA",
        "04052": "WARSZAWA",
        "04053": "WARSZAWA",
        "04055": "WARSZAWA",
        "04057": "WARSZAWA",
        "04058": "WARSZAWA",
        "04059": "WARSZAWA",
        "04060": "WARSZAWA",
        "04062": "WARSZAWA",
        "04063": "WARSZAWA",
        "04064": "WARSZAWA",
        "04065": "WARSZAWA",
        "04066": "WARSZAWA",
        "04067": "WARSZAWA",
        "04068": "WARSZAWA",
        "04069": "WARSZAWA",
        "04072": "WARSZAWA",
        "04073": "WARSZAWA",
        "04074": "WARSZAWA",
        "04076": "WARSZAWA",
        "04077": "WARSZAWA",
        "04078": "WARSZAWA",
        "04079": "WARSZAWA",
        "04080": "WARSZAWA",
        "04081": "WARSZAWA",
        "04082": "WARSZAWA",
        "04083": "WARSZAWA",
        "04085": "WARSZAWA",
        "04086": "WARSZAWA",
        "04087": "WARSZAWA",
        "04088": "WARSZAWA",
        "04089": "WARSZAWA",
        "04090": "WARSZAWA",
        "04091": "WARSZAWA",
        "04092": "WARSZAWA",
        "04101": "WARSZAWA",
        "04102": "WARSZAWA",
        "04105": "WARSZAWA",
        "04106": "WARSZAWA",
        "04109": "WARSZAWA",
        "04110": "WARSZAWA",
        "04111": "WARSZAWA",
        "04112": "WARSZAWA",
        "04113": "WARSZAWA",
        "04116": "WARSZAWA",
        "04118": "WARSZAWA",
        "04119": "WARSZAWA",
        "04120": "WARSZAWA",
        "04121": "WARSZAWA",
        "04123": "WARSZAWA",
        "04124": "WARSZAWA",
        "04125": "WARSZAWA",
        "04127": "WARSZAWA",
        "04128": "WARSZAWA",
        "04129": "WARSZAWA",
        "04131": "WARSZAWA",
        "04133": "WARSZAWA",
        "04134": "WARSZAWA",
        "04136": "WARSZAWA",
        "04137": "WARSZAWA",
        "04138": "WARSZAWA",
        "04139": "WARSZAWA",
        "04141": "WARSZAWA",
        "04142": "WARSZAWA",
        "04143": "WARSZAWA",
        "04144": "WARSZAWA",
        "04145": "WARSZAWA",
        "04146": "WARSZAWA",
        "04147": "WARSZAWA",
        "04148": "WARSZAWA",
        "04149": "WARSZAWA",
        "04151": "WARSZAWA",
        "04152": "WARSZAWA",
        "04154": "WARSZAWA",
        "04155": "WARSZAWA",
        "04156": "WARSZAWA",
        "04157": "WARSZAWA",
        "04158": "WARSZAWA",
        "04160": "WARSZAWA",
        "04161": "WARSZAWA",
        "04163": "WARSZAWA",
        "04164": "WARSZAWA",
        "04167": "WARSZAWA",
        "04169": "WARSZAWA",
        "04170": "WARSZAWA",
        "04171": "WARSZAWA",
        "04172": "WARSZAWA",
        "04173": "WARSZAWA",
        "04174": "WARSZAWA",
        "04175": "WARSZAWA",
        "04180": "WARSZAWA",
        "04183": "WARSZAWA",
        "04185": "WARSZAWA",
        "04186": "WARSZAWA",
        "04187": "WARSZAWA",
        "04188": "WARSZAWA",
        "04189": "WARSZAWA",
        "04190": "WARSZAWA",
        "04191": "WARSZAWA",
        "04192": "WARSZAWA",
        "04193": "WARSZAWA",
        "04194": "WARSZAWA",
        "04196": "WARSZAWA",
        "04202": "WARSZAWA",
        "04203": "WARSZAWA",
        "04204": "WARSZAWA",
        "04205": "WARSZAWA",
        "04206": "WARSZAWA",
        "04207": "WARSZAWA",
        "04208": "WARSZAWA",
        "04210": "WARSZAWA",
        "04211": "WARSZAWA",
        "04212": "WARSZAWA",
        "04213": "WARSZAWA",
        "04214": "WARSZAWA",
        "04215": "WARSZAWA",
        "04216": "WARSZAWA",
        "04217": "WARSZAWA",
        "04218": "WARSZAWA",
        "04219": "WARSZAWA",
        "04221": "WARSZAWA",
        "04222": "WARSZAWA",
        "04223": "WARSZAWA",
        "04224": "WARSZAWA",
        "04226": "WARSZAWA",
        "04227": "WARSZAWA",
        "04228": "WARSZAWA",
        "04230": "WARSZAWA",
        "04231": "WARSZAWA",
        "04232": "WARSZAWA",
        "04233": "WARSZAWA",
        "04234": "WARSZAWA",
        "04235": "WARSZAWA",
        "04237": "WARSZAWA",
        "04238": "WARSZAWA",
        "04239": "WARSZAWA",
        "04240": "WARSZAWA",
        "04241": "WARSZAWA",
        "04242": "WARSZAWA",
        "04243": "WARSZAWA",
        "04244": "WARSZAWA",
        "04246": "WARSZAWA",
        "04247": "WARSZAWA",
        "04248": "WARSZAWA",
        "04252": "WARSZAWA",
        "04253": "WARSZAWA",
        "04254": "WARSZAWA",
        "04255": "WARSZAWA",
        "04256": "WARSZAWA",
        "04257": "WARSZAWA",
        "04258": "WARSZAWA",
        "04259": "WARSZAWA",
        "04260": "WARSZAWA",
        "04261": "WARSZAWA",
        "04262": "WARSZAWA",
        "04263": "WARSZAWA",
        "04266": "WARSZAWA",
        "04267": "WARSZAWA",
        "04268": "WARSZAWA",
        "04269": "WARSZAWA",
        "04270": "WARSZAWA",
        "04271": "WARSZAWA",
        "04272": "WARSZAWA",
        "04273": "WARSZAWA",
        "04274": "WARSZAWA",
        "04275": "WARSZAWA",
        "04276": "WARSZAWA",
        "04277": "WARSZAWA",
        "04278": "WARSZAWA",
        "04280": "WARSZAWA",
        "04281": "WARSZAWA",
        "04282": "WARSZAWA",
        "04283": "WARSZAWA",
        "04284": "WARSZAWA",
        "04285": "WARSZAWA",
        "04287": "WARSZAWA",
        "04288": "WARSZAWA",
        "04289": "WARSZAWA",
        "04290": "WARSZAWA",
        "04291": "WARSZAWA",
        "04292": "WARSZAWA",
        "04293": "WARSZAWA",
        "04294": "WARSZAWA",
        "04301": "WARSZAWA",
        "04302": "WARSZAWA",
        "04303": "WARSZAWA",
        "04304": "WARSZAWA",
        "04305": "WARSZAWA",
        "04306": "WARSZAWA",
        "04307": "WARSZAWA",
        "04308": "WARSZAWA",
        "04309": "WARSZAWA",
        "04310": "WARSZAWA",
        "04311": "WARSZAWA",
        "04312": "WARSZAWA",
        "04313": "WARSZAWA",
        "04314": "WARSZAWA",
        "04316": "WARSZAWA",
        "04317": "WARSZAWA",
        "04319": "WARSZAWA",
        "04320": "WARSZAWA",
        "04321": "WARSZAWA",
        "04322": "WARSZAWA",
        "04323": "WARSZAWA",
        "04324": "WARSZAWA",
        "04325": "WARSZAWA",
        "04326": "WARSZAWA",
        "04327": "WARSZAWA",
        "04328": "WARSZAWA",
        "04329": "WARSZAWA",
        "04330": "WARSZAWA",
        "04331": "WARSZAWA",
        "04332": "WARSZAWA",
        "04333": "WARSZAWA",
        "04334": "WARSZAWA",
        "04335": "WARSZAWA",
        "04336": "WARSZAWA",
        "04337": "WARSZAWA",
        "04338": "WARSZAWA",
        "04339": "WARSZAWA",
        "04340": "WARSZAWA",
        "04341": "WARSZAWA",
        "04342": "WARSZAWA",
        "04343": "WARSZAWA",
        "04344": "WARSZAWA",
        "04345": "WARSZAWA",
        "04346": "WARSZAWA",
        "04347": "WARSZAWA",
        "04348": "WARSZAWA",
        "04349": "WARSZAWA",
        "04350": "WARSZAWA",
        "04351": "WARSZAWA",
        "04352": "WARSZAWA",
        "04353": "WARSZAWA",
        "04354": "WARSZAWA",
        "04355": "WARSZAWA",
        "04356": "WARSZAWA",
        "04357": "WARSZAWA",
        "04358": "WARSZAWA",
        "04359": "WARSZAWA",
        "04360": "WARSZAWA",
        "04361": "WARSZAWA",
        "04362": "WARSZAWA",
        "04363": "WARSZAWA",
        "04364": "WARSZAWA",
        "04365": "WARSZAWA",
        "04366": "WARSZAWA",
        "04367": "WARSZAWA",
        "04368": "WARSZAWA",
        "04369": "WARSZAWA",
        "04370": "WARSZAWA",
        "04371": "WARSZAWA",
        "04372": "WARSZAWA",
        "04373": "WARSZAWA",
        "04375": "WARSZAWA",
        "04376": "WARSZAWA",
        "04377": "WARSZAWA",
        "04378": "WARSZAWA",
        "04379": "WARSZAWA",
        "04380": "WARSZAWA",
        "04381": "WARSZAWA",
        "04382": "WARSZAWA",
        "04384": "WARSZAWA",
        "04385": "WARSZAWA",
        "04386": "WARSZAWA",
        "04387": "WARSZAWA",
        "04388": "WARSZAWA",
        "04389": "WARSZAWA",
        "04390": "WARSZAWA",
        "04391": "WARSZAWA",
        "04392": "WARSZAWA",
        "04393": "WARSZAWA",
        "04394": "WARSZAWA",
        "04395": "WARSZAWA",
        "04396": "WARSZAWA",
        "04397": "WARSZAWA",
        "04398": "WARSZAWA",
        "04400": "WARSZAWA",
        "04401": "WARSZAWA",
        "04402": "WARSZAWA",
        "04403": "WARSZAWA",
        "04404": "WARSZAWA",
        "04406": "WARSZAWA",
        "04407": "WARSZAWA",
        "04408": "WARSZAWA",
        "04409": "WARSZAWA",
        "04410": "WARSZAWA",
        "04412": "WARSZAWA",
        "04413": "WARSZAWA",
        "04414": "WARSZAWA",
        "04416": "WARSZAWA",
        "04417": "WARSZAWA",
        "04418": "WARSZAWA",
        "04419": "WARSZAWA",
        "04420": "WARSZAWA",
        "04421": "WARSZAWA",
        "04423": "WARSZAWA",
        "04424": "WARSZAWA",
        "04425": "WARSZAWA",
        "04426": "WARSZAWA",
        "04428": "WARSZAWA",
        "04429": "WARSZAWA",
        "04430": "WARSZAWA",
        "04431": "WARSZAWA",
        "04432": "WARSZAWA",
        "04434": "WARSZAWA",
        "04435": "WARSZAWA",
        "04436": "WARSZAWA",
        "04437": "WARSZAWA",
        "04438": "WARSZAWA",
        "04439": "WARSZAWA",
        "04440": "WARSZAWA",
        "04441": "WARSZAWA",
        "04443": "WARSZAWA",
        "04444": "WARSZAWA",
        "04445": "WARSZAWA",
        "04446": "WARSZAWA",
        "04447": "WARSZAWA",
        "04448": "WARSZAWA",
        "04450": "WARSZAWA",
        "04451": "WARSZAWA",
        "04452": "WARSZAWA",
        "04453": "WARSZAWA",
        "04454": "WARSZAWA",
        "04455": "WARSZAWA",
        "04457": "WARSZAWA",
        "04458": "WARSZAWA",
        "04459": "WARSZAWA",
        "04460": "WARSZAWA",
        "04461": "WARSZAWA",
        "04462": "WARSZAWA",
        "04463": "WARSZAWA",
        "04464": "WARSZAWA",
        "04465": "WARSZAWA",
        "04466": "WARSZAWA",
        "04467": "WARSZAWA",
        "04468": "WARSZAWA",
        "04470": "WARSZAWA",
        "04471": "WARSZAWA",
        "04473": "WARSZAWA",
        "04474": "WARSZAWA",
        "04475": "WARSZAWA",
        "04476": "WARSZAWA",
        "04478": "WARSZAWA",
        "04479": "WARSZAWA",
        "04480": "WARSZAWA",
        "04481": "WARSZAWA",
        "04482": "WARSZAWA",
        "04483": "WARSZAWA",
        "04484": "WARSZAWA",
        "04485": "WARSZAWA",
        "04487": "WARSZAWA",
        "04488": "WARSZAWA",
        "04489": "WARSZAWA",
        "04491": "WARSZAWA",
        "04492": "WARSZAWA",
        "04493": "WARSZAWA",
        "04494": "WARSZAWA",
        "04495": "WARSZAWA",
        "04497": "WARSZAWA",
        "04498": "WARSZAWA",
        "04501": "WARSZAWA",
        "04502": "WARSZAWA",
        "04504": "WARSZAWA",
        "04505": "WARSZAWA",
        "04506": "WARSZAWA",
        "04507": "WARSZAWA",
        "04508": "WARSZAWA",
        "04509": "WARSZAWA",
        "04510": "WARSZAWA",
        "04511": "WARSZAWA",
        "04512": "WARSZAWA",
        "04513": "WARSZAWA",
        "04514": "WARSZAWA",
        "04515": "WARSZAWA",
        "04516": "WARSZAWA",
        "04517": "WARSZAWA",
        "04519": "WARSZAWA",
        "04520": "WARSZAWA",
        "04521": "WARSZAWA",
        "04522": "WARSZAWA",
        "04523": "WARSZAWA",
        "04524": "WARSZAWA",
        "04525": "WARSZAWA",
        "04526": "WARSZAWA",
        "04528": "WARSZAWA",
        "04529": "WARSZAWA",
        "04530": "WARSZAWA",
        "04532": "WARSZAWA",
        "04533": "WARSZAWA",
        "04534": "WARSZAWA",
        "04535": "WARSZAWA",
        "04536": "WARSZAWA",
        "04537": "WARSZAWA",
        "04538": "WARSZAWA",
        "04539": "WARSZAWA",
        "04540": "WARSZAWA",
        "04541": "WARSZAWA",
        "04542": "WARSZAWA",
        "04543": "WARSZAWA",
        "04544": "WARSZAWA",
        "04545": "WARSZAWA",
        "04547": "WARSZAWA",
        "04549": "WARSZAWA",
        "04550": "WARSZAWA",
        "04551": "WARSZAWA",
        "04552": "WARSZAWA",
        "04555": "WARSZAWA",
        "04556": "WARSZAWA",
        "04557": "WARSZAWA",
        "04558": "WARSZAWA",
        "04559": "WARSZAWA",
        "04560": "WARSZAWA",
        "04561": "WARSZAWA",
        "04562": "WARSZAWA",
        "04563": "WARSZAWA",
        "04564": "WARSZAWA",
        "04565": "WARSZAWA",
        "04566": "WARSZAWA",
        "04567": "WARSZAWA",
        "04568": "WARSZAWA",
        "04569": "WARSZAWA",
        "04570": "WARSZAWA",
        "04601": "WARSZAWA",
        "04602": "WARSZAWA",
        "04603": "WARSZAWA",
        "04604": "WARSZAWA",
        "04605": "WARSZAWA",
        "04606": "WARSZAWA",
        "04607": "WARSZAWA",
        "04608": "WARSZAWA",
        "04609": "WARSZAWA",
        "04610": "WARSZAWA",
        "04611": "WARSZAWA",
        "04612": "WARSZAWA",
        "04613": "WARSZAWA",
        "04614": "WARSZAWA",
        "04615": "WARSZAWA",
        "04616": "WARSZAWA",
        "04617": "WARSZAWA",
        "04618": "WARSZAWA",
        "04619": "WARSZAWA",
        "04620": "WARSZAWA",
        "04621": "WARSZAWA",
        "04622": "WARSZAWA",
        "04623": "WARSZAWA",
        "04624": "WARSZAWA",
        "04625": "WARSZAWA",
        "04626": "WARSZAWA",
        "04627": "WARSZAWA",
        "04628": "WARSZAWA",
        "04629": "WARSZAWA",
        "04630": "WARSZAWA",
        "04632": "WARSZAWA",
        "04633": "WARSZAWA",
        "04634": "WARSZAWA",
        "04635": "WARSZAWA",
        "04636": "WARSZAWA",
        "04637": "WARSZAWA",
        "04638": "WARSZAWA",
        "04639": "WARSZAWA",
        "04640": "WARSZAWA",
        "04641": "WARSZAWA",
        "04642": "WARSZAWA",
        "04643": "WARSZAWA",
        "04644": "WARSZAWA",
        "04645": "WARSZAWA",
        "04647": "WARSZAWA",
        "04648": "WARSZAWA",
        "04649": "WARSZAWA",
        "04650": "WARSZAWA",
        "04651": "WARSZAWA",
        "04652": "WARSZAWA",
        "04653": "WARSZAWA",
        "04654": "WARSZAWA",
        "04655": "WARSZAWA",
        "04656": "WARSZAWA",
        "04657": "WARSZAWA",
        "04658": "WARSZAWA",
        "04659": "WARSZAWA",
        "04660": "WARSZAWA",
        "04661": "WARSZAWA",
        "04662": "WARSZAWA",
        "04663": "WARSZAWA",
        "04664": "WARSZAWA",
        "04665": "WARSZAWA",
        "04666": "WARSZAWA",
        "04667": "WARSZAWA",
        "04668": "WARSZAWA",
        "04669": "WARSZAWA",
        "04671": "WARSZAWA",
        "04672": "WARSZAWA",
        "04673": "WARSZAWA",
        "04674": "WARSZAWA",
        "04675": "WARSZAWA",
        "04676": "WARSZAWA",
        "04678": "WARSZAWA",
        "04679": "WARSZAWA",
        "04680": "WARSZAWA",
        "04681": "WARSZAWA",
        "04682": "WARSZAWA",
        "04683": "WARSZAWA",
        "04684": "WARSZAWA",
        "04685": "WARSZAWA",
        "04686": "WARSZAWA",
        "04687": "WARSZAWA",
        "04688": "WARSZAWA",
        "04689": "WARSZAWA",
        "04690": "WARSZAWA",
        "04691": "WARSZAWA",
        "04692": "WARSZAWA",
        "04693": "WARSZAWA",
        "04694": "WARSZAWA",
        "04695": "WARSZAWA",
        "04696": "WARSZAWA",
        "04697": "WARSZAWA",
        "04701": "WARSZAWA",
        "04702": "WARSZAWA",
        "04703": "WARSZAWA",
        "04704": "WARSZAWA",
        "04705": "WARSZAWA",
        "04707": "WARSZAWA",
        "04708": "WARSZAWA",
        "04709": "WARSZAWA",
        "04710": "WARSZAWA",
        "04711": "WARSZAWA",
        "04712": "WARSZAWA",
        "04713": "WARSZAWA",
        "04714": "WARSZAWA",
        "04715": "WARSZAWA",
        "04716": "WARSZAWA",
        "04717": "WARSZAWA",
        "04718": "WARSZAWA",
        "04719": "WARSZAWA",
        "04720": "WARSZAWA",
        "04721": "WARSZAWA",
        "04722": "WARSZAWA",
        "04723": "WARSZAWA",
        "04724": "WARSZAWA",
        "04725": "WARSZAWA",
        "04726": "WARSZAWA",
        "04727": "WARSZAWA",
        "04728": "WARSZAWA",
        "04729": "WARSZAWA",
        "04730": "WARSZAWA",
        "04731": "WARSZAWA",
        "04732": "WARSZAWA",
        "04733": "WARSZAWA",
        "04734": "WARSZAWA",
        "04735": "WARSZAWA",
        "04736": "WARSZAWA",
        "04737": "WARSZAWA",
        "04738": "WARSZAWA",
        "04739": "WARSZAWA",
        "04740": "WARSZAWA",
        "04741": "WARSZAWA",
        "04742": "WARSZAWA",
        "04743": "WARSZAWA",
        "04744": "WARSZAWA",
        "04745": "WARSZAWA",
        "04746": "WARSZAWA",
        "04747": "WARSZAWA",
        "04748": "WARSZAWA",
        "04749": "WARSZAWA",
        "04750": "WARSZAWA",
        "04751": "WARSZAWA",
        "04752": "WARSZAWA",
        "04754": "WARSZAWA",
        "04755": "WARSZAWA",
        "04756": "WARSZAWA",
        "04757": "WARSZAWA",
        "04758": "WARSZAWA",
        "04760": "WARSZAWA",
        "04761": "WARSZAWA",
        "04762": "WARSZAWA",
        "04763": "WARSZAWA",
        "04764": "WARSZAWA",
        "04765": "WARSZAWA",
        "04766": "WARSZAWA",
        "04767": "WARSZAWA",
        "04768": "WARSZAWA",
        "04769": "WARSZAWA",
        "04770": "WARSZAWA",
        "04771": "WARSZAWA",
        "04772": "WARSZAWA",
        "04773": "WARSZAWA",
        "04774": "WARSZAWA",
        "04775": "WARSZAWA",
        "04776": "WARSZAWA",
        "04778": "WARSZAWA",
        "04779": "WARSZAWA",
        "04780": "WARSZAWA",
        "04781": "WARSZAWA",
        "04782": "WARSZAWA",
        "04783": "WARSZAWA",
        "04784": "WARSZAWA",
        "04785": "WARSZAWA",
        "04786": "WARSZAWA",
        "04787": "WARSZAWA",
        "04788": "WARSZAWA",
        "04789": "WARSZAWA",
        "04790": "WARSZAWA",
        "04791": "WARSZAWA",
        "04792": "WARSZAWA",
        "04793": "WARSZAWA",
        "04794": "WARSZAWA",
        "04795": "WARSZAWA",
        "04796": "WARSZAWA",
        "04797": "WARSZAWA",
        "04798": "WARSZAWA",
        "04801": "WARSZAWA",
        "04802": "WARSZAWA",
        "04803": "WARSZAWA",
        "04804": "WARSZAWA",
        "04805": "WARSZAWA",
        "04806": "WARSZAWA",
        "04807": "WARSZAWA",
        "04808": "WARSZAWA",
        "04809": "WARSZAWA",
        "04810": "WARSZAWA",
        "04811": "WARSZAWA",
        "04812": "WARSZAWA",
        "04813": "WARSZAWA",
        "04814": "WARSZAWA",
        "04815": "WARSZAWA",
        "04816": "WARSZAWA",
        "04817": "WARSZAWA",
        "04818": "WARSZAWA",
        "04819": "WARSZAWA",
        "04820": "WARSZAWA",
        "04822": "WARSZAWA",
        "04823": "WARSZAWA",
        "04824": "WARSZAWA",
        "04825": "WARSZAWA",
        "04826": "WARSZAWA",
        "04827": "WARSZAWA",
        "04828": "WARSZAWA",
        "04829": "WARSZAWA",
        "04830": "WARSZAWA",
        "04831": "WARSZAWA",
        "04832": "WARSZAWA",
        "04833": "WARSZAWA",
        "04834": "WARSZAWA",
        "04835": "WARSZAWA",
        "04836": "WARSZAWA",
        "04837": "WARSZAWA",
        "04838": "WARSZAWA",
        "04839": "WARSZAWA",
        "04840": "WARSZAWA",
        "04841": "WARSZAWA",
        "04842": "WARSZAWA",
        "04843": "WARSZAWA",
        "04844": "WARSZAWA",
        "04845": "WARSZAWA",
        "04846": "WARSZAWA",
        "04847": "WARSZAWA",
        "04848": "WARSZAWA",
        "04849": "WARSZAWA",
        "04850": "WARSZAWA",
        "04851": "WARSZAWA",
        "04852": "WARSZAWA",
        "04853": "WARSZAWA",
        "04854": "WARSZAWA",
        "04855": "WARSZAWA",
        "04856": "WARSZAWA",
        "04857": "WARSZAWA",
        "04858": "WARSZAWA",
        "04859": "WARSZAWA",
        "04860": "WARSZAWA",
        "04861": "WARSZAWA",
        "04862": "WARSZAWA",
        "04863": "WARSZAWA",
        "04864": "WARSZAWA",
        "04865": "WARSZAWA",
        "04866": "WARSZAWA",
        "04867": "WARSZAWA",
        "04869": "WARSZAWA",
        "04870": "WARSZAWA",
        "04871": "WARSZAWA",
        "04872": "WARSZAWA",
        "04874": "WARSZAWA",
        "04875": "WARSZAWA",
        "04876": "WARSZAWA",
        "04877": "WARSZAWA",
        "04878": "WARSZAWA",
        "04879": "WARSZAWA",
        "04880": "WARSZAWA",
        "04881": "WARSZAWA",
        "04882": "WARSZAWA",
        "04883": "WARSZAWA",
        "04884": "WARSZAWA",
        "04885": "WARSZAWA",
        "04886": "WARSZAWA",
        "04888": "WARSZAWA",
        "04889": "WARSZAWA",
        "04890": "WARSZAWA",
        "04891": "WARSZAWA",
        "04892": "WARSZAWA",
        "04893": "WARSZAWA",
        "04894": "WARSZAWA",
        "04895": "WARSZAWA",
        "04896": "WARSZAWA",
        "04897": "WARSZAWA",
        "04898": "WARSZAWA",
        "04900": "WARSZAWA",
        "04901": "WARSZAWA",
        "04902": "WARSZAWA",
        "04903": "WARSZAWA",
        "04904": "WARSZAWA",
        "04906": "WARSZAWA",
        "04907": "WARSZAWA",
        "04908": "WARSZAWA",
        "04909": "WARSZAWA",
        "04910": "WARSZAWA",
        "04911": "WARSZAWA",
        "04912": "WARSZAWA",
        "04913": "WARSZAWA",
        "04914": "WARSZAWA",
        "04915": "WARSZAWA",
        "04916": "WARSZAWA",
        "04917": "WARSZAWA",
        "04918": "WARSZAWA",
        "04919": "WARSZAWA",
        "04920": "WARSZAWA",
        "04921": "WARSZAWA",
        "04922": "WARSZAWA",
        "04923": "WARSZAWA",
        "04924": "WARSZAWA",
        "04925": "WARSZAWA",
        "04926": "WARSZAWA",
        "04927": "WARSZAWA",
        "04928": "WARSZAWA",
        "04929": "WARSZAWA",
        "04930": "WARSZAWA",
        "04931": "WARSZAWA",
        "04932": "WARSZAWA",
        "04933": "WARSZAWA",
        "04934": "WARSZAWA",
        "04935": "WARSZAWA",
        "04936": "WARSZAWA",
        "04937": "WARSZAWA",
        "04938": "WARSZAWA",
        "04939": "WARSZAWA",
        "04940": "WARSZAWA",
        "04941": "WARSZAWA",
        "04942": "WARSZAWA",
        "04943": "WARSZAWA",
        "04944": "WARSZAWA",
        "04946": "WARSZAWA",
        "04947": "WARSZAWA",
        "04948": "WARSZAWA",
        "04949": "WARSZAWA",
        "04950": "WARSZAWA",
        "04951": "WARSZAWA",
        "04952": "WARSZAWA",
        "04953": "WARSZAWA",
        "04954": "WARSZAWA",
        "04955": "WARSZAWA",
        "04956": "WARSZAWA",
        "04957": "WARSZAWA",
        "04958": "WARSZAWA",
        "04959": "WARSZAWA",
        "04960": "WARSZAWA",
        "04961": "WARSZAWA",
        "04962": "WARSZAWA",
        "04963": "WARSZAWA",
        "04964": "WARSZAWA",
        "04965": "WARSZAWA",
        "04966": "WARSZAWA",
        "04967": "WARSZAWA",
        "04968": "WARSZAWA",
        "04969": "WARSZAWA",
        "04970": "WARSZAWA",
        "04971": "WARSZAWA",
        "04972": "WARSZAWA",
        "04973": "WARSZAWA",
        "04974": "WARSZAWA",
        "04975": "WARSZAWA",
        "04976": "WARSZAWA",
        "04977": "WARSZAWA",
        "04979": "WARSZAWA",
        "04980": "WARSZAWA",
        "04981": "WARSZAWA",
        "04982": "WARSZAWA",
        "04983": "WARSZAWA",
        "04984": "WARSZAWA",
        "04985": "WARSZAWA",
        "04986": "WARSZAWA",
        "04987": "WARSZAWA",
        "04988": "WARSZAWA",
        "04989": "WARSZAWA",
        "04990": "WARSZAWA",
        "04991": "WARSZAWA",
        "04992": "WARSZAWA",
        "04993": "WARSZAWA",
        "04994": "WARSZAWA",
        "04995": "WARSZAWA",
        "04996": "WARSZAWA",
        "04997": "WARSZAWA",
        "04998": "WARSZAWA",
        "05070": "SULEJÓWEK",
        "05071": "SULEJÓWEK",
        "05074": "MIŃSK MAZOWIECKI",
        "05075": "WARSZAWA",
        "05076": "WARSZAWA",
        "05077": "WARSZAWA",
        "05079": "MIŃSK MAZOWIECKI",
        "05080": "WARSZAWA",
        "05082": "WARSZAWA",
        "05083": "WARSZAWA",
        "05084": "WARSZAWA",
        "05085": "WARSZAWA",
        "05088": "SOCHACZEW",
        "05089": "SOCHACZEW",
        "05090": "PRUSZKÓW",
        "05091": "ZĄBKI",
        "05092": "WARSZAWA",
        "05093": "ZĄBKI",
        "05094": "PRUSZKÓW",
        "05100": "NOWY DWÓR MAZOWIECKI",
        "05101": "NOWY DWÓR MAZOWIECKI",
        "05102": "NOWY DWÓR MAZOWIECKI",
        "05110": "LEGIONOWO",
        "05118": "LEGIONOWO",
        "05119": "LEGIONOWO",
        "05120": "LEGIONOWO",
        "05121": "LEGIONOWO",
        "05122": "LEGIONOWO",
        "05123": "CHOTOMÓW",
        "05124": "LEGIONOWO",
        "05126": "LEGIONOWO",
        "05127": "LEGIONOWO",
        "05130": "LEGIONOWO",
        "05131": "LEGIONOWO",
        "05135": "LEGIONOWO",
        "05140": "LEGIONOWO",
        "05152": "NOWY DWÓR MAZOWIECKI",
        "05154": "NOWY DWÓR MAZOWIECKI",
        "05155": "NOWY DWÓR MAZOWIECKI",
        "05156": "NOWY DWÓR MAZOWIECKI",
        "05160": "NOWY DWÓR MAZOWIECKI",
        "05170": "NOWY DWÓR MAZOWIECKI",
        "05180": "NOWY DWÓR MAZOWIECKI",
        "05190": "NASIELSK",
        "05191": "NASIELSK",
        "05192": "NOWY DWÓR MAZOWIECKI",
        "05200": "WOŁOMIN",
        "05202": "WOŁOMIN",
        "05203": "WOŁOMIN",
        "05205": "WOŁOMIN",
        "05206": "WOŁOMIN",
        "05207": "WARSZAWA",
        "05220": "ZIELONKA",
        "05230": "WOŁOMIN",
        "05240": "WOŁOMIN",
        "05250": "RADZYMIN",
        "05252": "WOŁOMIN",
        "05253": "WOŁOMIN",
        "05254": "WOŁOMIN",
        "05255": "WOŁOMIN",
        "05260": "WOŁOMIN",
        "05270": "WOŁOMIN",
        "05280": "WOŁOMIN",
        "05281": "WOŁOMIN",
        "05282": "WOŁOMIN",
        "05300": "MIŃSK MAZOWIECKI (NET)",
        "05302": "MIŃSK MAZOWIECKI (NET)",
        "05303": "MIŃSK MAZOWIECKI (NET)",
        "05304": "MIŃSK MAZOWIECKI (NET)",
        "05305": "MIŃSK MAZOWIECKI",
        "05306": "MIŃSK MAZOWIECKI (NET)",
        "05307": "MIŃSK MAZOWIECKI (NET)",
        "05310": "MIŃSK MAZOWIECKI (NET)",
        "05311": "MIŃSK MAZOWIECKI (NET)",
        "05317": "MIŃSK MAZOWIECKI (NET)",
        "05319": "MIŃSK MAZOWIECKI (NET)",
        "05320": "MIŃSK MAZOWIECKI (NET)",
        "05326": "WOŁOMIN",
        "05332": "MIŃSK MAZOWIECKI (NET)",
        "05334": "MIŃSK MAZOWIECKI (NET)",
        "05340": "OTWOCK",
        "05400": "OTWOCK",
        "05401": "OTWOCK",
        "05402": "OTWOCK",
        "05403": "OTWOCK",
        "05408": "OTWOCK",
        "05410": "OTWOCK",
        "05420": "OTWOCK",
        "05430": "OTWOCK",
        "05462": "OTWOCK",
        "05480": "OTWOCK",
        "05500": "PIASECZNO",
        "05501": "PIASECZNO",
        "05502": "PIASECZNO",
        "05503": "PIASECZNO",
        "05504": "PIASECZNO",
        "05505": "PIASECZNO",
        "05506": "PIASECZNO",
        "05507": "PIASECZNO",
        "05508": "PIASECZNO",
        "05509": "PIASECZNO",
        "05510": "PIASECZNO",
        "05515": "PIASECZNO",
        "05520": "PIASECZNO",
        "05530": "GÓRA KALWARIA",
        "05532": "PIASECZNO",
        "05533": "PIASECZNO",
        "05540": "PIASECZNO",
        "05552": "PIASECZNO",
        "05555": "PIASECZNO",
        "05600": "GRÓJEC",
        "05601": "WARSZAWA",
        "05604": "GRÓJEC",
        "05610": "GRÓJEC",
        "05620": "GRÓJEC",
        "05622": "GRÓJEC",
        "05640": "GRÓJEC",
        "05650": "GRÓJEC",
        "05651": "GRÓJEC",
        "05652": "GRÓJEC",
        "05660": "WARKA",
        "05800": "PRUSZKÓW",
        "05802": "PRUSZKÓW",
        "05803": "PRUSZKÓW",
        "05804": "PRUSZKÓW",
        "05805": "PRUSZKÓW",
        "05806": "PRUSZKÓW",
        "05807": "GRODZISK MAZOWIECKI",
        "05808": "PRUSZKÓW",
        "05809": "PRUSZKÓW",
        "05816": "PRUSZKÓW",
        "05819": "PRUSZKÓW",
        "05820": "PRUSZKÓW",
        "05822": "GRODZISK MAZOWIECKI",
        "05824": "GRODZISK MAZOWIECKI",
        "05825": "GRODZISK MAZOWIECKI",
        "05826": "GRODZISK MAZOWIECKI",
        "05827": "GRODZISK MAZOWIECKI",
        "05830": "PRUSZKÓW",
        "05831": "PRUSZKÓW",
        "05840": "PRUSZKÓW",
        "05850": "OŻARÓW MAZOWIECKI",
        "05860": "WARSZAWA",
        "05870": "BŁONIE",
        "06100": "PUŁTUSK",
        "06102": "PUŁTUSK",
        "06114": "PUŁTUSK",
        "06120": "PUŁTUSK",
        "06121": "PUŁTUSK",
        "06123": "PUŁTUSK",
        "06124": "PUŁTUSK",
        "06126": "PUŁTUSK",
        "06141": "PUŁTUSK",
        "06150": "PUŁTUSK",
        "06200": "MAKÓW MAZOWIECKI",
        "06210": "MAKÓW MAZOWIECKI",
        "06211": "MAKÓW MAZOWIECKI",
        "06212": "MAKÓW MAZOWIECKI",
        "06213": "MAKÓW MAZOWIECKI",
        "06214": "MAKÓW MAZOWIECKI",
        "06216": "MAKÓW MAZOWIECKI",
        "06220": "MAKÓW MAZOWIECKI",
        "06225": "MAKÓW MAZOWIECKI",
        "06230": "MAKÓW MAZOWIECKI",
        "06231": "MAKÓW MAZOWIECKI",
        "06232": "MAKÓW MAZOWIECKI",
        "06300": "PRZASNYSZ",
        "06301": "PRZASNYSZ",
        "06302": "PRZASNYSZ",
        "06316": "PRZASNYSZ",
        "06320": "OSTROŁĘKA",
        "06322": "PRZASNYSZ",
        "06323": "PRZASNYSZ",
        "06330": "PRZASNYSZ",
        "06333": "PRZASNYSZ",
        "06400": "CIECHANÓW",
        "06401": "CIECHANÓW",
        "06402": "CIECHANÓW",
        "06403": "CIECHANÓW",
        "06404": "CIECHANÓW",
        "06405": "PRZASNYSZ",
        "06406": "CIECHANÓW",
        "06407": "CIECHANÓW",
        "06408": "PRZASNYSZ",
        "06409": "CIECHANÓW",
        "06410": "CIECHANÓW",
        "06411": "PRZASNYSZ",
        "06413": "CIECHANÓW",
        "06415": "PRZASNYSZ",
        "06420": "CIECHANÓW",
        "06425": "MAKÓW MAZOWIECKI",
        "06430": "CIECHANÓW",
        "06440": "CIECHANÓW",
        "06445": "MŁAWA",
        "06450": "CIECHANÓW",
        "06452": "CIECHANÓW",
        "06455": "CIECHANÓW",
        "06456": "CIECHANÓW",
        "06458": "MŁAWA",
        "06460": "CIECHANÓW",
        "06461": "CIECHANÓW",
        "06463": "CIECHANÓW",
        "06500": "MŁAWA",
        "06501": "MŁAWA",
        "06513": "MŁAWA",
        "06516": "MŁAWA",
        "06518": "MŁAWA",
        "06520": "MŁAWA",
        "06521": "MŁAWA",
        "06522": "MŁAWA",
        "06540": "MŁAWA",
        "06541": "MŁAWA",
        "06542": "MŁAWA",
        "06544": "MŁAWA",
        "06545": "MŁAWA",
        "06550": "MŁAWA",
        "06560": "MŁAWA",
        "06561": "MŁAWA",
        "06562": "MŁAWA",
        "07100": "WĘGRÓW",
        "07104": "WĘGRÓW",
        "07106": "WĘGRÓW",
        "07109": "WĘGRÓW",
        "07110": "WĘGRÓW",
        "07111": "WĘGRÓW",
        "07120": "WĘGRÓW",
        "07130": "ŁOCHÓW",
        "07132": "WĘGRÓW",
        "07140": "WĘGRÓW",
        "07200": "WYSZKÓW (NET)",
        "07201": "WYSZKÓW (NET)",
        "07202": "WYSZKÓW (NET)",
        "07203": "WYSZKÓW (NET)",
        "07204": "WYSZKÓW",
        "07205": "WYSZKÓW (NET)",
        "07206": "WYSZKÓW (NET)",
        "07207": "WYSZKÓW (NET)",
        "07210": "WYSZKÓW (NET)",
        "07211": "WYSZKÓW (NET)",
        "07214": "PUŁTUSK",
        "07215": "PUŁTUSK",
        "07217": "PUŁTUSK",
        "07220": "WYSZKÓW (NET)",
        "07221": "WYSZKÓW (NET)",
        "07230": "WYSZKÓW (NET)",
        "07300": "OSTRÓW MAZOWIECKA",
        "07302": "OSTRÓW MAZOWIECKA",
        "07303": "OSTRÓW MAZOWIECKA",
        "07304": "OSTRÓW MAZOWIECKA",
        "07305": "OSTRÓW MAZOWIECKA",
        "07306": "OSTRÓW MAZOWIECKA",
        "07308": "WYSZKÓW (NET)",
        "07310": "OSTRÓW MAZOWIECKA",
        "07311": "OSTRÓW MAZOWIECKA",
        "07319": "OSTRÓW MAZOWIECKA",
        "07320": "MAŁKINIA",
        "07321": "OSTRÓW MAZOWIECKA",
        "07322": "OSTRÓW MAZOWIECKA",
        "07323": "OSTRÓW MAZOWIECKA",
        "07324": "OSTRÓW MAZOWIECKA",
        "07325": "OSTRÓW MAZOWIECKA",
        "07326": "SOKOŁÓW PODLASKI",
        "07400": "OSTROŁĘKA",
        "07401": "OSTROŁĘKA",
        "07402": "OSTROŁĘKA",
        "07405": "OSTROŁĘKA",
        "07406": "OSTROŁĘKA",
        "07407": "OSTROŁĘKA",
        "07409": "OSTROŁĘKA",
        "07410": "OSTROŁĘKA",
        "07411": "OSTROŁĘKA",
        "07412": "OSTROŁĘKA",
        "07413": "OSTROŁĘKA",
        "07415": "OSTROŁĘKA",
        "07416": "OSTROŁĘKA",
        "07417": "OSTROŁĘKA",
        "07420": "OSTROŁĘKA",
        "07430": "OSTROŁĘKA",
        "07431": "OSTROŁĘKA",
        "07436": "OSTROŁĘKA",
        "07437": "OSTROŁĘKA",
        "07438": "OSTROŁĘKA",
        "07440": "GOWOROWO",
        "08100": "SIEDLCE",
        "08101": "SIEDLCE",
        "08102": "SIEDLCE",
        "08103": "SIEDLCE",
        "08104": "SIEDLCE",
        "08105": "SIEDLCE",
        "08106": "SIEDLCE",
        "08107": "SIEDLCE",
        "08108": "SIEDLCE",
        "08109": "SIEDLCE",
        "08110": "SIEDLCE",
        "08111": "SIEDLCE",
        "08112": "SIEDLCE",
        "08113": "SIEDLCE",
        "08114": "SIEDLCE",
        "08116": "SIEDLCE",
        "08117": "SIEDLCE",
        "08119": "SIEDLCE",
        "08122": "SIEDLCE",
        "08124": "SIEDLCE",
        "08125": "SIEDLCE",
        "08130": "SIEDLCE",
        "08140": "SIEDLCE",
        "08142": "SIEDLCE",
        "08200": "ŁOSICE",
        "08205": "ŁOSICE",
        "08206": "ŁOSICE",
        "08207": "ŁOSICE",
        "08210": "PLATERÓW",
        "08220": "ŁOSICE",
        "08221": "ŁOSICE",
        "08300": "SOKOŁÓW PODLASKI",
        "08301": "SOKOŁÓW PODLASKI",
        "08304": "SOKOŁÓW PODLASKI",
        "08307": "SOKOŁÓW PODLASKI",
        "08311": "SOKOŁÓW PODLASKI",
        "08320": "SOKOŁÓW PODLASKI",
        "08322": "SOKOŁÓW PODLASKI",
        "08330": "SOKOŁÓW PODLASKI",
        "08331": "SOKOŁÓW PODLASKI",
        "08400": "GARWOLIN",
        "08404": "GARWOLIN",
        "08410": "GARWOLIN",
        "08412": "GARWOLIN",
        "08420": "GARWOLIN",
        "08430": "GARWOLIN",
        "08439": "OTWOCK",
        "08440": "GARWOLIN",
        "08441": "GARWOLIN",
        "08443": "OTWOCK",
        "08445": "OTWOCK",
        "08450": "GARWOLIN",
        "08455": "GARWOLIN",
        "08460": "GARWOLIN",
        "08470": "GARWOLIN",
        "08480": "GARWOLIN",
        "08500": "RYKI",
        "08501": "RYKI",
        "08503": "RYKI",
        "08504": "RYKI",
        "08505": "DĘBLIN",
        "08521": "DĘBLIN",
        "08530": "DĘBLIN",
        "08540": "RYKI",
        "08550": "RYKI",
        "09100": "PŁOŃSK",
        "09101": "PŁOŃSK",
        "09104": "PŁOŃSK",
        "09105": "PŁOŃSK",
        "09110": "PŁOŃSK",
        "09120": "PŁOŃSK",
        "09130": "PŁOŃSK",
        "09131": "PŁOŃSK",
        "09134": "ŻUROMIN",
        "09135": "ŻUROMIN",
        "09136": "PŁOŃSK",
        "09138": "PŁOŃSK",
        "09140": "PŁOŃSK",
        "09141": "PŁOŃSK",
        "09142": "PŁOŃSK",
        "09145": "PŁOŃSK",
        "09146": "PŁOŃSK",
        "09150": "PŁOŃSK",
        "09151": "PŁOŃSK",
        "09152": "PŁOŃSK",
        "09162": "PŁOŃSK",
        "09163": "PŁOŃSK",
        "09164": "PŁOŃSK",
        "09166": "PŁOŃSK",
        "09200": "SIERPC",
        "09201": "SIERPC",
        "09204": "SIERPC",
        "09205": "SIERPC",
        "09206": "SIERPC",
        "09209": "PŁOCK",
        "09210": "PŁOCK",
        "09212": "SIERPC",
        "09213": "SIERPC",
        "09214": "SIERPC",
        "09215": "SIERPC",
        "09216": "SIERPC",
        "09226": "SIERPC",
        "09227": "SIERPC",
        "09228": "SIERPC",
        "09230": "PŁOCK",
        "09300": "ŻUROMIN",
        "09303": "ŻUROMIN",
        "09304": "ŻUROMIN",
        "09305": "ŻUROMIN",
        "09310": "ŻUROMIN",
        "09311": "ŻUROMIN",
        "09315": "ŻUROMIN",
        "09317": "ŻUROMIN",
        "09318": "ŻUROMIN",
        "09320": "ŻUROMIN",
        "09321": "ŻUROMIN",
        "09400": "PŁOCK",
        "09401": "PŁOCK",
        "09402": "PŁOCK",
        "09403": "PŁOCK",
        "09404": "PŁOCK",
        "09405": "PŁOCK",
        "09406": "PŁOCK",
        "09407": "PŁOCK",
        "09408": "PŁOCK",
        "09409": "PŁOCK",
        "09410": "PŁOCK",
        "09411": "PŁOCK",
        "09412": "PŁOCK",
        "09413": "PŁOCK",
        "09414": "PŁOCK",
        "09416": "PŁOCK",
        "09417": "PŁOCK",
        "09418": "PŁOCK",
        "09419": "PŁOCK",
        "09420": "PŁOCK",
        "09440": "PŁOCK",
        "09442": "PŁOCK",
        "09450": "PŁOCK",
        "09451": "PŁOCK",
        "09452": "PŁOCK",
        "09454": "PŁOCK",
        "09460": "PŁOCK",
        "09470": "PŁOCK",
        "09471": "PŁOCK",
        "09472": "PŁOCK",
        "09500": "GOSTYNIN",
        "09501": "GOSTYNIN",
        "09504": "GOSTYNIN",
        "09505": "PŁOCK",
        "09506": "PŁOCK",
        "09520": "PŁOCK",
        "09522": "PŁOCK",
        "09530": "PŁOCK",
        "09533": "PŁOCK",
        "09540": "GOSTYNIN",
        "09541": "GOSTYNIN",
        "09542": "PŁOCK",
        "09543": "GOSTYNIN",
        "09550": "GOSTYNIN",
        "10001": "OLSZTYN",
        "10003": "OLSZTYN",
        "10004": "OLSZTYN",
        "10005": "OLSZTYN",
        "10006": "OLSZTYN",
        "10007": "OLSZTYN",
        "10008": "OLSZTYN",
        "10009": "OLSZTYN",
        "10010": "OLSZTYN",
        "10011": "OLSZTYN",
        "10012": "OLSZTYN",
        "10013": "OLSZTYN",
        "10014": "OLSZTYN",
        "10015": "OLSZTYN",
        "10016": "OLSZTYN",
        "10017": "OLSZTYN",
        "10018": "OLSZTYN",
        "10019": "OLSZTYN",
        "10020": "OLSZTYN",
        "10021": "OLSZTYN",
        "10022": "OLSZTYN",
        "10023": "OLSZTYN",
        "10024": "OLSZTYN",
        "10025": "OLSZTYN",
        "10026": "OLSZTYN",
        "10027": "OLSZTYN",
        "10028": "OLSZTYN",
        "10029": "OLSZTYN",
        "10030": "OLSZTYN",
        "10031": "OLSZTYN",
        "10032": "OLSZTYN",
        "10033": "OLSZTYN",
        "10034": "OLSZTYN",
        "10035": "OLSZTYN",
        "10036": "OLSZTYN",
        "10037": "OLSZTYN",
        "10038": "OLSZTYN",
        "10039": "OLSZTYN",
        "10040": "OLSZTYN",
        "10041": "OLSZTYN",
        "10042": "OLSZTYN",
        "10043": "OLSZTYN",
        "10044": "OLSZTYN",
        "10045": "OLSZTYN",
        "10046": "OLSZTYN",
        "10047": "OLSZTYN",
        "10048": "OLSZTYN",
        "10049": "OLSZTYN",
        "10050": "OLSZTYN",
        "10051": "OLSZTYN",
        "10052": "OLSZTYN",
        "10053": "OLSZTYN",
        "10054": "OLSZTYN",
        "10055": "OLSZTYN",
        "10056": "OLSZTYN",
        "10057": "OLSZTYN",
        "10059": "OLSZTYN",
        "10061": "OLSZTYN",
        "10062": "OLSZTYN",
        "10063": "OLSZTYN",
        "10064": "OLSZTYN",
        "10065": "OLSZTYN",
        "10066": "OLSZTYN",
        "10067": "OLSZTYN",
        "10068": "OLSZTYN",
        "10069": "OLSZTYN",
        "10070": "OLSZTYN",
        "10072": "OLSZTYN",
        "10073": "OLSZTYN",
        "10074": "OLSZTYN",
        "10075": "OLSZTYN",
        "10076": "OLSZTYN",
        "10077": "OLSZTYN",
        "10078": "OLSZTYN",
        "10079": "OLSZTYN",
        "10080": "OLSZTYN",
        "10081": "OLSZTYN",
        "10082": "OLSZTYN",
        "10083": "OLSZTYN",
        "10084": "OLSZTYN",
        "10085": "OLSZTYN",
        "10086": "OLSZTYN",
        "10087": "OLSZTYN",
        "10088": "OLSZTYN",
        "10089": "OLSZTYN",
        "10090": "OLSZTYN",
        "10091": "OLSZTYN",
        "10092": "OLSZTYN",
        "10101": "OLSZTYN",
        "10102": "OLSZTYN",
        "10103": "OLSZTYN",
        "10104": "OLSZTYN",
        "10105": "OLSZTYN",
        "10106": "OLSZTYN",
        "10109": "OLSZTYN",
        "10110": "OLSZTYN",
        "10111": "OLSZTYN",
        "10112": "OLSZTYN",
        "10113": "OLSZTYN",
        "10114": "OLSZTYN",
        "10115": "OLSZTYN",
        "10116": "OLSZTYN",
        "10117": "OLSZTYN",
        "10118": "OLSZTYN",
        "10119": "OLSZTYN",
        "10120": "OLSZTYN",
        "10121": "OLSZTYN",
        "10123": "OLSZTYN",
        "10124": "OLSZTYN",
        "10125": "OLSZTYN",
        "10126": "OLSZTYN",
        "10127": "OLSZTYN",
        "10129": "OLSZTYN",
        "10130": "OLSZTYN",
        "10131": "OLSZTYN",
        "10132": "OLSZTYN",
        "10133": "OLSZTYN",
        "10135": "OLSZTYN",
        "10136": "OLSZTYN",
        "10137": "OLSZTYN",
        "10138": "OLSZTYN",
        "10139": "OLSZTYN",
        "10140": "OLSZTYN",
        "10141": "OLSZTYN",
        "10142": "OLSZTYN",
        "10143": "OLSZTYN",
        "10144": "OLSZTYN",
        "10145": "OLSZTYN",
        "10147": "OLSZTYN",
        "10148": "OLSZTYN",
        "10149": "OLSZTYN",
        "10150": "OLSZTYN",
        "10151": "OLSZTYN",
        "10153": "OLSZTYN",
        "10154": "OLSZTYN",
        "10155": "OLSZTYN",
        "10156": "OLSZTYN",
        "10157": "OLSZTYN",
        "10158": "OLSZTYN",
        "10159": "OLSZTYN",
        "10160": "OLSZTYN",
        "10161": "OLSZTYN",
        "10162": "OLSZTYN",
        "10163": "OLSZTYN",
        "10164": "OLSZTYN",
        "10165": "OLSZTYN",
        "10166": "OLSZTYN",
        "10167": "OLSZTYN",
        "10168": "OLSZTYN",
        "10169": "OLSZTYN",
        "10170": "OLSZTYN",
        "10171": "OLSZTYN",
        "10172": "OLSZTYN",
        "10173": "OLSZTYN",
        "10174": "OLSZTYN",
        "10175": "OLSZTYN",
        "10176": "OLSZTYN",
        "10177": "OLSZTYN",
        "10178": "OLSZTYN",
        "10179": "OLSZTYN",
        "10180": "OLSZTYN",
        "10181": "OLSZTYN",
        "10182": "OLSZTYN",
        "10183": "OLSZTYN",
        "10184": "OLSZTYN",
        "10185": "OLSZTYN",
        "10186": "OLSZTYN",
        "10187": "OLSZTYN",
        "10188": "OLSZTYN",
        "10189": "OLSZTYN",
        "10190": "OLSZTYN",
        "10191": "OLSZTYN",
        "10192": "OLSZTYN",
        "10201": "OLSZTYN",
        "10202": "OLSZTYN",
        "10203": "OLSZTYN",
        "10204": "OLSZTYN",
        "10205": "OLSZTYN",
        "10206": "OLSZTYN",
        "10207": "OLSZTYN",
        "10208": "OLSZTYN",
        "10209": "OLSZTYN",
        "10210": "OLSZTYN",
        "10211": "OLSZTYN",
        "10212": "OLSZTYN",
        "10213": "OLSZTYN",
        "10214": "OLSZTYN",
        "10215": "OLSZTYN",
        "10216": "OLSZTYN",
        "10217": "OLSZTYN",
        "10218": "OLSZTYN",
        "10219": "OLSZTYN",
        "10220": "OLSZTYN",
        "10221": "OLSZTYN",
        "10222": "OLSZTYN",
        "10223": "OLSZTYN",
        "10224": "OLSZTYN",
        "10225": "OLSZTYN",
        "10226": "OLSZTYN",
        "10227": "OLSZTYN",
        "10228": "OLSZTYN",
        "10229": "OLSZTYN",
        "10230": "OLSZTYN",
        "10232": "OLSZTYN",
        "10233": "OLSZTYN",
        "10234": "OLSZTYN",
        "10235": "OLSZTYN",
        "10236": "OLSZTYN",
        "10237": "OLSZTYN",
        "10238": "OLSZTYN",
        "10239": "OLSZTYN",
        "10240": "OLSZTYN",
        "10241": "OLSZTYN",
        "10242": "OLSZTYN",
        "10243": "OLSZTYN",
        "10244": "OLSZTYN",
        "10245": "OLSZTYN",
        "10246": "OLSZTYN",
        "10247": "OLSZTYN",
        "10248": "OLSZTYN",
        "10249": "OLSZTYN",
        "10250": "OLSZTYN",
        "10251": "OLSZTYN",
        "10252": "OLSZTYN",
        "10253": "OLSZTYN",
        "10254": "OLSZTYN",
        "10255": "OLSZTYN",
        "10256": "OLSZTYN",
        "10257": "OLSZTYN",
        "10258": "OLSZTYN",
        "10259": "OLSZTYN",
        "10260": "OLSZTYN",
        "10261": "OLSZTYN",
        "10262": "OLSZTYN",
        "10266": "OLSZTYN",
        "10267": "OLSZTYN",
        "10268": "OLSZTYN",
        "10269": "OLSZTYN",
        "10270": "OLSZTYN",
        "10271": "OLSZTYN",
        "10272": "OLSZTYN",
        "10273": "OLSZTYN",
        "10274": "OLSZTYN",
        "10275": "OLSZTYN",
        "10276": "OLSZTYN",
        "10277": "OLSZTYN",
        "10278": "OLSZTYN",
        "10279": "OLSZTYN",
        "10280": "OLSZTYN",
        "10281": "OLSZTYN",
        "10282": "OLSZTYN",
        "10283": "OLSZTYN",
        "10284": "OLSZTYN",
        "10285": "OLSZTYN",
        "10286": "OLSZTYN",
        "10287": "OLSZTYN",
        "10288": "OLSZTYN",
        "10290": "OLSZTYN",
        "10291": "OLSZTYN",
        "10292": "OLSZTYN",
        "10293": "OLSZTYN",
        "10294": "OLSZTYN",
        "10295": "OLSZTYN",
        "10301": "OLSZTYN",
        "10302": "OLSZTYN",
        "10303": "OLSZTYN",
        "10304": "OLSZTYN",
        "10305": "OLSZTYN",
        "10306": "OLSZTYN",
        "10307": "OLSZTYN",
        "10308": "OLSZTYN",
        "10309": "OLSZTYN",
        "10310": "OLSZTYN",
        "10313": "OLSZTYN",
        "10314": "OLSZTYN",
        "10315": "OLSZTYN",
        "10316": "OLSZTYN",
        "10319": "OLSZTYN",
        "10320": "OLSZTYN",
        "10321": "OLSZTYN",
        "10322": "OLSZTYN",
        "10323": "OLSZTYN",
        "10324": "OLSZTYN",
        "10325": "OLSZTYN",
        "10326": "OLSZTYN",
        "10327": "OLSZTYN",
        "10329": "OLSZTYN",
        "10330": "OLSZTYN",
        "10332": "OLSZTYN",
        "10333": "OLSZTYN",
        "10334": "OLSZTYN",
        "10335": "OLSZTYN",
        "10336": "OLSZTYN",
        "10337": "OLSZTYN",
        "10339": "OLSZTYN",
        "10340": "OLSZTYN",
        "10341": "OLSZTYN",
        "10342": "OLSZTYN",
        "10343": "OLSZTYN",
        "10344": "OLSZTYN",
        "10345": "OLSZTYN",
        "10346": "OLSZTYN",
        "10347": "OLSZTYN",
        "10348": "OLSZTYN",
        "10349": "OLSZTYN",
        "10350": "OLSZTYN",
        "10351": "OLSZTYN",
        "10352": "OLSZTYN",
        "10353": "OLSZTYN",
        "10354": "OLSZTYN",
        "10355": "OLSZTYN",
        "10356": "OLSZTYN",
        "10357": "OLSZTYN",
        "10358": "OLSZTYN",
        "10359": "OLSZTYN",
        "10360": "OLSZTYN",
        "10361": "OLSZTYN",
        "10362": "OLSZTYN",
        "10363": "OLSZTYN",
        "10364": "OLSZTYN",
        "10365": "OLSZTYN",
        "10366": "OLSZTYN",
        "10367": "OLSZTYN",
        "10368": "OLSZTYN",
        "10369": "OLSZTYN",
        "10370": "OLSZTYN",
        "10371": "OLSZTYN",
        "10372": "OLSZTYN",
        "10373": "OLSZTYN",
        "10374": "OLSZTYN",
        "10375": "OLSZTYN",
        "10376": "OLSZTYN",
        "10377": "OLSZTYN",
        "10378": "OLSZTYN",
        "10379": "OLSZTYN",
        "10380": "OLSZTYN",
        "10381": "OLSZTYN",
        "10382": "OLSZTYN",
        "10401": "OLSZTYN",
        "10402": "OLSZTYN",
        "10404": "OLSZTYN",
        "10405": "OLSZTYN",
        "10406": "OLSZTYN",
        "10407": "OLSZTYN",
        "10408": "OLSZTYN",
        "10409": "OLSZTYN",
        "10410": "OLSZTYN",
        "10413": "OLSZTYN",
        "10414": "OLSZTYN",
        "10416": "OLSZTYN",
        "10417": "OLSZTYN",
        "10418": "OLSZTYN",
        "10419": "OLSZTYN",
        "10420": "OLSZTYN",
        "10421": "OLSZTYN",
        "10422": "OLSZTYN",
        "10423": "OLSZTYN",
        "10424": "OLSZTYN",
        "10425": "OLSZTYN",
        "10426": "OLSZTYN",
        "10427": "OLSZTYN",
        "10429": "OLSZTYN",
        "10430": "OLSZTYN",
        "10431": "OLSZTYN",
        "10432": "OLSZTYN",
        "10433": "OLSZTYN",
        "10434": "OLSZTYN",
        "10436": "OLSZTYN",
        "10437": "OLSZTYN",
        "10438": "OLSZTYN",
        "10442": "OLSZTYN",
        "10443": "OLSZTYN",
        "10444": "OLSZTYN",
        "10445": "OLSZTYN",
        "10446": "OLSZTYN",
        "10447": "OLSZTYN",
        "10448": "OLSZTYN",
        "10449": "OLSZTYN",
        "10450": "OLSZTYN",
        "10454": "OLSZTYN",
        "10455": "OLSZTYN",
        "10456": "OLSZTYN",
        "10457": "OLSZTYN",
        "10459": "OLSZTYN",
        "10460": "OLSZTYN",
        "10461": "OLSZTYN",
        "10462": "OLSZTYN",
        "10463": "OLSZTYN",
        "10464": "OLSZTYN",
        "10465": "OLSZTYN",
        "10467": "OLSZTYN",
        "10501": "OLSZTYN",
        "10502": "OLSZTYN",
        "10503": "OLSZTYN",
        "10504": "OLSZTYN",
        "10505": "OLSZTYN",
        "10506": "OLSZTYN",
        "10507": "OLSZTYN",
        "10508": "OLSZTYN",
        "10509": "OLSZTYN",
        "10510": "OLSZTYN",
        "10511": "OLSZTYN",
        "10512": "OLSZTYN",
        "10513": "OLSZTYN",
        "10514": "OLSZTYN",
        "10515": "OLSZTYN",
        "10516": "OLSZTYN",
        "10517": "OLSZTYN",
        "10518": "OLSZTYN",
        "10519": "OLSZTYN",
        "10520": "OLSZTYN",
        "10521": "OLSZTYN",
        "10522": "OLSZTYN",
        "10523": "OLSZTYN",
        "10524": "OLSZTYN",
        "10525": "OLSZTYN",
        "10526": "OLSZTYN",
        "10527": "OLSZTYN",
        "10528": "OLSZTYN",
        "10529": "OLSZTYN",
        "10530": "OLSZTYN",
        "10531": "OLSZTYN",
        "10532": "OLSZTYN",
        "10533": "OLSZTYN",
        "10534": "OLSZTYN",
        "10535": "OLSZTYN",
        "10536": "OLSZTYN",
        "10537": "OLSZTYN",
        "10538": "OLSZTYN",
        "10539": "OLSZTYN",
        "10540": "OLSZTYN",
        "10541": "OLSZTYN",
        "10542": "OLSZTYN",
        "10543": "OLSZTYN",
        "10544": "OLSZTYN",
        "10545": "OLSZTYN",
        "10546": "OLSZTYN",
        "10547": "OLSZTYN",
        "10548": "OLSZTYN",
        "10549": "OLSZTYN",
        "10550": "OLSZTYN",
        "10551": "OLSZTYN",
        "10552": "OLSZTYN",
        "10553": "OLSZTYN",
        "10554": "OLSZTYN",
        "10555": "OLSZTYN",
        "10556": "OLSZTYN",
        "10557": "OLSZTYN",
        "10558": "OLSZTYN",
        "10559": "OLSZTYN",
        "10560": "OLSZTYN",
        "10561": "OLSZTYN",
        "10562": "OLSZTYN",
        "10563": "OLSZTYN",
        "10564": "OLSZTYN",
        "10565": "OLSZTYN",
        "10566": "OLSZTYN",
        "10570": "OLSZTYN",
        "10572": "OLSZTYN",
        "10573": "OLSZTYN",
        "10574": "OLSZTYN",
        "10575": "OLSZTYN",
        "10576": "OLSZTYN",
        "10577": "OLSZTYN",
        "10578": "OLSZTYN",
        "10579": "OLSZTYN",
        "10580": "OLSZTYN",
        "10581": "OLSZTYN",
        "10583": "OLSZTYN",
        "10584": "OLSZTYN",
        "10585": "OLSZTYN",
        "10586": "OLSZTYN",
        "10587": "OLSZTYN",
        "10588": "OLSZTYN",
        "10589": "OLSZTYN",
        "10601": "OLSZTYN",
        "10602": "OLSZTYN",
        "10603": "OLSZTYN",
        "10604": "OLSZTYN",
        "10605": "OLSZTYN",
        "10606": "OLSZTYN",
        "10607": "OLSZTYN",
        "10608": "OLSZTYN",
        "10609": "OLSZTYN",
        "10610": "OLSZTYN",
        "10611": "OLSZTYN",
        "10612": "OLSZTYN",
        "10613": "OLSZTYN",
        "10614": "OLSZTYN",
        "10615": "OLSZTYN",
        "10616": "OLSZTYN",
        "10617": "OLSZTYN",
        "10619": "OLSZTYN",
        "10620": "OLSZTYN",
        "10621": "OLSZTYN",
        "10622": "OLSZTYN",
        "10623": "OLSZTYN",
        "10624": "OLSZTYN",
        "10625": "OLSZTYN",
        "10626": "OLSZTYN",
        "10627": "OLSZTYN",
        "10628": "OLSZTYN",
        "10629": "OLSZTYN",
        "10630": "OLSZTYN",
        "10631": "OLSZTYN",
        "10632": "OLSZTYN",
        "10633": "OLSZTYN",
        "10634": "OLSZTYN",
        "10635": "OLSZTYN",
        "10636": "OLSZTYN",
        "10637": "OLSZTYN",
        "10638": "OLSZTYN",
        "10639": "OLSZTYN",
        "10640": "OLSZTYN",
        "10642": "OLSZTYN",
        "10643": "OLSZTYN",
        "10644": "OLSZTYN",
        "10645": "OLSZTYN",
        "10646": "OLSZTYN",
        "10647": "OLSZTYN",
        "10648": "OLSZTYN",
        "10649": "OLSZTYN",
        "10650": "OLSZTYN",
        "10651": "OLSZTYN",
        "10652": "OLSZTYN",
        "10653": "OLSZTYN",
        "10654": "OLSZTYN",
        "10655": "OLSZTYN",
        "10656": "OLSZTYN",
        "10657": "OLSZTYN",
        "10658": "OLSZTYN",
        "10659": "OLSZTYN",
        "10660": "OLSZTYN",
        "10661": "OLSZTYN",
        "10662": "OLSZTYN",
        "10663": "OLSZTYN",
        "10664": "OLSZTYN",
        "10665": "OLSZTYN",
        "10666": "OLSZTYN",
        "10667": "OLSZTYN",
        "10668": "OLSZTYN",
        "10669": "OLSZTYN",
        "10670": "OLSZTYN",
        "10672": "OLSZTYN",
        "10673": "OLSZTYN",
        "10674": "OLSZTYN",
        "10675": "OLSZTYN",
        "10676": "OLSZTYN",
        "10677": "OLSZTYN",
        "10678": "OLSZTYN",
        "10679": "OLSZTYN",
        "10680": "OLSZTYN",
        "10681": "OLSZTYN",
        "10682": "OLSZTYN",
        "10683": "OLSZTYN",
        "10684": "OLSZTYN",
        "10685": "OLSZTYN",
        "10686": "OLSZTYN",
        "10687": "OLSZTYN",
        "10688": "OLSZTYN",
        "10689": "OLSZTYN",
        "10690": "OLSZTYN",
        "10691": "OLSZTYN",
        "10692": "OLSZTYN",
        "10693": "OLSZTYN",
        "10694": "OLSZTYN",
        "10695": "OLSZTYN",
        "10696": "OLSZTYN",
        "10698": "OLSZTYN",
        "10699": "OLSZTYN",
        "10701": "OLSZTYN",
        "10702": "OLSZTYN",
        "10705": "OLSZTYN",
        "10706": "OLSZTYN",
        "10707": "OLSZTYN",
        "10708": "OLSZTYN",
        "10709": "OLSZTYN",
        "10710": "OLSZTYN",
        "10711": "OLSZTYN",
        "10712": "OLSZTYN",
        "10713": "OLSZTYN",
        "10718": "OLSZTYN",
        "10719": "OLSZTYN",
        "10720": "OLSZTYN",
        "10721": "OLSZTYN",
        "10722": "OLSZTYN",
        "10723": "OLSZTYN",
        "10724": "OLSZTYN",
        "10725": "OLSZTYN",
        "10726": "OLSZTYN",
        "10727": "OLSZTYN",
        "10728": "OLSZTYN",
        "10745": "OLSZTYN",
        "10746": "OLSZTYN",
        "10747": "OLSZTYN",
        "10748": "OLSZTYN",
        "10749": "OLSZTYN",
        "10750": "OLSZTYN",
        "10751": "OLSZTYN",
        "10752": "OLSZTYN",
        "10753": "OLSZTYN",
        "10754": "OLSZTYN",
        "10755": "OLSZTYN",
        "10756": "OLSZTYN",
        "10757": "OLSZTYN",
        "10758": "OLSZTYN",
        "10759": "OLSZTYN",
        "10760": "OLSZTYN",
        "10761": "OLSZTYN",
        "10762": "OLSZTYN",
        "10763": "OLSZTYN",
        "10764": "OLSZTYN",
        "10765": "OLSZTYN",
        "10766": "OLSZTYN",
        "10767": "OLSZTYN",
        "10768": "OLSZTYN",
        "10769": "OLSZTYN",
        "10770": "OLSZTYN",
        "10771": "OLSZTYN",
        "10772": "OLSZTYN",
        "10773": "OLSZTYN",
        "10774": "OLSZTYN",
        "10801": "OLSZTYN",
        "10802": "OLSZTYN",
        "10803": "OLSZTYN",
        "10804": "OLSZTYN",
        "10805": "OLSZTYN",
        "10806": "OLSZTYN",
        "10807": "OLSZTYN",
        "10808": "OLSZTYN",
        "10809": "OLSZTYN",
        "10810": "OLSZTYN",
        "10811": "OLSZTYN",
        "10812": "OLSZTYN",
        "10813": "OLSZTYN",
        "10814": "OLSZTYN",
        "10815": "OLSZTYN",
        "10816": "OLSZTYN",
        "10817": "OLSZTYN",
        "10818": "OLSZTYN",
        "10819": "OLSZTYN",
        "10820": "OLSZTYN",
        "10822": "OLSZTYN",
        "10823": "OLSZTYN",
        "10824": "OLSZTYN",
        "10825": "OLSZTYN",
        "10828": "OLSZTYN",
        "10829": "OLSZTYN",
        "10830": "OLSZTYN",
        "10831": "OLSZTYN",
        "10832": "OLSZTYN",
        "10833": "OLSZTYN",
        "10834": "OLSZTYN",
        "10835": "OLSZTYN",
        "10836": "OLSZTYN",
        "10837": "OLSZTYN",
        "10838": "OLSZTYN",
        "10839": "OLSZTYN",
        "10840": "OLSZTYN",
        "10841": "OLSZTYN",
        "10842": "OLSZTYN",
        "10843": "OLSZTYN",
        "10844": "OLSZTYN",
        "10845": "OLSZTYN",
        "10846": "OLSZTYN",
        "10847": "OLSZTYN",
        "10848": "OLSZTYN",
        "10849": "OLSZTYN",
        "10850": "OLSZTYN",
        "10851": "OLSZTYN",
        "10852": "OLSZTYN",
        "10853": "OLSZTYN",
        "10854": "OLSZTYN",
        "10855": "OLSZTYN",
        "10856": "OLSZTYN",
        "10857": "OLSZTYN",
        "10858": "OLSZTYN",
        "10859": "OLSZTYN",
        "10860": "OLSZTYN",
        "10861": "OLSZTYN",
        "10862": "OLSZTYN",
        "10900": "OLSZTYN",
        "10903": "OLSZTYN",
        "10940": "OLSZTYN",
        "10941": "OLSZTYN",
        "10950": "OLSZTYN",
        "10952": "OLSZTYN",
        "10953": "OLSZTYN",
        "10954": "OLSZTYN",
        "10955": "OLSZTYN",
        "10956": "OLSZTYN",
        "10958": "OLSZTYN",
        "10959": "OLSZTYN",
        "11001": "OLSZTYN",
        "11002": "OLSZTYN",
        "11008": "OLSZTYN",
        "11010": "OLSZTYN",
        "11015": "OLSZTYN",
        "11030": "OLSZTYN",
        "11034": "OLSZTYN",
        "11036": "OLSZTYN",
        "11040": "OLSZTYN",
        "11041": "OLSZTYN",
        "11042": "OLSZTYN",
        "11043": "OLSZTYN",
        "11100": "LIDZBARK WARMIŃSKI",
        "11101": "LIDZBARK WARMIŃSKI",
        "11102": "LIDZBARK WARMIŃSKI",
        "11106": "LIDZBARK WARMIŃSKI",
        "11107": "LIDZBARK WARMIŃSKI",
        "11130": "ORNETA",
        "11135": "LIDZBARK WARMIŃSKI",
        "11200": "BARTOSZYCE",
        "11201": "BARTOSZYCE",
        "11204": "BARTOSZYCE",
        "11210": "BARTOSZYCE",
        "11211": "BARTOSZYCE",
        "11214": "BARTOSZYCE",
        "11218": "BARTOSZYCE",
        "11220": "BARTOSZYCE",
        "11227": "BARTOSZYCE",
        "11230": "BARTOSZYCE",
        "11300": "OLSZTYN",
        "11301": "OLSZTYN",
        "11302": "OLSZTYN",
        "11311": "OLSZTYN",
        "11313": "NIDZICA",
        "11320": "OLSZTYN",
        "11400": "KĘTRZYN",
        "11401": "KĘTRZYN",
        "11402": "KĘTRZYN",
        "11404": "KĘTRZYN",
        "11405": "KĘTRZYN",
        "11409": "KĘTRZYN",
        "11410": "KĘTRZYN",
        "11414": "KĘTRZYN",
        "11420": "KĘTRZYN",
        "11430": "KĘTRZYN",
        "11440": "KĘTRZYN",
        "11441": "KĘTRZYN",
        "11442": "KĘTRZYN",
        "11500": "GIŻYCKO",
        "11501": "GIŻYCKO",
        "11503": "GIŻYCKO",
        "11504": "GIŻYCKO",
        "11507": "GIŻYCKO",
        "11508": "GIŻYCKO",
        "11510": "GIŻYCKO",
        "11513": "GIŻYCKO",
        "11520": "GIŻYCKO",
        "11600": "WĘGORZEWO",
        "11601": "WĘGORZEWO",
        "11606": "WĘGORZEWO",
        "11610": "WĘGORZEWO",
        "11612": "GIŻYCKO",
        "11700": "MRĄGOWO",
        "11701": "MRĄGOWO",
        "11702": "MRĄGOWO",
        "11709": "MRĄGOWO",
        "11710": "MRĄGOWO",
        "11730": "MRĄGOWO",
        "11731": "MRĄGOWO",
        "11732": "MRĄGOWO",
        "11737": "MRĄGOWO",
        "12100": "SZCZYTNO",
        "12101": "SZCZYTNO",
        "12102": "SZCZYTNO",
        "12114": "SZCZYTNO",
        "12120": "SZCZYTNO",
        "12122": "SZCZYTNO",
        "12130": "SZCZYTNO",
        "12140": "SZCZYTNO",
        "12150": "SZCZYTNO",
        "12160": "SZCZYTNO",
        "12200": "PISZ",
        "12201": "PISZ",
        "12202": "PISZ",
        "12207": "PISZ",
        "12220": "PISZ",
        "12221": "PISZ",
        "12230": "PISZ",
        "12250": "ORZYSZ",
        "12251": "ORZYSZ",
        "13100": "NIDZICA",
        "13105": "NIDZICA",
        "13111": "NIDZICA",
        "13112": "NIDZICA",
        "13113": "NIDZICA",
        "13124": "NIDZICA",
        "13125": "NIDZICA",
        "13200": "DZIAŁDOWO",
        "13201": "DZIAŁDOWO",
        "13203": "LIDZBARK WARMIŃSKI",
        "13204": "DZIAŁDOWO",
        "13206": "DZIAŁDOWO",
        "13210": "DZIAŁDOWO",
        "13214": "DZIAŁDOWO",
        "13220": "DZIAŁDOWO",
        "13230": "LIDZBARK",
        "13240": "DZIAŁDOWO",
        "13300": "NOWE MIASTO LUBAWSKIE",
        "13304": "NOWE MIASTO LUBAWSKIE",
        "13305": "DZIAŁDOWO",
        "13306": "NOWE MIASTO LUBAWSKIE",
        "13307": "DZIAŁDOWO",
        "13308": "NOWE MIASTO LUBAWSKIE",
        "13314": "NOWE MIASTO LUBAWSKIE",
        "13315": "NOWE MIASTO LUBAWSKIE",
        "13324": "NOWE MIASTO LUBAWSKIE",
        "13330": "NOWE MIASTO LUBAWSKIE",
        "13331": "DZIAŁDOWO",
        "13332": "NOWE MIASTO LUBAWSKIE",
        "13334": "NOWE MIASTO LUBAWSKIE",
        "13340": "NOWE MIASTO LUBAWSKIE",
        "13341": "DZIAŁDOWO",
        "14100": "OSTRÓDA",
        "14101": "OSTRÓDA",
        "14102": "OSTRÓDA",
        "14103": "OSTRÓDA",
        "14104": "OSTRÓDA",
        "14105": "OSTRÓDA",
        "14106": "OSTRÓDA",
        "14107": "OSTRÓDA",
        "14110": "OSTRÓDA",
        "14120": "OSTRÓDA",
        "14133": "OSTRÓDA",
        "14140": "OSTRÓDA",
        "14200": "IŁAWA",
        "14202": "IŁAWA",
        "14204": "IŁAWA",
        "14210": "IŁAWA",
        "14216": "IŁAWA",
        "14220": "IŁAWA",
        "14229": "IŁAWA",
        "14230": "IŁAWA",
        "14233": "IŁAWA",
        "14240": "IŁAWA",
        "14241": "IŁAWA",
        "14260": "IŁAWA",
        "14300": "MORĄG",
        "14301": "MORĄG",
        "14310": "OSTRÓDA",
        "14330": "OSTRÓDA",
        "14400": "PASŁĘK",
        "14401": "PASŁĘK",
        "14405": "BRANIEWO",
        "14407": "ELBLĄG",
        "14411": "ELBLĄG",
        "14420": "ELBLĄG",
        "14500": "BRANIEWO",
        "14501": "BRANIEWO",
        "14502": "BRANIEWO",
        "14520": "BRANIEWO",
        "14521": "BRANIEWO",
        "14522": "BRANIEWO",
        "14526": "BRANIEWO",
        "14527": "BRANIEWO",
        "14528": "BRANIEWO",
        "14530": "BRANIEWO",
        "15001": "BIAŁYSTOK",
        "15002": "BIAŁYSTOK",
        "15003": "BIAŁYSTOK",
        "15004": "BIAŁYSTOK",
        "15005": "BIAŁYSTOK",
        "15006": "BIAŁYSTOK",
        "15007": "BIAŁYSTOK",
        "15008": "BIAŁYSTOK",
        "15010": "BIAŁYSTOK",
        "15011": "BIAŁYSTOK",
        "15013": "BIAŁYSTOK",
        "15014": "BIAŁYSTOK",
        "15016": "BIAŁYSTOK",
        "15017": "BIAŁYSTOK",
        "15019": "BIAŁYSTOK",
        "15021": "BIAŁYSTOK",
        "15023": "BIAŁYSTOK",
        "15024": "BIAŁYSTOK",
        "15025": "BIAŁYSTOK",
        "15026": "BIAŁYSTOK",
        "15027": "BIAŁYSTOK",
        "15028": "BIAŁYSTOK",
        "15029": "BIAŁYSTOK",
        "15030": "BIAŁYSTOK",
        "15032": "BIAŁYSTOK",
        "15034": "BIAŁYSTOK",
        "15035": "BIAŁYSTOK",
        "15037": "BIAŁYSTOK",
        "15038": "BIAŁYSTOK",
        "15040": "BIAŁYSTOK",
        "15042": "BIAŁYSTOK",
        "15044": "BIAŁYSTOK",
        "15045": "BIAŁYSTOK",
        "15046": "BIAŁYSTOK",
        "15047": "BIAŁYSTOK",
        "15048": "BIAŁYSTOK",
        "15050": "BIAŁYSTOK",
        "15052": "BIAŁYSTOK",
        "15054": "BIAŁYSTOK",
        "15055": "BIAŁYSTOK",
        "15057": "BIAŁYSTOK",
        "15062": "BIAŁYSTOK",
        "15063": "BIAŁYSTOK",
        "15064": "BIAŁYSTOK",
        "15065": "BIAŁYSTOK",
        "15066": "BIAŁYSTOK",
        "15067": "BIAŁYSTOK",
        "15068": "BIAŁYSTOK",
        "15070": "BIAŁYSTOK",
        "15071": "BIAŁYSTOK",
        "15073": "BIAŁYSTOK",
        "15074": "BIAŁYSTOK",
        "15077": "BIAŁYSTOK",
        "15078": "BIAŁYSTOK",
        "15080": "BIAŁYSTOK",
        "15081": "BIAŁYSTOK",
        "15082": "BIAŁYSTOK",
        "15083": "BIAŁYSTOK",
        "15084": "BIAŁYSTOK",
        "15085": "BIAŁYSTOK",
        "15086": "BIAŁYSTOK",
        "15087": "BIAŁYSTOK",
        "15088": "BIAŁYSTOK",
        "15089": "BIAŁYSTOK",
        "15090": "BIAŁYSTOK",
        "15091": "BIAŁYSTOK",
        "15092": "BIAŁYSTOK",
        "15093": "BIAŁYSTOK",
        "15094": "BIAŁYSTOK",
        "15096": "BIAŁYSTOK",
        "15097": "BIAŁYSTOK",
        "15099": "BIAŁYSTOK",
        "15100": "BIAŁYSTOK",
        "15101": "BIAŁYSTOK",
        "15102": "BIAŁYSTOK",
        "15103": "BIAŁYSTOK",
        "15104": "BIAŁYSTOK",
        "15106": "BIAŁYSTOK",
        "15107": "BIAŁYSTOK",
        "15108": "BIAŁYSTOK",
        "15109": "BIAŁYSTOK",
        "15110": "BIAŁYSTOK",
        "15111": "BIAŁYSTOK",
        "15113": "BIAŁYSTOK",
        "15114": "BIAŁYSTOK",
        "15115": "BIAŁYSTOK",
        "15117": "BIAŁYSTOK",
        "15118": "BIAŁYSTOK",
        "15119": "BIAŁYSTOK",
        "15120": "BIAŁYSTOK",
        "15121": "BIAŁYSTOK",
        "15122": "BIAŁYSTOK",
        "15123": "BIAŁYSTOK",
        "15124": "BIAŁYSTOK",
        "15125": "BIAŁYSTOK",
        "15126": "BIAŁYSTOK",
        "15127": "BIAŁYSTOK",
        "15128": "BIAŁYSTOK",
        "15129": "BIAŁYSTOK",
        "15130": "BIAŁYSTOK",
        "15131": "BIAŁYSTOK",
        "15132": "BIAŁYSTOK",
        "15133": "BIAŁYSTOK",
        "15134": "BIAŁYSTOK",
        "15135": "BIAŁYSTOK",
        "15136": "BIAŁYSTOK",
        "15137": "BIAŁYSTOK",
        "15138": "BIAŁYSTOK",
        "15139": "BIAŁYSTOK",
        "15140": "BIAŁYSTOK",
        "15141": "BIAŁYSTOK",
        "15142": "BIAŁYSTOK",
        "15143": "BIAŁYSTOK",
        "15144": "BIAŁYSTOK",
        "15145": "BIAŁYSTOK",
        "15147": "BIAŁYSTOK",
        "15148": "BIAŁYSTOK",
        "15149": "BIAŁYSTOK",
        "15150": "BIAŁYSTOK",
        "15151": "BIAŁYSTOK",
        "15152": "BIAŁYSTOK",
        "15153": "BIAŁYSTOK",
        "15154": "BIAŁYSTOK",
        "15155": "BIAŁYSTOK",
        "15156": "BIAŁYSTOK",
        "15157": "BIAŁYSTOK",
        "15158": "BIAŁYSTOK",
        "15159": "BIAŁYSTOK",
        "15160": "BIAŁYSTOK",
        "15161": "BIAŁYSTOK",
        "15162": "BIAŁYSTOK",
        "15163": "BIAŁYSTOK",
        "15164": "BIAŁYSTOK",
        "15165": "BIAŁYSTOK",
        "15166": "BIAŁYSTOK",
        "15167": "BIAŁYSTOK",
        "15168": "BIAŁYSTOK",
        "15169": "BIAŁYSTOK",
        "15170": "BIAŁYSTOK",
        "15171": "BIAŁYSTOK",
        "15173": "BIAŁYSTOK",
        "15174": "BIAŁYSTOK",
        "15175": "BIAŁYSTOK",
        "15176": "BIAŁYSTOK",
        "15177": "BIAŁYSTOK",
        "15178": "BIAŁYSTOK",
        "15180": "BIAŁYSTOK",
        "15181": "BIAŁYSTOK",
        "15182": "BIAŁYSTOK",
        "15183": "BIAŁYSTOK",
        "15184": "BIAŁYSTOK",
        "15185": "BIAŁYSTOK",
        "15186": "BIAŁYSTOK",
        "15187": "BIAŁYSTOK",
        "15188": "BIAŁYSTOK",
        "15189": "BIAŁYSTOK",
        "15190": "BIAŁYSTOK",
        "15191": "BIAŁYSTOK",
        "15192": "BIAŁYSTOK",
        "15193": "BIAŁYSTOK",
        "15194": "BIAŁYSTOK",
        "15195": "BIAŁYSTOK",
        "15196": "BIAŁYSTOK",
        "15197": "BIAŁYSTOK",
        "15198": "BIAŁYSTOK",
        "15199": "BIAŁYSTOK",
        "15201": "BIAŁYSTOK",
        "15202": "BIAŁYSTOK",
        "15203": "BIAŁYSTOK",
        "15204": "BIAŁYSTOK",
        "15205": "BIAŁYSTOK",
        "15206": "BIAŁYSTOK",
        "15207": "BIAŁYSTOK",
        "15208": "BIAŁYSTOK",
        "15209": "BIAŁYSTOK",
        "15210": "BIAŁYSTOK",
        "15211": "BIAŁYSTOK",
        "15212": "BIAŁYSTOK",
        "15213": "BIAŁYSTOK",
        "15214": "BIAŁYSTOK",
        "15215": "BIAŁYSTOK",
        "15218": "BIAŁYSTOK",
        "15219": "BIAŁYSTOK",
        "15220": "BIAŁYSTOK",
        "15222": "BIAŁYSTOK",
        "15223": "BIAŁYSTOK",
        "15224": "BIAŁYSTOK",
        "15225": "BIAŁYSTOK",
        "15227": "BIAŁYSTOK",
        "15229": "BIAŁYSTOK",
        "15232": "BIAŁYSTOK",
        "15233": "BIAŁYSTOK",
        "15234": "BIAŁYSTOK",
        "15235": "BIAŁYSTOK",
        "15236": "BIAŁYSTOK",
        "15237": "BIAŁYSTOK",
        "15238": "BIAŁYSTOK",
        "15239": "BIAŁYSTOK",
        "15240": "BIAŁYSTOK",
        "15241": "BIAŁYSTOK",
        "15242": "BIAŁYSTOK",
        "15244": "BIAŁYSTOK",
        "15245": "BIAŁYSTOK",
        "15246": "BIAŁYSTOK",
        "15247": "BIAŁYSTOK",
        "15249": "BIAŁYSTOK",
        "15250": "BIAŁYSTOK",
        "15251": "BIAŁYSTOK",
        "15252": "BIAŁYSTOK",
        "15253": "BIAŁYSTOK",
        "15254": "BIAŁYSTOK",
        "15255": "BIAŁYSTOK",
        "15256": "BIAŁYSTOK",
        "15257": "BIAŁYSTOK",
        "15258": "BIAŁYSTOK",
        "15259": "BIAŁYSTOK",
        "15260": "BIAŁYSTOK",
        "15261": "BIAŁYSTOK",
        "15262": "BIAŁYSTOK",
        "15263": "BIAŁYSTOK",
        "15264": "BIAŁYSTOK",
        "15265": "BIAŁYSTOK",
        "15266": "BIAŁYSTOK",
        "15267": "BIAŁYSTOK",
        "15268": "BIAŁYSTOK",
        "15269": "BIAŁYSTOK",
        "15270": "BIAŁYSTOK",
        "15271": "BIAŁYSTOK",
        "15272": "BIAŁYSTOK",
        "15274": "BIAŁYSTOK",
        "15275": "BIAŁYSTOK",
        "15276": "BIAŁYSTOK",
        "15277": "BIAŁYSTOK",
        "15278": "BIAŁYSTOK",
        "15279": "BIAŁYSTOK",
        "15280": "BIAŁYSTOK",
        "15281": "BIAŁYSTOK",
        "15282": "BIAŁYSTOK",
        "15283": "BIAŁYSTOK",
        "15284": "BIAŁYSTOK",
        "15285": "BIAŁYSTOK",
        "15287": "BIAŁYSTOK",
        "15288": "BIAŁYSTOK",
        "15289": "BIAŁYSTOK",
        "15290": "BIAŁYSTOK",
        "15291": "BIAŁYSTOK",
        "15292": "BIAŁYSTOK",
        "15293": "BIAŁYSTOK",
        "15294": "BIAŁYSTOK",
        "15295": "BIAŁYSTOK",
        "15297": "BIAŁYSTOK",
        "15298": "BIAŁYSTOK",
        "15301": "BIAŁYSTOK",
        "15302": "BIAŁYSTOK",
        "15304": "BIAŁYSTOK",
        "15305": "BIAŁYSTOK",
        "15306": "BIAŁYSTOK",
        "15307": "BIAŁYSTOK",
        "15308": "BIAŁYSTOK",
        "15309": "BIAŁYSTOK",
        "15311": "BIAŁYSTOK",
        "15312": "BIAŁYSTOK",
        "15317": "BIAŁYSTOK",
        "15320": "BIAŁYSTOK",
        "15321": "BIAŁYSTOK",
        "15322": "BIAŁYSTOK",
        "15323": "BIAŁYSTOK",
        "15324": "BIAŁYSTOK",
        "15325": "BIAŁYSTOK",
        "15326": "BIAŁYSTOK",
        "15327": "BIAŁYSTOK",
        "15328": "BIAŁYSTOK",
        "15330": "BIAŁYSTOK",
        "15333": "BIAŁYSTOK",
        "15335": "BIAŁYSTOK",
        "15336": "BIAŁYSTOK",
        "15337": "BIAŁYSTOK",
        "15338": "BIAŁYSTOK",
        "15339": "BIAŁYSTOK",
        "15340": "BIAŁYSTOK",
        "15341": "BIAŁYSTOK",
        "15342": "BIAŁYSTOK",
        "15343": "BIAŁYSTOK",
        "15344": "BIAŁYSTOK",
        "15345": "BIAŁYSTOK",
        "15346": "BIAŁYSTOK",
        "15347": "BIAŁYSTOK",
        "15348": "BIAŁYSTOK",
        "15349": "BIAŁYSTOK",
        "15351": "BIAŁYSTOK",
        "15352": "BIAŁYSTOK",
        "15353": "BIAŁYSTOK",
        "15354": "BIAŁYSTOK",
        "15355": "BIAŁYSTOK",
        "15356": "BIAŁYSTOK",
        "15357": "BIAŁYSTOK",
        "15361": "BIAŁYSTOK",
        "15362": "BIAŁYSTOK",
        "15363": "BIAŁYSTOK",
        "15364": "BIAŁYSTOK",
        "15365": "BIAŁYSTOK",
        "15367": "BIAŁYSTOK",
        "15369": "BIAŁYSTOK",
        "15370": "BIAŁYSTOK",
        "15371": "BIAŁYSTOK",
        "15372": "BIAŁYSTOK",
        "15373": "BIAŁYSTOK",
        "15374": "BIAŁYSTOK",
        "15376": "BIAŁYSTOK",
        "15377": "BIAŁYSTOK",
        "15378": "BIAŁYSTOK",
        "15379": "BIAŁYSTOK",
        "15380": "BIAŁYSTOK",
        "15381": "BIAŁYSTOK",
        "15386": "BIAŁYSTOK",
        "15387": "BIAŁYSTOK",
        "15388": "BIAŁYSTOK",
        "15390": "BIAŁYSTOK",
        "15391": "BIAŁYSTOK",
        "15393": "BIAŁYSTOK",
        "15394": "BIAŁYSTOK",
        "15395": "BIAŁYSTOK",
        "15396": "BIAŁYSTOK",
        "15397": "BIAŁYSTOK",
        "15398": "BIAŁYSTOK",
        "15399": "BIAŁYSTOK",
        "15401": "BIAŁYSTOK",
        "15402": "BIAŁYSTOK",
        "15403": "BIAŁYSTOK",
        "15404": "BIAŁYSTOK",
        "15405": "BIAŁYSTOK",
        "15406": "BIAŁYSTOK",
        "15407": "BIAŁYSTOK",
        "15408": "BIAŁYSTOK",
        "15410": "BIAŁYSTOK",
        "15411": "BIAŁYSTOK",
        "15412": "BIAŁYSTOK",
        "15413": "BIAŁYSTOK",
        "15414": "BIAŁYSTOK",
        "15415": "BIAŁYSTOK",
        "15416": "BIAŁYSTOK",
        "15417": "BIAŁYSTOK",
        "15418": "BIAŁYSTOK",
        "15419": "BIAŁYSTOK",
        "15420": "BIAŁYSTOK",
        "15421": "BIAŁYSTOK",
        "15422": "BIAŁYSTOK",
        "15423": "BIAŁYSTOK",
        "15424": "BIAŁYSTOK",
        "15425": "BIAŁYSTOK",
        "15426": "BIAŁYSTOK",
        "15427": "BIAŁYSTOK",
        "15428": "BIAŁYSTOK",
        "15429": "BIAŁYSTOK",
        "15430": "BIAŁYSTOK",
        "15431": "BIAŁYSTOK",
        "15432": "BIAŁYSTOK",
        "15434": "BIAŁYSTOK",
        "15435": "BIAŁYSTOK",
        "15436": "BIAŁYSTOK",
        "15437": "BIAŁYSTOK",
        "15439": "BIAŁYSTOK",
        "15440": "BIAŁYSTOK",
        "15441": "BIAŁYSTOK",
        "15442": "BIAŁYSTOK",
        "15443": "BIAŁYSTOK",
        "15444": "BIAŁYSTOK",
        "15445": "BIAŁYSTOK",
        "15446": "BIAŁYSTOK",
        "15447": "BIAŁYSTOK",
        "15448": "BIAŁYSTOK",
        "15449": "BIAŁYSTOK",
        "15450": "BIAŁYSTOK",
        "15452": "BIAŁYSTOK",
        "15453": "BIAŁYSTOK",
        "15455": "BIAŁYSTOK",
        "15459": "BIAŁYSTOK",
        "15460": "BIAŁYSTOK",
        "15461": "BIAŁYSTOK",
        "15463": "BIAŁYSTOK",
        "15464": "BIAŁYSTOK",
        "15465": "BIAŁYSTOK",
        "15467": "BIAŁYSTOK",
        "15469": "BIAŁYSTOK",
        "15470": "BIAŁYSTOK",
        "15471": "BIAŁYSTOK",
        "15472": "BIAŁYSTOK",
        "15473": "BIAŁYSTOK",
        "15476": "BIAŁYSTOK",
        "15478": "BIAŁYSTOK",
        "15480": "BIAŁYSTOK",
        "15481": "BIAŁYSTOK",
        "15482": "BIAŁYSTOK",
        "15483": "BIAŁYSTOK",
        "15487": "BIAŁYSTOK",
        "15489": "BIAŁYSTOK",
        "15490": "BIAŁYSTOK",
        "15501": "BIAŁYSTOK",
        "15502": "BIAŁYSTOK",
        "15503": "BIAŁYSTOK",
        "15505": "BIAŁYSTOK",
        "15506": "BIAŁYSTOK",
        "15507": "BIAŁYSTOK",
        "15509": "BIAŁYSTOK",
        "15510": "BIAŁYSTOK",
        "15511": "BIAŁYSTOK",
        "15512": "BIAŁYSTOK",
        "15513": "BIAŁYSTOK",
        "15514": "BIAŁYSTOK",
        "15516": "BIAŁYSTOK",
        "15517": "BIAŁYSTOK",
        "15518": "BIAŁYSTOK",
        "15519": "BIAŁYSTOK",
        "15521": "BIAŁYSTOK",
        "15522": "BIAŁYSTOK",
        "15523": "BIAŁYSTOK",
        "15524": "BIAŁYSTOK",
        "15528": "BIAŁYSTOK",
        "15530": "BIAŁYSTOK",
        "15531": "BIAŁYSTOK",
        "15532": "BIAŁYSTOK",
        "15533": "BIAŁYSTOK",
        "15534": "BIAŁYSTOK",
        "15535": "BIAŁYSTOK",
        "15536": "BIAŁYSTOK",
        "15537": "BIAŁYSTOK",
        "15539": "BIAŁYSTOK",
        "15540": "BIAŁYSTOK",
        "15541": "BIAŁYSTOK",
        "15542": "BIAŁYSTOK",
        "15543": "BIAŁYSTOK",
        "15544": "BIAŁYSTOK",
        "15545": "BIAŁYSTOK",
        "15546": "BIAŁYSTOK",
        "15547": "BIAŁYSTOK",
        "15548": "BIAŁYSTOK",
        "15549": "BIAŁYSTOK",
        "15551": "BIAŁYSTOK",
        "15552": "BIAŁYSTOK",
        "15553": "BIAŁYSTOK",
        "15554": "BIAŁYSTOK",
        "15555": "BIAŁYSTOK",
        "15556": "BIAŁYSTOK",
        "15557": "BIAŁYSTOK",
        "15558": "BIAŁYSTOK",
        "15559": "BIAŁYSTOK",
        "15560": "BIAŁYSTOK",
        "15561": "BIAŁYSTOK",
        "15562": "BIAŁYSTOK",
        "15563": "BIAŁYSTOK",
        "15564": "BIAŁYSTOK",
        "15565": "BIAŁYSTOK",
        "15566": "BIAŁYSTOK",
        "15567": "BIAŁYSTOK",
        "15568": "BIAŁYSTOK",
        "15569": "BIAŁYSTOK",
        "15570": "BIAŁYSTOK",
        "15571": "BIAŁYSTOK",
        "15572": "BIAŁYSTOK",
        "15573": "BIAŁYSTOK",
        "15574": "BIAŁYSTOK",
        "15575": "BIAŁYSTOK",
        "15576": "BIAŁYSTOK",
        "15577": "BIAŁYSTOK",
        "15578": "BIAŁYSTOK",
        "15579": "BIAŁYSTOK",
        "15580": "BIAŁYSTOK",
        "15581": "BIAŁYSTOK",
        "15582": "BIAŁYSTOK",
        "15583": "BIAŁYSTOK",
        "15584": "BIAŁYSTOK",
        "15585": "BIAŁYSTOK",
        "15586": "BIAŁYSTOK",
        "15587": "BIAŁYSTOK",
        "15588": "BIAŁYSTOK",
        "15589": "BIAŁYSTOK",
        "15590": "BIAŁYSTOK",
        "15591": "BIAŁYSTOK",
        "15592": "BIAŁYSTOK",
        "15593": "BIAŁYSTOK",
        "15594": "BIAŁYSTOK",
        "15595": "BIAŁYSTOK",
        "15597": "BIAŁYSTOK",
        "15601": "BIAŁYSTOK",
        "15602": "BIAŁYSTOK",
        "15603": "BIAŁYSTOK",
        "15604": "BIAŁYSTOK",
        "15605": "BIAŁYSTOK",
        "15606": "BIAŁYSTOK",
        "15607": "BIAŁYSTOK",
        "15608": "BIAŁYSTOK",
        "15611": "BIAŁYSTOK",
        "15612": "BIAŁYSTOK",
        "15613": "BIAŁYSTOK",
        "15614": "BIAŁYSTOK",
        "15615": "BIAŁYSTOK",
        "15616": "BIAŁYSTOK",
        "15617": "BIAŁYSTOK",
        "15618": "BIAŁYSTOK",
        "15619": "BIAŁYSTOK",
        "15620": "BIAŁYSTOK",
        "15621": "BIAŁYSTOK",
        "15623": "BIAŁYSTOK",
        "15624": "BIAŁYSTOK",
        "15625": "BIAŁYSTOK",
        "15626": "BIAŁYSTOK",
        "15627": "BIAŁYSTOK",
        "15628": "BIAŁYSTOK",
        "15629": "BIAŁYSTOK",
        "15630": "BIAŁYSTOK",
        "15631": "BIAŁYSTOK",
        "15632": "BIAŁYSTOK",
        "15633": "BIAŁYSTOK",
        "15634": "BIAŁYSTOK",
        "15635": "BIAŁYSTOK",
        "15636": "BIAŁYSTOK",
        "15637": "BIAŁYSTOK",
        "15638": "BIAŁYSTOK",
        "15639": "BIAŁYSTOK",
        "15640": "BIAŁYSTOK",
        "15641": "BIAŁYSTOK",
        "15642": "BIAŁYSTOK",
        "15643": "BIAŁYSTOK",
        "15644": "BIAŁYSTOK",
        "15645": "BIAŁYSTOK",
        "15646": "BIAŁYSTOK",
        "15647": "BIAŁYSTOK",
        "15649": "BIAŁYSTOK",
        "15650": "BIAŁYSTOK",
        "15651": "BIAŁYSTOK",
        "15652": "BIAŁYSTOK",
        "15654": "BIAŁYSTOK",
        "15655": "BIAŁYSTOK",
        "15656": "BIAŁYSTOK",
        "15657": "BIAŁYSTOK",
        "15659": "BIAŁYSTOK",
        "15660": "BIAŁYSTOK",
        "15661": "BIAŁYSTOK",
        "15662": "BIAŁYSTOK",
        "15663": "BIAŁYSTOK",
        "15664": "BIAŁYSTOK",
        "15665": "BIAŁYSTOK",
        "15666": "BIAŁYSTOK",
        "15667": "BIAŁYSTOK",
        "15668": "BIAŁYSTOK",
        "15669": "BIAŁYSTOK",
        "15670": "BIAŁYSTOK",
        "15671": "BIAŁYSTOK",
        "15672": "BIAŁYSTOK",
        "15673": "BIAŁYSTOK",
        "15674": "BIAŁYSTOK",
        "15675": "BIAŁYSTOK",
        "15678": "BIAŁYSTOK",
        "15679": "BIAŁYSTOK",
        "15680": "BIAŁYSTOK",
        "15681": "BIAŁYSTOK",
        "15682": "BIAŁYSTOK",
        "15683": "BIAŁYSTOK",
        "15684": "BIAŁYSTOK",
        "15685": "BIAŁYSTOK",
        "15686": "BIAŁYSTOK",
        "15687": "BIAŁYSTOK",
        "15688": "BIAŁYSTOK",
        "15689": "BIAŁYSTOK",
        "15690": "BIAŁYSTOK",
        "15691": "BIAŁYSTOK",
        "15692": "BIAŁYSTOK",
        "15693": "BIAŁYSTOK",
        "15694": "BIAŁYSTOK",
        "15695": "BIAŁYSTOK",
        "15697": "BIAŁYSTOK",
        "15698": "BIAŁYSTOK",
        "15699": "BIAŁYSTOK",
        "15700": "BIAŁYSTOK",
        "15701": "BIAŁYSTOK",
        "15702": "BIAŁYSTOK",
        "15703": "BIAŁYSTOK",
        "15704": "BIAŁYSTOK",
        "15705": "BIAŁYSTOK",
        "15706": "BIAŁYSTOK",
        "15707": "BIAŁYSTOK",
        "15709": "BIAŁYSTOK",
        "15710": "BIAŁYSTOK",
        "15711": "BIAŁYSTOK",
        "15712": "BIAŁYSTOK",
        "15714": "BIAŁYSTOK",
        "15715": "BIAŁYSTOK",
        "15717": "BIAŁYSTOK",
        "15720": "BIAŁYSTOK",
        "15722": "BIAŁYSTOK",
        "15723": "BIAŁYSTOK",
        "15724": "BIAŁYSTOK",
        "15725": "BIAŁYSTOK",
        "15727": "BIAŁYSTOK",
        "15729": "BIAŁYSTOK",
        "15730": "BIAŁYSTOK",
        "15732": "BIAŁYSTOK",
        "15740": "BIAŁYSTOK",
        "15741": "BIAŁYSTOK",
        "15743": "BIAŁYSTOK",
        "15744": "BIAŁYSTOK",
        "15746": "BIAŁYSTOK",
        "15748": "BIAŁYSTOK",
        "15750": "BIAŁYSTOK",
        "15751": "BIAŁYSTOK",
        "15753": "BIAŁYSTOK",
        "15754": "BIAŁYSTOK",
        "15756": "BIAŁYSTOK",
        "15757": "BIAŁYSTOK",
        "15758": "BIAŁYSTOK",
        "15760": "BIAŁYSTOK",
        "15762": "BIAŁYSTOK",
        "15763": "BIAŁYSTOK",
        "15765": "BIAŁYSTOK",
        "15767": "BIAŁYSTOK",
        "15769": "BIAŁYSTOK",
        "15770": "BIAŁYSTOK",
        "15771": "BIAŁYSTOK",
        "15772": "BIAŁYSTOK",
        "15773": "BIAŁYSTOK",
        "15774": "BIAŁYSTOK",
        "15775": "BIAŁYSTOK",
        "15776": "BIAŁYSTOK",
        "15777": "BIAŁYSTOK",
        "15778": "BIAŁYSTOK",
        "15779": "BIAŁYSTOK",
        "15780": "BIAŁYSTOK",
        "15782": "BIAŁYSTOK",
        "15784": "BIAŁYSTOK",
        "15786": "BIAŁYSTOK",
        "15788": "BIAŁYSTOK",
        "15790": "BIAŁYSTOK",
        "15791": "BIAŁYSTOK",
        "15792": "BIAŁYSTOK",
        "15793": "BIAŁYSTOK",
        "15794": "BIAŁYSTOK",
        "15795": "BIAŁYSTOK",
        "15796": "BIAŁYSTOK",
        "15797": "BIAŁYSTOK",
        "15798": "BIAŁYSTOK",
        "15801": "BIAŁYSTOK",
        "15802": "BIAŁYSTOK",
        "15803": "BIAŁYSTOK",
        "15805": "BIAŁYSTOK",
        "15806": "BIAŁYSTOK",
        "15807": "BIAŁYSTOK",
        "15808": "BIAŁYSTOK",
        "15809": "BIAŁYSTOK",
        "15810": "BIAŁYSTOK",
        "15811": "BIAŁYSTOK",
        "15812": "BIAŁYSTOK",
        "15813": "BIAŁYSTOK",
        "15814": "BIAŁYSTOK",
        "15815": "BIAŁYSTOK",
        "15817": "BIAŁYSTOK",
        "15818": "BIAŁYSTOK",
        "15819": "BIAŁYSTOK",
        "15820": "BIAŁYSTOK",
        "15821": "BIAŁYSTOK",
        "15822": "BIAŁYSTOK",
        "15825": "BIAŁYSTOK",
        "15827": "BIAŁYSTOK",
        "15829": "BIAŁYSTOK",
        "15831": "BIAŁYSTOK",
        "15833": "BIAŁYSTOK",
        "15836": "BIAŁYSTOK",
        "15837": "BIAŁYSTOK",
        "15839": "BIAŁYSTOK",
        "15840": "BIAŁYSTOK",
        "15843": "BIAŁYSTOK",
        "15845": "BIAŁYSTOK",
        "15850": "BIAŁYSTOK",
        "15852": "BIAŁYSTOK",
        "15854": "BIAŁYSTOK",
        "15856": "BIAŁYSTOK",
        "15858": "BIAŁYSTOK",
        "15859": "BIAŁYSTOK",
        "15860": "BIAŁYSTOK",
        "15861": "BIAŁYSTOK",
        "15862": "BIAŁYSTOK",
        "15863": "BIAŁYSTOK",
        "15864": "BIAŁYSTOK",
        "15865": "BIAŁYSTOK",
        "15866": "BIAŁYSTOK",
        "15867": "BIAŁYSTOK",
        "15868": "BIAŁYSTOK",
        "15869": "BIAŁYSTOK",
        "15870": "BIAŁYSTOK",
        "15871": "BIAŁYSTOK",
        "15872": "BIAŁYSTOK",
        "15873": "BIAŁYSTOK",
        "15874": "BIAŁYSTOK",
        "15875": "BIAŁYSTOK",
        "15879": "BIAŁYSTOK",
        "15880": "BIAŁYSTOK",
        "15881": "BIAŁYSTOK",
        "15883": "BIAŁYSTOK",
        "15887": "BIAŁYSTOK",
        "15888": "BIAŁYSTOK",
        "15889": "BIAŁYSTOK",
        "15891": "BIAŁYSTOK",
        "15893": "BIAŁYSTOK",
        "15895": "BIAŁYSTOK",
        "15896": "BIAŁYSTOK",
        "15900": "BIAŁYSTOK",
        "15917": "BIAŁYSTOK",
        "15950": "BIAŁYSTOK",
        "15951": "BIAŁYSTOK",
        "15959": "BIAŁYSTOK",
        "16001": "BIAŁYSTOK",
        "16002": "BIAŁYSTOK",
        "16010": "BIAŁYSTOK",
        "16020": "BIAŁYSTOK",
        "16030": "BIAŁYSTOK",
        "16040": "BIAŁYSTOK",
        "16050": "BIAŁYSTOK",
        "16060": "BIAŁYSTOK",
        "16061": "BIAŁYSTOK",
        "16070": "BIAŁYSTOK",
        "16075": "BIAŁYSTOK",
        "16080": "BIAŁYSTOK",
        "16100": "SOKÓŁKA",
        "16101": "SOKÓŁKA",
        "16102": "SOKÓŁKA",
        "16113": "SOKÓŁKA",
        "16120": "SOKÓŁKA",
        "16123": "SOKÓŁKA",
        "16124": "SOKÓŁKA",
        "16130": "SOKÓŁKA",
        "16140": "SOKÓŁKA",
        "16150": "SOKÓŁKA",
        "16200": "DĄBROWA BIAŁOSTOCKA",
        "16205": "SOKÓŁKA",
        "16300": "AUGUSTÓW",
        "16301": "AUGUSTÓW",
        "16302": "AUGUSTÓW",
        "16303": "AUGUSTÓW",
        "16304": "AUGUSTÓW",
        "16310": "AUGUSTÓW",
        "16315": "AUGUSTÓW",
        "16316": "AUGUSTÓW",
        "16320": "AUGUSTÓW",
        "16326": "AUGUSTÓW",
        "16400": "SUWAŁKI",
        "16401": "SUWAŁKI",
        "16402": "SUWAŁKI",
        "16403": "SUWAŁKI",
        "16404": "SUWAŁKI",
        "16405": "SUWAŁKI",
        "16406": "SUWAŁKI",
        "16407": "SUWAŁKI",
        "16411": "SUWAŁKI",
        "16412": "SEJNY",
        "16413": "SUWAŁKI",
        "16420": "SUWAŁKI",
        "16421": "SUWAŁKI",
        "16423": "SUWAŁKI",
        "16424": "SUWAŁKI",
        "16427": "SUWAŁKI",
        "16430": "SUWAŁKI",
        "16431": "SUWAŁKI",
        "16432": "SUWAŁKI",
        "16433": "SUWAŁKI",
        "16500": "SEJNY",
        "16503": "SEJNY",
        "16506": "SEJNY",
        "16515": "SEJNY",
        "17100": "BIELSK PODLASKI",
        "17101": "BIELSK PODLASKI",
        "17102": "BIELSK PODLASKI",
        "17106": "BIELSK PODLASKI",
        "17111": "BIELSK PODLASKI",
        "17120": "BIELSK PODLASKI",
        "17123": "BIELSK PODLASKI",
        "17132": "BIELSK PODLASKI",
        "17200": "HAJNÓWKA",
        "17201": "HAJNÓWKA",
        "17204": "HAJNÓWKA",
        "17207": "HAJNÓWKA",
        "17210": "HAJNÓWKA",
        "17220": "HAJNÓWKA",
        "17221": "HAJNÓWKA",
        "17222": "HAJNÓWKA",
        "17230": "HAJNÓWKA",
        "17240": "HAJNÓWKA",
        "17250": "HAJNÓWKA",
        "17300": "SIEMIATYCZE",
        "17301": "SIEMIATYCZE",
        "17306": "SIEMIATYCZE",
        "17307": "SIEMIATYCZE",
        "17308": "SIEMIATYCZE",
        "17309": "SIEMIATYCZE",
        "17312": "SIEMIATYCZE",
        "17315": "SIEMIATYCZE",
        "17322": "SIEMIATYCZE",
        "17330": "SIEMIATYCZE",
        "17331": "SIEMIATYCZE",
        "17332": "SIEMIATYCZE",
        "17333": "SIEMIATYCZE",
        "18100": "BIAŁYSTOK",
        "18101": "BIAŁYSTOK",
        "18105": "BIAŁYSTOK",
        "18106": "BIAŁYSTOK",
        "18112": "BIAŁYSTOK",
        "18200": "WYSOKIE MAZOWIECKIE",
        "18204": "WYSOKIE MAZOWIECKIE",
        "18208": "WYSOKIE MAZOWIECKIE",
        "18210": "WYSOKIE MAZOWIECKIE",
        "18212": "WYSOKIE MAZOWIECKIE",
        "18214": "WYSOKIE MAZOWIECKIE",
        "18218": "WYSOKIE MAZOWIECKIE",
        "18220": "WYSOKIE MAZOWIECKIE",
        "18230": "WYSOKIE MAZOWIECKIE",
        "18300": "ZAMBRÓW",
        "18301": "ZAMBRÓW",
        "18305": "ZAMBRÓW",
        "18312": "ZAMBRÓW",
        "18315": "ZAMBRÓW",
        "18400": "ŁOMŻA",
        "18401": "ŁOMŻA",
        "18402": "ŁOMŻA",
        "18403": "ŁOMŻA",
        "18404": "ŁOMŻA",
        "18410": "ŁOMŻA",
        "18411": "ŁOMŻA",
        "18413": "ŁOMŻA",
        "18414": "ŁOMŻA",
        "18416": "ŁOMŻA",
        "18420": "ŁOMŻA",
        "18421": "ŁOMŻA",
        "18423": "ŁOMŻA",
        "18430": "ŁOMŻA",
        "18500": "KOLNO",
        "18505": "KOLNO",
        "18507": "KOLNO",
        "18516": "KOLNO",
        "18520": "KOLNO",
        "18525": "KOLNO",
        "19100": "MOŃKI",
        "19101": "MOŃKI",
        "19104": "MOŃKI",
        "19110": "MOŃKI",
        "19111": "MOŃKI",
        "19113": "ŁOMŻA",
        "19120": "MOŃKI",
        "19122": "MOŃKI",
        "19124": "MOŃKI",
        "19200": "GRAJEWO",
        "19203": "GRAJEWO",
        "19206": "GRAJEWO",
        "19212": "GRAJEWO",
        "19213": "GRAJEWO",
        "19222": "GRAJEWO",
        "19230": "GRAJEWO",
        "19300": "EŁK",
        "19301": "EŁK",
        "19302": "EŁK",
        "19303": "EŁK",
        "19304": "EŁK",
        "19305": "EŁK",
        "19306": "EŁK",
        "19311": "EŁK",
        "19312": "EŁK",
        "19313": "EŁK",
        "19314": "EŁK",
        "19321": "EŁK",
        "19324": "EŁK",
        "19325": "EŁK",
        "19326": "EŁK",
        "19330": "EŁK",
        "19335": "EŁK",
        "19400": "OLECKO",
        "19401": "OLECKO",
        "19402": "OLECKO",
        "19404": "OLECKO",
        "19411": "OLECKO",
        "19420": "OLECKO",
        "19500": "GOŁDAP",
        "19501": "GOŁDAP",
        "19504": "GOŁDAP",
        "19505": "GOŁDAP",
        "19506": "GOŁDAP",
        "19507": "GOŁDAP",
        "19520": "GOŁDAP",
        "20001": "LUBLIN",
        "20002": "LUBLIN",
        "20003": "LUBLIN",
        "20004": "LUBLIN",
        "20005": "LUBLIN",
        "20006": "LUBLIN",
        "20007": "LUBLIN",
        "20008": "LUBLIN",
        "20009": "LUBLIN",
        "20010": "LUBLIN",
        "20011": "LUBLIN",
        "20012": "LUBLIN",
        "20013": "LUBLIN",
        "20014": "LUBLIN",
        "20015": "LUBLIN",
        "20016": "LUBLIN",
        "20017": "LUBLIN",
        "20018": "LUBLIN",
        "20019": "LUBLIN",
        "20020": "LUBLIN",
        "20021": "LUBLIN",
        "20022": "LUBLIN",
        "20023": "LUBLIN",
        "20024": "LUBLIN",
        "20025": "LUBLIN",
        "20026": "LUBLIN",
        "20027": "LUBLIN",
        "20028": "LUBLIN",
        "20029": "LUBLIN",
        "20030": "LUBLIN",
        "20031": "LUBLIN",
        "20032": "LUBLIN",
        "20033": "LUBLIN",
        "20034": "LUBLIN",
        "20035": "LUBLIN",
        "20036": "LUBLIN",
        "20037": "LUBLIN",
        "20038": "LUBLIN",
        "20039": "LUBLIN",
        "20040": "LUBLIN",
        "20041": "LUBLIN",
        "20042": "LUBLIN",
        "20043": "LUBLIN",
        "20044": "LUBLIN",
        "20045": "LUBLIN",
        "20046": "LUBLIN",
        "20047": "LUBLIN",
        "20048": "LUBLIN",
        "20049": "LUBLIN",
        "20050": "LUBLIN",
        "20051": "LUBLIN",
        "20052": "LUBLIN",
        "20053": "LUBLIN",
        "20054": "LUBLIN",
        "20055": "LUBLIN",
        "20056": "LUBLIN",
        "20057": "LUBLIN",
        "20058": "LUBLIN",
        "20059": "LUBLIN",
        "20060": "LUBLIN",
        "20061": "LUBLIN",
        "20064": "LUBLIN",
        "20066": "LUBLIN",
        "20067": "LUBLIN",
        "20068": "LUBLIN",
        "20069": "LUBLIN",
        "20070": "LUBLIN",
        "20071": "LUBLIN",
        "20072": "LUBLIN",
        "20073": "LUBLIN",
        "20074": "LUBLIN",
        "20075": "LUBLIN",
        "20076": "LUBLIN",
        "20077": "LUBLIN",
        "20078": "LUBLIN",
        "20079": "LUBLIN",
        "20080": "LUBLIN",
        "20081": "LUBLIN",
        "20082": "LUBLIN",
        "20083": "LUBLIN",
        "20084": "LUBLIN",
        "20085": "LUBLIN",
        "20086": "LUBLIN",
        "20087": "LUBLIN",
        "20088": "LUBLIN",
        "20089": "LUBLIN",
        "20090": "LUBLIN",
        "20091": "LUBLIN",
        "20092": "LUBLIN",
        "20093": "LUBLIN",
        "20094": "LUBLIN",
        "20095": "LUBLIN",
        "20097": "LUBLIN",
        "20100": "LUBLIN",
        "20101": "LUBLIN",
        "20102": "LUBLIN",
        "20103": "LUBLIN",
        "20104": "LUBLIN",
        "20105": "LUBLIN",
        "20106": "LUBLIN",
        "20107": "LUBLIN",
        "20108": "LUBLIN",
        "20109": "LUBLIN",
        "20110": "LUBLIN",
        "20111": "LUBLIN",
        "20112": "LUBLIN",
        "20113": "LUBLIN",
        "20114": "LUBLIN",
        "20115": "LUBLIN",
        "20116": "LUBLIN",
        "20117": "LUBLIN",
        "20118": "LUBLIN",
        "20119": "LUBLIN",
        "20120": "LUBLIN",
        "20121": "LUBLIN",
        "20122": "LUBLIN",
        "20123": "LUBLIN",
        "20124": "LUBLIN",
        "20125": "LUBLIN",
        "20126": "LUBLIN",
        "20127": "LUBLIN",
        "20128": "LUBLIN",
        "20129": "LUBLIN",
        "20130": "LUBLIN",
        "20132": "LUBLIN",
        "20133": "LUBLIN",
        "20134": "LUBLIN",
        "20135": "LUBLIN",
        "20136": "LUBLIN",
        "20137": "LUBLIN",
        "20138": "LUBLIN",
        "20139": "LUBLIN",
        "20140": "LUBLIN",
        "20141": "LUBLIN",
        "20142": "LUBLIN",
        "20143": "LUBLIN",
        "20144": "LUBLIN",
        "20145": "LUBLIN",
        "20146": "LUBLIN",
        "20147": "LUBLIN",
        "20148": "LUBLIN",
        "20149": "LUBLIN",
        "20150": "LUBLIN",
        "20151": "LUBLIN",
        "20152": "LUBLIN",
        "20153": "LUBLIN",
        "20154": "LUBLIN",
        "20155": "LUBLIN",
        "20160": "LUBLIN",
        "20201": "LUBLIN",
        "20202": "LUBLIN",
        "20203": "LUBLIN",
        "20204": "LUBLIN",
        "20205": "LUBLIN",
        "20207": "LUBLIN",
        "20208": "LUBLIN",
        "20209": "LUBLIN",
        "20210": "LUBLIN",
        "20211": "LUBLIN",
        "20212": "LUBLIN",
        "20213": "LUBLIN",
        "20214": "LUBLIN",
        "20215": "LUBLIN",
        "20216": "LUBLIN",
        "20217": "LUBLIN",
        "20218": "LUBLIN",
        "20219": "LUBLIN",
        "20220": "LUBLIN",
        "20221": "LUBLIN",
        "20222": "LUBLIN",
        "20223": "LUBLIN",
        "20224": "LUBLIN",
        "20225": "LUBLIN",
        "20226": "LUBLIN",
        "20227": "LUBLIN",
        "20228": "LUBLIN",
        "20229": "LUBLIN",
        "20230": "LUBLIN",
        "20231": "LUBLIN",
        "20232": "LUBLIN",
        "20233": "LUBLIN",
        "20234": "LUBLIN",
        "20235": "LUBLIN",
        "20240": "LUBLIN",
        "20241": "LUBLIN",
        "20243": "LUBLIN",
        "20244": "LUBLIN",
        "20245": "LUBLIN",
        "20246": "LUBLIN",
        "20247": "LUBLIN",
        "20248": "LUBLIN",
        "20249": "LUBLIN",
        "20250": "LUBLIN",
        "20251": "LUBLIN",
        "20252": "LUBLIN",
        "20253": "LUBLIN",
        "20254": "LUBLIN",
        "20255": "LUBLIN",
        "20256": "LUBLIN",
        "20257": "LUBLIN",
        "20258": "LUBLIN",
        "20259": "LUBLIN",
        "20260": "LUBLIN",
        "20262": "LUBLIN",
        "20270": "LUBLIN",
        "20276": "LUBLIN",
        "20277": "LUBLIN",
        "20278": "LUBLIN",
        "20279": "LUBLIN",
        "20280": "LUBLIN",
        "20281": "LUBLIN",
        "20282": "LUBLIN",
        "20283": "LUBLIN",
        "20290": "LUBLIN",
        "20291": "LUBLIN",
        "20301": "LUBLIN",
        "20302": "LUBLIN",
        "20303": "LUBLIN",
        "20304": "LUBLIN",
        "20305": "LUBLIN",
        "20306": "LUBLIN",
        "20307": "LUBLIN",
        "20309": "LUBLIN",
        "20310": "LUBLIN",
        "20311": "LUBLIN",
        "20313": "LUBLIN",
        "20314": "LUBLIN",
        "20315": "LUBLIN",
        "20316": "LUBLIN",
        "20317": "LUBLIN",
        "20318": "LUBLIN",
        "20319": "LUBLIN",
        "20320": "LUBLIN",
        "20321": "LUBLIN",
        "20322": "LUBLIN",
        "20323": "LUBLIN",
        "20324": "LUBLIN",
        "20325": "LUBLIN",
        "20326": "LUBLIN",
        "20327": "LUBLIN",
        "20328": "LUBLIN",
        "20329": "LUBLIN",
        "20330": "LUBLIN",
        "20331": "LUBLIN",
        "20333": "LUBLIN",
        "20334": "LUBLIN",
        "20335": "LUBLIN",
        "20336": "LUBLIN",
        "20337": "LUBLIN",
        "20338": "LUBLIN",
        "20340": "LUBLIN",
        "20341": "LUBLIN",
        "20342": "LUBLIN",
        "20343": "LUBLIN",
        "20344": "LUBLIN",
        "20346": "LUBLIN",
        "20347": "LUBLIN",
        "20348": "LUBLIN",
        "20349": "LUBLIN",
        "20350": "LUBLIN",
        "20351": "LUBLIN",
        "20352": "LUBLIN",
        "20353": "LUBLIN",
        "20354": "LUBLIN",
        "20355": "LUBLIN",
        "20356": "LUBLIN",
        "20357": "LUBLIN",
        "20358": "LUBLIN",
        "20359": "LUBLIN",
        "20360": "LUBLIN",
        "20361": "LUBLIN",
        "20362": "LUBLIN",
        "20363": "LUBLIN",
        "20364": "LUBLIN",
        "20365": "LUBLIN",
        "20366": "LUBLIN",
        "20367": "LUBLIN",
        "20368": "LUBLIN",
        "20369": "LUBLIN",
        "20370": "LUBLIN",
        "20371": "LUBLIN",
        "20372": "LUBLIN",
        "20373": "LUBLIN",
        "20374": "LUBLIN",
        "20375": "LUBLIN",
        "20376": "LUBLIN",
        "20377": "LUBLIN",
        "20378": "LUBLIN",
        "20379": "LUBLIN",
        "20380": "LUBLIN",
        "20381": "LUBLIN",
        "20382": "LUBLIN",
        "20383": "LUBLIN",
        "20384": "LUBLIN",
        "20385": "LUBLIN",
        "20386": "LUBLIN",
        "20387": "LUBLIN",
        "20388": "LUBLIN",
        "20390": "LUBLIN",
        "20391": "LUBLIN",
        "20400": "LUBLIN",
        "20401": "LUBLIN",
        "20402": "LUBLIN",
        "20403": "LUBLIN",
        "20404": "LUBLIN",
        "20405": "LUBLIN",
        "20406": "LUBLIN",
        "20407": "LUBLIN",
        "20408": "LUBLIN",
        "20409": "LUBLIN",
        "20410": "LUBLIN",
        "20411": "LUBLIN",
        "20412": "LUBLIN",
        "20413": "LUBLIN",
        "20414": "LUBLIN",
        "20415": "LUBLIN",
        "20416": "LUBLIN",
        "20417": "LUBLIN",
        "20418": "LUBLIN",
        "20420": "LUBLIN",
        "20421": "LUBLIN",
        "20422": "LUBLIN",
        "20423": "LUBLIN",
        "20424": "LUBLIN",
        "20425": "LUBLIN",
        "20426": "LUBLIN",
        "20427": "LUBLIN",
        "20429": "LUBLIN",
        "20430": "LUBLIN",
        "20431": "LUBLIN",
        "20432": "LUBLIN",
        "20433": "LUBLIN",
        "20434": "LUBLIN",
        "20435": "LUBLIN",
        "20436": "LUBLIN",
        "20437": "LUBLIN",
        "20439": "LUBLIN",
        "20440": "LUBLIN",
        "20441": "LUBLIN",
        "20442": "LUBLIN",
        "20443": "LUBLIN",
        "20444": "LUBLIN",
        "20445": "LUBLIN",
        "20446": "LUBLIN",
        "20447": "LUBLIN",
        "20448": "LUBLIN",
        "20449": "LUBLIN",
        "20450": "LUBLIN",
        "20451": "LUBLIN",
        "20452": "LUBLIN",
        "20453": "LUBLIN",
        "20454": "LUBLIN",
        "20455": "LUBLIN",
        "20456": "LUBLIN",
        "20457": "LUBLIN",
        "20458": "LUBLIN",
        "20459": "LUBLIN",
        "20460": "LUBLIN",
        "20461": "LUBLIN",
        "20462": "LUBLIN",
        "20463": "LUBLIN",
        "20464": "LUBLIN",
        "20465": "LUBLIN",
        "20466": "LUBLIN",
        "20467": "LUBLIN",
        "20468": "LUBLIN",
        "20469": "LUBLIN",
        "20470": "LUBLIN",
        "20471": "LUBLIN",
        "20472": "LUBLIN",
        "20473": "LUBLIN",
        "20474": "LUBLIN",
        "20479": "LUBLIN",
        "20481": "LUBLIN",
        "20482": "LUBLIN",
        "20483": "LUBLIN",
        "20484": "LUBLIN",
        "20485": "LUBLIN",
        "20486": "LUBLIN",
        "20487": "LUBLIN",
        "20488": "LUBLIN",
        "20489": "LUBLIN",
        "20490": "LUBLIN",
        "20491": "LUBLIN",
        "20492": "LUBLIN",
        "20500": "LUBLIN",
        "20501": "LUBLIN",
        "20502": "LUBLIN",
        "20504": "LUBLIN",
        "20506": "LUBLIN",
        "20508": "LUBLIN",
        "20509": "LUBLIN",
        "20510": "LUBLIN",
        "20515": "LUBLIN",
        "20516": "LUBLIN",
        "20517": "LUBLIN",
        "20518": "LUBLIN",
        "20520": "LUBLIN",
        "20521": "LUBLIN",
        "20522": "LUBLIN",
        "20523": "LUBLIN",
        "20524": "LUBLIN",
        "20525": "LUBLIN",
        "20530": "LUBLIN",
        "20531": "LUBLIN",
        "20532": "LUBLIN",
        "20533": "LUBLIN",
        "20534": "LUBLIN",
        "20535": "LUBLIN",
        "20536": "LUBLIN",
        "20537": "LUBLIN",
        "20538": "LUBLIN",
        "20539": "LUBLIN",
        "20540": "LUBLIN",
        "20541": "LUBLIN",
        "20542": "LUBLIN",
        "20543": "LUBLIN",
        "20550": "LUBLIN",
        "20551": "LUBLIN",
        "20552": "LUBLIN",
        "20553": "LUBLIN",
        "20554": "LUBLIN",
        "20555": "LUBLIN",
        "20560": "LUBLIN",
        "20561": "LUBLIN",
        "20562": "LUBLIN",
        "20563": "LUBLIN",
        "20564": "LUBLIN",
        "20570": "LUBLIN",
        "20571": "LUBLIN",
        "20572": "LUBLIN",
        "20573": "LUBLIN",
        "20574": "LUBLIN",
        "20575": "LUBLIN",
        "20576": "LUBLIN",
        "20577": "LUBLIN",
        "20578": "LUBLIN",
        "20579": "LUBLIN",
        "20580": "LUBLIN",
        "20581": "LUBLIN",
        "20582": "LUBLIN",
        "20583": "LUBLIN",
        "20590": "LUBLIN",
        "20601": "LUBLIN",
        "20602": "LUBLIN",
        "20603": "LUBLIN",
        "20604": "LUBLIN",
        "20605": "LUBLIN",
        "20606": "LUBLIN",
        "20607": "LUBLIN",
        "20608": "LUBLIN",
        "20609": "LUBLIN",
        "20610": "LUBLIN",
        "20611": "LUBLIN",
        "20612": "LUBLIN",
        "20613": "LUBLIN",
        "20614": "LUBLIN",
        "20615": "LUBLIN",
        "20616": "LUBLIN",
        "20617": "LUBLIN",
        "20618": "LUBLIN",
        "20619": "LUBLIN",
        "20620": "LUBLIN",
        "20621": "LUBLIN",
        "20624": "LUBLIN",
        "20625": "LUBLIN",
        "20626": "LUBLIN",
        "20627": "LUBLIN",
        "20628": "LUBLIN",
        "20629": "LUBLIN",
        "20630": "LUBLIN",
        "20631": "LUBLIN",
        "20632": "LUBLIN",
        "20633": "LUBLIN",
        "20634": "LUBLIN",
        "20635": "LUBLIN",
        "20636": "LUBLIN",
        "20637": "LUBLIN",
        "20639": "LUBLIN",
        "20640": "LUBLIN",
        "20701": "LUBLIN",
        "20703": "LUBLIN",
        "20704": "LUBLIN",
        "20705": "LUBLIN",
        "20706": "LUBLIN",
        "20707": "LUBLIN",
        "20708": "LUBLIN",
        "20709": "LUBLIN",
        "20710": "LUBLIN",
        "20711": "LUBLIN",
        "20712": "LUBLIN",
        "20713": "LUBLIN",
        "20714": "LUBLIN",
        "20715": "LUBLIN",
        "20716": "LUBLIN",
        "20717": "LUBLIN",
        "20718": "LUBLIN",
        "20719": "LUBLIN",
        "20721": "LUBLIN",
        "20722": "LUBLIN",
        "20723": "LUBLIN",
        "20724": "LUBLIN",
        "20725": "LUBLIN",
        "20726": "LUBLIN",
        "20727": "LUBLIN",
        "20728": "LUBLIN",
        "20729": "LUBLIN",
        "20730": "LUBLIN",
        "20731": "LUBLIN",
        "20732": "LUBLIN",
        "20733": "LUBLIN",
        "20734": "LUBLIN",
        "20735": "LUBLIN",
        "20736": "LUBLIN",
        "20737": "LUBLIN",
        "20738": "LUBLIN",
        "20739": "LUBLIN",
        "20750": "LUBLIN",
        "20751": "LUBLIN",
        "20752": "LUBLIN",
        "20780": "LUBLIN",
        "20781": "LUBLIN",
        "20782": "LUBLIN",
        "20783": "LUBLIN",
        "20784": "LUBLIN",
        "20785": "LUBLIN",
        "20786": "LUBLIN",
        "20787": "LUBLIN",
        "20788": "LUBLIN",
        "20789": "LUBLIN",
        "20801": "LUBLIN",
        "20802": "LUBLIN",
        "20803": "LUBLIN",
        "20804": "LUBLIN",
        "20805": "LUBLIN",
        "20806": "LUBLIN",
        "20807": "LUBLIN",
        "20808": "LUBLIN",
        "20809": "LUBLIN",
        "20810": "LUBLIN",
        "20811": "LUBLIN",
        "20812": "LUBLIN",
        "20813": "LUBLIN",
        "20814": "LUBLIN",
        "20815": "LUBLIN",
        "20816": "LUBLIN",
        "20817": "LUBLIN",
        "20818": "LUBLIN",
        "20819": "LUBLIN",
        "20820": "LUBLIN",
        "20822": "LUBLIN",
        "20823": "LUBLIN",
        "20824": "LUBLIN",
        "20825": "LUBLIN",
        "20826": "LUBLIN",
        "20827": "LUBLIN",
        "20828": "LUBLIN",
        "20829": "LUBLIN",
        "20830": "LUBLIN",
        "20831": "LUBLIN",
        "20832": "LUBLIN",
        "20833": "LUBLIN",
        "20834": "LUBLIN",
        "20835": "LUBLIN",
        "20836": "LUBLIN",
        "20837": "LUBLIN",
        "20838": "LUBLIN",
        "20839": "LUBLIN",
        "20840": "LUBLIN",
        "20841": "LUBLIN",
        "20843": "LUBLIN",
        "20844": "LUBLIN",
        "20845": "LUBLIN",
        "20848": "LUBLIN",
        "20849": "LUBLIN",
        "20850": "LUBLIN",
        "20851": "LUBLIN",
        "20853": "LUBLIN",
        "20854": "LUBLIN",
        "20856": "LUBLIN",
        "20857": "LUBLIN",
        "20858": "LUBLIN",
        "20859": "LUBLIN",
        "20860": "LUBLIN",
        "20861": "LUBLIN",
        "20862": "LUBLIN",
        "20863": "LUBLIN",
        "20864": "LUBLIN",
        "20865": "LUBLIN",
        "20866": "LUBLIN",
        "20867": "LUBLIN",
        "20868": "LUBLIN",
        "20869": "LUBLIN",
        "20870": "LUBLIN",
        "20871": "LUBLIN",
        "20872": "LUBLIN",
        "20874": "LUBLIN",
        "20875": "LUBLIN",
        "20880": "LUBLIN",
        "20881": "LUBLIN",
        "20882": "LUBLIN",
        "20883": "LUBLIN",
        "20884": "LUBLIN",
        "20900": "LUBLIN",
        "20914": "LUBLIN",
        "20940": "LUBLIN",
        "20950": "LUBLIN",
        "20951": "LUBLIN",
        "20952": "LUBLIN",
        "20953": "LUBLIN",
        "20954": "LUBLIN",
        "20955": "LUBLIN",
        "20956": "LUBLIN",
        "20958": "LUBLIN",
        "20960": "LUBLIN",
        "20990": "LUBLIN",
        "21000": "LUBARTÓW",
        "21002": "LUBLIN",
        "21003": "LUBLIN",
        "21007": "ŚWIDNIK",
        "21008": "LUBLIN",
        "21010": "ŁĘCZNA",
        "21011": "ŁĘCZNA",
        "21013": "ŁĘCZNA",
        "21017": "ŁĘCZNA",
        "21020": "ŁĘCZNA",
        "21025": "LUBLIN",
        "21030": "LUBLIN",
        "21040": "ŚWIDNIK",
        "21044": "ŚWIDNIK",
        "21045": "ŚWIDNIK",
        "21046": "ŚWIDNIK",
        "21047": "ŚWIDNIK",
        "21050": "ŚWIDNIK",
        "21060": "KRASNYSTAW",
        "21065": "ŚWIDNIK",
        "21070": "ŁĘCZNA",
        "21075": "ŁĘCZNA",
        "21077": "ŁĘCZNA",
        "21080": "LUBLIN",
        "21100": "LUBARTÓW",
        "21102": "LUBARTÓW",
        "21104": "LUBARTÓW",
        "21107": "LUBARTÓW",
        "21108": "LUBARTÓW",
        "21109": "LUBARTÓW",
        "21110": "LUBARTÓW",
        "21132": "LUBARTÓW",
        "21136": "LUBARTÓW",
        "21140": "LUBARTÓW",
        "21143": "LUBARTÓW",
        "21146": "LUBARTÓW",
        "21150": "LUBARTÓW",
        "21200": "PARCZEW",
        "21205": "PARCZEW",
        "21210": "PARCZEW",
        "21211": "PARCZEW",
        "21213": "PARCZEW",
        "21220": "PARCZEW",
        "21222": "PARCZEW",
        "21230": "PARCZEW",
        "21300": "RADZYŃ PODLASKI",
        "21302": "RADZYŃ PODLASKI",
        "21305": "RADZYŃ PODLASKI",
        "21306": "RADZYŃ PODLASKI",
        "21307": "RADZYŃ PODLASKI",
        "21310": "RADZYŃ PODLASKI",
        "21311": "RADZYŃ PODLASKI",
        "21315": "RADZYŃ PODLASKI",
        "21345": "RADZYŃ PODLASKI",
        "21400": "ŁUKÓW",
        "21404": "ŁUKÓW",
        "21405": "ŁUKÓW",
        "21410": "ŁUKÓW",
        "21411": "ŁUKÓW",
        "21412": "ŁUKÓW",
        "21413": "ŁUKÓW",
        "21421": "ŁUKÓW",
        "21422": "ŁUKÓW",
        "21425": "ŁUKÓW",
        "21426": "ŁUKÓW",
        "21450": "ŁUKÓW",
        "21470": "ŁUKÓW",
        "21480": "ŁUKÓW",
        "21481": "ŁUKÓW",
        "21500": "BIAŁA PODLASKA",
        "21501": "BIAŁA PODLASKA",
        "21502": "BIAŁA PODLASKA",
        "21504": "BIAŁA PODLASKA",
        "21505": "JANÓW PODLASKI",
        "21506": "BIAŁA PODLASKA",
        "21509": "BIAŁA PODLASKA",
        "21512": "BIAŁA PODLASKA",
        "21515": "BIAŁA PODLASKA",
        "21518": "BIAŁA PODLASKA",
        "21523": "BIAŁA PODLASKA",
        "21526": "BIAŁA PODLASKA",
        "21527": "BIAŁA PODLASKA",
        "21530": "BIAŁA PODLASKA",
        "21532": "BIAŁA PODLASKA",
        "21533": "BIAŁA PODLASKA",
        "21536": "BIAŁA PODLASKA",
        "21540": "BIAŁA PODLASKA",
        "21542": "BIAŁA PODLASKA",
        "21543": "BIAŁA PODLASKA",
        "21550": "TERESPOL",
        "21560": "MIĘDZYRZEC PODLASKI",
        "21561": "MIĘDZYRZEC PODLASKI",
        "21564": "BIAŁA PODLASKA",
        "21570": "BIAŁA PODLASKA",
        "21580": "BIAŁA PODLASKA",
        "21590": "BIAŁA PODLASKA",
        "22100": "CHEŁM (NET)",
        "22102": "CHEŁM (NET)",
        "22103": "CHEŁM (NET)",
        "22104": "CHEŁM (NET)",
        "22105": "CHEŁM (NET)",
        "22106": "CHEŁM (NET)",
        "22107": "CHEŁM (NET)",
        "22109": "CHEŁM (NET)",
        "22110": "CHEŁM (NET)",
        "22113": "CHEŁM (NET)",
        "22114": "CHEŁM (NET)",
        "22115": "CHEŁM (NET)",
        "22116": "CHEŁM (NET)",
        "22117": "CHEŁM (NET)",
        "22118": "CHEŁM (NET)",
        "22120": "CHEŁM (NET)",
        "22121": "CHEŁM (NET)",
        "22122": "CHEŁM (NET)",
        "22130": "CHEŁM (NET)",
        "22133": "CHEŁM (NET)",
        "22135": "CHEŁM (NET)",
        "22145": "CHEŁM (NET)",
        "22150": "CHEŁM (NET)",
        "22151": "CHEŁM (NET)",
        "22169": "CHEŁM (NET)",
        "22170": "CHEŁM (NET)",
        "22171": "CHEŁM (NET)",
        "22172": "CHEŁM (NET)",
        "22174": "CHEŁM (NET)",
        "22175": "DOROHUSK",
        "22200": "WŁODAWA",
        "22201": "WŁODAWA",
        "22205": "WŁODAWA",
        "22206": "WŁODAWA",
        "22207": "WŁODAWA",
        "22211": "WŁODAWA",
        "22220": "WŁODAWA",
        "22230": "WŁODAWA",
        "22232": "WŁODAWA",
        "22234": "WŁODAWA",
        "22235": "WŁODAWA",
        "22244": "WŁODAWA",
        "22300": "KRASNYSTAW",
        "22302": "KRASNYSTAW",
        "22304": "KRASNYSTAW",
        "22310": "KRASNYSTAW",
        "22315": "KRASNYSTAW",
        "22330": "KRASNYSTAW",
        "22335": "KRASNYSTAW",
        "22351": "KRASNYSTAW",
        "22360": "KRASNYSTAW",
        "22363": "CHEŁM (NET)",
        "22375": "KRASNYSTAW",
        "22376": "KRASNYSTAW",
        "22400": "ZAMOŚĆ",
        "22401": "ZAMOŚĆ",
        "22402": "ZAMOŚĆ",
        "22403": "ZAMOŚĆ",
        "22404": "ZAMOŚĆ",
        "22405": "ZAMOŚĆ",
        "22406": "ZAMOŚĆ",
        "22407": "ZAMOŚĆ",
        "22409": "ZAMOŚĆ",
        "22410": "ZAMOŚĆ",
        "22413": "ZAMOŚĆ",
        "22417": "ZAMOŚĆ",
        "22420": "ZAMOŚĆ",
        "22424": "ZAMOŚĆ",
        "22425": "ZAMOŚĆ",
        "22435": "ZAMOŚĆ",
        "22437": "ZAMOŚĆ",
        "22440": "ZAMOŚĆ",
        "22442": "ZAMOŚĆ",
        "22448": "ZAMOŚĆ",
        "22450": "ZAMOŚĆ",
        "22455": "ZAMOŚĆ",
        "22457": "ZAMOŚĆ",
        "22460": "ZAMOŚĆ",
        "22461": "ZAMOŚĆ",
        "22463": "ZAMOŚĆ",
        "22470": "ZAMOŚĆ",
        "22490": "ZAMOŚĆ",
        "22500": "HRUBIESZÓW",
        "22501": "HRUBIESZÓW",
        "22510": "HRUBIESZÓW",
        "22523": "HRUBIESZÓW",
        "22525": "HRUBIESZÓW",
        "22526": "HRUBIESZÓW",
        "22530": "HRUBIESZÓW",
        "22540": "HRUBIESZÓW",
        "22541": "HRUBIESZÓW",
        "22546": "HRUBIESZÓW",
        "22547": "HRUBIESZÓW",
        "22550": "HRUBIESZÓW",
        "22554": "HRUBIESZÓW",
        "22565": "HRUBIESZÓW",
        "22600": "TOMASZÓW LUBELSKI",
        "22602": "TOMASZÓW LUBELSKI",
        "22604": "TOMASZÓW LUBELSKI",
        "22610": "TOMASZÓW LUBELSKI",
        "22630": "TOMASZÓW LUBELSKI",
        "22640": "TOMASZÓW LUBELSKI",
        "22650": "TOMASZÓW LUBELSKI",
        "22652": "TOMASZÓW LUBELSKI",
        "22664": "TOMASZÓW LUBELSKI",
        "22670": "TOMASZÓW LUBELSKI",
        "22671": "TOMASZÓW LUBELSKI",
        "22672": "TOMASZÓW LUBELSKI",
        "22678": "TOMASZÓW LUBELSKI",
        "22680": "TOMASZÓW LUBELSKI",
        "22681": "TOMASZÓW LUBELSKI",
        "23100": "LUBLIN",
        "23107": "LUBLIN",
        "23110": "LUBLIN",
        "23114": "LUBLIN",
        "23145": "LUBLIN",
        "23155": "LUBLIN",
        "23156": "LUBLIN",
        "23200": "KRAŚNIK",
        "23202": "KRAŚNIK",
        "23203": "KRAŚNIK",
        "23204": "KRAŚNIK",
        "23205": "KRAŚNIK",
        "23206": "KRAŚNIK",
        "23210": "KRAŚNIK",
        "23212": "KRAŚNIK",
        "23213": "KRAŚNIK",
        "23225": "KRAŚNIK",
        "23230": "KRAŚNIK",
        "23231": "KRAŚNIK",
        "23235": "KRAŚNIK",
        "23250": "KRAŚNIK",
        "23251": "KRAŚNIK",
        "23275": "KRAŚNIK",
        "23300": "JANÓW LUBELSKI",
        "23302": "JANÓW LUBELSKI",
        "23303": "JANÓW LUBELSKI",
        "23304": "JANÓW LUBELSKI",
        "23305": "CHRZANÓW",
        "23310": "JANÓW LUBELSKI",
        "23313": "JANÓW LUBELSKI",
        "23320": "JANÓW LUBELSKI",
        "23400": "BIŁGORAJ",
        "23401": "BIŁGORAJ",
        "23407": "BIŁGORAJ",
        "23408": "BIŁGORAJ",
        "23412": "BIŁGORAJ",
        "23413": "BIŁGORAJ",
        "23414": "BIŁGORAJ",
        "23415": "BIŁGORAJ",
        "23416": "BIŁGORAJ",
        "23420": "BIŁGORAJ",
        "23423": "BIŁGORAJ",
        "23425": "BIŁGORAJ",
        "23440": "BIŁGORAJ",
        "23450": "BIŁGORAJ",
        "23460": "BIŁGORAJ",
        "23465": "BIŁGORAJ",
        "24100": "PUŁAWY",
        "24101": "PUŁAWY",
        "24103": "PUŁAWY",
        "24105": "PUŁAWY",
        "24110": "PUŁAWY",
        "24111": "PUŁAWY",
        "24112": "PUŁAWY",
        "24120": "PUŁAWY",
        "24123": "PUŁAWY",
        "24130": "PUŁAWY",
        "24140": "NAŁĘCZÓW",
        "24150": "NAŁĘCZÓW",
        "24160": "PUŁAWY",
        "24170": "PUŁAWY",
        "24173": "PUŁAWY",
        "24200": "LUBLIN",
        "24204": "LUBLIN",
        "24220": "LUBLIN",
        "24224": "LUBLIN",
        "24300": "OPOLE LUBELSKIE",
        "24310": "OPOLE LUBELSKIE",
        "24313": "OPOLE LUBELSKIE",
        "24320": "OPOLE LUBELSKIE",
        "24333": "OPOLE LUBELSKIE",
        "24335": "OPOLE LUBELSKIE",
        "24340": "OPOLE LUBELSKIE",
        "24350": "OPOLE LUBELSKIE",
        "25001": "KIELCE",
        "25002": "KIELCE",
        "25003": "KIELCE",
        "25004": "KIELCE",
        "25005": "KIELCE",
        "25006": "KIELCE",
        "25007": "KIELCE",
        "25008": "KIELCE",
        "25009": "KIELCE",
        "25010": "KIELCE",
        "25011": "KIELCE",
        "25012": "KIELCE",
        "25013": "KIELCE",
        "25014": "KIELCE",
        "25015": "KIELCE",
        "25016": "KIELCE",
        "25017": "KIELCE",
        "25018": "KIELCE",
        "25019": "KIELCE",
        "25020": "KIELCE",
        "25021": "KIELCE",
        "25022": "KIELCE",
        "25023": "KIELCE",
        "25024": "KIELCE",
        "25025": "KIELCE",
        "25026": "KIELCE",
        "25027": "KIELCE",
        "25028": "KIELCE",
        "25029": "KIELCE",
        "25030": "KIELCE",
        "25031": "KIELCE",
        "25032": "KIELCE",
        "25033": "KIELCE",
        "25034": "KIELCE",
        "25035": "KIELCE",
        "25036": "KIELCE",
        "25037": "KIELCE",
        "25038": "KIELCE",
        "25039": "KIELCE",
        "25040": "KIELCE",
        "25041": "KIELCE",
        "25042": "KIELCE",
        "25043": "KIELCE",
        "25044": "KIELCE",
        "25045": "KIELCE",
        "25046": "KIELCE",
        "25047": "KIELCE",
        "25090": "KIELCE",
        "25093": "KIELCE",
        "25101": "KIELCE",
        "25102": "KIELCE",
        "25103": "KIELCE",
        "25104": "KIELCE",
        "25105": "KIELCE",
        "25106": "KIELCE",
        "25107": "KIELCE",
        "25108": "KIELCE",
        "25109": "KIELCE",
        "25110": "KIELCE",
        "25111": "KIELCE",
        "25112": "KIELCE",
        "25113": "KIELCE",
        "25114": "KIELCE",
        "25115": "KIELCE",
        "25116": "KIELCE",
        "25117": "KIELCE",
        "25118": "KIELCE",
        "25119": "KIELCE",
        "25120": "KIELCE",
        "25121": "KIELCE",
        "25122": "KIELCE",
        "25123": "KIELCE",
        "25124": "KIELCE",
        "25125": "KIELCE",
        "25127": "KIELCE",
        "25128": "KIELCE",
        "25129": "KIELCE",
        "25130": "KIELCE",
        "25131": "KIELCE",
        "25132": "KIELCE",
        "25133": "KIELCE",
        "25134": "KIELCE",
        "25135": "KIELCE",
        "25136": "KIELCE",
        "25137": "KIELCE",
        "25138": "KIELCE",
        "25139": "KIELCE",
        "25140": "KIELCE",
        "25141": "KIELCE",
        "25142": "KIELCE",
        "25143": "KIELCE",
        "25144": "KIELCE",
        "25145": "KIELCE",
        "25146": "KIELCE",
        "25147": "KIELCE",
        "25148": "KIELCE",
        "25149": "KIELCE",
        "25150": "KIELCE",
        "25151": "KIELCE",
        "25152": "KIELCE",
        "25154": "KIELCE",
        "25155": "KIELCE",
        "25201": "KIELCE",
        "25202": "KIELCE",
        "25204": "KIELCE",
        "25205": "KIELCE",
        "25206": "KIELCE",
        "25208": "KIELCE",
        "25209": "KIELCE",
        "25210": "KIELCE",
        "25211": "KIELCE",
        "25212": "KIELCE",
        "25213": "KIELCE",
        "25214": "KIELCE",
        "25217": "KIELCE",
        "25218": "KIELCE",
        "25219": "KIELCE",
        "25220": "KIELCE",
        "25221": "KIELCE",
        "25222": "KIELCE",
        "25223": "KIELCE",
        "25224": "KIELCE",
        "25225": "KIELCE",
        "25226": "KIELCE",
        "25227": "KIELCE",
        "25228": "KIELCE",
        "25229": "KIELCE",
        "25230": "KIELCE",
        "25231": "KIELCE",
        "25232": "KIELCE",
        "25233": "KIELCE",
        "25234": "KIELCE",
        "25235": "KIELCE",
        "25236": "KIELCE",
        "25237": "KIELCE",
        "25252": "KIELCE",
        "25253": "KIELCE",
        "25254": "KIELCE",
        "25255": "KIELCE",
        "25257": "KIELCE",
        "25258": "KIELCE",
        "25259": "KIELCE",
        "25260": "KIELCE",
        "25301": "KIELCE",
        "25302": "KIELCE",
        "25303": "KIELCE",
        "25304": "KIELCE",
        "25305": "KIELCE",
        "25306": "KIELCE",
        "25307": "KIELCE",
        "25308": "KIELCE",
        "25309": "KIELCE",
        "25310": "KIELCE",
        "25311": "KIELCE",
        "25312": "KIELCE",
        "25313": "KIELCE",
        "25314": "KIELCE",
        "25315": "KIELCE",
        "25316": "KIELCE",
        "25317": "KIELCE",
        "25318": "KIELCE",
        "25319": "KIELCE",
        "25320": "KIELCE",
        "25321": "KIELCE",
        "25322": "KIELCE",
        "25323": "KIELCE",
        "25324": "KIELCE",
        "25325": "KIELCE",
        "25326": "KIELCE",
        "25327": "KIELCE",
        "25328": "KIELCE",
        "25329": "KIELCE",
        "25330": "KIELCE",
        "25331": "KIELCE",
        "25332": "KIELCE",
        "25333": "KIELCE",
        "25334": "KIELCE",
        "25335": "KIELCE",
        "25336": "KIELCE",
        "25337": "KIELCE",
        "25338": "KIELCE",
        "25339": "KIELCE",
        "25340": "KIELCE",
        "25341": "KIELCE",
        "25342": "KIELCE",
        "25343": "KIELCE",
        "25344": "KIELCE",
        "25345": "KIELCE",
        "25346": "KIELCE",
        "25347": "KIELCE",
        "25348": "KIELCE",
        "25349": "KIELCE",
        "25350": "KIELCE",
        "25351": "KIELCE",
        "25352": "KIELCE",
        "25353": "KIELCE",
        "25354": "KIELCE",
        "25355": "KIELCE",
        "25356": "KIELCE",
        "25357": "KIELCE",
        "25358": "KIELCE",
        "25359": "KIELCE",
        "25360": "KIELCE",
        "25361": "KIELCE",
        "25362": "KIELCE",
        "25363": "KIELCE",
        "25364": "KIELCE",
        "25365": "KIELCE",
        "25366": "KIELCE",
        "25367": "KIELCE",
        "25368": "KIELCE",
        "25369": "KIELCE",
        "25370": "KIELCE",
        "25371": "KIELCE",
        "25372": "KIELCE",
        "25373": "KIELCE",
        "25375": "KIELCE",
        "25376": "KIELCE",
        "25377": "KIELCE",
        "25378": "KIELCE",
        "25379": "KIELCE",
        "25380": "KIELCE",
        "25381": "KIELCE",
        "25382": "KIELCE",
        "25383": "KIELCE",
        "25384": "KIELCE",
        "25385": "KIELCE",
        "25386": "KIELCE",
        "25387": "KIELCE",
        "25389": "KIELCE",
        "25390": "KIELCE",
        "25391": "KIELCE",
        "25392": "KIELCE",
        "25394": "KIELCE",
        "25395": "KIELCE",
        "25401": "KIELCE",
        "25402": "KIELCE",
        "25403": "KIELCE",
        "25405": "KIELCE",
        "25406": "KIELCE",
        "25408": "KIELCE",
        "25409": "KIELCE",
        "25410": "KIELCE",
        "25411": "KIELCE",
        "25412": "KIELCE",
        "25413": "KIELCE",
        "25414": "KIELCE",
        "25415": "KIELCE",
        "25416": "KIELCE",
        "25417": "KIELCE",
        "25418": "KIELCE",
        "25419": "KIELCE",
        "25420": "KIELCE",
        "25421": "KIELCE",
        "25422": "KIELCE",
        "25424": "KIELCE",
        "25425": "KIELCE",
        "25426": "KIELCE",
        "25429": "KIELCE",
        "25430": "KIELCE",
        "25431": "KIELCE",
        "25432": "KIELCE",
        "25433": "KIELCE",
        "25434": "KIELCE",
        "25435": "KIELCE",
        "25436": "KIELCE",
        "25437": "KIELCE",
        "25438": "KIELCE",
        "25439": "KIELCE",
        "25440": "KIELCE",
        "25441": "KIELCE",
        "25442": "KIELCE",
        "25443": "KIELCE",
        "25444": "KIELCE",
        "25445": "KIELCE",
        "25446": "KIELCE",
        "25447": "KIELCE",
        "25448": "KIELCE",
        "25449": "KIELCE",
        "25450": "KIELCE",
        "25451": "KIELCE",
        "25452": "KIELCE",
        "25453": "KIELCE",
        "25454": "KIELCE",
        "25455": "KIELCE",
        "25456": "KIELCE",
        "25457": "KIELCE",
        "25458": "KIELCE",
        "25459": "KIELCE",
        "25460": "KIELCE",
        "25470": "KIELCE",
        "25501": "KIELCE",
        "25502": "KIELCE",
        "25503": "KIELCE",
        "25504": "KIELCE",
        "25505": "KIELCE",
        "25506": "KIELCE",
        "25507": "KIELCE",
        "25508": "KIELCE",
        "25509": "KIELCE",
        "25510": "KIELCE",
        "25511": "KIELCE",
        "25512": "KIELCE",
        "25513": "KIELCE",
        "25514": "KIELCE",
        "25515": "KIELCE",
        "25516": "KIELCE",
        "25517": "KIELCE",
        "25518": "KIELCE",
        "25519": "KIELCE",
        "25520": "KIELCE",
        "25521": "KIELCE",
        "25522": "KIELCE",
        "25523": "KIELCE",
        "25524": "KIELCE",
        "25525": "KIELCE",
        "25526": "KIELCE",
        "25527": "KIELCE",
        "25528": "KIELCE",
        "25529": "KIELCE",
        "25530": "KIELCE",
        "25531": "KIELCE",
        "25532": "KIELCE",
        "25533": "KIELCE",
        "25534": "KIELCE",
        "25535": "KIELCE",
        "25536": "KIELCE",
        "25537": "KIELCE",
        "25538": "KIELCE",
        "25539": "KIELCE",
        "25540": "KIELCE",
        "25541": "KIELCE",
        "25542": "KIELCE",
        "25543": "KIELCE",
        "25544": "KIELCE",
        "25545": "KIELCE",
        "25546": "KIELCE",
        "25547": "KIELCE",
        "25548": "KIELCE",
        "25549": "KIELCE",
        "25550": "KIELCE",
        "25551": "KIELCE",
        "25552": "KIELCE",
        "25553": "KIELCE",
        "25554": "KIELCE",
        "25555": "KIELCE",
        "25556": "KIELCE",
        "25557": "KIELCE",
        "25558": "KIELCE",
        "25559": "KIELCE",
        "25560": "KIELCE",
        "25561": "KIELCE",
        "25562": "KIELCE",
        "25563": "KIELCE",
        "25564": "KIELCE",
        "25565": "KIELCE",
        "25566": "KIELCE",
        "25567": "KIELCE",
        "25568": "KIELCE",
        "25601": "KIELCE",
        "25602": "KIELCE",
        "25603": "KIELCE",
        "25604": "KIELCE",
        "25605": "KIELCE",
        "25606": "KIELCE",
        "25607": "KIELCE",
        "25608": "KIELCE",
        "25609": "KIELCE",
        "25610": "KIELCE",
        "25611": "KIELCE",
        "25612": "KIELCE",
        "25613": "KIELCE",
        "25614": "KIELCE",
        "25615": "KIELCE",
        "25616": "KIELCE",
        "25617": "KIELCE",
        "25618": "KIELCE",
        "25619": "KIELCE",
        "25620": "KIELCE",
        "25621": "KIELCE",
        "25622": "KIELCE",
        "25623": "KIELCE",
        "25624": "KIELCE",
        "25625": "KIELCE",
        "25626": "KIELCE",
        "25627": "KIELCE",
        "25628": "KIELCE",
        "25629": "KIELCE",
        "25630": "KIELCE",
        "25631": "KIELCE",
        "25632": "KIELCE",
        "25633": "KIELCE",
        "25634": "KIELCE",
        "25635": "KIELCE",
        "25636": "KIELCE",
        "25637": "KIELCE",
        "25638": "KIELCE",
        "25639": "KIELCE",
        "25640": "KIELCE",
        "25644": "KIELCE",
        "25645": "KIELCE",
        "25646": "KIELCE",
        "25647": "KIELCE",
        "25648": "KIELCE",
        "25649": "KIELCE",
        "25650": "KIELCE",
        "25651": "KIELCE",
        "25652": "KIELCE",
        "25653": "KIELCE",
        "25654": "KIELCE",
        "25655": "KIELCE",
        "25656": "KIELCE",
        "25657": "KIELCE",
        "25658": "KIELCE",
        "25659": "KIELCE",
        "25660": "KIELCE",
        "25661": "KIELCE",
        "25662": "KIELCE",
        "25663": "KIELCE",
        "25664": "KIELCE",
        "25665": "KIELCE",
        "25666": "KIELCE",
        "25667": "KIELCE",
        "25668": "KIELCE",
        "25669": "KIELCE",
        "25670": "KIELCE",
        "25671": "KIELCE",
        "25672": "KIELCE",
        "25673": "KIELCE",
        "25675": "KIELCE",
        "25677": "KIELCE",
        "25678": "KIELCE",
        "25679": "KIELCE",
        "25680": "KIELCE",
        "25681": "KIELCE",
        "25682": "KIELCE",
        "25701": "KIELCE",
        "25702": "KIELCE",
        "25703": "KIELCE",
        "25704": "KIELCE",
        "25705": "KIELCE",
        "25706": "KIELCE",
        "25707": "KIELCE",
        "25708": "KIELCE",
        "25709": "KIELCE",
        "25710": "KIELCE",
        "25711": "KIELCE",
        "25712": "KIELCE",
        "25713": "KIELCE",
        "25714": "KIELCE",
        "25715": "KIELCE",
        "25716": "KIELCE",
        "25717": "KIELCE",
        "25718": "KIELCE",
        "25719": "KIELCE",
        "25720": "KIELCE",
        "25721": "KIELCE",
        "25722": "KIELCE",
        "25723": "KIELCE",
        "25724": "KIELCE",
        "25725": "KIELCE",
        "25726": "KIELCE",
        "25727": "KIELCE",
        "25728": "KIELCE",
        "25729": "KIELCE",
        "25730": "KIELCE",
        "25731": "KIELCE",
        "25732": "KIELCE",
        "25733": "KIELCE",
        "25734": "KIELCE",
        "25735": "KIELCE",
        "25736": "KIELCE",
        "25737": "KIELCE",
        "25738": "KIELCE",
        "25739": "KIELCE",
        "25744": "KIELCE",
        "25745": "KIELCE",
        "25746": "KIELCE",
        "25749": "KIELCE",
        "25750": "KIELCE",
        "25751": "KIELCE",
        "25752": "KIELCE",
        "25753": "KIELCE",
        "25754": "KIELCE",
        "25756": "KIELCE",
        "25757": "KIELCE",
        "25758": "KIELCE",
        "25759": "KIELCE",
        "25801": "KIELCE",
        "25802": "KIELCE",
        "25803": "KIELCE",
        "25804": "KIELCE",
        "25805": "KIELCE",
        "25806": "KIELCE",
        "25807": "KIELCE",
        "25808": "KIELCE",
        "25809": "KIELCE",
        "25810": "KIELCE",
        "25811": "KIELCE",
        "25812": "KIELCE",
        "25813": "KIELCE",
        "25814": "KIELCE",
        "25815": "KIELCE",
        "25816": "KIELCE",
        "25817": "KIELCE",
        "25818": "KIELCE",
        "25819": "KIELCE",
        "25820": "KIELCE",
        "25821": "KIELCE",
        "25822": "KIELCE",
        "25823": "KIELCE",
        "25824": "KIELCE",
        "25825": "KIELCE",
        "25826": "KIELCE",
        "25827": "KIELCE",
        "25828": "KIELCE",
        "25829": "KIELCE",
        "25851": "KIELCE",
        "25852": "KIELCE",
        "25900": "KIELCE",
        "25949": "KIELCE",
        "25960": "KIELCE",
        "26001": "KIELCE",
        "26004": "KIELCE",
        "26006": "KIELCE",
        "26008": "KIELCE",
        "26009": "KIELCE",
        "26010": "KIELCE",
        "26011": "KIELCE",
        "26015": "KIELCE",
        "26020": "KIELCE",
        "26021": "KIELCE",
        "26025": "KIELCE",
        "26026": "KIELCE",
        "26035": "KIELCE",
        "26050": "KIELCE",
        "26052": "SITKÓWKA-NOWINY",
        "26060": "KIELCE",
        "26065": "KIELCE",
        "26067": "KIELCE",
        "26070": "KIELCE",
        "26080": "KIELCE",
        "26085": "KIELCE",
        "26100": "SKARŻYSKO-KAMIENNA",
        "26110": "SKARŻYSKO-KAMIENNA",
        "26111": "SKARŻYSKO-KAMIENNA",
        "26112": "SKARŻYSKO-KAMIENNA",
        "26113": "SKARŻYSKO-KAMIENNA",
        "26115": "SKARŻYSKO-KAMIENNA",
        "26120": "SKARŻYSKO-KAMIENNA",
        "26130": "SKARŻYSKO-KAMIENNA",
        "26140": "SKARŻYSKO-KAMIENNA",
        "26200": "KOŃSKIE",
        "26202": "KOŃSKIE",
        "26212": "KOŃSKIE",
        "26220": "KOŃSKIE",
        "26225": "KOŃSKIE",
        "26230": "KOŃSKIE",
        "26234": "KOŃSKIE",
        "26242": "KOŃSKIE",
        "26260": "KOŃSKIE",
        "26300": "OPOCZNO",
        "26301": "OPOCZNO",
        "26307": "OPOCZNO",
        "26315": "OPOCZNO",
        "26330": "OPOCZNO",
        "26332": "OPOCZNO",
        "26333": "OPOCZNO",
        "26337": "PIOTRKÓW TRYBUNALSKI",
        "26340": "OPOCZNO",
        "26341": "OPOCZNO",
        "26400": "PRZYSUCHA",
        "26411": "PRZYSUCHA",
        "26414": "PRZYSUCHA",
        "26415": "PRZYSUCHA",
        "26420": "GRÓJEC",
        "26422": "PRZYSUCHA",
        "26425": "PRZYSUCHA",
        "26432": "PRZYSUCHA",
        "26434": "PRZYSUCHA",
        "26500": "SZYDŁOWIEC",
        "26502": "SZYDŁOWIEC",
        "26503": "SZYDŁOWIEC",
        "26505": "SZYDŁOWIEC",
        "26510": "SZYDŁOWIEC",
        "26600": "RADOM",
        "26601": "RADOM",
        "26602": "RADOM",
        "26603": "RADOM",
        "26604": "RADOM",
        "26605": "RADOM",
        "26606": "RADOM",
        "26607": "RADOM",
        "26608": "RADOM",
        "26609": "RADOM",
        "26610": "RADOM",
        "26611": "RADOM",
        "26612": "RADOM",
        "26613": "RADOM",
        "26614": "RADOM",
        "26615": "RADOM",
        "26616": "RADOM",
        "26617": "RADOM",
        "26618": "RADOM",
        "26619": "RADOM",
        "26620": "RADOM",
        "26621": "RADOM",
        "26622": "RADOM",
        "26623": "RADOM",
        "26624": "RADOM",
        "26625": "RADOM",
        "26626": "RADOM",
        "26627": "RADOM",
        "26630": "RADOM",
        "26631": "RADOM",
        "26634": "RADOM",
        "26640": "RADOM",
        "26650": "RADOM",
        "26652": "RADOM",
        "26660": "RADOM",
        "26670": "PIONKI",
        "26675": "PIONKI",
        "26680": "RADOM",
        "26700": "ZWOLEŃ",
        "26704": "ZWOLEŃ",
        "26706": "ZWOLEŃ",
        "26713": "ZWOLEŃ",
        "26720": "ZWOLEŃ",
        "26800": "BIAŁOBRZEGI",
        "26801": "BIAŁOBRZEGI",
        "26803": "BIAŁOBRZEGI",
        "26804": "BIAŁOBRZEGI",
        "26806": "BIAŁOBRZEGI",
        "26807": "BIAŁOBRZEGI",
        "26811": "BIAŁOBRZEGI",
        "26900": "KOZIENICE (NET)",
        "26901": "KOZIENICE (NET)",
        "26902": "KOZIENICE (NET)",
        "26903": "KOZIENICE (NET)",
        "26904": "KOZIENICE (NET)",
        "26905": "KOZIENICE - ELEKTROWNIA",
        "26906": "KOZIENICE - ELEKTROWNIA",
        "26910": "KOZIENICE (NET)",
        "26914": "KOZIENICE (NET)",
        "26920": "KOZIENICE (NET)",
        "26922": "KOZIENICE (NET)",
        "26930": "KOZIENICE (NET)",
        "27100": "RADOM",
        "27200": "STARACHOWICE",
        "27201": "STARACHOWICE",
        "27202": "STARACHOWICE",
        "27203": "STARACHOWICE",
        "27205": "STARACHOWICE",
        "27206": "STARACHOWICE",
        "27215": "STARACHOWICE",
        "27220": "STARACHOWICE",
        "27225": "STARACHOWICE",
        "27230": "STARACHOWICE",
        "27300": "LIPSKO",
        "27301": "LIPSKO",
        "27302": "LIPSKO",
        "27310": "LIPSKO",
        "27312": "LIPSKO",
        "27320": "LIPSKO",
        "27330": "LIPSKO",
        "27350": "LIPSKO",
        "27353": "LIPSKO",
        "27400": "OSTROWIEC ŚWIĘTOKRZYSKI",
        "27401": "OSTROWIEC ŚWIĘTOKRZYSKI",
        "27402": "OSTROWIEC ŚWIĘTOKRZYSKI",
        "27404": "OSTROWIEC ŚWIĘTOKRZYSKI",
        "27405": "OSTROWIEC ŚWIĘTOKRZYSKI",
        "27406": "OSTROWIEC ŚWIĘTOKRZYSKI",
        "27415": "OSTROWIEC ŚWIĘTOKRZYSKI",
        "27420": "OSTROWIEC ŚWIĘTOKRZYSKI",
        "27423": "OSTROWIEC ŚWIĘTOKRZYSKI",
        "27425": "OSTROWIEC ŚWIĘTOKRZYSKI",
        "27440": "OSTROWIEC ŚWIĘTOKRZYSKI",
        "27500": "OPATÓW",
        "27515": "OPATÓW",
        "27530": "OPATÓW",
        "27532": "OPATÓW",
        "27540": "LIPNIK",
        "27545": "OPATÓW",
        "27552": "OPATÓW",
        "27570": "OPATÓW",
        "27580": "OPATÓW",
        "27600": "SANDOMIERZ",
        "27601": "SANDOMIERZ",
        "27602": "SANDOMIERZ",
        "27610": "SANDOMIERZ",
        "27612": "SANDOMIERZ",
        "27620": "SANDOMIERZ",
        "27630": "SANDOMIERZ",
        "27640": "SANDOMIERZ",
        "27641": "SANDOMIERZ",
        "27650": "SANDOMIERZ",
        "27660": "SANDOMIERZ",
        "27670": "SANDOMIERZ",
        "28100": "BUSKO-ZDRÓJ",
        "28101": "BUSKO-ZDRÓJ",
        "28102": "BUSKO-ZDRÓJ",
        "28114": "BUSKO-ZDRÓJ",
        "28130": "BUSKO-ZDRÓJ",
        "28131": "BUSKO-ZDRÓJ",
        "28133": "BUSKO-ZDRÓJ",
        "28136": "BUSKO-ZDRÓJ",
        "28142": "BUSKO-ZDRÓJ",
        "28160": "BUSKO-ZDRÓJ",
        "28200": "STASZÓW",
        "28203": "STASZÓW",
        "28210": "STASZÓW",
        "28220": "STASZÓW",
        "28221": "STASZÓW",
        "28225": "STASZÓW",
        "28230": "STASZÓW",
        "28232": "STASZÓW",
        "28236": "STASZÓW",
        "28300": "JĘDRZEJÓW",
        "28305": "JĘDRZEJÓW",
        "28310": "JĘDRZEJÓW",
        "28313": "JĘDRZEJÓW",
        "28330": "JĘDRZEJÓW",
        "28340": "JĘDRZEJÓW",
        "28350": "JĘDRZEJÓW",
        "28362": "JĘDRZEJÓW",
        "28363": "JĘDRZEJÓW",
        "28366": "JĘDRZEJÓW",
        "28400": "PIŃCZÓW",
        "28404": "PIŃCZÓW",
        "28411": "PIŃCZÓW",
        "28425": "PIŃCZÓW",
        "28440": "PIŃCZÓW",
        "28500": "KAZIMIERZA WIELKA",
        "28506": "KAZIMIERZA WIELKA",
        "28512": "KAZIMIERZA WIELKA",
        "28520": "KAZIMIERZA WIELKA",
        "28530": "KAZIMIERZA WIELKA",
        "29100": "WŁOSZCZOWA",
        "29105": "WŁOSZCZOWA",
        "29106": "STASZÓW",
        "29120": "WŁOSZCZOWA",
        "29130": "WŁOSZCZOWA",
        "29135": "WŁOSZCZOWA",
        "29145": "WŁOSZCZOWA",
        "30001": "KRAKÓW",
        "30002": "KRAKÓW",
        "30003": "KRAKÓW",
        "30004": "KRAKÓW",
        "30006": "KRAKÓW",
        "30007": "KRAKÓW",
        "30009": "KRAKÓW",
        "30010": "KRAKÓW",
        "30011": "KRAKÓW",
        "30012": "KRAKÓW",
        "30014": "KRAKÓW",
        "30015": "KRAKÓW",
        "30016": "KRAKÓW",
        "30017": "KRAKÓW",
        "30018": "KRAKÓW",
        "30019": "KRAKÓW",
        "30020": "KRAKÓW",
        "30021": "KRAKÓW",
        "30022": "KRAKÓW",
        "30023": "KRAKÓW",
        "30024": "KRAKÓW",
        "30031": "KRAKÓW",
        "30032": "KRAKÓW",
        "30033": "KRAKÓW",
        "30034": "KRAKÓW",
        "30035": "KRAKÓW",
        "30036": "KRAKÓW",
        "30037": "KRAKÓW",
        "30038": "KRAKÓW",
        "30039": "KRAKÓW",
        "30040": "KRAKÓW",
        "30041": "KRAKÓW",
        "30042": "KRAKÓW",
        "30043": "KRAKÓW",
        "30044": "KRAKÓW",
        "30045": "KRAKÓW",
        "30046": "KRAKÓW",
        "30047": "KRAKÓW",
        "30048": "KRAKÓW",
        "30049": "KRAKÓW",
        "30050": "KRAKÓW",
        "30051": "KRAKÓW",
        "30052": "KRAKÓW",
        "30053": "KRAKÓW",
        "30054": "KRAKÓW",
        "30055": "KRAKÓW",
        "30056": "KRAKÓW",
        "30057": "KRAKÓW",
        "30058": "KRAKÓW",
        "30059": "KRAKÓW",
        "30060": "KRAKÓW",
        "30061": "KRAKÓW",
        "30062": "KRAKÓW",
        "30063": "KRAKÓW",
        "30065": "KRAKÓW",
        "30066": "KRAKÓW",
        "30067": "KRAKÓW",
        "30068": "KRAKÓW",
        "30069": "KRAKÓW",
        "30070": "KRAKÓW",
        "30071": "KRAKÓW",
        "30072": "KRAKÓW",
        "30073": "KRAKÓW",
        "30074": "KRAKÓW",
        "30075": "KRAKÓW",
        "30076": "KRAKÓW",
        "30077": "KRAKÓW",
        "30078": "KRAKÓW",
        "30079": "KRAKÓW",
        "30081": "KRAKÓW",
        "30082": "KRAKÓW",
        "30084": "KRAKÓW",
        "30085": "KRAKÓW",
        "30086": "KRAKÓW",
        "30087": "KRAKÓW",
        "30091": "KRAKÓW",
        "30092": "KRAKÓW",
        "30093": "KRAKÓW",
        "30094": "KRAKÓW",
        "30095": "KRAKÓW",
        "30100": "KRAKÓW",
        "30101": "KRAKÓW",
        "30102": "KRAKÓW",
        "30103": "KRAKÓW",
        "30104": "KRAKÓW",
        "30105": "KRAKÓW",
        "30106": "KRAKÓW",
        "30107": "KRAKÓW",
        "30108": "KRAKÓW",
        "30109": "KRAKÓW",
        "30110": "KRAKÓW",
        "30111": "KRAKÓW",
        "30112": "KRAKÓW",
        "30114": "KRAKÓW",
        "30116": "KRAKÓW",
        "30117": "KRAKÓW",
        "30118": "KRAKÓW",
        "30119": "KRAKÓW",
        "30120": "KRAKÓW",
        "30121": "KRAKÓW",
        "30122": "KRAKÓW",
        "30123": "KRAKÓW",
        "30124": "KRAKÓW",
        "30126": "KRAKÓW",
        "30127": "KRAKÓW",
        "30128": "KRAKÓW",
        "30129": "KRAKÓW",
        "30130": "KRAKÓW",
        "30131": "KRAKÓW",
        "30132": "KRAKÓW",
        "30133": "KRAKÓW",
        "30134": "KRAKÓW",
        "30135": "KRAKÓW",
        "30136": "KRAKÓW",
        "30137": "KRAKÓW",
        "30138": "KRAKÓW",
        "30139": "KRAKÓW",
        "30142": "KRAKÓW",
        "30143": "KRAKÓW",
        "30144": "KRAKÓW",
        "30145": "KRAKÓW",
        "30146": "KRAKÓW",
        "30147": "KRAKÓW",
        "30148": "KRAKÓW",
        "30149": "KRAKÓW",
        "30150": "KRAKÓW",
        "30198": "KRAKÓW",
        "30199": "KRAKÓW",
        "30201": "KRAKÓW",
        "30202": "KRAKÓW",
        "30203": "KRAKÓW",
        "30204": "KRAKÓW",
        "30205": "KRAKÓW",
        "30206": "KRAKÓW",
        "30207": "KRAKÓW",
        "30209": "KRAKÓW",
        "30210": "KRAKÓW",
        "30211": "KRAKÓW",
        "30212": "KRAKÓW",
        "30213": "KRAKÓW",
        "30214": "KRAKÓW",
        "30215": "KRAKÓW",
        "30216": "KRAKÓW",
        "30217": "KRAKÓW",
        "30218": "KRAKÓW",
        "30219": "KRAKÓW",
        "30220": "KRAKÓW",
        "30221": "KRAKÓW",
        "30222": "KRAKÓW",
        "30223": "KRAKÓW",
        "30224": "KRAKÓW",
        "30225": "KRAKÓW",
        "30227": "KRAKÓW",
        "30228": "KRAKÓW",
        "30229": "KRAKÓW",
        "30230": "KRAKÓW",
        "30231": "KRAKÓW",
        "30232": "KRAKÓW",
        "30233": "KRAKÓW",
        "30234": "KRAKÓW",
        "30235": "KRAKÓW",
        "30236": "KRAKÓW",
        "30237": "KRAKÓW",
        "30238": "KRAKÓW",
        "30239": "KRAKÓW",
        "30240": "KRAKÓW",
        "30241": "KRAKÓW",
        "30243": "KRAKÓW",
        "30244": "KRAKÓW",
        "30245": "KRAKÓW",
        "30246": "KRAKÓW",
        "30247": "KRAKÓW",
        "30248": "KRAKÓW",
        "30249": "KRAKÓW",
        "30250": "KRAKÓW",
        "30251": "KRAKÓW",
        "30252": "KRAKÓW",
        "30253": "KRAKÓW",
        "30254": "KRAKÓW",
        "30255": "KRAKÓW",
        "30298": "KRAKÓW",
        "30300": "KRAKÓW",
        "30301": "KRAKÓW",
        "30302": "KRAKÓW",
        "30303": "KRAKÓW",
        "30304": "KRAKÓW",
        "30305": "KRAKÓW",
        "30306": "KRAKÓW",
        "30307": "KRAKÓW",
        "30308": "KRAKÓW",
        "30309": "KRAKÓW",
        "30311": "KRAKÓW",
        "30312": "KRAKÓW",
        "30313": "KRAKÓW",
        "30314": "KRAKÓW",
        "30315": "KRAKÓW",
        "30316": "KRAKÓW",
        "30317": "KRAKÓW",
        "30318": "KRAKÓW",
        "30319": "KRAKÓW",
        "30320": "KRAKÓW",
        "30321": "KRAKÓW",
        "30322": "KRAKÓW",
        "30323": "KRAKÓW",
        "30324": "KRAKÓW",
        "30326": "KRAKÓW",
        "30327": "KRAKÓW",
        "30328": "KRAKÓW",
        "30329": "KRAKÓW",
        "30331": "KRAKÓW",
        "30332": "KRAKÓW",
        "30333": "KRAKÓW",
        "30334": "KRAKÓW",
        "30335": "KRAKÓW",
        "30336": "KRAKÓW",
        "30337": "KRAKÓW",
        "30346": "KRAKÓW",
        "30347": "KRAKÓW",
        "30348": "KRAKÓW",
        "30349": "KRAKÓW",
        "30350": "KRAKÓW",
        "30358": "KRAKÓW",
        "30361": "KRAKÓW",
        "30362": "KRAKÓW",
        "30363": "KRAKÓW",
        "30364": "KRAKÓW",
        "30373": "KRAKÓW",
        "30374": "KRAKÓW",
        "30375": "KRAKÓW",
        "30376": "KRAKÓW",
        "30377": "KRAKÓW",
        "30379": "KRAKÓW",
        "30380": "KRAKÓW",
        "30381": "KRAKÓW",
        "30382": "KRAKÓW",
        "30383": "KRAKÓW",
        "30384": "KRAKÓW",
        "30385": "KRAKÓW",
        "30386": "KRAKÓW",
        "30387": "KRAKÓW",
        "30388": "KRAKÓW",
        "30389": "KRAKÓW",
        "30390": "KRAKÓW",
        "30391": "KRAKÓW",
        "30392": "KRAKÓW",
        "30393": "KRAKÓW",
        "30394": "KRAKÓW",
        "30395": "KRAKÓW",
        "30396": "KRAKÓW",
        "30397": "KRAKÓW",
        "30398": "KRAKÓW",
        "30399": "KRAKÓW",
        "30403": "KRAKÓW",
        "30404": "KRAKÓW",
        "30405": "KRAKÓW",
        "30406": "KRAKÓW",
        "30407": "KRAKÓW",
        "30408": "KRAKÓW",
        "30409": "KRAKÓW",
        "30410": "KRAKÓW",
        "30411": "KRAKÓW",
        "30412": "KRAKÓW",
        "30413": "KRAKÓW",
        "30414": "KRAKÓW",
        "30415": "KRAKÓW",
        "30416": "KRAKÓW",
        "30417": "KRAKÓW",
        "30418": "KRAKÓW",
        "30419": "KRAKÓW",
        "30420": "KRAKÓW",
        "30421": "KRAKÓW",
        "30422": "KRAKÓW",
        "30423": "KRAKÓW",
        "30424": "KRAKÓW",
        "30425": "KRAKÓW",
        "30426": "KRAKÓW",
        "30427": "KRAKÓW",
        "30428": "KRAKÓW",
        "30429": "KRAKÓW",
        "30430": "KRAKÓW",
        "30431": "KRAKÓW",
        "30432": "KRAKÓW",
        "30433": "KRAKÓW",
        "30434": "KRAKÓW",
        "30435": "KRAKÓW",
        "30436": "KRAKÓW",
        "30437": "KRAKÓW",
        "30438": "KRAKÓW",
        "30439": "KRAKÓW",
        "30440": "KRAKÓW",
        "30441": "KRAKÓW",
        "30442": "KRAKÓW",
        "30443": "KRAKÓW",
        "30444": "KRAKÓW",
        "30445": "KRAKÓW",
        "30446": "KRAKÓW",
        "30447": "KRAKÓW",
        "30450": "KRAKÓW",
        "30498": "KRAKÓW",
        "30499": "KRAKÓW",
        "30500": "KRAKÓW",
        "30501": "KRAKÓW",
        "30502": "KRAKÓW",
        "30503": "KRAKÓW",
        "30504": "KRAKÓW",
        "30505": "KRAKÓW",
        "30506": "KRAKÓW",
        "30507": "KRAKÓW",
        "30508": "KRAKÓW",
        "30509": "KRAKÓW",
        "30510": "KRAKÓW",
        "30512": "KRAKÓW",
        "30513": "KRAKÓW",
        "30515": "KRAKÓW",
        "30516": "KRAKÓW",
        "30518": "KRAKÓW",
        "30519": "KRAKÓW",
        "30520": "KRAKÓW",
        "30521": "KRAKÓW",
        "30522": "KRAKÓW",
        "30523": "KRAKÓW",
        "30524": "KRAKÓW",
        "30525": "KRAKÓW",
        "30526": "KRAKÓW",
        "30527": "KRAKÓW",
        "30528": "KRAKÓW",
        "30529": "KRAKÓW",
        "30530": "KRAKÓW",
        "30531": "KRAKÓW",
        "30532": "KRAKÓW",
        "30533": "KRAKÓW",
        "30534": "KRAKÓW",
        "30535": "KRAKÓW",
        "30536": "KRAKÓW",
        "30537": "KRAKÓW",
        "30538": "KRAKÓW",
        "30539": "KRAKÓW",
        "30540": "KRAKÓW",
        "30542": "KRAKÓW",
        "30543": "KRAKÓW",
        "30544": "KRAKÓW",
        "30545": "KRAKÓW",
        "30546": "KRAKÓW",
        "30547": "KRAKÓW",
        "30548": "KRAKÓW",
        "30549": "KRAKÓW",
        "30550": "KRAKÓW",
        "30551": "KRAKÓW",
        "30552": "KRAKÓW",
        "30553": "KRAKÓW",
        "30554": "KRAKÓW",
        "30555": "KRAKÓW",
        "30556": "KRAKÓW",
        "30557": "KRAKÓW",
        "30559": "KRAKÓW",
        "30560": "KRAKÓW",
        "30563": "KRAKÓW",
        "30564": "KRAKÓW",
        "30565": "KRAKÓW",
        "30566": "KRAKÓW",
        "30568": "KRAKÓW",
        "30570": "KRAKÓW",
        "30571": "KRAKÓW",
        "30572": "KRAKÓW",
        "30601": "KRAKÓW",
        "30602": "KRAKÓW",
        "30603": "KRAKÓW",
        "30604": "KRAKÓW",
        "30605": "KRAKÓW",
        "30606": "KRAKÓW",
        "30607": "KRAKÓW",
        "30608": "KRAKÓW",
        "30609": "KRAKÓW",
        "30610": "KRAKÓW",
        "30611": "KRAKÓW",
        "30612": "KRAKÓW",
        "30613": "KRAKÓW",
        "30614": "KRAKÓW",
        "30615": "KRAKÓW",
        "30616": "KRAKÓW",
        "30617": "KRAKÓW",
        "30618": "KRAKÓW",
        "30619": "KRAKÓW",
        "30620": "KRAKÓW",
        "30621": "KRAKÓW",
        "30622": "KRAKÓW",
        "30623": "KRAKÓW",
        "30624": "KRAKÓW",
        "30625": "KRAKÓW",
        "30626": "KRAKÓW",
        "30627": "KRAKÓW",
        "30628": "KRAKÓW",
        "30629": "KRAKÓW",
        "30630": "KRAKÓW",
        "30631": "KRAKÓW",
        "30632": "KRAKÓW",
        "30633": "KRAKÓW",
        "30636": "KRAKÓW",
        "30638": "KRAKÓW",
        "30639": "KRAKÓW",
        "30641": "KRAKÓW",
        "30643": "KRAKÓW",
        "30644": "KRAKÓW",
        "30645": "KRAKÓW",
        "30646": "KRAKÓW",
        "30647": "KRAKÓW",
        "30648": "KRAKÓW",
        "30649": "KRAKÓW",
        "30650": "KRAKÓW",
        "30651": "KRAKÓW",
        "30652": "KRAKÓW",
        "30653": "KRAKÓW",
        "30654": "KRAKÓW",
        "30655": "KRAKÓW",
        "30656": "KRAKÓW",
        "30657": "KRAKÓW",
        "30658": "KRAKÓW",
        "30659": "KRAKÓW",
        "30660": "KRAKÓW",
        "30661": "KRAKÓW",
        "30662": "KRAKÓW",
        "30663": "KRAKÓW",
        "30664": "KRAKÓW",
        "30665": "KRAKÓW",
        "30666": "KRAKÓW",
        "30667": "KRAKÓW",
        "30668": "KRAKÓW",
        "30669": "KRAKÓW",
        "30670": "KRAKÓW",
        "30681": "KRAKÓW",
        "30682": "KRAKÓW",
        "30683": "KRAKÓW",
        "30684": "KRAKÓW",
        "30685": "KRAKÓW",
        "30686": "KRAKÓW",
        "30687": "KRAKÓW",
        "30688": "KRAKÓW",
        "30689": "KRAKÓW",
        "30690": "KRAKÓW",
        "30691": "KRAKÓW",
        "30692": "KRAKÓW",
        "30693": "KRAKÓW",
        "30694": "KRAKÓW",
        "30695": "KRAKÓW",
        "30697": "KRAKÓW",
        "30698": "KRAKÓW",
        "30699": "KRAKÓW",
        "30701": "KRAKÓW",
        "30702": "KRAKÓW",
        "30703": "KRAKÓW",
        "30704": "KRAKÓW",
        "30705": "KRAKÓW",
        "30706": "KRAKÓW",
        "30707": "KRAKÓW",
        "30709": "KRAKÓW",
        "30710": "KRAKÓW",
        "30711": "KRAKÓW",
        "30712": "KRAKÓW",
        "30713": "KRAKÓW",
        "30714": "KRAKÓW",
        "30715": "KRAKÓW",
        "30716": "KRAKÓW",
        "30717": "KRAKÓW",
        "30718": "KRAKÓW",
        "30719": "KRAKÓW",
        "30720": "KRAKÓW",
        "30721": "KRAKÓW",
        "30722": "KRAKÓW",
        "30723": "KRAKÓW",
        "30724": "KRAKÓW",
        "30725": "KRAKÓW",
        "30726": "KRAKÓW",
        "30727": "KRAKÓW",
        "30728": "KRAKÓW",
        "30729": "KRAKÓW",
        "30730": "KRAKÓW",
        "30731": "KRAKÓW",
        "30732": "KRAKÓW",
        "30733": "KRAKÓW",
        "30734": "KRAKÓW",
        "30735": "KRAKÓW",
        "30736": "KRAKÓW",
        "30737": "KRAKÓW",
        "30738": "KRAKÓW",
        "30739": "KRAKÓW",
        "30740": "KRAKÓW",
        "30741": "KRAKÓW",
        "30742": "KRAKÓW",
        "30758": "KRAKÓW",
        "30797": "KRAKÓW",
        "30798": "KRAKÓW",
        "30799": "KRAKÓW",
        "30800": "KRAKÓW",
        "30802": "KRAKÓW",
        "30803": "KRAKÓW",
        "30804": "KRAKÓW",
        "30805": "KRAKÓW",
        "30806": "KRAKÓW",
        "30807": "KRAKÓW",
        "30808": "KRAKÓW",
        "30809": "KRAKÓW",
        "30810": "KRAKÓW",
        "30811": "KRAKÓW",
        "30812": "KRAKÓW",
        "30813": "KRAKÓW",
        "30814": "KRAKÓW",
        "30815": "KRAKÓW",
        "30816": "KRAKÓW",
        "30817": "KRAKÓW",
        "30818": "KRAKÓW",
        "30819": "KRAKÓW",
        "30820": "KRAKÓW",
        "30821": "KRAKÓW",
        "30822": "KRAKÓW",
        "30823": "KRAKÓW",
        "30824": "KRAKÓW",
        "30825": "KRAKÓW",
        "30826": "KRAKÓW",
        "30827": "KRAKÓW",
        "30828": "KRAKÓW",
        "30829": "KRAKÓW",
        "30830": "KRAKÓW",
        "30833": "KRAKÓW",
        "30834": "KRAKÓW",
        "30835": "KRAKÓW",
        "30836": "KRAKÓW",
        "30837": "KRAKÓW",
        "30838": "KRAKÓW",
        "30851": "KRAKÓW",
        "30852": "KRAKÓW",
        "30853": "KRAKÓW",
        "30854": "KRAKÓW",
        "30855": "KRAKÓW",
        "30856": "KRAKÓW",
        "30857": "KRAKÓW",
        "30858": "KRAKÓW",
        "30860": "KRAKÓW",
        "30863": "KRAKÓW",
        "30864": "KRAKÓW",
        "30865": "KRAKÓW",
        "30867": "KRAKÓW",
        "30868": "KRAKÓW",
        "30870": "KRAKÓW",
        "30898": "KRAKÓW",
        "30899": "KRAKÓW",
        "30900": "KRAKÓW",
        "30901": "KRAKÓW",
        "30902": "KRAKÓW",
        "30940": "KRAKÓW",
        "30942": "KRAKÓW",
        "30950": "KRAKÓW",
        "30951": "KRAKÓW",
        "30952": "KRAKÓW",
        "30953": "KRAKÓW",
        "30954": "KRAKÓW",
        "30955": "KRAKÓW",
        "30956": "KRAKÓW",
        "30960": "KRAKÓW",
        "30961": "KRAKÓW",
        "30962": "KRAKÓW",
        "31000": "KRAKÓW",
        "31001": "KRAKÓW",
        "31002": "KRAKÓW",
        "31003": "KRAKÓW",
        "31004": "KRAKÓW",
        "31005": "KRAKÓW",
        "31006": "KRAKÓW",
        "31007": "KRAKÓW",
        "31008": "KRAKÓW",
        "31009": "KRAKÓW",
        "31010": "KRAKÓW",
        "31011": "KRAKÓW",
        "31012": "KRAKÓW",
        "31013": "KRAKÓW",
        "31014": "KRAKÓW",
        "31015": "KRAKÓW",
        "31016": "KRAKÓW",
        "31017": "KRAKÓW",
        "31018": "KRAKÓW",
        "31019": "KRAKÓW",
        "31020": "KRAKÓW",
        "31021": "KRAKÓW",
        "31022": "KRAKÓW",
        "31023": "KRAKÓW",
        "31024": "KRAKÓW",
        "31025": "KRAKÓW",
        "31026": "KRAKÓW",
        "31027": "KRAKÓW",
        "31028": "KRAKÓW",
        "31029": "KRAKÓW",
        "31030": "KRAKÓW",
        "31031": "KRAKÓW",
        "31032": "KRAKÓW",
        "31033": "KRAKÓW",
        "31034": "KRAKÓW",
        "31035": "KRAKÓW",
        "31036": "KRAKÓW",
        "31037": "KRAKÓW",
        "31038": "KRAKÓW",
        "31039": "KRAKÓW",
        "31041": "KRAKÓW",
        "31042": "KRAKÓW",
        "31043": "KRAKÓW",
        "31044": "KRAKÓW",
        "31045": "KRAKÓW",
        "31046": "KRAKÓW",
        "31047": "KRAKÓW",
        "31048": "KRAKÓW",
        "31049": "KRAKÓW",
        "31050": "KRAKÓW",
        "31051": "KRAKÓW",
        "31052": "KRAKÓW",
        "31053": "KRAKÓW",
        "31054": "KRAKÓW",
        "31055": "KRAKÓW",
        "31056": "KRAKÓW",
        "31057": "KRAKÓW",
        "31058": "KRAKÓW",
        "31059": "KRAKÓW",
        "31060": "KRAKÓW",
        "31061": "KRAKÓW",
        "31062": "KRAKÓW",
        "31063": "KRAKÓW",
        "31064": "KRAKÓW",
        "31065": "KRAKÓW",
        "31066": "KRAKÓW",
        "31067": "KRAKÓW",
        "31068": "KRAKÓW",
        "31069": "KRAKÓW",
        "31070": "KRAKÓW",
        "31071": "KRAKÓW",
        "31072": "KRAKÓW",
        "31073": "KRAKÓW",
        "31075": "KRAKÓW",
        "31080": "KRAKÓW",
        "31100": "KRAKÓW",
        "31101": "KRAKÓW",
        "31102": "KRAKÓW",
        "31103": "KRAKÓW",
        "31104": "KRAKÓW",
        "31105": "KRAKÓW",
        "31106": "KRAKÓW",
        "31107": "KRAKÓW",
        "31108": "KRAKÓW",
        "31109": "KRAKÓW",
        "31110": "KRAKÓW",
        "31111": "KRAKÓW",
        "31112": "KRAKÓW",
        "31113": "KRAKÓW",
        "31114": "KRAKÓW",
        "31115": "KRAKÓW",
        "31116": "KRAKÓW",
        "31117": "KRAKÓW",
        "31118": "KRAKÓW",
        "31120": "KRAKÓW",
        "31121": "KRAKÓW",
        "31123": "KRAKÓW",
        "31124": "KRAKÓW",
        "31126": "KRAKÓW",
        "31127": "KRAKÓW",
        "31128": "KRAKÓW",
        "31130": "KRAKÓW",
        "31131": "KRAKÓW",
        "31132": "KRAKÓW",
        "31133": "KRAKÓW",
        "31134": "KRAKÓW",
        "31135": "KRAKÓW",
        "31136": "KRAKÓW",
        "31137": "KRAKÓW",
        "31138": "KRAKÓW",
        "31139": "KRAKÓW",
        "31140": "KRAKÓW",
        "31141": "KRAKÓW",
        "31142": "KRAKÓW",
        "31143": "KRAKÓW",
        "31144": "KRAKÓW",
        "31145": "KRAKÓW",
        "31146": "KRAKÓW",
        "31147": "KRAKÓW",
        "31148": "KRAKÓW",
        "31149": "KRAKÓW",
        "31150": "KRAKÓW",
        "31151": "KRAKÓW",
        "31152": "KRAKÓW",
        "31153": "KRAKÓW",
        "31154": "KRAKÓW",
        "31155": "KRAKÓW",
        "31156": "KRAKÓW",
        "31157": "KRAKÓW",
        "31158": "KRAKÓW",
        "31159": "KRAKÓW",
        "31160": "KRAKÓW",
        "31161": "KRAKÓW",
        "31162": "KRAKÓW",
        "31200": "KRAKÓW",
        "31201": "KRAKÓW",
        "31202": "KRAKÓW",
        "31203": "KRAKÓW",
        "31207": "KRAKÓW",
        "31209": "KRAKÓW",
        "31210": "KRAKÓW",
        "31212": "KRAKÓW",
        "31213": "KRAKÓW",
        "31214": "KRAKÓW",
        "31215": "KRAKÓW",
        "31216": "KRAKÓW",
        "31217": "KRAKÓW",
        "31218": "KRAKÓW",
        "31220": "KRAKÓW",
        "31221": "KRAKÓW",
        "31222": "KRAKÓW",
        "31223": "KRAKÓW",
        "31224": "KRAKÓW",
        "31225": "KRAKÓW",
        "31226": "KRAKÓW",
        "31227": "KRAKÓW",
        "31228": "KRAKÓW",
        "31229": "KRAKÓW",
        "31230": "KRAKÓW",
        "31231": "KRAKÓW",
        "31232": "KRAKÓW",
        "31233": "KRAKÓW",
        "31234": "KRAKÓW",
        "31235": "KRAKÓW",
        "31236": "KRAKÓW",
        "31241": "KRAKÓW",
        "31242": "KRAKÓW",
        "31261": "KRAKÓW",
        "31262": "KRAKÓW",
        "31263": "KRAKÓW",
        "31264": "KRAKÓW",
        "31265": "KRAKÓW",
        "31266": "KRAKÓW",
        "31267": "KRAKÓW",
        "31268": "KRAKÓW",
        "31269": "KRAKÓW",
        "31270": "KRAKÓW",
        "31271": "KRAKÓW",
        "31272": "KRAKÓW",
        "31273": "KRAKÓW",
        "31274": "KRAKÓW",
        "31275": "KRAKÓW",
        "31276": "KRAKÓW",
        "31277": "KRAKÓW",
        "31278": "KRAKÓW",
        "31279": "KRAKÓW",
        "31280": "KRAKÓW",
        "31300": "KRAKÓW",
        "31301": "KRAKÓW",
        "31302": "KRAKÓW",
        "31303": "KRAKÓW",
        "31305": "KRAKÓW",
        "31306": "KRAKÓW",
        "31307": "KRAKÓW",
        "31308": "KRAKÓW",
        "31309": "KRAKÓW",
        "31310": "KRAKÓW",
        "31311": "KRAKÓW",
        "31312": "KRAKÓW",
        "31313": "KRAKÓW",
        "31314": "KRAKÓW",
        "31315": "KRAKÓW",
        "31316": "KRAKÓW",
        "31317": "KRAKÓW",
        "31318": "KRAKÓW",
        "31319": "KRAKÓW",
        "31320": "KRAKÓW",
        "31321": "KRAKÓW",
        "31322": "KRAKÓW",
        "31323": "KRAKÓW",
        "31324": "KRAKÓW",
        "31325": "KRAKÓW",
        "31326": "KRAKÓW",
        "31327": "KRAKÓW",
        "31328": "KRAKÓW",
        "31329": "KRAKÓW",
        "31330": "KRAKÓW",
        "31331": "KRAKÓW",
        "31332": "KRAKÓW",
        "31333": "KRAKÓW",
        "31334": "KRAKÓW",
        "31335": "KRAKÓW",
        "31336": "KRAKÓW",
        "31337": "KRAKÓW",
        "31338": "KRAKÓW",
        "31339": "KRAKÓW",
        "31340": "KRAKÓW",
        "31341": "KRAKÓW",
        "31342": "KRAKÓW",
        "31343": "KRAKÓW",
        "31344": "KRAKÓW",
        "31345": "KRAKÓW",
        "31346": "KRAKÓW",
        "31347": "KRAKÓW",
        "31348": "KRAKÓW",
        "31349": "KRAKÓW",
        "31350": "KRAKÓW",
        "31351": "KRAKÓW",
        "31352": "KRAKÓW",
        "31353": "KRAKÓW",
        "31354": "KRAKÓW",
        "31355": "KRAKÓW",
        "31357": "KRAKÓW",
        "31358": "KRAKÓW",
        "31398": "KRAKÓW",
        "31401": "KRAKÓW",
        "31402": "KRAKÓW",
        "31403": "KRAKÓW",
        "31404": "KRAKÓW",
        "31406": "KRAKÓW",
        "31408": "KRAKÓW",
        "31409": "KRAKÓW",
        "31410": "KRAKÓW",
        "31411": "KRAKÓW",
        "31413": "KRAKÓW",
        "31414": "KRAKÓW",
        "31416": "KRAKÓW",
        "31417": "KRAKÓW",
        "31418": "KRAKÓW",
        "31419": "KRAKÓW",
        "31420": "KRAKÓW",
        "31421": "KRAKÓW",
        "31422": "KRAKÓW",
        "31423": "KRAKÓW",
        "31424": "KRAKÓW",
        "31425": "KRAKÓW",
        "31426": "KRAKÓW",
        "31428": "KRAKÓW",
        "31429": "KRAKÓW",
        "31431": "KRAKÓW",
        "31432": "KRAKÓW",
        "31435": "KRAKÓW",
        "31436": "KRAKÓW",
        "31443": "KRAKÓW",
        "31444": "KRAKÓW",
        "31445": "KRAKÓW",
        "31446": "KRAKÓW",
        "31450": "KRAKÓW",
        "31452": "KRAKÓW",
        "31455": "KRAKÓW",
        "31456": "KRAKÓW",
        "31457": "KRAKÓW",
        "31460": "KRAKÓW",
        "31461": "KRAKÓW",
        "31462": "KRAKÓW",
        "31463": "KRAKÓW",
        "31464": "KRAKÓW",
        "31465": "KRAKÓW",
        "31466": "KRAKÓW",
        "31467": "KRAKÓW",
        "31469": "KRAKÓW",
        "31470": "KRAKÓW",
        "31471": "KRAKÓW",
        "31474": "KRAKÓW",
        "31475": "KRAKÓW",
        "31476": "KRAKÓW",
        "31477": "KRAKÓW",
        "31478": "KRAKÓW",
        "31479": "KRAKÓW",
        "31480": "KRAKÓW",
        "31481": "KRAKÓW",
        "31482": "KRAKÓW",
        "31500": "KRAKÓW",
        "31501": "KRAKÓW",
        "31502": "KRAKÓW",
        "31503": "KRAKÓW",
        "31504": "KRAKÓW",
        "31505": "KRAKÓW",
        "31506": "KRAKÓW",
        "31507": "KRAKÓW",
        "31508": "KRAKÓW",
        "31509": "KRAKÓW",
        "31510": "KRAKÓW",
        "31511": "KRAKÓW",
        "31512": "KRAKÓW",
        "31513": "KRAKÓW",
        "31514": "KRAKÓW",
        "31515": "KRAKÓW",
        "31516": "KRAKÓW",
        "31517": "KRAKÓW",
        "31518": "KRAKÓW",
        "31519": "KRAKÓW",
        "31520": "KRAKÓW",
        "31521": "KRAKÓW",
        "31523": "KRAKÓW",
        "31524": "KRAKÓW",
        "31525": "KRAKÓW",
        "31526": "KRAKÓW",
        "31527": "KRAKÓW",
        "31529": "KRAKÓW",
        "31530": "KRAKÓW",
        "31531": "KRAKÓW",
        "31532": "KRAKÓW",
        "31534": "KRAKÓW",
        "31535": "KRAKÓW",
        "31536": "KRAKÓW",
        "31537": "KRAKÓW",
        "31538": "KRAKÓW",
        "31539": "KRAKÓW",
        "31540": "KRAKÓW",
        "31541": "KRAKÓW",
        "31542": "KRAKÓW",
        "31543": "KRAKÓW",
        "31545": "KRAKÓW",
        "31546": "KRAKÓW",
        "31547": "KRAKÓW",
        "31548": "KRAKÓW",
        "31550": "KRAKÓW",
        "31552": "KRAKÓW",
        "31553": "KRAKÓW",
        "31557": "KRAKÓW",
        "31559": "KRAKÓW",
        "31560": "KRAKÓW",
        "31563": "KRAKÓW",
        "31564": "KRAKÓW",
        "31566": "KRAKÓW",
        "31567": "KRAKÓW",
        "31571": "KRAKÓW",
        "31572": "KRAKÓW",
        "31573": "KRAKÓW",
        "31574": "KRAKÓW",
        "31579": "KRAKÓW",
        "31580": "KRAKÓW",
        "31581": "KRAKÓW",
        "31586": "KRAKÓW",
        "31587": "KRAKÓW",
        "31588": "KRAKÓW",
        "31589": "KRAKÓW",
        "31603": "KRAKÓW",
        "31604": "KRAKÓW",
        "31605": "KRAKÓW",
        "31606": "KRAKÓW",
        "31607": "KRAKÓW",
        "31608": "KRAKÓW",
        "31609": "KRAKÓW",
        "31610": "KRAKÓW",
        "31611": "KRAKÓW",
        "31612": "KRAKÓW",
        "31615": "KRAKÓW",
        "31616": "KRAKÓW",
        "31617": "KRAKÓW",
        "31618": "KRAKÓW",
        "31619": "KRAKÓW",
        "31620": "KRAKÓW",
        "31621": "KRAKÓW",
        "31622": "KRAKÓW",
        "31623": "KRAKÓW",
        "31624": "KRAKÓW",
        "31625": "KRAKÓW",
        "31626": "KRAKÓW",
        "31628": "KRAKÓW",
        "31630": "KRAKÓW",
        "31634": "KRAKÓW",
        "31635": "KRAKÓW",
        "31636": "KRAKÓW",
        "31637": "KRAKÓW",
        "31638": "KRAKÓW",
        "31640": "KRAKÓW",
        "31643": "KRAKÓW",
        "31644": "KRAKÓW",
        "31651": "KRAKÓW",
        "31670": "KRAKÓW",
        "31701": "KRAKÓW",
        "31702": "KRAKÓW",
        "31703": "KRAKÓW",
        "31704": "KRAKÓW",
        "31705": "KRAKÓW",
        "31706": "KRAKÓW",
        "31707": "KRAKÓW",
        "31708": "KRAKÓW",
        "31709": "KRAKÓW",
        "31710": "KRAKÓW",
        "31711": "KRAKÓW",
        "31712": "KRAKÓW",
        "31721": "KRAKÓW",
        "31722": "KRAKÓW",
        "31723": "KRAKÓW",
        "31724": "KRAKÓW",
        "31725": "KRAKÓW",
        "31726": "KRAKÓW",
        "31727": "KRAKÓW",
        "31750": "KRAKÓW",
        "31751": "KRAKÓW",
        "31752": "KRAKÓW",
        "31753": "KRAKÓW",
        "31754": "KRAKÓW",
        "31761": "KRAKÓW",
        "31762": "KRAKÓW",
        "31763": "KRAKÓW",
        "31764": "KRAKÓW",
        "31765": "KRAKÓW",
        "31766": "KRAKÓW",
        "31767": "KRAKÓW",
        "31768": "KRAKÓW",
        "31800": "KRAKÓW",
        "31801": "KRAKÓW",
        "31802": "KRAKÓW",
        "31803": "KRAKÓW",
        "31804": "KRAKÓW",
        "31807": "KRAKÓW",
        "31808": "KRAKÓW",
        "31809": "KRAKÓW",
        "31810": "KRAKÓW",
        "31812": "KRAKÓW",
        "31813": "KRAKÓW",
        "31814": "KRAKÓW",
        "31815": "KRAKÓW",
        "31816": "KRAKÓW",
        "31818": "KRAKÓW",
        "31819": "KRAKÓW",
        "31820": "KRAKÓW",
        "31825": "KRAKÓW",
        "31826": "KRAKÓW",
        "31827": "KRAKÓW",
        "31828": "KRAKÓW",
        "31829": "KRAKÓW",
        "31831": "KRAKÓW",
        "31832": "KRAKÓW",
        "31833": "KRAKÓW",
        "31834": "KRAKÓW",
        "31835": "KRAKÓW",
        "31836": "KRAKÓW",
        "31837": "KRAKÓW",
        "31839": "KRAKÓW",
        "31840": "KRAKÓW",
        "31841": "KRAKÓW",
        "31842": "KRAKÓW",
        "31843": "KRAKÓW",
        "31844": "KRAKÓW",
        "31845": "KRAKÓW",
        "31850": "KRAKÓW",
        "31851": "KRAKÓW",
        "31852": "KRAKÓW",
        "31853": "KRAKÓW",
        "31854": "KRAKÓW",
        "31855": "KRAKÓW",
        "31858": "KRAKÓW",
        "31859": "KRAKÓW",
        "31860": "KRAKÓW",
        "31861": "KRAKÓW",
        "31862": "KRAKÓW",
        "31863": "KRAKÓW",
        "31864": "KRAKÓW",
        "31865": "KRAKÓW",
        "31866": "KRAKÓW",
        "31867": "KRAKÓW",
        "31868": "KRAKÓW",
        "31869": "KRAKÓW",
        "31870": "KRAKÓW",
        "31871": "KRAKÓW",
        "31872": "KRAKÓW",
        "31873": "KRAKÓW",
        "31874": "KRAKÓW",
        "31875": "KRAKÓW",
        "31876": "KRAKÓW",
        "31880": "KRAKÓW",
        "31881": "KRAKÓW",
        "31901": "KRAKÓW",
        "31902": "KRAKÓW",
        "31903": "KRAKÓW",
        "31905": "KRAKÓW",
        "31906": "KRAKÓW",
        "31907": "KRAKÓW",
        "31908": "KRAKÓW",
        "31909": "KRAKÓW",
        "31910": "KRAKÓW",
        "31911": "KRAKÓW",
        "31912": "KRAKÓW",
        "31913": "KRAKÓW",
        "31914": "KRAKÓW",
        "31915": "KRAKÓW",
        "31916": "KRAKÓW",
        "31917": "KRAKÓW",
        "31918": "KRAKÓW",
        "31919": "KRAKÓW",
        "31920": "KRAKÓW",
        "31921": "KRAKÓW",
        "31922": "KRAKÓW",
        "31923": "KRAKÓW",
        "31924": "KRAKÓW",
        "31925": "KRAKÓW",
        "31926": "KRAKÓW",
        "31927": "KRAKÓW",
        "31928": "KRAKÓW",
        "31929": "KRAKÓW",
        "31930": "KRAKÓW",
        "31931": "KRAKÓW",
        "31932": "KRAKÓW",
        "31933": "KRAKÓW",
        "31934": "KRAKÓW",
        "31935": "KRAKÓW",
        "31936": "KRAKÓW",
        "31937": "KRAKÓW",
        "31938": "KRAKÓW",
        "31939": "KRAKÓW",
        "31940": "KRAKÓW",
        "31941": "KRAKÓW",
        "31942": "KRAKÓW",
        "31943": "KRAKÓW",
        "31944": "KRAKÓW",
        "31945": "KRAKÓW",
        "31946": "KRAKÓW",
        "31947": "KRAKÓW",
        "31948": "KRAKÓW",
        "31949": "KRAKÓW",
        "31950": "KRAKÓW",
        "31951": "KRAKÓW",
        "31952": "KRAKÓW",
        "31953": "KRAKÓW",
        "31954": "KRAKÓW",
        "31955": "KRAKÓW",
        "31956": "KRAKÓW",
        "31957": "KRAKÓW",
        "31958": "KRAKÓW",
        "31959": "KRAKÓW",
        "31960": "KRAKÓW",
        "31961": "KRAKÓW",
        "31962": "KRAKÓW",
        "31963": "KRAKÓW",
        "31964": "KRAKÓW",
        "31965": "KRAKÓW",
        "31966": "KRAKÓW",
        "31967": "KRAKÓW",
        "31968": "KRAKÓW",
        "31969": "KRAKÓW",
        "31970": "KRAKÓW",
        "31971": "KRAKÓW",
        "31972": "KRAKÓW",
        "31974": "KRAKÓW",
        "31975": "KRAKÓW",
        "31976": "KRAKÓW",
        "31977": "KRAKÓW",
        "31978": "KRAKÓW",
        "31979": "KRAKÓW",
        "31980": "KRAKÓW",
        "31981": "KRAKÓW",
        "31982": "KRAKÓW",
        "31983": "KRAKÓW",
        "31985": "KRAKÓW",
        "31987": "KRAKÓW",
        "31988": "KRAKÓW",
        "31989": "KRAKÓW",
        "31990": "KRAKÓW",
        "31992": "KRAKÓW",
        "31997": "KRAKÓW",
        "31998": "KRAKÓW",
        "31999": "KRAKÓW",
        "32002": "WIELICZKA",
        "32003": "WIELICZKA",
        "32005": "NIEPOŁOMICE",
        "32007": "WIELICZKA",
        "32010": "KRAKÓW",
        "32013": "WIELICZKA",
        "32014": "BRZEZIE",
        "32015": "WIELICZKA",
        "32020": "WIELICZKA",
        "32031": "KRAKÓW",
        "32040": "KRAKÓW",
        "32043": "KRAKÓW",
        "32045": "KRAKÓW",
        "32046": "KRAKÓW",
        "32047": "KRAKÓW",
        "32048": "KRAKÓW",
        "32049": "KRAKÓW",
        "32050": "SKAWINA",
        "32051": "KRAKÓW",
        "32052": "KRAKÓW",
        "32053": "KRAKÓW",
        "32060": "KRAKÓW",
        "32061": "KRAKÓW",
        "32064": "KRAKÓW",
        "32065": "KRAKÓW",
        "32067": "KRAKÓW",
        "32070": "KRAKÓW",
        "32071": "KRAKÓW",
        "32075": "MIECHÓW",
        "32077": "KRAKÓW",
        "32080": "ZABIERZÓW",
        "32082": "KRAKÓW",
        "32083": "KRAKÓW",
        "32084": "KRAKÓW",
        "32085": "KRAKÓW",
        "32086": "KRAKÓW",
        "32087": "KRAKÓW",
        "32088": "KRAKÓW",
        "32089": "KRAKÓW",
        "32090": "KRAKÓW",
        "32091": "KRAKÓW",
        "32095": "KRAKÓW",
        "32100": "PROSZOWICE",
        "32101": "PROSZOWICE",
        "32104": "PROSZOWICE",
        "32107": "PROSZOWICE",
        "32109": "PROSZOWICE",
        "32112": "PROSZOWICE",
        "32120": "PROSZOWICE",
        "32125": "KRAKÓW",
        "32126": "KRAKÓW",
        "32130": "PROSZOWICE",
        "32200": "MIECHÓW",
        "32210": "MIECHÓW",
        "32218": "MIECHÓW",
        "32222": "MIECHÓW",
        "32241": "MIECHÓW",
        "32250": "MIECHÓW",
        "32300": "OLKUSZ",
        "32302": "OLKUSZ",
        "32305": "OLKUSZ",
        "32306": "OLKUSZ",
        "32310": "OLKUSZ",
        "32312": "OLKUSZ",
        "32327": "OLKUSZ",
        "32329": "OLKUSZ",
        "32332": "OLKUSZ",
        "32340": "WOLBROM",
        "32341": "OLKUSZ",
        "32342": "OLKUSZ",
        "32353": "OLKUSZ",
        "32354": "OLKUSZ",
        "32400": "MYŚLENICE",
        "32406": "MYŚLENICE",
        "32410": "MYŚLENICE",
        "32412": "MYŚLENICE",
        "32413": "MYŚLENICE",
        "32414": "MYŚLENICE",
        "32415": "MYŚLENICE",
        "32420": "WIELICZKA",
        "32422": "MYŚLENICE",
        "32425": "MYŚLENICE",
        "32431": "MYŚLENICE",
        "32432": "PCIM",
        "32433": "MYŚLENICE",
        "32434": "MYŚLENICE",
        "32435": "MYŚLENICE",
        "32436": "MYŚLENICE",
        "32437": "MYŚLENICE",
        "32438": "MYŚLENICE",
        "32440": "SUŁKOWICE",
        "32442": "MYŚLENICE",
        "32444": "MYŚLENICE",
        "32445": "MYŚLENICE",
        "32447": "MYŚLENICE",
        "32500": "CHRZANÓW",
        "32501": "CHRZANÓW",
        "32502": "CHRZANÓW",
        "32503": "CHRZANÓW",
        "32530": "TRZEBINIA",
        "32540": "TRZEBINIA",
        "32541": "TRZEBINIA",
        "32543": "CHRZANÓW",
        "32545": "CHRZANÓW",
        "32546": "CHRZANÓW",
        "32551": "CHRZANÓW",
        "32552": "CHRZANÓW",
        "32555": "CHRZANÓW",
        "32566": "CHRZANÓW",
        "32590": "LIBIĄŻ",
        "32591": "CHRZANÓW",
        "32592": "LIBIĄŻ",
        "32593": "LIBIĄŻ",
        "32600": "OŚWIĘCIM",
        "32601": "OŚWIĘCIM",
        "32602": "OŚWIĘCIM",
        "32603": "OŚWIĘCIM",
        "32606": "OŚWIĘCIM",
        "32607": "OŚWIĘCIM",
        "32608": "OŚWIĘCIM",
        "32610": "OŚWIĘCIM",
        "32615": "OŚWIĘCIM",
        "32620": "BRZESZCZE",
        "32621": "BRZESZCZE",
        "32622": "BRZESZCZE",
        "32625": "OŚWIĘCIM",
        "32626": "OŚWIĘCIM",
        "32640": "OŚWIĘCIM",
        "32641": "OŚWIĘCIM",
        "32642": "OŚWIĘCIM",
        "32650": "KĘTY",
        "32651": "OŚWIĘCIM",
        "32652": "OŚWIĘCIM",
        "32653": "KĘTY",
        "32660": "CHEŁMEK",
        "32661": "OŚWIĘCIM",
        "32700": "BOCHNIA",
        "32701": "BOCHNIA",
        "32708": "BOCHNIA",
        "32709": "BOCHNIA",
        "32711": "BOCHNIA",
        "32712": "BOCHNIA",
        "32720": "BOCHNIA",
        "32722": "BOCHNIA",
        "32724": "BOCHNIA",
        "32725": "BOCHNIA",
        "32731": "BOCHNIA",
        "32732": "BOCHNIA",
        "32733": "BOCHNIA",
        "32740": "BOCHNIA",
        "32741": "BOCHNIA",
        "32742": "BOCHNIA",
        "32744": "BOCHNIA",
        "32765": "BOCHNIA",
        "32800": "BRZESKO",
        "32810": "BRZESKO",
        "32813": "BRZESKO",
        "32820": "BRZESKO",
        "32821": "BRZESKO",
        "32822": "BRZESKO",
        "32823": "BRZESKO",
        "32824": "BRZESKO",
        "32825": "BRZESKO",
        "32828": "BRZESKO",
        "32830": "TARNÓW",
        "32831": "TARNÓW",
        "32840": "TARNÓW",
        "32841": "TARNÓW",
        "32842": "TARNÓW",
        "32851": "BRZESKO",
        "32852": "BRZESKO",
        "32853": "BRZESKO",
        "32854": "BRZESKO",
        "32855": "TARNÓW",
        "32859": "BRZESKO",
        "32860": "BRZESKO",
        "32861": "BRZESKO",
        "32862": "BRZESKO",
        "32863": "BRZESKO",
        "32864": "BRZESKO",
        "32865": "BRZESKO",
        "33100": "TARNÓW",
        "33101": "TARNÓW",
        "33102": "TARNÓW",
        "33103": "TARNÓW",
        "33104": "TARNÓW",
        "33105": "TARNÓW",
        "33106": "TARNÓW",
        "33107": "TARNÓW",
        "33110": "TARNÓW",
        "33111": "TARNÓW",
        "33112": "TARNÓW",
        "33113": "TARNÓW",
        "33114": "TARNÓW",
        "33115": "TARNÓW",
        "33121": "TARNÓW",
        "33122": "TARNÓW",
        "33130": "TARNÓW",
        "33131": "TARNÓW",
        "33132": "TARNÓW",
        "33133": "TARNÓW",
        "33140": "TARNÓW",
        "33150": "TARNÓW",
        "33151": "TARNÓW",
        "33152": "TARNÓW",
        "33156": "TARNÓW",
        "33157": "TARNÓW",
        "33158": "TARNÓW",
        "33159": "TARNÓW",
        "33160": "TARNÓW",
        "33161": "TARNÓW",
        "33162": "TARNÓW",
        "33163": "TARNÓW",
        "33164": "TARNÓW",
        "33167": "TARNÓW",
        "33170": "TUCHÓW",
        "33171": "TARNÓW",
        "33172": "TARNÓW",
        "33173": "TARNÓW",
        "33180": "TARNÓW",
        "33181": "TARNÓW",
        "33182": "TARNÓW",
        "33190": "TARNÓW",
        "33191": "TARNÓW",
        "33192": "TARNÓW",
        "33200": "DĄBROWA TARNOWSKA",
        "33202": "DĄBROWA TARNOWSKA",
        "33203": "DĄBROWA TARNOWSKA",
        "33204": "DĄBROWA TARNOWSKA",
        "33205": "DĄBROWA TARNOWSKA",
        "33206": "DĄBROWA TARNOWSKA",
        "33207": "DĄBROWA TARNOWSKA",
        "33210": "DĄBROWA TARNOWSKA",
        "33220": "DĄBROWA TARNOWSKA",
        "33221": "DĄBROWA TARNOWSKA",
        "33230": "DĄBROWA TARNOWSKA",
        "33240": "TARNÓW",
        "33250": "TARNÓW",
        "33251": "TARNÓW",
        "33260": "DĄBROWA TARNOWSKA",
        "33262": "DĄBROWA TARNOWSKA",
        "33263": "DĄBROWA TARNOWSKA",
        "33264": "DĄBROWA TARNOWSKA",
        "33270": "TARNÓW",
        "33271": "TARNÓW",
        "33273": "TARNÓW",
        "33300": "NOWY SĄCZ",
        "33302": "NOWY SĄCZ",
        "33303": "NOWY SĄCZ",
        "33304": "NOWY SĄCZ",
        "33305": "NOWY SĄCZ",
        "33306": "NOWY SĄCZ",
        "33307": "NOWY SĄCZ",
        "33310": "NOWY SĄCZ",
        "33311": "NOWY SĄCZ",
        "33312": "NOWY SĄCZ",
        "33314": "NOWY SĄCZ",
        "33316": "NOWY SĄCZ",
        "33318": "NOWY SĄCZ",
        "33320": "NOWY SĄCZ",
        "33321": "NOWY SĄCZ",
        "33322": "NOWY SĄCZ",
        "33323": "NOWY SĄCZ",
        "33325": "NOWY SĄCZ",
        "33326": "NOWY SĄCZ",
        "33330": "NOWY SĄCZ",
        "33331": "NOWY SĄCZ",
        "33332": "NOWY SĄCZ",
        "33333": "NOWY SĄCZ",
        "33334": "NOWY SĄCZ",
        "33335": "NOWY SĄCZ",
        "33336": "NOWY SĄCZ",
        "33340": "NOWY SĄCZ",
        "33342": "NOWY SĄCZ",
        "33343": "NOWY SĄCZ",
        "33350": "NOWY SĄCZ",
        "33351": "NOWY SĄCZ",
        "33360": "NOWY SĄCZ",
        "33370": "MUSZYNA",
        "33380": "KRYNICA-ZDRÓJ",
        "33383": "NOWY SĄCZ",
        "33386": "NOWY SĄCZ",
        "33388": "NOWY SĄCZ",
        "33389": "NOWY SĄCZ",
        "33390": "NOWY SĄCZ",
        "33393": "NOWY SĄCZ",
        "33394": "NOWY SĄCZ",
        "33395": "NOWY SĄCZ",
        "34100": "WADOWICE (NET)",
        "34103": "WADOWICE (NET)",
        "34104": "WADOWICE (NET)",
        "34105": "WADOWICE (NET)",
        "34106": "WADOWICE (NET)",
        "34108": "WADOWICE (NET)",
        "34112": "WADOWICE",
        "34113": "WADOWICE",
        "34114": "WADOWICE",
        "34115": "WADOWICE (NET)",
        "34116": "WADOWICE (NET)",
        "34120": "ANDRYCHÓW",
        "34121": "WADOWICE",
        "34122": "WADOWICE (NET)",
        "34123": "WADOWICE (NET)",
        "34124": "WADOWICE (NET)",
        "34125": "WADOWICE (NET)",
        "34130": "KALWARIA ZEBRZYDOWSKA",
        "34141": "WADOWICE",
        "34142": "WADOWICE",
        "34143": "WADOWICE (NET)",
        "34144": "WADOWICE",
        "34145": "WADOWICE (NET)",
        "34146": "WADOWICE (NET)",
        "34200": "SUCHA BESKIDZKA",
        "34205": "SUCHA BESKIDZKA",
        "34206": "SUCHA BESKIDZKA",
        "34210": "SUCHA BESKIDZKA",
        "34211": "SUCHA BESKIDZKA",
        "34212": "SUCHA BESKIDZKA",
        "34220": "SUCHA BESKIDZKA",
        "34221": "SUCHA BESKIDZKA",
        "34222": "SUCHA BESKIDZKA",
        "34231": "SUCHA BESKIDZKA",
        "34232": "SUCHA BESKIDZKA",
        "34233": "SUCHA BESKIDZKA",
        "34234": "SUCHA BESKIDZKA",
        "34235": "SUCHA BESKIDZKA",
        "34236": "SUCHA BESKIDZKA",
        "34240": "JORDANÓW",
        "34242": "SUCHA BESKIDZKA",
        "34300": "ŻYWIEC",
        "34310": "ŻYWIEC",
        "34311": "ŻYWIEC",
        "34312": "ŻYWIEC",
        "34315": "ŻYWIEC",
        "34321": "ŻYWIEC",
        "34322": "ŻYWIEC",
        "34323": "ŻYWIEC",
        "34324": "ŻYWIEC",
        "34325": "ŻYWIEC",
        "34326": "ŻYWIEC",
        "34330": "ŻYWIEC",
        "34331": "ŻYWIEC",
        "34332": "ŻYWIEC",
        "34335": "ŻYWIEC",
        "34340": "ŻYWIEC",
        "34341": "ŻYWIEC",
        "34350": "ŻYWIEC",
        "34360": "ŻYWIEC",
        "34370": "ŻYWIEC",
        "34371": "ŻYWIEC",
        "34373": "ŻYWIEC",
        "34381": "ŻYWIEC",
        "34382": "ŻYWIEC",
        "34383": "ŻYWIEC",
        "34400": "NOWY TARG",
        "34401": "NOWY TARG",
        "34402": "NOWY TARG",
        "34403": "NOWY TARG",
        "34404": "NOWY TARG",
        "34405": "ZAKOPANE",
        "34406": "ZAKOPANE",
        "34407": "NOWY TARG",
        "34408": "NOWY TARG",
        "34424": "NOWY TARG",
        "34425": "ZAKOPANE",
        "34431": "NOWY TARG",
        "34432": "NOWY TARG",
        "34433": "NOWY TARG",
        "34434": "NOWY TARG",
        "34435": "NOWY TARG",
        "34436": "NOWY TARG",
        "34440": "NOWY TARG",
        "34441": "NOWY TARG",
        "34442": "NOWY TARG",
        "34443": "NOWY TARG",
        "34445": "NOWY TARG",
        "34450": "NOWY TARG",
        "34451": "NOWY TARG",
        "34452": "NOWY TARG",
        "34453": "NOWY TARG",
        "34460": "SZCZAWNICA",
        "34470": "NOWY TARG",
        "34471": "NOWY TARG",
        "34472": "NOWY TARG",
        "34480": "NOWY TARG",
        "34481": "NOWY TARG",
        "34482": "NOWY TARG",
        "34483": "NOWY TARG",
        "34484": "NOWY TARG",
        "34500": "ZAKOPANE",
        "34501": "ZAKOPANE",
        "34502": "ZAKOPANE",
        "34503": "ZAKOPANE",
        "34505": "ZAKOPANE",
        "34511": "ZAKOPANE",
        "34512": "ZAKOPANE",
        "34513": "NOWY TARG",
        "34514": "ZAKOPANE",
        "34520": "ZAKOPANE",
        "34521": "ZAKOPANE",
        "34530": "ZAKOPANE",
        "34531": "ZAKOPANE",
        "34532": "ZAKOPANE",
        "34600": "LIMANOWA",
        "34601": "LIMANOWA",
        "34602": "LIMANOWA",
        "34603": "LIMANOWA",
        "34604": "LIMANOWA",
        "34606": "LIMANOWA",
        "34607": "LIMANOWA",
        "34608": "LIMANOWA",
        "34611": "LUBACZÓW",
        "34615": "LIMANOWA",
        "34617": "LIMANOWA",
        "34620": "LIMANOWA",
        "34623": "LIMANOWA",
        "34625": "LIMANOWA",
        "34642": "LIMANOWA",
        "34643": "LIMANOWA",
        "34650": "LIMANOWA",
        "34651": "LIMANOWA",
        "34652": "LIMANOWA",
        "34654": "LIMANOWA",
        "34700": "RABKA-ZDRÓJ",
        "34713": "NOWY TARG",
        "34720": "NOWY TARG",
        "34721": "NOWY TARG",
        "34722": "NOWY TARG",
        "34723": "NOWY TARG",
        "34730": "MSZANA DOLNA",
        "34732": "LIMANOWA",
        "34733": "MSZANA DOLNA",
        "34734": "LIMANOWA",
        "34735": "LIMANOWA",
        "34736": "LIMANOWA",
        "34741": "LIMANOWA",
        "34745": "NOWY TARG",
        "35001": "RZESZÓW",
        "35002": "RZESZÓW",
        "35005": "RZESZÓW",
        "35006": "RZESZÓW",
        "35010": "RZESZÓW",
        "35011": "RZESZÓW",
        "35015": "RZESZÓW",
        "35016": "RZESZÓW",
        "35017": "RZESZÓW",
        "35020": "RZESZÓW",
        "35021": "RZESZÓW",
        "35025": "RZESZÓW",
        "35026": "RZESZÓW",
        "35030": "RZESZÓW",
        "35031": "RZESZÓW",
        "35032": "RZESZÓW",
        "35033": "RZESZÓW",
        "35036": "RZESZÓW",
        "35037": "RZESZÓW",
        "35038": "RZESZÓW",
        "35040": "RZESZÓW",
        "35042": "RZESZÓW",
        "35045": "RZESZÓW",
        "35046": "RZESZÓW",
        "35047": "RZESZÓW",
        "35050": "RZESZÓW",
        "35051": "RZESZÓW",
        "35055": "RZESZÓW",
        "35056": "RZESZÓW",
        "35060": "RZESZÓW",
        "35061": "RZESZÓW",
        "35064": "RZESZÓW",
        "35065": "RZESZÓW",
        "35068": "RZESZÓW",
        "35069": "RZESZÓW",
        "35070": "RZESZÓW",
        "35073": "RZESZÓW",
        "35074": "RZESZÓW",
        "35075": "RZESZÓW",
        "35077": "RZESZÓW",
        "35078": "RZESZÓW",
        "35079": "RZESZÓW",
        "35080": "RZESZÓW",
        "35082": "RZESZÓW",
        "35083": "RZESZÓW",
        "35084": "RZESZÓW",
        "35086": "RZESZÓW",
        "35100": "RZESZÓW",
        "35101": "RZESZÓW",
        "35102": "RZESZÓW",
        "35103": "RZESZÓW",
        "35104": "RZESZÓW",
        "35105": "RZESZÓW",
        "35106": "RZESZÓW",
        "35107": "RZESZÓW",
        "35111": "RZESZÓW",
        "35112": "RZESZÓW",
        "35113": "RZESZÓW",
        "35114": "RZESZÓW",
        "35115": "RZESZÓW",
        "35116": "RZESZÓW",
        "35117": "RZESZÓW",
        "35118": "RZESZÓW",
        "35119": "RZESZÓW",
        "35120": "RZESZÓW",
        "35122": "RZESZÓW",
        "35123": "RZESZÓW",
        "35124": "RZESZÓW",
        "35125": "RZESZÓW",
        "35201": "RZESZÓW",
        "35202": "RZESZÓW",
        "35203": "RZESZÓW",
        "35205": "RZESZÓW",
        "35206": "RZESZÓW",
        "35207": "RZESZÓW",
        "35208": "RZESZÓW",
        "35209": "RZESZÓW",
        "35210": "RZESZÓW",
        "35211": "RZESZÓW",
        "35213": "RZESZÓW",
        "35215": "RZESZÓW",
        "35216": "RZESZÓW",
        "35222": "RZESZÓW",
        "35223": "RZESZÓW",
        "35224": "RZESZÓW",
        "35225": "RZESZÓW",
        "35230": "RZESZÓW",
        "35231": "RZESZÓW",
        "35232": "RZESZÓW",
        "35233": "RZESZÓW",
        "35234": "RZESZÓW",
        "35235": "RZESZÓW",
        "35241": "RZESZÓW",
        "35242": "RZESZÓW",
        "35300": "RZESZÓW",
        "35301": "RZESZÓW",
        "35302": "RZESZÓW",
        "35303": "RZESZÓW",
        "35304": "RZESZÓW",
        "35305": "RZESZÓW",
        "35306": "RZESZÓW",
        "35307": "RZESZÓW",
        "35308": "RZESZÓW",
        "35309": "RZESZÓW",
        "35310": "RZESZÓW",
        "35311": "RZESZÓW",
        "35312": "RZESZÓW",
        "35313": "RZESZÓW",
        "35314": "RZESZÓW",
        "35315": "RZESZÓW",
        "35316": "RZESZÓW",
        "35317": "RZESZÓW",
        "35320": "RZESZÓW",
        "35321": "RZESZÓW",
        "35322": "RZESZÓW",
        "35323": "RZESZÓW",
        "35324": "RZESZÓW",
        "35326": "RZESZÓW",
        "35327": "RZESZÓW",
        "35328": "RZESZÓW",
        "35329": "RZESZÓW",
        "35330": "RZESZÓW",
        "35332": "RZESZÓW",
        "35333": "RZESZÓW",
        "35404": "RZESZÓW",
        "35410": "RZESZÓW",
        "35501": "RZESZÓW",
        "35502": "RZESZÓW",
        "35503": "RZESZÓW",
        "35504": "RZESZÓW",
        "35505": "RZESZÓW",
        "35506": "RZESZÓW",
        "35507": "RZESZÓW",
        "35508": "RZESZÓW",
        "35509": "RZESZÓW",
        "35510": "RZESZÓW",
        "35511": "RZESZÓW",
        "35512": "RZESZÓW",
        "35513": "RZESZÓW",
        "35515": "RZESZÓW",
        "35516": "RZESZÓW",
        "35601": "RZESZÓW",
        "35602": "RZESZÓW",
        "35603": "RZESZÓW",
        "35604": "RZESZÓW",
        "35605": "RZESZÓW",
        "35606": "RZESZÓW",
        "35607": "RZESZÓW",
        "35608": "RZESZÓW",
        "35609": "RZESZÓW",
        "35610": "RZESZÓW",
        "35611": "RZESZÓW",
        "35612": "RZESZÓW",
        "35614": "RZESZÓW",
        "35615": "RZESZÓW",
        "35616": "RZESZÓW",
        "35617": "RZESZÓW",
        "35620": "RZESZÓW",
        "35622": "RZESZÓW",
        "35623": "RZESZÓW",
        "35624": "RZESZÓW",
        "35625": "RZESZÓW",
        "35626": "RZESZÓW",
        "35627": "RZESZÓW",
        "35628": "RZESZÓW",
        "35629": "RZESZÓW",
        "35630": "RZESZÓW",
        "35749": "RZESZÓW",
        "35900": "RZESZÓW",
        "35959": "RZESZÓW",
        "36001": "RZESZÓW",
        "36002": "RZESZÓW",
        "36003": "RZESZÓW",
        "36004": "RZESZÓW",
        "36007": "RZESZÓW",
        "36016": "RZESZÓW",
        "36017": "RZESZÓW",
        "36020": "RZESZÓW",
        "36021": "RZESZÓW",
        "36024": "RZESZÓW",
        "36025": "RZESZÓW",
        "36030": "RZESZÓW",
        "36032": "RZESZÓW",
        "36034": "RZESZÓW",
        "36040": "RZESZÓW",
        "36041": "RZESZÓW",
        "36042": "RZESZÓW",
        "36043": "RZESZÓW",
        "36046": "RZESZÓW",
        "36047": "RZESZÓW",
        "36050": "RZESZÓW",
        "36051": "RZESZÓW",
        "36052": "RZESZÓW",
        "36053": "RZESZÓW",
        "36054": "RZESZÓW",
        "36055": "RZESZÓW",
        "36060": "RZESZÓW",
        "36061": "RZESZÓW",
        "36062": "RZESZÓW",
        "36065": "DYNÓW",
        "36067": "RZESZÓW",
        "36068": "RZESZÓW",
        "36069": "RZESZÓW",
        "36071": "RZESZÓW",
        "36072": "RZESZÓW",
        "36073": "RZESZÓW",
        "36100": "KOLBUSZOWA",
        "36105": "KOLBUSZOWA",
        "36106": "KOLBUSZOWA",
        "36107": "KOLBUSZOWA",
        "36110": "KOLBUSZOWA",
        "36121": "KOLBUSZOWA",
        "36122": "KOLBUSZOWA",
        "36123": "KOLBUSZOWA",
        "36125": "KOLBUSZOWA",
        "36130": "KOLBUSZOWA",
        "36145": "KOLBUSZOWA",
        "36147": "KOLBUSZOWA",
        "36200": "BRZOZÓW",
        "36203": "BRZOZÓW",
        "36204": "BRZOZÓW",
        "36205": "BRZOZÓW",
        "36206": "BRZOZÓW",
        "36207": "BRZOZÓW",
        "36211": "BRZOZÓW",
        "36212": "BRZOZÓW",
        "36213": "BRZOZÓW",
        "36220": "BRZOZÓW",
        "36221": "BRZOZÓW",
        "36230": "BRZOZÓW",
        "36231": "BRZOZÓW",
        "36233": "BRZOZÓW",
        "36244": "BRZOZÓW",
        "36245": "BRZOZÓW",
        "37100": "ŁAŃCUT",
        "37110": "ŁAŃCUT",
        "37111": "ŁAŃCUT",
        "37112": "ŁAŃCUT",
        "37114": "ŁAŃCUT",
        "37120": "ŁAŃCUT",
        "37121": "ŁAŃCUT",
        "37122": "ŁAŃCUT",
        "37123": "ŁAŃCUT",
        "37124": "ŁAŃCUT",
        "37125": "ŁAŃCUT",
        "37126": "ŁAŃCUT",
        "37127": "ŁAŃCUT",
        "37200": "PRZEWORSK",
        "37203": "PRZEWORSK",
        "37204": "PRZEWORSK",
        "37205": "PRZEWORSK",
        "37206": "PRZEWORSK",
        "37207": "PRZEWORSK",
        "37210": "PRZEWORSK",
        "37220": "PRZEWORSK",
        "37222": "PRZEWORSK",
        "37223": "RZESZÓW",
        "37224": "PRZEWORSK",
        "37225": "RZESZÓW",
        "37230": "PRZEWORSK",
        "37231": "RZESZÓW",
        "37232": "PRZEWORSK",
        "37240": "PRZEWORSK",
        "37300": "LEŻAJSK",
        "37303": "LEŻAJSK",
        "37304": "LEŻAJSK",
        "37305": "LEŻAJSK",
        "37306": "LEŻAJSK",
        "37307": "LEŻAJSK",
        "37310": "NOWA SARZYNA",
        "37311": "LEŻAJSK",
        "37312": "LEŻAJSK",
        "37400": "NISKO",
        "37403": "STALOWA WOLA",
        "37405": "NISKO",
        "37410": "NISKO",
        "37413": "NISKO",
        "37414": "NISKO",
        "37415": "STALOWA WOLA",
        "37416": "STALOWA WOLA",
        "37418": "NISKO",
        "37420": "NISKO",
        "37430": "NISKO",
        "37433": "STALOWA WOLA",
        "37450": "STALOWA WOLA",
        "37455": "STALOWA WOLA",
        "37462": "STALOWA WOLA",
        "37463": "STALOWA WOLA",
        "37464": "STALOWA WOLA",
        "37465": "STALOWA WOLA",
        "37467": "STALOWA WOLA",
        "37470": "STALOWA WOLA",
        "37500": "JAROSŁAW",
        "37501": "JAROSŁAW",
        "37504": "JAROSŁAW",
        "37505": "JAROSŁAW",
        "37511": "JAROSŁAW",
        "37512": "RZESZÓW",
        "37514": "JAROSŁAW",
        "37522": "JAROSŁAW",
        "37523": "JAROSŁAW",
        "37530": "PRZEWORSK",
        "37534": "PRZEWORSK",
        "37535": "RZESZÓW",
        "37536": "RZESZÓW",
        "37541": "RZESZÓW",
        "37542": "RZESZÓW",
        "37543": "JAROSŁAW",
        "37544": "JAROSŁAW",
        "37545": "RZESZÓW",
        "37550": "JAROSŁAW",
        "37551": "RZESZÓW",
        "37552": "JAROSŁAW",
        "37554": "JAROSŁAW",
        "37555": "JAROSŁAW",
        "37560": "JAROSŁAW",
        "37561": "JAROSŁAW",
        "37562": "JAROSŁAW",
        "37564": "RZESZÓW",
        "37565": "JAROSŁAW",
        "37600": "LUBACZÓW",
        "37610": "LUBACZÓW",
        "37611": "LUBACZÓW",
        "37612": "LUBACZÓW",
        "37613": "LUBACZÓW",
        "37614": "LUBACZÓW",
        "37620": "LUBACZÓW",
        "37621": "LUBACZÓW",
        "37622": "RZESZÓW",
        "37625": "LUBACZÓW",
        "37626": "LUBACZÓW",
        "37627": "LUBACZÓW",
        "37630": "LUBACZÓW",
        "37631": "LUBACZÓW",
        "37632": "LUBACZÓW",
        "37700": "PRZEMYŚL",
        "37701": "PRZEMYŚL",
        "37702": "PRZEMYŚL",
        "37703": "PRZEMYŚL",
        "37704": "PRZEMYŚL",
        "37705": "PRZEMYŚL",
        "37706": "PRZEMYŚL",
        "37707": "PRZEMYŚL",
        "37710": "PRZEMYŚL",
        "37712": "PRZEMYŚL",
        "37713": "PRZEMYŚL",
        "37714": "PRZEMYŚL",
        "37716": "PRZEMYŚL",
        "37717": "PRZEMYŚL",
        "37720": "PRZEMYŚL",
        "37722": "PRZEMYŚL",
        "37723": "PRZEMYŚL",
        "37724": "PRZEMYŚL",
        "37731": "PRZEMYŚL",
        "37732": "PRZEMYŚL",
        "37733": "PRZEMYŚL",
        "37734": "PRZEMYŚL",
        "37740": "PRZEMYŚL",
        "37741": "PRZEMYŚL",
        "37742": "PRZEMYŚL",
        "37743": "PRZEMYŚL",
        "37744": "PRZEMYŚL",
        "37749": "PRZEMYŚL",
        "37750": "PRZEMYŚL",
        "37751": "PRZEMYŚL",
        "37752": "PRZEMYŚL",
        "37753": "PRZEMYŚL",
        "37754": "PRZEMYŚL",
        "37755": "PRZEMYŚL",
        "38100": "STRZYŻÓW",
        "38102": "STRZYŻÓW",
        "38103": "PRZEMYŚL",
        "38111": "STRZYŻÓW",
        "38112": "STRZYŻÓW",
        "38114": "STRZYŻÓW",
        "38115": "STRZYŻÓW",
        "38116": "STRZYŻÓW",
        "38120": "STRZYŻÓW",
        "38121": "STRZYŻÓW",
        "38122": "PRZEMYŚL",
        "38123": "STRZYŻÓW",
        "38124": "STRZYŻÓW",
        "38125": "STRZYŻÓW",
        "38126": "STRZYŻÓW",
        "38130": "STRZYŻÓW",
        "38131": "STRZYŻÓW",
        "38200": "JASŁO",
        "38201": "JASŁO",
        "38203": "JASŁO",
        "38204": "JASŁO",
        "38207": "JASŁO",
        "38211": "JASŁO",
        "38212": "JASŁO",
        "38213": "JASŁO",
        "38214": "JASŁO",
        "38220": "JASŁO",
        "38222": "JASŁO",
        "38223": "JASŁO",
        "38230": "JASŁO",
        "38232": "JASŁO",
        "38241": "JASŁO",
        "38242": "JASŁO",
        "38243": "JASŁO",
        "38244": "JASŁO",
        "38245": "TARNÓW",
        "38246": "TARNÓW",
        "38247": "TARNÓW",
        "38300": "GORLICE",
        "38301": "GORLICE",
        "38302": "GORLICE",
        "38303": "GORLICE",
        "38304": "GORLICE",
        "38305": "GORLICE",
        "38306": "GORLICE",
        "38307": "GORLICE",
        "38311": "GORLICE",
        "38312": "GORLICE",
        "38313": "GORLICE",
        "38314": "GORLICE",
        "38315": "GORLICE",
        "38316": "GORLICE",
        "38320": "GORLICE",
        "38321": "GORLICE",
        "38322": "GORLICE",
        "38323": "GORLICE",
        "38324": "GORLICE",
        "38331": "GORLICE",
        "38333": "GORLICE",
        "38340": "GORLICE",
        "38350": "GORLICE",
        "38400": "KROSNO",
        "38401": "KROSNO",
        "38402": "KROSNO",
        "38404": "KROSNO",
        "38406": "KROSNO",
        "38407": "KROSNO",
        "38408": "KROSNO",
        "38409": "KROSNO",
        "38410": "KROSNO",
        "38411": "KROSNO",
        "38420": "KROSNO",
        "38421": "KROSNO",
        "38422": "KROSNO",
        "38423": "KROSNO",
        "38430": "KROSNO",
        "38440": "KROSNO",
        "38441": "KROSNO",
        "38450": "KROSNO",
        "38451": "KROSNO",
        "38454": "KROSNO",
        "38455": "KROSNO",
        "38456": "KROSNO",
        "38457": "KROSNO",
        "38458": "KROSNO",
        "38459": "KROSNO",
        "38460": "KROSNO",
        "38462": "KROSNO",
        "38471": "KROSNO",
        "38472": "KROSNO",
        "38473": "KROSNO",
        "38480": "KROSNO",
        "38481": "KROSNO",
        "38482": "KROSNO",
        "38483": "KROSNO",
        "38485": "KROSNO",
        "38500": "SANOK",
        "38501": "SANOK",
        "38503": "SANOK",
        "38504": "SANOK",
        "38505": "SANOK",
        "38506": "SANOK",
        "38507": "SANOK",
        "38512": "SANOK",
        "38516": "SANOK",
        "38524": "SANOK",
        "38530": "SANOK",
        "38532": "SANOK",
        "38533": "SANOK",
        "38534": "SANOK",
        "38535": "SANOK",
        "38540": "SANOK",
        "38542": "SANOK",
        "38543": "SANOK",
        "38544": "SANOK",
        "38600": "LESKO",
        "38604": "LESKO",
        "38606": "LESKO",
        "38607": "LESKO",
        "38608": "LESKO",
        "38610": "LESKO",
        "38623": "LESKO",
        "38700": "USTRZYKI DOLNE",
        "38709": "USTRZYKI DOLNE",
        "38710": "USTRZYKI DOLNE",
        "38711": "USTRZYKI DOLNE",
        "38712": "USTRZYKI DOLNE",
        "38713": "USTRZYKI DOLNE",
        "38714": "USTRZYKI DOLNE",
        "38715": "USTRZYKI DOLNE",
        "38722": "LESKO",
        "38749": "KROSNO",
        "39100": "ROPCZYCE",
        "39102": "ROPCZYCE",
        "39103": "ROPCZYCE",
        "39104": "ROPCZYCE",
        "39105": "ROPCZYCE",
        "39106": "ROPCZYCE",
        "39107": "ROPCZYCE",
        "39110": "ROPCZYCE",
        "39111": "ROPCZYCE",
        "39120": "ROPCZYCE",
        "39122": "ROPCZYCE",
        "39123": "ROPCZYCE",
        "39124": "ROPCZYCE",
        "39126": "ROPCZYCE",
        "39127": "ROPCZYCE",
        "39200": "DĘBICA (NET)",
        "39201": "DĘBICA (NET)",
        "39203": "DĘBICA (NET)",
        "39204": "DĘBICA (NET)",
        "39205": "DĘBICA (NET)",
        "39206": "DĘBICA (NET)",
        "39207": "DĘBICA (NET)",
        "39208": "DĘBICA (NET)",
        "39209": "DĘBICA (NET)",
        "39210": "DĘBICA (NET)",
        "39215": "DĘBICA (NET)",
        "39216": "DĘBICA (NET)",
        "39217": "DĘBICA (NET)",
        "39218": "DĘBICA (NET)",
        "39220": "DĘBICA (NET)",
        "39221": "DĘBICA (NET)",
        "39222": "DĘBICA (NET)",
        "39223": "DĘBICA (NET)",
        "39224": "DĘBICA (NET)",
        "39225": "DĘBICA (NET)",
        "39230": "DĘBICA (NET)",
        "39231": "DĘBICA (NET)",
        "39232": "DĘBICA (NET)",
        "39300": "MIELEC",
        "39301": "MIELEC",
        "39302": "MIELEC",
        "39303": "MIELEC",
        "39304": "MIELEC",
        "39305": "MIELEC",
        "39306": "MIELEC",
        "39307": "MIELEC",
        "39308": "MIELEC",
        "39309": "MIELEC",
        "39310": "MIELEC",
        "39311": "MIELEC",
        "39312": "MIELEC",
        "39315": "MIELEC",
        "39320": "MIELEC",
        "39321": "MIELEC",
        "39322": "MIELEC",
        "39323": "MIELEC",
        "39331": "MIELEC",
        "39332": "MIELEC",
        "39333": "MIELEC",
        "39340": "MIELEC",
        "39400": "TARNOBRZEG",
        "39401": "TARNOBRZEG",
        "39402": "TARNOBRZEG",
        "39403": "TARNOBRZEG",
        "39405": "TARNOBRZEG",
        "39407": "TARNOBRZEG",
        "39410": "TARNOBRZEG",
        "39432": "GORZYCE",
        "39433": "TARNOBRZEG",
        "39434": "TARNOBRZEG",
        "39441": "TARNOBRZEG",
        "39442": "TARNOBRZEG",
        "39450": "TARNOBRZEG",
        "39451": "TARNOBRZEG",
        "39460": "NOWA DĘBA",
        "40001": "KATOWICE",
        "40002": "KATOWICE",
        "40003": "KATOWICE",
        "40004": "KATOWICE",
        "40005": "KATOWICE",
        "40006": "KATOWICE",
        "40007": "KATOWICE",
        "40008": "KATOWICE",
        "40009": "KATOWICE",
        "40010": "KATOWICE",
        "40011": "KATOWICE",
        "40012": "KATOWICE",
        "40013": "KATOWICE",
        "40014": "KATOWICE",
        "40015": "KATOWICE",
        "40016": "KATOWICE",
        "40017": "KATOWICE",
        "40018": "KATOWICE",
        "40019": "KATOWICE",
        "40020": "KATOWICE",
        "40021": "KATOWICE",
        "40022": "KATOWICE",
        "40024": "KATOWICE",
        "40025": "KATOWICE",
        "40026": "KATOWICE",
        "40027": "KATOWICE",
        "40028": "KATOWICE",
        "40029": "KATOWICE",
        "40030": "KATOWICE",
        "40031": "KATOWICE",
        "40032": "KATOWICE",
        "40034": "KATOWICE",
        "40035": "KATOWICE",
        "40036": "KATOWICE",
        "40037": "KATOWICE",
        "40038": "KATOWICE",
        "40039": "KATOWICE",
        "40040": "KATOWICE",
        "40041": "KATOWICE",
        "40042": "KATOWICE",
        "40043": "KATOWICE",
        "40044": "KATOWICE",
        "40045": "KATOWICE",
        "40046": "KATOWICE",
        "40047": "KATOWICE",
        "40048": "KATOWICE",
        "40049": "KATOWICE",
        "40050": "KATOWICE",
        "40052": "KATOWICE",
        "40053": "KATOWICE",
        "40054": "KATOWICE",
        "40055": "KATOWICE",
        "40056": "KATOWICE",
        "40057": "KATOWICE",
        "40058": "KATOWICE",
        "40059": "KATOWICE",
        "40060": "KATOWICE",
        "40061": "KATOWICE",
        "40062": "KATOWICE",
        "40063": "KATOWICE",
        "40064": "KATOWICE",
        "40065": "KATOWICE",
        "40066": "KATOWICE",
        "40067": "KATOWICE",
        "40068": "KATOWICE",
        "40069": "KATOWICE",
        "40070": "KATOWICE",
        "40071": "KATOWICE",
        "40072": "KATOWICE",
        "40073": "KATOWICE",
        "40074": "KATOWICE",
        "40076": "KATOWICE",
        "40077": "KATOWICE",
        "40078": "KATOWICE",
        "40079": "KATOWICE",
        "40081": "KATOWICE",
        "40082": "KATOWICE",
        "40083": "KATOWICE",
        "40084": "KATOWICE",
        "40085": "KATOWICE",
        "40086": "KATOWICE",
        "40087": "KATOWICE",
        "40091": "KATOWICE",
        "40092": "KATOWICE",
        "40093": "KATOWICE",
        "40094": "KATOWICE",
        "40095": "KATOWICE",
        "40096": "KATOWICE",
        "40097": "KATOWICE",
        "40098": "KATOWICE",
        "40100": "KATOWICE",
        "40101": "KATOWICE",
        "40102": "KATOWICE",
        "40103": "KATOWICE",
        "40104": "KATOWICE",
        "40105": "KATOWICE",
        "40106": "KATOWICE",
        "40107": "KATOWICE",
        "40108": "KATOWICE",
        "40109": "KATOWICE",
        "40110": "KATOWICE",
        "40111": "KATOWICE",
        "40112": "KATOWICE",
        "40113": "KATOWICE",
        "40114": "KATOWICE",
        "40115": "KATOWICE",
        "40116": "KATOWICE",
        "40117": "KATOWICE",
        "40118": "KATOWICE",
        "40119": "KATOWICE",
        "40121": "KATOWICE",
        "40123": "KATOWICE",
        "40124": "KATOWICE",
        "40125": "KATOWICE",
        "40126": "KATOWICE",
        "40127": "KATOWICE",
        "40129": "KATOWICE",
        "40131": "KATOWICE",
        "40132": "KATOWICE",
        "40133": "KATOWICE",
        "40134": "KATOWICE",
        "40135": "KATOWICE",
        "40136": "KATOWICE",
        "40137": "KATOWICE",
        "40139": "KATOWICE",
        "40140": "KATOWICE",
        "40141": "KATOWICE",
        "40142": "KATOWICE",
        "40143": "KATOWICE",
        "40144": "KATOWICE",
        "40145": "KATOWICE",
        "40146": "KATOWICE",
        "40147": "KATOWICE",
        "40148": "KATOWICE",
        "40149": "KATOWICE",
        "40150": "KATOWICE",
        "40151": "KATOWICE",
        "40152": "KATOWICE",
        "40153": "KATOWICE",
        "40154": "KATOWICE",
        "40155": "KATOWICE",
        "40156": "KATOWICE",
        "40157": "KATOWICE",
        "40158": "KATOWICE",
        "40159": "KATOWICE",
        "40160": "KATOWICE",
        "40161": "KATOWICE",
        "40162": "KATOWICE",
        "40163": "KATOWICE",
        "40164": "KATOWICE",
        "40165": "KATOWICE",
        "40166": "KATOWICE",
        "40167": "KATOWICE",
        "40168": "KATOWICE",
        "40169": "KATOWICE",
        "40170": "KATOWICE",
        "40171": "KATOWICE",
        "40172": "KATOWICE",
        "40173": "KATOWICE",
        "40174": "KATOWICE",
        "40175": "KATOWICE",
        "40176": "KATOWICE",
        "40177": "KATOWICE",
        "40179": "KATOWICE",
        "40181": "KATOWICE",
        "40186": "KATOWICE",
        "40188": "KATOWICE",
        "40189": "KATOWICE",
        "40200": "KATOWICE",
        "40201": "KATOWICE",
        "40202": "KATOWICE",
        "40203": "KATOWICE",
        "40205": "KATOWICE",
        "40206": "KATOWICE",
        "40208": "KATOWICE",
        "40209": "KATOWICE",
        "40210": "KATOWICE",
        "40211": "KATOWICE",
        "40212": "KATOWICE",
        "40213": "KATOWICE",
        "40214": "KATOWICE",
        "40215": "KATOWICE",
        "40216": "KATOWICE",
        "40217": "KATOWICE",
        "40218": "KATOWICE",
        "40219": "KATOWICE",
        "40224": "KATOWICE",
        "40225": "KATOWICE",
        "40226": "KATOWICE",
        "40227": "KATOWICE",
        "40228": "KATOWICE",
        "40229": "KATOWICE",
        "40230": "KATOWICE",
        "40231": "KATOWICE",
        "40232": "KATOWICE",
        "40233": "KATOWICE",
        "40234": "KATOWICE",
        "40235": "KATOWICE",
        "40236": "KATOWICE",
        "40237": "KATOWICE",
        "40238": "KATOWICE",
        "40239": "KATOWICE",
        "40240": "KATOWICE",
        "40241": "KATOWICE",
        "40242": "KATOWICE",
        "40246": "KATOWICE",
        "40256": "KATOWICE",
        "40265": "KATOWICE",
        "40266": "KATOWICE",
        "40271": "KATOWICE",
        "40272": "KATOWICE",
        "40273": "KATOWICE",
        "40276": "KATOWICE",
        "40277": "KATOWICE",
        "40281": "KATOWICE",
        "40282": "KATOWICE",
        "40283": "KATOWICE",
        "40284": "KATOWICE",
        "40285": "KATOWICE",
        "40286": "KATOWICE",
        "40287": "KATOWICE",
        "40288": "KATOWICE",
        "40290": "KATOWICE",
        "40291": "KATOWICE",
        "40300": "KATOWICE",
        "40301": "KATOWICE",
        "40302": "KATOWICE",
        "40303": "KATOWICE",
        "40304": "KATOWICE",
        "40305": "KATOWICE",
        "40306": "KATOWICE",
        "40307": "KATOWICE",
        "40308": "KATOWICE",
        "40309": "KATOWICE",
        "40310": "KATOWICE",
        "40311": "KATOWICE",
        "40312": "KATOWICE",
        "40313": "KATOWICE",
        "40314": "MIKOŁÓW",
        "40315": "KATOWICE",
        "40316": "KATOWICE",
        "40317": "KATOWICE",
        "40318": "KATOWICE",
        "40319": "KATOWICE",
        "40320": "KATOWICE",
        "40321": "KATOWICE",
        "40322": "KATOWICE",
        "40325": "KATOWICE",
        "40326": "KATOWICE",
        "40334": "KATOWICE",
        "40335": "KATOWICE",
        "40336": "KATOWICE",
        "40337": "KATOWICE",
        "40338": "KATOWICE",
        "40339": "KATOWICE",
        "40340": "KATOWICE",
        "40341": "KATOWICE",
        "40342": "KATOWICE",
        "40348": "KATOWICE",
        "40351": "KATOWICE",
        "40353": "KATOWICE",
        "40356": "KATOWICE",
        "40357": "KATOWICE",
        "40358": "KATOWICE",
        "40360": "KATOWICE",
        "40367": "KATOWICE",
        "40368": "KATOWICE",
        "40370": "KATOWICE",
        "40373": "KATOWICE",
        "40374": "KATOWICE",
        "40375": "KATOWICE",
        "40376": "KATOWICE",
        "40377": "KATOWICE",
        "40378": "KATOWICE",
        "40379": "KATOWICE",
        "40381": "KATOWICE",
        "40382": "KATOWICE",
        "40383": "KATOWICE",
        "40384": "KATOWICE",
        "40386": "KATOWICE",
        "40387": "KATOWICE",
        "40388": "KATOWICE",
        "40389": "KATOWICE",
        "40391": "KATOWICE",
        "40393": "KATOWICE",
        "40394": "KATOWICE",
        "40401": "KATOWICE",
        "40402": "KATOWICE",
        "40403": "KATOWICE",
        "40404": "KATOWICE",
        "40405": "KATOWICE",
        "40406": "KATOWICE",
        "40407": "KATOWICE",
        "40410": "KATOWICE",
        "40411": "KATOWICE",
        "40412": "KATOWICE",
        "40413": "KATOWICE",
        "40414": "KATOWICE",
        "40421": "KATOWICE",
        "40422": "KATOWICE",
        "40423": "KATOWICE",
        "40424": "KATOWICE",
        "40425": "KATOWICE",
        "40431": "KATOWICE",
        "40432": "KATOWICE",
        "40434": "KATOWICE",
        "40435": "KATOWICE",
        "40452": "KATOWICE",
        "40453": "KATOWICE",
        "40457": "KATOWICE",
        "40458": "KATOWICE",
        "40459": "KATOWICE",
        "40460": "KATOWICE",
        "40461": "KATOWICE",
        "40462": "KATOWICE",
        "40463": "KATOWICE",
        "40464": "KATOWICE",
        "40465": "KATOWICE",
        "40466": "KATOWICE",
        "40467": "KATOWICE",
        "40468": "KATOWICE",
        "40469": "KATOWICE",
        "40470": "KATOWICE",
        "40471": "KATOWICE",
        "40472": "KATOWICE",
        "40473": "KATOWICE",
        "40474": "KATOWICE",
        "40476": "KATOWICE",
        "40477": "KATOWICE",
        "40478": "KATOWICE",
        "40479": "KATOWICE",
        "40483": "KATOWICE",
        "40484": "KATOWICE",
        "40485": "KATOWICE",
        "40486": "KATOWICE",
        "40487": "KATOWICE",
        "40488": "KATOWICE",
        "40489": "KATOWICE",
        "40494": "KATOWICE",
        "40496": "KATOWICE",
        "40499": "KATOWICE",
        "40500": "KATOWICE",
        "40502": "KATOWICE",
        "40503": "KATOWICE",
        "40504": "KATOWICE",
        "40505": "KATOWICE",
        "40506": "KATOWICE",
        "40507": "KATOWICE",
        "40508": "KATOWICE",
        "40510": "KATOWICE",
        "40511": "KATOWICE",
        "40513": "KATOWICE",
        "40514": "KATOWICE",
        "40517": "KATOWICE",
        "40518": "KATOWICE",
        "40519": "KATOWICE",
        "40520": "KATOWICE",
        "40521": "KATOWICE",
        "40522": "KATOWICE",
        "40523": "KATOWICE",
        "40524": "KATOWICE",
        "40525": "KATOWICE",
        "40526": "KATOWICE",
        "40527": "KATOWICE",
        "40528": "KATOWICE",
        "40529": "KATOWICE",
        "40530": "KATOWICE",
        "40531": "KATOWICE",
        "40532": "KATOWICE",
        "40533": "KATOWICE",
        "40534": "KATOWICE",
        "40535": "KATOWICE",
        "40536": "KATOWICE",
        "40537": "KATOWICE",
        "40538": "KATOWICE",
        "40539": "KATOWICE",
        "40540": "KATOWICE",
        "40541": "KATOWICE",
        "40542": "KATOWICE",
        "40543": "KATOWICE",
        "40544": "KATOWICE",
        "40545": "KATOWICE",
        "40546": "KATOWICE",
        "40547": "KATOWICE",
        "40551": "KATOWICE",
        "40553": "KATOWICE",
        "40555": "KATOWICE",
        "40558": "KATOWICE",
        "40559": "KATOWICE",
        "40560": "KATOWICE",
        "40561": "KATOWICE",
        "40562": "KATOWICE",
        "40563": "KATOWICE",
        "40564": "KATOWICE",
        "40565": "KATOWICE",
        "40566": "KATOWICE",
        "40567": "KATOWICE",
        "40568": "KATOWICE",
        "40569": "KATOWICE",
        "40570": "KATOWICE",
        "40571": "KATOWICE",
        "40572": "KATOWICE",
        "40573": "KATOWICE",
        "40574": "KATOWICE",
        "40575": "KATOWICE",
        "40576": "KATOWICE",
        "40578": "KATOWICE",
        "40579": "KATOWICE",
        "40580": "KATOWICE",
        "40581": "KATOWICE",
        "40582": "KATOWICE",
        "40583": "KATOWICE",
        "40584": "KATOWICE",
        "40585": "KATOWICE",
        "40586": "KATOWICE",
        "40587": "KATOWICE",
        "40588": "KATOWICE",
        "40589": "KATOWICE",
        "40590": "KATOWICE",
        "40591": "KATOWICE",
        "40592": "KATOWICE",
        "40593": "KATOWICE",
        "40594": "KATOWICE",
        "40595": "KATOWICE",
        "40596": "KATOWICE",
        "40597": "KATOWICE",
        "40598": "KATOWICE",
        "40599": "KATOWICE",
        "40600": "KATOWICE",
        "40601": "KATOWICE",
        "40602": "KATOWICE",
        "40605": "KATOWICE",
        "40606": "KATOWICE",
        "40607": "KATOWICE",
        "40608": "KATOWICE",
        "40609": "KATOWICE",
        "40610": "KATOWICE",
        "40611": "KATOWICE",
        "40612": "KATOWICE",
        "40613": "KATOWICE",
        "40615": "KATOWICE",
        "40616": "KATOWICE",
        "40617": "KATOWICE",
        "40618": "KATOWICE",
        "40619": "KATOWICE",
        "40620": "KATOWICE",
        "40621": "KATOWICE",
        "40622": "KATOWICE",
        "40623": "KATOWICE",
        "40624": "KATOWICE",
        "40625": "KATOWICE",
        "40626": "KATOWICE",
        "40627": "KATOWICE",
        "40628": "KATOWICE",
        "40629": "KATOWICE",
        "40630": "KATOWICE",
        "40631": "KATOWICE",
        "40632": "KATOWICE",
        "40633": "KATOWICE",
        "40634": "KATOWICE",
        "40635": "KATOWICE",
        "40636": "KATOWICE",
        "40637": "KATOWICE",
        "40638": "KATOWICE",
        "40639": "KATOWICE",
        "40640": "KATOWICE",
        "40641": "KATOWICE",
        "40642": "KATOWICE",
        "40643": "KATOWICE",
        "40644": "KATOWICE",
        "40645": "KATOWICE",
        "40646": "KATOWICE",
        "40647": "KATOWICE",
        "40648": "KATOWICE",
        "40649": "KATOWICE",
        "40650": "KATOWICE",
        "40651": "KATOWICE",
        "40652": "KATOWICE",
        "40653": "KATOWICE",
        "40654": "KATOWICE",
        "40655": "KATOWICE",
        "40656": "KATOWICE",
        "40657": "KATOWICE",
        "40658": "KATOWICE",
        "40659": "KATOWICE",
        "40660": "KATOWICE",
        "40661": "KATOWICE",
        "40662": "KATOWICE",
        "40663": "KATOWICE",
        "40664": "KATOWICE",
        "40665": "KATOWICE",
        "40666": "KATOWICE",
        "40667": "KATOWICE",
        "40668": "KATOWICE",
        "40669": "KATOWICE",
        "40670": "KATOWICE",
        "40671": "KATOWICE",
        "40672": "KATOWICE",
        "40673": "KATOWICE",
        "40674": "KATOWICE",
        "40675": "KATOWICE",
        "40676": "KATOWICE",
        "40677": "KATOWICE",
        "40678": "KATOWICE",
        "40679": "KATOWICE",
        "40680": "KATOWICE",
        "40681": "KATOWICE",
        "40682": "KATOWICE",
        "40683": "KATOWICE",
        "40684": "KATOWICE",
        "40685": "KATOWICE",
        "40686": "KATOWICE",
        "40687": "KATOWICE",
        "40688": "KATOWICE",
        "40689": "KATOWICE",
        "40690": "KATOWICE",
        "40691": "KATOWICE",
        "40692": "KATOWICE",
        "40693": "KATOWICE",
        "40694": "KATOWICE",
        "40695": "KATOWICE",
        "40696": "KATOWICE",
        "40697": "KATOWICE",
        "40698": "KATOWICE",
        "40701": "KATOWICE",
        "40702": "KATOWICE",
        "40703": "KATOWICE",
        "40704": "KATOWICE",
        "40705": "KATOWICE",
        "40706": "KATOWICE",
        "40707": "KATOWICE",
        "40708": "KATOWICE",
        "40709": "KATOWICE",
        "40710": "KATOWICE",
        "40711": "KATOWICE",
        "40712": "KATOWICE",
        "40713": "KATOWICE",
        "40714": "KATOWICE",
        "40715": "KATOWICE",
        "40716": "KATOWICE",
        "40717": "KATOWICE",
        "40718": "KATOWICE",
        "40719": "KATOWICE",
        "40720": "KATOWICE",
        "40721": "KATOWICE",
        "40722": "KATOWICE",
        "40723": "KATOWICE",
        "40724": "KATOWICE",
        "40725": "KATOWICE",
        "40728": "KATOWICE",
        "40729": "KATOWICE",
        "40730": "KATOWICE",
        "40731": "KATOWICE",
        "40732": "KATOWICE",
        "40733": "KATOWICE",
        "40734": "KATOWICE",
        "40736": "KATOWICE",
        "40737": "KATOWICE",
        "40738": "KATOWICE",
        "40739": "KATOWICE",
        "40740": "KATOWICE",
        "40741": "KATOWICE",
        "40742": "KATOWICE",
        "40743": "KATOWICE",
        "40748": "KATOWICE",
        "40749": "KATOWICE",
        "40750": "KATOWICE",
        "40751": "KATOWICE",
        "40752": "KATOWICE",
        "40753": "KATOWICE",
        "40754": "KATOWICE",
        "40755": "KATOWICE",
        "40756": "KATOWICE",
        "40757": "KATOWICE",
        "40758": "KATOWICE",
        "40759": "KATOWICE",
        "40760": "KATOWICE",
        "40761": "KATOWICE",
        "40762": "KATOWICE",
        "40763": "KATOWICE",
        "40764": "KATOWICE",
        "40765": "KATOWICE",
        "40766": "KATOWICE",
        "40767": "KATOWICE",
        "40768": "KATOWICE",
        "40769": "KATOWICE",
        "40770": "KATOWICE",
        "40771": "KATOWICE",
        "40772": "KATOWICE",
        "40773": "KATOWICE",
        "40774": "KATOWICE",
        "40775": "KATOWICE",
        "40776": "KATOWICE",
        "40777": "KATOWICE",
        "40778": "KATOWICE",
        "40779": "KATOWICE",
        "40780": "KATOWICE",
        "40781": "KATOWICE",
        "40782": "KATOWICE",
        "40783": "KATOWICE",
        "40801": "KATOWICE",
        "40802": "KATOWICE",
        "40803": "KATOWICE",
        "40804": "KATOWICE",
        "40805": "KATOWICE",
        "40806": "KATOWICE",
        "40807": "KATOWICE",
        "40808": "KATOWICE",
        "40809": "KATOWICE",
        "40810": "KATOWICE",
        "40812": "KATOWICE",
        "40813": "KATOWICE",
        "40815": "KATOWICE",
        "40816": "KATOWICE",
        "40817": "KATOWICE",
        "40818": "KATOWICE",
        "40819": "KATOWICE",
        "40820": "KATOWICE",
        "40821": "KATOWICE",
        "40823": "KATOWICE",
        "40824": "KATOWICE",
        "40826": "KATOWICE",
        "40831": "KATOWICE",
        "40832": "KATOWICE",
        "40833": "KATOWICE",
        "40834": "KATOWICE",
        "40836": "KATOWICE",
        "40837": "KATOWICE",
        "40841": "KATOWICE",
        "40842": "KATOWICE",
        "40843": "KATOWICE",
        "40844": "KATOWICE",
        "40845": "KATOWICE",
        "40846": "KATOWICE",
        "40847": "KATOWICE",
        "40848": "KATOWICE",
        "40850": "KATOWICE",
        "40851": "KATOWICE",
        "40852": "KATOWICE",
        "40853": "KATOWICE",
        "40854": "KATOWICE",
        "40855": "KATOWICE",
        "40856": "KATOWICE",
        "40857": "KATOWICE",
        "40858": "KATOWICE",
        "40859": "KATOWICE",
        "40860": "KATOWICE",
        "40861": "KATOWICE",
        "40862": "KATOWICE",
        "40863": "KATOWICE",
        "40865": "KATOWICE",
        "40866": "KATOWICE",
        "40867": "KATOWICE",
        "40868": "KATOWICE",
        "40869": "KATOWICE",
        "40870": "KATOWICE",
        "40871": "KATOWICE",
        "40872": "KATOWICE",
        "40873": "KATOWICE",
        "40874": "KATOWICE",
        "40875": "KATOWICE",
        "40876": "KATOWICE",
        "40877": "KATOWICE",
        "40878": "KATOWICE",
        "40881": "KATOWICE",
        "40887": "KATOWICE",
        "40892": "KATOWICE",
        "40900": "KATOWICE",
        "40923": "KATOWICE",
        "40925": "KATOWICE",
        "40927": "KATOWICE",
        "40929": "KATOWICE",
        "40930": "KATOWICE",
        "40940": "KATOWICE",
        "40950": "KATOWICE",
        "40955": "KATOWICE",
        "40959": "KATOWICE",
        "40980": "KATOWICE",
        "41100": "SIEMIANOWICE ŚLĄSKIE",
        "41103": "SIEMIANOWICE ŚLĄSKIE",
        "41106": "SIEMIANOWICE ŚLĄSKIE",
        "41200": "SOSNOWIEC",
        "41203": "SOSNOWIEC",
        "41205": "SOSNOWIEC",
        "41206": "SOSNOWIEC",
        "41207": "SOSNOWIEC",
        "41208": "SOSNOWIEC",
        "41209": "SOSNOWIEC",
        "41210": "SOSNOWIEC",
        "41211": "SOSNOWIEC",
        "41213": "SOSNOWIEC",
        "41214": "SOSNOWIEC",
        "41215": "SOSNOWIEC",
        "41216": "SOSNOWIEC",
        "41217": "SOSNOWIEC",
        "41218": "SOSNOWIEC",
        "41219": "SOSNOWIEC",
        "41220": "SOSNOWIEC",
        "41221": "SOSNOWIEC",
        "41250": "CZELADŹ",
        "41253": "CZELADŹ",
        "41254": "CZELADŹ",
        "41260": "BĘDZIN",
        "41300": "DĄBROWA GÓRNICZA",
        "41303": "DĄBROWA GÓRNICZA",
        "41304": "DĄBROWA GÓRNICZA",
        "41306": "DĄBROWA GÓRNICZA",
        "41308": "DĄBROWA GÓRNICZA",
        "41310": "DĄBROWA GÓRNICZA",
        "41400": "MYSŁOWICE",
        "41401": "MYSŁOWICE",
        "41403": "BIERUŃ",
        "41404": "MYSŁOWICE",
        "41406": "MYSŁOWICE",
        "41407": "BIERUŃ",
        "41408": "MYSŁOWICE",
        "41409": "MYSŁOWICE",
        "41410": "MYSŁOWICE",
        "41412": "MYSŁOWICE",
        "41500": "CHORZÓW",
        "41503": "CHORZÓW",
        "41504": "CHORZÓW",
        "41506": "CHORZÓW",
        "41507": "CHORZÓW",
        "41512": "CHORZÓW",
        "41513": "CHORZÓW",
        "41515": "CHORZÓW",
        "41516": "CHORZÓW",
        "41530": "CHORZÓW",
        "41600": "ŚWIĘTOCHŁOWICE",
        "41603": "ŚWIĘTOCHŁOWICE",
        "41605": "ŚWIĘTOCHŁOWICE",
        "41608": "ŚWIĘTOCHŁOWICE",
        "41700": "RUDA ŚLĄSKA",
        "41703": "RUDA ŚLĄSKA",
        "41705": "RUDA ŚLĄSKA",
        "41706": "RUDA ŚLĄSKA",
        "41707": "RUDA ŚLĄSKA",
        "41709": "RUDA ŚLĄSKA",
        "41710": "RUDA ŚLĄSKA",
        "41711": "RUDA ŚLĄSKA",
        "41712": "RUDA ŚLĄSKA",
        "41713": "RUDA ŚLĄSKA",
        "41714": "RUDA ŚLĄSKA",
        "41717": "RUDA ŚLĄSKA",
        "41800": "ZABRZE",
        "41803": "ZABRZE",
        "41805": "ZABRZE",
        "41806": "ZABRZE",
        "41807": "ZABRZE",
        "41808": "ZABRZE",
        "41809": "ZABRZE",
        "41810": "ZABRZE",
        "41811": "ZABRZE",
        "41813": "ZABRZE",
        "41814": "ZABRZE",
        "41815": "ZABRZE",
        "41818": "ZABRZE",
        "41819": "ZABRZE",
        "41820": "ZABRZE",
        "41821": "ZABRZE",
        "41822": "ZABRZE",
        "41840": "ZABRZE",
        "41849": "ZABRZE",
        "41851": "ZABRZE",
        "41900": "BYTOM",
        "41902": "BYTOM",
        "41905": "BYTOM",
        "41906": "BYTOM",
        "41907": "BYTOM",
        "41908": "BYTOM",
        "41909": "BYTOM",
        "41910": "BYTOM",
        "41914": "BYTOM",
        "41915": "BYTOM",
        "41916": "BYTOM",
        "41922": "TARNOWSKIE GÓRY",
        "41923": "BYTOM",
        "41925": "BYTOM",
        "41926": "BYTOM",
        "41927": "BYTOM",
        "41933": "BYTOM",
        "41935": "BYTOM",
        "41936": "BYTOM",
        "41940": "PIEKARY ŚLĄSKIE",
        "41943": "PIEKARY ŚLĄSKIE",
        "41945": "PIEKARY ŚLĄSKIE",
        "41946": "PIEKARY ŚLĄSKIE",
        "41948": "PIEKARY ŚLĄSKIE",
        "41949": "PIEKARY ŚLĄSKIE",
        "42100": "KŁOBUCK",
        "42110": "KŁOBUCK",
        "42120": "KŁOBUCK",
        "42122": "KŁOBUCK",
        "42125": "KŁOBUCK",
        "42130": "KŁOBUCK",
        "42133": "KŁOBUCK",
        "42134": "KŁOBUCK",
        "42140": "KŁOBUCK",
        "42141": "KŁOBUCK",
        "42142": "KŁOBUCK",
        "42151": "KŁOBUCK",
        "42152": "KŁOBUCK",
        "42160": "KRZEPICE",
        "42161": "KŁOBUCK",
        "42164": "KŁOBUCK",
        "42165": "KŁOBUCK",
        "42166": "KŁOBUCK",
        "42200": "CZĘSTOCHOWA",
        "42201": "CZĘSTOCHOWA",
        "42202": "CZĘSTOCHOWA",
        "42203": "CZĘSTOCHOWA",
        "42204": "CZĘSTOCHOWA",
        "42205": "CZĘSTOCHOWA",
        "42207": "CZĘSTOCHOWA",
        "42208": "CZĘSTOCHOWA",
        "42209": "CZĘSTOCHOWA",
        "42210": "CZĘSTOCHOWA",
        "42211": "CZĘSTOCHOWA",
        "42213": "CZĘSTOCHOWA",
        "42214": "CZĘSTOCHOWA",
        "42215": "CZĘSTOCHOWA",
        "42216": "CZĘSTOCHOWA",
        "42217": "CZĘSTOCHOWA",
        "42218": "CZĘSTOCHOWA",
        "42219": "CZĘSTOCHOWA",
        "42221": "CZĘSTOCHOWA",
        "42224": "CZĘSTOCHOWA",
        "42225": "CZĘSTOCHOWA",
        "42226": "CZĘSTOCHOWA",
        "42227": "CZĘSTOCHOWA",
        "42228": "CZĘSTOCHOWA",
        "42229": "CZĘSTOCHOWA",
        "42230": "KONIECPOL",
        "42231": "CZĘSTOCHOWA",
        "42233": "CZĘSTOCHOWA",
        "42235": "CZĘSTOCHOWA",
        "42240": "RUDNIKI (NET)",
        "42242": "CZĘSTOCHOWA",
        "42244": "CZĘSTOCHOWA",
        "42248": "CZĘSTOCHOWA",
        "42250": "CZĘSTOCHOWA",
        "42253": "CZĘSTOCHOWA",
        "42256": "CZĘSTOCHOWA",
        "42260": "CZĘSTOCHOWA",
        "42261": "CZĘSTOCHOWA",
        "42262": "CZĘSTOCHOWA",
        "42263": "CZĘSTOCHOWA",
        "42265": "CZĘSTOCHOWA",
        "42270": "CZĘSTOCHOWA",
        "42271": "CZĘSTOCHOWA",
        "42274": "CZĘSTOCHOWA",
        "42280": "CZĘSTOCHOWA",
        "42282": "CZĘSTOCHOWA",
        "42283": "LUBLINIEC",
        "42284": "LUBLINIEC",
        "42286": "LUBLINIEC",
        "42287": "LUBLINIEC",
        "42288": "LUBLINIEC",
        "42289": "LUBLINIEC",
        "42290": "CZĘSTOCHOWA",
        "42293": "CZĘSTOCHOWA",
        "42294": "CZĘSTOCHOWA",
        "42300": "MYSZKÓW",
        "42310": "MYSZKÓW",
        "42311": "MYSZKÓW",
        "42320": "MYSZKÓW",
        "42330": "MYSZKÓW",
        "42350": "MYSZKÓW",
        "42360": "MYSZKÓW",
        "42400": "ZAWIERCIE",
        "42403": "ZAWIERCIE",
        "42404": "ZAWIERCIE",
        "42421": "ZAWIERCIE",
        "42425": "ZAWIERCIE",
        "42427": "ZAWIERCIE",
        "42431": "ZAWIERCIE",
        "42436": "ZAWIERCIE",
        "42439": "ZAWIERCIE",
        "42440": "ZAWIERCIE",
        "42445": "SZCZEKOCINY",
        "42446": "ZAWIERCIE",
        "42450": "ZAWIERCIE",
        "42451": "ZAWIERCIE",
        "42453": "ZAWIERCIE",
        "42454": "ZAWIERCIE",
        "42456": "ZAWIERCIE",
        "42457": "ZAWIERCIE",
        "42458": "ZAWIERCIE",
        "42460": "BĘDZIN",
        "42470": "SIEWIERZ",
        "42471": "BRUDZOWICE",
        "42480": "ZAWIERCIE",
        "42500": "BĘDZIN",
        "42504": "BĘDZIN",
        "42505": "BĘDZIN",
        "42506": "BĘDZIN",
        "42510": "WOJKOWICE",
        "42512": "BĘDZIN",
        "42519": "BĘDZIN",
        "42520": "DĄBROWA GÓRNICZA",
        "42522": "DĄBROWA GÓRNICZA",
        "42523": "DĄBROWA GÓRNICZA",
        "42524": "DĄBROWA GÓRNICZA",
        "42530": "DĄBROWA GÓRNICZA",
        "42552": "BĘDZIN",
        "42575": "BĘDZIN",
        "42580": "WOJKOWICE",
        "42582": "BĘDZIN",
        "42583": "BĘDZIN",
        "42584": "BĘDZIN",
        "42595": "BĘDZIN",
        "42600": "TARNOWSKIE GÓRY",
        "42603": "TARNOWSKIE GÓRY",
        "42605": "TARNOWSKIE GÓRY",
        "42606": "TARNOWSKIE GÓRY",
        "42609": "TARNOWSKIE GÓRY",
        "42610": "MIASTECZKO ŚLĄSKIE",
        "42612": "TARNOWSKIE GÓRY",
        "42620": "TARNOWSKIE GÓRY",
        "42622": "TARNOWSKIE GÓRY",
        "42624": "TĄPKOWICE",
        "42625": "TARNOWSKIE GÓRY",
        "42660": "TARNOWSKIE GÓRY",
        "42665": "TARNOWSKIE GÓRY",
        "42672": "TARNOWSKIE GÓRY",
        "42674": "TARNOWSKIE GÓRY",
        "42675": "TARNOWSKIE GÓRY",
        "42676": "TARNOWSKIE GÓRY",
        "42677": "TARNOWSKIE GÓRY",
        "42680": "TARNOWSKIE GÓRY",
        "42690": "TARNOWSKIE GÓRY",
        "42691": "TARNOWSKIE GÓRY",
        "42693": "TARNOWSKIE GÓRY",
        "42700": "LUBLINIEC",
        "42703": "LUBLINIEC",
        "42713": "LUBLINIEC",
        "42714": "LUBLINIEC",
        "42772": "LUBLINIEC",
        "42790": "LUBLINIEC",
        "42793": "LUBLINIEC",
        "43100": "TYCHY",
        "43105": "TYCHY",
        "43108": "TYCHY",
        "43109": "TYCHY",
        "43110": "TYCHY",
        "43130": "BIERUŃ",
        "43140": "BIERUŃ",
        "43143": "BIERUŃ",
        "43144": "BIERUŃ",
        "43150": "BIERUŃ",
        "43155": "BIERUŃ",
        "43170": "ŁAZISKA GÓRNE",
        "43171": "MIKOŁÓW",
        "43173": "ŁAZISKA GÓRNE",
        "43175": "MIKOŁÓW",
        "43176": "MIKOŁÓW",
        "43178": "MIKOŁÓW",
        "43180": "MIKOŁÓW",
        "43186": "MIKOŁÓW",
        "43187": "MIKOŁÓW",
        "43188": "MIKOŁÓW",
        "43190": "MIKOŁÓW",
        "43193": "MIKOŁÓW",
        "43195": "MIKOŁÓW",
        "43196": "MIKOŁÓW",
        "43200": "PSZCZYNA",
        "43210": "PSZCZYNA",
        "43211": "PSZCZYNA",
        "43215": "PSZCZYNA",
        "43220": "BIERUŃ",
        "43225": "PSZCZYNA",
        "43227": "PSZCZYNA",
        "43229": "PSZCZYNA",
        "43230": "PSZCZYNA",
        "43241": "PSZCZYNA",
        "43243": "PSZCZYNA",
        "43245": "PSZCZYNA",
        "43246": "CIESZYN",
        "43250": "PSZCZYNA",
        "43251": "PSZCZYNA",
        "43252": "PSZCZYNA",
        "43253": "PSZCZYNA",
        "43254": "PSZCZYNA",
        "43262": "PSZCZYNA",
        "43265": "PSZCZYNA",
        "43267": "PSZCZYNA",
        "43300": "BIELSKO-BIAŁA",
        "43301": "BIELSKO-BIAŁA",
        "43302": "BIELSKO-BIAŁA",
        "43303": "BIELSKO-BIAŁA",
        "43304": "BIELSKO-BIAŁA",
        "43305": "BIELSKO-BIAŁA",
        "43306": "BIELSKO-BIAŁA",
        "43307": "BIELSKO-BIAŁA",
        "43308": "BIELSKO-BIAŁA",
        "43309": "BIELSKO-BIAŁA",
        "43310": "BIELSKO-BIAŁA",
        "43311": "BIELSKO-BIAŁA",
        "43316": "BIELSKO-BIAŁA",
        "43317": "BIELSKO-BIAŁA",
        "43318": "BIELSKO-BIAŁA",
        "43319": "BIELSKO-BIAŁA",
        "43330": "BIELSKO-BIAŁA",
        "43331": "BIELSKO-BIAŁA",
        "43332": "PISARZOWICE",
        "43340": "BIELSKO-BIAŁA",
        "43344": "BIELSKO-BIAŁA",
        "43346": "BIELSKO-BIAŁA",
        "43350": "BIELSKO-BIAŁA",
        "43353": "BIELSKO-BIAŁA",
        "43354": "BIELSKO-BIAŁA",
        "43356": "BIELSKO-BIAŁA",
        "43360": "BIELSKO-BIAŁA",
        "43365": "BIELSKO-BIAŁA",
        "43370": "BIELSKO-BIAŁA",
        "43374": "BIELSKO-BIAŁA",
        "43376": "BIELSKO-BIAŁA",
        "43378": "BIELSKO-BIAŁA",
        "43382": "BIELSKO-BIAŁA",
        "43384": "BIELSKO-BIAŁA",
        "43385": "BIELSKO-BIAŁA",
        "43386": "BIELSKO-BIAŁA",
        "43391": "BIELSKO-BIAŁA",
        "43392": "BIELSKO-BIAŁA",
        "43394": "BIELSKO-BIAŁA",
        "43400": "CIESZYN",
        "43410": "CIESZYN",
        "43416": "CIESZYN",
        "43417": "CIESZYN",
        "43418": "CIESZYN",
        "43419": "CIESZYN",
        "43424": "CIESZYN",
        "43426": "CIESZYN",
        "43430": "SKOCZÓW",
        "43436": "CIESZYN",
        "43438": "CIESZYN",
        "43440": "CIESZYN",
        "43445": "CIESZYN",
        "43450": "USTROŃ",
        "43460": "WISŁA",
        "43470": "CIESZYN",
        "43474": "CIESZYN",
        "43476": "CIESZYN",
        "43500": "CZECHOWICE-DZIEDZICE",
        "43502": "CZECHOWICE-DZIEDZICE",
        "43503": "CZECHOWICE-DZIEDZICE",
        "43512": "BIELSKO-BIAŁA",
        "43514": "BIELSKO-BIAŁA",
        "43516": "BIELSKO-BIAŁA",
        "43518": "BIELSKO-BIAŁA",
        "43520": "CIESZYN",
        "43523": "CIESZYN",
        "43600": "JAWORZNO",
        "43602": "JAWORZNO",
        "43603": "JAWORZNO",
        "43605": "JAWORZNO",
        "43607": "JAWORZNO",
        "43608": "JAWORZNO",
        "43609": "JAWORZNO",
        "44100": "GLIWICE",
        "44102": "GLIWICE",
        "44103": "GLIWICE",
        "44105": "GLIWICE",
        "44106": "GLIWICE",
        "44107": "GLIWICE",
        "44109": "GLIWICE",
        "44113": "GLIWICE",
        "44114": "GLIWICE",
        "44117": "GLIWICE",
        "44119": "GLIWICE",
        "44120": "PYSKOWICE",
        "44121": "GLIWICE",
        "44122": "GLIWICE",
        "44123": "PYSKOWICE",
        "44141": "GLIWICE",
        "44144": "GLIWICE",
        "44145": "GLIWICE",
        "44151": "GLIWICE",
        "44152": "GLIWICE",
        "44153": "GLIWICE",
        "44154": "GLIWICE",
        "44156": "GLIWICE",
        "44160": "GLIWICE",
        "44161": "GLIWICE",
        "44164": "GLIWICE",
        "44171": "GLIWICE",
        "44172": "GLIWICE",
        "44177": "GLIWICE",
        "44178": "GLIWICE",
        "44180": "GLIWICE",
        "44181": "GLIWICE",
        "44186": "GLIWICE",
        "44187": "GLIWICE",
        "44189": "GLIWICE",
        "44190": "GLIWICE",
        "44191": "GLIWICE",
        "44193": "GLIWICE",
        "44194": "GLIWICE",
        "44196": "GLIWICE",
        "44200": "RYBNIK",
        "44201": "RYBNIK",
        "44203": "RYBNIK",
        "44206": "RYBNIK",
        "44207": "RYBNIK",
        "44210": "RYBNIK",
        "44213": "RYBNIK",
        "44217": "RYBNIK",
        "44218": "RYBNIK",
        "44230": "CZERWIONKA-LESZCZYNY",
        "44237": "RYBNIK",
        "44238": "CZERWIONKA-LESZCZYNY",
        "44240": "ŻORY",
        "44241": "ŻORY",
        "44244": "ŻORY",
        "44245": "ŻORY",
        "44246": "RYBNIK",
        "44247": "ŻORY",
        "44250": "RYBNIK",
        "44251": "RYBNIK",
        "44253": "RYBNIK",
        "44264": "RYBNIK",
        "44266": "RYBNIK",
        "44268": "JASTRZĘBIE-ZDRÓJ",
        "44270": "RYBNIK",
        "44273": "RYBNIK",
        "44274": "RYBNIK",
        "44280": "RYDUŁTOWY",
        "44282": "RYBNIK",
        "44284": "RYBNIK",
        "44285": "RACIBÓRZ (NET)",
        "44286": "WODZISŁAW ŚLĄSKI",
        "44290": "RYBNIK",
        "44292": "RYBNIK",
        "44293": "RYBNIK",
        "44295": "RYBNIK",
        "44300": "WODZISŁAW ŚLĄSKI",
        "44304": "WODZISŁAW ŚLĄSKI",
        "44307": "WODZISŁAW ŚLĄSKI",
        "44310": "RADLIN",
        "44313": "WODZISŁAW ŚLĄSKI",
        "44314": "RADLIN",
        "44321": "WODZISŁAW ŚLĄSKI",
        "44323": "WODZISŁAW ŚLĄSKI",
        "44325": "WODZISŁAW ŚLĄSKI",
        "44330": "JASTRZĘBIE-ZDRÓJ",
        "44335": "JASTRZĘBIE-ZDRÓJ",
        "44336": "JASTRZĘBIE-ZDRÓJ",
        "44337": "JASTRZĘBIE-ZDRÓJ",
        "44338": "JASTRZĘBIE-ZDRÓJ",
        "44340": "WODZISŁAW ŚLĄSKI",
        "44341": "WODZISŁAW ŚLĄSKI",
        "44348": "WODZISŁAW ŚLĄSKI",
        "44350": "WODZISŁAW ŚLĄSKI",
        "44351": "WODZISŁAW ŚLĄSKI",
        "44352": "WODZISŁAW ŚLĄSKI",
        "44353": "WODZISŁAW ŚLĄSKI",
        "44360": "WODZISŁAW ŚLĄSKI",
        "44361": "WODZISŁAW ŚLĄSKI",
        "44362": "WODZISŁAW ŚLĄSKI",
        "44370": "WODZISŁAW ŚLĄSKI",
        "44373": "WODZISŁAW ŚLĄSKI",
        "44401": "GLIWICE",
        "45001": "OPOLE",
        "45002": "OPOLE",
        "45003": "OPOLE",
        "45004": "OPOLE",
        "45005": "OPOLE",
        "45006": "OPOLE",
        "45007": "OPOLE",
        "45009": "OPOLE",
        "45010": "OPOLE",
        "45011": "OPOLE",
        "45012": "OPOLE",
        "45013": "OPOLE",
        "45015": "OPOLE",
        "45016": "OPOLE",
        "45017": "OPOLE",
        "45018": "OPOLE",
        "45019": "OPOLE",
        "45020": "OPOLE",
        "45021": "OPOLE",
        "45022": "OPOLE",
        "45023": "OPOLE",
        "45024": "OPOLE",
        "45025": "OPOLE",
        "45026": "OPOLE",
        "45027": "OPOLE",
        "45030": "OPOLE",
        "45031": "OPOLE",
        "45032": "OPOLE",
        "45033": "OPOLE",
        "45034": "OPOLE",
        "45035": "OPOLE",
        "45036": "OPOLE",
        "45037": "OPOLE",
        "45038": "OPOLE",
        "45039": "OPOLE",
        "45040": "OPOLE",
        "45044": "OPOLE",
        "45045": "OPOLE",
        "45046": "OPOLE",
        "45047": "OPOLE",
        "45048": "OPOLE",
        "45049": "OPOLE",
        "45050": "OPOLE",
        "45051": "OPOLE",
        "45052": "OPOLE",
        "45053": "OPOLE",
        "45054": "OPOLE",
        "45055": "OPOLE",
        "45056": "OPOLE",
        "45057": "OPOLE",
        "45058": "OPOLE",
        "45059": "OPOLE",
        "45061": "OPOLE",
        "45062": "OPOLE",
        "45064": "OPOLE",
        "45065": "OPOLE",
        "45066": "OPOLE",
        "45067": "OPOLE",
        "45068": "OPOLE",
        "45069": "OPOLE",
        "45070": "OPOLE",
        "45071": "OPOLE",
        "45072": "OPOLE",
        "45073": "OPOLE",
        "45075": "OPOLE",
        "45076": "OPOLE",
        "45077": "OPOLE",
        "45078": "OPOLE",
        "45079": "OPOLE",
        "45080": "OPOLE",
        "45081": "OPOLE",
        "45083": "OPOLE",
        "45084": "OPOLE",
        "45085": "OPOLE",
        "45086": "OPOLE",
        "45087": "OPOLE",
        "45088": "OPOLE",
        "45089": "OPOLE",
        "45090": "OPOLE",
        "45091": "OPOLE",
        "45092": "OPOLE",
        "45094": "OPOLE",
        "45108": "OPOLE",
        "45109": "OPOLE",
        "45110": "OPOLE",
        "45111": "OPOLE",
        "45112": "OPOLE",
        "45113": "OPOLE",
        "45114": "OPOLE",
        "45115": "OPOLE",
        "45116": "OPOLE",
        "45117": "OPOLE",
        "45118": "OPOLE",
        "45119": "OPOLE",
        "45121": "OPOLE",
        "45123": "OPOLE",
        "45124": "OPOLE",
        "45125": "OPOLE",
        "45126": "OPOLE",
        "45127": "OPOLE",
        "45128": "OPOLE",
        "45129": "OPOLE",
        "45131": "OPOLE",
        "45132": "OPOLE",
        "45133": "OPOLE",
        "45134": "OPOLE",
        "45135": "OPOLE",
        "45136": "OPOLE",
        "45137": "OPOLE",
        "45138": "OPOLE",
        "45139": "OPOLE",
        "45141": "OPOLE",
        "45142": "OPOLE",
        "45143": "OPOLE",
        "45144": "OPOLE",
        "45145": "OPOLE",
        "45215": "OPOLE",
        "45217": "OPOLE",
        "45218": "OPOLE",
        "45219": "OPOLE",
        "45220": "OPOLE",
        "45221": "OPOLE",
        "45222": "OPOLE",
        "45223": "OPOLE",
        "45224": "OPOLE",
        "45225": "OPOLE",
        "45226": "OPOLE",
        "45227": "OPOLE",
        "45228": "OPOLE",
        "45229": "OPOLE",
        "45230": "OPOLE",
        "45231": "OPOLE",
        "45232": "OPOLE",
        "45233": "OPOLE",
        "45234": "OPOLE",
        "45235": "OPOLE",
        "45236": "OPOLE",
        "45237": "OPOLE",
        "45238": "OPOLE",
        "45239": "OPOLE",
        "45240": "OPOLE",
        "45241": "OPOLE",
        "45265": "OPOLE",
        "45266": "OPOLE",
        "45267": "OPOLE",
        "45268": "OPOLE",
        "45269": "OPOLE",
        "45271": "OPOLE",
        "45272": "OPOLE",
        "45273": "OPOLE",
        "45282": "OPOLE",
        "45283": "OPOLE",
        "45284": "OPOLE",
        "45285": "OPOLE",
        "45286": "OPOLE",
        "45287": "OPOLE",
        "45288": "OPOLE",
        "45290": "OPOLE",
        "45291": "OPOLE",
        "45301": "OPOLE",
        "45302": "OPOLE",
        "45303": "OPOLE",
        "45304": "OPOLE",
        "45305": "OPOLE",
        "45306": "OPOLE",
        "45307": "OPOLE",
        "45308": "OPOLE",
        "45309": "OPOLE",
        "45310": "OPOLE",
        "45311": "OPOLE",
        "45312": "OPOLE",
        "45313": "OPOLE",
        "45314": "OPOLE",
        "45315": "OPOLE",
        "45316": "OPOLE",
        "45317": "OPOLE",
        "45318": "OPOLE",
        "45319": "OPOLE",
        "45320": "OPOLE",
        "45321": "OPOLE",
        "45323": "OPOLE",
        "45324": "OPOLE",
        "45325": "OPOLE",
        "45326": "OPOLE",
        "45331": "OPOLE",
        "45332": "OPOLE",
        "45339": "OPOLE",
        "45340": "OPOLE",
        "45342": "OPOLE",
        "45344": "OPOLE",
        "45346": "OPOLE",
        "45347": "OPOLE",
        "45348": "OPOLE",
        "45349": "OPOLE",
        "45351": "OPOLE",
        "45352": "OPOLE",
        "45353": "OPOLE",
        "45354": "OPOLE",
        "45355": "OPOLE",
        "45356": "OPOLE",
        "45357": "OPOLE",
        "45358": "OPOLE",
        "45359": "OPOLE",
        "45360": "OPOLE",
        "45361": "OPOLE",
        "45362": "OPOLE",
        "45363": "OPOLE",
        "45364": "OPOLE",
        "45365": "OPOLE",
        "45367": "OPOLE",
        "45368": "OPOLE",
        "45370": "OPOLE",
        "45371": "OPOLE",
        "45372": "OPOLE",
        "45373": "OPOLE",
        "45401": "OPOLE",
        "45402": "OPOLE",
        "45403": "OPOLE",
        "45404": "OPOLE",
        "45405": "OPOLE",
        "45406": "OPOLE",
        "45407": "OPOLE",
        "45408": "OPOLE",
        "45409": "OPOLE",
        "45410": "OPOLE",
        "45411": "OPOLE",
        "45413": "OPOLE",
        "45414": "OPOLE",
        "45415": "OPOLE",
        "45416": "OPOLE",
        "45417": "OPOLE",
        "45418": "OPOLE",
        "45419": "OPOLE",
        "45420": "OPOLE",
        "45424": "OPOLE",
        "45425": "OPOLE",
        "45427": "OPOLE",
        "45428": "OPOLE",
        "45429": "OPOLE",
        "45430": "OPOLE",
        "45431": "OPOLE",
        "45432": "OPOLE",
        "45433": "OPOLE",
        "45434": "OPOLE",
        "45435": "OPOLE",
        "45436": "OPOLE",
        "45437": "OPOLE",
        "45438": "OPOLE",
        "45439": "OPOLE",
        "45440": "OPOLE",
        "45441": "OPOLE",
        "45442": "OPOLE",
        "45443": "OPOLE",
        "45446": "OPOLE",
        "45449": "OPOLE",
        "45459": "OPOLE",
        "45460": "OPOLE",
        "45461": "OPOLE",
        "45462": "OPOLE",
        "45463": "OPOLE",
        "45464": "OPOLE",
        "45465": "OPOLE",
        "45466": "OPOLE",
        "45467": "OPOLE",
        "45468": "OPOLE",
        "45469": "OPOLE",
        "45470": "OPOLE",
        "45471": "OPOLE",
        "45472": "OPOLE",
        "45473": "OPOLE",
        "45474": "OPOLE",
        "45475": "OPOLE",
        "45476": "OPOLE",
        "45477": "OPOLE",
        "45478": "OPOLE",
        "45512": "OPOLE",
        "45513": "OPOLE",
        "45514": "OPOLE",
        "45515": "OPOLE",
        "45516": "OPOLE",
        "45517": "OPOLE",
        "45518": "OPOLE",
        "45519": "OPOLE",
        "45520": "OPOLE",
        "45521": "OPOLE",
        "45522": "OPOLE",
        "45523": "OPOLE",
        "45524": "OPOLE",
        "45525": "OPOLE",
        "45526": "OPOLE",
        "45527": "OPOLE",
        "45528": "OPOLE",
        "45529": "OPOLE",
        "45530": "OPOLE",
        "45531": "OPOLE",
        "45532": "OPOLE",
        "45533": "OPOLE",
        "45534": "OPOLE",
        "45535": "OPOLE",
        "45536": "OPOLE",
        "45542": "OPOLE",
        "45543": "OPOLE",
        "45550": "OPOLE",
        "45551": "OPOLE",
        "45552": "OPOLE",
        "45553": "OPOLE",
        "45554": "OPOLE",
        "45555": "OPOLE",
        "45556": "OPOLE",
        "45557": "OPOLE",
        "45558": "OPOLE",
        "45559": "OPOLE",
        "45560": "OPOLE",
        "45561": "OPOLE",
        "45562": "OPOLE",
        "45563": "OPOLE",
        "45564": "OPOLE",
        "45565": "OPOLE",
        "45568": "OPOLE",
        "45569": "OPOLE",
        "45570": "OPOLE",
        "45571": "OPOLE",
        "45572": "OPOLE",
        "45573": "OPOLE",
        "45574": "OPOLE",
        "45575": "OPOLE",
        "45577": "OPOLE",
        "45578": "OPOLE",
        "45580": "OPOLE",
        "45586": "OPOLE",
        "45587": "OPOLE",
        "45588": "OPOLE",
        "45590": "OPOLE",
        "45591": "OPOLE",
        "45592": "OPOLE",
        "45593": "OPOLE",
        "45594": "OPOLE",
        "45601": "OPOLE",
        "45612": "OPOLE",
        "45618": "OPOLE",
        "45622": "OPOLE",
        "45623": "OPOLE",
        "45624": "OPOLE",
        "45625": "OPOLE",
        "45626": "OPOLE",
        "45627": "OPOLE",
        "45628": "OPOLE",
        "45630": "OPOLE",
        "45631": "OPOLE",
        "45632": "OPOLE",
        "45633": "OPOLE",
        "45634": "OPOLE",
        "45635": "OPOLE",
        "45636": "OPOLE",
        "45638": "OPOLE",
        "45639": "OPOLE",
        "45640": "OPOLE",
        "45641": "OPOLE",
        "45642": "OPOLE",
        "45644": "OPOLE",
        "45645": "OPOLE",
        "45646": "OPOLE",
        "45647": "OPOLE",
        "45648": "OPOLE",
        "45649": "OPOLE",
        "45650": "OPOLE",
        "45651": "OPOLE",
        "45652": "OPOLE",
        "45653": "OPOLE",
        "45654": "OPOLE",
        "45655": "OPOLE",
        "45656": "OPOLE",
        "45660": "OPOLE",
        "45661": "OPOLE",
        "45662": "OPOLE",
        "45663": "OPOLE",
        "45665": "OPOLE",
        "45667": "OPOLE",
        "45668": "OPOLE",
        "45669": "OPOLE",
        "45670": "OPOLE",
        "45671": "OPOLE",
        "45675": "OPOLE",
        "45676": "OPOLE",
        "45677": "OPOLE",
        "45678": "OPOLE",
        "45679": "OPOLE",
        "45680": "OPOLE",
        "45681": "OPOLE",
        "45682": "OPOLE",
        "45683": "OPOLE",
        "45684": "OPOLE",
        "45685": "OPOLE",
        "45686": "OPOLE",
        "45687": "OPOLE",
        "45688": "OPOLE",
        "45701": "OPOLE",
        "45702": "OPOLE",
        "45703": "OPOLE",
        "45704": "OPOLE",
        "45705": "OPOLE",
        "45706": "OPOLE",
        "45707": "OPOLE",
        "45708": "OPOLE",
        "45709": "OPOLE",
        "45710": "OPOLE",
        "45711": "OPOLE",
        "45712": "OPOLE",
        "45713": "OPOLE",
        "45714": "OPOLE",
        "45715": "OPOLE",
        "45716": "OPOLE",
        "45717": "OPOLE",
        "45720": "OPOLE",
        "45721": "OPOLE",
        "45722": "OPOLE",
        "45723": "OPOLE",
        "45724": "OPOLE",
        "45725": "OPOLE",
        "45726": "OPOLE",
        "45751": "OPOLE",
        "45752": "OPOLE",
        "45753": "OPOLE",
        "45754": "OPOLE",
        "45755": "OPOLE",
        "45756": "OPOLE",
        "45757": "OPOLE",
        "45758": "OPOLE",
        "45759": "OPOLE",
        "45760": "OPOLE",
        "45761": "OPOLE",
        "45762": "OPOLE",
        "45763": "OPOLE",
        "45765": "OPOLE",
        "45766": "OPOLE",
        "45767": "OPOLE",
        "45771": "OPOLE",
        "45772": "OPOLE",
        "45773": "OPOLE",
        "45774": "OPOLE",
        "45776": "OPOLE",
        "45801": "OPOLE",
        "45802": "OPOLE",
        "45803": "OPOLE",
        "45804": "OPOLE",
        "45805": "OPOLE",
        "45806": "OPOLE",
        "45807": "OPOLE",
        "45809": "OPOLE",
        "45811": "OPOLE",
        "45814": "OPOLE",
        "45815": "OPOLE",
        "45819": "OPOLE",
        "45820": "OPOLE",
        "45821": "OPOLE",
        "45822": "OPOLE",
        "45823": "OPOLE",
        "45824": "OPOLE",
        "45825": "OPOLE",
        "45826": "OPOLE",
        "45827": "OPOLE",
        "45828": "OPOLE",
        "45829": "OPOLE",
        "45830": "OPOLE",
        "45831": "OPOLE",
        "45832": "OPOLE",
        "45833": "OPOLE",
        "45834": "OPOLE",
        "45835": "OPOLE",
        "45836": "OPOLE",
        "45837": "OPOLE",
        "45838": "OPOLE",
        "45839": "OPOLE",
        "45840": "OPOLE",
        "45841": "OPOLE",
        "45842": "OPOLE",
        "45843": "OPOLE",
        "45844": "OPOLE",
        "45850": "OPOLE",
        "45852": "OPOLE",
        "45853": "OPOLE",
        "45854": "OPOLE",
        "45855": "OPOLE",
        "45856": "OPOLE",
        "45857": "OPOLE",
        "45858": "OPOLE",
        "45859": "OPOLE",
        "45860": "OPOLE",
        "45861": "OPOLE",
        "45862": "OPOLE",
        "45863": "OPOLE",
        "45864": "OPOLE",
        "45865": "OPOLE",
        "45867": "OPOLE",
        "45899": "OPOLE",
        "45910": "OPOLE",
        "46020": "OPOLE",
        "46021": "OPOLE",
        "46022": "OPOLE",
        "46023": "OPOLE",
        "46024": "OPOLE",
        "46030": "OPOLE",
        "46034": "NAMYSŁÓW",
        "46037": "OPOLE",
        "46040": "OZIMEK",
        "46041": "OPOLE",
        "46042": "OPOLE",
        "46043": "OPOLE",
        "46045": "OPOLE",
        "46046": "OPOLE",
        "46047": "OLESNO",
        "46048": "OLESNO",
        "46050": "TARNÓW OPOLSKI",
        "46053": "OPOLE",
        "46060": "OPOLE",
        "46061": "OPOLE",
        "46070": "OPOLE",
        "46073": "OPOLE",
        "46080": "OPOLE",
        "46081": "OPOLE",
        "46082": "OPOLE",
        "46083": "OPOLE",
        "46090": "OPOLE",
        "46100": "NAMYSŁÓW",
        "46112": "NAMYSŁÓW",
        "46113": "NAMYSŁÓW",
        "46115": "NAMYSŁÓW",
        "46125": "NAMYSŁÓW",
        "46134": "NAMYSŁÓW",
        "46142": "NAMYSŁÓW",
        "46146": "NAMYSŁÓW",
        "46166": "NAMYSŁÓW",
        "46200": "KLUCZBORK",
        "46203": "KLUCZBORK",
        "46211": "KLUCZBORK",
        "46220": "KLUCZBORK",
        "46233": "KLUCZBORK",
        "46243": "KLUCZBORK",
        "46250": "WOŁCZYN",
        "46255": "KLUCZBORK",
        "46262": "SKAŁĄGI",
        "46264": "KLUCZBORK",
        "46275": "KLUCZBORK",
        "46280": "KLUCZBORK",
        "46282": "KLUCZBORK",
        "46300": "OLESNO",
        "46310": "OLESNO",
        "46312": "OLESNO",
        "46320": "OLESNO",
        "46321": "OLESNO",
        "46324": "OLESNO",
        "46325": "OLESNO",
        "46331": "OLESNO",
        "46333": "OLESNO",
        "46375": "OLESNO",
        "46380": "DOBRODZIEŃ",
        "47100": "STRZELCE OPOLSKIE",
        "47110": "STRZELCE OPOLSKIE",
        "47113": "STRZELCE OPOLSKIE",
        "47120": "STRZELCE OPOLSKIE",
        "47126": "STRZELCE OPOLSKIE",
        "47133": "STRZELCE OPOLSKIE",
        "47134": "STRZELCE OPOLSKIE",
        "47143": "STRZELCE OPOLSKIE",
        "47150": "STRZELCE OPOLSKIE",
        "47154": "STRZELCE OPOLSKIE",
        "47161": "STRZELCE OPOLSKIE",
        "47171": "STRZELCE OPOLSKIE",
        "47175": "STRZELCE OPOLSKIE",
        "47180": "STRZELCE OPOLSKIE",
        "47200": "KĘDZIERZYN-KOŹLE",
        "47205": "KĘDZIERZYN-KOŹLE",
        "47206": "KĘDZIERZYN-KOŹLE",
        "47208": "KĘDZIERZYN-KOŹLE",
        "47214": "KĘDZIERZYN-KOŹLE",
        "47220": "KĘDZIERZYN-KOŹLE",
        "47222": "KĘDZIERZYN-KOŹLE",
        "47223": "KĘDZIERZYN-KOŹLE",
        "47224": "KĘDZIERZYN-KOŹLE",
        "47225": "KĘDZIERZYN-KOŹLE",
        "47230": "KĘDZIERZYN-KOŹLE",
        "47232": "KĘDZIERZYN-KOŹLE",
        "47240": "KĘDZIERZYN-KOŹLE",
        "47244": "KĘDZIERZYN-KOŹLE",
        "47246": "KĘDZIERZYN-KOŹLE",
        "47253": "KĘDZIERZYN-KOŹLE",
        "47260": "KĘDZIERZYN-KOŹLE",
        "47263": "KĘDZIERZYN-KOŹLE",
        "47270": "KĘDZIERZYN-KOŹLE",
        "47280": "KĘDZIERZYN-KOŹLE",
        "47300": "KRAPKOWICE",
        "47303": "KRAPKOWICE",
        "47316": "KRAPKOWICE",
        "47320": "KRAPKOWICE",
        "47325": "KRAPKOWICE",
        "47330": "ZDZIESZOWICE",
        "47340": "PRUDNIK",
        "47341": "KRAPKOWICE",
        "47344": "KRAPKOWICE",
        "47351": "KRAPKOWICE",
        "47364": "KRAPKOWICE",
        "47370": "KRAPKOWICE",
        "47400": "RACIBÓRZ (NET)",
        "47403": "RACIBÓRZ (NET)",
        "47404": "RACIBÓRZ (NET)",
        "47406": "RACIBÓRZ (NET)",
        "47411": "RACIBÓRZ (NET)",
        "47415": "RACIBÓRZ (NET)",
        "47417": "RACIBÓRZ (NET)",
        "47420": "RACIBÓRZ (NET)",
        "47430": "RACIBÓRZ (NET)",
        "47435": "RYBNIK",
        "47440": "RACIBÓRZ (NET)",
        "47442": "RACIBÓRZ (NET)",
        "47445": "RACIBÓRZ (NET)",
        "47450": "RACIBÓRZ (NET)",
        "47451": "RACIBÓRZ (NET)",
        "47460": "RACIBÓRZ (NET)",
        "47470": "RACIBÓRZ (NET)",
        "47475": "RACIBÓRZ (NET)",
        "47480": "RACIBÓRZ (NET)",
        "47491": "RACIBÓRZ (NET)",
        "47494": "RACIBÓRZ (NET)",
        "48100": "GŁUBCZYCE",
        "48118": "GŁUBCZYCE",
        "48120": "GŁUBCZYCE",
        "48130": "GŁUBCZYCE",
        "48133": "GŁUBCZYCE",
        "48140": "BRANICE",
        "48145": "GŁUBCZYCE",
        "48155": "GŁUBCZYCE",
        "48200": "PRUDNIK",
        "48210": "PRUDNIK",
        "48217": "PRUDNIK",
        "48220": "PRUDNIK",
        "48231": "PRUDNIK",
        "48250": "PRUDNIK",
        "48267": "NYSA",
        "48300": "NYSA",
        "48303": "NYSA",
        "48304": "NYSA",
        "48314": "NYSA",
        "48315": "NYSA",
        "48316": "NYSA",
        "48317": "NYSA",
        "48318": "NYSA",
        "48319": "NYSA",
        "48320": "NYSA",
        "48321": "NYSA",
        "48324": "NYSA",
        "48325": "NYSA",
        "48330": "NYSA",
        "48340": "GŁUCHOŁAZY",
        "48351": "NYSA",
        "48355": "NYSA",
        "48364": "NYSA",
        "48370": "PACZKÓW",
        "48381": "NYSA",
        "48385": "NYSA",
        "48387": "NYSA",
        "48388": "NYSA",
        "49100": "OPOLE",
        "49120": "OPOLE",
        "49125": "BRZESKO",
        "49130": "OPOLE",
        "49153": "OPOLE",
        "49156": "OPOLE",
        "49200": "GRODKÓW",
        "49300": "BRZEG (NET)",
        "49302": "BRZEG (NET)",
        "49304": "BRZEG (NET)",
        "49305": "BRZEG (NET)",
        "49306": "BRZEG (NET)",
        "49312": "BRZEG (NET)",
        "49313": "BRZEG (NET)",
        "49314": "BRZEG (NET)",
        "49315": "BRZEG (NET)",
        "49318": "BRZEG (NET)",
        "49330": "BRZEG (NET)",
        "49332": "BRZEG (NET)",
        "49340": "BRZEG",
        "49345": "BRZEG",
        "49351": "BRZEG (NET)",
        "49353": "BRZESKO",
        "50000": "WROCŁAW",
        "50001": "WROCŁAW",
        "50002": "WROCŁAW",
        "50003": "WROCŁAW",
        "50004": "WROCŁAW",
        "50005": "WROCŁAW",
        "50006": "WROCŁAW",
        "50007": "WROCŁAW",
        "50008": "WROCŁAW",
        "50009": "WROCŁAW",
        "50010": "WROCŁAW",
        "50011": "WROCŁAW",
        "50012": "WROCŁAW",
        "50013": "WROCŁAW",
        "50014": "WROCŁAW",
        "50015": "WROCŁAW",
        "50016": "WROCŁAW",
        "50017": "WROCŁAW",
        "50018": "WROCŁAW",
        "50019": "WROCŁAW",
        "50020": "WROCŁAW",
        "50021": "WROCŁAW",
        "50022": "WROCŁAW",
        "50023": "WROCŁAW",
        "50024": "WROCŁAW",
        "50026": "WROCŁAW",
        "50027": "WROCŁAW",
        "50028": "WROCŁAW",
        "50029": "WROCŁAW",
        "50030": "WROCŁAW",
        "50031": "WROCŁAW",
        "50032": "WROCŁAW",
        "50033": "WROCŁAW",
        "50034": "WROCŁAW",
        "50035": "WROCŁAW",
        "50036": "WROCŁAW",
        "50037": "WROCŁAW",
        "50038": "WROCŁAW",
        "50039": "WROCŁAW",
        "50040": "WROCŁAW",
        "50042": "WROCŁAW",
        "50043": "WROCŁAW",
        "50044": "WROCŁAW",
        "50045": "WROCŁAW",
        "50046": "WROCŁAW",
        "50047": "WROCŁAW",
        "50048": "WROCŁAW",
        "50049": "WROCŁAW",
        "50050": "WROCŁAW",
        "50051": "WROCŁAW",
        "50052": "WROCŁAW",
        "50053": "WROCŁAW",
        "50054": "WROCŁAW",
        "50055": "WROCŁAW",
        "50056": "WROCŁAW",
        "50057": "WROCŁAW",
        "50059": "WROCŁAW",
        "50060": "WROCŁAW",
        "50061": "WROCŁAW",
        "50062": "WROCŁAW",
        "50063": "WROCŁAW",
        "50064": "WROCŁAW",
        "50065": "WROCŁAW",
        "50066": "WROCŁAW",
        "50067": "WROCŁAW",
        "50068": "WROCŁAW",
        "50069": "WROCŁAW",
        "50070": "WROCŁAW",
        "50071": "WROCŁAW",
        "50072": "WROCŁAW",
        "50073": "WROCŁAW",
        "50074": "WROCŁAW",
        "50075": "WROCŁAW",
        "50076": "WROCŁAW",
        "50077": "WROCŁAW",
        "50078": "WROCŁAW",
        "50079": "WROCŁAW",
        "50080": "WROCŁAW",
        "50082": "WROCŁAW",
        "50083": "WROCŁAW",
        "50084": "WROCŁAW",
        "50085": "WROCŁAW",
        "50086": "WROCŁAW",
        "50087": "WROCŁAW",
        "50088": "WROCŁAW",
        "50089": "WROCŁAW",
        "50090": "WROCŁAW",
        "50101": "WROCŁAW",
        "50102": "WROCŁAW",
        "50103": "WROCŁAW",
        "50104": "WROCŁAW",
        "50105": "WROCŁAW",
        "50106": "WROCŁAW",
        "50107": "WROCŁAW",
        "50108": "WROCŁAW",
        "50109": "WROCŁAW",
        "50110": "WROCŁAW",
        "50111": "WROCŁAW",
        "50112": "WROCŁAW",
        "50113": "WROCŁAW",
        "50114": "WROCŁAW",
        "50115": "WROCŁAW",
        "50116": "WROCŁAW",
        "50117": "WROCŁAW",
        "50118": "WROCŁAW",
        "50119": "WROCŁAW",
        "50120": "WROCŁAW",
        "50121": "WROCŁAW",
        "50122": "WROCŁAW",
        "50123": "WROCŁAW",
        "50124": "WROCŁAW",
        "50125": "WROCŁAW",
        "50126": "WROCŁAW",
        "50127": "WROCŁAW",
        "50128": "WROCŁAW",
        "50129": "WROCŁAW",
        "50130": "WROCŁAW",
        "50131": "WROCŁAW",
        "50132": "WROCŁAW",
        "50133": "WROCŁAW",
        "50134": "WROCŁAW",
        "50135": "WROCŁAW",
        "50136": "WROCŁAW",
        "50137": "WROCŁAW",
        "50138": "WROCŁAW",
        "50139": "WROCŁAW",
        "50140": "WROCŁAW",
        "50141": "WROCŁAW",
        "50142": "WROCŁAW",
        "50143": "WROCŁAW",
        "50144": "WROCŁAW",
        "50145": "WROCŁAW",
        "50146": "WROCŁAW",
        "50147": "WROCŁAW",
        "50148": "WROCŁAW",
        "50149": "WROCŁAW",
        "50150": "WROCŁAW",
        "50151": "WROCŁAW",
        "50152": "WROCŁAW",
        "50153": "WROCŁAW",
        "50155": "WROCŁAW",
        "50156": "WROCŁAW",
        "50157": "WROCŁAW",
        "50158": "WROCŁAW",
        "50159": "WROCŁAW",
        "50165": "WROCŁAW",
        "50201": "WROCŁAW",
        "50202": "WROCŁAW",
        "50203": "WROCŁAW",
        "50204": "WROCŁAW",
        "50205": "WROCŁAW",
        "50206": "WROCŁAW",
        "50207": "WROCŁAW",
        "50208": "WROCŁAW",
        "50209": "WROCŁAW",
        "50210": "WROCŁAW",
        "50211": "WROCŁAW",
        "50212": "WROCŁAW",
        "50213": "WROCŁAW",
        "50214": "WROCŁAW",
        "50215": "WROCŁAW",
        "50216": "WROCŁAW",
        "50217": "WROCŁAW",
        "50218": "WROCŁAW",
        "50219": "WROCŁAW",
        "50220": "WROCŁAW",
        "50221": "WROCŁAW",
        "50222": "WROCŁAW",
        "50223": "WROCŁAW",
        "50224": "WROCŁAW",
        "50225": "WROCŁAW",
        "50226": "WROCŁAW",
        "50227": "WROCŁAW",
        "50228": "WROCŁAW",
        "50229": "WROCŁAW",
        "50230": "WROCŁAW",
        "50231": "WROCŁAW",
        "50232": "WROCŁAW",
        "50233": "WROCŁAW",
        "50234": "WROCŁAW",
        "50235": "WROCŁAW",
        "50236": "WROCŁAW",
        "50237": "WROCŁAW",
        "50238": "WROCŁAW",
        "50239": "WROCŁAW",
        "50240": "WROCŁAW",
        "50241": "WROCŁAW",
        "50242": "WROCŁAW",
        "50243": "WROCŁAW",
        "50244": "WROCŁAW",
        "50245": "WROCŁAW",
        "50246": "WROCŁAW",
        "50247": "WROCŁAW",
        "50248": "WROCŁAW",
        "50249": "WROCŁAW",
        "50250": "WROCŁAW",
        "50251": "WROCŁAW",
        "50252": "WROCŁAW",
        "50253": "WROCŁAW",
        "50254": "WROCŁAW",
        "50255": "WROCŁAW",
        "50256": "WROCŁAW",
        "50257": "WROCŁAW",
        "50258": "WROCŁAW",
        "50259": "WROCŁAW",
        "50260": "WROCŁAW",
        "50261": "WROCŁAW",
        "50262": "WROCŁAW",
        "50263": "WROCŁAW",
        "50264": "WROCŁAW",
        "50265": "WROCŁAW",
        "50266": "WROCŁAW",
        "50267": "WROCŁAW",
        "50300": "WROCŁAW",
        "50301": "WROCŁAW",
        "50302": "WROCŁAW",
        "50303": "WROCŁAW",
        "50304": "WROCŁAW",
        "50305": "WROCŁAW",
        "50306": "WROCŁAW",
        "50307": "WROCŁAW",
        "50308": "WROCŁAW",
        "50309": "WROCŁAW",
        "50310": "WROCŁAW",
        "50311": "WROCŁAW",
        "50312": "WROCŁAW",
        "50313": "WROCŁAW",
        "50314": "WROCŁAW",
        "50315": "WROCŁAW",
        "50316": "WROCŁAW",
        "50317": "WROCŁAW",
        "50318": "WROCŁAW",
        "50319": "WROCŁAW",
        "50320": "WROCŁAW",
        "50321": "WROCŁAW",
        "50322": "WROCŁAW",
        "50323": "WROCŁAW",
        "50324": "WROCŁAW",
        "50325": "WROCŁAW",
        "50326": "WROCŁAW",
        "50327": "WROCŁAW",
        "50328": "WROCŁAW",
        "50329": "WROCŁAW",
        "50330": "WROCŁAW",
        "50331": "WROCŁAW",
        "50332": "WROCŁAW",
        "50333": "WROCŁAW",
        "50334": "WROCŁAW",
        "50335": "WROCŁAW",
        "50336": "WROCŁAW",
        "50337": "WROCŁAW",
        "50338": "WROCŁAW",
        "50339": "WROCŁAW",
        "50340": "WROCŁAW",
        "50341": "WROCŁAW",
        "50342": "WROCŁAW",
        "50343": "WROCŁAW",
        "50344": "WROCŁAW",
        "50345": "WROCŁAW",
        "50346": "WROCŁAW",
        "50347": "WROCŁAW",
        "50348": "WROCŁAW",
        "50349": "WROCŁAW",
        "50350": "WROCŁAW",
        "50351": "WROCŁAW",
        "50352": "WROCŁAW",
        "50353": "WROCŁAW",
        "50354": "WROCŁAW",
        "50355": "WROCŁAW",
        "50356": "WROCŁAW",
        "50357": "WROCŁAW",
        "50359": "WROCŁAW",
        "50360": "WROCŁAW",
        "50361": "WROCŁAW",
        "50362": "WROCŁAW",
        "50363": "WROCŁAW",
        "50364": "WROCŁAW",
        "50365": "WROCŁAW",
        "50366": "WROCŁAW",
        "50367": "WROCŁAW",
        "50368": "WROCŁAW",
        "50369": "WROCŁAW",
        "50370": "WROCŁAW",
        "50371": "WROCŁAW",
        "50372": "WROCŁAW",
        "50373": "WROCŁAW",
        "50374": "WROCŁAW",
        "50375": "WROCŁAW",
        "50376": "WROCŁAW",
        "50377": "WROCŁAW",
        "50378": "WROCŁAW",
        "50379": "WROCŁAW",
        "50380": "WROCŁAW",
        "50381": "WROCŁAW",
        "50382": "WROCŁAW",
        "50383": "WROCŁAW",
        "50384": "WROCŁAW",
        "50385": "WROCŁAW",
        "50386": "WROCŁAW",
        "50388": "WROCŁAW",
        "50399": "WROCŁAW",
        "50401": "WROCŁAW",
        "50402": "WROCŁAW",
        "50403": "WROCŁAW",
        "50406": "WROCŁAW",
        "50407": "WROCŁAW",
        "50408": "WROCŁAW",
        "50411": "WROCŁAW",
        "50412": "WROCŁAW",
        "50413": "WROCŁAW",
        "50414": "WROCŁAW",
        "50415": "WROCŁAW",
        "50416": "WROCŁAW",
        "50417": "WROCŁAW",
        "50418": "WROCŁAW",
        "50419": "WROCŁAW",
        "50420": "WROCŁAW",
        "50421": "WROCŁAW",
        "50422": "WROCŁAW",
        "50424": "WROCŁAW",
        "50425": "WROCŁAW",
        "50426": "WROCŁAW",
        "50427": "WROCŁAW",
        "50428": "WROCŁAW",
        "50429": "WROCŁAW",
        "50430": "WROCŁAW",
        "50431": "WROCŁAW",
        "50432": "WROCŁAW",
        "50433": "WROCŁAW",
        "50434": "WROCŁAW",
        "50435": "WROCŁAW",
        "50436": "WROCŁAW",
        "50437": "WROCŁAW",
        "50438": "WROCŁAW",
        "50439": "WROCŁAW",
        "50440": "WROCŁAW",
        "50441": "WROCŁAW",
        "50442": "WROCŁAW",
        "50443": "WROCŁAW",
        "50444": "WROCŁAW",
        "50445": "WROCŁAW",
        "50446": "WROCŁAW",
        "50447": "WROCŁAW",
        "50448": "WROCŁAW",
        "50449": "WROCŁAW",
        "50450": "WROCŁAW",
        "50451": "WROCŁAW",
        "50452": "WROCŁAW",
        "50453": "WROCŁAW",
        "50454": "WROCŁAW",
        "50455": "WROCŁAW",
        "50456": "WROCŁAW",
        "50457": "WROCŁAW",
        "50458": "WROCŁAW",
        "50501": "WROCŁAW",
        "50502": "WROCŁAW",
        "50503": "WROCŁAW",
        "50504": "WROCŁAW",
        "50505": "WROCŁAW",
        "50506": "WROCŁAW",
        "50507": "WROCŁAW",
        "50508": "WROCŁAW",
        "50509": "WROCŁAW",
        "50510": "WROCŁAW",
        "50511": "WROCŁAW",
        "50512": "WROCŁAW",
        "50513": "WROCŁAW",
        "50514": "WROCŁAW",
        "50515": "WROCŁAW",
        "50516": "WROCŁAW",
        "50517": "WROCŁAW",
        "50518": "WROCŁAW",
        "50519": "WROCŁAW",
        "50520": "WROCŁAW",
        "50521": "WROCŁAW",
        "50522": "WROCŁAW",
        "50523": "WROCŁAW",
        "50524": "WROCŁAW",
        "50525": "WROCŁAW",
        "50526": "WROCŁAW",
        "50527": "WROCŁAW",
        "50528": "WROCŁAW",
        "50529": "WROCŁAW",
        "50530": "WROCŁAW",
        "50531": "WROCŁAW",
        "50532": "WROCŁAW",
        "50533": "WROCŁAW",
        "50534": "WROCŁAW",
        "50535": "WROCŁAW",
        "50536": "WROCŁAW",
        "50537": "WROCŁAW",
        "50538": "WROCŁAW",
        "50539": "WROCŁAW",
        "50540": "WROCŁAW",
        "50541": "WROCŁAW",
        "50542": "WROCŁAW",
        "50543": "WROCŁAW",
        "50544": "WROCŁAW",
        "50545": "WROCŁAW",
        "50546": "WROCŁAW",
        "50547": "WROCŁAW",
        "50548": "WROCŁAW",
        "50549": "WROCŁAW",
        "50550": "WROCŁAW",
        "50551": "WROCŁAW",
        "50552": "WROCŁAW",
        "50553": "WROCŁAW",
        "50554": "WROCŁAW",
        "50555": "WROCŁAW",
        "50556": "WROCŁAW",
        "50557": "WROCŁAW",
        "50558": "WROCŁAW",
        "50559": "WROCŁAW",
        "50560": "WROCŁAW",
        "50561": "WROCŁAW",
        "50562": "WROCŁAW",
        "50563": "WROCŁAW",
        "50564": "WROCŁAW",
        "50565": "WROCŁAW",
        "50566": "WROCŁAW",
        "50567": "WROCŁAW",
        "50568": "WROCŁAW",
        "50569": "WROCŁAW",
        "50570": "WROCŁAW",
        "50571": "WROCŁAW",
        "50572": "WROCŁAW",
        "50573": "WROCŁAW",
        "50574": "WROCŁAW",
        "50576": "WROCŁAW",
        "50580": "WROCŁAW",
        "50900": "WROCŁAW",
        "50901": "WROCŁAW",
        "50930": "WROCŁAW",
        "50936": "WROCŁAW",
        "50940": "WROCŁAW",
        "50950": "WROCŁAW",
        "50951": "WROCŁAW",
        "50952": "WROCŁAW",
        "50953": "WROCŁAW",
        "50954": "WROCŁAW",
        "50955": "WROCŁAW",
        "50956": "WROCŁAW",
        "50961": "WROCŁAW",
        "50962": "WROCŁAW",
        "50963": "WROCŁAW",
        "50964": "WROCŁAW",
        "50965": "WROCŁAW",
        "50966": "WROCŁAW",
        "50970": "WROCŁAW",
        "50971": "WROCŁAW",
        "50972": "WROCŁAW",
        "50973": "WROCŁAW",
        "50974": "WROCŁAW",
        "50981": "WROCŁAW",
        "50982": "WROCŁAW",
        "50983": "WROCŁAW",
        "50984": "WROCŁAW",
        "50985": "WROCŁAW",
        "50986": "WROCŁAW",
        "50989": "WROCŁAW",
        "50990": "WROCŁAW",
        "50991": "WROCŁAW",
        "50994": "WROCŁAW",
        "50995": "WROCŁAW",
        "50996": "WROCŁAW",
        "51001": "WROCŁAW",
        "51002": "WROCŁAW",
        "51003": "WROCŁAW",
        "51004": "WROCŁAW",
        "51005": "WROCŁAW",
        "51006": "WROCŁAW",
        "51007": "WROCŁAW",
        "51008": "WROCŁAW",
        "51009": "WROCŁAW",
        "51010": "WROCŁAW",
        "51011": "WROCŁAW",
        "51050": "WROCŁAW",
        "51051": "WROCŁAW",
        "51052": "WROCŁAW",
        "51107": "WROCŁAW",
        "51108": "WROCŁAW",
        "51109": "WROCŁAW",
        "51110": "WROCŁAW",
        "51111": "WROCŁAW",
        "51112": "WROCŁAW",
        "51113": "WROCŁAW",
        "51114": "WROCŁAW",
        "51115": "WROCŁAW",
        "51116": "WROCŁAW",
        "51117": "WROCŁAW",
        "51118": "WROCŁAW",
        "51119": "WROCŁAW",
        "51120": "WROCŁAW",
        "51121": "WROCŁAW",
        "51122": "WROCŁAW",
        "51123": "WROCŁAW",
        "51124": "WROCŁAW",
        "51125": "WROCŁAW",
        "51126": "WROCŁAW",
        "51127": "WROCŁAW",
        "51128": "WROCŁAW",
        "51129": "WROCŁAW",
        "51130": "WROCŁAW",
        "51131": "WROCŁAW",
        "51132": "WROCŁAW",
        "51134": "WROCŁAW",
        "51136": "WROCŁAW",
        "51137": "WROCŁAW",
        "51138": "WROCŁAW",
        "51139": "WROCŁAW",
        "51140": "WROCŁAW",
        "51141": "WROCŁAW",
        "51142": "WROCŁAW",
        "51143": "WROCŁAW",
        "51144": "WROCŁAW",
        "51145": "WROCŁAW",
        "51146": "WROCŁAW",
        "51147": "WROCŁAW",
        "51148": "WROCŁAW",
        "51149": "WROCŁAW",
        "51151": "WROCŁAW",
        "51152": "WROCŁAW",
        "51153": "WROCŁAW",
        "51160": "WROCŁAW",
        "51161": "WROCŁAW",
        "51162": "WROCŁAW",
        "51163": "WROCŁAW",
        "51164": "WROCŁAW",
        "51165": "WROCŁAW",
        "51166": "WROCŁAW",
        "51167": "WROCŁAW",
        "51168": "WROCŁAW",
        "51169": "WROCŁAW",
        "51170": "WROCŁAW",
        "51171": "WROCŁAW",
        "51173": "WROCŁAW",
        "51179": "WROCŁAW",
        "51180": "WROCŁAW",
        "51188": "WROCŁAW",
        "51200": "WROCŁAW",
        "51203": "WROCŁAW",
        "51204": "WROCŁAW",
        "51205": "WROCŁAW",
        "51206": "WROCŁAW",
        "51207": "WROCŁAW",
        "51208": "WROCŁAW",
        "51209": "WROCŁAW",
        "51210": "WROCŁAW",
        "51211": "WROCŁAW",
        "51212": "WROCŁAW",
        "51213": "WROCŁAW",
        "51214": "WROCŁAW",
        "51215": "WROCŁAW",
        "51216": "WROCŁAW",
        "51217": "WROCŁAW",
        "51218": "WROCŁAW",
        "51219": "WROCŁAW",
        "51220": "WROCŁAW",
        "51222": "WROCŁAW",
        "51230": "WROCŁAW",
        "51231": "WROCŁAW",
        "51250": "WROCŁAW",
        "51251": "WROCŁAW",
        "51252": "WROCŁAW",
        "51253": "WROCŁAW",
        "51259": "WROCŁAW",
        "51310": "WROCŁAW",
        "51311": "WROCŁAW",
        "51312": "WROCŁAW",
        "51313": "WROCŁAW",
        "51314": "WROCŁAW",
        "51315": "WROCŁAW",
        "51316": "WROCŁAW",
        "51317": "WROCŁAW",
        "51318": "WROCŁAW",
        "51319": "WROCŁAW",
        "51321": "WROCŁAW",
        "51347": "WROCŁAW",
        "51348": "WROCŁAW",
        "51349": "WROCŁAW",
        "51350": "WROCŁAW",
        "51351": "WROCŁAW",
        "51352": "WROCŁAW",
        "51354": "WROCŁAW",
        "51355": "WROCŁAW",
        "51356": "WROCŁAW",
        "51361": "WROCŁAW",
        "51376": "WROCŁAW",
        "51378": "WROCŁAW",
        "51410": "WROCŁAW",
        "51411": "WROCŁAW",
        "51412": "WROCŁAW",
        "51413": "WROCŁAW",
        "51414": "WROCŁAW",
        "51415": "WROCŁAW",
        "51416": "WROCŁAW",
        "51417": "WROCŁAW",
        "51418": "WROCŁAW",
        "51419": "WROCŁAW",
        "51420": "WROCŁAW",
        "51421": "WROCŁAW",
        "51422": "WROCŁAW",
        "51423": "WROCŁAW",
        "51424": "WROCŁAW",
        "51425": "WROCŁAW",
        "51426": "WROCŁAW",
        "51427": "WROCŁAW",
        "51428": "WROCŁAW",
        "51429": "WROCŁAW",
        "51430": "WROCŁAW",
        "51501": "WROCŁAW",
        "51502": "WROCŁAW",
        "51503": "WROCŁAW",
        "51504": "WROCŁAW",
        "51505": "WROCŁAW",
        "51506": "WROCŁAW",
        "51507": "WROCŁAW",
        "51508": "WROCŁAW",
        "51511": "WROCŁAW",
        "51512": "WROCŁAW",
        "51513": "WROCŁAW",
        "51514": "WROCŁAW",
        "51515": "WROCŁAW",
        "51516": "WROCŁAW",
        "51517": "WROCŁAW",
        "51518": "WROCŁAW",
        "51519": "WROCŁAW",
        "51520": "WROCŁAW",
        "51521": "WROCŁAW",
        "51522": "WROCŁAW",
        "51523": "WROCŁAW",
        "51524": "WROCŁAW",
        "51531": "WROCŁAW",
        "51537": "WROCŁAW",
        "51601": "WROCŁAW",
        "51602": "WROCŁAW",
        "51603": "WROCŁAW",
        "51604": "WROCŁAW",
        "51605": "WROCŁAW",
        "51606": "WROCŁAW",
        "51607": "WROCŁAW",
        "51608": "WROCŁAW",
        "51609": "WROCŁAW",
        "51610": "WROCŁAW",
        "51611": "WROCŁAW",
        "51612": "WROCŁAW",
        "51613": "WROCŁAW",
        "51616": "WROCŁAW",
        "51617": "WROCŁAW",
        "51618": "WROCŁAW",
        "51619": "WROCŁAW",
        "51620": "WROCŁAW",
        "51621": "WROCŁAW",
        "51622": "WROCŁAW",
        "51627": "WROCŁAW",
        "51628": "WROCŁAW",
        "51629": "WROCŁAW",
        "51630": "WROCŁAW",
        "51631": "WROCŁAW",
        "51636": "WROCŁAW",
        "51637": "WROCŁAW",
        "51638": "WROCŁAW",
        "51639": "WROCŁAW",
        "51640": "WROCŁAW",
        "51641": "WROCŁAW",
        "51642": "WROCŁAW",
        "51643": "WROCŁAW",
        "51644": "WROCŁAW",
        "51645": "WROCŁAW",
        "51646": "WROCŁAW",
        "51647": "WROCŁAW",
        "51648": "WROCŁAW",
        "51649": "WROCŁAW",
        "51650": "WROCŁAW",
        "51651": "WROCŁAW",
        "51657": "WROCŁAW",
        "51658": "WROCŁAW",
        "51659": "WROCŁAW",
        "51660": "WROCŁAW",
        "51661": "WROCŁAW",
        "51662": "WROCŁAW",
        "51663": "WROCŁAW",
        "51664": "WROCŁAW",
        "51665": "WROCŁAW",
        "51668": "WROCŁAW",
        "51669": "WROCŁAW",
        "51670": "WROCŁAW",
        "51671": "WROCŁAW",
        "51672": "WROCŁAW",
        "51673": "WROCŁAW",
        "51674": "WROCŁAW",
        "51675": "WROCŁAW",
        "51676": "WROCŁAW",
        "51677": "WROCŁAW",
        "51678": "WROCŁAW",
        "51679": "WROCŁAW",
        "51680": "WROCŁAW",
        "51681": "WROCŁAW",
        "51682": "WROCŁAW",
        "51683": "WROCŁAW",
        "51684": "WROCŁAW",
        "51685": "WROCŁAW",
        "51686": "WROCŁAW",
        "51687": "WROCŁAW",
        "51688": "WROCŁAW",
        "51689": "WROCŁAW",
        "51690": "WROCŁAW",
        "51691": "WROCŁAW",
        "51692": "WROCŁAW",
        "52007": "WROCŁAW",
        "52008": "WROCŁAW",
        "52010": "WROCŁAW",
        "52011": "WROCŁAW",
        "52012": "WROCŁAW",
        "52013": "WROCŁAW",
        "52014": "WROCŁAW",
        "52015": "WROCŁAW",
        "52016": "WROCŁAW",
        "52017": "WROCŁAW",
        "52018": "WROCŁAW",
        "52019": "WROCŁAW",
        "52020": "WROCŁAW",
        "52021": "WROCŁAW",
        "52022": "WROCŁAW",
        "52023": "WROCŁAW",
        "52024": "WROCŁAW",
        "52025": "WROCŁAW",
        "52026": "WROCŁAW",
        "52027": "WROCŁAW",
        "52028": "WROCŁAW",
        "52029": "WROCŁAW",
        "52051": "WROCŁAW",
        "52110": "WROCŁAW",
        "52111": "WROCŁAW",
        "52112": "WROCŁAW",
        "52113": "WROCŁAW",
        "52114": "WROCŁAW",
        "52115": "WROCŁAW",
        "52116": "WROCŁAW",
        "52117": "WROCŁAW",
        "52118": "WROCŁAW",
        "52119": "WROCŁAW",
        "52120": "WROCŁAW",
        "52121": "WROCŁAW",
        "52122": "WROCŁAW",
        "52123": "WROCŁAW",
        "52124": "WROCŁAW",
        "52126": "WROCŁAW",
        "52127": "WROCŁAW",
        "52128": "WROCŁAW",
        "52129": "WROCŁAW",
        "52130": "WROCŁAW",
        "52131": "WROCŁAW",
        "52132": "WROCŁAW",
        "52133": "WROCŁAW",
        "52135": "WROCŁAW",
        "52141": "WROCŁAW",
        "52200": "WROCŁAW",
        "52201": "WROCŁAW",
        "52203": "WROCŁAW",
        "52204": "WROCŁAW",
        "52205": "WROCŁAW",
        "52206": "WROCŁAW",
        "52207": "WROCŁAW",
        "52208": "WROCŁAW",
        "52209": "WROCŁAW",
        "52210": "WROCŁAW",
        "52211": "WROCŁAW",
        "52212": "WROCŁAW",
        "52213": "WROCŁAW",
        "52214": "WROCŁAW",
        "52215": "WROCŁAW",
        "52216": "WROCŁAW",
        "52218": "WROCŁAW",
        "52219": "WROCŁAW",
        "52220": "WROCŁAW",
        "52221": "WROCŁAW",
        "52222": "WROCŁAW",
        "52223": "WROCŁAW",
        "52224": "WROCŁAW",
        "52225": "WROCŁAW",
        "52226": "WROCŁAW",
        "52227": "WROCŁAW",
        "52228": "WROCŁAW",
        "52229": "WROCŁAW",
        "52230": "WROCŁAW",
        "52231": "WROCŁAW",
        "52232": "WROCŁAW",
        "52233": "WROCŁAW",
        "52234": "WROCŁAW",
        "52235": "WROCŁAW",
        "52239": "WROCŁAW",
        "52241": "WROCŁAW",
        "52242": "WROCŁAW",
        "52244": "WROCŁAW",
        "52245": "WROCŁAW",
        "52258": "WROCŁAW",
        "52311": "WROCŁAW",
        "52314": "WROCŁAW",
        "52315": "WROCŁAW",
        "52316": "WROCŁAW",
        "52317": "WROCŁAW",
        "52319": "WROCŁAW",
        "52320": "WROCŁAW",
        "52326": "WROCŁAW",
        "52327": "WROCŁAW",
        "52331": "WROCŁAW",
        "52332": "WROCŁAW",
        "52333": "WROCŁAW",
        "52334": "WROCŁAW",
        "52335": "WROCŁAW",
        "52336": "WROCŁAW",
        "52339": "WROCŁAW",
        "52340": "WROCŁAW",
        "52401": "WROCŁAW",
        "52402": "WROCŁAW",
        "52403": "WROCŁAW",
        "52404": "WROCŁAW",
        "52405": "WROCŁAW",
        "52407": "WROCŁAW",
        "52408": "WROCŁAW",
        "52409": "WROCŁAW",
        "52411": "WROCŁAW",
        "52412": "WROCŁAW",
        "52413": "WROCŁAW",
        "52414": "WROCŁAW",
        "52415": "WROCŁAW",
        "52416": "WROCŁAW",
        "52417": "WROCŁAW",
        "52418": "WROCŁAW",
        "52419": "WROCŁAW",
        "52420": "WROCŁAW",
        "52421": "WROCŁAW",
        "52422": "WROCŁAW",
        "52423": "WROCŁAW",
        "52424": "WROCŁAW",
        "52425": "WROCŁAW",
        "52427": "WROCŁAW",
        "52428": "WROCŁAW",
        "52429": "WROCŁAW",
        "52430": "WROCŁAW",
        "52431": "WROCŁAW",
        "52432": "WROCŁAW",
        "52433": "WROCŁAW",
        "52434": "WROCŁAW",
        "52435": "WROCŁAW",
        "52436": "WROCŁAW",
        "52437": "WROCŁAW",
        "52438": "WROCŁAW",
        "52443": "WROCŁAW",
        "53000": "WROCŁAW",
        "53004": "WROCŁAW",
        "53006": "WROCŁAW",
        "53007": "WROCŁAW",
        "53008": "WROCŁAW",
        "53009": "WROCŁAW",
        "53010": "WROCŁAW",
        "53011": "WROCŁAW",
        "53012": "WROCŁAW",
        "53013": "WROCŁAW",
        "53014": "WROCŁAW",
        "53015": "WROCŁAW",
        "53017": "WROCŁAW",
        "53018": "WROCŁAW",
        "53019": "WROCŁAW",
        "53020": "WROCŁAW",
        "53021": "WROCŁAW",
        "53022": "WROCŁAW",
        "53023": "WROCŁAW",
        "53024": "WROCŁAW",
        "53025": "WROCŁAW",
        "53026": "WROCŁAW",
        "53027": "WROCŁAW",
        "53028": "WROCŁAW",
        "53029": "WROCŁAW",
        "53030": "WROCŁAW",
        "53031": "WROCŁAW",
        "53032": "WROCŁAW",
        "53033": "WROCŁAW",
        "53034": "WROCŁAW",
        "53035": "WROCŁAW",
        "53110": "WROCŁAW",
        "53111": "WROCŁAW",
        "53112": "WROCŁAW",
        "53113": "WROCŁAW",
        "53114": "WROCŁAW",
        "53115": "WROCŁAW",
        "53116": "WROCŁAW",
        "53117": "WROCŁAW",
        "53118": "WROCŁAW",
        "53119": "WROCŁAW",
        "53120": "WROCŁAW",
        "53121": "WROCŁAW",
        "53122": "WROCŁAW",
        "53123": "WROCŁAW",
        "53124": "WROCŁAW",
        "53125": "WROCŁAW",
        "53126": "WROCŁAW",
        "53127": "WROCŁAW",
        "53128": "WROCŁAW",
        "53129": "WROCŁAW",
        "53133": "WROCŁAW",
        "53134": "WROCŁAW",
        "53135": "WROCŁAW",
        "53136": "WROCŁAW",
        "53137": "WROCŁAW",
        "53138": "WROCŁAW",
        "53139": "WROCŁAW",
        "53140": "WROCŁAW",
        "53141": "WROCŁAW",
        "53142": "WROCŁAW",
        "53143": "WROCŁAW",
        "53144": "WROCŁAW",
        "53145": "WROCŁAW",
        "53146": "WROCŁAW",
        "53147": "WROCŁAW",
        "53148": "WROCŁAW",
        "53149": "WROCŁAW",
        "53150": "WROCŁAW",
        "53151": "WROCŁAW",
        "53152": "WROCŁAW",
        "53153": "WROCŁAW",
        "53201": "WROCŁAW",
        "53202": "WROCŁAW",
        "53203": "WROCŁAW",
        "53204": "WROCŁAW",
        "53205": "WROCŁAW",
        "53206": "WROCŁAW",
        "53207": "WROCŁAW",
        "53208": "WROCŁAW",
        "53209": "WROCŁAW",
        "53210": "WROCŁAW",
        "53211": "WROCŁAW",
        "53212": "WROCŁAW",
        "53213": "WROCŁAW",
        "53214": "WROCŁAW",
        "53224": "WROCŁAW",
        "53225": "WROCŁAW",
        "53226": "WROCŁAW",
        "53227": "WROCŁAW",
        "53228": "WROCŁAW",
        "53229": "WROCŁAW",
        "53230": "WROCŁAW",
        "53231": "WROCŁAW",
        "53232": "WROCŁAW",
        "53233": "WROCŁAW",
        "53234": "WROCŁAW",
        "53235": "WROCŁAW",
        "53236": "WROCŁAW",
        "53237": "WROCŁAW",
        "53238": "WROCŁAW",
        "53239": "WROCŁAW",
        "53240": "WROCŁAW",
        "53241": "WROCŁAW",
        "53245": "WROCŁAW",
        "53301": "WROCŁAW",
        "53302": "WROCŁAW",
        "53303": "WROCŁAW",
        "53304": "WROCŁAW",
        "53305": "WROCŁAW",
        "53306": "WROCŁAW",
        "53307": "WROCŁAW",
        "53308": "WROCŁAW",
        "53310": "WROCŁAW",
        "53311": "WROCŁAW",
        "53312": "WROCŁAW",
        "53313": "WROCŁAW",
        "53314": "WROCŁAW",
        "53315": "WROCŁAW",
        "53316": "WROCŁAW",
        "53317": "WROCŁAW",
        "53318": "WROCŁAW",
        "53319": "WROCŁAW",
        "53320": "WROCŁAW",
        "53321": "WROCŁAW",
        "53322": "WROCŁAW",
        "53323": "WROCŁAW",
        "53324": "WROCŁAW",
        "53325": "WROCŁAW",
        "53326": "WROCŁAW",
        "53327": "WROCŁAW",
        "53328": "WROCŁAW",
        "53329": "WROCŁAW",
        "53330": "WROCŁAW",
        "53331": "WROCŁAW",
        "53332": "WROCŁAW",
        "53333": "WROCŁAW",
        "53334": "WROCŁAW",
        "53335": "WROCŁAW",
        "53336": "WROCŁAW",
        "53337": "WROCŁAW",
        "53338": "WROCŁAW",
        "53339": "WROCŁAW",
        "53340": "WROCŁAW",
        "53341": "WROCŁAW",
        "53342": "WROCŁAW",
        "53343": "WROCŁAW",
        "53344": "WROCŁAW",
        "53345": "WROCŁAW",
        "53350": "WROCŁAW",
        "53401": "WROCŁAW",
        "53402": "WROCŁAW",
        "53403": "WROCŁAW",
        "53404": "WROCŁAW",
        "53405": "WROCŁAW",
        "53406": "WROCŁAW",
        "53407": "WROCŁAW",
        "53408": "WROCŁAW",
        "53409": "WROCŁAW",
        "53410": "WROCŁAW",
        "53411": "WROCŁAW",
        "53412": "WROCŁAW",
        "53413": "WROCŁAW",
        "53414": "WROCŁAW",
        "53415": "WROCŁAW",
        "53416": "WROCŁAW",
        "53417": "WROCŁAW",
        "53418": "WROCŁAW",
        "53419": "WROCŁAW",
        "53421": "WROCŁAW",
        "53422": "WROCŁAW",
        "53423": "WROCŁAW",
        "53424": "WROCŁAW",
        "53425": "WROCŁAW",
        "53426": "WROCŁAW",
        "53427": "WROCŁAW",
        "53428": "WROCŁAW",
        "53429": "WROCŁAW",
        "53430": "WROCŁAW",
        "53431": "WROCŁAW",
        "53432": "WROCŁAW",
        "53433": "WROCŁAW",
        "53434": "WROCŁAW",
        "53435": "WROCŁAW",
        "53436": "WROCŁAW",
        "53437": "WROCŁAW",
        "53438": "WROCŁAW",
        "53439": "WROCŁAW",
        "53440": "WROCŁAW",
        "53441": "WROCŁAW",
        "53442": "WROCŁAW",
        "53443": "WROCŁAW",
        "53444": "WROCŁAW",
        "53445": "WROCŁAW",
        "53446": "WROCŁAW",
        "53447": "WROCŁAW",
        "53501": "WROCŁAW",
        "53502": "WROCŁAW",
        "53503": "WROCŁAW",
        "53504": "WROCŁAW",
        "53505": "WROCŁAW",
        "53506": "WROCŁAW",
        "53507": "WROCŁAW",
        "53508": "WROCŁAW",
        "53509": "WROCŁAW",
        "53510": "WROCŁAW",
        "53511": "WROCŁAW",
        "53512": "WROCŁAW",
        "53513": "WROCŁAW",
        "53514": "WROCŁAW",
        "53515": "WROCŁAW",
        "53516": "WROCŁAW",
        "53517": "WROCŁAW",
        "53518": "WROCŁAW",
        "53519": "WROCŁAW",
        "53520": "WROCŁAW",
        "53521": "WROCŁAW",
        "53522": "WROCŁAW",
        "53523": "WROCŁAW",
        "53525": "WROCŁAW",
        "53526": "WROCŁAW",
        "53527": "WROCŁAW",
        "53528": "WROCŁAW",
        "53529": "WROCŁAW",
        "53530": "WROCŁAW",
        "53531": "WROCŁAW",
        "53532": "WROCŁAW",
        "53533": "WROCŁAW",
        "53534": "WROCŁAW",
        "53535": "WROCŁAW",
        "53601": "WROCŁAW",
        "53602": "WROCŁAW",
        "53603": "WROCŁAW",
        "53604": "WROCŁAW",
        "53605": "WROCŁAW",
        "53607": "WROCŁAW",
        "53608": "WROCŁAW",
        "53609": "WROCŁAW",
        "53610": "WROCŁAW",
        "53611": "WROCŁAW",
        "53612": "WROCŁAW",
        "53613": "WROCŁAW",
        "53614": "WROCŁAW",
        "53615": "WROCŁAW",
        "53616": "WROCŁAW",
        "53617": "WROCŁAW",
        "53621": "WROCŁAW",
        "53622": "WROCŁAW",
        "53623": "WROCŁAW",
        "53624": "WROCŁAW",
        "53625": "WROCŁAW",
        "53626": "WROCŁAW",
        "53627": "WROCŁAW",
        "53628": "WROCŁAW",
        "53629": "WROCŁAW",
        "53630": "WROCŁAW",
        "53631": "WROCŁAW",
        "53632": "WROCŁAW",
        "53633": "WROCŁAW",
        "53638": "WROCŁAW",
        "53641": "WROCŁAW",
        "53642": "WROCŁAW",
        "53643": "WROCŁAW",
        "53644": "WROCŁAW",
        "53645": "WROCŁAW",
        "53646": "WROCŁAW",
        "53647": "WROCŁAW",
        "53648": "WROCŁAW",
        "53649": "WROCŁAW",
        "53650": "WROCŁAW",
        "53651": "WROCŁAW",
        "53652": "WROCŁAW",
        "53653": "WROCŁAW",
        "53654": "WROCŁAW",
        "53655": "WROCŁAW",
        "53656": "WROCŁAW",
        "53657": "WROCŁAW",
        "53658": "WROCŁAW",
        "53659": "WROCŁAW",
        "53660": "WROCŁAW",
        "53661": "WROCŁAW",
        "53662": "WROCŁAW",
        "53663": "WROCŁAW",
        "53671": "WROCŁAW",
        "53672": "WROCŁAW",
        "53673": "WROCŁAW",
        "53674": "WROCŁAW",
        "53675": "WROCŁAW",
        "53676": "WROCŁAW",
        "53677": "WROCŁAW",
        "53678": "WROCŁAW",
        "53679": "WROCŁAW",
        "53680": "WROCŁAW",
        "53681": "WROCŁAW",
        "54001": "WROCŁAW",
        "54002": "WROCŁAW",
        "54003": "WROCŁAW",
        "54004": "WROCŁAW",
        "54005": "WROCŁAW",
        "54006": "WROCŁAW",
        "54007": "WROCŁAW",
        "54008": "WROCŁAW",
        "54009": "WROCŁAW",
        "54010": "WROCŁAW",
        "54011": "WROCŁAW",
        "54014": "WROCŁAW",
        "54015": "WROCŁAW",
        "54016": "WROCŁAW",
        "54017": "WROCŁAW",
        "54018": "WROCŁAW",
        "54019": "WROCŁAW",
        "54020": "WROCŁAW",
        "54025": "WROCŁAW",
        "54026": "WROCŁAW",
        "54027": "WROCŁAW",
        "54028": "WROCŁAW",
        "54029": "WROCŁAW",
        "54030": "WROCŁAW",
        "54031": "WROCŁAW",
        "54032": "WROCŁAW",
        "54033": "WROCŁAW",
        "54034": "WROCŁAW",
        "54035": "WROCŁAW",
        "54041": "WROCŁAW",
        "54042": "WROCŁAW",
        "54043": "WROCŁAW",
        "54044": "WROCŁAW",
        "54045": "WROCŁAW",
        "54046": "WROCŁAW",
        "54047": "WROCŁAW",
        "54048": "WROCŁAW",
        "54049": "WROCŁAW",
        "54054": "WROCŁAW",
        "54055": "WROCŁAW",
        "54056": "WROCŁAW",
        "54057": "WROCŁAW",
        "54058": "WROCŁAW",
        "54059": "WROCŁAW",
        "54060": "WROCŁAW",
        "54061": "WROCŁAW",
        "54062": "WROCŁAW",
        "54063": "WROCŁAW",
        "54064": "WROCŁAW",
        "54066": "WROCŁAW",
        "54067": "WROCŁAW",
        "54071": "WROCŁAW",
        "54072": "WROCŁAW",
        "54074": "WROCŁAW",
        "54076": "WROCŁAW",
        "54078": "WROCŁAW",
        "54079": "WROCŁAW",
        "54081": "WROCŁAW",
        "54101": "WROCŁAW",
        "54102": "WROCŁAW",
        "54103": "WROCŁAW",
        "54104": "WROCŁAW",
        "54105": "WROCŁAW",
        "54106": "WROCŁAW",
        "54107": "WROCŁAW",
        "54108": "WROCŁAW",
        "54109": "WROCŁAW",
        "54110": "WROCŁAW",
        "54111": "WROCŁAW",
        "54112": "WROCŁAW",
        "54113": "WROCŁAW",
        "54114": "WROCŁAW",
        "54115": "WROCŁAW",
        "54116": "WROCŁAW",
        "54117": "WROCŁAW",
        "54118": "WROCŁAW",
        "54120": "WROCŁAW",
        "54126": "WROCŁAW",
        "54127": "WROCŁAW",
        "54128": "WROCŁAW",
        "54129": "WROCŁAW",
        "54130": "WROCŁAW",
        "54131": "WROCŁAW",
        "54132": "WROCŁAW",
        "54133": "WROCŁAW",
        "54134": "WROCŁAW",
        "54135": "WROCŁAW",
        "54136": "WROCŁAW",
        "54137": "WROCŁAW",
        "54138": "WROCŁAW",
        "54139": "WROCŁAW",
        "54142": "WROCŁAW",
        "54143": "WROCŁAW",
        "54144": "WROCŁAW",
        "54145": "WROCŁAW",
        "54149": "WROCŁAW",
        "54150": "WROCŁAW",
        "54151": "WROCŁAW",
        "54152": "WROCŁAW",
        "54153": "WROCŁAW",
        "54154": "WROCŁAW",
        "54155": "WROCŁAW",
        "54156": "WROCŁAW",
        "54160": "WROCŁAW",
        "54201": "WROCŁAW",
        "54202": "WROCŁAW",
        "54203": "WROCŁAW",
        "54204": "WROCŁAW",
        "54205": "WROCŁAW",
        "54206": "WROCŁAW",
        "54207": "WROCŁAW",
        "54210": "WROCŁAW",
        "54211": "WROCŁAW",
        "54212": "WROCŁAW",
        "54213": "WROCŁAW",
        "54214": "WROCŁAW",
        "54215": "WROCŁAW",
        "54216": "WROCŁAW",
        "54217": "WROCŁAW",
        "54218": "WROCŁAW",
        "54219": "WROCŁAW",
        "54220": "WROCŁAW",
        "54221": "WROCŁAW",
        "54222": "WROCŁAW",
        "54229": "WROCŁAW",
        "54230": "WROCŁAW",
        "54231": "WROCŁAW",
        "54232": "WROCŁAW",
        "54233": "WROCŁAW",
        "54234": "WROCŁAW",
        "54235": "WROCŁAW",
        "54236": "WROCŁAW",
        "54237": "WROCŁAW",
        "54238": "WROCŁAW",
        "54239": "WROCŁAW",
        "54240": "WROCŁAW",
        "54241": "WROCŁAW",
        "54242": "WROCŁAW",
        "54310": "WROCŁAW",
        "54311": "WROCŁAW",
        "54312": "WROCŁAW",
        "54313": "WROCŁAW",
        "54314": "WROCŁAW",
        "54315": "WROCŁAW",
        "54316": "WROCŁAW",
        "54317": "WROCŁAW",
        "54318": "WROCŁAW",
        "54320": "WROCŁAW",
        "54330": "WROCŁAW",
        "54401": "WROCŁAW",
        "54402": "WROCŁAW",
        "54403": "WROCŁAW",
        "54404": "WROCŁAW",
        "54405": "WROCŁAW",
        "54406": "WROCŁAW",
        "54409": "WROCŁAW",
        "54411": "WROCŁAW",
        "54412": "WROCŁAW",
        "54413": "WROCŁAW",
        "54414": "WROCŁAW",
        "54424": "WROCŁAW",
        "54425": "WROCŁAW",
        "54426": "WROCŁAW",
        "54427": "WROCŁAW",
        "54428": "WROCŁAW",
        "54429": "WROCŁAW",
        "54430": "WROCŁAW",
        "54431": "WROCŁAW",
        "54432": "WROCŁAW",
        "54433": "WROCŁAW",
        "54434": "WROCŁAW",
        "54435": "WROCŁAW",
        "54436": "WROCŁAW",
        "54438": "WROCŁAW",
        "54440": "WROCŁAW",
        "54510": "WROCŁAW",
        "54511": "WROCŁAW",
        "54512": "WROCŁAW",
        "54513": "WROCŁAW",
        "54514": "WROCŁAW",
        "54515": "WROCŁAW",
        "54516": "WROCŁAW",
        "54517": "WROCŁAW",
        "54518": "WROCŁAW",
        "54519": "WROCŁAW",
        "54520": "WROCŁAW",
        "54530": "WROCŁAW",
        "54607": "WROCŁAW",
        "54608": "WROCŁAW",
        "54609": "WROCŁAW",
        "54610": "WROCŁAW",
        "54611": "WROCŁAW",
        "54612": "WROCŁAW",
        "54613": "WROCŁAW",
        "54614": "WROCŁAW",
        "54615": "WROCŁAW",
        "54616": "WROCŁAW",
        "54617": "WROCŁAW",
        "54618": "WROCŁAW",
        "54619": "WROCŁAW",
        "54620": "WROCŁAW",
        "54621": "WROCŁAW",
        "54622": "WROCŁAW",
        "54701": "WROCŁAW",
        "54702": "WROCŁAW",
        "54703": "WROCŁAW",
        "54704": "WROCŁAW",
        "54705": "WROCŁAW",
        "55002": "WROCŁAW",
        "55003": "WROCŁAW",
        "55004": "WROCŁAW",
        "55010": "WROCŁAW",
        "55011": "WROCŁAW",
        "55015": "WROCŁAW",
        "55020": "WROCŁAW",
        "55040": "KOBIERZYCE",
        "55041": "WROCŁAW",
        "55042": "WROCŁAW",
        "55045": "WROCŁAW",
        "55050": "WROCŁAW",
        "55051": "WROCŁAW",
        "55065": "WROCŁAW",
        "55070": "WROCŁAW",
        "55075": "WROCŁAW",
        "55076": "WROCŁAW",
        "55077": "WROCŁAW",
        "55080": "WROCŁAW",
        "55081": "WROCŁAW",
        "55090": "WROCŁAW",
        "55091": "WROCŁAW",
        "55093": "WROCŁAW",
        "55094": "WROCŁAW",
        "55095": "MIRKÓW K. WROCŁAWIA",
        "55100": "TRZEBNICA",
        "55106": "TRZEBNICA",
        "55107": "TRZEBNICA",
        "55110": "TRZEBNICA",
        "55114": "TRZEBNICA",
        "55120": "OBORNIKI ŚLĄSKIE",
        "55121": "TRZEBNICA",
        "55124": "TRZEBNICA",
        "55130": "TRZEBNICA",
        "55140": "TRZEBNICA (NET)",
        "55200": "OŁAWA",
        "55201": "OŁAWA",
        "55202": "OŁAWA",
        "55203": "OŁAWA",
        "55206": "OŁAWA",
        "55216": "OŁAWA",
        "55217": "OŁAWA",
        "55220": "OŁAWA",
        "55221": "OŁAWA",
        "55230": "OŁAWA",
        "55231": "OŁAWA",
        "55300": "ŚRODA ŚLĄSKA",
        "55311": "ŚRODA ŚLĄSKA",
        "55318": "ŚRODA ŚLĄSKA",
        "55320": "ŚRODA ŚLĄSKA",
        "55330": "ŚRODA ŚLĄSKA",
        "55333": "ŚRODA ŚLĄSKA",
        "55334": "ŚRODA ŚLĄSKA",
        "55340": "ŚRODA ŚLĄSKA (NET)",
        "55341": "ŚRODA ŚLĄSKA",
        "56100": "WOŁÓW",
        "56110": "WOŁÓW",
        "56120": "BRZEG DOLNY",
        "56121": "BRZEG DOLNY",
        "56122": "BRZEG DOLNY",
        "56150": "WOŁÓW",
        "56160": "WOŁÓW",
        "56200": "GÓRA",
        "56201": "GÓRA",
        "56209": "GÓRA",
        "56210": "GÓRA",
        "56211": "GÓRA",
        "56215": "GÓRA",
        "56300": "MILICZ",
        "56305": "MILICZ",
        "56306": "MILICZ",
        "56320": "MILICZ",
        "56321": "MILICZ",
        "56330": "MILICZ",
        "56400": "OLEŚNICA",
        "56401": "OLEŚNICA",
        "56402": "OLEŚNICA",
        "56403": "OLEŚNICA",
        "56404": "OLEŚNICA",
        "56409": "OLEŚNICA",
        "56410": "OLEŚNICA",
        "56416": "OLEŚNICA",
        "56417": "GOSZCZ",
        "56420": "OLEŚNICA",
        "56500": "SYCÓW",
        "56501": "OLEŚNICA",
        "56504": "OLEŚNICA (NET)",
        "56513": "OLEŚNICA (NET)",
        "57100": "STRZELIN",
        "57110": "STRZELIN",
        "57120": "STRZELIN",
        "57130": "STRZELIN",
        "57150": "STRZELIN",
        "57160": "STRZELIN",
        "57200": "ZĄBKOWICE ŚLĄSKIE",
        "57201": "ZĄBKOWICE ŚLĄSKIE",
        "57206": "ZĄBKOWICE ŚLĄSKIE",
        "57208": "ZĄBKOWICE ŚLĄSKIE",
        "57210": "ZĄBKOWICE ŚLĄSKIE",
        "57211": "ZĄBKOWICE ŚLĄSKIE",
        "57212": "ZĄBKOWICE ŚLĄSKIE",
        "57213": "ZĄBKOWICE ŚLĄSKIE",
        "57214": "ZĄBKOWICE ŚLĄSKIE",
        "57215": "ZĄBKOWICE ŚLĄSKIE",
        "57220": "ZĄBKOWICE ŚLĄSKIE",
        "57221": "ZĄBKOWICE ŚLĄSKIE",
        "57222": "ZĄBKOWICE ŚLĄSKIE",
        "57223": "ZĄBKOWICE ŚLĄSKIE",
        "57224": "ZĄBKOWICE ŚLĄSKIE",
        "57230": "ZĄBKOWICE ŚLĄSKIE",
        "57240": "ZĄBKOWICE ŚLĄSKIE",
        "57241": "ZĄBKOWICE ŚLĄSKIE",
        "57242": "ZĄBKOWICE ŚLĄSKIE",
        "57250": "ZĄBKOWICE ŚLĄSKIE",
        "57251": "ZĄBKOWICE ŚLĄSKIE",
        "57255": "ZĄBKOWICE ŚLĄSKIE",
        "57256": "ZĄBKOWICE ŚLĄSKIE",
        "57257": "ZĄBKOWICE ŚLĄSKIE",
        "57300": "KŁODZKO",
        "57303": "KŁODZKO",
        "57304": "KŁODZKO",
        "57312": "KŁODZKO",
        "57313": "KŁODZKO",
        "57314": "KŁODZKO",
        "57315": "KŁODZKO",
        "57320": "POLANICA-ZDRÓJ",
        "57322": "KŁODZKO",
        "57330": "KŁODZKO",
        "57340": "DUSZNIKI ZDRÓJ",
        "57343": "KŁODZKO",
        "57350": "KUDOWA ZDRÓJ",
        "57351": "KUDOWA ZDRÓJ",
        "57360": "KŁODZKO",
        "57361": "KŁODZKO",
        "57362": "KŁODZKO",
        "57400": "NOWA RUDA",
        "57401": "NOWA RUDA",
        "57402": "NOWA RUDA",
        "57403": "NOWA RUDA",
        "57408": "KŁODZKO",
        "57409": "KŁODZKO",
        "57410": "KŁODZKO",
        "57411": "KŁODZKO",
        "57420": "KŁODZKO",
        "57430": "KŁODZKO",
        "57431": "KŁODZKO",
        "57432": "KŁODZKO",
        "57441": "KŁODZKO",
        "57442": "KŁODZKO",
        "57450": "KŁODZKO",
        "57451": "KŁODZKO",
        "57500": "KŁODZKO",
        "57501": "KŁODZKO",
        "57511": "KŁODZKO",
        "57512": "KŁODZKO",
        "57513": "KŁODZKO",
        "57514": "KŁODZKO",
        "57515": "KŁODZKO",
        "57516": "KŁODZKO",
        "57517": "KŁODZKO",
        "57520": "KŁODZKO",
        "57521": "KŁODZKO",
        "57522": "KŁODZKO",
        "57530": "KŁODZKO",
        "57540": "KŁODZKO",
        "57541": "KŁODZKO",
        "57550": "KŁODZKO",
        "58100": "ŚWIDNICA",
        "58101": "ŚWIDNICA",
        "58102": "ŚWIDNICA",
        "58103": "ŚWIDNICA",
        "58105": "ŚWIDNICA",
        "58106": "ŚWIDNICA",
        "58111": "ŚWIDNICA",
        "58112": "ŚWIDNICA",
        "58113": "ŚWIDNICA",
        "58114": "ŚWIDNICA",
        "58115": "ŚWIDNICA",
        "58116": "DZIERŻONIÓW",
        "58120": "ŚWIDNICA",
        "58121": "ŚWIDNICA",
        "58123": "ŚWIDNICA",
        "58124": "ŚWIDNICA",
        "58125": "ŚWIDNICA",
        "58130": "ŚWIDNICA",
        "58140": "ŚWIDNICA",
        "58141": "ŚWIDNICA",
        "58150": "STRZEGOM",
        "58152": "ŚWIDNICA",
        "58160": "ŚWIEBODZICE",
        "58163": "ŚWIEBODZICE",
        "58170": "ŚWIDNICA",
        "58172": "ŚWIDNICA",
        "58173": "ŚWIDNICA",
        "58200": "DZIERŻONIÓW",
        "58202": "DZIERŻONIÓW",
        "58203": "DZIERŻONIÓW",
        "58204": "DZIERŻONIÓW",
        "58207": "DZIERŻONIÓW",
        "58210": "DZIERŻONIÓW",
        "58211": "DZIERŻONIÓW",
        "58212": "DZIERŻONIÓW",
        "58214": "DZIERŻONIÓW",
        "58217": "DZIERŻONIÓW",
        "58230": "NIEMCZA",
        "58231": "DZIERŻONIÓW",
        "58240": "DZIERŻONIÓW",
        "58241": "DZIERŻONIÓW",
        "58250": "DZIERŻONIÓW",
        "58251": "DZIERŻONIÓW",
        "58252": "DZIERŻONIÓW",
        "58260": "BIELAWA",
        "58261": "BIELAWA",
        "58262": "DZIERŻONIÓW",
        "58263": "BIELAWA",
        "58300": "WAŁBRZYCH",
        "58301": "WAŁBRZYCH",
        "58302": "WAŁBRZYCH",
        "58303": "WAŁBRZYCH",
        "58304": "WAŁBRZYCH",
        "58305": "WAŁBRZYCH",
        "58306": "WAŁBRZYCH",
        "58307": "WAŁBRZYCH",
        "58308": "WAŁBRZYCH",
        "58309": "WAŁBRZYCH",
        "58310": "SZCZAWNO-ZDRÓJ",
        "58311": "WAŁBRZYCH",
        "58312": "WAŁBRZYCH",
        "58313": "WAŁBRZYCH",
        "58314": "WAŁBRZYCH",
        "58316": "WAŁBRZYCH",
        "58320": "WAŁBRZYCH",
        "58321": "WAŁBRZYCH",
        "58330": "WAŁBRZYCH",
        "58340": "WAŁBRZYCH",
        "58350": "WAŁBRZYCH",
        "58351": "WAŁBRZYCH",
        "58352": "WAŁBRZYCH",
        "58370": "WAŁBRZYCH",
        "58371": "WAŁBRZYCH",
        "58372": "WAŁBRZYCH",
        "58373": "WAŁBRZYCH",
        "58379": "WAŁBRZYCH",
        "58390": "WAŁBRZYCH",
        "58400": "KAMIENNA GÓRA",
        "58402": "KAMIENNA GÓRA",
        "58405": "KAMIENNA GÓRA",
        "58407": "KAMIENNA GÓRA",
        "58410": "KAMIENNA GÓRA",
        "58411": "KAMIENNA GÓRA",
        "58420": "KAMIENNA GÓRA",
        "58422": "KAMIENNA GÓRA",
        "58424": "KAMIENNA GÓRA",
        "58425": "KAMIENNA GÓRA",
        "58500": "JELENIA GÓRA",
        "58501": "JELENIA GÓRA",
        "58503": "JELENIA GÓRA",
        "58505": "JELENIA GÓRA",
        "58506": "JELENIA GÓRA",
        "58507": "JELENIA GÓRA",
        "58508": "JELENIA GÓRA",
        "58512": "JELENIA GÓRA",
        "58513": "JELENIA GÓRA",
        "58520": "JELENIA GÓRA",
        "58521": "JELENIA GÓRA",
        "58522": "JELENIA GÓRA",
        "58530": "KOWARY",
        "58531": "JELENIA GÓRA",
        "58532": "JELENIA GÓRA",
        "58533": "JELENIA GÓRA",
        "58534": "JELENIA GÓRA",
        "58535": "JELENIA GÓRA",
        "58540": "JELENIA GÓRA",
        "58550": "JELENIA GÓRA",
        "58560": "JELENIA GÓRA",
        "58562": "JELENIA GÓRA",
        "58563": "JELENIA GÓRA",
        "58564": "JELENIA GÓRA",
        "58570": "JELENIA GÓRA",
        "58573": "JELENIA GÓRA",
        "58580": "JELENIA GÓRA",
        "58588": "JELENIA GÓRA",
        "59100": "POLKOWICE",
        "59101": "POLKOWICE",
        "59140": "CHOCIANÓW",
        "59141": "CHOCIANÓW",
        "59145": "POLKOWICE",
        "59147": "POLKOWICE",
        "59150": "POLKOWICE",
        "59160": "POLKOWICE",
        "59170": "POLKOWICE",
        "59171": "POLKOWICE",
        "59180": "POLKOWICE",
        "59200": "LEGNICA",
        "59202": "LEGNICA",
        "59203": "LEGNICA",
        "59204": "LEGNICA",
        "59205": "LEGNICA",
        "59206": "LEGNICA",
        "59207": "LEGNICA",
        "59208": "LEGNICA",
        "59209": "LEGNICA",
        "59210": "LEGNICA",
        "59211": "LEGNICA",
        "59212": "LEGNICA",
        "59213": "LEGNICA",
        "59214": "LEGNICA",
        "59216": "LEGNICA",
        "59217": "LEGNICA",
        "59220": "LEGNICA",
        "59222": "LEGNICA",
        "59223": "LEGNICA",
        "59224": "CHOJNÓW",
        "59225": "CHOJNÓW",
        "59226": "LEGNICA",
        "59227": "LEGNICA",
        "59228": "LEGNICA",
        "59230": "LEGNICA",
        "59241": "LEGNICA",
        "59243": "LEGNICA",
        "59290": "LEGNICA",
        "59300": "LUBIN",
        "59301": "LUBIN",
        "59302": "LUBIN",
        "59303": "LUBIN",
        "59304": "LUBIN",
        "59305": "LUBIN",
        "59307": "LUBIN",
        "59311": "LUBIN",
        "59323": "LUBIN",
        "59330": "LUBIN",
        "59331": "LUBIN",
        "59334": "LUBIN",
        "59335": "LUBIN",
        "59336": "LUBIN",
        "59337": "LUBIN",
        "59338": "LUBIN",
        "59339": "LUBIN",
        "59340": "LUBIN",
        "59400": "JAWOR",
        "59401": "JAWOR",
        "59402": "JAWOR",
        "59406": "JAWOR",
        "59407": "JAWOR",
        "59411": "JAWOR",
        "59420": "JAWOR",
        "59421": "JAWOR",
        "59423": "JAWOR",
        "59424": "JAWOR",
        "59430": "JAWOR",
        "59431": "JAWOR",
        "59500": "ZŁOTORYJA",
        "59501": "ZŁOTORYJA",
        "59511": "ZŁOTORYJA",
        "59512": "ZŁOTORYJA",
        "59513": "ZŁOTORYJA",
        "59516": "ZŁOTORYJA",
        "59517": "ZŁOTORYJA",
        "59524": "ZŁOTORYJA",
        "59525": "ZŁOTORYJA",
        "59540": "ZŁOTORYJA",
        "59550": "ZŁOTORYJA",
        "59600": "LWÓWEK ŚLĄSKI",
        "59601": "LWÓWEK ŚLĄSKI",
        "59610": "LWÓWEK ŚLĄSKI",
        "59620": "LWÓWEK ŚLĄSKI",
        "59623": "LWÓWEK ŚLĄSKI",
        "59630": "LWÓWEK ŚLĄSKI",
        "59700": "BOLESŁAWIEC",
        "59701": "BOLESŁAWIEC",
        "59702": "BOLESŁAWIEC",
        "59703": "BOLESŁAWIEC",
        "59706": "BOLESŁAWIEC",
        "59707": "BOLESŁAWIEC",
        "59708": "BOLESŁAWIEC",
        "59720": "BOLESŁAWIEC",
        "59721": "BOLESŁAWIEC",
        "59722": "WARTA BOLESŁAWIECKA",
        "59723": "BOLESŁAWIEC",
        "59724": "BOLESŁAWIEC",
        "59725": "BOLESŁAWIEC",
        "59726": "BOLESŁAWIEC",
        "59730": "BOLESŁAWIEC",
        "59731": "BOLESŁAWIEC",
        "59733": "BOLESŁAWIEC",
        "59800": "LUBAŃ",
        "59801": "LUBAŃ",
        "59811": "LUBAŃ",
        "59812": "LUBAŃ",
        "59814": "LUBAŃ",
        "59816": "LUBAŃ",
        "59817": "LUBAŃ",
        "59818": "LUBAŃ",
        "59820": "LUBAŃ",
        "59830": "LUBAŃ",
        "59850": "LUBAŃ",
        "59851": "LUBAŃ",
        "59852": "LUBAŃ",
        "59900": "ZGORZELEC",
        "59901": "ZGORZELEC",
        "59902": "ZGORZELEC",
        "59903": "ZGORZELEC",
        "59911": "ZGORZELEC",
        "59914": "ZGORZELEC",
        "59915": "ZGORZELEC",
        "59916": "ZGORZELEC",
        "59917": "ZGORZELEC",
        "59920": "ZGORZELEC",
        "59921": "ZGORZELEC",
        "59922": "ZGORZELEC",
        "59930": "ZGORZELEC",
        "59940": "ZGORZELEC",
        "59941": "ZGORZELEC",
        "59942": "ZGORZELEC",
        "59950": "ZGORZELEC",
        "59970": "ZGORZELEC",
        "59975": "ZGORZELEC",
        "60001": "POZNAŃ",
        "60002": "POZNAŃ",
        "60003": "POZNAŃ",
        "60004": "POZNAŃ",
        "60005": "POZNAŃ",
        "60008": "POZNAŃ",
        "60009": "POZNAŃ",
        "60012": "POZNAŃ",
        "60013": "POZNAŃ",
        "60101": "POZNAŃ",
        "60102": "POZNAŃ",
        "60103": "POZNAŃ",
        "60104": "POZNAŃ",
        "60105": "POZNAŃ",
        "60106": "POZNAŃ",
        "60107": "POZNAŃ",
        "60108": "POZNAŃ",
        "60111": "POZNAŃ",
        "60112": "POZNAŃ",
        "60113": "POZNAŃ",
        "60114": "POZNAŃ",
        "60115": "POZNAŃ",
        "60116": "POZNAŃ",
        "60118": "POZNAŃ",
        "60119": "POZNAŃ",
        "60120": "POZNAŃ",
        "60121": "POZNAŃ",
        "60122": "POZNAŃ",
        "60123": "POZNAŃ",
        "60124": "POZNAŃ",
        "60125": "POZNAŃ",
        "60126": "POZNAŃ",
        "60128": "POZNAŃ",
        "60129": "POZNAŃ",
        "60130": "POZNAŃ",
        "60131": "POZNAŃ",
        "60132": "POZNAŃ",
        "60133": "POZNAŃ",
        "60134": "POZNAŃ",
        "60135": "POZNAŃ",
        "60136": "POZNAŃ",
        "60137": "POZNAŃ",
        "60138": "POZNAŃ",
        "60139": "POZNAŃ",
        "60141": "POZNAŃ",
        "60142": "POZNAŃ",
        "60143": "POZNAŃ",
        "60144": "POZNAŃ",
        "60147": "POZNAŃ",
        "60148": "POZNAŃ",
        "60149": "POZNAŃ",
        "60151": "POZNAŃ",
        "60152": "POZNAŃ",
        "60153": "POZNAŃ",
        "60157": "POZNAŃ",
        "60158": "POZNAŃ",
        "60159": "POZNAŃ",
        "60160": "POZNAŃ",
        "60161": "POZNAŃ",
        "60162": "POZNAŃ",
        "60163": "POZNAŃ",
        "60164": "POZNAŃ",
        "60166": "POZNAŃ",
        "60167": "POZNAŃ",
        "60168": "POZNAŃ",
        "60169": "POZNAŃ",
        "60171": "POZNAŃ",
        "60173": "POZNAŃ",
        "60174": "POZNAŃ",
        "60175": "POZNAŃ",
        "60176": "POZNAŃ",
        "60177": "POZNAŃ",
        "60178": "POZNAŃ",
        "60179": "POZNAŃ",
        "60182": "POZNAŃ",
        "60183": "POZNAŃ",
        "60184": "POZNAŃ",
        "60185": "POZNAŃ",
        "60186": "POZNAŃ",
        "60187": "POZNAŃ",
        "60188": "POZNAŃ",
        "60189": "POZNAŃ",
        "60190": "POZNAŃ",
        "60192": "POZNAŃ",
        "60193": "POZNAŃ",
        "60194": "POZNAŃ",
        "60195": "POZNAŃ",
        "60196": "POZNAŃ",
        "60197": "POZNAŃ",
        "60198": "POZNAŃ",
        "60201": "POZNAŃ",
        "60202": "POZNAŃ",
        "60203": "POZNAŃ",
        "60204": "POZNAŃ",
        "60205": "POZNAŃ",
        "60206": "POZNAŃ",
        "60208": "POZNAŃ",
        "60209": "POZNAŃ",
        "60211": "POZNAŃ",
        "60212": "POZNAŃ",
        "60213": "POZNAŃ",
        "60214": "POZNAŃ",
        "60215": "POZNAŃ",
        "60216": "POZNAŃ",
        "60218": "POZNAŃ",
        "60219": "POZNAŃ",
        "60220": "POZNAŃ",
        "60221": "POZNAŃ",
        "60222": "POZNAŃ",
        "60223": "POZNAŃ",
        "60224": "POZNAŃ",
        "60225": "POZNAŃ",
        "60226": "POZNAŃ",
        "60227": "POZNAŃ",
        "60228": "POZNAŃ",
        "60229": "POZNAŃ",
        "60231": "POZNAŃ",
        "60232": "POZNAŃ",
        "60233": "POZNAŃ",
        "60234": "POZNAŃ",
        "60235": "POZNAŃ",
        "60236": "POZNAŃ",
        "60237": "POZNAŃ",
        "60238": "POZNAŃ",
        "60239": "POZNAŃ",
        "60240": "POZNAŃ",
        "60241": "POZNAŃ",
        "60242": "POZNAŃ",
        "60243": "POZNAŃ",
        "60244": "POZNAŃ",
        "60245": "POZNAŃ",
        "60246": "POZNAŃ",
        "60247": "POZNAŃ",
        "60248": "POZNAŃ",
        "60251": "POZNAŃ",
        "60252": "POZNAŃ",
        "60253": "POZNAŃ",
        "60254": "POZNAŃ",
        "60255": "POZNAŃ",
        "60256": "POZNAŃ",
        "60257": "POZNAŃ",
        "60258": "POZNAŃ",
        "60259": "POZNAŃ",
        "60260": "POZNAŃ",
        "60261": "POZNAŃ",
        "60262": "POZNAŃ",
        "60263": "POZNAŃ",
        "60264": "POZNAŃ",
        "60265": "POZNAŃ",
        "60266": "POZNAŃ",
        "60267": "POZNAŃ",
        "60268": "POZNAŃ",
        "60269": "POZNAŃ",
        "60271": "POZNAŃ",
        "60272": "POZNAŃ",
        "60273": "POZNAŃ",
        "60274": "POZNAŃ",
        "60275": "POZNAŃ",
        "60276": "POZNAŃ",
        "60277": "POZNAŃ",
        "60278": "POZNAŃ",
        "60279": "POZNAŃ",
        "60281": "POZNAŃ",
        "60282": "POZNAŃ",
        "60283": "POZNAŃ",
        "60284": "POZNAŃ",
        "60286": "POZNAŃ",
        "60287": "POZNAŃ",
        "60288": "POZNAŃ",
        "60289": "POZNAŃ",
        "60301": "POZNAŃ",
        "60302": "POZNAŃ",
        "60303": "POZNAŃ",
        "60304": "POZNAŃ",
        "60306": "POZNAŃ",
        "60307": "POZNAŃ",
        "60308": "POZNAŃ",
        "60309": "POZNAŃ",
        "60311": "POZNAŃ",
        "60312": "POZNAŃ",
        "60313": "POZNAŃ",
        "60315": "POZNAŃ",
        "60316": "POZNAŃ",
        "60317": "POZNAŃ",
        "60318": "POZNAŃ",
        "60319": "POZNAŃ",
        "60320": "POZNAŃ",
        "60321": "POZNAŃ",
        "60322": "POZNAŃ",
        "60323": "POZNAŃ",
        "60324": "POZNAŃ",
        "60325": "POZNAŃ",
        "60326": "POZNAŃ",
        "60327": "POZNAŃ",
        "60328": "POZNAŃ",
        "60329": "POZNAŃ",
        "60330": "POZNAŃ",
        "60331": "POZNAŃ",
        "60332": "POZNAŃ",
        "60334": "POZNAŃ",
        "60335": "POZNAŃ",
        "60336": "POZNAŃ",
        "60337": "POZNAŃ",
        "60338": "POZNAŃ",
        "60339": "POZNAŃ",
        "60341": "POZNAŃ",
        "60343": "POZNAŃ",
        "60344": "POZNAŃ",
        "60345": "POZNAŃ",
        "60346": "POZNAŃ",
        "60347": "POZNAŃ",
        "60348": "POZNAŃ",
        "60349": "POZNAŃ",
        "60350": "POZNAŃ",
        "60351": "POZNAŃ",
        "60352": "POZNAŃ",
        "60354": "POZNAŃ",
        "60355": "POZNAŃ",
        "60356": "POZNAŃ",
        "60357": "POZNAŃ",
        "60358": "POZNAŃ",
        "60359": "POZNAŃ",
        "60361": "POZNAŃ",
        "60362": "POZNAŃ",
        "60363": "POZNAŃ",
        "60365": "POZNAŃ",
        "60366": "POZNAŃ",
        "60367": "POZNAŃ",
        "60368": "POZNAŃ",
        "60369": "POZNAŃ",
        "60371": "POZNAŃ",
        "60373": "POZNAŃ",
        "60374": "POZNAŃ",
        "60375": "POZNAŃ",
        "60376": "POZNAŃ",
        "60378": "POZNAŃ",
        "60379": "POZNAŃ",
        "60381": "POZNAŃ",
        "60382": "POZNAŃ",
        "60383": "POZNAŃ",
        "60384": "POZNAŃ",
        "60385": "POZNAŃ",
        "60386": "POZNAŃ",
        "60387": "POZNAŃ",
        "60388": "POZNAŃ",
        "60389": "POZNAŃ",
        "60391": "POZNAŃ",
        "60392": "POZNAŃ",
        "60393": "POZNAŃ",
        "60394": "POZNAŃ",
        "60395": "POZNAŃ",
        "60396": "POZNAŃ",
        "60397": "POZNAŃ",
        "60398": "POZNAŃ",
        "60401": "POZNAŃ",
        "60406": "POZNAŃ",
        "60407": "POZNAŃ",
        "60408": "POZNAŃ",
        "60409": "POZNAŃ",
        "60411": "POZNAŃ",
        "60412": "POZNAŃ",
        "60413": "POZNAŃ",
        "60415": "POZNAŃ",
        "60416": "POZNAŃ",
        "60418": "POZNAŃ",
        "60419": "POZNAŃ",
        "60421": "POZNAŃ",
        "60425": "POZNAŃ",
        "60427": "POZNAŃ",
        "60431": "POZNAŃ",
        "60432": "POZNAŃ",
        "60433": "POZNAŃ",
        "60434": "POZNAŃ",
        "60438": "POZNAŃ",
        "60439": "POZNAŃ",
        "60441": "POZNAŃ",
        "60442": "POZNAŃ",
        "60443": "POZNAŃ",
        "60446": "POZNAŃ",
        "60447": "POZNAŃ",
        "60449": "POZNAŃ",
        "60451": "POZNAŃ",
        "60452": "POZNAŃ",
        "60453": "POZNAŃ",
        "60454": "POZNAŃ",
        "60456": "POZNAŃ",
        "60457": "POZNAŃ",
        "60458": "POZNAŃ",
        "60460": "POZNAŃ",
        "60461": "POZNAŃ",
        "60462": "POZNAŃ",
        "60463": "POZNAŃ",
        "60464": "POZNAŃ",
        "60465": "POZNAŃ",
        "60466": "POZNAŃ",
        "60467": "POZNAŃ",
        "60468": "POZNAŃ",
        "60469": "POZNAŃ",
        "60470": "POZNAŃ",
        "60471": "POZNAŃ",
        "60472": "POZNAŃ",
        "60473": "POZNAŃ",
        "60474": "POZNAŃ",
        "60475": "POZNAŃ",
        "60476": "POZNAŃ",
        "60478": "POZNAŃ",
        "60479": "POZNAŃ",
        "60480": "POZNAŃ",
        "60501": "POZNAŃ",
        "60502": "POZNAŃ",
        "60503": "POZNAŃ",
        "60504": "POZNAŃ",
        "60505": "POZNAŃ",
        "60506": "POZNAŃ",
        "60507": "POZNAŃ",
        "60508": "POZNAŃ",
        "60509": "POZNAŃ",
        "60511": "POZNAŃ",
        "60512": "POZNAŃ",
        "60513": "POZNAŃ",
        "60514": "POZNAŃ",
        "60516": "POZNAŃ",
        "60517": "POZNAŃ",
        "60518": "POZNAŃ",
        "60519": "POZNAŃ",
        "60521": "POZNAŃ",
        "60522": "POZNAŃ",
        "60523": "POZNAŃ",
        "60524": "POZNAŃ",
        "60525": "POZNAŃ",
        "60526": "POZNAŃ",
        "60527": "POZNAŃ",
        "60528": "POZNAŃ",
        "60529": "POZNAŃ",
        "60531": "POZNAŃ",
        "60532": "POZNAŃ",
        "60533": "POZNAŃ",
        "60534": "POZNAŃ",
        "60535": "POZNAŃ",
        "60536": "POZNAŃ",
        "60537": "POZNAŃ",
        "60538": "POZNAŃ",
        "60539": "POZNAŃ",
        "60541": "POZNAŃ",
        "60542": "POZNAŃ",
        "60543": "POZNAŃ",
        "60544": "POZNAŃ",
        "60545": "POZNAŃ",
        "60546": "POZNAŃ",
        "60547": "POZNAŃ",
        "60548": "POZNAŃ",
        "60549": "POZNAŃ",
        "60551": "POZNAŃ",
        "60552": "POZNAŃ",
        "60553": "POZNAŃ",
        "60554": "POZNAŃ",
        "60555": "POZNAŃ",
        "60556": "POZNAŃ",
        "60557": "POZNAŃ",
        "60558": "POZNAŃ",
        "60559": "POZNAŃ",
        "60560": "POZNAŃ",
        "60561": "POZNAŃ",
        "60562": "POZNAŃ",
        "60563": "POZNAŃ",
        "60564": "POZNAŃ",
        "60566": "POZNAŃ",
        "60567": "POZNAŃ",
        "60568": "POZNAŃ",
        "60569": "POZNAŃ",
        "60571": "POZNAŃ",
        "60572": "POZNAŃ",
        "60573": "POZNAŃ",
        "60574": "POZNAŃ",
        "60575": "POZNAŃ",
        "60576": "POZNAŃ",
        "60577": "POZNAŃ",
        "60578": "POZNAŃ",
        "60579": "POZNAŃ",
        "60580": "POZNAŃ",
        "60581": "POZNAŃ",
        "60582": "POZNAŃ",
        "60583": "POZNAŃ",
        "60584": "POZNAŃ",
        "60586": "POZNAŃ",
        "60587": "POZNAŃ",
        "60588": "POZNAŃ",
        "60589": "POZNAŃ",
        "60591": "POZNAŃ",
        "60592": "POZNAŃ",
        "60593": "POZNAŃ",
        "60594": "POZNAŃ",
        "60595": "POZNAŃ",
        "60598": "POZNAŃ",
        "60601": "POZNAŃ",
        "60602": "POZNAŃ",
        "60603": "POZNAŃ",
        "60604": "POZNAŃ",
        "60605": "POZNAŃ",
        "60607": "POZNAŃ",
        "60608": "POZNAŃ",
        "60611": "POZNAŃ",
        "60612": "POZNAŃ",
        "60613": "POZNAŃ",
        "60614": "POZNAŃ",
        "60615": "POZNAŃ",
        "60616": "POZNAŃ",
        "60617": "POZNAŃ",
        "60618": "POZNAŃ",
        "60619": "POZNAŃ",
        "60621": "POZNAŃ",
        "60622": "POZNAŃ",
        "60623": "POZNAŃ",
        "60624": "POZNAŃ",
        "60625": "POZNAŃ",
        "60626": "POZNAŃ",
        "60627": "POZNAŃ",
        "60628": "POZNAŃ",
        "60631": "POZNAŃ",
        "60632": "POZNAŃ",
        "60633": "POZNAŃ",
        "60637": "POZNAŃ",
        "60638": "POZNAŃ",
        "60639": "POZNAŃ",
        "60641": "POZNAŃ",
        "60642": "POZNAŃ",
        "60643": "POZNAŃ",
        "60644": "POZNAŃ",
        "60645": "POZNAŃ",
        "60646": "POZNAŃ",
        "60647": "POZNAŃ",
        "60648": "POZNAŃ",
        "60649": "POZNAŃ",
        "60650": "POZNAŃ",
        "60651": "POZNAŃ",
        "60652": "POZNAŃ",
        "60653": "POZNAŃ",
        "60654": "POZNAŃ",
        "60655": "POZNAŃ",
        "60656": "POZNAŃ",
        "60658": "POZNAŃ",
        "60660": "POZNAŃ",
        "60661": "POZNAŃ",
        "60663": "POZNAŃ",
        "60665": "POZNAŃ",
        "60666": "POZNAŃ",
        "60667": "POZNAŃ",
        "60668": "POZNAŃ",
        "60669": "POZNAŃ",
        "60670": "POZNAŃ",
        "60680": "POZNAŃ",
        "60681": "POZNAŃ",
        "60682": "POZNAŃ",
        "60683": "POZNAŃ",
        "60684": "POZNAŃ",
        "60685": "POZNAŃ",
        "60686": "POZNAŃ",
        "60687": "POZNAŃ",
        "60688": "POZNAŃ",
        "60689": "POZNAŃ",
        "60690": "POZNAŃ",
        "60691": "POZNAŃ",
        "60692": "POZNAŃ",
        "60693": "POZNAŃ",
        "60694": "POZNAŃ",
        "60700": "POZNAŃ",
        "60701": "POZNAŃ",
        "60702": "POZNAŃ",
        "60703": "POZNAŃ",
        "60704": "POZNAŃ",
        "60705": "POZNAŃ",
        "60706": "POZNAŃ",
        "60707": "POZNAŃ",
        "60708": "POZNAŃ",
        "60709": "POZNAŃ",
        "60710": "POZNAŃ",
        "60711": "POZNAŃ",
        "60712": "POZNAŃ",
        "60713": "POZNAŃ",
        "60715": "POZNAŃ",
        "60716": "POZNAŃ",
        "60717": "POZNAŃ",
        "60718": "POZNAŃ",
        "60719": "POZNAŃ",
        "60720": "POZNAŃ",
        "60722": "POZNAŃ",
        "60723": "POZNAŃ",
        "60724": "POZNAŃ",
        "60725": "POZNAŃ",
        "60726": "POZNAŃ",
        "60727": "POZNAŃ",
        "60728": "POZNAŃ",
        "60729": "POZNAŃ",
        "60731": "POZNAŃ",
        "60732": "POZNAŃ",
        "60733": "POZNAŃ",
        "60734": "POZNAŃ",
        "60736": "POZNAŃ",
        "60737": "POZNAŃ",
        "60738": "POZNAŃ",
        "60739": "POZNAŃ",
        "60740": "POZNAŃ",
        "60741": "POZNAŃ",
        "60743": "POZNAŃ",
        "60744": "POZNAŃ",
        "60745": "POZNAŃ",
        "60746": "POZNAŃ",
        "60747": "POZNAŃ",
        "60748": "POZNAŃ",
        "60749": "POZNAŃ",
        "60750": "POZNAŃ",
        "60751": "POZNAŃ",
        "60753": "POZNAŃ",
        "60754": "POZNAŃ",
        "60755": "POZNAŃ",
        "60756": "POZNAŃ",
        "60757": "POZNAŃ",
        "60758": "POZNAŃ",
        "60759": "POZNAŃ",
        "60760": "POZNAŃ",
        "60761": "POZNAŃ",
        "60762": "POZNAŃ",
        "60763": "POZNAŃ",
        "60764": "POZNAŃ",
        "60765": "POZNAŃ",
        "60766": "POZNAŃ",
        "60767": "POZNAŃ",
        "60768": "POZNAŃ",
        "60769": "POZNAŃ",
        "60770": "POZNAŃ",
        "60771": "POZNAŃ",
        "60772": "POZNAŃ",
        "60773": "POZNAŃ",
        "60774": "POZNAŃ",
        "60775": "POZNAŃ",
        "60778": "POZNAŃ",
        "60779": "POZNAŃ",
        "60780": "POZNAŃ",
        "60781": "POZNAŃ",
        "60782": "POZNAŃ",
        "60783": "POZNAŃ",
        "60784": "POZNAŃ",
        "60785": "POZNAŃ",
        "60786": "POZNAŃ",
        "60787": "POZNAŃ",
        "60788": "POZNAŃ",
        "60789": "POZNAŃ",
        "60790": "POZNAŃ",
        "60791": "POZNAŃ",
        "60792": "POZNAŃ",
        "60800": "POZNAŃ",
        "60801": "POZNAŃ",
        "60802": "POZNAŃ",
        "60803": "POZNAŃ",
        "60804": "POZNAŃ",
        "60805": "POZNAŃ",
        "60806": "POZNAŃ",
        "60808": "POZNAŃ",
        "60809": "POZNAŃ",
        "60810": "POZNAŃ",
        "60811": "POZNAŃ",
        "60812": "POZNAŃ",
        "60813": "POZNAŃ",
        "60814": "POZNAŃ",
        "60815": "POZNAŃ",
        "60816": "POZNAŃ",
        "60817": "POZNAŃ",
        "60818": "POZNAŃ",
        "60819": "POZNAŃ",
        "60820": "POZNAŃ",
        "60821": "POZNAŃ",
        "60822": "POZNAŃ",
        "60823": "POZNAŃ",
        "60824": "POZNAŃ",
        "60825": "POZNAŃ",
        "60826": "POZNAŃ",
        "60829": "POZNAŃ",
        "60830": "POZNAŃ",
        "60831": "POZNAŃ",
        "60832": "POZNAŃ",
        "60833": "POZNAŃ",
        "60834": "POZNAŃ",
        "60835": "POZNAŃ",
        "60836": "POZNAŃ",
        "60837": "POZNAŃ",
        "60838": "POZNAŃ",
        "60839": "POZNAŃ",
        "60840": "POZNAŃ",
        "60841": "POZNAŃ",
        "60842": "POZNAŃ",
        "60843": "POZNAŃ",
        "60844": "POZNAŃ",
        "60845": "POZNAŃ",
        "60846": "POZNAŃ",
        "60847": "POZNAŃ",
        "60848": "POZNAŃ",
        "60849": "POZNAŃ",
        "60850": "POZNAŃ",
        "60851": "POZNAŃ",
        "60852": "POZNAŃ",
        "60853": "POZNAŃ",
        "60854": "POZNAŃ",
        "60855": "POZNAŃ",
        "60856": "POZNAŃ",
        "60857": "POZNAŃ",
        "60858": "POZNAŃ",
        "60859": "POZNAŃ",
        "60860": "POZNAŃ",
        "60861": "POZNAŃ",
        "60862": "POZNAŃ",
        "60863": "POZNAŃ",
        "60864": "POZNAŃ",
        "60865": "POZNAŃ",
        "60866": "POZNAŃ",
        "60867": "POZNAŃ",
        "60870": "POZNAŃ",
        "60880": "POZNAŃ",
        "60900": "POZNAŃ",
        "60901": "POZNAŃ",
        "60902": "POZNAŃ",
        "60903": "POZNAŃ",
        "60904": "POZNAŃ",
        "60907": "POZNAŃ",
        "60908": "POZNAŃ",
        "60909": "POZNAŃ",
        "60911": "POZNAŃ",
        "60912": "POZNAŃ",
        "60914": "POZNAŃ",
        "60915": "POZNAŃ",
        "60916": "POZNAŃ",
        "60917": "POZNAŃ",
        "60918": "POZNAŃ",
        "60919": "POZNAŃ",
        "60920": "POZNAŃ",
        "60921": "POZNAŃ",
        "60923": "POZNAŃ",
        "60924": "POZNAŃ",
        "60925": "POZNAŃ",
        "60929": "POZNAŃ",
        "60930": "POZNAŃ",
        "60931": "POZNAŃ",
        "60932": "POZNAŃ",
        "60938": "POZNAŃ",
        "60939": "POZNAŃ",
        "60940": "POZNAŃ",
        "60941": "POZNAŃ",
        "60942": "POZNAŃ",
        "60943": "POZNAŃ",
        "60944": "POZNAŃ",
        "60945": "POZNAŃ",
        "60946": "POZNAŃ",
        "60947": "POZNAŃ",
        "60948": "POZNAŃ",
        "60950": "POZNAŃ",
        "60951": "POZNAŃ",
        "60952": "POZNAŃ",
        "60953": "POZNAŃ",
        "60955": "POZNAŃ",
        "60956": "POZNAŃ",
        "60957": "POZNAŃ",
        "60958": "POZNAŃ",
        "60959": "POZNAŃ",
        "60960": "POZNAŃ",
        "60961": "POZNAŃ",
        "60962": "POZNAŃ",
        "60963": "POZNAŃ",
        "60964": "POZNAŃ",
        "60965": "POZNAŃ",
        "60966": "POZNAŃ",
        "60967": "POZNAŃ",
        "60968": "POZNAŃ",
        "60969": "POZNAŃ",
        "60970": "POZNAŃ",
        "60971": "POZNAŃ",
        "60972": "POZNAŃ",
        "60973": "POZNAŃ",
        "60974": "POZNAŃ",
        "60975": "POZNAŃ",
        "60976": "POZNAŃ",
        "60977": "POZNAŃ",
        "60978": "POZNAŃ",
        "60979": "POZNAŃ",
        "60980": "POZNAŃ",
        "60982": "POZNAŃ",
        "60983": "POZNAŃ",
        "60985": "POZNAŃ",
        "60987": "POZNAŃ",
        "60988": "POZNAŃ",
        "60989": "POZNAŃ",
        "60990": "POZNAŃ",
        "60991": "POZNAŃ",
        "60992": "POZNAŃ",
        "60993": "POZNAŃ",
        "60994": "POZNAŃ",
        "60995": "POZNAŃ",
        "60999": "POZNAŃ",
        "61001": "POZNAŃ",
        "61002": "POZNAŃ",
        "61003": "POZNAŃ",
        "61005": "POZNAŃ",
        "61006": "POZNAŃ",
        "61007": "POZNAŃ",
        "61008": "POZNAŃ",
        "61010": "POZNAŃ",
        "61011": "POZNAŃ",
        "61012": "POZNAŃ",
        "61013": "POZNAŃ",
        "61014": "POZNAŃ",
        "61015": "POZNAŃ",
        "61016": "POZNAŃ",
        "61017": "POZNAŃ",
        "61019": "POZNAŃ",
        "61021": "POZNAŃ",
        "61022": "POZNAŃ",
        "61023": "POZNAŃ",
        "61024": "POZNAŃ",
        "61028": "POZNAŃ",
        "61029": "POZNAŃ",
        "61031": "POZNAŃ",
        "61033": "POZNAŃ",
        "61035": "POZNAŃ",
        "61036": "POZNAŃ",
        "61037": "POZNAŃ",
        "61038": "POZNAŃ",
        "61039": "POZNAŃ",
        "61040": "POZNAŃ",
        "61041": "POZNAŃ",
        "61042": "POZNAŃ",
        "61043": "POZNAŃ",
        "61044": "POZNAŃ",
        "61045": "POZNAŃ",
        "61046": "POZNAŃ",
        "61047": "POZNAŃ",
        "61048": "POZNAŃ",
        "61049": "POZNAŃ",
        "61051": "POZNAŃ",
        "61052": "POZNAŃ",
        "61053": "POZNAŃ",
        "61054": "POZNAŃ",
        "61055": "POZNAŃ",
        "61056": "POZNAŃ",
        "61057": "POZNAŃ",
        "61058": "POZNAŃ",
        "61059": "POZNAŃ",
        "61062": "POZNAŃ",
        "61063": "POZNAŃ",
        "61064": "POZNAŃ",
        "61065": "POZNAŃ",
        "61066": "POZNAŃ",
        "61070": "POZNAŃ",
        "61101": "POZNAŃ",
        "61102": "POZNAŃ",
        "61103": "POZNAŃ",
        "61104": "POZNAŃ",
        "61105": "POZNAŃ",
        "61108": "POZNAŃ",
        "61109": "POZNAŃ",
        "61111": "POZNAŃ",
        "61112": "POZNAŃ",
        "61113": "POZNAŃ",
        "61114": "POZNAŃ",
        "61115": "POZNAŃ",
        "61116": "POZNAŃ",
        "61117": "POZNAŃ",
        "61118": "POZNAŃ",
        "61119": "POZNAŃ",
        "61120": "POZNAŃ",
        "61121": "POZNAŃ",
        "61122": "POZNAŃ",
        "61123": "POZNAŃ",
        "61124": "POZNAŃ",
        "61125": "POZNAŃ",
        "61126": "POZNAŃ",
        "61127": "POZNAŃ",
        "61128": "POZNAŃ",
        "61129": "POZNAŃ",
        "61131": "POZNAŃ",
        "61132": "POZNAŃ",
        "61136": "POZNAŃ",
        "61138": "POZNAŃ",
        "61139": "POZNAŃ",
        "61140": "POZNAŃ",
        "61141": "POZNAŃ",
        "61142": "POZNAŃ",
        "61144": "POZNAŃ",
        "61145": "POZNAŃ",
        "61146": "POZNAŃ",
        "61147": "POZNAŃ",
        "61148": "POZNAŃ",
        "61149": "POZNAŃ",
        "61151": "POZNAŃ",
        "61152": "POZNAŃ",
        "61153": "POZNAŃ",
        "61154": "POZNAŃ",
        "61155": "POZNAŃ",
        "61156": "POZNAŃ",
        "61157": "POZNAŃ",
        "61158": "POZNAŃ",
        "61159": "POZNAŃ",
        "61160": "POZNAŃ",
        "61161": "POZNAŃ",
        "61162": "POZNAŃ",
        "61163": "POZNAŃ",
        "61164": "POZNAŃ",
        "61165": "POZNAŃ",
        "61166": "POZNAŃ",
        "61167": "POZNAŃ",
        "61168": "POZNAŃ",
        "61203": "POZNAŃ",
        "61204": "POZNAŃ",
        "61205": "POZNAŃ",
        "61206": "POZNAŃ",
        "61207": "POZNAŃ",
        "61208": "POZNAŃ",
        "61209": "POZNAŃ",
        "61211": "POZNAŃ",
        "61212": "POZNAŃ",
        "61213": "POZNAŃ",
        "61214": "POZNAŃ",
        "61215": "POZNAŃ",
        "61216": "POZNAŃ",
        "61217": "POZNAŃ",
        "61218": "POZNAŃ",
        "61219": "POZNAŃ",
        "61220": "POZNAŃ",
        "61221": "POZNAŃ",
        "61222": "POZNAŃ",
        "61223": "POZNAŃ",
        "61224": "POZNAŃ",
        "61225": "POZNAŃ",
        "61226": "POZNAŃ",
        "61227": "POZNAŃ",
        "61228": "POZNAŃ",
        "61229": "POZNAŃ",
        "61231": "POZNAŃ",
        "61232": "POZNAŃ",
        "61233": "POZNAŃ",
        "61234": "POZNAŃ",
        "61235": "POZNAŃ",
        "61236": "POZNAŃ",
        "61237": "POZNAŃ",
        "61238": "POZNAŃ",
        "61239": "POZNAŃ",
        "61240": "POZNAŃ",
        "61241": "POZNAŃ",
        "61242": "POZNAŃ",
        "61243": "POZNAŃ",
        "61244": "POZNAŃ",
        "61245": "POZNAŃ",
        "61246": "POZNAŃ",
        "61248": "POZNAŃ",
        "61249": "POZNAŃ",
        "61250": "POZNAŃ",
        "61251": "POZNAŃ",
        "61252": "POZNAŃ",
        "61253": "POZNAŃ",
        "61255": "POZNAŃ",
        "61280": "POZNAŃ",
        "61285": "POZNAŃ",
        "61286": "POZNAŃ",
        "61287": "POZNAŃ",
        "61288": "POZNAŃ",
        "61289": "POZNAŃ",
        "61290": "POZNAŃ",
        "61291": "POZNAŃ",
        "61292": "POZNAŃ",
        "61293": "POZNAŃ",
        "61294": "POZNAŃ",
        "61295": "POZNAŃ",
        "61296": "POZNAŃ",
        "61297": "POZNAŃ",
        "61298": "POZNAŃ",
        "61299": "POZNAŃ",
        "61302": "POZNAŃ",
        "61303": "POZNAŃ",
        "61304": "POZNAŃ",
        "61306": "POZNAŃ",
        "61307": "POZNAŃ",
        "61308": "POZNAŃ",
        "61309": "POZNAŃ",
        "61310": "POZNAŃ",
        "61311": "POZNAŃ",
        "61312": "POZNAŃ",
        "61313": "POZNAŃ",
        "61314": "POZNAŃ",
        "61315": "POZNAŃ",
        "61316": "POZNAŃ",
        "61317": "POZNAŃ",
        "61318": "POZNAŃ",
        "61321": "POZNAŃ",
        "61323": "POZNAŃ",
        "61324": "POZNAŃ",
        "61327": "POZNAŃ",
        "61328": "POZNAŃ",
        "61329": "POZNAŃ",
        "61332": "POZNAŃ",
        "61333": "POZNAŃ",
        "61334": "POZNAŃ",
        "61335": "POZNAŃ",
        "61337": "POZNAŃ",
        "61339": "POZNAŃ",
        "61341": "POZNAŃ",
        "61343": "POZNAŃ",
        "61344": "POZNAŃ",
        "61345": "POZNAŃ",
        "61347": "POZNAŃ",
        "61348": "POZNAŃ",
        "61351": "POZNAŃ",
        "61353": "POZNAŃ",
        "61354": "POZNAŃ",
        "61355": "POZNAŃ",
        "61357": "POZNAŃ",
        "61359": "POZNAŃ",
        "61360": "POZNAŃ",
        "61361": "POZNAŃ",
        "61362": "POZNAŃ",
        "61366": "POZNAŃ",
        "61367": "POZNAŃ",
        "61368": "POZNAŃ",
        "61369": "POZNAŃ",
        "61370": "POZNAŃ",
        "61371": "POZNAŃ",
        "61372": "POZNAŃ",
        "61373": "POZNAŃ",
        "61374": "POZNAŃ",
        "61375": "POZNAŃ",
        "61376": "POZNAŃ",
        "61377": "POZNAŃ",
        "61378": "POZNAŃ",
        "61379": "POZNAŃ",
        "61381": "POZNAŃ",
        "61382": "POZNAŃ",
        "61383": "POZNAŃ",
        "61384": "POZNAŃ",
        "61385": "POZNAŃ",
        "61386": "POZNAŃ",
        "61387": "POZNAŃ",
        "61388": "POZNAŃ",
        "61389": "POZNAŃ",
        "61391": "POZNAŃ",
        "61392": "POZNAŃ",
        "61393": "POZNAŃ",
        "61394": "POZNAŃ",
        "61395": "POZNAŃ",
        "61396": "POZNAŃ",
        "61397": "POZNAŃ",
        "61401": "POZNAŃ",
        "61402": "POZNAŃ",
        "61403": "POZNAŃ",
        "61404": "POZNAŃ",
        "61405": "POZNAŃ",
        "61406": "POZNAŃ",
        "61407": "POZNAŃ",
        "61408": "POZNAŃ",
        "61409": "POZNAŃ",
        "61410": "POZNAŃ",
        "61411": "POZNAŃ",
        "61412": "POZNAŃ",
        "61413": "POZNAŃ",
        "61414": "POZNAŃ",
        "61415": "POZNAŃ",
        "61417": "POZNAŃ",
        "61418": "POZNAŃ",
        "61419": "POZNAŃ",
        "61421": "POZNAŃ",
        "61422": "POZNAŃ",
        "61423": "POZNAŃ",
        "61424": "POZNAŃ",
        "61425": "POZNAŃ",
        "61426": "POZNAŃ",
        "61427": "POZNAŃ",
        "61428": "POZNAŃ",
        "61429": "POZNAŃ",
        "61431": "POZNAŃ",
        "61432": "POZNAŃ",
        "61433": "POZNAŃ",
        "61434": "POZNAŃ",
        "61435": "POZNAŃ",
        "61436": "POZNAŃ",
        "61437": "POZNAŃ",
        "61440": "POZNAŃ",
        "61441": "POZNAŃ",
        "61442": "POZNAŃ",
        "61443": "POZNAŃ",
        "61444": "POZNAŃ",
        "61445": "POZNAŃ",
        "61446": "POZNAŃ",
        "61447": "POZNAŃ",
        "61448": "POZNAŃ",
        "61449": "POZNAŃ",
        "61450": "POZNAŃ",
        "61451": "POZNAŃ",
        "61453": "POZNAŃ",
        "61454": "POZNAŃ",
        "61455": "POZNAŃ",
        "61456": "POZNAŃ",
        "61457": "POZNAŃ",
        "61458": "POZNAŃ",
        "61459": "POZNAŃ",
        "61461": "POZNAŃ",
        "61462": "POZNAŃ",
        "61463": "POZNAŃ",
        "61464": "POZNAŃ",
        "61465": "POZNAŃ",
        "61466": "POZNAŃ",
        "61467": "POZNAŃ",
        "61468": "POZNAŃ",
        "61469": "POZNAŃ",
        "61471": "POZNAŃ",
        "61472": "POZNAŃ",
        "61473": "POZNAŃ",
        "61474": "POZNAŃ",
        "61475": "POZNAŃ",
        "61476": "POZNAŃ",
        "61477": "POZNAŃ",
        "61478": "POZNAŃ",
        "61479": "POZNAŃ",
        "61481": "POZNAŃ",
        "61482": "POZNAŃ",
        "61483": "POZNAŃ",
        "61485": "POZNAŃ",
        "61486": "POZNAŃ",
        "61487": "POZNAŃ",
        "61488": "POZNAŃ",
        "61489": "POZNAŃ",
        "61491": "POZNAŃ",
        "61492": "POZNAŃ",
        "61493": "POZNAŃ",
        "61494": "POZNAŃ",
        "61495": "POZNAŃ",
        "61496": "POZNAŃ",
        "61501": "POZNAŃ",
        "61502": "POZNAŃ",
        "61503": "POZNAŃ",
        "61504": "POZNAŃ",
        "61505": "POZNAŃ",
        "61507": "POZNAŃ",
        "61508": "POZNAŃ",
        "61509": "POZNAŃ",
        "61511": "POZNAŃ",
        "61512": "POZNAŃ",
        "61513": "POZNAŃ",
        "61514": "POZNAŃ",
        "61515": "POZNAŃ",
        "61517": "POZNAŃ",
        "61518": "POZNAŃ",
        "61519": "POZNAŃ",
        "61521": "POZNAŃ",
        "61522": "POZNAŃ",
        "61523": "POZNAŃ",
        "61524": "POZNAŃ",
        "61525": "POZNAŃ",
        "61526": "POZNAŃ",
        "61527": "POZNAŃ",
        "61528": "POZNAŃ",
        "61529": "POZNAŃ",
        "61530": "POZNAŃ",
        "61531": "POZNAŃ",
        "61532": "POZNAŃ",
        "61534": "POZNAŃ",
        "61535": "POZNAŃ",
        "61536": "POZNAŃ",
        "61537": "POZNAŃ",
        "61538": "POZNAŃ",
        "61540": "POZNAŃ",
        "61541": "POZNAŃ",
        "61542": "POZNAŃ",
        "61543": "POZNAŃ",
        "61544": "POZNAŃ",
        "61545": "POZNAŃ",
        "61546": "POZNAŃ",
        "61547": "POZNAŃ",
        "61548": "POZNAŃ",
        "61551": "POZNAŃ",
        "61552": "POZNAŃ",
        "61553": "POZNAŃ",
        "61555": "POZNAŃ",
        "61556": "POZNAŃ",
        "61558": "POZNAŃ",
        "61559": "POZNAŃ",
        "61561": "POZNAŃ",
        "61562": "POZNAŃ",
        "61563": "POZNAŃ",
        "61564": "POZNAŃ",
        "61565": "POZNAŃ",
        "61567": "POZNAŃ",
        "61568": "POZNAŃ",
        "61569": "POZNAŃ",
        "61571": "POZNAŃ",
        "61572": "POZNAŃ",
        "61573": "POZNAŃ",
        "61574": "POZNAŃ",
        "61575": "POZNAŃ",
        "61576": "POZNAŃ",
        "61577": "POZNAŃ",
        "61578": "POZNAŃ",
        "61579": "POZNAŃ",
        "61581": "POZNAŃ",
        "61582": "POZNAŃ",
        "61583": "POZNAŃ",
        "61584": "POZNAŃ",
        "61585": "POZNAŃ",
        "61586": "POZNAŃ",
        "61588": "POZNAŃ",
        "61601": "POZNAŃ",
        "61602": "POZNAŃ",
        "61603": "POZNAŃ",
        "61605": "POZNAŃ",
        "61606": "POZNAŃ",
        "61607": "POZNAŃ",
        "61608": "POZNAŃ",
        "61609": "POZNAŃ",
        "61610": "POZNAŃ",
        "61611": "POZNAŃ",
        "61612": "POZNAŃ",
        "61613": "POZNAŃ",
        "61614": "POZNAŃ",
        "61615": "POZNAŃ",
        "61616": "POZNAŃ",
        "61619": "POZNAŃ",
        "61620": "POZNAŃ",
        "61621": "POZNAŃ",
        "61622": "POZNAŃ",
        "61623": "POZNAŃ",
        "61624": "POZNAŃ",
        "61625": "POZNAŃ",
        "61626": "POZNAŃ",
        "61627": "POZNAŃ",
        "61628": "POZNAŃ",
        "61629": "POZNAŃ",
        "61631": "POZNAŃ",
        "61632": "POZNAŃ",
        "61633": "POZNAŃ",
        "61634": "POZNAŃ",
        "61635": "POZNAŃ",
        "61636": "POZNAŃ",
        "61637": "POZNAŃ",
        "61638": "POZNAŃ",
        "61639": "POZNAŃ",
        "61640": "POZNAŃ",
        "61641": "POZNAŃ",
        "61642": "POZNAŃ",
        "61643": "POZNAŃ",
        "61644": "POZNAŃ",
        "61645": "POZNAŃ",
        "61646": "POZNAŃ",
        "61647": "POZNAŃ",
        "61648": "POZNAŃ",
        "61649": "POZNAŃ",
        "61650": "POZNAŃ",
        "61651": "POZNAŃ",
        "61652": "POZNAŃ",
        "61653": "POZNAŃ",
        "61654": "POZNAŃ",
        "61655": "POZNAŃ",
        "61656": "POZNAŃ",
        "61657": "POZNAŃ",
        "61658": "POZNAŃ",
        "61659": "POZNAŃ",
        "61660": "POZNAŃ",
        "61661": "POZNAŃ",
        "61662": "POZNAŃ",
        "61663": "POZNAŃ",
        "61664": "POZNAŃ",
        "61666": "POZNAŃ",
        "61667": "POZNAŃ",
        "61668": "POZNAŃ",
        "61670": "POZNAŃ",
        "61671": "POZNAŃ",
        "61672": "POZNAŃ",
        "61673": "POZNAŃ",
        "61674": "POZNAŃ",
        "61675": "POZNAŃ",
        "61676": "POZNAŃ",
        "61677": "POZNAŃ",
        "61678": "POZNAŃ",
        "61679": "POZNAŃ",
        "61680": "POZNAŃ",
        "61681": "POZNAŃ",
        "61682": "POZNAŃ",
        "61683": "POZNAŃ",
        "61684": "POZNAŃ",
        "61685": "POZNAŃ",
        "61686": "POZNAŃ",
        "61687": "POZNAŃ",
        "61688": "POZNAŃ",
        "61689": "POZNAŃ",
        "61691": "POZNAŃ",
        "61692": "POZNAŃ",
        "61693": "POZNAŃ",
        "61694": "POZNAŃ",
        "61695": "POZNAŃ",
        "61696": "POZNAŃ",
        "61697": "POZNAŃ",
        "61698": "POZNAŃ",
        "61699": "POZNAŃ",
        "61701": "POZNAŃ",
        "61702": "POZNAŃ",
        "61703": "POZNAŃ",
        "61704": "POZNAŃ",
        "61705": "POZNAŃ",
        "61706": "POZNAŃ",
        "61707": "POZNAŃ",
        "61708": "POZNAŃ",
        "61709": "POZNAŃ",
        "61710": "POZNAŃ",
        "61711": "POZNAŃ",
        "61712": "POZNAŃ",
        "61713": "POZNAŃ",
        "61714": "POZNAŃ",
        "61715": "POZNAŃ",
        "61716": "POZNAŃ",
        "61717": "POZNAŃ",
        "61718": "POZNAŃ",
        "61719": "POZNAŃ",
        "61720": "POZNAŃ",
        "61721": "POZNAŃ",
        "61722": "POZNAŃ",
        "61725": "POZNAŃ",
        "61726": "POZNAŃ",
        "61727": "POZNAŃ",
        "61728": "POZNAŃ",
        "61729": "POZNAŃ",
        "61730": "POZNAŃ",
        "61731": "POZNAŃ",
        "61732": "POZNAŃ",
        "61733": "POZNAŃ",
        "61734": "POZNAŃ",
        "61735": "POZNAŃ",
        "61736": "POZNAŃ",
        "61737": "POZNAŃ",
        "61738": "POZNAŃ",
        "61739": "POZNAŃ",
        "61740": "POZNAŃ",
        "61741": "POZNAŃ",
        "61742": "POZNAŃ",
        "61743": "POZNAŃ",
        "61744": "POZNAŃ",
        "61745": "POZNAŃ",
        "61746": "POZNAŃ",
        "61747": "POZNAŃ",
        "61748": "POZNAŃ",
        "61749": "POZNAŃ",
        "61751": "POZNAŃ",
        "61752": "POZNAŃ",
        "61753": "POZNAŃ",
        "61754": "POZNAŃ",
        "61755": "POZNAŃ",
        "61756": "POZNAŃ",
        "61757": "POZNAŃ",
        "61758": "POZNAŃ",
        "61759": "POZNAŃ",
        "61760": "POZNAŃ",
        "61761": "POZNAŃ",
        "61762": "POZNAŃ",
        "61763": "POZNAŃ",
        "61764": "POZNAŃ",
        "61765": "POZNAŃ",
        "61766": "POZNAŃ",
        "61767": "POZNAŃ",
        "61768": "POZNAŃ",
        "61770": "POZNAŃ",
        "61771": "POZNAŃ",
        "61772": "POZNAŃ",
        "61773": "POZNAŃ",
        "61774": "POZNAŃ",
        "61775": "POZNAŃ",
        "61776": "POZNAŃ",
        "61777": "POZNAŃ",
        "61778": "POZNAŃ",
        "61779": "POZNAŃ",
        "61780": "POZNAŃ",
        "61781": "POZNAŃ",
        "61782": "POZNAŃ",
        "61800": "POZNAŃ",
        "61801": "POZNAŃ",
        "61802": "POZNAŃ",
        "61803": "POZNAŃ",
        "61804": "POZNAŃ",
        "61805": "POZNAŃ",
        "61806": "POZNAŃ",
        "61807": "POZNAŃ",
        "61808": "POZNAŃ",
        "61809": "POZNAŃ",
        "61810": "POZNAŃ",
        "61812": "POZNAŃ",
        "61813": "POZNAŃ",
        "61814": "POZNAŃ",
        "61815": "POZNAŃ",
        "61816": "POZNAŃ",
        "61817": "POZNAŃ",
        "61818": "POZNAŃ",
        "61819": "POZNAŃ",
        "61820": "POZNAŃ",
        "61821": "POZNAŃ",
        "61823": "POZNAŃ",
        "61825": "POZNAŃ",
        "61826": "POZNAŃ",
        "61827": "POZNAŃ",
        "61828": "POZNAŃ",
        "61829": "POZNAŃ",
        "61831": "POZNAŃ",
        "61832": "POZNAŃ",
        "61833": "POZNAŃ",
        "61834": "POZNAŃ",
        "61835": "POZNAŃ",
        "61836": "POZNAŃ",
        "61837": "POZNAŃ",
        "61838": "POZNAŃ",
        "61840": "POZNAŃ",
        "61841": "POZNAŃ",
        "61842": "POZNAŃ",
        "61843": "POZNAŃ",
        "61844": "POZNAŃ",
        "61845": "POZNAŃ",
        "61846": "POZNAŃ",
        "61847": "POZNAŃ",
        "61848": "POZNAŃ",
        "61849": "POZNAŃ",
        "61850": "POZNAŃ",
        "61851": "POZNAŃ",
        "61852": "POZNAŃ",
        "61853": "POZNAŃ",
        "61854": "POZNAŃ",
        "61856": "POZNAŃ",
        "61857": "POZNAŃ",
        "61858": "POZNAŃ",
        "61859": "POZNAŃ",
        "61860": "POZNAŃ",
        "61861": "POZNAŃ",
        "61862": "POZNAŃ",
        "61863": "POZNAŃ",
        "61866": "POZNAŃ",
        "61867": "POZNAŃ",
        "61868": "POZNAŃ",
        "61869": "POZNAŃ",
        "61870": "POZNAŃ",
        "61871": "POZNAŃ",
        "61872": "POZNAŃ",
        "61873": "POZNAŃ",
        "61874": "POZNAŃ",
        "61875": "POZNAŃ",
        "61876": "POZNAŃ",
        "61877": "POZNAŃ",
        "61878": "POZNAŃ",
        "61879": "POZNAŃ",
        "61880": "POZNAŃ",
        "61881": "POZNAŃ",
        "61882": "POZNAŃ",
        "61883": "POZNAŃ",
        "61884": "POZNAŃ",
        "61885": "POZNAŃ",
        "61886": "POZNAŃ",
        "61887": "POZNAŃ",
        "61888": "POZNAŃ",
        "61889": "POZNAŃ",
        "61890": "POZNAŃ",
        "61891": "POZNAŃ",
        "61892": "POZNAŃ",
        "61893": "POZNAŃ",
        "61894": "POZNAŃ",
        "61895": "POZNAŃ",
        "61896": "POZNAŃ",
        "61897": "POZNAŃ",
        "62001": "POZNAŃ",
        "62002": "POZNAŃ",
        "62003": "POZNAŃ",
        "62004": "POZNAŃ",
        "62005": "POZNAŃ",
        "62006": "POZNAŃ",
        "62007": "POZNAŃ",
        "62008": "POZNAŃ",
        "62010": "POZNAŃ",
        "62017": "SWARZĘDZ",
        "62018": "SWARZĘDZ",
        "62019": "SWARZĘDZ",
        "62020": "SWARZĘDZ",
        "62021": "POZNAŃ",
        "62022": "POZNAŃ",
        "62023": "POZNAŃ",
        "62024": "POZNAŃ",
        "62025": "POZNAŃ",
        "62027": "POZNAŃ",
        "62028": "POZNAŃ",
        "62029": "POZNAŃ",
        "62030": "LUBOŃ",
        "62031": "POZNAŃ",
        "62035": "POZNAŃ",
        "62040": "PUSZCZYKOWO",
        "62045": "PNIEWY",
        "62050": "POZNAŃ",
        "62051": "POZNAŃ",
        "62052": "POZNAŃ",
        "62053": "POZNAŃ",
        "62056": "POZNAŃ",
        "62060": "STĘSZEW",
        "62061": "POZNAŃ",
        "62062": "POZNAŃ",
        "62063": "POZNAŃ",
        "62064": "POZNAŃ",
        "62065": "GRODZISK WIELKOPOLSKI",
        "62066": "GRODZISK WIELKOPOLSKI",
        "62067": "RAKONIEWICE",
        "62068": "GRODZISK WIELKOPOLSKI",
        "62069": "POZNAŃ",
        "62070": "POZNAŃ",
        "62071": "GRODZISK WIELKOPOLSKI",
        "62072": "POZNAŃ",
        "62073": "GRODZISK WIELKOPOLSKI",
        "62079": "POZNAŃ",
        "62080": "POZNAŃ",
        "62081": "PRZEŹMIEROWO",
        "62085": "WĄGROWIEC",
        "62090": "POZNAŃ",
        "62092": "SZAMOTUŁY",
        "62093": "WĄGROWIEC",
        "62095": "MUROWANA GOŚLINA",
        "62096": "MUROWANA GOŚLINA",
        "62097": "POZNAŃ",
        "62100": "WĄGROWIEC",
        "62104": "WĄGROWIEC",
        "62105": "WĄGROWIEC",
        "62106": "WĄGROWIEC",
        "62107": "WĄGROWIEC",
        "62110": "WĄGROWIEC",
        "62112": "WĄGROWIEC",
        "62113": "WĄGROWIEC",
        "62120": "WĄGROWIEC",
        "62121": "WĄGROWIEC",
        "62130": "WĄGROWIEC",
        "62131": "WĄGROWIEC",
        "62132": "WĄGROWIEC",
        "62200": "GNIEZNO",
        "62204": "GNIEZNO",
        "62206": "GNIEZNO",
        "62210": "GNIEZNO",
        "62211": "GNIEZNO",
        "62212": "GNIEZNO",
        "62213": "GNIEZNO",
        "62214": "GNIEZNO",
        "62215": "GNIEZNO",
        "62220": "GNIEZNO",
        "62230": "GNIEZNO",
        "62235": "GNIEZNO",
        "62237": "GNIEZNO",
        "62238": "GNIEZNO",
        "62240": "GNIEZNO",
        "62241": "GNIEZNO",
        "62242": "GNIEZNO",
        "62250": "GNIEZNO",
        "62260": "GNIEZNO",
        "62261": "GNIEZNO",
        "62262": "GNIEZNO",
        "62265": "GNIEZNO",
        "62270": "GNIEZNO",
        "62271": "GNIEZNO",
        "62272": "GNIEZNO",
        "62280": "GNIEZNO",
        "62285": "WĄGROWIEC",
        "62290": "WĄGROWIEC",
        "62291": "WĄGROWIEC",
        "62292": "WĄGROWIEC",
        "62300": "WRZEŚNIA",
        "62301": "WRZEŚNIA",
        "62302": "WRZEŚNIA",
        "62303": "WRZEŚNIA",
        "62304": "WRZEŚNIA",
        "62305": "WRZEŚNIA",
        "62306": "WRZEŚNIA",
        "62307": "WRZEŚNIA",
        "62308": "WRZEŚNIA",
        "62309": "WRZEŚNIA",
        "62310": "WRZEŚNIA",
        "62311": "WRZEŚNIA",
        "62312": "WRZEŚNIA",
        "62313": "WRZEŚNIA",
        "62314": "WRZEŚNIA",
        "62320": "WRZEŚNIA",
        "62321": "WRZEŚNIA",
        "62322": "WRZEŚNIA",
        "62323": "WRZEŚNIA",
        "62330": "WRZEŚNIA",
        "62400": "SŁUPCA",
        "62401": "SŁUPCA",
        "62402": "SŁUPCA",
        "62404": "WRZEŚNIA",
        "62405": "WRZEŚNIA",
        "62406": "SŁUPCA",
        "62410": "SŁUPCA",
        "62420": "SŁUPCA",
        "62430": "SŁUPCA",
        "62436": "SŁUPCA",
        "62500": "KONIN",
        "62501": "KONIN",
        "62502": "KONIN",
        "62503": "KONIN",
        "62504": "KONIN",
        "62505": "KONIN",
        "62506": "KONIN",
        "62507": "KONIN",
        "62508": "KONIN",
        "62509": "KONIN",
        "62510": "KONIN",
        "62511": "KONIN",
        "62513": "KONIN",
        "62530": "KONIN",
        "62540": "KONIN",
        "62541": "KONIN",
        "62543": "KONIN",
        "62550": "KONIN",
        "62560": "KONIN",
        "62561": "KONIN",
        "62563": "KONIN",
        "62570": "KONIN",
        "62571": "KONIN",
        "62572": "KONIN",
        "62573": "KONIN",
        "62574": "KONIN",
        "62580": "KONIN",
        "62585": "KONIN",
        "62586": "KONIN",
        "62590": "KONIN",
        "62600": "KOŁO",
        "62601": "KOŁO",
        "62602": "KOŁO",
        "62604": "KOŁO",
        "62610": "KONIN",
        "62613": "KOŁO",
        "62618": "KONIN",
        "62619": "KONIN",
        "62620": "KOŁO",
        "62635": "KOŁO",
        "62640": "KOŁO",
        "62641": "KOŁO",
        "62650": "KŁODAWA",
        "62652": "KOŁO",
        "62660": "KOŁO",
        "62700": "TUREK",
        "62701": "TUREK",
        "62702": "TUREK",
        "62704": "TUREK",
        "62709": "TUREK",
        "62710": "TUREK",
        "62720": "TUREK",
        "62730": "TUREK",
        "62731": "TUREK",
        "62732": "TUREK",
        "62740": "TUREK",
        "62800": "KALISZ",
        "62801": "KALISZ",
        "62802": "KALISZ",
        "62803": "KALISZ",
        "62804": "KALISZ",
        "62805": "KALISZ",
        "62806": "KALISZ",
        "62809": "KALISZ",
        "62810": "KALISZ",
        "62811": "PLESZEW",
        "62812": "KALISZ",
        "62814": "KALISZ",
        "62817": "KALISZ",
        "62819": "KALISZ",
        "62820": "KALISZ",
        "62821": "KALISZ",
        "62830": "KALISZ",
        "62831": "KALISZ",
        "62834": "KALISZ",
        "62840": "KALISZ",
        "62850": "KALISZ",
        "62860": "KALISZ",
        "62862": "KALISZ",
        "62865": "KALISZ",
        "62872": "KALISZ",
        "62874": "KALISZ",
        "63000": "ŚRODA WIELKOPOLSKA",
        "63001": "ŚRODA WIELKOPOLSKA",
        "63004": "POZNAŃ",
        "63005": "POZNAŃ",
        "63006": "POZNAŃ",
        "63011": "ŚRODA WIELKOPOLSKA",
        "63012": "ŚRODA WIELKOPOLSKA",
        "63013": "ŚRODA WIELKOPOLSKA",
        "63014": "ŚRODA WIELKOPOLSKA",
        "63020": "ŚRODA WIELKOPOLSKA",
        "63021": "ŚRODA WIELKOPOLSKA",
        "63022": "ŚRODA WIELKOPOLSKA",
        "63023": "ŚRODA WIELKOPOLSKA",
        "63024": "ŚRODA WIELKOPOLSKA",
        "63025": "ŚRODA WIELKOPOLSKA",
        "63040": "ŚRODA WIELKOPOLSKA",
        "63041": "ŚRODA WIELKOPOLSKA",
        "63100": "ŚREM",
        "63101": "ŚREM",
        "63102": "ŚREM",
        "63112": "ŚREM",
        "63130": "ŚREM",
        "63140": "ŚREM",
        "63200": "JAROCIN",
        "63201": "JAROCIN",
        "63202": "JAROCIN",
        "63210": "JAROCIN",
        "63220": "JAROCIN",
        "63230": "JAROCIN",
        "63233": "JAROCIN",
        "63300": "PLESZEW",
        "63301": "PLESZEW",
        "63304": "PLESZEW",
        "63308": "PLESZEW",
        "63313": "PLESZEW",
        "63322": "PLESZEW",
        "63330": "PLESZEW",
        "63400": "OSTRÓW WIELKOPOLSKI",
        "63401": "OSTRÓW WIELKOPOLSKI",
        "63402": "OSTRÓW WIELKOPOLSKI",
        "63403": "OSTRÓW WIELKOPOLSKI",
        "63404": "OSTRÓW WIELKOPOLSKI",
        "63405": "OSTRÓW WIELKOPOLSKI",
        "63409": "OSTRÓW WIELKOPOLSKI",
        "63410": "OSTRÓW WIELKOPOLSKI",
        "63417": "OSTRÓW WIELKOPOLSKI",
        "63421": "OSTRÓW WIELKOPOLSKI",
        "63430": "OSTRÓW WIELKOPOLSKI",
        "63435": "OSTRÓW WIELKOPOLSKI",
        "63440": "OSTRÓW WIELKOPOLSKI",
        "63450": "OSTRÓW WIELKOPOLSKI",
        "63460": "OSTRÓW WIELKOPOLSKI",
        "63500": "OSTRZESZÓW",
        "63505": "OSTRZESZÓW",
        "63507": "OSTRZESZÓW",
        "63508": "OSTRZESZÓW",
        "63510": "OSTRZESZÓW",
        "63520": "OSTRZESZÓW",
        "63522": "OSTRZESZÓW",
        "63524": "OSTRZESZÓW",
        "63600": "KĘPNO",
        "63604": "KĘPNO",
        "63611": "OPATÓW",
        "63620": "KĘPNO",
        "63630": "KĘPNO",
        "63640": "BRALIN",
        "63642": "KĘPNO",
        "63645": "KĘPNO",
        "63648": "OPATÓW",
        "63700": "KROTOSZYN",
        "63701": "KROTOSZYN",
        "63702": "KROTOSZYN",
        "63703": "KROTOSZYN",
        "63704": "KROTOSZYN",
        "63707": "KROTOSZYN",
        "63708": "KROTOSZYN",
        "63714": "KROTOSZYN",
        "63716": "KROTOSZYN",
        "63720": "KROTOSZYN",
        "63721": "KROTOSZYN",
        "63740": "KROTOSZYN",
        "63745": "KROTOSZYN",
        "63750": "KROTOSZYN",
        "63760": "KROTOSZYN",
        "63800": "GOSTYŃ",
        "63805": "GOSTYNIN",
        "63810": "GOSTYŃ",
        "63814": "GOSTYŃ",
        "63815": "GOSTYŃ",
        "63816": "GOSTYŃ",
        "63820": "GOSTYŃ",
        "63830": "GOSTYŃ",
        "63831": "GOSTYNIN",
        "63840": "GOSTYŃ",
        "63842": "GOSTYŃ",
        "63860": "GOSTYŃ",
        "63900": "RAWICZ",
        "63901": "RAWICZ",
        "63904": "RAWICZ",
        "63910": "RAWICZ",
        "63911": "RAWICZ",
        "63913": "RAWICZ",
        "63920": "RAWICZ",
        "63921": "RAWICZ",
        "63930": "RAWICZ",
        "63940": "RAWICZ",
        "64000": "KOŚCIAN",
        "64001": "KOŚCIAN",
        "64004": "KOŚCIAN",
        "64005": "KOŚCIAN",
        "64006": "KOŚCIAN",
        "64009": "KOŚCIAN",
        "64010": "KOŚCIAN",
        "64020": "KOŚCIAN",
        "64030": "KOŚCIAN",
        "64032": "GRODZISK WIELKOPOLSKI",
        "64035": "KOŚCIAN",
        "64040": "KOŚCIAN",
        "64050": "GRODZISK WIELKOPOLSKI",
        "64060": "GRODZISK WIELKOPOLSKI",
        "64061": "GRODZISK WIELKOPOLSKI",
        "64100": "LESZNO",
        "64101": "LESZNO",
        "64102": "LESZNO",
        "64103": "LESZNO",
        "64104": "LESZNO",
        "64105": "LESZNO",
        "64106": "LESZNO",
        "64110": "LESZNO",
        "64111": "LESZNO",
        "64113": "LESZNO",
        "64115": "LESZNO",
        "64117": "LESZNO",
        "64120": "LESZNO",
        "64122": "LESZNO",
        "64125": "GOSTYŃ",
        "64130": "LESZNO",
        "64140": "LESZNO",
        "64141": "LESZNO",
        "64150": "LESZNO",
        "64200": "WOLSZTYN",
        "64211": "WOLSZTYN",
        "64212": "WOLSZTYN",
        "64214": "WOLSZTYN",
        "64223": "WOLSZTYN",
        "64224": "WOLSZTYN",
        "64225": "WOLSZTYN",
        "64231": "WOLSZTYN",
        "64232": "WOLSZTYN",
        "64234": "WOLSZTYN",
        "64235": "WOLSZTYN",
        "64300": "NOWY TOMYŚL",
        "64304": "NOWY TOMYŚL",
        "64305": "NOWY TOMYŚL",
        "64306": "NOWY TOMYŚL",
        "64307": "GRODZISK WIELKOPOLSKI",
        "64308": "GRODZISK WIELKOPOLSKI",
        "64310": "NOWY TOMYŚL",
        "64311": "NOWY TOMYŚL",
        "64312": "NOWY TOMYŚL",
        "64313": "NOWY TOMYŚL",
        "64314": "NOWY TOMYŚL",
        "64315": "NOWY TOMYŚL",
        "64316": "NOWY TOMYŚL",
        "64317": "NOWY TOMYŚL",
        "64320": "POZNAŃ",
        "64330": "OPALENICA",
        "64331": "NOWY TOMYŚL",
        "64332": "NOWY TOMYŚL",
        "64333": "NOWY TOMYŚL",
        "64334": "NOWY TOMYŚL",
        "64335": "NOWY TOMYŚL",
        "64336": "NOWY TOMYŚL",
        "64360": "ZBĄSZYŃ",
        "64361": "NOWY TOMYŚL",
        "64400": "MIĘDZYCHÓD",
        "64410": "MIĘDZYCHÓD",
        "64412": "MIĘDZYCHÓD",
        "64420": "MIĘDZYCHÓD",
        "64421": "MIĘDZYCHÓD",
        "64423": "MIĘDZYCHÓD",
        "64426": "MIĘDZYCHÓD",
        "64427": "MIĘDZYCHÓD",
        "64500": "SZAMOTUŁY",
        "64501": "SZAMOTUŁY",
        "64510": "SZAMOTUŁY",
        "64512": "SZAMOTUŁY",
        "64513": "SZAMOTUŁY",
        "64514": "SZAMOTUŁY",
        "64520": "SZAMOTUŁY",
        "64530": "SZAMOTUŁY",
        "64531": "SZAMOTUŁY",
        "64541": "SZAMOTUŁY",
        "64542": "SZAMOTUŁY",
        "64550": "SZAMOTUŁY",
        "64551": "SZAMOTUŁY",
        "64552": "SZAMOTUŁY",
        "64553": "SZAMOTUŁY",
        "64554": "SZAMOTUŁY",
        "64560": "SZAMOTUŁY",
        "64561": "SZAMOTUŁY",
        "64600": "OBORNIKI",
        "64601": "OBORNIKI",
        "64603": "OBORNIKI",
        "64604": "OBORNIKI",
        "64605": "OBORNIKI",
        "64606": "OBORNIKI",
        "64607": "OBORNIKI",
        "64608": "OBORNIKI",
        "64610": "ROGOŹNO",
        "64611": "OBORNIKI",
        "64612": "OBORNIKI",
        "64630": "OBORNIKI (NET)",
        "64700": "CZARNKÓW",
        "64704": "TRZCIANKA",
        "64705": "CHODZIEŻ",
        "64706": "PIŁA",
        "64707": "TRZCIANKA",
        "64708": "TRZCIANKA",
        "64710": "CZARNKÓW",
        "64711": "TRZCIANKA",
        "64712": "TRZCIANKA",
        "64713": "TRZCIANKA",
        "64720": "CZARNKÓW",
        "64721": "TRZCIANKA",
        "64723": "TRZCIANKA",
        "64729": "TRZCIANKA",
        "64730": "CZARNKÓW",
        "64731": "TRZCIANKA",
        "64733": "CZARNKÓW",
        "64734": "CZARNKÓW",
        "64735": "TRZCIANKA",
        "64761": "CZARNKÓW",
        "64763": "TRZCIANKA",
        "64800": "CHODZIEŻ",
        "64810": "PIŁA",
        "64811": "PIŁA",
        "64812": "PIŁA",
        "64813": "CHODZIEŻ",
        "64814": "CHODZIEŻ",
        "64815": "CHODZIEŻ",
        "64820": "CHODZIEŻ",
        "64830": "CHODZIEŻ",
        "64831": "CHODZIEŻ",
        "64832": "CHODZIEŻ",
        "64834": "CHODZIEŻ",
        "64840": "CHODZIEŻ",
        "64841": "CHODZIEŻ",
        "64843": "PIŁA",
        "64850": "PIŁA",
        "64900": "PIŁA",
        "64903": "TRZCIANKA",
        "64904": "TRZCIANKA",
        "64905": "TRZCIANKA",
        "64910": "TRZCIANKA",
        "64915": "ZŁOTÓW",
        "64917": "ZŁOTÓW",
        "64918": "ZŁOTÓW",
        "64919": "ZŁOTÓW",
        "64920": "PIŁA",
        "64930": "PIŁA",
        "64931": "PIŁA",
        "64932": "PIŁA",
        "64934": "PIŁA",
        "64935": "PIŁA",
        "64962": "ZŁOTÓW",
        "64965": "ZŁOTÓW",
        "64970": "PIŁA",
        "64980": "TRZCIANKA",
        "65001": "ZIELONA GÓRA",
        "65002": "ZIELONA GÓRA",
        "65003": "ZIELONA GÓRA",
        "65004": "ZIELONA GÓRA",
        "65007": "ZIELONA GÓRA",
        "65010": "ZIELONA GÓRA",
        "65012": "ZIELONA GÓRA",
        "65014": "ZIELONA GÓRA",
        "65015": "ZIELONA GÓRA",
        "65017": "ZIELONA GÓRA",
        "65018": "ZIELONA GÓRA",
        "65019": "ZIELONA GÓRA",
        "65020": "ZIELONA GÓRA",
        "65021": "ZIELONA GÓRA",
        "65022": "ZIELONA GÓRA",
        "65023": "ZIELONA GÓRA",
        "65025": "ZIELONA GÓRA",
        "65027": "ZIELONA GÓRA",
        "65028": "ZIELONA GÓRA",
        "65029": "ZIELONA GÓRA",
        "65031": "ZIELONA GÓRA",
        "65032": "ZIELONA GÓRA",
        "65033": "ZIELONA GÓRA",
        "65034": "ZIELONA GÓRA",
        "65035": "ZIELONA GÓRA",
        "65036": "ZIELONA GÓRA",
        "65037": "ZIELONA GÓRA",
        "65038": "ZIELONA GÓRA",
        "65039": "ZIELONA GÓRA",
        "65040": "ZIELONA GÓRA",
        "65041": "ZIELONA GÓRA",
        "65042": "ZIELONA GÓRA",
        "65043": "ZIELONA GÓRA",
        "65044": "ZIELONA GÓRA",
        "65045": "ZIELONA GÓRA",
        "65046": "ZIELONA GÓRA",
        "65047": "ZIELONA GÓRA",
        "65048": "ZIELONA GÓRA",
        "65049": "ZIELONA GÓRA",
        "65050": "ZIELONA GÓRA",
        "65052": "ZIELONA GÓRA",
        "65053": "ZIELONA GÓRA",
        "65054": "ZIELONA GÓRA",
        "65055": "ZIELONA GÓRA",
        "65056": "ZIELONA GÓRA",
        "65057": "ZIELONA GÓRA",
        "65058": "ZIELONA GÓRA",
        "65059": "ZIELONA GÓRA",
        "65060": "ZIELONA GÓRA",
        "65061": "ZIELONA GÓRA",
        "65063": "ZIELONA GÓRA",
        "65064": "ZIELONA GÓRA",
        "65065": "ZIELONA GÓRA",
        "65066": "ZIELONA GÓRA",
        "65067": "ZIELONA GÓRA",
        "65068": "ZIELONA GÓRA",
        "65069": "ZIELONA GÓRA",
        "65071": "ZIELONA GÓRA",
        "65072": "ZIELONA GÓRA",
        "65073": "ZIELONA GÓRA",
        "65074": "ZIELONA GÓRA",
        "65075": "ZIELONA GÓRA",
        "65076": "ZIELONA GÓRA",
        "65077": "ZIELONA GÓRA",
        "65078": "ZIELONA GÓRA",
        "65081": "ZIELONA GÓRA",
        "65082": "ZIELONA GÓRA",
        "65083": "ZIELONA GÓRA",
        "65084": "ZIELONA GÓRA",
        "65085": "ZIELONA GÓRA",
        "65086": "ZIELONA GÓRA",
        "65087": "ZIELONA GÓRA",
        "65088": "ZIELONA GÓRA",
        "65089": "ZIELONA GÓRA",
        "65090": "ZIELONA GÓRA",
        "65093": "ZIELONA GÓRA",
        "65094": "ZIELONA GÓRA",
        "65095": "ZIELONA GÓRA",
        "65096": "ZIELONA GÓRA",
        "65097": "ZIELONA GÓRA",
        "65101": "ZIELONA GÓRA",
        "65104": "ZIELONA GÓRA",
        "65106": "ZIELONA GÓRA",
        "65107": "ZIELONA GÓRA",
        "65109": "ZIELONA GÓRA",
        "65110": "ZIELONA GÓRA",
        "65112": "ZIELONA GÓRA",
        "65114": "ZIELONA GÓRA",
        "65115": "ZIELONA GÓRA",
        "65119": "ZIELONA GÓRA",
        "65120": "ZIELONA GÓRA",
        "65121": "ZIELONA GÓRA",
        "65122": "ZIELONA GÓRA",
        "65123": "ZIELONA GÓRA",
        "65124": "ZIELONA GÓRA",
        "65125": "ZIELONA GÓRA",
        "65126": "ZIELONA GÓRA",
        "65127": "ZIELONA GÓRA",
        "65128": "ZIELONA GÓRA",
        "65129": "ZIELONA GÓRA",
        "65130": "ZIELONA GÓRA",
        "65131": "ZIELONA GÓRA",
        "65132": "ZIELONA GÓRA",
        "65133": "ZIELONA GÓRA",
        "65135": "ZIELONA GÓRA",
        "65137": "ZIELONA GÓRA",
        "65138": "ZIELONA GÓRA",
        "65139": "ZIELONA GÓRA",
        "65140": "ZIELONA GÓRA",
        "65142": "ZIELONA GÓRA",
        "65147": "ZIELONA GÓRA",
        "65152": "ZIELONA GÓRA",
        "65153": "ZIELONA GÓRA",
        "65154": "ZIELONA GÓRA",
        "65155": "ZIELONA GÓRA",
        "65158": "ZIELONA GÓRA",
        "65160": "ZIELONA GÓRA",
        "65167": "ZIELONA GÓRA",
        "65169": "ZIELONA GÓRA",
        "65170": "ZIELONA GÓRA",
        "65175": "ZIELONA GÓRA",
        "65176": "ZIELONA GÓRA",
        "65177": "ZIELONA GÓRA",
        "65178": "ZIELONA GÓRA",
        "65179": "ZIELONA GÓRA",
        "65180": "ZIELONA GÓRA",
        "65181": "ZIELONA GÓRA",
        "65182": "ZIELONA GÓRA",
        "65183": "ZIELONA GÓRA",
        "65184": "ZIELONA GÓRA",
        "65186": "ZIELONA GÓRA",
        "65187": "ZIELONA GÓRA",
        "65190": "ZIELONA GÓRA",
        "65191": "ZIELONA GÓRA",
        "65201": "ZIELONA GÓRA",
        "65204": "ZIELONA GÓRA",
        "65209": "ZIELONA GÓRA",
        "65211": "ZIELONA GÓRA",
        "65212": "ZIELONA GÓRA",
        "65213": "ZIELONA GÓRA",
        "65215": "ZIELONA GÓRA",
        "65218": "ZIELONA GÓRA",
        "65219": "ZIELONA GÓRA",
        "65220": "ZIELONA GÓRA",
        "65221": "ZIELONA GÓRA",
        "65222": "ZIELONA GÓRA",
        "65223": "ZIELONA GÓRA",
        "65224": "ZIELONA GÓRA",
        "65225": "ZIELONA GÓRA",
        "65229": "ZIELONA GÓRA",
        "65231": "ZIELONA GÓRA",
        "65238": "ZIELONA GÓRA",
        "65240": "ZIELONA GÓRA",
        "65245": "ZIELONA GÓRA",
        "65246": "ZIELONA GÓRA",
        "65247": "ZIELONA GÓRA",
        "65249": "ZIELONA GÓRA",
        "65253": "ZIELONA GÓRA",
        "65254": "ZIELONA GÓRA",
        "65255": "ZIELONA GÓRA",
        "65256": "ZIELONA GÓRA",
        "65261": "ZIELONA GÓRA",
        "65264": "ZIELONA GÓRA",
        "65265": "ZIELONA GÓRA",
        "65266": "ZIELONA GÓRA",
        "65267": "ZIELONA GÓRA",
        "65268": "ZIELONA GÓRA",
        "65269": "ZIELONA GÓRA",
        "65270": "ZIELONA GÓRA",
        "65272": "ZIELONA GÓRA",
        "65273": "ZIELONA GÓRA",
        "65301": "ZIELONA GÓRA",
        "65303": "ZIELONA GÓRA",
        "65304": "ZIELONA GÓRA",
        "65305": "ZIELONA GÓRA",
        "65306": "ZIELONA GÓRA",
        "65307": "ZIELONA GÓRA",
        "65308": "ZIELONA GÓRA",
        "65309": "ZIELONA GÓRA",
        "65310": "ZIELONA GÓRA",
        "65311": "ZIELONA GÓRA",
        "65312": "ZIELONA GÓRA",
        "65315": "ZIELONA GÓRA",
        "65318": "ZIELONA GÓRA",
        "65322": "ZIELONA GÓRA",
        "65323": "ZIELONA GÓRA",
        "65324": "ZIELONA GÓRA",
        "65325": "ZIELONA GÓRA",
        "65326": "ZIELONA GÓRA",
        "65327": "ZIELONA GÓRA",
        "65328": "ZIELONA GÓRA",
        "65329": "ZIELONA GÓRA",
        "65331": "ZIELONA GÓRA",
        "65332": "ZIELONA GÓRA",
        "65334": "ZIELONA GÓRA",
        "65335": "ZIELONA GÓRA",
        "65336": "ZIELONA GÓRA",
        "65337": "ZIELONA GÓRA",
        "65338": "ZIELONA GÓRA",
        "65339": "ZIELONA GÓRA",
        "65340": "ZIELONA GÓRA",
        "65341": "ZIELONA GÓRA",
        "65342": "ZIELONA GÓRA",
        "65343": "ZIELONA GÓRA",
        "65344": "ZIELONA GÓRA",
        "65345": "ZIELONA GÓRA",
        "65352": "ZIELONA GÓRA",
        "65358": "ZIELONA GÓRA",
        "65364": "ZIELONA GÓRA",
        "65366": "ZIELONA GÓRA",
        "65368": "ZIELONA GÓRA",
        "65371": "ZIELONA GÓRA",
        "65372": "ZIELONA GÓRA",
        "65373": "ZIELONA GÓRA",
        "65374": "ZIELONA GÓRA",
        "65375": "ZIELONA GÓRA",
        "65376": "ZIELONA GÓRA",
        "65377": "ZIELONA GÓRA",
        "65378": "ZIELONA GÓRA",
        "65380": "ZIELONA GÓRA",
        "65381": "ZIELONA GÓRA",
        "65382": "ZIELONA GÓRA",
        "65383": "ZIELONA GÓRA",
        "65384": "ZIELONA GÓRA",
        "65385": "ZIELONA GÓRA",
        "65386": "ZIELONA GÓRA",
        "65387": "ZIELONA GÓRA",
        "65388": "ZIELONA GÓRA",
        "65389": "ZIELONA GÓRA",
        "65390": "ZIELONA GÓRA",
        "65391": "ZIELONA GÓRA",
        "65392": "ZIELONA GÓRA",
        "65395": "ZIELONA GÓRA",
        "65401": "ZIELONA GÓRA",
        "65404": "ZIELONA GÓRA",
        "65405": "ZIELONA GÓRA",
        "65406": "ZIELONA GÓRA",
        "65407": "ZIELONA GÓRA",
        "65409": "ZIELONA GÓRA",
        "65410": "ZIELONA GÓRA",
        "65411": "ZIELONA GÓRA",
        "65412": "ZIELONA GÓRA",
        "65413": "ZIELONA GÓRA",
        "65414": "ZIELONA GÓRA",
        "65415": "ZIELONA GÓRA",
        "65416": "ZIELONA GÓRA",
        "65417": "ZIELONA GÓRA",
        "65418": "ZIELONA GÓRA",
        "65419": "ZIELONA GÓRA",
        "65421": "ZIELONA GÓRA",
        "65423": "ZIELONA GÓRA",
        "65424": "ZIELONA GÓRA",
        "65426": "ZIELONA GÓRA",
        "65427": "ZIELONA GÓRA",
        "65431": "ZIELONA GÓRA",
        "65432": "ZIELONA GÓRA",
        "65433": "ZIELONA GÓRA",
        "65434": "ZIELONA GÓRA",
        "65436": "ZIELONA GÓRA",
        "65437": "ZIELONA GÓRA",
        "65441": "ZIELONA GÓRA",
        "65442": "ZIELONA GÓRA",
        "65443": "ZIELONA GÓRA",
        "65448": "ZIELONA GÓRA",
        "65449": "ZIELONA GÓRA",
        "65450": "ZIELONA GÓRA",
        "65452": "ZIELONA GÓRA",
        "65453": "ZIELONA GÓRA",
        "65454": "ZIELONA GÓRA",
        "65461": "ZIELONA GÓRA",
        "65462": "ZIELONA GÓRA",
        "65463": "ZIELONA GÓRA",
        "65465": "ZIELONA GÓRA",
        "65470": "ZIELONA GÓRA",
        "65472": "ZIELONA GÓRA",
        "65501": "ZIELONA GÓRA",
        "65502": "ZIELONA GÓRA",
        "65503": "ZIELONA GÓRA",
        "65505": "ZIELONA GÓRA",
        "65506": "ZIELONA GÓRA",
        "65507": "ZIELONA GÓRA",
        "65508": "ZIELONA GÓRA",
        "65509": "ZIELONA GÓRA",
        "65510": "ZIELONA GÓRA",
        "65511": "ZIELONA GÓRA",
        "65512": "ZIELONA GÓRA",
        "65514": "ZIELONA GÓRA",
        "65515": "ZIELONA GÓRA",
        "65516": "ZIELONA GÓRA",
        "65517": "ZIELONA GÓRA",
        "65518": "ZIELONA GÓRA",
        "65519": "ZIELONA GÓRA",
        "65520": "ZIELONA GÓRA",
        "65525": "ZIELONA GÓRA",
        "65528": "ZIELONA GÓRA",
        "65530": "ZIELONA GÓRA",
        "65533": "ZIELONA GÓRA",
        "65534": "ZIELONA GÓRA",
        "65536": "ZIELONA GÓRA",
        "65540": "ZIELONA GÓRA",
        "65542": "ZIELONA GÓRA",
        "65544": "ZIELONA GÓRA",
        "65546": "ZIELONA GÓRA",
        "65547": "ZIELONA GÓRA",
        "65548": "ZIELONA GÓRA",
        "65552": "ZIELONA GÓRA",
        "65556": "ZIELONA GÓRA",
        "65557": "ZIELONA GÓRA",
        "65559": "ZIELONA GÓRA",
        "65561": "ZIELONA GÓRA",
        "65562": "ZIELONA GÓRA",
        "65563": "ZIELONA GÓRA",
        "65601": "ZIELONA GÓRA",
        "65602": "ZIELONA GÓRA",
        "65609": "ZIELONA GÓRA",
        "65610": "ZIELONA GÓRA",
        "65613": "ZIELONA GÓRA",
        "65622": "ZIELONA GÓRA",
        "65625": "ZIELONA GÓRA",
        "65634": "ZIELONA GÓRA",
        "65636": "ZIELONA GÓRA",
        "65638": "ZIELONA GÓRA",
        "65649": "ZIELONA GÓRA",
        "65654": "ZIELONA GÓRA",
        "65664": "ZIELONA GÓRA",
        "65705": "ZIELONA GÓRA",
        "65707": "ZIELONA GÓRA",
        "65713": "ZIELONA GÓRA",
        "65714": "ZIELONA GÓRA",
        "65729": "ZIELONA GÓRA",
        "65730": "ZIELONA GÓRA",
        "65733": "ZIELONA GÓRA",
        "65734": "ZIELONA GÓRA",
        "65735": "ZIELONA GÓRA",
        "65736": "ZIELONA GÓRA",
        "65739": "ZIELONA GÓRA",
        "65740": "ZIELONA GÓRA",
        "65742": "ZIELONA GÓRA",
        "65744": "ZIELONA GÓRA",
        "65747": "ZIELONA GÓRA",
        "65751": "ZIELONA GÓRA",
        "65752": "ZIELONA GÓRA",
        "65755": "ZIELONA GÓRA",
        "65760": "ZIELONA GÓRA",
        "65761": "ZIELONA GÓRA",
        "65762": "ZIELONA GÓRA",
        "65763": "ZIELONA GÓRA",
        "65764": "ZIELONA GÓRA",
        "65766": "ZIELONA GÓRA",
        "65767": "ZIELONA GÓRA",
        "65770": "ZIELONA GÓRA",
        "65775": "ZIELONA GÓRA",
        "65778": "ZIELONA GÓRA",
        "65779": "ZIELONA GÓRA",
        "65780": "ZIELONA GÓRA",
        "65783": "ZIELONA GÓRA",
        "65784": "ZIELONA GÓRA",
        "65785": "ZIELONA GÓRA",
        "65786": "ZIELONA GÓRA",
        "65788": "ZIELONA GÓRA",
        "65790": "ZIELONA GÓRA",
        "65792": "ZIELONA GÓRA",
        "65794": "ZIELONA GÓRA",
        "65803": "ZIELONA GÓRA",
        "65805": "ZIELONA GÓRA",
        "65807": "ZIELONA GÓRA",
        "65823": "ZIELONA GÓRA",
        "65831": "ZIELONA GÓRA",
        "65849": "ZIELONA GÓRA",
        "65850": "ZIELONA GÓRA",
        "65900": "ZIELONA GÓRA",
        "65901": "ZIELONA GÓRA",
        "65903": "ZIELONA GÓRA",
        "65904": "ZIELONA GÓRA",
        "65905": "ZIELONA GÓRA",
        "65906": "ZIELONA GÓRA",
        "65908": "ZIELONA GÓRA",
        "65909": "ZIELONA GÓRA",
        "65912": "ZIELONA GÓRA",
        "65913": "ZIELONA GÓRA",
        "65936": "ZIELONA GÓRA",
        "65939": "ZIELONA GÓRA",
        "65941": "ZIELONA GÓRA",
        "65943": "ZIELONA GÓRA",
        "65945": "ZIELONA GÓRA",
        "65954": "ZIELONA GÓRA",
        "65960": "ZIELONA GÓRA",
        "65980": "ZIELONA GÓRA",
        "66001": "ZIELONA GÓRA",
        "66002": "ZIELONA GÓRA",
        "66003": "ZIELONA GÓRA",
        "66004": "ZIELONA GÓRA",
        "66006": "ZIELONA GÓRA",
        "66007": "ZIELONA GÓRA",
        "66008": "ZIELONA GÓRA",
        "66010": "ZIELONA GÓRA",
        "66014": "ZIELONA GÓRA",
        "66015": "ZIELONA GÓRA",
        "66016": "ZIELONA GÓRA",
        "66017": "ZIELONA GÓRA",
        "66019": "SŁUBICE",
        "66100": "SULECHÓW",
        "66101": "SULECHÓW",
        "66105": "ZIELONA GÓRA",
        "66110": "ZIELONA GÓRA",
        "66111": "ZIELONA GÓRA",
        "66112": "ZIELONA GÓRA",
        "66120": "ZIELONA GÓRA",
        "66130": "ZIELONA GÓRA",
        "66131": "ZIELONA GÓRA",
        "66132": "ZIELONA GÓRA",
        "66133": "ZIELONA GÓRA",
        "66200": "ŚWIEBODZIN",
        "66203": "ŚWIEBODZIN",
        "66210": "ZBĄSZYNEK",
        "66211": "ŚWIEBODZIN",
        "66213": "ŚWIEBODZIN",
        "66218": "ŚWIEBODZIN",
        "66220": "ŚWIEBODZIN",
        "66225": "ŚWIEBODZIN",
        "66233": "ŚWIEBODZIN",
        "66234": "SULĘCIN",
        "66235": "SULĘCIN",
        "66300": "MIĘDZYRZECZ",
        "66301": "MIĘDZYRZECZ",
        "66302": "MIĘDZYRZECZ",
        "66304": "MIĘDZYRZECZ",
        "66305": "ŁOMŻA",
        "66306": "ŁOMŻA",
        "66307": "MIĘDZYRZECZ",
        "66313": "ŁOMŻA",
        "66320": "MIĘDZYRZECZ",
        "66330": "MIĘDZYRZECZ",
        "66340": "MIĘDZYRZECZ",
        "66341": "ŁOMŻA",
        "66342": "MIĘDZYRZECZ",
        "66343": "ŁOMŻA",
        "66350": "MIĘDZYRZECZ",
        "66400": "GORZÓW WIELKOPOLSKI",
        "66401": "GORZÓW WIELKOPOLSKI",
        "66403": "GORZÓW WIELKOPOLSKI",
        "66404": "GORZÓW WIELKOPOLSKI",
        "66405": "GORZÓW WIELKOPOLSKI",
        "66406": "GORZÓW WIELKOPOLSKI",
        "66407": "GORZÓW WIELKOPOLSKI",
        "66408": "GORZÓW WIELKOPOLSKI",
        "66410": "GORZÓW WIELKOPOLSKI",
        "66412": "GORZÓW WIELKOPOLSKI",
        "66413": "GORZÓW WIELKOPOLSKI",
        "66414": "GORZÓW WIELKOPOLSKI",
        "66415": "GORZÓW WIELKOPOLSKI",
        "66416": "GORZÓW WIELKOPOLSKI",
        "66418": "GORZÓW WIELKOPOLSKI",
        "66425": "GORZÓW WIELKOPOLSKI",
        "66428": "GORZÓW WIELKOPOLSKI",
        "66429": "GORZÓW WIELKOPOLSKI",
        "66431": "GORZÓW WIELKOPOLSKI",
        "66432": "GORZÓW WIELKOPOLSKI",
        "66433": "GORZÓW WIELKOPOLSKI",
        "66434": "SŁUBICE",
        "66435": "SULĘCIN",
        "66436": "SULĘCIN",
        "66437": "SULĘCIN",
        "66439": "SULĘCIN",
        "66440": "SKWIERZYNA",
        "66441": "ŁOMŻA",
        "66443": "ŁOMŻA",
        "66445": "ŁOMŻA",
        "66446": "GORZÓW WIELKOPOLSKI",
        "66447": "GORZÓW WIELKOPOLSKI",
        "66450": "GORZÓW WIELKOPOLSKI",
        "66451": "GORZÓW WIELKOPOLSKI",
        "66460": "GORZÓW WIELKOPOLSKI",
        "66470": "KOSTRZYN NAD ODRĄ",
        "66471": "KOSTRZYN NAD ODRĄ",
        "66472": "KOSTRZYN NAD ODRĄ",
        "66473": "KOSTRZYN NAD ODRĄ",
        "66500": "STRZELCE KRAJEŃSKIE",
        "66505": "STRZELCE KRAJEŃSKIE",
        "66510": "STRZELCE KRAJEŃSKIE",
        "66520": "STRZELCE KRAJEŃSKIE",
        "66522": "STRZELCE KRAJEŃSKIE",
        "66530": "DREZDENKO",
        "66535": "STRZELCE KRAJEŃSKIE",
        "66540": "STRZELCE KRAJEŃSKIE",
        "66542": "STRZELCE KRAJEŃSKIE",
        "66543": "STRZELCE KRAJEŃSKIE",
        "66544": "GORZÓW WIELKOPOLSKI",
        "66551": "STRZELCE KRAJEŃSKIE",
        "66600": "KROSNO ODRZAŃSKIE",
        "66601": "KROSNO ODRZAŃSKIE",
        "66602": "KROSNO ODRZAŃSKIE",
        "66614": "KROSNO ODRZAŃSKIE",
        "66615": "KROSNO",
        "66620": "GUBIN",
        "66626": "KROSNO",
        "66627": "KROSNO ODRZAŃSKIE",
        "66629": "KROSNO",
        "66630": "KROSNO ODRZAŃSKIE",
        "66633": "KROSNO",
        "66635": "GUBIN",
        "67100": "NOWA SÓL",
        "67101": "NOWA SÓL",
        "67106": "NOWA SÓL",
        "67108": "NOWA SÓL",
        "67112": "NOWA SÓL",
        "67115": "NOWA SÓL",
        "67120": "NOWA SÓL",
        "67124": "NOWA SÓL",
        "67125": "NOWA SÓL",
        "67128": "NOWA SÓL",
        "67130": "ŻAGAŃ",
        "67200": "GŁOGÓW",
        "67202": "GŁOGÓW",
        "67203": "GŁOGÓW",
        "67204": "GŁOGÓW",
        "67205": "GŁOGÓW",
        "67206": "GŁOGÓW",
        "67210": "GŁOGÓW",
        "67211": "GŁOGÓW",
        "67221": "GŁOGÓW",
        "67222": "GŁOGÓW",
        "67231": "GŁOGÓW",
        "67232": "GŁOGÓW",
        "67240": "GŁOGÓW",
        "67300": "SZPROTAWA",
        "67312": "ŻAGAŃ",
        "67320": "ŻAGAŃ",
        "67321": "ŻAGAŃ",
        "67400": "WSCHOWA",
        "67407": "SZLICHTYNGOWA",
        "67410": "SŁAWA",
        "67415": "NOWA SÓL",
        "67416": "NOWA SÓL",
        "68100": "ŻAGAŃ",
        "68101": "ŻAGAŃ",
        "68103": "ŻAGAŃ",
        "68111": "ŻAGAŃ",
        "68113": "ŻAGAŃ",
        "68114": "ŻAGAŃ",
        "68120": "ŻAGAŃ",
        "68121": "ŻAGAŃ",
        "68130": "ŻAGAŃ",
        "68131": "ŻAGAŃ",
        "68132": "ŻARY",
        "68200": "ŻARY",
        "68203": "ŻARY",
        "68206": "ŻARY",
        "68208": "ŻARY",
        "68210": "ŻARY",
        "68212": "ŻARY",
        "68213": "ŻARY",
        "68219": "ŻARY",
        "68300": "LUBSKO",
        "68301": "LUBSKO",
        "68320": "ŻARY",
        "68343": "ŻARY",
        "69100": "SŁUBICE",
        "69101": "SŁUBICE",
        "69105": "SŁUBICE",
        "69108": "SŁUBICE",
        "69110": "SŁUBICE",
        "69113": "SŁUBICE",
        "69115": "SULĘCIN",
        "69121": "SŁUBICE",
        "69200": "SULĘCIN",
        "69210": "SULĘCIN",
        "69211": "SULĘCIN",
        "69213": "SULĘCIN",
        "69214": "SŁUBICE",
        "69220": "SŁUBICE",
        "70001": "SZCZECIN",
        "70002": "SZCZECIN",
        "70003": "SZCZECIN",
        "70004": "SZCZECIN",
        "70005": "SZCZECIN",
        "70006": "SZCZECIN",
        "70007": "SZCZECIN",
        "70008": "SZCZECIN",
        "70009": "SZCZECIN",
        "70010": "SZCZECIN",
        "70011": "SZCZECIN",
        "70012": "SZCZECIN",
        "70013": "SZCZECIN",
        "70014": "SZCZECIN",
        "70015": "SZCZECIN",
        "70016": "SZCZECIN",
        "70017": "SZCZECIN",
        "70018": "SZCZECIN",
        "70020": "SZCZECIN",
        "70021": "SZCZECIN",
        "70022": "SZCZECIN",
        "70023": "SZCZECIN",
        "70024": "SZCZECIN",
        "70025": "SZCZECIN",
        "70026": "SZCZECIN",
        "70027": "SZCZECIN",
        "70028": "SZCZECIN",
        "70030": "SZCZECIN",
        "70031": "SZCZECIN",
        "70032": "SZCZECIN",
        "70033": "SZCZECIN",
        "70034": "SZCZECIN",
        "70035": "SZCZECIN",
        "70037": "SZCZECIN",
        "70100": "SZCZECIN",
        "70101": "SZCZECIN",
        "70102": "SZCZECIN",
        "70103": "SZCZECIN",
        "70104": "SZCZECIN",
        "70105": "SZCZECIN",
        "70106": "SZCZECIN",
        "70107": "SZCZECIN",
        "70110": "SZCZECIN",
        "70111": "SZCZECIN",
        "70112": "SZCZECIN",
        "70113": "SZCZECIN",
        "70114": "SZCZECIN",
        "70115": "SZCZECIN",
        "70116": "SZCZECIN",
        "70117": "SZCZECIN",
        "70120": "SZCZECIN",
        "70121": "SZCZECIN",
        "70123": "SZCZECIN",
        "70128": "SZCZECIN",
        "70130": "SZCZECIN",
        "70131": "SZCZECIN",
        "70132": "SZCZECIN",
        "70133": "SZCZECIN",
        "70134": "SZCZECIN",
        "70136": "SZCZECIN",
        "70137": "SZCZECIN",
        "70200": "SZCZECIN",
        "70201": "SZCZECIN",
        "70202": "SZCZECIN",
        "70203": "SZCZECIN",
        "70204": "SZCZECIN",
        "70205": "SZCZECIN",
        "70206": "SZCZECIN",
        "70207": "SZCZECIN",
        "70209": "SZCZECIN",
        "70210": "SZCZECIN",
        "70211": "SZCZECIN",
        "70212": "SZCZECIN",
        "70213": "SZCZECIN",
        "70214": "SZCZECIN",
        "70215": "SZCZECIN",
        "70216": "SZCZECIN",
        "70217": "SZCZECIN",
        "70220": "SZCZECIN",
        "70221": "SZCZECIN",
        "70222": "SZCZECIN",
        "70223": "SZCZECIN",
        "70224": "SZCZECIN",
        "70225": "SZCZECIN",
        "70226": "SZCZECIN",
        "70227": "SZCZECIN",
        "70230": "SZCZECIN",
        "70231": "SZCZECIN",
        "70232": "SZCZECIN",
        "70233": "SZCZECIN",
        "70234": "SZCZECIN",
        "70236": "SZCZECIN",
        "70237": "SZCZECIN",
        "70238": "SZCZECIN",
        "70240": "SZCZECIN",
        "70241": "SZCZECIN",
        "70242": "SZCZECIN",
        "70243": "SZCZECIN",
        "70244": "SZCZECIN",
        "70245": "SZCZECIN",
        "70246": "SZCZECIN",
        "70250": "SZCZECIN",
        "70251": "SZCZECIN",
        "70252": "SZCZECIN",
        "70253": "SZCZECIN",
        "70254": "SZCZECIN",
        "70255": "SZCZECIN",
        "70256": "SZCZECIN",
        "70257": "SZCZECIN",
        "70260": "SZCZECIN",
        "70261": "SZCZECIN",
        "70262": "SZCZECIN",
        "70263": "SZCZECIN",
        "70300": "SZCZECIN",
        "70301": "SZCZECIN",
        "70302": "SZCZECIN",
        "70303": "SZCZECIN",
        "70304": "SZCZECIN",
        "70305": "SZCZECIN",
        "70306": "SZCZECIN",
        "70307": "SZCZECIN",
        "70310": "SZCZECIN",
        "70311": "SZCZECIN",
        "70312": "SZCZECIN",
        "70313": "SZCZECIN",
        "70314": "SZCZECIN",
        "70315": "SZCZECIN",
        "70316": "SZCZECIN",
        "70317": "SZCZECIN",
        "70320": "SZCZECIN",
        "70321": "SZCZECIN",
        "70322": "SZCZECIN",
        "70323": "SZCZECIN",
        "70325": "SZCZECIN",
        "70326": "SZCZECIN",
        "70327": "SZCZECIN",
        "70330": "SZCZECIN",
        "70331": "SZCZECIN",
        "70332": "SZCZECIN",
        "70333": "SZCZECIN",
        "70334": "SZCZECIN",
        "70335": "SZCZECIN",
        "70337": "SZCZECIN",
        "70340": "SZCZECIN",
        "70341": "SZCZECIN",
        "70342": "SZCZECIN",
        "70343": "SZCZECIN",
        "70344": "SZCZECIN",
        "70345": "SZCZECIN",
        "70346": "SZCZECIN",
        "70347": "SZCZECIN",
        "70348": "SZCZECIN",
        "70349": "SZCZECIN",
        "70350": "SZCZECIN",
        "70351": "SZCZECIN",
        "70352": "SZCZECIN",
        "70353": "SZCZECIN",
        "70354": "SZCZECIN",
        "70355": "SZCZECIN",
        "70356": "SZCZECIN",
        "70357": "SZCZECIN",
        "70358": "SZCZECIN",
        "70360": "SZCZECIN",
        "70361": "SZCZECIN",
        "70362": "SZCZECIN",
        "70363": "SZCZECIN",
        "70364": "SZCZECIN",
        "70365": "SZCZECIN",
        "70366": "SZCZECIN",
        "70367": "SZCZECIN",
        "70370": "SZCZECIN",
        "70371": "SZCZECIN",
        "70372": "SZCZECIN",
        "70373": "SZCZECIN",
        "70374": "SZCZECIN",
        "70375": "SZCZECIN",
        "70376": "SZCZECIN",
        "70377": "SZCZECIN",
        "70380": "SZCZECIN",
        "70381": "SZCZECIN",
        "70382": "SZCZECIN",
        "70383": "SZCZECIN",
        "70384": "SZCZECIN",
        "70385": "SZCZECIN",
        "70386": "SZCZECIN",
        "70387": "SZCZECIN",
        "70390": "SZCZECIN",
        "70391": "SZCZECIN",
        "70392": "SZCZECIN",
        "70393": "SZCZECIN",
        "70394": "SZCZECIN",
        "70395": "SZCZECIN",
        "70396": "SZCZECIN",
        "70400": "SZCZECIN",
        "70402": "SZCZECIN",
        "70403": "SZCZECIN",
        "70404": "SZCZECIN",
        "70405": "SZCZECIN",
        "70406": "SZCZECIN",
        "70407": "SZCZECIN",
        "70410": "SZCZECIN",
        "70411": "SZCZECIN",
        "70412": "SZCZECIN",
        "70413": "SZCZECIN",
        "70414": "SZCZECIN",
        "70415": "SZCZECIN",
        "70416": "SZCZECIN",
        "70419": "SZCZECIN",
        "70420": "SZCZECIN",
        "70421": "SZCZECIN",
        "70422": "SZCZECIN",
        "70423": "SZCZECIN",
        "70424": "SZCZECIN",
        "70425": "SZCZECIN",
        "70426": "SZCZECIN",
        "70427": "SZCZECIN",
        "70428": "SZCZECIN",
        "70430": "SZCZECIN",
        "70431": "SZCZECIN",
        "70432": "SZCZECIN",
        "70433": "SZCZECIN",
        "70434": "SZCZECIN",
        "70435": "SZCZECIN",
        "70436": "SZCZECIN",
        "70437": "SZCZECIN",
        "70440": "SZCZECIN",
        "70441": "SZCZECIN",
        "70442": "SZCZECIN",
        "70443": "SZCZECIN",
        "70444": "SZCZECIN",
        "70445": "SZCZECIN",
        "70446": "SZCZECIN",
        "70450": "SZCZECIN",
        "70451": "SZCZECIN",
        "70452": "SZCZECIN",
        "70453": "SZCZECIN",
        "70454": "SZCZECIN",
        "70455": "SZCZECIN",
        "70456": "SZCZECIN",
        "70460": "SZCZECIN",
        "70461": "SZCZECIN",
        "70462": "SZCZECIN",
        "70463": "SZCZECIN",
        "70464": "SZCZECIN",
        "70465": "SZCZECIN",
        "70466": "SZCZECIN",
        "70467": "SZCZECIN",
        "70470": "SZCZECIN",
        "70471": "SZCZECIN",
        "70472": "SZCZECIN",
        "70473": "SZCZECIN",
        "70474": "SZCZECIN",
        "70475": "SZCZECIN",
        "70476": "SZCZECIN",
        "70477": "SZCZECIN",
        "70478": "SZCZECIN",
        "70479": "SZCZECIN",
        "70480": "SZCZECIN",
        "70481": "SZCZECIN",
        "70482": "SZCZECIN",
        "70483": "SZCZECIN",
        "70484": "SZCZECIN",
        "70485": "SZCZECIN",
        "70486": "SZCZECIN",
        "70487": "SZCZECIN",
        "70488": "SZCZECIN",
        "70490": "SZCZECIN",
        "70491": "SZCZECIN",
        "70492": "SZCZECIN",
        "70493": "SZCZECIN",
        "70494": "SZCZECIN",
        "70495": "SZCZECIN",
        "70496": "SZCZECIN",
        "70497": "SZCZECIN",
        "70500": "SZCZECIN",
        "70501": "SZCZECIN",
        "70502": "SZCZECIN",
        "70503": "SZCZECIN",
        "70504": "SZCZECIN",
        "70505": "SZCZECIN",
        "70506": "SZCZECIN",
        "70507": "SZCZECIN",
        "70508": "SZCZECIN",
        "70509": "SZCZECIN",
        "70510": "SZCZECIN",
        "70511": "SZCZECIN",
        "70512": "SZCZECIN",
        "70513": "SZCZECIN",
        "70514": "SZCZECIN",
        "70515": "SZCZECIN",
        "70520": "SZCZECIN",
        "70521": "SZCZECIN",
        "70522": "SZCZECIN",
        "70524": "SZCZECIN",
        "70525": "SZCZECIN",
        "70526": "SZCZECIN",
        "70527": "SZCZECIN",
        "70529": "SZCZECIN",
        "70530": "SZCZECIN",
        "70531": "SZCZECIN",
        "70532": "SZCZECIN",
        "70533": "SZCZECIN",
        "70534": "SZCZECIN",
        "70535": "SZCZECIN",
        "70536": "SZCZECIN",
        "70537": "SZCZECIN",
        "70538": "SZCZECIN",
        "70540": "SZCZECIN",
        "70541": "SZCZECIN",
        "70542": "SZCZECIN",
        "70543": "SZCZECIN",
        "70545": "SZCZECIN",
        "70546": "SZCZECIN",
        "70547": "SZCZECIN",
        "70549": "SZCZECIN",
        "70550": "SZCZECIN",
        "70551": "SZCZECIN",
        "70552": "SZCZECIN",
        "70553": "SZCZECIN",
        "70554": "SZCZECIN",
        "70555": "SZCZECIN",
        "70556": "SZCZECIN",
        "70557": "SZCZECIN",
        "70560": "SZCZECIN",
        "70561": "SZCZECIN",
        "70562": "SZCZECIN",
        "70563": "SZCZECIN",
        "70564": "SZCZECIN",
        "70565": "SZCZECIN",
        "70566": "SZCZECIN",
        "70567": "SZCZECIN",
        "70568": "SZCZECIN",
        "70569": "SZCZECIN",
        "70570": "SZCZECIN",
        "70600": "SZCZECIN",
        "70601": "SZCZECIN",
        "70602": "SZCZECIN",
        "70603": "SZCZECIN",
        "70604": "SZCZECIN",
        "70605": "SZCZECIN",
        "70606": "SZCZECIN",
        "70607": "SZCZECIN",
        "70608": "SZCZECIN",
        "70610": "SZCZECIN",
        "70611": "SZCZECIN",
        "70612": "SZCZECIN",
        "70613": "SZCZECIN",
        "70614": "SZCZECIN",
        "70615": "SZCZECIN",
        "70616": "SZCZECIN",
        "70617": "SZCZECIN",
        "70620": "SZCZECIN",
        "70621": "SZCZECIN",
        "70622": "SZCZECIN",
        "70623": "SZCZECIN",
        "70630": "SZCZECIN",
        "70631": "SZCZECIN",
        "70632": "SZCZECIN",
        "70633": "SZCZECIN",
        "70634": "SZCZECIN",
        "70635": "SZCZECIN",
        "70636": "SZCZECIN",
        "70640": "SZCZECIN",
        "70641": "SZCZECIN",
        "70642": "SZCZECIN",
        "70644": "SZCZECIN",
        "70646": "SZCZECIN",
        "70651": "SZCZECIN",
        "70652": "SZCZECIN",
        "70653": "SZCZECIN",
        "70655": "SZCZECIN",
        "70656": "SZCZECIN",
        "70660": "SZCZECIN",
        "70661": "SZCZECIN",
        "70662": "SZCZECIN",
        "70663": "SZCZECIN",
        "70664": "SZCZECIN",
        "70665": "SZCZECIN",
        "70666": "SZCZECIN",
        "70667": "SZCZECIN",
        "70668": "SZCZECIN",
        "70671": "SZCZECIN",
        "70672": "SZCZECIN",
        "70673": "SZCZECIN",
        "70674": "SZCZECIN",
        "70675": "SZCZECIN",
        "70676": "SZCZECIN",
        "70700": "SZCZECIN",
        "70701": "SZCZECIN",
        "70702": "SZCZECIN",
        "70703": "SZCZECIN",
        "70704": "SZCZECIN",
        "70705": "SZCZECIN",
        "70706": "SZCZECIN",
        "70707": "SZCZECIN",
        "70708": "SZCZECIN",
        "70710": "SZCZECIN",
        "70711": "SZCZECIN",
        "70712": "SZCZECIN",
        "70713": "SZCZECIN",
        "70714": "SZCZECIN",
        "70715": "SZCZECIN",
        "70716": "SZCZECIN",
        "70717": "SZCZECIN",
        "70720": "SZCZECIN",
        "70721": "SZCZECIN",
        "70722": "SZCZECIN",
        "70723": "SZCZECIN",
        "70724": "SZCZECIN",
        "70725": "SZCZECIN",
        "70726": "SZCZECIN",
        "70727": "SZCZECIN",
        "70730": "SZCZECIN",
        "70731": "SZCZECIN",
        "70732": "SZCZECIN",
        "70733": "SZCZECIN",
        "70734": "SZCZECIN",
        "70735": "SZCZECIN",
        "70736": "SZCZECIN",
        "70737": "SZCZECIN",
        "70740": "SZCZECIN",
        "70741": "SZCZECIN",
        "70742": "SZCZECIN",
        "70743": "SZCZECIN",
        "70744": "SZCZECIN",
        "70745": "SZCZECIN",
        "70746": "SZCZECIN",
        "70747": "SZCZECIN",
        "70748": "SZCZECIN",
        "70750": "SZCZECIN",
        "70751": "SZCZECIN",
        "70752": "SZCZECIN",
        "70753": "SZCZECIN",
        "70754": "SZCZECIN",
        "70760": "SZCZECIN",
        "70761": "SZCZECIN",
        "70762": "SZCZECIN",
        "70763": "SZCZECIN",
        "70764": "SZCZECIN",
        "70765": "SZCZECIN",
        "70766": "SZCZECIN",
        "70767": "SZCZECIN",
        "70770": "SZCZECIN",
        "70771": "SZCZECIN",
        "70772": "SZCZECIN",
        "70773": "SZCZECIN",
        "70774": "SZCZECIN",
        "70775": "SZCZECIN",
        "70776": "SZCZECIN",
        "70777": "SZCZECIN",
        "70778": "SZCZECIN",
        "70779": "SZCZECIN",
        "70780": "SZCZECIN",
        "70781": "SZCZECIN",
        "70782": "SZCZECIN",
        "70783": "SZCZECIN",
        "70784": "SZCZECIN",
        "70785": "SZCZECIN",
        "70786": "SZCZECIN",
        "70787": "SZCZECIN",
        "70788": "SZCZECIN",
        "70789": "SZCZECIN",
        "70790": "SZCZECIN",
        "70791": "SZCZECIN",
        "70792": "SZCZECIN",
        "70793": "SZCZECIN",
        "70794": "SZCZECIN",
        "70795": "SZCZECIN",
        "70796": "SZCZECIN",
        "70797": "SZCZECIN",
        "70798": "SZCZECIN",
        "70799": "SZCZECIN",
        "70800": "SZCZECIN",
        "70801": "SZCZECIN",
        "70802": "SZCZECIN",
        "70803": "SZCZECIN",
        "70804": "SZCZECIN",
        "70805": "SZCZECIN",
        "70806": "SZCZECIN",
        "70807": "SZCZECIN",
        "70809": "SZCZECIN",
        "70810": "SZCZECIN",
        "70811": "SZCZECIN",
        "70812": "SZCZECIN",
        "70813": "SZCZECIN",
        "70814": "SZCZECIN",
        "70815": "SZCZECIN",
        "70819": "SZCZECIN",
        "70820": "SZCZECIN",
        "70821": "SZCZECIN",
        "70822": "SZCZECIN",
        "70823": "SZCZECIN",
        "70824": "SZCZECIN",
        "70825": "SZCZECIN",
        "70826": "SZCZECIN",
        "70827": "SZCZECIN",
        "70830": "SZCZECIN",
        "70831": "SZCZECIN",
        "70832": "SZCZECIN",
        "70833": "SZCZECIN",
        "70834": "SZCZECIN",
        "70835": "SZCZECIN",
        "70836": "SZCZECIN",
        "70837": "SZCZECIN",
        "70839": "SZCZECIN",
        "70840": "SZCZECIN",
        "70841": "SZCZECIN",
        "70842": "SZCZECIN",
        "70843": "SZCZECIN",
        "70844": "SZCZECIN",
        "70845": "SZCZECIN",
        "70846": "SZCZECIN",
        "70847": "SZCZECIN",
        "70848": "SZCZECIN",
        "70850": "SZCZECIN",
        "70851": "SZCZECIN",
        "70852": "SZCZECIN",
        "70853": "SZCZECIN",
        "70854": "SZCZECIN",
        "70855": "SZCZECIN",
        "70856": "SZCZECIN",
        "70857": "SZCZECIN",
        "70862": "SZCZECIN",
        "70864": "SZCZECIN",
        "70870": "SZCZECIN",
        "70871": "SZCZECIN",
        "70872": "SZCZECIN",
        "70873": "SZCZECIN",
        "70874": "SZCZECIN",
        "70875": "SZCZECIN",
        "70876": "SZCZECIN",
        "70877": "SZCZECIN",
        "70878": "SZCZECIN",
        "70879": "SZCZECIN",
        "70880": "SZCZECIN",
        "70881": "SZCZECIN",
        "70882": "SZCZECIN",
        "70883": "SZCZECIN",
        "70884": "SZCZECIN",
        "70885": "SZCZECIN",
        "70886": "SZCZECIN",
        "70887": "SZCZECIN",
        "70888": "SZCZECIN",
        "70889": "SZCZECIN",
        "70890": "SZCZECIN",
        "70891": "SZCZECIN",
        "70892": "SZCZECIN",
        "70893": "SZCZECIN",
        "70894": "SZCZECIN",
        "70895": "SZCZECIN",
        "70896": "SZCZECIN",
        "70900": "SZCZECIN",
        "70901": "SZCZECIN",
        "70904": "SZCZECIN",
        "70907": "SZCZECIN",
        "70940": "SZCZECIN",
        "70950": "SZCZECIN",
        "70953": "SZCZECIN",
        "71001": "SZCZECIN",
        "71002": "SZCZECIN",
        "71003": "SZCZECIN",
        "71004": "SZCZECIN",
        "71005": "SZCZECIN",
        "71006": "SZCZECIN",
        "71007": "SZCZECIN",
        "71008": "SZCZECIN",
        "71009": "SZCZECIN",
        "71010": "SZCZECIN",
        "71011": "SZCZECIN",
        "71012": "SZCZECIN",
        "71013": "SZCZECIN",
        "71014": "SZCZECIN",
        "71015": "SZCZECIN",
        "71016": "SZCZECIN",
        "71017": "SZCZECIN",
        "71018": "SZCZECIN",
        "71019": "SZCZECIN",
        "71020": "SZCZECIN",
        "71021": "SZCZECIN",
        "71022": "SZCZECIN",
        "71023": "SZCZECIN",
        "71024": "SZCZECIN",
        "71025": "SZCZECIN",
        "71026": "SZCZECIN",
        "71027": "SZCZECIN",
        "71028": "SZCZECIN",
        "71030": "SZCZECIN",
        "71031": "SZCZECIN",
        "71032": "SZCZECIN",
        "71033": "SZCZECIN",
        "71034": "SZCZECIN",
        "71035": "SZCZECIN",
        "71036": "SZCZECIN",
        "71037": "SZCZECIN",
        "71040": "SZCZECIN",
        "71041": "SZCZECIN",
        "71042": "SZCZECIN",
        "71043": "SZCZECIN",
        "71044": "SZCZECIN",
        "71045": "SZCZECIN",
        "71046": "SZCZECIN",
        "71047": "SZCZECIN",
        "71050": "SZCZECIN",
        "71051": "SZCZECIN",
        "71052": "SZCZECIN",
        "71060": "SZCZECIN",
        "71061": "SZCZECIN",
        "71062": "SZCZECIN",
        "71063": "SZCZECIN",
        "71064": "SZCZECIN",
        "71065": "SZCZECIN",
        "71066": "SZCZECIN",
        "71069": "SZCZECIN",
        "71070": "SZCZECIN",
        "71071": "SZCZECIN",
        "71072": "SZCZECIN",
        "71073": "SZCZECIN",
        "71074": "SZCZECIN",
        "71075": "SZCZECIN",
        "71076": "SZCZECIN",
        "71078": "SZCZECIN",
        "71080": "SZCZECIN",
        "71081": "SZCZECIN",
        "71082": "SZCZECIN",
        "71083": "SZCZECIN",
        "71084": "SZCZECIN",
        "71085": "SZCZECIN",
        "71086": "SZCZECIN",
        "71100": "SZCZECIN",
        "71101": "SZCZECIN",
        "71102": "SZCZECIN",
        "71103": "SZCZECIN",
        "71104": "SZCZECIN",
        "71105": "SZCZECIN",
        "71106": "SZCZECIN",
        "71107": "SZCZECIN",
        "71110": "SZCZECIN",
        "71111": "SZCZECIN",
        "71112": "SZCZECIN",
        "71113": "SZCZECIN",
        "71114": "SZCZECIN",
        "71115": "SZCZECIN",
        "71116": "SZCZECIN",
        "71117": "SZCZECIN",
        "71118": "SZCZECIN",
        "71119": "SZCZECIN",
        "71120": "SZCZECIN",
        "71121": "SZCZECIN",
        "71122": "SZCZECIN",
        "71123": "SZCZECIN",
        "71124": "SZCZECIN",
        "71125": "SZCZECIN",
        "71126": "SZCZECIN",
        "71129": "SZCZECIN",
        "71130": "SZCZECIN",
        "71131": "SZCZECIN",
        "71132": "SZCZECIN",
        "71133": "SZCZECIN",
        "71134": "SZCZECIN",
        "71135": "SZCZECIN",
        "71136": "SZCZECIN",
        "71137": "SZCZECIN",
        "71138": "SZCZECIN",
        "71140": "SZCZECIN",
        "71141": "SZCZECIN",
        "71142": "SZCZECIN",
        "71143": "SZCZECIN",
        "71144": "SZCZECIN",
        "71145": "SZCZECIN",
        "71146": "SZCZECIN",
        "71147": "SZCZECIN",
        "71148": "SZCZECIN",
        "71149": "SZCZECIN",
        "71150": "SZCZECIN",
        "71151": "SZCZECIN",
        "71152": "SZCZECIN",
        "71153": "SZCZECIN",
        "71154": "SZCZECIN",
        "71155": "SZCZECIN",
        "71156": "SZCZECIN",
        "71157": "SZCZECIN",
        "71160": "SZCZECIN",
        "71161": "SZCZECIN",
        "71162": "SZCZECIN",
        "71163": "SZCZECIN",
        "71165": "SZCZECIN",
        "71170": "SZCZECIN",
        "71171": "SZCZECIN",
        "71172": "SZCZECIN",
        "71173": "SZCZECIN",
        "71174": "SZCZECIN",
        "71175": "SZCZECIN",
        "71176": "SZCZECIN",
        "71177": "SZCZECIN",
        "71178": "SZCZECIN",
        "71179": "SZCZECIN",
        "71180": "SZCZECIN",
        "71181": "SZCZECIN",
        "71200": "SZCZECIN",
        "71201": "SZCZECIN",
        "71202": "SZCZECIN",
        "71203": "SZCZECIN",
        "71204": "SZCZECIN",
        "71205": "SZCZECIN",
        "71206": "SZCZECIN",
        "71207": "SZCZECIN",
        "71209": "SZCZECIN",
        "71210": "SZCZECIN",
        "71211": "SZCZECIN",
        "71212": "SZCZECIN",
        "71213": "SZCZECIN",
        "71214": "SZCZECIN",
        "71215": "SZCZECIN",
        "71216": "SZCZECIN",
        "71217": "SZCZECIN",
        "71218": "SZCZECIN",
        "71219": "SZCZECIN",
        "71220": "SZCZECIN",
        "71221": "SZCZECIN",
        "71222": "SZCZECIN",
        "71223": "SZCZECIN",
        "71224": "SZCZECIN",
        "71225": "SZCZECIN",
        "71226": "SZCZECIN",
        "71227": "SZCZECIN",
        "71228": "SZCZECIN",
        "71229": "SZCZECIN",
        "71230": "SZCZECIN",
        "71231": "SZCZECIN",
        "71232": "SZCZECIN",
        "71233": "SZCZECIN",
        "71234": "SZCZECIN",
        "71235": "SZCZECIN",
        "71236": "SZCZECIN",
        "71237": "SZCZECIN",
        "71238": "SZCZECIN",
        "71240": "SZCZECIN",
        "71241": "SZCZECIN",
        "71242": "SZCZECIN",
        "71244": "SZCZECIN",
        "71245": "SZCZECIN",
        "71246": "SZCZECIN",
        "71247": "SZCZECIN",
        "71248": "SZCZECIN",
        "71249": "SZCZECIN",
        "71250": "SZCZECIN",
        "71251": "SZCZECIN",
        "71252": "SZCZECIN",
        "71253": "SZCZECIN",
        "71254": "SZCZECIN",
        "71255": "SZCZECIN",
        "71256": "SZCZECIN",
        "71257": "SZCZECIN",
        "71260": "SZCZECIN",
        "71261": "SZCZECIN",
        "71262": "SZCZECIN",
        "71263": "SZCZECIN",
        "71264": "SZCZECIN",
        "71265": "SZCZECIN",
        "71266": "SZCZECIN",
        "71270": "SZCZECIN",
        "71271": "SZCZECIN",
        "71272": "SZCZECIN",
        "71273": "SZCZECIN",
        "71274": "SZCZECIN",
        "71275": "SZCZECIN",
        "71276": "SZCZECIN",
        "71277": "SZCZECIN",
        "71278": "SZCZECIN",
        "71279": "SZCZECIN",
        "71280": "SZCZECIN",
        "71281": "SZCZECIN",
        "71294": "SZCZECIN",
        "71295": "SZCZECIN",
        "71296": "SZCZECIN",
        "71297": "SZCZECIN",
        "71298": "SZCZECIN",
        "71299": "SZCZECIN",
        "71300": "SZCZECIN",
        "71301": "SZCZECIN",
        "71302": "SZCZECIN",
        "71303": "SZCZECIN",
        "71304": "SZCZECIN",
        "71305": "SZCZECIN",
        "71306": "SZCZECIN",
        "71307": "SZCZECIN",
        "71310": "SZCZECIN",
        "71311": "SZCZECIN",
        "71312": "SZCZECIN",
        "71313": "SZCZECIN",
        "71314": "SZCZECIN",
        "71315": "SZCZECIN",
        "71316": "SZCZECIN",
        "71317": "SZCZECIN",
        "71320": "SZCZECIN",
        "71321": "SZCZECIN",
        "71322": "SZCZECIN",
        "71323": "SZCZECIN",
        "71324": "SZCZECIN",
        "71325": "SZCZECIN",
        "71326": "SZCZECIN",
        "71327": "SZCZECIN",
        "71330": "SZCZECIN",
        "71331": "SZCZECIN",
        "71332": "SZCZECIN",
        "71333": "SZCZECIN",
        "71334": "SZCZECIN",
        "71335": "SZCZECIN",
        "71336": "SZCZECIN",
        "71337": "SZCZECIN",
        "71340": "SZCZECIN",
        "71341": "SZCZECIN",
        "71342": "SZCZECIN",
        "71343": "SZCZECIN",
        "71344": "SZCZECIN",
        "71345": "SZCZECIN",
        "71346": "SZCZECIN",
        "71370": "SZCZECIN",
        "71371": "SZCZECIN",
        "71372": "SZCZECIN",
        "71373": "SZCZECIN",
        "71374": "SZCZECIN",
        "71375": "SZCZECIN",
        "71376": "SZCZECIN",
        "71377": "SZCZECIN",
        "71378": "SZCZECIN",
        "71380": "SZCZECIN",
        "71381": "SZCZECIN",
        "71382": "SZCZECIN",
        "71386": "SZCZECIN",
        "71387": "SZCZECIN",
        "71390": "SZCZECIN",
        "71391": "SZCZECIN",
        "71392": "SZCZECIN",
        "71393": "SZCZECIN",
        "71400": "SZCZECIN",
        "71401": "SZCZECIN",
        "71402": "SZCZECIN",
        "71403": "SZCZECIN",
        "71404": "SZCZECIN",
        "71405": "SZCZECIN",
        "71407": "SZCZECIN",
        "71410": "SZCZECIN",
        "71411": "SZCZECIN",
        "71412": "SZCZECIN",
        "71413": "SZCZECIN",
        "71414": "SZCZECIN",
        "71415": "SZCZECIN",
        "71416": "SZCZECIN",
        "71417": "SZCZECIN",
        "71420": "SZCZECIN",
        "71421": "SZCZECIN",
        "71422": "SZCZECIN",
        "71423": "SZCZECIN",
        "71424": "SZCZECIN",
        "71425": "SZCZECIN",
        "71426": "SZCZECIN",
        "71427": "SZCZECIN",
        "71430": "SZCZECIN",
        "71431": "SZCZECIN",
        "71432": "SZCZECIN",
        "71433": "SZCZECIN",
        "71434": "SZCZECIN",
        "71435": "SZCZECIN",
        "71436": "SZCZECIN",
        "71437": "SZCZECIN",
        "71438": "SZCZECIN",
        "71440": "SZCZECIN",
        "71441": "SZCZECIN",
        "71443": "SZCZECIN",
        "71444": "SZCZECIN",
        "71445": "SZCZECIN",
        "71446": "SZCZECIN",
        "71447": "SZCZECIN",
        "71449": "SZCZECIN",
        "71450": "SZCZECIN",
        "71451": "SZCZECIN",
        "71452": "SZCZECIN",
        "71453": "SZCZECIN",
        "71454": "SZCZECIN",
        "71455": "SZCZECIN",
        "71457": "SZCZECIN",
        "71459": "SZCZECIN",
        "71460": "SZCZECIN",
        "71461": "SZCZECIN",
        "71462": "SZCZECIN",
        "71463": "SZCZECIN",
        "71464": "SZCZECIN",
        "71465": "SZCZECIN",
        "71466": "SZCZECIN",
        "71467": "SZCZECIN",
        "71468": "SZCZECIN",
        "71470": "SZCZECIN",
        "71471": "SZCZECIN",
        "71472": "SZCZECIN",
        "71474": "SZCZECIN",
        "71475": "SZCZECIN",
        "71476": "SZCZECIN",
        "71477": "SZCZECIN",
        "71478": "SZCZECIN",
        "71479": "SZCZECIN",
        "71480": "SZCZECIN",
        "71481": "SZCZECIN",
        "71482": "SZCZECIN",
        "71483": "SZCZECIN",
        "71484": "SZCZECIN",
        "71486": "SZCZECIN",
        "71487": "SZCZECIN",
        "71490": "SZCZECIN",
        "71491": "SZCZECIN",
        "71492": "SZCZECIN",
        "71493": "SZCZECIN",
        "71494": "SZCZECIN",
        "71495": "SZCZECIN",
        "71496": "SZCZECIN",
        "71497": "SZCZECIN",
        "71498": "SZCZECIN",
        "71499": "SZCZECIN",
        "71500": "SZCZECIN",
        "71501": "SZCZECIN",
        "71502": "SZCZECIN",
        "71503": "SZCZECIN",
        "71504": "SZCZECIN",
        "71505": "SZCZECIN",
        "71506": "SZCZECIN",
        "71507": "SZCZECIN",
        "71515": "SZCZECIN",
        "71516": "SZCZECIN",
        "71520": "SZCZECIN",
        "71521": "SZCZECIN",
        "71522": "SZCZECIN",
        "71524": "SZCZECIN",
        "71525": "SZCZECIN",
        "71526": "SZCZECIN",
        "71527": "SZCZECIN",
        "71528": "SZCZECIN",
        "71530": "SZCZECIN",
        "71531": "SZCZECIN",
        "71532": "SZCZECIN",
        "71533": "SZCZECIN",
        "71534": "SZCZECIN",
        "71535": "SZCZECIN",
        "71537": "SZCZECIN",
        "71540": "SZCZECIN",
        "71541": "SZCZECIN",
        "71543": "SZCZECIN",
        "71544": "SZCZECIN",
        "71545": "SZCZECIN",
        "71547": "SZCZECIN",
        "71550": "SZCZECIN",
        "71551": "SZCZECIN",
        "71552": "SZCZECIN",
        "71553": "SZCZECIN",
        "71554": "SZCZECIN",
        "71555": "SZCZECIN",
        "71556": "SZCZECIN",
        "71557": "SZCZECIN",
        "71560": "SZCZECIN",
        "71561": "SZCZECIN",
        "71562": "SZCZECIN",
        "71563": "SZCZECIN",
        "71564": "SZCZECIN",
        "71565": "SZCZECIN",
        "71600": "SZCZECIN",
        "71601": "SZCZECIN",
        "71602": "SZCZECIN",
        "71603": "SZCZECIN",
        "71604": "SZCZECIN",
        "71605": "SZCZECIN",
        "71606": "SZCZECIN",
        "71607": "SZCZECIN",
        "71610": "SZCZECIN",
        "71611": "SZCZECIN",
        "71612": "SZCZECIN",
        "71614": "SZCZECIN",
        "71615": "SZCZECIN",
        "71616": "SZCZECIN",
        "71617": "SZCZECIN",
        "71620": "SZCZECIN",
        "71621": "SZCZECIN",
        "71622": "SZCZECIN",
        "71623": "SZCZECIN",
        "71625": "SZCZECIN",
        "71626": "SZCZECIN",
        "71627": "SZCZECIN",
        "71629": "SZCZECIN",
        "71630": "SZCZECIN",
        "71631": "SZCZECIN",
        "71632": "SZCZECIN",
        "71634": "SZCZECIN",
        "71635": "SZCZECIN",
        "71636": "SZCZECIN",
        "71637": "SZCZECIN",
        "71641": "SZCZECIN",
        "71642": "SZCZECIN",
        "71643": "SZCZECIN",
        "71644": "SZCZECIN",
        "71645": "SZCZECIN",
        "71646": "SZCZECIN",
        "71647": "SZCZECIN",
        "71650": "SZCZECIN",
        "71652": "SZCZECIN",
        "71653": "SZCZECIN",
        "71656": "SZCZECIN",
        "71657": "SZCZECIN",
        "71660": "SZCZECIN",
        "71661": "SZCZECIN",
        "71662": "SZCZECIN",
        "71663": "SZCZECIN",
        "71664": "SZCZECIN",
        "71665": "SZCZECIN",
        "71666": "SZCZECIN",
        "71667": "SZCZECIN",
        "71668": "SZCZECIN",
        "71669": "SZCZECIN",
        "71670": "SZCZECIN",
        "71671": "SZCZECIN",
        "71672": "SZCZECIN",
        "71673": "SZCZECIN",
        "71674": "SZCZECIN",
        "71675": "SZCZECIN",
        "71676": "SZCZECIN",
        "71677": "SZCZECIN",
        "71680": "SZCZECIN",
        "71681": "SZCZECIN",
        "71682": "SZCZECIN",
        "71683": "SZCZECIN",
        "71684": "SZCZECIN",
        "71685": "SZCZECIN",
        "71687": "SZCZECIN",
        "71688": "SZCZECIN",
        "71690": "SZCZECIN",
        "71691": "SZCZECIN",
        "71692": "SZCZECIN",
        "71693": "SZCZECIN",
        "71694": "SZCZECIN",
        "71695": "SZCZECIN",
        "71696": "SZCZECIN",
        "71697": "SZCZECIN",
        "71698": "SZCZECIN",
        "71699": "SZCZECIN",
        "71700": "SZCZECIN",
        "71702": "SZCZECIN",
        "71703": "SZCZECIN",
        "71704": "SZCZECIN",
        "71705": "SZCZECIN",
        "71706": "SZCZECIN",
        "71707": "SZCZECIN",
        "71710": "SZCZECIN",
        "71711": "SZCZECIN",
        "71712": "SZCZECIN",
        "71713": "SZCZECIN",
        "71714": "SZCZECIN",
        "71715": "SZCZECIN",
        "71716": "SZCZECIN",
        "71717": "SZCZECIN",
        "71718": "SZCZECIN",
        "71720": "SZCZECIN",
        "71721": "SZCZECIN",
        "71722": "SZCZECIN",
        "71723": "SZCZECIN",
        "71724": "SZCZECIN",
        "71725": "SZCZECIN",
        "71726": "SZCZECIN",
        "71727": "SZCZECIN",
        "71728": "SZCZECIN",
        "71730": "SZCZECIN",
        "71731": "SZCZECIN",
        "71732": "SZCZECIN",
        "71733": "SZCZECIN",
        "71734": "SZCZECIN",
        "71735": "SZCZECIN",
        "71736": "SZCZECIN",
        "71737": "SZCZECIN",
        "71738": "SZCZECIN",
        "71739": "SZCZECIN",
        "71740": "SZCZECIN",
        "71741": "SZCZECIN",
        "71742": "SZCZECIN",
        "71743": "SZCZECIN",
        "71744": "SZCZECIN",
        "71745": "SZCZECIN",
        "71746": "SZCZECIN",
        "71747": "SZCZECIN",
        "71748": "SZCZECIN",
        "71750": "SZCZECIN",
        "71751": "SZCZECIN",
        "71752": "SZCZECIN",
        "71753": "SZCZECIN",
        "71754": "SZCZECIN",
        "71755": "SZCZECIN",
        "71756": "SZCZECIN",
        "71757": "SZCZECIN",
        "71758": "SZCZECIN",
        "71767": "SZCZECIN",
        "71768": "SZCZECIN",
        "71769": "SZCZECIN",
        "71770": "SZCZECIN",
        "71771": "SZCZECIN",
        "71772": "SZCZECIN",
        "71773": "SZCZECIN",
        "71774": "SZCZECIN",
        "71775": "SZCZECIN",
        "71776": "SZCZECIN",
        "71777": "SZCZECIN",
        "71778": "SZCZECIN",
        "71779": "SZCZECIN",
        "71780": "SZCZECIN",
        "71781": "SZCZECIN",
        "71782": "SZCZECIN",
        "71783": "SZCZECIN",
        "71784": "SZCZECIN",
        "71785": "SZCZECIN",
        "71786": "SZCZECIN",
        "71787": "SZCZECIN",
        "71788": "SZCZECIN",
        "71789": "SZCZECIN",
        "71790": "SZCZECIN",
        "71791": "SZCZECIN",
        "71792": "SZCZECIN",
        "71793": "SZCZECIN",
        "71794": "SZCZECIN",
        "71795": "SZCZECIN",
        "71796": "SZCZECIN",
        "71797": "SZCZECIN",
        "71798": "SZCZECIN",
        "71799": "SZCZECIN",
        "71800": "SZCZECIN",
        "71801": "SZCZECIN",
        "71802": "SZCZECIN",
        "71803": "SZCZECIN",
        "71804": "SZCZECIN",
        "71805": "SZCZECIN",
        "71806": "SZCZECIN",
        "71807": "SZCZECIN",
        "71808": "SZCZECIN",
        "71809": "SZCZECIN",
        "71810": "SZCZECIN",
        "71811": "SZCZECIN",
        "71812": "SZCZECIN",
        "71813": "SZCZECIN",
        "71814": "SZCZECIN",
        "71815": "SZCZECIN",
        "71816": "SZCZECIN",
        "71817": "SZCZECIN",
        "71818": "SZCZECIN",
        "71820": "SZCZECIN",
        "71821": "SZCZECIN",
        "71822": "SZCZECIN",
        "71823": "SZCZECIN",
        "71824": "SZCZECIN",
        "71825": "SZCZECIN",
        "71826": "SZCZECIN",
        "71827": "SZCZECIN",
        "71828": "SZCZECIN",
        "71829": "SZCZECIN",
        "71830": "SZCZECIN",
        "71831": "SZCZECIN",
        "71832": "SZCZECIN",
        "71833": "SZCZECIN",
        "71834": "SZCZECIN",
        "71835": "SZCZECIN",
        "71836": "SZCZECIN",
        "71837": "SZCZECIN",
        "71838": "SZCZECIN",
        "71840": "SZCZECIN",
        "71841": "SZCZECIN",
        "71842": "SZCZECIN",
        "71843": "SZCZECIN",
        "71844": "SZCZECIN",
        "71845": "SZCZECIN",
        "71867": "SZCZECIN",
        "71868": "SZCZECIN",
        "71869": "SZCZECIN",
        "71870": "SZCZECIN",
        "71871": "SZCZECIN",
        "71872": "SZCZECIN",
        "71873": "SZCZECIN",
        "71874": "SZCZECIN",
        "71875": "SZCZECIN",
        "71876": "SZCZECIN",
        "71877": "SZCZECIN",
        "71878": "SZCZECIN",
        "71880": "SZCZECIN",
        "71881": "SZCZECIN",
        "71882": "SZCZECIN",
        "71883": "SZCZECIN",
        "71884": "SZCZECIN",
        "71885": "SZCZECIN",
        "71886": "SZCZECIN",
        "71887": "SZCZECIN",
        "71888": "SZCZECIN",
        "71889": "SZCZECIN",
        "71890": "SZCZECIN",
        "71891": "SZCZECIN",
        "71892": "SZCZECIN",
        "71893": "SZCZECIN",
        "71894": "SZCZECIN",
        "71895": "SZCZECIN",
        "71896": "SZCZECIN",
        "71897": "SZCZECIN",
        "71898": "SZCZECIN",
        "71899": "SZCZECIN",
        "72001": "POLICE",
        "72002": "POLICE",
        "72003": "POLICE",
        "72004": "POLICE",
        "72005": "POLICE",
        "72006": "POLICE",
        "72009": "POLICE",
        "72010": "POLICE",
        "72011": "POLICE",
        "72015": "POLICE",
        "72020": "POLICE",
        "72022": "POLICE",
        "72100": "GOLENIÓW",
        "72101": "GOLENIÓW",
        "72102": "GOLENIÓW",
        "72105": "GOLENIÓW",
        "72110": "GOLENIÓW",
        "72111": "GOLENIÓW",
        "72112": "GOLENIÓW",
        "72113": "GOLENIÓW",
        "72121": "GOLENIÓW",
        "72122": "GOLENIÓW",
        "72123": "GOLENIÓW",
        "72130": "GOLENIÓW",
        "72131": "GOLENIÓW",
        "72132": "GOLENIÓW",
        "72200": "NOWOGARD",
        "72203": "NOWOGARD",
        "72204": "GOLENIÓW",
        "72205": "GOLENIÓW",
        "72207": "GOLENIÓW",
        "72209": "GOLENIÓW",
        "72210": "ŁOBEZ",
        "72211": "ŁOBEZ",
        "72212": "GOLENIÓW",
        "72220": "GOLENIÓW",
        "72221": "GOLENIÓW",
        "72300": "GRYFICE",
        "72301": "GRYFICE",
        "72302": "GRYFICE",
        "72304": "GRYFICE",
        "72306": "GRYFICE",
        "72307": "GRYFICE",
        "72310": "GRYFICE",
        "72311": "GRYFICE",
        "72313": "GRYFICE",
        "72314": "ŁOBEZ",
        "72315": "ŁOBEZ",
        "72316": "ŁOBEZ",
        "72317": "ŁOBEZ",
        "72320": "GRYFICE",
        "72321": "GRYFICE",
        "72322": "GRYFICE",
        "72330": "GRYFICE",
        "72332": "GRYFICE",
        "72341": "GRYFICE",
        "72342": "GRYFICE",
        "72343": "GRYFICE",
        "72344": "GRYFICE",
        "72345": "GRYFICE",
        "72346": "GRYFICE",
        "72350": "GRYFICE",
        "72351": "GRYFICE",
        "72400": "KAMIEŃ POMORSKI",
        "72401": "KAMIEŃ POMORSKI",
        "72405": "KAMIEŃ POMORSKI",
        "72410": "KAMIEŃ POMORSKI",
        "72415": "KAMIEŃ POMORSKI",
        "72418": "KAMIEŃ POMORSKI",
        "72420": "KAMIEŃ POMORSKI",
        "72500": "MIĘDZYZDROJE",
        "72510": "KAMIEŃ POMORSKI",
        "72511": "KAMIEŃ POMORSKI",
        "72513": "KAMIEŃ POMORSKI",
        "72514": "KAMIEŃ POMORSKI",
        "72518": "KAMIEŃ POMORSKI",
        "72600": "ŚWINOUJŚCIE",
        "72601": "ŚWINOUJŚCIE",
        "72602": "ŚWINOUJŚCIE",
        "72604": "ŚWINOUJŚCIE",
        "72605": "ŚWINOUJŚCIE",
        "72606": "ŚWINOUJŚCIE",
        "72610": "ŚWINOUJŚCIE",
        "72611": "ŚWINOUJŚCIE",
        "73100": "STARGARD SZCZECIŃSKI (NET)",
        "73101": "STARGARD SZCZECIŃSKI (NET)",
        "73102": "STARGARD SZCZECIŃSKI (NET)",
        "73103": "STARGARD SZCZECIŃSKI (NET)",
        "73104": "STARGARD SZCZECIŃSKI (NET)",
        "73105": "STARGARD SZCZECIŃSKI (NET)",
        "73106": "STARGARD SZCZECIŃSKI (NET)",
        "73107": "STARGARD SZCZECIŃSKI (NET)",
        "73108": "STARGARD SZCZECIŃSKI",
        "73109": "STARGARD SZCZECIŃSKI (NET)",
        "73110": "STARGARD SZCZECIŃSKI (NET)",
        "73112": "STARGARD SZCZECIŃSKI (NET)",
        "73113": "STARGARD SZCZECIŃSKI (NET)",
        "73115": "STARGARD SZCZECIŃSKI (NET)",
        "73116": "STARGARD SZCZECIŃSKI (NET)",
        "73120": "STARGARD SZCZECIŃSKI (NET)",
        "73121": "STARGARD SZCZECIŃSKI (NET)",
        "73130": "STARGARD SZCZECIŃSKI (NET)",
        "73131": "STARGARD SZCZECIŃSKI (NET)",
        "73132": "STARGARD SZCZECIŃSKI (NET)",
        "73134": "STARGARD SZCZECIŃSKI (NET)",
        "73140": "STARGARD SZCZECIŃSKI (NET)",
        "73150": "ŁOBEZ",
        "73151": "ŁOBEZ",
        "73152": "ŁOBEZ",
        "73153": "ŁOBEZ",
        "73154": "ŁOBEZ",
        "73155": "ŁOBEZ",
        "73200": "CHOSZCZNO",
        "73201": "CHOSZCZNO",
        "73210": "CHOSZCZNO",
        "73211": "CHOSZCZNO",
        "73220": "CHOSZCZNO",
        "73222": "CHOSZCZNO",
        "73231": "CHOSZCZNO",
        "73234": "CHOSZCZNO",
        "73236": "CHOSZCZNO",
        "73240": "CHOSZCZNO",
        "73260": "CHOSZCZNO",
        "73261": "CHOSZCZNO",
        "74100": "GRYFINO",
        "74101": "GRYFINO",
        "74102": "GRYFINO",
        "74105": "GRYFINO",
        "74106": "GRYFINO",
        "74107": "GRYFINO",
        "74110": "GRYFINO",
        "74111": "GRYFINO",
        "74120": "GRYFINO",
        "74121": "GRYFINO",
        "74200": "PYRZYCE",
        "74201": "PYRZYCE",
        "74202": "PYRZYCE",
        "74204": "PYRZYCE",
        "74205": "PYRZYCE",
        "74210": "PYRZYCE",
        "74211": "PYRZYCE",
        "74230": "PYRZYCE",
        "74240": "PYRZYCE",
        "74300": "MYŚLIBÓRZ",
        "74304": "MYŚLIBÓRZ",
        "74305": "MYŚLIBÓRZ",
        "74311": "MYŚLIBÓRZ",
        "74312": "MYŚLIBÓRZ",
        "74320": "BARLINEK",
        "74322": "MYŚLIBÓRZ",
        "74400": "MYŚLIBÓRZ",
        "74401": "MYŚLIBÓRZ",
        "74404": "MYŚLIBÓRZ",
        "74405": "MYŚLIBÓRZ",
        "74406": "MYŚLIBÓRZ",
        "74407": "MYŚLIBÓRZ",
        "74500": "GRYFINO",
        "74503": "GRYFINO",
        "74505": "GRYFINO",
        "74506": "GRYFINO",
        "74510": "GRYFINO",
        "74520": "GRYFINO",
        "75001": "KOSZALIN",
        "75002": "KOSZALIN",
        "75003": "KOSZALIN",
        "75004": "KOSZALIN",
        "75005": "KOSZALIN",
        "75006": "KOSZALIN",
        "75007": "KOSZALIN",
        "75008": "KOSZALIN",
        "75009": "KOSZALIN",
        "75011": "KOSZALIN",
        "75012": "KOSZALIN",
        "75013": "KOSZALIN",
        "75014": "KOSZALIN",
        "75015": "KOSZALIN",
        "75016": "KOSZALIN",
        "75017": "KOSZALIN",
        "75020": "KOSZALIN",
        "75021": "KOSZALIN",
        "75022": "KOSZALIN",
        "75023": "KOSZALIN",
        "75025": "KOSZALIN",
        "75027": "KOSZALIN",
        "75028": "KOSZALIN",
        "75029": "KOSZALIN",
        "75031": "KOSZALIN",
        "75032": "KOSZALIN",
        "75033": "KOSZALIN",
        "75034": "KOSZALIN",
        "75035": "KOSZALIN",
        "75036": "KOSZALIN",
        "75037": "KOSZALIN",
        "75038": "KOSZALIN",
        "75039": "KOSZALIN",
        "75041": "KOSZALIN",
        "75042": "KOSZALIN",
        "75050": "KOSZALIN",
        "75051": "KOSZALIN",
        "75052": "KOSZALIN",
        "75053": "KOSZALIN",
        "75054": "KOSZALIN",
        "75055": "KOSZALIN",
        "75056": "KOSZALIN",
        "75057": "KOSZALIN",
        "75058": "KOSZALIN",
        "75059": "KOSZALIN",
        "75061": "KOSZALIN",
        "75062": "KOSZALIN",
        "75063": "KOSZALIN",
        "75064": "KOSZALIN",
        "75065": "KOSZALIN",
        "75070": "KOSZALIN",
        "75072": "KOSZALIN",
        "75073": "KOSZALIN",
        "75074": "KOSZALIN",
        "75075": "KOSZALIN",
        "75076": "KOSZALIN",
        "75077": "KOSZALIN",
        "75078": "KOSZALIN",
        "75079": "KOSZALIN",
        "75081": "KOSZALIN",
        "75100": "KOSZALIN",
        "75102": "KOSZALIN",
        "75103": "KOSZALIN",
        "75104": "KOSZALIN",
        "75105": "KOSZALIN",
        "75106": "KOSZALIN",
        "75107": "KOSZALIN",
        "75108": "KOSZALIN",
        "75109": "KOSZALIN",
        "75111": "KOSZALIN",
        "75112": "KOSZALIN",
        "75113": "KOSZALIN",
        "75120": "KOSZALIN",
        "75121": "KOSZALIN",
        "75122": "KOSZALIN",
        "75123": "KOSZALIN",
        "75124": "KOSZALIN",
        "75125": "KOSZALIN",
        "75126": "KOSZALIN",
        "75127": "KOSZALIN",
        "75128": "KOSZALIN",
        "75129": "KOSZALIN",
        "75130": "KOSZALIN",
        "75131": "KOSZALIN",
        "75132": "KOSZALIN",
        "75134": "KOSZALIN",
        "75135": "KOSZALIN",
        "75136": "KOSZALIN",
        "75137": "KOSZALIN",
        "75200": "KOSZALIN",
        "75201": "KOSZALIN",
        "75202": "KOSZALIN",
        "75203": "KOSZALIN",
        "75204": "KOSZALIN",
        "75205": "KOSZALIN",
        "75206": "KOSZALIN",
        "75207": "KOSZALIN",
        "75208": "KOSZALIN",
        "75209": "KOSZALIN",
        "75210": "KOSZALIN",
        "75211": "KOSZALIN",
        "75212": "KOSZALIN",
        "75213": "KOSZALIN",
        "75215": "KOSZALIN",
        "75216": "KOSZALIN",
        "75217": "KOSZALIN",
        "75218": "KOSZALIN",
        "75219": "KOSZALIN",
        "75220": "KOSZALIN",
        "75221": "KOSZALIN",
        "75222": "KOSZALIN",
        "75223": "KOSZALIN",
        "75224": "KOSZALIN",
        "75225": "KOSZALIN",
        "75226": "KOSZALIN",
        "75227": "KOSZALIN",
        "75228": "KOSZALIN",
        "75229": "KOSZALIN",
        "75230": "KOSZALIN",
        "75232": "KOSZALIN",
        "75233": "KOSZALIN",
        "75234": "KOSZALIN",
        "75235": "KOSZALIN",
        "75236": "KOSZALIN",
        "75237": "KOSZALIN",
        "75238": "KOSZALIN",
        "75239": "KOSZALIN",
        "75240": "KOSZALIN",
        "75241": "KOSZALIN",
        "75242": "KOSZALIN",
        "75243": "KOSZALIN",
        "75244": "KOSZALIN",
        "75245": "KOSZALIN",
        "75246": "KOSZALIN",
        "75247": "KOSZALIN",
        "75249": "KOSZALIN",
        "75250": "KOSZALIN",
        "75251": "KOSZALIN",
        "75252": "KOSZALIN",
        "75253": "KOSZALIN",
        "75254": "KOSZALIN",
        "75255": "KOSZALIN",
        "75256": "KOSZALIN",
        "75257": "KOSZALIN",
        "75300": "KOSZALIN",
        "75301": "KOSZALIN",
        "75302": "KOSZALIN",
        "75303": "KOSZALIN",
        "75304": "KOSZALIN",
        "75305": "KOSZALIN",
        "75306": "KOSZALIN",
        "75307": "KOSZALIN",
        "75308": "KOSZALIN",
        "75309": "KOSZALIN",
        "75310": "KOSZALIN",
        "75311": "KOSZALIN",
        "75312": "KOSZALIN",
        "75313": "KOSZALIN",
        "75319": "KOSZALIN",
        "75320": "KOSZALIN",
        "75321": "KOSZALIN",
        "75322": "KOSZALIN",
        "75323": "KOSZALIN",
        "75324": "KOSZALIN",
        "75325": "KOSZALIN",
        "75326": "KOSZALIN",
        "75327": "KOSZALIN",
        "75328": "KOSZALIN",
        "75329": "KOSZALIN",
        "75330": "KOSZALIN",
        "75331": "KOSZALIN",
        "75332": "KOSZALIN",
        "75333": "KOSZALIN",
        "75334": "KOSZALIN",
        "75335": "KOSZALIN",
        "75336": "KOSZALIN",
        "75337": "KOSZALIN",
        "75338": "KOSZALIN",
        "75339": "KOSZALIN",
        "75340": "KOSZALIN",
        "75341": "KOSZALIN",
        "75342": "KOSZALIN",
        "75343": "KOSZALIN",
        "75344": "KOSZALIN",
        "75345": "KOSZALIN",
        "75346": "KOSZALIN",
        "75347": "KOSZALIN",
        "75348": "KOSZALIN",
        "75349": "KOSZALIN",
        "75350": "KOSZALIN",
        "75351": "KOSZALIN",
        "75352": "KOSZALIN",
        "75353": "KOSZALIN",
        "75354": "KOSZALIN",
        "75355": "KOSZALIN",
        "75356": "KOSZALIN",
        "75357": "KOSZALIN",
        "75358": "KOSZALIN",
        "75359": "KOSZALIN",
        "75360": "KOSZALIN",
        "75361": "KOSZALIN",
        "75362": "KOSZALIN",
        "75363": "KOSZALIN",
        "75364": "KOSZALIN",
        "75365": "KOSZALIN",
        "75366": "KOSZALIN",
        "75367": "KOSZALIN",
        "75368": "KOSZALIN",
        "75369": "KOSZALIN",
        "75370": "KOSZALIN",
        "75371": "KOSZALIN",
        "75372": "KOSZALIN",
        "75373": "KOSZALIN",
        "75374": "KOSZALIN",
        "75375": "KOSZALIN",
        "75376": "KOSZALIN",
        "75377": "KOSZALIN",
        "75378": "KOSZALIN",
        "75379": "KOSZALIN",
        "75380": "KOSZALIN",
        "75381": "KOSZALIN",
        "75382": "KOSZALIN",
        "75383": "KOSZALIN",
        "75384": "KOSZALIN",
        "75385": "KOSZALIN",
        "75386": "KOSZALIN",
        "75388": "KOSZALIN",
        "75389": "KOSZALIN",
        "75390": "KOSZALIN",
        "75391": "KOSZALIN",
        "75392": "KOSZALIN",
        "75393": "KOSZALIN",
        "75394": "KOSZALIN",
        "75395": "KOSZALIN",
        "75396": "KOSZALIN",
        "75397": "KOSZALIN",
        "75398": "KOSZALIN",
        "75399": "KOSZALIN",
        "75400": "KOSZALIN",
        "75401": "KOSZALIN",
        "75402": "KOSZALIN",
        "75403": "KOSZALIN",
        "75404": "KOSZALIN",
        "75405": "KOSZALIN",
        "75406": "KOSZALIN",
        "75407": "KOSZALIN",
        "75408": "KOSZALIN",
        "75409": "KOSZALIN",
        "75410": "KOSZALIN",
        "75411": "KOSZALIN",
        "75412": "KOSZALIN",
        "75413": "KOSZALIN",
        "75414": "KOSZALIN",
        "75415": "KOSZALIN",
        "75420": "KOSZALIN",
        "75421": "KOSZALIN",
        "75422": "KOSZALIN",
        "75423": "KOSZALIN",
        "75424": "KOSZALIN",
        "75425": "KOSZALIN",
        "75426": "KOSZALIN",
        "75427": "KOSZALIN",
        "75428": "KOSZALIN",
        "75429": "KOSZALIN",
        "75430": "KOSZALIN",
        "75431": "KOSZALIN",
        "75432": "KOSZALIN",
        "75433": "KOSZALIN",
        "75434": "KOSZALIN",
        "75435": "KOSZALIN",
        "75436": "KOSZALIN",
        "75437": "KOSZALIN",
        "75438": "KOSZALIN",
        "75440": "KOSZALIN",
        "75441": "KOSZALIN",
        "75442": "KOSZALIN",
        "75443": "KOSZALIN",
        "75444": "KOSZALIN",
        "75445": "KOSZALIN",
        "75446": "KOSZALIN",
        "75447": "KOSZALIN",
        "75448": "KOSZALIN",
        "75449": "KOSZALIN",
        "75450": "KOSZALIN",
        "75451": "KOSZALIN",
        "75452": "KOSZALIN",
        "75453": "KOSZALIN",
        "75454": "KOSZALIN",
        "75455": "KOSZALIN",
        "75500": "KOSZALIN",
        "75501": "KOSZALIN",
        "75502": "KOSZALIN",
        "75503": "KOSZALIN",
        "75504": "KOSZALIN",
        "75505": "KOSZALIN",
        "75506": "KOSZALIN",
        "75507": "KOSZALIN",
        "75508": "KOSZALIN",
        "75509": "KOSZALIN",
        "75511": "KOSZALIN",
        "75512": "KOSZALIN",
        "75519": "KOSZALIN",
        "75520": "KOSZALIN",
        "75521": "KOSZALIN",
        "75522": "KOSZALIN",
        "75523": "KOSZALIN",
        "75524": "KOSZALIN",
        "75525": "KOSZALIN",
        "75526": "KOSZALIN",
        "75527": "KOSZALIN",
        "75528": "KOSZALIN",
        "75529": "KOSZALIN",
        "75531": "KOSZALIN",
        "75540": "KOSZALIN",
        "75541": "KOSZALIN",
        "75542": "KOSZALIN",
        "75543": "KOSZALIN",
        "75544": "KOSZALIN",
        "75545": "KOSZALIN",
        "75546": "KOSZALIN",
        "75547": "KOSZALIN",
        "75548": "KOSZALIN",
        "75549": "KOSZALIN",
        "75551": "KOSZALIN",
        "75552": "KOSZALIN",
        "75553": "KOSZALIN",
        "75554": "KOSZALIN",
        "75555": "KOSZALIN",
        "75556": "KOSZALIN",
        "75557": "KOSZALIN",
        "75558": "KOSZALIN",
        "75560": "KOSZALIN",
        "75561": "KOSZALIN",
        "75562": "KOSZALIN",
        "75563": "KOSZALIN",
        "75564": "KOSZALIN",
        "75565": "KOSZALIN",
        "75566": "KOSZALIN",
        "75567": "KOSZALIN",
        "75568": "KOSZALIN",
        "75569": "KOSZALIN",
        "75571": "KOSZALIN",
        "75572": "KOSZALIN",
        "75573": "KOSZALIN",
        "75574": "KOSZALIN",
        "75575": "KOSZALIN",
        "75576": "KOSZALIN",
        "75577": "KOSZALIN",
        "75578": "KOSZALIN",
        "75579": "KOSZALIN",
        "75580": "KOSZALIN",
        "75581": "KOSZALIN",
        "75582": "KOSZALIN",
        "75583": "KOSZALIN",
        "75584": "KOSZALIN",
        "75585": "KOSZALIN",
        "75586": "KOSZALIN",
        "75587": "KOSZALIN",
        "75588": "KOSZALIN",
        "75589": "KOSZALIN",
        "75590": "KOSZALIN",
        "75600": "KOSZALIN",
        "75601": "KOSZALIN",
        "75602": "KOSZALIN",
        "75603": "KOSZALIN",
        "75604": "KOSZALIN",
        "75605": "KOSZALIN",
        "75606": "KOSZALIN",
        "75607": "KOSZALIN",
        "75608": "KOSZALIN",
        "75609": "KOSZALIN",
        "75610": "KOSZALIN",
        "75611": "KOSZALIN",
        "75612": "KOSZALIN",
        "75613": "KOSZALIN",
        "75614": "KOSZALIN",
        "75615": "KOSZALIN",
        "75616": "KOSZALIN",
        "75617": "KOSZALIN",
        "75620": "KOSZALIN",
        "75621": "KOSZALIN",
        "75622": "KOSZALIN",
        "75623": "KOSZALIN",
        "75625": "KOSZALIN",
        "75626": "KOSZALIN",
        "75627": "KOSZALIN",
        "75628": "KOSZALIN",
        "75629": "KOSZALIN",
        "75630": "KOSZALIN",
        "75631": "KOSZALIN",
        "75632": "KOSZALIN",
        "75633": "KOSZALIN",
        "75634": "KOSZALIN",
        "75635": "KOSZALIN",
        "75636": "KOSZALIN",
        "75637": "KOSZALIN",
        "75638": "KOSZALIN",
        "75639": "KOSZALIN",
        "75640": "KOSZALIN",
        "75641": "KOSZALIN",
        "75642": "KOSZALIN",
        "75643": "KOSZALIN",
        "75644": "KOSZALIN",
        "75645": "KOSZALIN",
        "75646": "KOSZALIN",
        "75647": "KOSZALIN",
        "75648": "KOSZALIN",
        "75649": "KOSZALIN",
        "75650": "KOSZALIN",
        "75651": "KOSZALIN",
        "75652": "KOSZALIN",
        "75653": "KOSZALIN",
        "75654": "KOSZALIN",
        "75655": "KOSZALIN",
        "75656": "KOSZALIN",
        "75657": "KOSZALIN",
        "75658": "KOSZALIN",
        "75659": "KOSZALIN",
        "75660": "KOSZALIN",
        "75661": "KOSZALIN",
        "75662": "KOSZALIN",
        "75663": "KOSZALIN",
        "75664": "KOSZALIN",
        "75665": "KOSZALIN",
        "75666": "KOSZALIN",
        "75667": "KOSZALIN",
        "75668": "KOSZALIN",
        "75669": "KOSZALIN",
        "75670": "KOSZALIN",
        "75671": "KOSZALIN",
        "75672": "KOSZALIN",
        "75673": "KOSZALIN",
        "75674": "KOSZALIN",
        "75675": "KOSZALIN",
        "75676": "KOSZALIN",
        "75677": "KOSZALIN",
        "75678": "KOSZALIN",
        "75679": "KOSZALIN",
        "75680": "KOSZALIN",
        "75681": "KOSZALIN",
        "75682": "KOSZALIN",
        "75683": "KOSZALIN",
        "75684": "KOSZALIN",
        "75685": "KOSZALIN",
        "75686": "KOSZALIN",
        "75687": "KOSZALIN",
        "75688": "KOSZALIN",
        "75689": "KOSZALIN",
        "75690": "KOSZALIN",
        "75691": "KOSZALIN",
        "75692": "KOSZALIN",
        "75693": "KOSZALIN",
        "75694": "KOSZALIN",
        "75695": "KOSZALIN",
        "75696": "KOSZALIN",
        "75697": "KOSZALIN",
        "75698": "KOSZALIN",
        "75699": "KOSZALIN",
        "75700": "KOSZALIN",
        "75701": "KOSZALIN",
        "75702": "KOSZALIN",
        "75703": "KOSZALIN",
        "75704": "KOSZALIN",
        "75705": "KOSZALIN",
        "75706": "KOSZALIN",
        "75707": "KOSZALIN",
        "75708": "KOSZALIN",
        "75709": "KOSZALIN",
        "75710": "KOSZALIN",
        "75711": "KOSZALIN",
        "75712": "KOSZALIN",
        "75713": "KOSZALIN",
        "75714": "KOSZALIN",
        "75715": "KOSZALIN",
        "75716": "KOSZALIN",
        "75717": "KOSZALIN",
        "75718": "KOSZALIN",
        "75719": "KOSZALIN",
        "75720": "KOSZALIN",
        "75721": "KOSZALIN",
        "75722": "KOSZALIN",
        "75723": "KOSZALIN",
        "75724": "KOSZALIN",
        "75726": "KOSZALIN",
        "75727": "KOSZALIN",
        "75728": "KOSZALIN",
        "75729": "KOSZALIN",
        "75731": "KOSZALIN",
        "75732": "KOSZALIN",
        "75733": "KOSZALIN",
        "75734": "KOSZALIN",
        "75736": "KOSZALIN",
        "75737": "KOSZALIN",
        "75738": "KOSZALIN",
        "75800": "KOSZALIN",
        "75801": "KOSZALIN",
        "75802": "KOSZALIN",
        "75803": "KOSZALIN",
        "75804": "KOSZALIN",
        "75805": "KOSZALIN",
        "75806": "KOSZALIN",
        "75807": "KOSZALIN",
        "75808": "KOSZALIN",
        "75809": "KOSZALIN",
        "75810": "KOSZALIN",
        "75811": "KOSZALIN",
        "75812": "KOSZALIN",
        "75813": "KOSZALIN",
        "75814": "KOSZALIN",
        "75815": "KOSZALIN",
        "75816": "KOSZALIN",
        "75817": "KOSZALIN",
        "75818": "KOSZALIN",
        "75819": "KOSZALIN",
        "75820": "KOSZALIN",
        "75821": "KOSZALIN",
        "75823": "KOSZALIN",
        "75824": "KOSZALIN",
        "75825": "KOSZALIN",
        "75826": "KOSZALIN",
        "75827": "KOSZALIN",
        "75828": "KOSZALIN",
        "75829": "KOSZALIN",
        "75831": "KOSZALIN",
        "75832": "KOSZALIN",
        "75833": "KOSZALIN",
        "75834": "KOSZALIN",
        "75835": "KOSZALIN",
        "75836": "KOSZALIN",
        "75837": "KOSZALIN",
        "75838": "KOSZALIN",
        "75839": "KOSZALIN",
        "75840": "KOSZALIN",
        "75841": "KOSZALIN",
        "75842": "KOSZALIN",
        "75843": "KOSZALIN",
        "75844": "KOSZALIN",
        "75845": "KOSZALIN",
        "75846": "KOSZALIN",
        "75847": "KOSZALIN",
        "75848": "KOSZALIN",
        "75849": "KOSZALIN",
        "75850": "KOSZALIN",
        "75851": "KOSZALIN",
        "75852": "KOSZALIN",
        "75900": "KOSZALIN",
        "75901": "KOSZALIN",
        "75903": "KOSZALIN",
        "76002": "KOSZALIN",
        "76003": "KOSZALIN",
        "76004": "KOSZALIN",
        "76006": "KOSZALIN",
        "76009": "KOSZALIN",
        "76010": "KOSZALIN",
        "76012": "KOSZALIN",
        "76015": "KOSZALIN",
        "76020": "KOSZALIN",
        "76021": "KOSZALIN",
        "76022": "KOSZALIN",
        "76023": "BIAŁOGARD",
        "76024": "KOSZALIN",
        "76031": "KOSZALIN",
        "76032": "KOSZALIN",
        "76034": "KOSZALIN",
        "76035": "KOSZALIN",
        "76036": "KOSZALIN",
        "76037": "KOSZALIN",
        "76038": "KOSZALIN",
        "76039": "KOSZALIN",
        "76042": "KOSZALIN",
        "76066": "KOSZALIN",
        "76100": "SŁAWNO",
        "76101": "SŁAWNO",
        "76102": "SŁAWNO",
        "76104": "SŁAWNO",
        "76106": "SŁAWNO",
        "76107": "SŁAWNO",
        "76113": "SŁAWNO",
        "76121": "SŁAWNO",
        "76122": "SŁAWNO",
        "76123": "SŁAWNO",
        "76124": "SŁAWNO",
        "76125": "KOSZALIN",
        "76129": "SŁAWNO",
        "76141": "SŁAWNO",
        "76142": "SŁAWNO",
        "76144": "SŁAWNO",
        "76150": "DARŁOWO",
        "76153": "DARŁOWO",
        "76154": "SŁAWNO",
        "76156": "SŁAWNO",
        "76200": "SŁUPSK",
        "76201": "SŁUPSK",
        "76202": "SŁUPSK",
        "76203": "SŁUPSK",
        "76204": "SŁUPSK",
        "76205": "SŁUPSK",
        "76206": "SŁUPSK",
        "76207": "SŁUPSK",
        "76208": "SŁUPSK",
        "76209": "SŁUPSK",
        "76210": "SŁUPSK",
        "76211": "SŁUPSK",
        "76212": "SŁUPSK",
        "76213": "SŁUPSK",
        "76214": "SŁUPSK",
        "76215": "SŁUPSK",
        "76216": "SŁUPSK",
        "76217": "SŁUPSK",
        "76218": "SŁUPSK",
        "76219": "SŁUPSK",
        "76220": "SŁUPSK",
        "76230": "SŁUPSK",
        "76231": "SŁUPSK",
        "76242": "SŁUPSK",
        "76243": "BYTÓW",
        "76245": "SŁUPSK",
        "76246": "SŁUPSK",
        "76248": "SŁUPSK",
        "76251": "SŁUPSK",
        "76252": "SŁUPSK",
        "76256": "SŁUPSK",
        "76270": "SŁUPSK",
        "76271": "SŁUPSK",
        "76272": "SŁUPSK",
        "76273": "SŁUPSK",
        "76274": "SŁUPSK",
        "76280": "SŁUPSK",
        "77100": "BYTÓW",
        "77101": "BYTÓW",
        "77102": "BYTÓW",
        "77112": "SŁUPSK",
        "77113": "SŁUPSK",
        "77114": "BYTÓW",
        "77115": "BYTÓW",
        "77116": "BYTÓW",
        "77121": "BYTÓW",
        "77122": "BYTÓW",
        "77123": "BYTÓW",
        "77124": "BYTÓW",
        "77125": "BYTÓW",
        "77127": "BYTÓW",
        "77130": "BYTÓW",
        "77131": "BYTÓW",
        "77132": "BYTÓW",
        "77133": "BYTÓW",
        "77134": "BYTÓW",
        "77135": "BYTÓW",
        "77138": "BYTÓW",
        "77139": "BYTÓW",
        "77140": "BYTÓW",
        "77141": "BYTÓW",
        "77142": "BYTÓW",
        "77143": "BYTÓW",
        "77200": "BYTÓW",
        "77201": "BYTÓW",
        "77203": "BYTÓW",
        "77205": "BYTÓW",
        "77207": "BYTÓW",
        "77208": "CZŁUCHÓW",
        "77211": "BYTÓW",
        "77220": "CZŁUCHÓW",
        "77222": "BYTÓW",
        "77223": "SŁUPSK",
        "77224": "SŁUPSK",
        "77230": "SŁUPSK",
        "77231": "SŁUPSK",
        "77232": "SŁUPSK",
        "77233": "BYTÓW",
        "77235": "BYTÓW",
        "77300": "CZŁUCHÓW",
        "77301": "CZŁUCHÓW",
        "77302": "CZŁUCHÓW",
        "77304": "RZECZENICA",
        "77306": "CZŁUCHÓW",
        "77310": "CZŁUCHÓW",
        "77311": "CZŁUCHÓW",
        "77314": "CZŁUCHÓW",
        "77317": "CZŁUCHÓW",
        "77318": "CZŁUCHÓW",
        "77320": "CZŁUCHÓW",
        "77323": "CZŁUCHÓW",
        "77324": "CZŁUCHÓW",
        "77326": "CZŁUCHÓW",
        "77330": "CZARNE",
        "77400": "ZŁOTÓW",
        "77404": "ZŁOTÓW",
        "77405": "ZŁOTÓW",
        "77411": "ZŁOTÓW",
        "77413": "ZŁOTÓW",
        "77414": "ZŁOTÓW",
        "77415": "ZŁOTÓW",
        "77416": "ZŁOTÓW",
        "77420": "ZŁOTÓW",
        "77424": "ZŁOTÓW",
        "77430": "ZŁOTÓW",
        "78100": "KOŁOBRZEG",
        "78101": "KOŁOBRZEG",
        "78102": "KOŁOBRZEG",
        "78103": "KOŁOBRZEG",
        "78104": "KOŁOBRZEG",
        "78105": "KOŁOBRZEG",
        "78106": "KOŁOBRZEG",
        "78111": "KOŁOBRZEG",
        "78112": "KOŁOBRZEG",
        "78113": "KOŁOBRZEG",
        "78114": "KOŁOBRZEG",
        "78120": "KOŁOBRZEG",
        "78121": "KOŁOBRZEG",
        "78122": "KOŁOBRZEG",
        "78123": "KOŁOBRZEG",
        "78124": "KOŁOBRZEG",
        "78125": "KOŁOBRZEG",
        "78131": "KOŁOBRZEG",
        "78132": "KOŁOBRZEG",
        "78133": "KOŁOBRZEG",
        "78200": "BIAŁOGARD",
        "78201": "BIAŁOGARD",
        "78202": "BIAŁOGARD",
        "78210": "BIAŁOGARD",
        "78211": "BIAŁOGARD",
        "78214": "BIAŁOGARD",
        "78217": "BIAŁOGARD",
        "78220": "BIAŁOGARD",
        "78221": "BIAŁOGARD",
        "78230": "BIAŁOGARD",
        "78300": "ŚWIDWIN",
        "78301": "ŚWIDWIN",
        "78311": "ŚWIDWIN",
        "78312": "ŚWIDWIN",
        "78314": "ŚWIDWIN",
        "78316": "ŚWIDWIN",
        "78320": "POŁCZYN-ZDRÓJ",
        "78321": "ŚWIDWIN",
        "78324": "ŚWIDWIN",
        "78325": "ŚWIDWIN",
        "78326": "ŚWIDWIN",
        "78327": "ŚWIDWIN",
        "78331": "ŚWIDWIN",
        "78332": "ŚWIDWIN",
        "78333": "ŚWIDWIN",
        "78334": "ŚWIDWIN",
        "78336": "ŚWIDWIN",
        "78400": "SZCZECINEK",
        "78401": "SZCZECINEK",
        "78402": "SZCZECINEK",
        "78403": "SZCZECINEK",
        "78404": "SZCZECINEK",
        "78405": "SZCZECINEK",
        "78410": "SZCZECINEK",
        "78411": "SZCZECINEK",
        "78412": "SZCZECINEK",
        "78421": "SZCZECINEK",
        "78422": "SZCZECINEK",
        "78423": "SZCZECINEK",
        "78425": "BIAŁY BÓR",
        "78426": "SZCZECINEK",
        "78431": "SZCZECINEK",
        "78444": "SZCZECINEK",
        "78445": "SZCZECINEK",
        "78446": "SZCZECINEK",
        "78447": "SZCZECINEK",
        "78449": "SZCZECINEK",
        "78450": "SZCZECINEK",
        "78451": "SZCZECINEK",
        "78452": "SZCZECINEK",
        "78460": "SZCZECINEK",
        "78461": "SZCZECINEK",
        "78500": "DRAWSKO POMORSKIE",
        "78504": "DRAWSKO POMORSKIE",
        "78506": "DRAWSKO POMORSKIE",
        "78512": "DRAWSKO POMORSKIE",
        "78513": "DRAWSKO POMORSKIE",
        "78520": "ZŁOCIENIEC",
        "78523": "DRAWSKO POMORSKIE",
        "78524": "ZŁOCIENIEC",
        "78525": "DRAWSKO POMORSKIE",
        "78529": "DRAWSKO POMORSKIE",
        "78530": "DRAWSKO POMORSKIE",
        "78531": "DRAWSKO POMORSKIE",
        "78540": "DRAWSKO POMORSKIE",
        "78550": "DRAWSKO POMORSKIE",
        "78551": "DRAWSKO POMORSKIE",
        "78552": "DRAWSKO POMORSKIE",
        "78553": "DRAWSKO POMORSKIE",
        "78600": "WAŁCZ",
        "78601": "WAŁCZ",
        "78603": "WAŁCZ",
        "78604": "WAŁCZ",
        "78607": "WAŁCZ",
        "78609": "WAŁCZ",
        "78611": "DRAWSKO POMORSKIE",
        "78627": "WAŁCZ",
        "78630": "WAŁCZ",
        "78640": "WAŁCZ",
        "78641": "WAŁCZ",
        "78642": "WAŁCZ",
        "78650": "WAŁCZ",
        "78651": "WAŁCZ",
        "78652": "WAŁCZ",
        "80001": "GDAŃSK",
        "80003": "GDAŃSK",
        "80007": "GDAŃSK",
        "80008": "GDAŃSK",
        "80009": "GDAŃSK",
        "80010": "GDAŃSK",
        "80011": "GDAŃSK",
        "80012": "GDAŃSK",
        "80013": "GDAŃSK",
        "80014": "GDAŃSK",
        "80016": "GDAŃSK",
        "80017": "GDAŃSK",
        "80018": "GDAŃSK",
        "80019": "GDAŃSK",
        "80020": "GDAŃSK",
        "80021": "GDAŃSK",
        "80022": "GDAŃSK",
        "80024": "GDAŃSK",
        "80025": "GDAŃSK",
        "80026": "GDAŃSK",
        "80027": "GDAŃSK",
        "80028": "GDAŃSK",
        "80029": "GDAŃSK",
        "80030": "GDAŃSK",
        "80031": "GDAŃSK",
        "80032": "GDAŃSK",
        "80033": "GDAŃSK",
        "80034": "GDAŃSK",
        "80035": "GDAŃSK",
        "80036": "GDAŃSK",
        "80037": "GDAŃSK",
        "80038": "GDAŃSK",
        "80039": "GDAŃSK",
        "80041": "GDAŃSK",
        "80042": "GDAŃSK",
        "80043": "GDAŃSK",
        "80044": "GDAŃSK",
        "80045": "GDAŃSK",
        "80046": "GDAŃSK",
        "80047": "GDAŃSK",
        "80048": "GDAŃSK",
        "80049": "GDAŃSK",
        "80050": "GDAŃSK",
        "80051": "GDAŃSK",
        "80052": "GDAŃSK",
        "80053": "GDAŃSK",
        "80054": "GDAŃSK",
        "80055": "GDAŃSK",
        "80056": "GDAŃSK",
        "80057": "GDAŃSK",
        "80058": "GDAŃSK",
        "80059": "GDAŃSK",
        "80060": "GDAŃSK",
        "80061": "GDAŃSK",
        "80062": "GDAŃSK",
        "80063": "GDAŃSK",
        "80064": "GDAŃSK",
        "80065": "GDAŃSK",
        "80066": "GDAŃSK",
        "80067": "GDAŃSK",
        "80068": "GDAŃSK",
        "80069": "GDAŃSK",
        "80070": "GDAŃSK",
        "80071": "GDAŃSK",
        "80073": "GDAŃSK",
        "80074": "GDAŃSK",
        "80075": "GDAŃSK",
        "80076": "GDAŃSK",
        "80077": "GDAŃSK",
        "80078": "GDAŃSK",
        "80097": "GDAŃSK",
        "80103": "GDAŃSK",
        "80104": "GDAŃSK",
        "80105": "GDAŃSK",
        "80107": "GDAŃSK",
        "80108": "GDAŃSK",
        "80110": "GDAŃSK",
        "80111": "GDAŃSK",
        "80112": "GDAŃSK",
        "80113": "GDAŃSK",
        "80114": "GDAŃSK",
        "80115": "GDAŃSK",
        "80116": "GDAŃSK",
        "80117": "GDAŃSK",
        "80118": "GDAŃSK",
        "80119": "GDAŃSK",
        "80120": "GDAŃSK",
        "80121": "GDAŃSK",
        "80122": "GDAŃSK",
        "80123": "GDAŃSK",
        "80124": "GDAŃSK",
        "80125": "GDAŃSK",
        "80126": "GDAŃSK",
        "80127": "GDAŃSK",
        "80128": "GDAŃSK",
        "80129": "GDAŃSK",
        "80130": "GDAŃSK",
        "80132": "GDAŃSK",
        "80133": "GDAŃSK",
        "80134": "GDAŃSK",
        "80135": "GDAŃSK",
        "80136": "GDAŃSK",
        "80137": "GDAŃSK",
        "80138": "GDAŃSK",
        "80139": "GDAŃSK",
        "80140": "GDAŃSK",
        "80141": "GDAŃSK",
        "80142": "GDAŃSK",
        "80143": "GDAŃSK",
        "80145": "GDAŃSK",
        "80146": "GDAŃSK",
        "80147": "GDAŃSK",
        "80148": "GDAŃSK",
        "80150": "GDAŃSK",
        "80151": "GDAŃSK",
        "80152": "GDAŃSK",
        "80153": "GDAŃSK",
        "80154": "GDAŃSK",
        "80155": "GDAŃSK",
        "80156": "GDAŃSK",
        "80158": "GDAŃSK",
        "80163": "GDAŃSK",
        "80165": "GDAŃSK",
        "80169": "GDAŃSK",
        "80170": "GDAŃSK",
        "80171": "GDAŃSK",
        "80172": "GDAŃSK",
        "80174": "GDAŃSK",
        "80175": "GDAŃSK",
        "80176": "GDAŃSK",
        "80177": "GDAŃSK",
        "80178": "GDAŃSK",
        "80180": "GDAŃSK",
        "80190": "GDAŃSK",
        "80201": "GDAŃSK",
        "80202": "GDAŃSK",
        "80203": "GDAŃSK",
        "80204": "GDAŃSK",
        "80205": "GDAŃSK",
        "80206": "GDAŃSK",
        "80207": "GDAŃSK",
        "80208": "GDAŃSK",
        "80209": "KARTUZY",
        "80210": "GDAŃSK",
        "80211": "GDAŃSK",
        "80212": "GDAŃSK",
        "80213": "GDAŃSK",
        "80214": "GDAŃSK",
        "80215": "GDAŃSK",
        "80216": "GDAŃSK",
        "80217": "GDAŃSK",
        "80218": "GDAŃSK",
        "80219": "GDAŃSK",
        "80221": "GDAŃSK",
        "80222": "GDAŃSK",
        "80223": "GDAŃSK",
        "80224": "GDAŃSK",
        "80225": "GDAŃSK",
        "80226": "GDAŃSK",
        "80227": "GDAŃSK",
        "80229": "GDAŃSK",
        "80230": "GDAŃSK",
        "80231": "GDAŃSK",
        "80232": "GDAŃSK",
        "80233": "GDAŃSK",
        "80234": "GDAŃSK",
        "80235": "GDAŃSK",
        "80236": "GDAŃSK",
        "80237": "GDAŃSK",
        "80238": "GDAŃSK",
        "80239": "GDAŃSK",
        "80240": "GDAŃSK",
        "80241": "GDAŃSK",
        "80242": "GDAŃSK",
        "80243": "GDAŃSK",
        "80244": "GDAŃSK",
        "80245": "GDAŃSK",
        "80246": "GDAŃSK",
        "80247": "GDAŃSK",
        "80248": "GDAŃSK",
        "80249": "GDAŃSK",
        "80250": "GDAŃSK",
        "80251": "GDAŃSK",
        "80252": "GDAŃSK",
        "80253": "GDAŃSK",
        "80254": "GDAŃSK",
        "80255": "GDAŃSK",
        "80256": "GDAŃSK",
        "80257": "GDAŃSK",
        "80258": "GDAŃSK",
        "80259": "GDAŃSK",
        "80260": "GDAŃSK",
        "80261": "GDAŃSK",
        "80262": "GDAŃSK",
        "80264": "GDAŃSK",
        "80265": "GDAŃSK",
        "80266": "GDAŃSK",
        "80267": "GDAŃSK",
        "80268": "GDAŃSK",
        "80270": "GDAŃSK",
        "80271": "GDAŃSK",
        "80272": "GDAŃSK",
        "80273": "GDAŃSK",
        "80274": "GDAŃSK",
        "80275": "GDAŃSK",
        "80276": "GDAŃSK",
        "80277": "GDAŃSK",
        "80278": "GDAŃSK",
        "80279": "GDAŃSK",
        "80280": "GDAŃSK",
        "80281": "GDAŃSK",
        "80282": "GDAŃSK",
        "80283": "GDAŃSK",
        "80284": "GDAŃSK",
        "80285": "GDAŃSK",
        "80286": "GDAŃSK",
        "80287": "GDAŃSK",
        "80288": "GDAŃSK",
        "80289": "GDAŃSK",
        "80290": "GDAŃSK",
        "80291": "GDAŃSK",
        "80292": "GDAŃSK",
        "80293": "GDAŃSK",
        "80294": "GDAŃSK",
        "80296": "GDAŃSK",
        "80297": "KARTUZY",
        "80298": "GDAŃSK",
        "80299": "GDAŃSK",
        "80300": "GDAŃSK",
        "80301": "GDAŃSK",
        "80302": "GDAŃSK",
        "80303": "GDAŃSK",
        "80304": "GDAŃSK",
        "80305": "GDAŃSK",
        "80306": "GDAŃSK",
        "80307": "GDAŃSK",
        "80308": "GDAŃSK",
        "80309": "GDAŃSK",
        "80310": "GDAŃSK",
        "80311": "GDAŃSK",
        "80312": "GDAŃSK",
        "80313": "GDAŃSK",
        "80314": "GDAŃSK",
        "80315": "GDAŃSK",
        "80316": "GDAŃSK",
        "80317": "GDAŃSK",
        "80318": "GDAŃSK",
        "80319": "GDAŃSK",
        "80320": "GDAŃSK",
        "80321": "GDAŃSK",
        "80322": "GDAŃSK",
        "80323": "GDAŃSK",
        "80324": "GDAŃSK",
        "80325": "GDAŃSK",
        "80326": "GDAŃSK",
        "80327": "GDAŃSK",
        "80328": "GDAŃSK",
        "80329": "GDAŃSK",
        "80330": "GDAŃSK",
        "80331": "GDAŃSK",
        "80332": "GDAŃSK",
        "80333": "GDAŃSK",
        "80334": "GDAŃSK",
        "80335": "GDAŃSK",
        "80336": "GDAŃSK",
        "80337": "GDAŃSK",
        "80338": "GDAŃSK",
        "80339": "GDAŃSK",
        "80340": "GDAŃSK",
        "80341": "GDAŃSK",
        "80342": "GDAŃSK",
        "80343": "GDAŃSK",
        "80344": "GDAŃSK",
        "80345": "GDAŃSK",
        "80346": "GDAŃSK",
        "80347": "GDAŃSK",
        "80348": "GDAŃSK",
        "80349": "GDAŃSK",
        "80350": "GDAŃSK",
        "80351": "GDAŃSK",
        "80352": "GDAŃSK",
        "80353": "GDAŃSK",
        "80354": "GDAŃSK",
        "80355": "GDAŃSK",
        "80356": "GDAŃSK",
        "80357": "GDAŃSK",
        "80358": "GDAŃSK",
        "80359": "GDAŃSK",
        "80360": "GDAŃSK",
        "80361": "GDAŃSK",
        "80362": "GDAŃSK",
        "80363": "GDAŃSK",
        "80364": "GDAŃSK",
        "80365": "GDAŃSK",
        "80366": "GDAŃSK",
        "80367": "GDAŃSK",
        "80368": "GDAŃSK",
        "80369": "GDAŃSK",
        "80371": "GDAŃSK",
        "80373": "GDAŃSK",
        "80374": "GDAŃSK",
        "80375": "GDAŃSK",
        "80376": "GDAŃSK",
        "80377": "GDAŃSK",
        "80378": "GDAŃSK",
        "80379": "GDAŃSK",
        "80380": "GDAŃSK",
        "80381": "GDAŃSK",
        "80382": "GDAŃSK",
        "80383": "GDAŃSK",
        "80384": "GDAŃSK",
        "80385": "GDAŃSK",
        "80386": "GDAŃSK",
        "80387": "GDAŃSK",
        "80388": "GDAŃSK",
        "80389": "GDAŃSK",
        "80390": "GDAŃSK",
        "80391": "GDAŃSK",
        "80392": "GDAŃSK",
        "80393": "GDAŃSK",
        "80394": "GDAŃSK",
        "80395": "GDAŃSK",
        "80396": "GDAŃSK",
        "80397": "GDAŃSK",
        "80398": "GDAŃSK",
        "80399": "GDAŃSK",
        "80401": "GDAŃSK",
        "80402": "GDAŃSK",
        "80403": "GDAŃSK",
        "80404": "GDAŃSK",
        "80405": "GDAŃSK",
        "80406": "GDAŃSK",
        "80407": "GDAŃSK",
        "80408": "GDAŃSK",
        "80409": "GDAŃSK",
        "80410": "GDAŃSK",
        "80411": "GDAŃSK",
        "80412": "GDAŃSK",
        "80413": "GDAŃSK",
        "80414": "GDAŃSK",
        "80415": "GDAŃSK",
        "80416": "GDAŃSK",
        "80417": "GDAŃSK",
        "80418": "GDAŃSK",
        "80419": "GDAŃSK",
        "80420": "GDAŃSK",
        "80421": "GDAŃSK",
        "80422": "GDAŃSK",
        "80423": "GDAŃSK",
        "80424": "GDAŃSK",
        "80425": "GDAŃSK",
        "80426": "GDAŃSK",
        "80427": "GDAŃSK",
        "80430": "GDAŃSK",
        "80431": "GDAŃSK",
        "80432": "GDAŃSK",
        "80433": "GDAŃSK",
        "80434": "GDAŃSK",
        "80435": "GDAŃSK",
        "80437": "GDAŃSK",
        "80438": "GDAŃSK",
        "80440": "GDAŃSK",
        "80441": "GDAŃSK",
        "80442": "GDAŃSK",
        "80443": "GDAŃSK",
        "80444": "GDAŃSK",
        "80445": "GDAŃSK",
        "80446": "GDAŃSK",
        "80447": "GDAŃSK",
        "80448": "GDAŃSK",
        "80449": "GDAŃSK",
        "80450": "GDAŃSK",
        "80451": "GDAŃSK",
        "80452": "GDAŃSK",
        "80453": "GDAŃSK",
        "80454": "GDAŃSK",
        "80455": "GDAŃSK",
        "80456": "GDAŃSK",
        "80457": "GDAŃSK",
        "80460": "GDAŃSK",
        "80461": "GDAŃSK",
        "80462": "GDAŃSK",
        "80463": "GDAŃSK",
        "80464": "GDAŃSK",
        "80465": "GDAŃSK",
        "80466": "GDAŃSK",
        "80471": "GDAŃSK",
        "80472": "GDAŃSK",
        "80473": "GDAŃSK",
        "80501": "GDAŃSK",
        "80502": "GDAŃSK",
        "80503": "GDAŃSK",
        "80504": "GDAŃSK",
        "80506": "GDAŃSK",
        "80507": "GDAŃSK",
        "80508": "GDAŃSK",
        "80509": "GDAŃSK",
        "80510": "GDAŃSK",
        "80511": "GDAŃSK",
        "80512": "GDAŃSK",
        "80513": "GDAŃSK",
        "80514": "GDAŃSK",
        "80515": "GDAŃSK",
        "80516": "GDAŃSK",
        "80518": "GDAŃSK",
        "80519": "GDAŃSK",
        "80520": "GDAŃSK",
        "80522": "GDAŃSK",
        "80523": "GDAŃSK",
        "80524": "GDAŃSK",
        "80526": "GDAŃSK",
        "80528": "GDAŃSK",
        "80529": "GDAŃSK",
        "80530": "GDAŃSK",
        "80531": "GDAŃSK",
        "80532": "GDAŃSK",
        "80533": "GDAŃSK",
        "80534": "GDAŃSK",
        "80535": "GDAŃSK",
        "80536": "GDAŃSK",
        "80537": "GDAŃSK",
        "80538": "GDAŃSK",
        "80539": "GDAŃSK",
        "80540": "GDAŃSK",
        "80541": "GDAŃSK",
        "80542": "GDAŃSK",
        "80543": "GDAŃSK",
        "80544": "GDAŃSK",
        "80545": "GDAŃSK",
        "80546": "GDAŃSK",
        "80547": "GDAŃSK",
        "80548": "GDAŃSK",
        "80549": "GDAŃSK",
        "80550": "GDAŃSK",
        "80551": "GDAŃSK",
        "80553": "GDAŃSK",
        "80554": "GDAŃSK",
        "80555": "GDAŃSK",
        "80556": "GDAŃSK",
        "80557": "GDAŃSK",
        "80560": "GDAŃSK",
        "80561": "GDAŃSK",
        "80562": "GDAŃSK",
        "80563": "GDAŃSK",
        "80564": "GDAŃSK",
        "80600": "GDAŃSK",
        "80601": "GDAŃSK",
        "80603": "GDAŃSK",
        "80604": "GDAŃSK",
        "80605": "GDAŃSK",
        "80606": "GDAŃSK",
        "80607": "GDAŃSK",
        "80608": "GDAŃSK",
        "80609": "GDAŃSK",
        "80610": "GDAŃSK",
        "80611": "GDAŃSK",
        "80612": "GDAŃSK",
        "80613": "GDAŃSK",
        "80614": "GDAŃSK",
        "80616": "GDAŃSK",
        "80617": "GDAŃSK",
        "80618": "GDAŃSK",
        "80620": "GDAŃSK",
        "80621": "GDAŃSK",
        "80622": "GDAŃSK",
        "80623": "GDAŃSK",
        "80624": "GDAŃSK",
        "80625": "GDAŃSK",
        "80626": "GDAŃSK",
        "80627": "GDAŃSK",
        "80628": "GDAŃSK",
        "80629": "GDAŃSK",
        "80631": "GDAŃSK",
        "80632": "GDAŃSK",
        "80633": "GDAŃSK",
        "80634": "GDAŃSK",
        "80635": "GDAŃSK",
        "80636": "GDAŃSK",
        "80637": "GDAŃSK",
        "80638": "GDAŃSK",
        "80641": "GDAŃSK",
        "80642": "GDAŃSK",
        "80643": "GDAŃSK",
        "80644": "GDAŃSK",
        "80645": "GDAŃSK",
        "80646": "GDAŃSK",
        "80647": "GDAŃSK",
        "80648": "GDAŃSK",
        "80652": "GDAŃSK",
        "80653": "GDAŃSK",
        "80654": "GDAŃSK",
        "80656": "GDAŃSK",
        "80658": "GDAŃSK",
        "80660": "GDAŃSK",
        "80663": "GDAŃSK",
        "80665": "GDAŃSK",
        "80680": "GDAŃSK",
        "80690": "GDAŃSK",
        "80691": "GDAŃSK",
        "80700": "GDAŃSK",
        "80701": "GDAŃSK",
        "80702": "GDAŃSK",
        "80703": "GDAŃSK",
        "80704": "GDAŃSK",
        "80705": "GDAŃSK",
        "80706": "GDAŃSK",
        "80707": "GDAŃSK",
        "80708": "GDAŃSK",
        "80711": "GDAŃSK",
        "80715": "GDAŃSK",
        "80716": "GDAŃSK",
        "80717": "GDAŃSK",
        "80718": "GDAŃSK",
        "80719": "GDAŃSK",
        "80720": "GDAŃSK",
        "80721": "GDAŃSK",
        "80722": "GDAŃSK",
        "80723": "GDAŃSK",
        "80724": "GDAŃSK",
        "80725": "GDAŃSK",
        "80726": "GDAŃSK",
        "80727": "GDAŃSK",
        "80728": "GDAŃSK",
        "80729": "GDAŃSK",
        "80730": "GDAŃSK",
        "80731": "GDAŃSK",
        "80732": "GDAŃSK",
        "80733": "GDAŃSK",
        "80734": "GDAŃSK",
        "80735": "GDAŃSK",
        "80736": "GDAŃSK",
        "80737": "GDAŃSK",
        "80738": "GDAŃSK",
        "80739": "GDAŃSK",
        "80740": "GDAŃSK",
        "80741": "GDAŃSK",
        "80742": "GDAŃSK",
        "80743": "GDAŃSK",
        "80744": "GDAŃSK",
        "80745": "GDAŃSK",
        "80746": "GDAŃSK",
        "80747": "GDAŃSK",
        "80748": "GDAŃSK",
        "80749": "GDAŃSK",
        "80750": "GDAŃSK",
        "80751": "GDAŃSK",
        "80752": "GDAŃSK",
        "80753": "GDAŃSK",
        "80754": "GDAŃSK",
        "80755": "GDAŃSK",
        "80756": "GDAŃSK",
        "80757": "GDAŃSK",
        "80758": "GDAŃSK",
        "80759": "GDAŃSK",
        "80760": "GDAŃSK",
        "80761": "GDAŃSK",
        "80762": "GDAŃSK",
        "80763": "GDAŃSK",
        "80764": "GDAŃSK",
        "80765": "GDAŃSK",
        "80766": "GDAŃSK",
        "80767": "GDAŃSK",
        "80768": "GDAŃSK",
        "80769": "GDAŃSK",
        "80770": "GDAŃSK",
        "80771": "GDAŃSK",
        "80772": "GDAŃSK",
        "80774": "GDAŃSK",
        "80776": "GDAŃSK",
        "80777": "GDAŃSK",
        "80778": "GDAŃSK",
        "80791": "GDAŃSK",
        "80792": "GDAŃSK",
        "80800": "GDAŃSK",
        "80801": "GDAŃSK",
        "80802": "GDAŃSK",
        "80803": "GDAŃSK",
        "80804": "GDAŃSK",
        "80805": "GDAŃSK",
        "80806": "GDAŃSK",
        "80807": "GDAŃSK",
        "80808": "GDAŃSK",
        "80809": "GDAŃSK",
        "80810": "GDAŃSK",
        "80811": "GDAŃSK",
        "80812": "GDAŃSK",
        "80813": "GDAŃSK",
        "80814": "GDAŃSK",
        "80815": "GDAŃSK",
        "80817": "GDAŃSK",
        "80818": "GDAŃSK",
        "80819": "GDAŃSK",
        "80820": "GDAŃSK",
        "80821": "GDAŃSK",
        "80822": "GDAŃSK",
        "80823": "GDAŃSK",
        "80824": "GDAŃSK",
        "80825": "GDAŃSK",
        "80826": "GDAŃSK",
        "80827": "GDAŃSK",
        "80828": "GDAŃSK",
        "80830": "GDAŃSK",
        "80831": "GDAŃSK",
        "80832": "GDAŃSK",
        "80833": "GDAŃSK",
        "80834": "GDAŃSK",
        "80835": "GDAŃSK",
        "80836": "GDAŃSK",
        "80837": "GDAŃSK",
        "80838": "GDAŃSK",
        "80839": "GDAŃSK",
        "80840": "GDAŃSK",
        "80841": "GDAŃSK",
        "80842": "GDAŃSK",
        "80843": "GDAŃSK",
        "80844": "GDAŃSK",
        "80845": "GDAŃSK",
        "80846": "GDAŃSK",
        "80847": "GDAŃSK",
        "80848": "GDAŃSK",
        "80849": "GDAŃSK",
        "80850": "GDAŃSK",
        "80851": "GDAŃSK",
        "80852": "GDAŃSK",
        "80853": "GDAŃSK",
        "80854": "GDAŃSK",
        "80855": "GDAŃSK",
        "80856": "GDAŃSK",
        "80857": "GDAŃSK",
        "80858": "GDAŃSK",
        "80859": "GDAŃSK",
        "80860": "GDAŃSK",
        "80861": "GDAŃSK",
        "80862": "GDAŃSK",
        "80863": "GDAŃSK",
        "80864": "GDAŃSK",
        "80865": "GDAŃSK",
        "80866": "GDAŃSK",
        "80867": "GDAŃSK",
        "80868": "GDAŃSK",
        "80869": "GDAŃSK",
        "80870": "GDAŃSK",
        "80871": "GDAŃSK",
        "80873": "GDAŃSK",
        "80874": "GDAŃSK",
        "80875": "GDAŃSK",
        "80876": "GDAŃSK",
        "80877": "GDAŃSK",
        "80878": "GDAŃSK",
        "80880": "GDAŃSK",
        "80881": "GDAŃSK",
        "80882": "GDAŃSK",
        "80883": "GDAŃSK",
        "80884": "GDAŃSK",
        "80885": "GDAŃSK",
        "80886": "GDAŃSK",
        "80887": "GDAŃSK",
        "80888": "GDAŃSK",
        "80890": "GDAŃSK",
        "80891": "GDAŃSK",
        "80893": "GDAŃSK",
        "80894": "GDAŃSK",
        "80895": "GDAŃSK",
        "80900": "GDAŃSK",
        "80917": "GDAŃSK",
        "80940": "GDAŃSK",
        "80949": "GDAŃSK",
        "80952": "GDAŃSK",
        "80953": "GDAŃSK",
        "80955": "GDAŃSK",
        "80958": "GDAŃSK",
        "80961": "GDAŃSK",
        "80962": "GDAŃSK",
        "80963": "GDAŃSK",
        "80964": "GDAŃSK",
        "80980": "GDAŃSK",
        "81000": "GDYNIA",
        "81001": "GDYNIA",
        "81002": "GDYNIA",
        "81003": "GDYNIA",
        "81004": "GDYNIA",
        "81005": "GDYNIA",
        "81006": "GDYNIA",
        "81007": "GDYNIA",
        "81008": "GDYNIA",
        "81009": "GDYNIA",
        "81010": "GDYNIA",
        "81012": "GDYNIA",
        "81015": "GDYNIA",
        "81016": "GDYNIA",
        "81017": "GDYNIA",
        "81018": "GDYNIA",
        "81019": "GDYNIA",
        "81020": "GDYNIA",
        "81021": "GDYNIA",
        "81022": "GDYNIA",
        "81023": "GDYNIA",
        "81024": "GDYNIA",
        "81025": "GDYNIA",
        "81028": "GDYNIA",
        "81029": "GDYNIA",
        "81033": "GDYNIA",
        "81034": "GDYNIA",
        "81035": "GDYNIA",
        "81036": "GDYNIA",
        "81037": "GDYNIA",
        "81040": "GDYNIA",
        "81041": "GDYNIA",
        "81042": "GDYNIA",
        "81044": "GDYNIA",
        "81045": "GDYNIA",
        "81047": "GDYNIA",
        "81048": "GDYNIA",
        "81049": "GDYNIA",
        "81050": "GDYNIA",
        "81051": "GDYNIA",
        "81052": "GDYNIA",
        "81053": "GDYNIA",
        "81055": "GDYNIA",
        "81056": "GDYNIA",
        "81057": "GDYNIA",
        "81058": "GDYNIA",
        "81059": "GDYNIA",
        "81060": "GDYNIA",
        "81061": "GDYNIA",
        "81062": "GDYNIA",
        "81063": "GDYNIA",
        "81064": "GDYNIA",
        "81065": "GDYNIA",
        "81066": "GDYNIA",
        "81068": "GDYNIA",
        "81072": "GDYNIA",
        "81074": "GDYNIA",
        "81075": "GDYNIA",
        "81076": "GDYNIA",
        "81077": "GDYNIA",
        "81078": "GDYNIA",
        "81079": "GDYNIA",
        "81080": "GDYNIA",
        "81081": "GDYNIA",
        "81082": "GDYNIA",
        "81083": "GDYNIA",
        "81084": "GDYNIA",
        "81085": "GDYNIA",
        "81086": "GDYNIA",
        "81087": "GDYNIA",
        "81089": "GDYNIA",
        "81092": "GDYNIA",
        "81094": "GDYNIA",
        "81095": "GDYNIA",
        "81097": "GDYNIA",
        "81100": "GDYNIA",
        "81101": "GDYNIA",
        "81102": "GDYNIA",
        "81103": "GDYNIA",
        "81104": "GDYNIA",
        "81105": "GDYNIA",
        "81106": "GDYNIA",
        "81107": "GDYNIA",
        "81108": "GDYNIA",
        "81109": "GDYNIA",
        "81110": "GDYNIA",
        "81111": "GDYNIA",
        "81112": "GDYNIA",
        "81113": "GDYNIA",
        "81114": "GDYNIA",
        "81115": "GDYNIA",
        "81116": "GDYNIA",
        "81117": "GDYNIA",
        "81118": "GDYNIA",
        "81120": "GDYNIA",
        "81121": "GDYNIA",
        "81122": "GDYNIA",
        "81123": "GDYNIA",
        "81124": "GDYNIA",
        "81125": "GDYNIA",
        "81127": "GDYNIA",
        "81130": "GDYNIA",
        "81131": "GDYNIA",
        "81132": "GDYNIA",
        "81133": "GDYNIA",
        "81134": "GDYNIA",
        "81136": "GDYNIA",
        "81137": "GDYNIA",
        "81138": "GDYNIA",
        "81146": "GDYNIA",
        "81147": "GDYNIA",
        "81148": "GDYNIA",
        "81149": "GDYNIA",
        "81150": "GDYNIA",
        "81151": "GDYNIA",
        "81152": "GDYNIA",
        "81153": "GDYNIA",
        "81154": "GDYNIA",
        "81155": "GDYNIA",
        "81156": "GDYNIA",
        "81157": "GDYNIA",
        "81158": "GDYNIA",
        "81159": "GDYNIA",
        "81160": "GDYNIA",
        "81161": "GDYNIA",
        "81162": "GDYNIA",
        "81163": "GDYNIA",
        "81164": "GDYNIA",
        "81165": "GDYNIA",
        "81166": "GDYNIA",
        "81167": "GDYNIA",
        "81168": "GDYNIA",
        "81169": "GDYNIA",
        "81170": "GDYNIA",
        "81171": "GDYNIA",
        "81172": "GDYNIA",
        "81173": "GDYNIA",
        "81174": "GDYNIA",
        "81175": "GDYNIA",
        "81176": "GDYNIA",
        "81177": "GDYNIA",
        "81178": "GDYNIA",
        "81179": "GDYNIA",
        "81180": "GDYNIA",
        "81181": "GDYNIA",
        "81182": "GDYNIA",
        "81183": "GDYNIA",
        "81184": "GDYNIA",
        "81185": "GDYNIA",
        "81187": "GDYNIA",
        "81188": "GDYNIA",
        "81189": "GDYNIA",
        "81190": "GDYNIA",
        "81191": "GDYNIA",
        "81192": "GDYNIA",
        "81193": "GDYNIA",
        "81194": "GDYNIA",
        "81195": "GDYNIA",
        "81197": "GDYNIA",
        "81198": "PUCK",
        "81200": "GDYNIA",
        "81201": "GDYNIA",
        "81202": "GDYNIA",
        "81203": "GDYNIA",
        "81204": "GDYNIA",
        "81207": "GDYNIA",
        "81208": "GDYNIA",
        "81209": "GDYNIA",
        "81210": "GDYNIA",
        "81211": "GDYNIA",
        "81212": "GDYNIA",
        "81213": "GDYNIA",
        "81214": "GDYNIA",
        "81215": "GDYNIA",
        "81217": "GDYNIA",
        "81218": "GDYNIA",
        "81219": "GDYNIA",
        "81220": "GDYNIA",
        "81221": "GDYNIA",
        "81222": "GDYNIA",
        "81223": "GDYNIA",
        "81224": "GDYNIA",
        "81225": "GDYNIA",
        "81226": "GDYNIA",
        "81228": "GDYNIA",
        "81229": "GDYNIA",
        "81230": "GDYNIA",
        "81231": "GDYNIA",
        "81232": "GDYNIA",
        "81233": "GDYNIA",
        "81234": "GDYNIA",
        "81235": "GDYNIA",
        "81236": "GDYNIA",
        "81237": "GDYNIA",
        "81241": "GDYNIA",
        "81242": "GDYNIA",
        "81244": "GDYNIA",
        "81245": "GDYNIA",
        "81249": "GDYNIA",
        "81250": "GDYNIA",
        "81253": "GDYNIA",
        "81254": "GDYNIA",
        "81255": "GDYNIA",
        "81256": "GDYNIA",
        "81257": "GDYNIA",
        "81258": "GDYNIA",
        "81259": "GDYNIA",
        "81260": "GDYNIA",
        "81261": "GDYNIA",
        "81262": "GDYNIA",
        "81263": "GDYNIA",
        "81265": "GDYNIA",
        "81266": "GDYNIA",
        "81267": "GDYNIA",
        "81268": "GDYNIA",
        "81269": "GDYNIA",
        "81270": "GDYNIA",
        "81271": "GDYNIA",
        "81272": "GDYNIA",
        "81273": "GDYNIA",
        "81290": "GDYNIA",
        "81300": "GDYNIA",
        "81301": "GDYNIA",
        "81302": "GDYNIA",
        "81303": "GDYNIA",
        "81304": "GDYNIA",
        "81305": "GDYNIA",
        "81306": "GDYNIA",
        "81308": "GDYNIA",
        "81309": "GDYNIA",
        "81310": "GDYNIA",
        "81311": "GDYNIA",
        "81312": "GDYNIA",
        "81313": "GDYNIA",
        "81314": "GDYNIA",
        "81315": "GDYNIA",
        "81316": "GDYNIA",
        "81317": "GDYNIA",
        "81319": "GDYNIA",
        "81320": "GDYNIA",
        "81321": "GDYNIA",
        "81322": "GDYNIA",
        "81323": "GDYNIA",
        "81324": "GDYNIA",
        "81325": "GDYNIA",
        "81326": "GDYNIA",
        "81327": "GDYNIA",
        "81328": "GDYNIA",
        "81329": "GDYNIA",
        "81330": "GDYNIA",
        "81331": "GDYNIA",
        "81332": "GDYNIA",
        "81333": "GDYNIA",
        "81334": "GDYNIA",
        "81335": "GDYNIA",
        "81336": "GDYNIA",
        "81337": "GDYNIA",
        "81338": "GDYNIA",
        "81339": "GDYNIA",
        "81340": "GDYNIA",
        "81341": "GDYNIA",
        "81342": "GDYNIA",
        "81343": "GDYNIA",
        "81345": "GDYNIA",
        "81346": "GDYNIA",
        "81347": "GDYNIA",
        "81348": "GDYNIA",
        "81349": "GDYNIA",
        "81350": "GDYNIA",
        "81351": "GDYNIA",
        "81352": "GDYNIA",
        "81353": "GDYNIA",
        "81354": "GDYNIA",
        "81355": "GDYNIA",
        "81356": "GDYNIA",
        "81357": "GDYNIA",
        "81358": "GDYNIA",
        "81359": "GDYNIA",
        "81361": "GDYNIA",
        "81362": "GDYNIA",
        "81363": "GDYNIA",
        "81364": "GDYNIA",
        "81365": "GDYNIA",
        "81366": "GDYNIA",
        "81367": "GDYNIA",
        "81368": "GDYNIA",
        "81369": "GDYNIA",
        "81370": "GDYNIA",
        "81371": "GDYNIA",
        "81372": "GDYNIA",
        "81373": "GDYNIA",
        "81374": "GDYNIA",
        "81375": "GDYNIA",
        "81376": "GDYNIA",
        "81377": "GDYNIA",
        "81378": "GDYNIA",
        "81379": "GDYNIA",
        "81380": "GDYNIA",
        "81381": "GDYNIA",
        "81382": "GDYNIA",
        "81383": "GDYNIA",
        "81384": "GDYNIA",
        "81385": "GDYNIA",
        "81386": "GDYNIA",
        "81387": "GDYNIA",
        "81388": "GDYNIA",
        "81389": "GDYNIA",
        "81390": "GDYNIA",
        "81391": "GDYNIA",
        "81392": "GDYNIA",
        "81393": "GDYNIA",
        "81394": "GDYNIA",
        "81395": "GDYNIA",
        "81396": "GDYNIA",
        "81397": "GDYNIA",
        "81399": "GDYNIA",
        "81400": "GDYNIA",
        "81401": "GDYNIA",
        "81402": "GDYNIA",
        "81403": "GDYNIA",
        "81404": "GDYNIA",
        "81405": "GDYNIA",
        "81406": "GDYNIA",
        "81407": "GDYNIA",
        "81408": "GDYNIA",
        "81409": "GDYNIA",
        "81410": "GDYNIA",
        "81411": "GDYNIA",
        "81412": "GDYNIA",
        "81413": "GDYNIA",
        "81414": "GDYNIA",
        "81415": "GDYNIA",
        "81416": "GDYNIA",
        "81417": "GDYNIA",
        "81418": "GDYNIA",
        "81420": "GDYNIA",
        "81421": "GDYNIA",
        "81422": "GDYNIA",
        "81423": "GDYNIA",
        "81424": "GDYNIA",
        "81425": "GDYNIA",
        "81426": "GDYNIA",
        "81427": "GDYNIA",
        "81428": "GDYNIA",
        "81429": "GDYNIA",
        "81431": "GDYNIA",
        "81432": "GDYNIA",
        "81433": "GDYNIA",
        "81434": "GDYNIA",
        "81435": "GDYNIA",
        "81436": "GDYNIA",
        "81437": "GDYNIA",
        "81438": "GDYNIA",
        "81439": "GDYNIA",
        "81440": "GDYNIA",
        "81441": "GDYNIA",
        "81442": "GDYNIA",
        "81448": "GDYNIA",
        "81449": "GDYNIA",
        "81450": "GDYNIA",
        "81451": "GDYNIA",
        "81452": "GDYNIA",
        "81453": "GDYNIA",
        "81454": "GDYNIA",
        "81455": "GDYNIA",
        "81456": "GDYNIA",
        "81457": "GDYNIA",
        "81458": "GDYNIA",
        "81459": "GDYNIA",
        "81460": "GDYNIA",
        "81461": "GDYNIA",
        "81462": "GDYNIA",
        "81463": "GDYNIA",
        "81464": "GDYNIA",
        "81465": "GDYNIA",
        "81466": "GDYNIA",
        "81467": "GDYNIA",
        "81468": "GDYNIA",
        "81469": "GDYNIA",
        "81470": "GDYNIA",
        "81471": "GDYNIA",
        "81472": "GDYNIA",
        "81473": "GDYNIA",
        "81474": "GDYNIA",
        "81475": "GDYNIA",
        "81476": "GDYNIA",
        "81500": "GDYNIA",
        "81501": "GDYNIA",
        "81502": "GDYNIA",
        "81503": "GDYNIA",
        "81504": "GDYNIA",
        "81505": "GDYNIA",
        "81506": "GDYNIA",
        "81507": "GDYNIA",
        "81508": "GDYNIA",
        "81509": "GDYNIA",
        "81510": "GDYNIA",
        "81511": "GDYNIA",
        "81512": "GDYNIA",
        "81513": "GDYNIA",
        "81514": "GDYNIA",
        "81515": "GDYNIA",
        "81516": "GDYNIA",
        "81517": "GDYNIA",
        "81518": "GDYNIA",
        "81519": "GDYNIA",
        "81520": "GDYNIA",
        "81521": "GDYNIA",
        "81522": "GDYNIA",
        "81523": "GDYNIA",
        "81524": "GDYNIA",
        "81525": "GDYNIA",
        "81526": "GDYNIA",
        "81527": "GDYNIA",
        "81528": "GDYNIA",
        "81529": "GDYNIA",
        "81530": "GDYNIA",
        "81531": "GDYNIA",
        "81532": "GDYNIA",
        "81533": "GDYNIA",
        "81534": "GDYNIA",
        "81535": "GDYNIA",
        "81536": "GDYNIA",
        "81537": "GDYNIA",
        "81538": "GDYNIA",
        "81539": "GDYNIA",
        "81540": "GDYNIA",
        "81541": "GDYNIA",
        "81542": "GDYNIA",
        "81543": "GDYNIA",
        "81544": "GDYNIA",
        "81545": "GDYNIA",
        "81547": "GDYNIA",
        "81548": "GDYNIA",
        "81549": "GDYNIA",
        "81550": "GDYNIA",
        "81551": "GDYNIA",
        "81552": "GDYNIA",
        "81553": "GDYNIA",
        "81554": "GDYNIA",
        "81555": "GDYNIA",
        "81556": "GDYNIA",
        "81557": "GDYNIA",
        "81558": "GDYNIA",
        "81559": "GDYNIA",
        "81560": "GDYNIA",
        "81561": "GDYNIA",
        "81562": "GDYNIA",
        "81570": "GDYNIA",
        "81571": "GDYNIA",
        "81572": "GDYNIA",
        "81573": "GDYNIA",
        "81574": "GDYNIA",
        "81575": "GDYNIA",
        "81576": "GDYNIA",
        "81577": "GDYNIA",
        "81578": "GDYNIA",
        "81579": "GDYNIA",
        "81580": "GDYNIA",
        "81581": "GDYNIA",
        "81582": "GDYNIA",
        "81583": "GDYNIA",
        "81584": "GDYNIA",
        "81585": "GDYNIA",
        "81586": "GDYNIA",
        "81587": "GDYNIA",
        "81589": "GDYNIA",
        "81591": "GDYNIA",
        "81592": "GDYNIA",
        "81593": "GDYNIA",
        "81594": "GDYNIA",
        "81595": "GDYNIA",
        "81596": "GDYNIA",
        "81597": "GDYNIA",
        "81598": "GDYNIA",
        "81601": "GDYNIA",
        "81602": "GDYNIA",
        "81603": "GDYNIA",
        "81604": "GDYNIA",
        "81605": "GDYNIA",
        "81606": "GDYNIA",
        "81607": "GDYNIA",
        "81608": "GDYNIA",
        "81609": "GDYNIA",
        "81611": "GDYNIA",
        "81612": "GDYNIA",
        "81613": "GDYNIA",
        "81614": "GDYNIA",
        "81615": "GDYNIA",
        "81616": "GDYNIA",
        "81617": "GDYNIA",
        "81619": "GDYNIA",
        "81620": "GDYNIA",
        "81621": "GDYNIA",
        "81622": "GDYNIA",
        "81623": "GDYNIA",
        "81624": "GDYNIA",
        "81625": "GDYNIA",
        "81626": "GDYNIA",
        "81627": "GDYNIA",
        "81628": "GDYNIA",
        "81629": "GDYNIA",
        "81630": "GDYNIA",
        "81631": "GDYNIA",
        "81632": "GDYNIA",
        "81633": "GDYNIA",
        "81634": "GDYNIA",
        "81635": "GDYNIA",
        "81636": "GDYNIA",
        "81637": "GDYNIA",
        "81638": "GDYNIA",
        "81639": "GDYNIA",
        "81640": "GDYNIA",
        "81641": "GDYNIA",
        "81645": "GDYNIA",
        "81646": "GDYNIA",
        "81647": "GDYNIA",
        "81649": "GDYNIA",
        "81650": "GDYNIA",
        "81651": "GDYNIA",
        "81653": "GDYNIA",
        "81654": "GDYNIA",
        "81655": "GDYNIA",
        "81656": "GDYNIA",
        "81657": "GDYNIA",
        "81658": "GDYNIA",
        "81659": "GDYNIA",
        "81660": "GDYNIA",
        "81661": "GDYNIA",
        "81701": "SOPOT",
        "81702": "SOPOT",
        "81703": "SOPOT",
        "81704": "SOPOT",
        "81705": "SOPOT",
        "81706": "SOPOT",
        "81707": "SOPOT",
        "81708": "SOPOT",
        "81709": "SOPOT",
        "81710": "SOPOT",
        "81711": "SOPOT",
        "81712": "SOPOT",
        "81713": "SOPOT",
        "81714": "SOPOT",
        "81715": "SOPOT",
        "81716": "SOPOT",
        "81717": "SOPOT",
        "81718": "SOPOT",
        "81719": "SOPOT",
        "81720": "SOPOT",
        "81721": "SOPOT",
        "81722": "SOPOT",
        "81723": "SOPOT",
        "81724": "SOPOT",
        "81725": "SOPOT",
        "81726": "SOPOT",
        "81727": "SOPOT",
        "81728": "SOPOT",
        "81729": "SOPOT",
        "81730": "SOPOT",
        "81731": "SOPOT",
        "81732": "SOPOT",
        "81733": "SOPOT",
        "81734": "SOPOT",
        "81735": "SOPOT",
        "81736": "SOPOT",
        "81737": "SOPOT",
        "81738": "SOPOT",
        "81739": "SOPOT",
        "81740": "SOPOT",
        "81741": "SOPOT",
        "81742": "SOPOT",
        "81743": "SOPOT",
        "81744": "SOPOT",
        "81745": "SOPOT",
        "81746": "SOPOT",
        "81747": "SOPOT",
        "81748": "SOPOT",
        "81749": "SOPOT",
        "81750": "SOPOT",
        "81751": "SOPOT",
        "81752": "SOPOT",
        "81753": "SOPOT",
        "81754": "SOPOT",
        "81755": "SOPOT",
        "81756": "SOPOT",
        "81757": "SOPOT",
        "81758": "SOPOT",
        "81759": "SOPOT",
        "81760": "SOPOT",
        "81761": "SOPOT",
        "81762": "SOPOT",
        "81763": "SOPOT",
        "81764": "SOPOT",
        "81765": "SOPOT",
        "81767": "SOPOT",
        "81768": "SOPOT",
        "81769": "SOPOT",
        "81770": "SOPOT",
        "81771": "SOPOT",
        "81772": "SOPOT",
        "81773": "SOPOT",
        "81775": "SOPOT",
        "81776": "SOPOT",
        "81777": "SOPOT",
        "81778": "SOPOT",
        "81779": "SOPOT",
        "81780": "SOPOT",
        "81781": "SOPOT",
        "81782": "SOPOT",
        "81783": "SOPOT",
        "81784": "SOPOT",
        "81785": "SOPOT",
        "81786": "SOPOT",
        "81803": "SOPOT",
        "81804": "SOPOT",
        "81805": "SOPOT",
        "81806": "SOPOT",
        "81807": "SOPOT",
        "81808": "SOPOT",
        "81809": "SOPOT",
        "81810": "SOPOT",
        "81811": "SOPOT",
        "81812": "SOPOT",
        "81813": "SOPOT",
        "81814": "SOPOT",
        "81815": "SOPOT",
        "81816": "SOPOT",
        "81817": "SOPOT",
        "81818": "SOPOT",
        "81819": "SOPOT",
        "81820": "SOPOT",
        "81821": "SOPOT",
        "81822": "SOPOT",
        "81823": "SOPOT",
        "81824": "SOPOT",
        "81825": "SOPOT",
        "81826": "SOPOT",
        "81827": "SOPOT",
        "81828": "SOPOT",
        "81829": "SOPOT",
        "81830": "SOPOT",
        "81831": "SOPOT",
        "81832": "SOPOT",
        "81833": "SOPOT",
        "81834": "SOPOT",
        "81835": "SOPOT",
        "81836": "SOPOT",
        "81837": "SOPOT",
        "81838": "SOPOT",
        "81839": "SOPOT",
        "81840": "SOPOT",
        "81841": "SOPOT",
        "81842": "SOPOT",
        "81843": "SOPOT",
        "81844": "SOPOT",
        "81845": "SOPOT",
        "81846": "SOPOT",
        "81847": "SOPOT",
        "81848": "SOPOT",
        "81849": "SOPOT",
        "81850": "SOPOT",
        "81851": "SOPOT",
        "81852": "SOPOT",
        "81853": "SOPOT",
        "81854": "SOPOT",
        "81855": "SOPOT",
        "81856": "SOPOT",
        "81857": "SOPOT",
        "81859": "SOPOT",
        "81860": "SOPOT",
        "81861": "SOPOT",
        "81862": "SOPOT",
        "81864": "SOPOT",
        "81865": "SOPOT",
        "81866": "SOPOT",
        "81867": "SOPOT",
        "81868": "SOPOT",
        "81869": "SOPOT",
        "81870": "SOPOT",
        "81871": "SOPOT",
        "81872": "SOPOT",
        "81873": "SOPOT",
        "81874": "SOPOT",
        "81875": "SOPOT",
        "81876": "SOPOT",
        "81877": "SOPOT",
        "81878": "SOPOT",
        "81880": "SOPOT",
        "81881": "SOPOT",
        "81912": "GDYNIA",
        "81919": "GDYNIA",
        "81963": "GDYNIA",
        "81969": "GDYNIA",
        "81980": "GDYNIA",
        "82100": "NOWY DWÓR GDAŃSKI (NET)",
        "82103": "NOWY DWÓR GDAŃSKI",
        "82104": "NOWY DWÓR GDAŃSKI",
        "82107": "NOWY DWÓR GDAŃSKI",
        "82110": "NOWY DWÓR GDAŃSKI",
        "82112": "NOWY DWÓR GDAŃSKI",
        "82113": "NOWY DWÓR GDAŃSKI",
        "82120": "NOWY DWÓR GDAŃSKI",
        "82200": "MALBORK",
        "82201": "MALBORK",
        "82202": "MALBORK",
        "82203": "MALBORK",
        "82204": "MALBORK",
        "82205": "MALBORK",
        "82210": "MALBORK",
        "82213": "MALBORK",
        "82220": "MALBORK",
        "82224": "MALBORK",
        "82230": "MALBORK",
        "82300": "ELBLĄG",
        "82301": "ELBLĄG",
        "82302": "ELBLĄG",
        "82303": "ELBLĄG",
        "82305": "ELBLĄG",
        "82306": "ELBLĄG",
        "82307": "ELBLĄG",
        "82308": "ELBLĄG",
        "82309": "ELBLĄG",
        "82310": "ELBLĄG",
        "82311": "ELBLĄG",
        "82312": "ELBLĄG",
        "82313": "ELBLĄG",
        "82314": "ELBLĄG",
        "82315": "ELBLĄG",
        "82316": "ELBLĄG",
        "82317": "ELBLĄG",
        "82325": "ELBLĄG",
        "82331": "ELBLĄG",
        "82335": "ELBLĄG",
        "82340": "ELBLĄG",
        "82400": "SZTUM",
        "82410": "SZTUM",
        "82411": "SZTUM",
        "82420": "KWIDZYN",
        "82433": "SZTUM",
        "82440": "SZTUM",
        "82450": "SZTUM",
        "82500": "KWIDZYN",
        "82501": "KWIDZYN",
        "82502": "KWIDZYN",
        "82503": "KWIDZYN",
        "82504": "KWIDZYN",
        "82505": "KWIDZYN",
        "82520": "KWIDZYN",
        "82522": "KWIDZYN",
        "82550": "KWIDZYN",
        "83000": "PRUSZCZ GDAŃSKI",
        "83002": "PRUSZCZ GDAŃSKI",
        "83004": "PRUSZCZ GDAŃSKI",
        "83005": "PRUSZCZ GDAŃSKI",
        "83009": "PRUSZCZ GDAŃSKI",
        "83010": "GDAŃSK",
        "83011": "GDAŃSK",
        "83020": "GDAŃSK",
        "83021": "GDAŃSK",
        "83022": "GDAŃSK",
        "83031": "GDAŃSK",
        "83032": "GDAŃSK",
        "83033": "GDAŃSK",
        "83034": "GDAŃSK",
        "83035": "KŁODAWA",
        "83041": "GDAŃSK",
        "83042": "GDAŃSK",
        "83047": "GDAŃSK",
        "83050": "KOLBUDY",
        "83051": "GDAŃSK",
        "83100": "TCZEW",
        "83101": "TCZEW",
        "83102": "TCZEW",
        "83110": "TCZEW",
        "83111": "TCZEW",
        "83112": "TCZEW",
        "83113": "TCZEW",
        "83115": "TCZEW",
        "83120": "TCZEW",
        "83121": "TCZEW",
        "83122": "TCZEW",
        "83123": "TCZEW",
        "83130": "TCZEW",
        "83132": "TCZEW",
        "83133": "TCZEW",
        "83135": "TCZEW",
        "83136": "TCZEW",
        "83140": "GNIEW",
        "83200": "STAROGARD GDAŃSKI",
        "83201": "STAROGARD GDAŃSKI",
        "83202": "STAROGARD GDAŃSKI",
        "83203": "STAROGARD GDAŃSKI",
        "83206": "STAROGARD GDAŃSKI",
        "83207": "STAROGARD GDAŃSKI",
        "83208": "STAROGARD GDAŃSKI",
        "83209": "STAROGARD GDAŃSKI",
        "83210": "STAROGARD GDAŃSKI",
        "83211": "STAROGARD GDAŃSKI",
        "83212": "STAROGARD GDAŃSKI",
        "83213": "STAROGARD GDAŃSKI",
        "83220": "STAROGARD GDAŃSKI",
        "83221": "STAROGARD GDAŃSKI",
        "83224": "STAROGARD GDAŃSKI",
        "83225": "STAROGARD GDAŃSKI",
        "83226": "STAROGARD GDAŃSKI",
        "83230": "STAROGARD GDAŃSKI",
        "83232": "STAROGARD GDAŃSKI",
        "83236": "STAROGARD GDAŃSKI",
        "83240": "STAROGARD GDAŃSKI",
        "83242": "STAROGARD GDAŃSKI",
        "83243": "STAROGARD GDAŃSKI",
        "83250": "STAROGARD GDAŃSKI",
        "83251": "STAROGARD GDAŃSKI",
        "83260": "STAROGARD GDAŃSKI",
        "83261": "STAROGARD GDAŃSKI",
        "83262": "STAROGARD GDAŃSKI",
        "83300": "KARTUZY",
        "83301": "KARTUZY",
        "83304": "KARTUZY",
        "83305": "KARTUZY",
        "83307": "KARTUZY",
        "83311": "KARTUZY",
        "83312": "KARTUZY",
        "83314": "KARTUZY",
        "83315": "KARTUZY (NET)",
        "83316": "KARTUZY (NET)",
        "83320": "KARTUZY (NET)",
        "83321": "KARTUZY",
        "83322": "KARTUZY (NET)",
        "83323": "KARTUZY",
        "83324": "KARTUZY",
        "83328": "KARTUZY",
        "83329": "KARTUZY",
        "83330": "ŻUKOWO",
        "83331": "KARTUZY",
        "83332": "KARTUZY",
        "83333": "KARTUZY",
        "83334": "KARTUZY",
        "83335": "KARTUZY",
        "83336": "KARTUZY",
        "83337": "KARTUZY",
        "83340": "KARTUZY",
        "83341": "KARTUZY",
        "83342": "KARTUZY",
        "83400": "KOŚCIERZYNA",
        "83401": "KOŚCIERZYNA",
        "83403": "KOŚCIERZYNA",
        "83404": "KOŚCIERZYNA",
        "83405": "KARTUZY",
        "83406": "KOŚCIERZYNA",
        "83407": "KOŚCIERZYNA",
        "83408": "KOŚCIERZYNA",
        "83409": "KOŚCIERZYNA",
        "83412": "KARTUZY",
        "83420": "KOŚCIERZYNA",
        "83421": "KARTUZY",
        "83422": "KOŚCIERZYNA",
        "83423": "KOŚCIERZYNA",
        "83424": "KOŚCIERZYNA",
        "83425": "KOŚCIERZYNA",
        "83430": "KOŚCIERZYNA",
        "83431": "KOŚCIERZYNA",
        "83432": "KARTUZY",
        "83433": "KARTUZY",
        "83440": "KOŚCIERZYNA",
        "83441": "KOŚCIERZYNA",
        "84100": "PUCK",
        "84103": "PUCK",
        "84104": "WŁADYSŁAWOWO",
        "84105": "PUCK",
        "84106": "PUCK",
        "84107": "PUCK",
        "84110": "PUCK",
        "84113": "PUCK",
        "84120": "WŁADYSŁAWOWO",
        "84122": "PUCK",
        "84123": "PUCK",
        "84130": "PUCK",
        "84140": "PUCK",
        "84141": "PUCK",
        "84150": "PUCK",
        "84200": "WEJHEROWO",
        "84201": "WEJHEROWO",
        "84202": "WEJHEROWO",
        "84204": "WEJHEROWO",
        "84206": "WEJHEROWO",
        "84207": "WEJHEROWO",
        "84208": "WEJHEROWO",
        "84210": "WEJHEROWO",
        "84211": "WEJHEROWO",
        "84213": "WEJHEROWO",
        "84214": "WEJHEROWO",
        "84215": "WEJHEROWO",
        "84217": "WEJHEROWO",
        "84218": "WEJHEROWO",
        "84219": "WEJHEROWO",
        "84220": "WEJHEROWO",
        "84222": "WEJHEROWO",
        "84223": "WEJHEROWO",
        "84230": "RUMIA",
        "84231": "RUMIA",
        "84232": "RUMIA",
        "84239": "WEJHEROWO",
        "84240": "WEJHEROWO",
        "84241": "WEJHEROWO",
        "84242": "LUZINO",
        "84243": "WEJHEROWO",
        "84244": "WEJHEROWO",
        "84250": "WEJHEROWO",
        "84251": "WEJHEROWO",
        "84252": "WEJHEROWO",
        "84300": "LĘBORK",
        "84301": "LĘBORK",
        "84302": "LĘBORK",
        "84303": "LĘBORK",
        "84310": "LĘBORK",
        "84311": "LĘBORK",
        "84312": "LĘBORK",
        "84313": "LĘBORK",
        "84315": "LĘBORK",
        "84342": "LĘBORK",
        "84350": "LĘBORK",
        "84351": "LĘBORK",
        "84352": "LĘBORK",
        "84353": "LĘBORK",
        "84360": "LĘBORK",
        "85001": "BYDGOSZCZ",
        "85002": "BYDGOSZCZ",
        "85003": "BYDGOSZCZ",
        "85004": "BYDGOSZCZ",
        "85005": "BYDGOSZCZ",
        "85006": "BYDGOSZCZ",
        "85007": "BYDGOSZCZ",
        "85008": "BYDGOSZCZ",
        "85009": "BYDGOSZCZ",
        "85010": "BYDGOSZCZ",
        "85011": "BYDGOSZCZ",
        "85012": "BYDGOSZCZ",
        "85013": "BYDGOSZCZ",
        "85014": "BYDGOSZCZ",
        "85015": "BYDGOSZCZ",
        "85016": "BYDGOSZCZ",
        "85017": "BYDGOSZCZ",
        "85018": "BYDGOSZCZ",
        "85020": "BYDGOSZCZ",
        "85021": "BYDGOSZCZ",
        "85022": "BYDGOSZCZ",
        "85023": "BYDGOSZCZ",
        "85024": "BYDGOSZCZ",
        "85026": "BYDGOSZCZ",
        "85027": "BYDGOSZCZ",
        "85028": "BYDGOSZCZ",
        "85029": "BYDGOSZCZ",
        "85030": "BYDGOSZCZ",
        "85031": "BYDGOSZCZ",
        "85032": "BYDGOSZCZ",
        "85033": "BYDGOSZCZ",
        "85034": "BYDGOSZCZ",
        "85035": "BYDGOSZCZ",
        "85036": "BYDGOSZCZ",
        "85037": "BYDGOSZCZ",
        "85038": "BYDGOSZCZ",
        "85039": "BYDGOSZCZ",
        "85040": "BYDGOSZCZ",
        "85041": "BYDGOSZCZ",
        "85042": "BYDGOSZCZ",
        "85043": "BYDGOSZCZ",
        "85044": "BYDGOSZCZ",
        "85045": "BYDGOSZCZ",
        "85046": "BYDGOSZCZ",
        "85047": "BYDGOSZCZ",
        "85048": "BYDGOSZCZ",
        "85049": "BYDGOSZCZ",
        "85050": "BYDGOSZCZ",
        "85051": "BYDGOSZCZ",
        "85052": "BYDGOSZCZ",
        "85053": "BYDGOSZCZ",
        "85054": "BYDGOSZCZ",
        "85055": "BYDGOSZCZ",
        "85056": "BYDGOSZCZ",
        "85057": "BYDGOSZCZ",
        "85058": "BYDGOSZCZ",
        "85059": "BYDGOSZCZ",
        "85060": "BYDGOSZCZ",
        "85061": "BYDGOSZCZ",
        "85062": "BYDGOSZCZ",
        "85063": "BYDGOSZCZ",
        "85064": "BYDGOSZCZ",
        "85065": "BYDGOSZCZ",
        "85066": "BYDGOSZCZ",
        "85067": "BYDGOSZCZ",
        "85068": "BYDGOSZCZ",
        "85069": "BYDGOSZCZ",
        "85070": "BYDGOSZCZ",
        "85071": "BYDGOSZCZ",
        "85072": "BYDGOSZCZ",
        "85073": "BYDGOSZCZ",
        "85074": "BYDGOSZCZ",
        "85075": "BYDGOSZCZ",
        "85076": "BYDGOSZCZ",
        "85077": "BYDGOSZCZ",
        "85078": "BYDGOSZCZ",
        "85079": "BYDGOSZCZ",
        "85080": "BYDGOSZCZ",
        "85081": "BYDGOSZCZ",
        "85082": "BYDGOSZCZ",
        "85083": "BYDGOSZCZ",
        "85084": "BYDGOSZCZ",
        "85085": "BYDGOSZCZ",
        "85086": "BYDGOSZCZ",
        "85087": "BYDGOSZCZ",
        "85088": "BYDGOSZCZ",
        "85089": "BYDGOSZCZ",
        "85090": "BYDGOSZCZ",
        "85091": "BYDGOSZCZ",
        "85092": "BYDGOSZCZ",
        "85093": "BYDGOSZCZ",
        "85094": "BYDGOSZCZ",
        "85095": "BYDGOSZCZ",
        "85096": "BYDGOSZCZ",
        "85097": "BYDGOSZCZ",
        "85098": "BYDGOSZCZ",
        "85099": "BYDGOSZCZ",
        "85100": "BYDGOSZCZ",
        "85101": "BYDGOSZCZ",
        "85102": "BYDGOSZCZ",
        "85103": "BYDGOSZCZ",
        "85104": "BYDGOSZCZ",
        "85105": "BYDGOSZCZ",
        "85106": "BYDGOSZCZ",
        "85107": "BYDGOSZCZ",
        "85108": "BYDGOSZCZ",
        "85109": "BYDGOSZCZ",
        "85110": "BYDGOSZCZ",
        "85111": "BYDGOSZCZ",
        "85112": "BYDGOSZCZ",
        "85113": "BYDGOSZCZ",
        "85114": "BYDGOSZCZ",
        "85115": "BYDGOSZCZ",
        "85116": "BYDGOSZCZ",
        "85117": "BYDGOSZCZ",
        "85118": "BYDGOSZCZ",
        "85119": "BYDGOSZCZ",
        "85120": "BYDGOSZCZ",
        "85121": "BYDGOSZCZ",
        "85122": "BYDGOSZCZ",
        "85123": "BYDGOSZCZ",
        "85124": "BYDGOSZCZ",
        "85125": "BYDGOSZCZ",
        "85126": "BYDGOSZCZ",
        "85127": "BYDGOSZCZ",
        "85128": "BYDGOSZCZ",
        "85129": "BYDGOSZCZ",
        "85130": "BYDGOSZCZ",
        "85131": "BYDGOSZCZ",
        "85132": "BYDGOSZCZ",
        "85133": "BYDGOSZCZ",
        "85134": "BYDGOSZCZ",
        "85135": "BYDGOSZCZ",
        "85136": "BYDGOSZCZ",
        "85137": "BYDGOSZCZ",
        "85138": "BYDGOSZCZ",
        "85139": "BYDGOSZCZ",
        "85140": "BYDGOSZCZ",
        "85141": "BYDGOSZCZ",
        "85142": "BYDGOSZCZ",
        "85143": "BYDGOSZCZ",
        "85144": "BYDGOSZCZ",
        "85145": "BYDGOSZCZ",
        "85146": "BYDGOSZCZ",
        "85147": "BYDGOSZCZ",
        "85148": "BYDGOSZCZ",
        "85149": "BYDGOSZCZ",
        "85150": "BYDGOSZCZ",
        "85151": "BYDGOSZCZ",
        "85152": "BYDGOSZCZ",
        "85153": "BYDGOSZCZ",
        "85154": "BYDGOSZCZ",
        "85155": "BYDGOSZCZ",
        "85156": "BYDGOSZCZ",
        "85157": "BYDGOSZCZ",
        "85158": "BYDGOSZCZ",
        "85159": "BYDGOSZCZ",
        "85160": "BYDGOSZCZ",
        "85161": "BYDGOSZCZ",
        "85162": "BYDGOSZCZ",
        "85163": "BYDGOSZCZ",
        "85164": "BYDGOSZCZ",
        "85165": "BYDGOSZCZ",
        "85166": "BYDGOSZCZ",
        "85167": "BYDGOSZCZ",
        "85168": "BYDGOSZCZ",
        "85169": "BYDGOSZCZ",
        "85170": "BYDGOSZCZ",
        "85171": "BYDGOSZCZ",
        "85172": "BYDGOSZCZ",
        "85174": "BYDGOSZCZ",
        "85176": "BYDGOSZCZ",
        "85177": "BYDGOSZCZ",
        "85178": "BYDGOSZCZ",
        "85179": "BYDGOSZCZ",
        "85181": "BYDGOSZCZ",
        "85182": "BYDGOSZCZ",
        "85183": "BYDGOSZCZ",
        "85184": "BYDGOSZCZ",
        "85185": "BYDGOSZCZ",
        "85186": "BYDGOSZCZ",
        "85188": "BYDGOSZCZ",
        "85189": "BYDGOSZCZ",
        "85195": "BYDGOSZCZ",
        "85198": "BYDGOSZCZ",
        "85200": "BYDGOSZCZ",
        "85201": "BYDGOSZCZ",
        "85202": "BYDGOSZCZ",
        "85203": "BYDGOSZCZ",
        "85204": "BYDGOSZCZ",
        "85205": "BYDGOSZCZ",
        "85206": "BYDGOSZCZ",
        "85207": "BYDGOSZCZ",
        "85208": "BYDGOSZCZ",
        "85209": "BYDGOSZCZ",
        "85210": "BYDGOSZCZ",
        "85211": "BYDGOSZCZ",
        "85212": "BYDGOSZCZ",
        "85213": "BYDGOSZCZ",
        "85214": "BYDGOSZCZ",
        "85215": "BYDGOSZCZ",
        "85216": "BYDGOSZCZ",
        "85217": "BYDGOSZCZ",
        "85218": "BYDGOSZCZ",
        "85219": "BYDGOSZCZ",
        "85220": "BYDGOSZCZ",
        "85222": "BYDGOSZCZ",
        "85223": "BYDGOSZCZ",
        "85224": "BYDGOSZCZ",
        "85225": "BYDGOSZCZ",
        "85226": "BYDGOSZCZ",
        "85227": "BYDGOSZCZ",
        "85228": "BYDGOSZCZ",
        "85229": "BYDGOSZCZ",
        "85230": "BYDGOSZCZ",
        "85231": "BYDGOSZCZ",
        "85232": "BYDGOSZCZ",
        "85233": "BYDGOSZCZ",
        "85234": "BYDGOSZCZ",
        "85235": "BYDGOSZCZ",
        "85236": "BYDGOSZCZ",
        "85237": "BYDGOSZCZ",
        "85238": "BYDGOSZCZ",
        "85239": "BYDGOSZCZ",
        "85240": "BYDGOSZCZ",
        "85241": "BYDGOSZCZ",
        "85242": "BYDGOSZCZ",
        "85300": "BYDGOSZCZ",
        "85301": "BYDGOSZCZ",
        "85302": "BYDGOSZCZ",
        "85303": "BYDGOSZCZ",
        "85304": "BYDGOSZCZ",
        "85305": "BYDGOSZCZ",
        "85306": "BYDGOSZCZ",
        "85307": "BYDGOSZCZ",
        "85308": "BYDGOSZCZ",
        "85309": "BYDGOSZCZ",
        "85311": "BYDGOSZCZ",
        "85312": "BYDGOSZCZ",
        "85313": "BYDGOSZCZ",
        "85314": "BYDGOSZCZ",
        "85315": "BYDGOSZCZ",
        "85316": "BYDGOSZCZ",
        "85317": "BYDGOSZCZ",
        "85318": "BYDGOSZCZ",
        "85319": "BYDGOSZCZ",
        "85320": "BYDGOSZCZ",
        "85321": "BYDGOSZCZ",
        "85322": "BYDGOSZCZ",
        "85323": "BYDGOSZCZ",
        "85324": "BYDGOSZCZ",
        "85325": "BYDGOSZCZ",
        "85326": "BYDGOSZCZ",
        "85327": "BYDGOSZCZ",
        "85328": "BYDGOSZCZ",
        "85329": "BYDGOSZCZ",
        "85330": "BYDGOSZCZ",
        "85331": "BYDGOSZCZ",
        "85332": "BYDGOSZCZ",
        "85333": "BYDGOSZCZ",
        "85334": "BYDGOSZCZ",
        "85335": "BYDGOSZCZ",
        "85336": "BYDGOSZCZ",
        "85337": "BYDGOSZCZ",
        "85338": "BYDGOSZCZ",
        "85339": "BYDGOSZCZ",
        "85340": "BYDGOSZCZ",
        "85341": "BYDGOSZCZ",
        "85342": "BYDGOSZCZ",
        "85343": "BYDGOSZCZ",
        "85344": "BYDGOSZCZ",
        "85345": "BYDGOSZCZ",
        "85346": "BYDGOSZCZ",
        "85347": "BYDGOSZCZ",
        "85348": "BYDGOSZCZ",
        "85349": "BYDGOSZCZ",
        "85350": "BYDGOSZCZ",
        "85351": "BYDGOSZCZ",
        "85352": "BYDGOSZCZ",
        "85353": "BYDGOSZCZ",
        "85354": "BYDGOSZCZ",
        "85355": "BYDGOSZCZ",
        "85356": "BYDGOSZCZ",
        "85357": "BYDGOSZCZ",
        "85358": "BYDGOSZCZ",
        "85359": "BYDGOSZCZ",
        "85360": "BYDGOSZCZ",
        "85361": "BYDGOSZCZ",
        "85362": "BYDGOSZCZ",
        "85363": "BYDGOSZCZ",
        "85364": "BYDGOSZCZ",
        "85365": "BYDGOSZCZ",
        "85366": "BYDGOSZCZ",
        "85367": "BYDGOSZCZ",
        "85368": "BYDGOSZCZ",
        "85369": "BYDGOSZCZ",
        "85370": "BYDGOSZCZ",
        "85371": "BYDGOSZCZ",
        "85372": "BYDGOSZCZ",
        "85373": "BYDGOSZCZ",
        "85374": "BYDGOSZCZ",
        "85375": "BYDGOSZCZ",
        "85376": "BYDGOSZCZ",
        "85377": "BYDGOSZCZ",
        "85378": "BYDGOSZCZ",
        "85379": "BYDGOSZCZ",
        "85380": "BYDGOSZCZ",
        "85381": "BYDGOSZCZ",
        "85382": "BYDGOSZCZ",
        "85383": "BYDGOSZCZ",
        "85384": "BYDGOSZCZ",
        "85385": "BYDGOSZCZ",
        "85386": "BYDGOSZCZ",
        "85387": "BYDGOSZCZ",
        "85388": "BYDGOSZCZ",
        "85389": "BYDGOSZCZ",
        "85390": "BYDGOSZCZ",
        "85391": "BYDGOSZCZ",
        "85392": "BYDGOSZCZ",
        "85395": "BYDGOSZCZ",
        "85401": "BYDGOSZCZ",
        "85402": "BYDGOSZCZ",
        "85403": "BYDGOSZCZ",
        "85404": "BYDGOSZCZ",
        "85405": "BYDGOSZCZ",
        "85406": "BYDGOSZCZ",
        "85407": "BYDGOSZCZ",
        "85408": "BYDGOSZCZ",
        "85409": "BYDGOSZCZ",
        "85410": "BYDGOSZCZ",
        "85411": "BYDGOSZCZ",
        "85412": "BYDGOSZCZ",
        "85413": "BYDGOSZCZ",
        "85414": "BYDGOSZCZ",
        "85415": "BYDGOSZCZ",
        "85416": "BYDGOSZCZ",
        "85417": "BYDGOSZCZ",
        "85418": "BYDGOSZCZ",
        "85419": "BYDGOSZCZ",
        "85420": "BYDGOSZCZ",
        "85421": "BYDGOSZCZ",
        "85422": "BYDGOSZCZ",
        "85423": "BYDGOSZCZ",
        "85424": "BYDGOSZCZ",
        "85425": "BYDGOSZCZ",
        "85426": "BYDGOSZCZ",
        "85427": "BYDGOSZCZ",
        "85428": "BYDGOSZCZ",
        "85429": "BYDGOSZCZ",
        "85430": "BYDGOSZCZ",
        "85431": "BYDGOSZCZ",
        "85432": "BYDGOSZCZ",
        "85433": "BYDGOSZCZ",
        "85434": "BYDGOSZCZ",
        "85435": "BYDGOSZCZ",
        "85436": "BYDGOSZCZ",
        "85437": "BYDGOSZCZ",
        "85438": "BYDGOSZCZ",
        "85439": "BYDGOSZCZ",
        "85440": "BYDGOSZCZ",
        "85441": "BYDGOSZCZ",
        "85443": "BYDGOSZCZ",
        "85444": "BYDGOSZCZ",
        "85445": "BYDGOSZCZ",
        "85446": "BYDGOSZCZ",
        "85447": "BYDGOSZCZ",
        "85448": "BYDGOSZCZ",
        "85449": "BYDGOSZCZ",
        "85450": "BYDGOSZCZ",
        "85451": "BYDGOSZCZ",
        "85452": "BYDGOSZCZ",
        "85453": "BYDGOSZCZ",
        "85454": "BYDGOSZCZ",
        "85455": "BYDGOSZCZ",
        "85456": "BYDGOSZCZ",
        "85457": "BYDGOSZCZ",
        "85458": "BYDGOSZCZ",
        "85459": "BYDGOSZCZ",
        "85460": "BYDGOSZCZ",
        "85461": "BYDGOSZCZ",
        "85462": "BYDGOSZCZ",
        "85463": "BYDGOSZCZ",
        "85464": "BYDGOSZCZ",
        "85465": "BYDGOSZCZ",
        "85466": "BYDGOSZCZ",
        "85467": "BYDGOSZCZ",
        "85468": "BYDGOSZCZ",
        "85469": "BYDGOSZCZ",
        "85470": "BYDGOSZCZ",
        "85471": "BYDGOSZCZ",
        "85472": "BYDGOSZCZ",
        "85473": "BYDGOSZCZ",
        "85474": "BYDGOSZCZ",
        "85475": "BYDGOSZCZ",
        "85476": "BYDGOSZCZ",
        "85477": "BYDGOSZCZ",
        "85478": "BYDGOSZCZ",
        "85479": "BYDGOSZCZ",
        "85480": "BYDGOSZCZ",
        "85481": "BYDGOSZCZ",
        "85482": "BYDGOSZCZ",
        "85483": "BYDGOSZCZ",
        "85485": "BYDGOSZCZ",
        "85501": "BYDGOSZCZ",
        "85502": "BYDGOSZCZ",
        "85503": "BYDGOSZCZ",
        "85504": "BYDGOSZCZ",
        "85505": "BYDGOSZCZ",
        "85506": "BYDGOSZCZ",
        "85507": "BYDGOSZCZ",
        "85508": "BYDGOSZCZ",
        "85509": "BYDGOSZCZ",
        "85510": "BYDGOSZCZ",
        "85511": "BYDGOSZCZ",
        "85513": "BYDGOSZCZ",
        "85514": "BYDGOSZCZ",
        "85515": "BYDGOSZCZ",
        "85516": "BYDGOSZCZ",
        "85517": "BYDGOSZCZ",
        "85518": "BYDGOSZCZ",
        "85519": "BYDGOSZCZ",
        "85520": "BYDGOSZCZ",
        "85521": "BYDGOSZCZ",
        "85522": "BYDGOSZCZ",
        "85523": "BYDGOSZCZ",
        "85524": "BYDGOSZCZ",
        "85525": "BYDGOSZCZ",
        "85526": "BYDGOSZCZ",
        "85527": "BYDGOSZCZ",
        "85528": "BYDGOSZCZ",
        "85529": "BYDGOSZCZ",
        "85530": "BYDGOSZCZ",
        "85531": "BYDGOSZCZ",
        "85532": "BYDGOSZCZ",
        "85533": "BYDGOSZCZ",
        "85534": "BYDGOSZCZ",
        "85535": "BYDGOSZCZ",
        "85536": "BYDGOSZCZ",
        "85537": "BYDGOSZCZ",
        "85539": "BYDGOSZCZ",
        "85540": "BYDGOSZCZ",
        "85541": "BYDGOSZCZ",
        "85542": "BYDGOSZCZ",
        "85543": "BYDGOSZCZ",
        "85544": "BYDGOSZCZ",
        "85545": "BYDGOSZCZ",
        "85546": "BYDGOSZCZ",
        "85547": "BYDGOSZCZ",
        "85548": "BYDGOSZCZ",
        "85549": "BYDGOSZCZ",
        "85550": "BYDGOSZCZ",
        "85551": "BYDGOSZCZ",
        "85552": "BYDGOSZCZ",
        "85553": "BYDGOSZCZ",
        "85554": "BYDGOSZCZ",
        "85555": "BYDGOSZCZ",
        "85556": "BYDGOSZCZ",
        "85557": "BYDGOSZCZ",
        "85558": "BYDGOSZCZ",
        "85560": "BYDGOSZCZ",
        "85561": "BYDGOSZCZ",
        "85562": "BYDGOSZCZ",
        "85563": "BYDGOSZCZ",
        "85564": "BYDGOSZCZ",
        "85565": "BYDGOSZCZ",
        "85566": "BYDGOSZCZ",
        "85567": "BYDGOSZCZ",
        "85568": "BYDGOSZCZ",
        "85569": "BYDGOSZCZ",
        "85570": "BYDGOSZCZ",
        "85601": "BYDGOSZCZ",
        "85602": "BYDGOSZCZ",
        "85603": "BYDGOSZCZ",
        "85604": "BYDGOSZCZ",
        "85605": "BYDGOSZCZ",
        "85606": "BYDGOSZCZ",
        "85609": "BYDGOSZCZ",
        "85613": "BYDGOSZCZ",
        "85614": "BYDGOSZCZ",
        "85615": "BYDGOSZCZ",
        "85616": "BYDGOSZCZ",
        "85617": "BYDGOSZCZ",
        "85619": "BYDGOSZCZ",
        "85620": "BYDGOSZCZ",
        "85621": "BYDGOSZCZ",
        "85622": "BYDGOSZCZ",
        "85624": "BYDGOSZCZ",
        "85625": "BYDGOSZCZ",
        "85626": "BYDGOSZCZ",
        "85627": "BYDGOSZCZ",
        "85628": "BYDGOSZCZ",
        "85630": "BYDGOSZCZ",
        "85631": "BYDGOSZCZ",
        "85632": "BYDGOSZCZ",
        "85634": "BYDGOSZCZ",
        "85635": "BYDGOSZCZ",
        "85636": "BYDGOSZCZ",
        "85637": "BYDGOSZCZ",
        "85638": "BYDGOSZCZ",
        "85640": "BYDGOSZCZ",
        "85641": "BYDGOSZCZ",
        "85642": "BYDGOSZCZ",
        "85643": "BYDGOSZCZ",
        "85644": "BYDGOSZCZ",
        "85645": "BYDGOSZCZ",
        "85646": "BYDGOSZCZ",
        "85647": "BYDGOSZCZ",
        "85650": "BYDGOSZCZ",
        "85651": "BYDGOSZCZ",
        "85652": "BYDGOSZCZ",
        "85654": "BYDGOSZCZ",
        "85655": "BYDGOSZCZ",
        "85656": "BYDGOSZCZ",
        "85657": "BYDGOSZCZ",
        "85658": "BYDGOSZCZ",
        "85659": "BYDGOSZCZ",
        "85660": "BYDGOSZCZ",
        "85661": "BYDGOSZCZ",
        "85664": "BYDGOSZCZ",
        "85665": "BYDGOSZCZ",
        "85666": "BYDGOSZCZ",
        "85667": "BYDGOSZCZ",
        "85668": "BYDGOSZCZ",
        "85669": "BYDGOSZCZ",
        "85670": "BYDGOSZCZ",
        "85671": "BYDGOSZCZ",
        "85674": "BYDGOSZCZ",
        "85675": "BYDGOSZCZ",
        "85676": "BYDGOSZCZ",
        "85677": "BYDGOSZCZ",
        "85680": "BYDGOSZCZ",
        "85681": "BYDGOSZCZ",
        "85684": "BYDGOSZCZ",
        "85685": "BYDGOSZCZ",
        "85686": "BYDGOSZCZ",
        "85687": "BYDGOSZCZ",
        "85689": "BYDGOSZCZ",
        "85700": "BYDGOSZCZ",
        "85701": "BYDGOSZCZ",
        "85703": "BYDGOSZCZ",
        "85704": "BYDGOSZCZ",
        "85706": "BYDGOSZCZ",
        "85707": "BYDGOSZCZ",
        "85708": "BYDGOSZCZ",
        "85709": "BYDGOSZCZ",
        "85710": "BYDGOSZCZ",
        "85711": "BYDGOSZCZ",
        "85712": "BYDGOSZCZ",
        "85713": "BYDGOSZCZ",
        "85714": "BYDGOSZCZ",
        "85715": "BYDGOSZCZ",
        "85717": "BYDGOSZCZ",
        "85718": "BYDGOSZCZ",
        "85719": "BYDGOSZCZ",
        "85720": "BYDGOSZCZ",
        "85721": "BYDGOSZCZ",
        "85722": "BYDGOSZCZ",
        "85723": "BYDGOSZCZ",
        "85724": "BYDGOSZCZ",
        "85726": "BYDGOSZCZ",
        "85727": "BYDGOSZCZ",
        "85728": "BYDGOSZCZ",
        "85729": "BYDGOSZCZ",
        "85730": "BYDGOSZCZ",
        "85731": "BYDGOSZCZ",
        "85733": "BYDGOSZCZ",
        "85734": "BYDGOSZCZ",
        "85735": "BYDGOSZCZ",
        "85736": "BYDGOSZCZ",
        "85737": "BYDGOSZCZ",
        "85738": "BYDGOSZCZ",
        "85739": "BYDGOSZCZ",
        "85740": "BYDGOSZCZ",
        "85741": "BYDGOSZCZ",
        "85742": "BYDGOSZCZ",
        "85744": "BYDGOSZCZ",
        "85746": "BYDGOSZCZ",
        "85748": "BYDGOSZCZ",
        "85749": "BYDGOSZCZ",
        "85750": "BYDGOSZCZ",
        "85751": "BYDGOSZCZ",
        "85752": "BYDGOSZCZ",
        "85753": "BYDGOSZCZ",
        "85754": "BYDGOSZCZ",
        "85755": "BYDGOSZCZ",
        "85756": "BYDGOSZCZ",
        "85757": "BYDGOSZCZ",
        "85758": "BYDGOSZCZ",
        "85759": "BYDGOSZCZ",
        "85764": "BYDGOSZCZ",
        "85765": "BYDGOSZCZ",
        "85766": "BYDGOSZCZ",
        "85767": "BYDGOSZCZ",
        "85768": "BYDGOSZCZ",
        "85769": "BYDGOSZCZ",
        "85770": "BYDGOSZCZ",
        "85771": "BYDGOSZCZ",
        "85772": "BYDGOSZCZ",
        "85773": "BYDGOSZCZ",
        "85774": "BYDGOSZCZ",
        "85775": "BYDGOSZCZ",
        "85776": "BYDGOSZCZ",
        "85777": "BYDGOSZCZ",
        "85778": "BYDGOSZCZ",
        "85779": "BYDGOSZCZ",
        "85780": "BYDGOSZCZ",
        "85782": "BYDGOSZCZ",
        "85787": "BYDGOSZCZ",
        "85788": "BYDGOSZCZ",
        "85789": "BYDGOSZCZ",
        "85790": "BYDGOSZCZ",
        "85791": "BYDGOSZCZ",
        "85792": "BYDGOSZCZ",
        "85793": "BYDGOSZCZ",
        "85794": "BYDGOSZCZ",
        "85795": "BYDGOSZCZ",
        "85796": "BYDGOSZCZ",
        "85797": "BYDGOSZCZ",
        "85798": "BYDGOSZCZ",
        "85799": "BYDGOSZCZ",
        "85800": "BYDGOSZCZ",
        "85801": "BYDGOSZCZ",
        "85802": "BYDGOSZCZ",
        "85803": "BYDGOSZCZ",
        "85804": "BYDGOSZCZ",
        "85805": "BYDGOSZCZ",
        "85806": "BYDGOSZCZ",
        "85807": "BYDGOSZCZ",
        "85808": "BYDGOSZCZ",
        "85809": "BYDGOSZCZ",
        "85810": "BYDGOSZCZ",
        "85811": "BYDGOSZCZ",
        "85812": "BYDGOSZCZ",
        "85813": "BYDGOSZCZ",
        "85814": "BYDGOSZCZ",
        "85815": "BYDGOSZCZ",
        "85816": "BYDGOSZCZ",
        "85817": "BYDGOSZCZ",
        "85818": "BYDGOSZCZ",
        "85819": "BYDGOSZCZ",
        "85820": "BYDGOSZCZ",
        "85821": "BYDGOSZCZ",
        "85822": "BYDGOSZCZ",
        "85823": "BYDGOSZCZ",
        "85824": "BYDGOSZCZ",
        "85825": "BYDGOSZCZ",
        "85826": "BYDGOSZCZ",
        "85827": "BYDGOSZCZ",
        "85828": "BYDGOSZCZ",
        "85829": "BYDGOSZCZ",
        "85830": "BYDGOSZCZ",
        "85831": "BYDGOSZCZ",
        "85832": "BYDGOSZCZ",
        "85833": "BYDGOSZCZ",
        "85834": "BYDGOSZCZ",
        "85835": "BYDGOSZCZ",
        "85836": "BYDGOSZCZ",
        "85837": "BYDGOSZCZ",
        "85838": "BYDGOSZCZ",
        "85839": "BYDGOSZCZ",
        "85840": "BYDGOSZCZ",
        "85841": "BYDGOSZCZ",
        "85843": "BYDGOSZCZ",
        "85844": "BYDGOSZCZ",
        "85845": "BYDGOSZCZ",
        "85846": "BYDGOSZCZ",
        "85847": "BYDGOSZCZ",
        "85849": "BYDGOSZCZ",
        "85850": "BYDGOSZCZ",
        "85851": "BYDGOSZCZ",
        "85852": "BYDGOSZCZ",
        "85853": "BYDGOSZCZ",
        "85854": "BYDGOSZCZ",
        "85855": "BYDGOSZCZ",
        "85856": "BYDGOSZCZ",
        "85857": "BYDGOSZCZ",
        "85858": "BYDGOSZCZ",
        "85859": "BYDGOSZCZ",
        "85860": "BYDGOSZCZ",
        "85861": "BYDGOSZCZ",
        "85862": "BYDGOSZCZ",
        "85863": "BYDGOSZCZ",
        "85864": "BYDGOSZCZ",
        "85865": "BYDGOSZCZ",
        "85866": "BYDGOSZCZ",
        "85867": "BYDGOSZCZ",
        "85868": "BYDGOSZCZ",
        "85869": "BYDGOSZCZ",
        "85870": "BYDGOSZCZ",
        "85871": "BYDGOSZCZ",
        "85872": "BYDGOSZCZ",
        "85873": "BYDGOSZCZ",
        "85874": "BYDGOSZCZ",
        "85875": "BYDGOSZCZ",
        "85876": "BYDGOSZCZ",
        "85877": "BYDGOSZCZ",
        "85879": "BYDGOSZCZ",
        "85880": "BYDGOSZCZ",
        "85881": "BYDGOSZCZ",
        "85882": "BYDGOSZCZ",
        "85883": "BYDGOSZCZ",
        "85884": "BYDGOSZCZ",
        "85885": "BYDGOSZCZ",
        "85886": "BYDGOSZCZ",
        "85888": "BYDGOSZCZ",
        "85889": "BYDGOSZCZ",
        "85890": "BYDGOSZCZ",
        "85891": "BYDGOSZCZ",
        "85892": "BYDGOSZCZ",
        "85893": "BYDGOSZCZ",
        "85894": "BYDGOSZCZ",
        "85895": "BYDGOSZCZ",
        "85900": "BYDGOSZCZ",
        "85915": "BYDGOSZCZ",
        "85940": "BYDGOSZCZ",
        "85950": "BYDGOSZCZ",
        "85980": "BYDGOSZCZ",
        "86005": "BYDGOSZCZ",
        "86008": "BYDGOSZCZ",
        "86010": "BYDGOSZCZ",
        "86011": "BYDGOSZCZ",
        "86013": "BYDGOSZCZ",
        "86014": "BYDGOSZCZ",
        "86015": "BYDGOSZCZ",
        "86016": "BYDGOSZCZ",
        "86017": "BYDGOSZCZ",
        "86020": "BYDGOSZCZ",
        "86021": "BYDGOSZCZ",
        "86022": "BYDGOSZCZ",
        "86031": "BYDGOSZCZ",
        "86032": "BYDGOSZCZ",
        "86050": "BYDGOSZCZ",
        "86055": "BYDGOSZCZ",
        "86060": "BYDGOSZCZ",
        "86061": "BYDGOSZCZ",
        "86065": "BYDGOSZCZ",
        "86070": "BYDGOSZCZ",
        "86071": "BYDGOSZCZ",
        "86100": "ŚWIECIE (NET)",
        "86101": "ŚWIECIE (NET)",
        "86102": "ŚWIECIE (NET)",
        "86105": "ŚWIECIE (NET)",
        "86111": "ŚWIECIE (NET)",
        "86120": "ŚWIECIE",
        "86122": "BUKOWIEC",
        "86130": "ŚWIECIE (NET)",
        "86131": "ŚWIECIE (NET)",
        "86132": "ŚWIECIE (NET)",
        "86134": "ŚWIECIE (NET)",
        "86140": "ŚWIECIE (NET)",
        "86141": "ŚWIECIE (NET)",
        "86150": "ŚWIECIE (NET)",
        "86160": "ŚWIECIE (NET)",
        "86170": "ŚWIECIE (NET)",
        "86173": "ŚWIECIE (NET)",
        "86181": "ŚWIECIE",
        "86182": "ŚWIECIE",
        "86200": "CHEŁMNO (NET)",
        "86202": "CHEŁMNO (NET)",
        "86203": "CHEŁMNO (NET)",
        "86208": "CHEŁMNO (NET)",
        "86212": "CHEŁMNO (NET)",
        "86221": "CHEŁMNO (NET)",
        "86230": "CHEŁMNO (NET)",
        "86253": "CHEŁMNO (NET)",
        "86260": "CHEŁMNO",
        "86300": "GRUDZIĄDZ",
        "86301": "GRUDZIĄDZ",
        "86302": "GRUDZIĄDZ",
        "86303": "GRUDZIĄDZ",
        "86304": "GRUDZIĄDZ",
        "86305": "GRUDZIĄDZ",
        "86306": "GRUDZIĄDZ",
        "86307": "GRUDZIĄDZ",
        "86308": "GRUDZIĄDZ",
        "86309": "GRUDZIĄDZ",
        "86311": "GRUDZIĄDZ",
        "86318": "GRUDZIĄDZ",
        "86320": "GRUDZIĄDZ",
        "86327": "GRUDZIĄDZ",
        "86330": "GRUDZIĄDZ",
        "86341": "GRUDZIĄDZ",
        "86342": "GRUDZIĄDZ",
        "86380": "GRUDZIĄDZ",
        "87100": "TORUŃ",
        "87101": "TORUŃ",
        "87102": "TORUŃ",
        "87103": "TORUŃ",
        "87104": "TORUŃ",
        "87105": "TORUŃ",
        "87106": "TORUŃ",
        "87107": "TORUŃ",
        "87108": "TORUŃ",
        "87109": "TORUŃ",
        "87110": "TORUŃ",
        "87111": "TORUŃ",
        "87112": "TORUŃ",
        "87113": "TORUŃ",
        "87114": "TORUŃ",
        "87115": "TORUŃ",
        "87116": "TORUŃ",
        "87117": "TORUŃ",
        "87118": "TORUŃ",
        "87119": "TORUŃ",
        "87120": "TORUŃ",
        "87122": "TORUŃ",
        "87123": "TORUŃ",
        "87124": "TORUŃ",
        "87125": "TORUŃ",
        "87126": "TORUŃ",
        "87127": "TORUŃ",
        "87133": "TORUŃ",
        "87134": "TORUŃ",
        "87140": "CHEŁMŻA",
        "87141": "BRODNICA",
        "87148": "TORUŃ",
        "87152": "TORUŃ",
        "87162": "TORUŃ",
        "87165": "TORUŃ",
        "87200": "WĄBRZEŹNO",
        "87201": "WĄBRZEŹNO",
        "87207": "WĄBRZEŹNO",
        "87213": "WĄBRZEŹNO",
        "87214": "WĄBRZEŹNO",
        "87220": "GRUDZIĄDZ",
        "87222": "WĄBRZEŹNO",
        "87300": "BRODNICA",
        "87301": "BRODNICA",
        "87302": "BRODNICA",
        "87305": "BRODNICA",
        "87312": "BRODNICA",
        "87313": "BRODNICA",
        "87320": "BRODNICA",
        "87321": "BRODNICA",
        "87322": "BRODNICA",
        "87325": "BRODNICA",
        "87326": "BRODNICA",
        "87327": "BRODNICA",
        "87330": "BRODNICA",
        "87335": "BRODNICA",
        "87337": "RYPIN",
        "87340": "BRODNICA",
        "87400": "GOLUB-DOBRZYŃ",
        "87401": "GOLUB-DOBRZYŃ",
        "87404": "GOLUB-DOBRZYŃ",
        "87408": "GOLUB-DOBRZYŃ",
        "87410": "GOLUB-DOBRZYŃ",
        "87423": "GOLUB-DOBRZYŃ",
        "87500": "RYPIN",
        "87501": "RYPIN",
        "87506": "RYPIN",
        "87510": "RYPIN",
        "87511": "RYPIN",
        "87512": "RYPIN",
        "87513": "RYPIN",
        "87514": "RYPIN",
        "87515": "RYPIN",
        "87516": "RYPIN",
        "87517": "RYPIN",
        "87521": "RYPIN",
        "87522": "RYPIN",
        "87600": "LIPNO",
        "87601": "LIPNO",
        "87602": "LIPNO",
        "87603": "LIPNO",
        "87605": "LIPNO",
        "87606": "LIPNO",
        "87607": "LIPNO",
        "87610": "LIPNO",
        "87611": "LIPNO",
        "87612": "LIPNO",
        "87615": "LIPNO",
        "87617": "LIPNO",
        "87618": "LIPNO",
        "87619": "LIPNO",
        "87620": "LIPNO",
        "87630": "LIPNO",
        "87632": "TORUŃ",
        "87640": "TORUŃ",
        "87641": "TORUŃ",
        "87645": "GOLUB-DOBRZYŃ",
        "87700": "ALEKSANDRÓW KUJAWSKI",
        "87702": "ALEKSANDRÓW KUJAWSKI",
        "87703": "ALEKSANDRÓW KUJAWSKI",
        "87704": "ALEKSANDRÓW KUJAWSKI",
        "87705": "ALEKSANDRÓW KUJAWSKI",
        "87706": "ALEKSANDRÓW KUJAWSKI",
        "87707": "ALEKSANDRÓW KUJAWSKI",
        "87708": "ALEKSANDRÓW KUJAWSKI",
        "87710": "ALEKSANDRÓW KUJAWSKI",
        "87712": "ALEKSANDRÓW KUJAWSKI",
        "87720": "CIECHOCINEK",
        "87721": "ALEKSANDRÓW KUJAWSKI",
        "87722": "CIECHOCINEK",
        "87730": "ALEKSANDRÓW KUJAWSKI",
        "87731": "ALEKSANDRÓW KUJAWSKI",
        "87732": "WŁOCŁAWEK",
        "87800": "WŁOCŁAWEK",
        "87801": "WŁOCŁAWEK",
        "87802": "WŁOCŁAWEK",
        "87803": "WŁOCŁAWEK",
        "87804": "WŁOCŁAWEK",
        "87805": "WŁOCŁAWEK",
        "87806": "WŁOCŁAWEK",
        "87807": "WŁOCŁAWEK",
        "87808": "WŁOCŁAWEK",
        "87809": "WŁOCŁAWEK",
        "87810": "WŁOCŁAWEK",
        "87811": "WŁOCŁAWEK",
        "87812": "WŁOCŁAWEK",
        "87814": "WŁOCŁAWEK",
        "87815": "WŁOCŁAWEK",
        "87816": "WŁOCŁAWEK",
        "87817": "WŁOCŁAWEK",
        "87818": "WŁOCŁAWEK",
        "87820": "WŁOCŁAWEK",
        "87821": "WŁOCŁAWEK",
        "87822": "WŁOCŁAWEK",
        "87823": "WŁOCŁAWEK",
        "87830": "WŁOCŁAWEK",
        "87840": "WŁOCŁAWEK",
        "87850": "WŁOCŁAWEK",
        "87851": "WŁOCŁAWEK",
        "87852": "WŁOCŁAWEK",
        "87853": "WŁOCŁAWEK",
        "87860": "WŁOCŁAWEK",
        "87865": "WŁOCŁAWEK",
        "87866": "WŁOCŁAWEK",
        "87875": "RADZIEJÓW",
        "87880": "WŁOCŁAWEK",
        "87890": "WŁOCŁAWEK",
        "87891": "WŁOCŁAWEK",
        "88100": "INOWROCŁAW",
        "88101": "INOWROCŁAW",
        "88102": "INOWROCŁAW",
        "88103": "INOWROCŁAW",
        "88104": "INOWROCŁAW",
        "88105": "INOWROCŁAW",
        "88106": "INOWROCŁAW",
        "88107": "INOWROCŁAW",
        "88108": "INOWROCŁAW",
        "88109": "INOWROCŁAW",
        "88110": "INOWROCŁAW",
        "88111": "INOWROCŁAW (NET)",
        "88112": "INOWROCŁAW",
        "88115": "INOWROCŁAW",
        "88121": "INOWROCŁAW (NET)",
        "88126": "INOWROCŁAW (NET)",
        "88133": "INOWROCŁAW (NET)",
        "88140": "INOWROCŁAW (NET)",
        "88150": "KRUSZWICA",
        "88153": "KRUSZWICA",
        "88160": "INOWROCŁAW (NET)",
        "88170": "INOWROCŁAW (NET)",
        "88180": "INOWROCŁAW (NET)",
        "88181": "INOWROCŁAW (NET)",
        "88190": "BARCIN",
        "88192": "ŻNIN (NET)",
        "88193": "BARCIN",
        "88200": "RADZIEJÓW",
        "88210": "RADZIEJÓW",
        "88220": "RADZIEJÓW",
        "88230": "RADZIEJÓW",
        "88231": "RADZIEJÓW",
        "88232": "RADZIEJÓW",
        "88234": "INOWROCŁAW",
        "88235": "RADZIEJÓW",
        "88237": "RADZIEJÓW",
        "88300": "MOGILNO",
        "88301": "MOGILNO",
        "88306": "MOGILNO",
        "88312": "MOGILNO",
        "88320": "MOGILNO",
        "88321": "MOGILNO",
        "88322": "MOGILNO",
        "88324": "MOGILNO",
        "88330": "MOGILNO",
        "88342": "MOGILNO",
        "88400": "ŻNIN (NET)",
        "88401": "ŻNIN (NET)",
        "88402": "ŻNIN (NET)",
        "88404": "ŻNIN (NET)",
        "88405": "ŻNIN (NET)",
        "88409": "ŻNIN (NET)",
        "88410": "ŻNIN (NET)",
        "88420": "ŻNIN (NET)",
        "88422": "ŻNIN (NET)",
        "88430": "ŻNIN (NET)",
        "89100": "NAKŁO NAD NOTECIĄ",
        "89103": "NAKŁO NAD NOTECIĄ",
        "89104": "NAKŁO NAD NOTECIĄ",
        "89110": "NAKŁO NAD NOTECIĄ",
        "89115": "NAKŁO NAD NOTECIĄ",
        "89120": "NAKŁO NAD NOTECIĄ",
        "89121": "NAKŁO NAD NOTECIĄ",
        "89122": "NAKŁO NAD NOTECIĄ",
        "89200": "SZUBIN",
        "89203": "NAKŁO NAD NOTECIĄ",
        "89205": "NAKŁO NAD NOTECIĄ",
        "89210": "ŻNIN",
        "89211": "ŻNIN",
        "89240": "NAKŁO NAD NOTECIĄ",
        "89241": "NAKŁO NAD NOTECIĄ",
        "89300": "WYRZYSK",
        "89310": "PIŁA",
        "89311": "PIŁA",
        "89312": "PIŁA",
        "89320": "PIŁA",
        "89321": "PIŁA",
        "89333": "PIŁA",
        "89334": "PIŁA",
        "89340": "PIŁA",
        "89350": "PIŁA",
        "89400": "SĘPÓLNO KRAJEŃSKIE",
        "89405": "PIŁA",
        "89410": "SĘPÓLNO KRAJEŃSKIE",
        "89412": "SĘPÓLNO KRAJEŃSKIE",
        "89413": "SĘPÓLNO KRAJEŃSKIE",
        "89422": "SĘPÓLNO KRAJEŃSKIE",
        "89430": "SĘPÓLNO KRAJEŃSKIE",
        "89500": "TUCHOLA",
        "89501": "TUCHOLA",
        "89502": "PIŁA",
        "89504": "TUCHOLA",
        "89505": "TUCHOLA",
        "89506": "TUCHOLA",
        "89510": "TUCHOLA",
        "89511": "TUCHOLA",
        "89512": "TUCHOLA",
        "89520": "TUCHOLA",
        "89524": "PIŁA",
        "89525": "TUCHOLA",
        "89526": "TUCHOLA",
        "89530": "TUCHOLA",
        "89600": "CHOJNICE",
        "89601": "CHOJNICE",
        "89604": "CHOJNICE",
        "89606": "CHOJNICE",
        "89607": "CHOJNICE",
        "89608": "CHOJNICE",
        "89620": "CHOJNICE",
        "89632": "CHOJNICE",
        "89634": "CHOJNICE",
        "89641": "CHOJNICE",
        "89642": "CHOJNICE",
        "89650": "CHOJNICE",
        "89651": "CHOJNICE",
        "89652": "CHOJNICE",
        "89665": "CHOJNICE",
        "90001": "ŁÓDŹ",
        "90002": "ŁÓDŹ",
        "90003": "ŁÓDŹ",
        "90004": "ŁÓDŹ",
        "90005": "ŁÓDŹ",
        "90006": "ŁÓDŹ",
        "90007": "ŁÓDŹ",
        "90008": "ŁÓDŹ",
        "90009": "ŁÓDŹ",
        "90010": "ŁÓDŹ",
        "90011": "ŁÓDŹ",
        "90012": "ŁÓDŹ",
        "90013": "ŁÓDŹ",
        "90014": "ŁÓDŹ",
        "90015": "ŁÓDŹ",
        "90016": "ŁÓDŹ",
        "90018": "ŁÓDŹ",
        "90019": "ŁÓDŹ",
        "90020": "ŁÓDŹ",
        "90021": "ŁÓDŹ",
        "90022": "ŁÓDŹ",
        "90023": "ŁÓDŹ",
        "90024": "ŁÓDŹ",
        "90025": "ŁÓDŹ",
        "90026": "ŁÓDŹ",
        "90028": "ŁÓDŹ",
        "90029": "ŁÓDŹ",
        "90030": "ŁÓDŹ",
        "90031": "ŁÓDŹ",
        "90032": "ŁÓDŹ",
        "90033": "ŁÓDŹ",
        "90034": "ŁÓDŹ",
        "90035": "ŁÓDŹ",
        "90036": "ŁÓDŹ",
        "90037": "ŁÓDŹ",
        "90038": "ŁÓDŹ",
        "90039": "ŁÓDŹ",
        "90040": "ŁÓDŹ",
        "90042": "ŁÓDŹ",
        "90043": "ŁÓDŹ",
        "90045": "ŁÓDŹ",
        "90046": "ŁÓDŹ",
        "90047": "ŁÓDŹ",
        "90049": "ŁÓDŹ",
        "90050": "ŁÓDŹ",
        "90051": "ŁÓDŹ",
        "90052": "ŁÓDŹ",
        "90053": "ŁÓDŹ",
        "90054": "ŁÓDŹ",
        "90055": "ŁÓDŹ",
        "90056": "ŁÓDŹ",
        "90057": "ŁÓDŹ",
        "90058": "ŁÓDŹ",
        "90060": "ŁÓDŹ",
        "90061": "ŁÓDŹ",
        "90062": "ŁÓDŹ",
        "90063": "ŁÓDŹ",
        "90101": "ŁÓDŹ",
        "90102": "ŁÓDŹ",
        "90103": "ŁÓDŹ",
        "90105": "ŁÓDŹ",
        "90106": "ŁÓDŹ",
        "90107": "ŁÓDŹ",
        "90110": "ŁÓDŹ",
        "90111": "ŁÓDŹ",
        "90113": "ŁÓDŹ",
        "90114": "ŁÓDŹ",
        "90116": "ŁÓDŹ",
        "90117": "ŁÓDŹ",
        "90118": "ŁÓDŹ",
        "90119": "ŁÓDŹ",
        "90123": "ŁÓDŹ",
        "90124": "ŁÓDŹ",
        "90125": "ŁÓDŹ",
        "90126": "ŁÓDŹ",
        "90127": "ŁÓDŹ",
        "90128": "ŁÓDŹ",
        "90129": "ŁÓDŹ",
        "90130": "ŁÓDŹ",
        "90131": "ŁÓDŹ",
        "90132": "ŁÓDŹ",
        "90133": "ŁÓDŹ",
        "90135": "ŁÓDŹ",
        "90136": "ŁÓDŹ",
        "90137": "ŁÓDŹ",
        "90138": "ŁÓDŹ",
        "90139": "ŁÓDŹ",
        "90140": "ŁÓDŹ",
        "90141": "ŁÓDŹ",
        "90142": "ŁÓDŹ",
        "90143": "ŁÓDŹ",
        "90145": "ŁÓDŹ",
        "90146": "ŁÓDŹ",
        "90147": "ŁÓDŹ",
        "90148": "ŁÓDŹ",
        "90149": "ŁÓDŹ",
        "90150": "ŁÓDŹ",
        "90151": "ŁÓDŹ",
        "90153": "ŁÓDŹ",
        "90154": "ŁÓDŹ",
        "90155": "ŁÓDŹ",
        "90156": "ŁÓDŹ",
        "90157": "ŁÓDŹ",
        "90158": "ŁÓDŹ",
        "90159": "ŁÓDŹ",
        "90160": "ŁÓDŹ",
        "90161": "ŁÓDŹ",
        "90201": "ŁÓDŹ",
        "90202": "ŁÓDŹ",
        "90203": "ŁÓDŹ",
        "90204": "ŁÓDŹ",
        "90205": "ŁÓDŹ",
        "90206": "ŁÓDŹ",
        "90207": "ŁÓDŹ",
        "90208": "ŁÓDŹ",
        "90209": "ŁÓDŹ",
        "90210": "ŁÓDŹ",
        "90211": "ŁÓDŹ",
        "90212": "ŁÓDŹ",
        "90213": "ŁÓDŹ",
        "90214": "ŁÓDŹ",
        "90215": "ŁÓDŹ",
        "90216": "ŁÓDŹ",
        "90217": "ŁÓDŹ",
        "90218": "ŁÓDŹ",
        "90219": "ŁÓDŹ",
        "90220": "ŁÓDŹ",
        "90221": "ŁÓDŹ",
        "90222": "ŁÓDŹ",
        "90223": "ŁÓDŹ",
        "90224": "ŁÓDŹ",
        "90225": "ŁÓDŹ",
        "90226": "ŁÓDŹ",
        "90227": "ŁÓDŹ",
        "90228": "ŁÓDŹ",
        "90229": "ŁÓDŹ",
        "90231": "ŁÓDŹ",
        "90232": "ŁÓDŹ",
        "90233": "ŁÓDŹ",
        "90234": "ŁÓDŹ",
        "90235": "ŁÓDŹ",
        "90236": "ŁÓDŹ",
        "90237": "ŁÓDŹ",
        "90238": "ŁÓDŹ",
        "90241": "ŁÓDŹ",
        "90242": "ŁÓDŹ",
        "90243": "ŁÓDŹ",
        "90244": "ŁÓDŹ",
        "90245": "ŁÓDŹ",
        "90248": "ŁÓDŹ",
        "90249": "ŁÓDŹ",
        "90250": "ŁÓDŹ",
        "90251": "ŁÓDŹ",
        "90252": "ŁÓDŹ",
        "90253": "ŁÓDŹ",
        "90254": "ŁÓDŹ",
        "90255": "ŁÓDŹ",
        "90256": "ŁÓDŹ",
        "90257": "ŁÓDŹ",
        "90258": "ŁÓDŹ",
        "90259": "ŁÓDŹ",
        "90260": "ŁÓDŹ",
        "90261": "ŁÓDŹ",
        "90262": "ŁÓDŹ",
        "90263": "ŁÓDŹ",
        "90264": "ŁÓDŹ",
        "90265": "ŁÓDŹ",
        "90266": "ŁÓDŹ",
        "90267": "ŁÓDŹ",
        "90268": "ŁÓDŹ",
        "90269": "ŁÓDŹ",
        "90270": "ŁÓDŹ",
        "90271": "ŁÓDŹ",
        "90272": "ŁÓDŹ",
        "90273": "ŁÓDŹ",
        "90301": "ŁÓDŹ",
        "90302": "ŁÓDŹ",
        "90303": "ŁÓDŹ",
        "90306": "ŁÓDŹ",
        "90307": "ŁÓDŹ",
        "90312": "ŁÓDŹ",
        "90315": "ŁÓDŹ",
        "90316": "ŁÓDŹ",
        "90317": "ŁÓDŹ",
        "90318": "ŁÓDŹ",
        "90319": "ŁÓDŹ",
        "90322": "ŁÓDŹ",
        "90323": "ŁÓDŹ",
        "90324": "ŁÓDŹ",
        "90325": "ŁÓDŹ",
        "90326": "ŁÓDŹ",
        "90328": "ŁÓDŹ",
        "90329": "ŁÓDŹ",
        "90330": "ŁÓDŹ",
        "90331": "ŁÓDŹ",
        "90332": "ŁÓDŹ",
        "90333": "ŁÓDŹ",
        "90336": "ŁÓDŹ",
        "90337": "ŁÓDŹ",
        "90338": "ŁÓDŹ",
        "90339": "ŁÓDŹ",
        "90340": "ŁÓDŹ",
        "90341": "ŁÓDŹ",
        "90344": "ŁÓDŹ",
        "90345": "ŁÓDŹ",
        "90346": "ŁÓDŹ",
        "90347": "ŁÓDŹ",
        "90348": "ŁÓDŹ",
        "90349": "ŁÓDŹ",
        "90350": "ŁÓDŹ",
        "90351": "ŁÓDŹ",
        "90353": "ŁÓDŹ",
        "90354": "ŁÓDŹ",
        "90355": "ŁÓDŹ",
        "90357": "ŁÓDŹ",
        "90360": "ŁÓDŹ",
        "90361": "ŁÓDŹ",
        "90363": "ŁÓDŹ",
        "90364": "ŁÓDŹ",
        "90365": "ŁÓDŹ",
        "90368": "ŁÓDŹ",
        "90369": "ŁÓDŹ",
        "90401": "ŁÓDŹ",
        "90402": "ŁÓDŹ",
        "90403": "ŁÓDŹ",
        "90404": "ŁÓDŹ",
        "90406": "ŁÓDŹ",
        "90407": "ŁÓDŹ",
        "90408": "ŁÓDŹ",
        "90410": "ŁÓDŹ",
        "90411": "ŁÓDŹ",
        "90413": "ŁÓDŹ",
        "90414": "ŁÓDŹ",
        "90415": "ŁÓDŹ",
        "90416": "ŁÓDŹ",
        "90418": "ŁÓDŹ",
        "90419": "ŁÓDŹ",
        "90420": "ŁÓDŹ",
        "90421": "ŁÓDŹ",
        "90422": "ŁÓDŹ",
        "90423": "ŁÓDŹ",
        "90425": "ŁÓDŹ",
        "90426": "ŁÓDŹ",
        "90427": "ŁÓDŹ",
        "90428": "ŁÓDŹ",
        "90430": "ŁÓDŹ",
        "90431": "ŁÓDŹ",
        "90432": "ŁÓDŹ",
        "90434": "ŁÓDŹ",
        "90435": "ŁÓDŹ",
        "90436": "ŁÓDŹ",
        "90437": "ŁÓDŹ",
        "90440": "ŁÓDŹ",
        "90441": "ŁÓDŹ",
        "90442": "ŁÓDŹ",
        "90443": "ŁÓDŹ",
        "90446": "ŁÓDŹ",
        "90447": "ŁÓDŹ",
        "90448": "ŁÓDŹ",
        "90449": "ŁÓDŹ",
        "90450": "ŁÓDŹ",
        "90451": "ŁÓDŹ",
        "90452": "ŁÓDŹ",
        "90453": "ŁÓDŹ",
        "90456": "ŁÓDŹ",
        "90457": "ŁÓDŹ",
        "90458": "ŁÓDŹ",
        "90501": "ŁÓDŹ",
        "90502": "ŁÓDŹ",
        "90503": "ŁÓDŹ",
        "90505": "ŁÓDŹ",
        "90507": "ŁÓDŹ",
        "90508": "ŁÓDŹ",
        "90509": "ŁÓDŹ",
        "90510": "ŁÓDŹ",
        "90511": "ŁÓDŹ",
        "90513": "ŁÓDŹ",
        "90514": "ŁÓDŹ",
        "90515": "ŁÓDŹ",
        "90516": "ŁÓDŹ",
        "90517": "ŁÓDŹ",
        "90519": "ŁÓDŹ",
        "90520": "ŁÓDŹ",
        "90521": "ŁÓDŹ",
        "90522": "ŁÓDŹ",
        "90525": "ŁÓDŹ",
        "90526": "ŁÓDŹ",
        "90527": "ŁÓDŹ",
        "90528": "ŁÓDŹ",
        "90530": "ŁÓDŹ",
        "90531": "ŁÓDŹ",
        "90532": "ŁÓDŹ",
        "90536": "ŁÓDŹ",
        "90537": "ŁÓDŹ",
        "90539": "ŁÓDŹ",
        "90540": "ŁÓDŹ",
        "90541": "ŁÓDŹ",
        "90542": "ŁÓDŹ",
        "90543": "ŁÓDŹ",
        "90545": "ŁÓDŹ",
        "90546": "ŁÓDŹ",
        "90547": "ŁÓDŹ",
        "90549": "ŁÓDŹ",
        "90550": "ŁÓDŹ",
        "90552": "ŁÓDŹ",
        "90553": "ŁÓDŹ",
        "90554": "ŁÓDŹ",
        "90556": "ŁÓDŹ",
        "90557": "ŁÓDŹ",
        "90558": "ŁÓDŹ",
        "90559": "ŁÓDŹ",
        "90560": "ŁÓDŹ",
        "90561": "ŁÓDŹ",
        "90562": "ŁÓDŹ",
        "90563": "ŁÓDŹ",
        "90567": "ŁÓDŹ",
        "90568": "ŁÓDŹ",
        "90569": "ŁÓDŹ",
        "90570": "ŁÓDŹ",
        "90571": "ŁÓDŹ",
        "90601": "ŁÓDŹ",
        "90602": "ŁÓDŹ",
        "90603": "ŁÓDŹ",
        "90604": "ŁÓDŹ",
        "90606": "ŁÓDŹ",
        "90607": "ŁÓDŹ",
        "90608": "ŁÓDŹ",
        "90609": "ŁÓDŹ",
        "90612": "ŁÓDŹ",
        "90613": "ŁÓDŹ",
        "90615": "ŁÓDŹ",
        "90616": "ŁÓDŹ",
        "90617": "ŁÓDŹ",
        "90618": "ŁÓDŹ",
        "90619": "ŁÓDŹ",
        "90623": "ŁÓDŹ",
        "90624": "ŁÓDŹ",
        "90625": "ŁÓDŹ",
        "90626": "ŁÓDŹ",
        "90629": "ŁÓDŹ",
        "90630": "ŁÓDŹ",
        "90631": "ŁÓDŹ",
        "90632": "ŁÓDŹ",
        "90635": "ŁÓDŹ",
        "90636": "ŁÓDŹ",
        "90637": "ŁÓDŹ",
        "90638": "ŁÓDŹ",
        "90639": "ŁÓDŹ",
        "90640": "ŁÓDŹ",
        "90642": "ŁÓDŹ",
        "90643": "ŁÓDŹ",
        "90644": "ŁÓDŹ",
        "90645": "ŁÓDŹ",
        "90646": "ŁÓDŹ",
        "90647": "ŁÓDŹ",
        "90648": "ŁÓDŹ",
        "90701": "ŁÓDŹ",
        "90702": "ŁÓDŹ",
        "90703": "ŁÓDŹ",
        "90704": "ŁÓDŹ",
        "90706": "ŁÓDŹ",
        "90707": "ŁÓDŹ",
        "90708": "ŁÓDŹ",
        "90710": "ŁÓDŹ",
        "90711": "ŁÓDŹ",
        "90712": "ŁÓDŹ",
        "90713": "ŁÓDŹ",
        "90715": "ŁÓDŹ",
        "90716": "ŁÓDŹ",
        "90717": "ŁÓDŹ",
        "90718": "ŁÓDŹ",
        "90720": "ŁÓDŹ",
        "90721": "ŁÓDŹ",
        "90722": "ŁÓDŹ",
        "90723": "ŁÓDŹ",
        "90725": "ŁÓDŹ",
        "90727": "ŁÓDŹ",
        "90728": "ŁÓDŹ",
        "90729": "ŁÓDŹ",
        "90730": "ŁÓDŹ",
        "90731": "ŁÓDŹ",
        "90732": "ŁÓDŹ",
        "90734": "ŁÓDŹ",
        "90735": "ŁÓDŹ",
        "90736": "ŁÓDŹ",
        "90737": "ŁÓDŹ",
        "90739": "ŁÓDŹ",
        "90740": "ŁÓDŹ",
        "90741": "ŁÓDŹ",
        "90742": "ŁÓDŹ",
        "90743": "ŁÓDŹ",
        "90745": "ŁÓDŹ",
        "90746": "ŁÓDŹ",
        "90747": "ŁÓDŹ",
        "90748": "ŁÓDŹ",
        "90749": "ŁÓDŹ",
        "90750": "ŁÓDŹ",
        "90752": "ŁÓDŹ",
        "90753": "ŁÓDŹ",
        "90754": "ŁÓDŹ",
        "90755": "ŁÓDŹ",
        "90756": "ŁÓDŹ",
        "90757": "ŁÓDŹ",
        "90758": "ŁÓDŹ",
        "90759": "ŁÓDŹ",
        "90760": "ŁÓDŹ",
        "90762": "ŁÓDŹ",
        "90763": "ŁÓDŹ",
        "90764": "ŁÓDŹ",
        "90765": "ŁÓDŹ",
        "90766": "ŁÓDŹ",
        "90767": "ŁÓDŹ",
        "90768": "ŁÓDŹ",
        "90900": "ŁÓDŹ",
        "90920": "ŁÓDŹ",
        "90921": "ŁÓDŹ",
        "90924": "ŁÓDŹ",
        "90926": "ŁÓDŹ",
        "90928": "ŁÓDŹ",
        "90930": "ŁÓDŹ",
        "90940": "ŁÓDŹ",
        "90948": "ŁÓDŹ",
        "90950": "ŁÓDŹ",
        "90951": "ŁÓDŹ",
        "90952": "ŁÓDŹ",
        "90953": "ŁÓDŹ",
        "90954": "ŁÓDŹ",
        "90955": "ŁÓDŹ",
        "90957": "ŁÓDŹ",
        "90959": "ŁÓDŹ",
        "90960": "ŁÓDŹ",
        "90961": "ŁÓDŹ",
        "90962": "ŁÓDŹ",
        "90963": "ŁÓDŹ",
        "90964": "ŁÓDŹ",
        "90965": "ŁÓDŹ",
        "90966": "ŁÓDŹ",
        "90967": "ŁÓDŹ",
        "90968": "ŁÓDŹ",
        "90969": "ŁÓDŹ",
        "90970": "ŁÓDŹ",
        "90971": "ŁÓDŹ",
        "90972": "ŁÓDŹ",
        "90973": "ŁÓDŹ",
        "90974": "ŁÓDŹ",
        "90975": "ŁÓDŹ",
        "90976": "ŁÓDŹ",
        "90977": "ŁÓDŹ",
        "90978": "ŁÓDŹ",
        "90980": "ŁÓDŹ",
        "90981": "ŁÓDŹ",
        "90982": "ŁÓDŹ",
        "90983": "ŁÓDŹ",
        "90984": "ŁÓDŹ",
        "90985": "ŁÓDŹ",
        "90986": "ŁÓDŹ",
        "90987": "ŁÓDŹ",
        "90988": "ŁÓDŹ",
        "90989": "ŁÓDŹ",
        "90990": "ŁÓDŹ",
        "90991": "ŁÓDŹ",
        "90992": "ŁÓDŹ",
        "90993": "ŁÓDŹ",
        "91001": "ŁÓDŹ",
        "91002": "ŁÓDŹ",
        "91003": "ŁÓDŹ",
        "91004": "ŁÓDŹ",
        "91005": "ŁÓDŹ",
        "91006": "ŁÓDŹ",
        "91008": "ŁÓDŹ",
        "91009": "ŁÓDŹ",
        "91010": "ŁÓDŹ",
        "91012": "ŁÓDŹ",
        "91013": "ŁÓDŹ",
        "91015": "ŁÓDŹ",
        "91016": "ŁÓDŹ",
        "91017": "ŁÓDŹ",
        "91018": "ŁÓDŹ",
        "91020": "ŁÓDŹ",
        "91021": "ŁÓDŹ",
        "91022": "ŁÓDŹ",
        "91023": "ŁÓDŹ",
        "91024": "ŁÓDŹ",
        "91025": "ŁÓDŹ",
        "91026": "ŁÓDŹ",
        "91027": "ŁÓDŹ",
        "91028": "ŁÓDŹ",
        "91029": "ŁÓDŹ",
        "91030": "ŁÓDŹ",
        "91031": "ŁÓDŹ",
        "91032": "ŁÓDŹ",
        "91033": "ŁÓDŹ",
        "91034": "ŁÓDŹ",
        "91035": "ŁÓDŹ",
        "91036": "ŁÓDŹ",
        "91037": "ŁÓDŹ",
        "91038": "ŁÓDŹ",
        "91039": "ŁÓDŹ",
        "91040": "ŁÓDŹ",
        "91041": "ŁÓDŹ",
        "91042": "ŁÓDŹ",
        "91043": "ŁÓDŹ",
        "91044": "ŁÓDŹ",
        "91045": "ŁÓDŹ",
        "91046": "ŁÓDŹ",
        "91048": "ŁÓDŹ",
        "91049": "ŁÓDŹ",
        "91050": "ŁÓDŹ",
        "91051": "ŁÓDŹ",
        "91052": "ŁÓDŹ",
        "91053": "ŁÓDŹ",
        "91054": "ŁÓDŹ",
        "91055": "ŁÓDŹ",
        "91056": "ŁÓDŹ",
        "91058": "ŁÓDŹ",
        "91059": "ŁÓDŹ",
        "91061": "ŁÓDŹ",
        "91062": "ŁÓDŹ",
        "91063": "ŁÓDŹ",
        "91064": "ŁÓDŹ",
        "91065": "ŁÓDŹ",
        "91066": "ŁÓDŹ",
        "91067": "ŁÓDŹ",
        "91068": "ŁÓDŹ",
        "91069": "ŁÓDŹ",
        "91070": "ŁÓDŹ",
        "91071": "ŁÓDŹ",
        "91072": "ŁÓDŹ",
        "91073": "ŁÓDŹ",
        "91074": "ŁÓDŹ",
        "91075": "ŁÓDŹ",
        "91076": "ŁÓDŹ",
        "91078": "ŁÓDŹ",
        "91079": "ŁÓDŹ",
        "91080": "ŁÓDŹ",
        "91082": "ŁÓDŹ",
        "91083": "ŁÓDŹ",
        "91084": "ŁÓDŹ",
        "91085": "ŁÓDŹ",
        "91087": "ŁÓDŹ",
        "91088": "ŁÓDŹ",
        "91089": "ŁÓDŹ",
        "91090": "ŁÓDŹ",
        "91101": "ŁÓDŹ",
        "91102": "ŁÓDŹ",
        "91103": "ŁÓDŹ",
        "91104": "ŁÓDŹ",
        "91110": "ŁÓDŹ",
        "91111": "ŁÓDŹ",
        "91115": "ŁÓDŹ",
        "91116": "ŁÓDŹ",
        "91117": "ŁÓDŹ",
        "91120": "ŁÓDŹ",
        "91127": "ŁÓDŹ",
        "91128": "ŁÓDŹ",
        "91129": "ŁÓDŹ",
        "91130": "ŁÓDŹ",
        "91134": "ŁÓDŹ",
        "91135": "ŁÓDŹ",
        "91140": "ŁÓDŹ",
        "91141": "ŁÓDŹ",
        "91142": "ŁÓDŹ",
        "91143": "ŁÓDŹ",
        "91144": "ŁÓDŹ",
        "91148": "ŁÓDŹ",
        "91149": "ŁÓDŹ",
        "91150": "ŁÓDŹ",
        "91151": "ŁÓDŹ",
        "91154": "ŁÓDŹ",
        "91155": "ŁÓDŹ",
        "91156": "ŁÓDŹ",
        "91157": "ŁÓDŹ",
        "91158": "ŁÓDŹ",
        "91159": "ŁÓDŹ",
        "91160": "ŁÓDŹ",
        "91161": "ŁÓDŹ",
        "91162": "ŁÓDŹ",
        "91163": "ŁÓDŹ",
        "91164": "ŁÓDŹ",
        "91165": "ŁÓDŹ",
        "91166": "ŁÓDŹ",
        "91167": "ŁÓDŹ",
        "91168": "ŁÓDŹ",
        "91169": "ŁÓDŹ",
        "91170": "ŁÓDŹ",
        "91171": "ŁÓDŹ",
        "91172": "ŁÓDŹ",
        "91173": "ŁÓDŹ",
        "91174": "ŁÓDŹ",
        "91175": "ŁÓDŹ",
        "91176": "ŁÓDŹ",
        "91177": "ŁÓDŹ",
        "91178": "ŁÓDŹ",
        "91179": "ŁÓDŹ",
        "91180": "ŁÓDŹ",
        "91181": "ŁÓDŹ",
        "91182": "ŁÓDŹ",
        "91183": "ŁÓDŹ",
        "91184": "ŁÓDŹ",
        "91185": "ŁÓDŹ",
        "91186": "ŁÓDŹ",
        "91187": "ŁÓDŹ",
        "91188": "ŁÓDŹ",
        "91189": "ŁÓDŹ",
        "91201": "ŁÓDŹ",
        "91202": "ŁÓDŹ",
        "91203": "ŁÓDŹ",
        "91204": "ŁÓDŹ",
        "91205": "ŁÓDŹ",
        "91210": "ŁÓDŹ",
        "91211": "ŁÓDŹ",
        "91212": "ŁÓDŹ",
        "91213": "ŁÓDŹ",
        "91214": "ŁÓDŹ",
        "91215": "ŁÓDŹ",
        "91218": "ŁÓDŹ",
        "91219": "ŁÓDŹ",
        "91220": "ŁÓDŹ",
        "91221": "ŁÓDŹ",
        "91222": "ŁÓDŹ",
        "91223": "ŁÓDŹ",
        "91224": "ŁÓDŹ",
        "91225": "ŁÓDŹ",
        "91226": "ŁÓDŹ",
        "91227": "ŁÓDŹ",
        "91228": "ŁÓDŹ",
        "91229": "ŁÓDŹ",
        "91230": "ŁÓDŹ",
        "91231": "ŁÓDŹ",
        "91232": "ŁÓDŹ",
        "91233": "ŁÓDŹ",
        "91301": "ŁÓDŹ",
        "91302": "ŁÓDŹ",
        "91303": "ŁÓDŹ",
        "91304": "ŁÓDŹ",
        "91305": "ŁÓDŹ",
        "91306": "ŁÓDŹ",
        "91308": "ŁÓDŹ",
        "91309": "ŁÓDŹ",
        "91310": "ŁÓDŹ",
        "91311": "ŁÓDŹ",
        "91312": "ŁÓDŹ",
        "91314": "ŁÓDŹ",
        "91315": "ŁÓDŹ",
        "91316": "ŁÓDŹ",
        "91318": "ŁÓDŹ",
        "91320": "ŁÓDŹ",
        "91321": "ŁÓDŹ",
        "91322": "ŁÓDŹ",
        "91323": "ŁÓDŹ",
        "91324": "ŁÓDŹ",
        "91327": "ŁÓDŹ",
        "91328": "ŁÓDŹ",
        "91329": "ŁÓDŹ",
        "91333": "ŁÓDŹ",
        "91334": "ŁÓDŹ",
        "91335": "ŁÓDŹ",
        "91336": "ŁÓDŹ",
        "91337": "ŁÓDŹ",
        "91338": "ŁÓDŹ",
        "91340": "ŁÓDŹ",
        "91341": "ŁÓDŹ",
        "91342": "ŁÓDŹ",
        "91345": "ŁÓDŹ",
        "91346": "ŁÓDŹ",
        "91347": "ŁÓDŹ",
        "91348": "ŁÓDŹ",
        "91349": "ŁÓDŹ",
        "91350": "ŁÓDŹ",
        "91351": "ŁÓDŹ",
        "91355": "ŁÓDŹ",
        "91356": "ŁÓDŹ",
        "91357": "ŁÓDŹ",
        "91358": "ŁÓDŹ",
        "91359": "ŁÓDŹ",
        "91360": "ŁÓDŹ",
        "91362": "ŁÓDŹ",
        "91363": "ŁÓDŹ",
        "91364": "ŁÓDŹ",
        "91365": "ŁÓDŹ",
        "91366": "ŁÓDŹ",
        "91370": "ŁÓDŹ",
        "91371": "ŁÓDŹ",
        "91372": "ŁÓDŹ",
        "91373": "ŁÓDŹ",
        "91402": "ŁÓDŹ",
        "91403": "ŁÓDŹ",
        "91404": "ŁÓDŹ",
        "91408": "ŁÓDŹ",
        "91409": "ŁÓDŹ",
        "91410": "ŁÓDŹ",
        "91414": "ŁÓDŹ",
        "91415": "ŁÓDŹ",
        "91416": "ŁÓDŹ",
        "91417": "ŁÓDŹ",
        "91420": "ŁÓDŹ",
        "91421": "ŁÓDŹ",
        "91422": "ŁÓDŹ",
        "91423": "ŁÓDŹ",
        "91425": "ŁÓDŹ",
        "91426": "ŁÓDŹ",
        "91427": "ŁÓDŹ",
        "91430": "ŁÓDŹ",
        "91431": "ŁÓDŹ",
        "91432": "ŁÓDŹ",
        "91433": "ŁÓDŹ",
        "91434": "ŁÓDŹ",
        "91437": "ŁÓDŹ",
        "91438": "ŁÓDŹ",
        "91439": "ŁÓDŹ",
        "91440": "ŁÓDŹ",
        "91441": "ŁÓDŹ",
        "91444": "ŁÓDŹ",
        "91445": "ŁÓDŹ",
        "91446": "ŁÓDŹ",
        "91449": "ŁÓDŹ",
        "91450": "ŁÓDŹ",
        "91455": "ŁÓDŹ",
        "91456": "ŁÓDŹ",
        "91457": "ŁÓDŹ",
        "91458": "ŁÓDŹ",
        "91459": "ŁÓDŹ",
        "91462": "ŁÓDŹ",
        "91463": "ŁÓDŹ",
        "91464": "ŁÓDŹ",
        "91465": "ŁÓDŹ",
        "91468": "ŁÓDŹ",
        "91469": "ŁÓDŹ",
        "91470": "ŁÓDŹ",
        "91471": "ŁÓDŹ",
        "91473": "ŁÓDŹ",
        "91474": "ŁÓDŹ",
        "91475": "ŁÓDŹ",
        "91478": "ŁÓDŹ",
        "91479": "ŁÓDŹ",
        "91480": "ŁÓDŹ",
        "91481": "ŁÓDŹ",
        "91485": "ŁÓDŹ",
        "91486": "ŁÓDŹ",
        "91487": "ŁÓDŹ",
        "91488": "ŁÓDŹ",
        "91489": "ŁÓDŹ",
        "91490": "ŁÓDŹ",
        "91491": "ŁÓDŹ",
        "91492": "ŁÓDŹ",
        "91493": "ŁÓDŹ",
        "91495": "ŁÓDŹ",
        "91496": "ŁÓDŹ",
        "91497": "ŁÓDŹ",
        "91498": "ŁÓDŹ",
        "91502": "ŁÓDŹ",
        "91503": "ŁÓDŹ",
        "91504": "ŁÓDŹ",
        "91505": "ŁÓDŹ",
        "91506": "ŁÓDŹ",
        "91509": "ŁÓDŹ",
        "91510": "ŁÓDŹ",
        "91511": "ŁÓDŹ",
        "91512": "ŁÓDŹ",
        "91513": "ŁÓDŹ",
        "91514": "ŁÓDŹ",
        "91518": "ŁÓDŹ",
        "91519": "ŁÓDŹ",
        "91520": "ŁÓDŹ",
        "91521": "ŁÓDŹ",
        "91522": "ŁÓDŹ",
        "91523": "ŁÓDŹ",
        "91524": "ŁÓDŹ",
        "91526": "ŁÓDŹ",
        "91527": "ŁÓDŹ",
        "91528": "ŁÓDŹ",
        "91529": "ŁÓDŹ",
        "91530": "ŁÓDŹ",
        "91531": "ŁÓDŹ",
        "91533": "ŁÓDŹ",
        "91534": "ŁÓDŹ",
        "91535": "ŁÓDŹ",
        "91536": "ŁÓDŹ",
        "91601": "ŁÓDŹ",
        "91602": "ŁÓDŹ",
        "91603": "ŁÓDŹ",
        "91604": "ŁÓDŹ",
        "91605": "ŁÓDŹ",
        "91606": "ŁÓDŹ",
        "91609": "ŁÓDŹ",
        "91610": "ŁÓDŹ",
        "91611": "ŁÓDŹ",
        "91612": "ŁÓDŹ",
        "91613": "ŁÓDŹ",
        "91614": "ŁÓDŹ",
        "91615": "ŁÓDŹ",
        "91616": "ŁÓDŹ",
        "91701": "ŁÓDŹ",
        "91702": "ŁÓDŹ",
        "91703": "ŁÓDŹ",
        "91704": "ŁÓDŹ",
        "91705": "ŁÓDŹ",
        "91708": "ŁÓDŹ",
        "91709": "ŁÓDŹ",
        "91710": "ŁÓDŹ",
        "91711": "ŁÓDŹ",
        "91712": "ŁÓDŹ",
        "91713": "ŁÓDŹ",
        "91716": "ŁÓDŹ",
        "91717": "ŁÓDŹ",
        "91718": "ŁÓDŹ",
        "91719": "ŁÓDŹ",
        "91720": "ŁÓDŹ",
        "91725": "ŁÓDŹ",
        "91726": "ŁÓDŹ",
        "91727": "ŁÓDŹ",
        "91728": "ŁÓDŹ",
        "91729": "ŁÓDŹ",
        "91734": "ŁÓDŹ",
        "91735": "ŁÓDŹ",
        "91736": "ŁÓDŹ",
        "91737": "ŁÓDŹ",
        "91738": "ŁÓDŹ",
        "91739": "ŁÓDŹ",
        "91743": "ŁÓDŹ",
        "91744": "ŁÓDŹ",
        "91745": "ŁÓDŹ",
        "91746": "ŁÓDŹ",
        "91747": "ŁÓDŹ",
        "91748": "ŁÓDŹ",
        "91754": "ŁÓDŹ",
        "91755": "ŁÓDŹ",
        "91756": "ŁÓDŹ",
        "91757": "ŁÓDŹ",
        "91761": "ŁÓDŹ",
        "91762": "ŁÓDŹ",
        "91763": "ŁÓDŹ",
        "91764": "ŁÓDŹ",
        "91765": "ŁÓDŹ",
        "91766": "ŁÓDŹ",
        "91801": "ŁÓDŹ",
        "91802": "ŁÓDŹ",
        "91803": "ŁÓDŹ",
        "91804": "ŁÓDŹ",
        "91805": "ŁÓDŹ",
        "91806": "ŁÓDŹ",
        "91809": "ŁÓDŹ",
        "91810": "ŁÓDŹ",
        "91811": "ŁÓDŹ",
        "91812": "ŁÓDŹ",
        "91815": "ŁÓDŹ",
        "91816": "ŁÓDŹ",
        "91817": "ŁÓDŹ",
        "91818": "ŁÓDŹ",
        "91819": "ŁÓDŹ",
        "91822": "ŁÓDŹ",
        "91823": "ŁÓDŹ",
        "91824": "ŁÓDŹ",
        "91825": "ŁÓDŹ",
        "91826": "ŁÓDŹ",
        "91829": "ŁÓDŹ",
        "91830": "ŁÓDŹ",
        "91831": "ŁÓDŹ",
        "91832": "ŁÓDŹ",
        "91833": "ŁÓDŹ",
        "91834": "ŁÓDŹ",
        "91836": "ŁÓDŹ",
        "91837": "ŁÓDŹ",
        "91838": "ŁÓDŹ",
        "91839": "ŁÓDŹ",
        "91842": "ŁÓDŹ",
        "91843": "ŁÓDŹ",
        "91844": "ŁÓDŹ",
        "91845": "ŁÓDŹ",
        "91848": "ŁÓDŹ",
        "91849": "ŁÓDŹ",
        "91850": "ŁÓDŹ",
        "91851": "ŁÓDŹ",
        "91852": "ŁÓDŹ",
        "91853": "ŁÓDŹ",
        "91854": "ŁÓDŹ",
        "91855": "ŁÓDŹ",
        "91857": "ŁÓDŹ",
        "91858": "ŁÓDŹ",
        "91859": "ŁÓDŹ",
        "91860": "ŁÓDŹ",
        "91862": "ŁÓDŹ",
        "91863": "ŁÓDŹ",
        "91864": "ŁÓDŹ",
        "91865": "ŁÓDŹ",
        "91866": "ŁÓDŹ",
        "91867": "ŁÓDŹ",
        "92001": "ŁÓDŹ",
        "92002": "ŁÓDŹ",
        "92003": "ŁÓDŹ",
        "92005": "ŁÓDŹ",
        "92006": "ŁÓDŹ",
        "92007": "ŁÓDŹ",
        "92008": "ŁÓDŹ",
        "92009": "ŁÓDŹ",
        "92010": "ŁÓDŹ",
        "92013": "ŁÓDŹ",
        "92014": "ŁÓDŹ",
        "92015": "ŁÓDŹ",
        "92016": "ŁÓDŹ",
        "92017": "ŁÓDŹ",
        "92018": "ŁÓDŹ",
        "92101": "ŁÓDŹ",
        "92102": "ŁÓDŹ",
        "92103": "ŁÓDŹ",
        "92104": "ŁÓDŹ",
        "92107": "ŁÓDŹ",
        "92108": "ŁÓDŹ",
        "92109": "ŁÓDŹ",
        "92110": "ŁÓDŹ",
        "92111": "ŁÓDŹ",
        "92114": "ŁÓDŹ",
        "92115": "ŁÓDŹ",
        "92116": "ŁÓDŹ",
        "92117": "ŁÓDŹ",
        "92118": "ŁÓDŹ",
        "92119": "ŁÓDŹ",
        "92120": "ŁÓDŹ",
        "92121": "ŁÓDŹ",
        "92122": "ŁÓDŹ",
        "92123": "ŁÓDŹ",
        "92201": "ŁÓDŹ",
        "92202": "ŁÓDŹ",
        "92203": "ŁÓDŹ",
        "92204": "ŁÓDŹ",
        "92207": "ŁÓDŹ",
        "92208": "ŁÓDŹ",
        "92209": "ŁÓDŹ",
        "92210": "ŁÓDŹ",
        "92213": "ŁÓDŹ",
        "92214": "ŁÓDŹ",
        "92215": "ŁÓDŹ",
        "92216": "ŁÓDŹ",
        "92219": "ŁÓDŹ",
        "92220": "ŁÓDŹ",
        "92221": "ŁÓDŹ",
        "92223": "ŁÓDŹ",
        "92226": "ŁÓDŹ",
        "92227": "ŁÓDŹ",
        "92228": "ŁÓDŹ",
        "92229": "ŁÓDŹ",
        "92230": "ŁÓDŹ",
        "92231": "ŁÓDŹ",
        "92232": "ŁÓDŹ",
        "92235": "ŁÓDŹ",
        "92236": "ŁÓDŹ",
        "92237": "ŁÓDŹ",
        "92238": "ŁÓDŹ",
        "92301": "ŁÓDŹ",
        "92302": "ŁÓDŹ",
        "92303": "ŁÓDŹ",
        "92304": "ŁÓDŹ",
        "92305": "ŁÓDŹ",
        "92306": "ŁÓDŹ",
        "92307": "ŁÓDŹ",
        "92308": "ŁÓDŹ",
        "92309": "ŁÓDŹ",
        "92310": "ŁÓDŹ",
        "92311": "ŁÓDŹ",
        "92312": "ŁÓDŹ",
        "92313": "ŁÓDŹ",
        "92314": "ŁÓDŹ",
        "92315": "ŁÓDŹ",
        "92316": "ŁÓDŹ",
        "92317": "ŁÓDŹ",
        "92318": "ŁÓDŹ",
        "92319": "ŁÓDŹ",
        "92320": "ŁÓDŹ",
        "92321": "ŁÓDŹ",
        "92322": "ŁÓDŹ",
        "92323": "ŁÓDŹ",
        "92326": "ŁÓDŹ",
        "92327": "ŁÓDŹ",
        "92328": "ŁÓDŹ",
        "92331": "ŁÓDŹ",
        "92332": "ŁÓDŹ",
        "92333": "ŁÓDŹ",
        "92334": "ŁÓDŹ",
        "92335": "ŁÓDŹ",
        "92336": "ŁÓDŹ",
        "92337": "ŁÓDŹ",
        "92338": "ŁÓDŹ",
        "92339": "ŁÓDŹ",
        "92340": "ŁÓDŹ",
        "92401": "ŁÓDŹ",
        "92402": "ŁÓDŹ",
        "92403": "ŁÓDŹ",
        "92404": "ŁÓDŹ",
        "92405": "ŁÓDŹ",
        "92407": "ŁÓDŹ",
        "92408": "ŁÓDŹ",
        "92409": "ŁÓDŹ",
        "92410": "ŁÓDŹ",
        "92411": "ŁÓDŹ",
        "92412": "ŁÓDŹ",
        "92413": "ŁÓDŹ",
        "92414": "ŁÓDŹ",
        "92415": "ŁÓDŹ",
        "92416": "ŁÓDŹ",
        "92417": "ŁÓDŹ",
        "92418": "ŁÓDŹ",
        "92419": "ŁÓDŹ",
        "92420": "ŁÓDŹ",
        "92423": "ŁÓDŹ",
        "92427": "ŁÓDŹ",
        "92430": "ŁÓDŹ",
        "92431": "ŁÓDŹ",
        "92432": "ŁÓDŹ",
        "92433": "ŁÓDŹ",
        "92434": "ŁÓDŹ",
        "92435": "ŁÓDŹ",
        "92436": "ŁÓDŹ",
        "92437": "ŁÓDŹ",
        "92438": "ŁÓDŹ",
        "92439": "ŁÓDŹ",
        "92440": "ŁÓDŹ",
        "92441": "ŁÓDŹ",
        "92442": "ŁÓDŹ",
        "92444": "ŁÓDŹ",
        "92445": "ŁÓDŹ",
        "92446": "ŁÓDŹ",
        "92447": "ŁÓDŹ",
        "92448": "ŁÓDŹ",
        "92501": "ŁÓDŹ",
        "92502": "ŁÓDŹ",
        "92503": "ŁÓDŹ",
        "92504": "ŁÓDŹ",
        "92507": "ŁÓDŹ",
        "92508": "ŁÓDŹ",
        "92510": "ŁÓDŹ",
        "92511": "ŁÓDŹ",
        "92512": "ŁÓDŹ",
        "92513": "ŁÓDŹ",
        "92514": "ŁÓDŹ",
        "92515": "ŁÓDŹ",
        "92516": "ŁÓDŹ",
        "92517": "ŁÓDŹ",
        "92518": "ŁÓDŹ",
        "92519": "ŁÓDŹ",
        "92520": "ŁÓDŹ",
        "92521": "ŁÓDŹ",
        "92522": "ŁÓDŹ",
        "92524": "ŁÓDŹ",
        "92525": "ŁÓDŹ",
        "92530": "ŁÓDŹ",
        "92531": "ŁÓDŹ",
        "92532": "ŁÓDŹ",
        "92533": "ŁÓDŹ",
        "92534": "ŁÓDŹ",
        "92535": "ŁÓDŹ",
        "92536": "ŁÓDŹ",
        "92537": "ŁÓDŹ",
        "92538": "ŁÓDŹ",
        "92539": "ŁÓDŹ",
        "92540": "ŁÓDŹ",
        "92541": "ŁÓDŹ",
        "92542": "ŁÓDŹ",
        "92543": "ŁÓDŹ",
        "92544": "ŁÓDŹ",
        "92545": "ŁÓDŹ",
        "92546": "ŁÓDŹ",
        "92547": "ŁÓDŹ",
        "92548": "ŁÓDŹ",
        "92549": "ŁÓDŹ",
        "92550": "ŁÓDŹ",
        "92551": "ŁÓDŹ",
        "92601": "ŁÓDŹ",
        "92602": "ŁÓDŹ",
        "92603": "ŁÓDŹ",
        "92604": "ŁÓDŹ",
        "92605": "ŁÓDŹ",
        "92606": "ŁÓDŹ",
        "92607": "ŁÓDŹ",
        "92608": "ŁÓDŹ",
        "92609": "ŁÓDŹ",
        "92610": "ŁÓDŹ",
        "92611": "ŁÓDŹ",
        "92612": "ŁÓDŹ",
        "92613": "ŁÓDŹ",
        "92614": "ŁÓDŹ",
        "92615": "ŁÓDŹ",
        "92616": "ŁÓDŹ",
        "92617": "ŁÓDŹ",
        "92619": "ŁÓDŹ",
        "92620": "ŁÓDŹ",
        "92621": "ŁÓDŹ",
        "92622": "ŁÓDŹ",
        "92623": "ŁÓDŹ",
        "92624": "ŁÓDŹ",
        "92625": "ŁÓDŹ",
        "92626": "ŁÓDŹ",
        "92627": "ŁÓDŹ",
        "92629": "ŁÓDŹ",
        "92630": "ŁÓDŹ",
        "92631": "ŁÓDŹ",
        "92632": "ŁÓDŹ",
        "92633": "ŁÓDŹ",
        "92634": "ŁÓDŹ",
        "92635": "ŁÓDŹ",
        "92636": "ŁÓDŹ",
        "92637": "ŁÓDŹ",
        "92638": "ŁÓDŹ",
        "92639": "ŁÓDŹ",
        "92640": "ŁÓDŹ",
        "92641": "ŁÓDŹ",
        "92642": "ŁÓDŹ",
        "92643": "ŁÓDŹ",
        "92644": "ŁÓDŹ",
        "92645": "ŁÓDŹ",
        "92647": "ŁÓDŹ",
        "92648": "ŁÓDŹ",
        "92649": "ŁÓDŹ",
        "92650": "ŁÓDŹ",
        "92701": "ŁÓDŹ",
        "92703": "ŁÓDŹ",
        "92704": "ŁÓDŹ",
        "92705": "ŁÓDŹ",
        "92706": "ŁÓDŹ",
        "92707": "ŁÓDŹ",
        "92708": "ŁÓDŹ",
        "92709": "ŁÓDŹ",
        "92710": "ŁÓDŹ",
        "92711": "ŁÓDŹ",
        "92712": "ŁÓDŹ",
        "92713": "ŁÓDŹ",
        "92714": "ŁÓDŹ",
        "92719": "ŁÓDŹ",
        "92720": "ŁÓDŹ",
        "92721": "ŁÓDŹ",
        "92722": "ŁÓDŹ",
        "92723": "ŁÓDŹ",
        "92724": "ŁÓDŹ",
        "92725": "ŁÓDŹ",
        "92726": "ŁÓDŹ",
        "92727": "ŁÓDŹ",
        "92728": "ŁÓDŹ",
        "92729": "ŁÓDŹ",
        "92730": "ŁÓDŹ",
        "92731": "ŁÓDŹ",
        "92732": "ŁÓDŹ",
        "92733": "ŁÓDŹ",
        "92734": "ŁÓDŹ",
        "92735": "ŁÓDŹ",
        "92736": "ŁÓDŹ",
        "92737": "ŁÓDŹ",
        "92738": "ŁÓDŹ",
        "92739": "ŁÓDŹ",
        "92740": "ŁÓDŹ",
        "92741": "ŁÓDŹ",
        "92742": "ŁÓDŹ",
        "92743": "ŁÓDŹ",
        "92750": "ŁÓDŹ",
        "92751": "ŁÓDŹ",
        "92752": "ŁÓDŹ",
        "92753": "ŁÓDŹ",
        "92754": "ŁÓDŹ",
        "92760": "ŁÓDŹ",
        "92761": "ŁÓDŹ",
        "92770": "ŁÓDŹ",
        "92771": "ŁÓDŹ",
        "92772": "ŁÓDŹ",
        "92773": "ŁÓDŹ",
        "92774": "ŁÓDŹ",
        "92775": "ŁÓDŹ",
        "92776": "ŁÓDŹ",
        "92777": "ŁÓDŹ",
        "92780": "ŁÓDŹ",
        "92781": "ŁÓDŹ",
        "92782": "ŁÓDŹ",
        "92783": "ŁÓDŹ",
        "92784": "ŁÓDŹ",
        "93001": "ŁÓDŹ",
        "93002": "ŁÓDŹ",
        "93003": "ŁÓDŹ",
        "93004": "ŁÓDŹ",
        "93005": "ŁÓDŹ",
        "93008": "ŁÓDŹ",
        "93009": "ŁÓDŹ",
        "93010": "ŁÓDŹ",
        "93011": "ŁÓDŹ",
        "93014": "ŁÓDŹ",
        "93015": "ŁÓDŹ",
        "93018": "ŁÓDŹ",
        "93019": "ŁÓDŹ",
        "93020": "ŁÓDŹ",
        "93021": "ŁÓDŹ",
        "93024": "ŁÓDŹ",
        "93025": "ŁÓDŹ",
        "93026": "ŁÓDŹ",
        "93029": "ŁÓDŹ",
        "93030": "ŁÓDŹ",
        "93031": "ŁÓDŹ",
        "93034": "ŁÓDŹ",
        "93035": "ŁÓDŹ",
        "93036": "ŁÓDŹ",
        "93037": "ŁÓDŹ",
        "93038": "ŁÓDŹ",
        "93101": "ŁÓDŹ",
        "93102": "ŁÓDŹ",
        "93105": "ŁÓDŹ",
        "93106": "ŁÓDŹ",
        "93109": "ŁÓDŹ",
        "93110": "ŁÓDŹ",
        "93113": "ŁÓDŹ",
        "93114": "ŁÓDŹ",
        "93115": "ŁÓDŹ",
        "93118": "ŁÓDŹ",
        "93119": "ŁÓDŹ",
        "93120": "ŁÓDŹ",
        "93121": "ŁÓDŹ",
        "93124": "ŁÓDŹ",
        "93126": "ŁÓDŹ",
        "93129": "ŁÓDŹ",
        "93130": "ŁÓDŹ",
        "93133": "ŁÓDŹ",
        "93134": "ŁÓDŹ",
        "93137": "ŁÓDŹ",
        "93138": "ŁÓDŹ",
        "93139": "ŁÓDŹ",
        "93140": "ŁÓDŹ",
        "93142": "ŁÓDŹ",
        "93143": "ŁÓDŹ",
        "93144": "ŁÓDŹ",
        "93148": "ŁÓDŹ",
        "93149": "ŁÓDŹ",
        "93150": "ŁÓDŹ",
        "93153": "ŁÓDŹ",
        "93154": "ŁÓDŹ",
        "93155": "ŁÓDŹ",
        "93156": "ŁÓDŹ",
        "93157": "ŁÓDŹ",
        "93159": "ŁÓDŹ",
        "93160": "ŁÓDŹ",
        "93161": "ŁÓDŹ",
        "93162": "ŁÓDŹ",
        "93165": "ŁÓDŹ",
        "93166": "ŁÓDŹ",
        "93167": "ŁÓDŹ",
        "93170": "ŁÓDŹ",
        "93171": "ŁÓDŹ",
        "93172": "ŁÓDŹ",
        "93173": "ŁÓDŹ",
        "93176": "ŁÓDŹ",
        "93177": "ŁÓDŹ",
        "93180": "ŁÓDŹ",
        "93181": "ŁÓDŹ",
        "93184": "ŁÓDŹ",
        "93185": "ŁÓDŹ",
        "93188": "ŁÓDŹ",
        "93189": "ŁÓDŹ",
        "93191": "ŁÓDŹ",
        "93192": "ŁÓDŹ",
        "93193": "ŁÓDŹ",
        "93201": "ŁÓDŹ",
        "93202": "ŁÓDŹ",
        "93203": "ŁÓDŹ",
        "93204": "ŁÓDŹ",
        "93208": "ŁÓDŹ",
        "93209": "ŁÓDŹ",
        "93210": "ŁÓDŹ",
        "93212": "ŁÓDŹ",
        "93213": "ŁÓDŹ",
        "93217": "ŁÓDŹ",
        "93218": "ŁÓDŹ",
        "93219": "ŁÓDŹ",
        "93220": "ŁÓDŹ",
        "93221": "ŁÓDŹ",
        "93222": "ŁÓDŹ",
        "93223": "ŁÓDŹ",
        "93224": "ŁÓDŹ",
        "93225": "ŁÓDŹ",
        "93228": "ŁÓDŹ",
        "93229": "ŁÓDŹ",
        "93230": "ŁÓDŹ",
        "93231": "ŁÓDŹ",
        "93232": "ŁÓDŹ",
        "93233": "ŁÓDŹ",
        "93235": "ŁÓDŹ",
        "93236": "ŁÓDŹ",
        "93237": "ŁÓDŹ",
        "93238": "ŁÓDŹ",
        "93239": "ŁÓDŹ",
        "93240": "ŁÓDŹ",
        "93241": "ŁÓDŹ",
        "93242": "ŁÓDŹ",
        "93243": "ŁÓDŹ",
        "93244": "ŁÓDŹ",
        "93245": "ŁÓDŹ",
        "93247": "ŁÓDŹ",
        "93248": "ŁÓDŹ",
        "93249": "ŁÓDŹ",
        "93252": "ŁÓDŹ",
        "93253": "ŁÓDŹ",
        "93254": "ŁÓDŹ",
        "93256": "ŁÓDŹ",
        "93257": "ŁÓDŹ",
        "93258": "ŁÓDŹ",
        "93259": "ŁÓDŹ",
        "93262": "ŁÓDŹ",
        "93263": "ŁÓDŹ",
        "93264": "ŁÓDŹ",
        "93266": "ŁÓDŹ",
        "93267": "ŁÓDŹ",
        "93271": "ŁÓDŹ",
        "93272": "ŁÓDŹ",
        "93273": "ŁÓDŹ",
        "93276": "ŁÓDŹ",
        "93277": "ŁÓDŹ",
        "93278": "ŁÓDŹ",
        "93279": "ŁÓDŹ",
        "93280": "ŁÓDŹ",
        "93281": "ŁÓDŹ",
        "93285": "ŁÓDŹ",
        "93286": "ŁÓDŹ",
        "93302": "ŁÓDŹ",
        "93303": "ŁÓDŹ",
        "93304": "ŁÓDŹ",
        "93305": "ŁÓDŹ",
        "93308": "ŁÓDŹ",
        "93309": "ŁÓDŹ",
        "93310": "ŁÓDŹ",
        "93311": "ŁÓDŹ",
        "93312": "ŁÓDŹ",
        "93313": "ŁÓDŹ",
        "93315": "ŁÓDŹ",
        "93316": "ŁÓDŹ",
        "93317": "ŁÓDŹ",
        "93318": "ŁÓDŹ",
        "93319": "ŁÓDŹ",
        "93320": "ŁÓDŹ",
        "93321": "ŁÓDŹ",
        "93322": "ŁÓDŹ",
        "93323": "ŁÓDŹ",
        "93324": "ŁÓDŹ",
        "93325": "ŁÓDŹ",
        "93326": "ŁÓDŹ",
        "93327": "ŁÓDŹ",
        "93328": "ŁÓDŹ",
        "93329": "ŁÓDŹ",
        "93330": "ŁÓDŹ",
        "93331": "ŁÓDŹ",
        "93332": "ŁÓDŹ",
        "93333": "ŁÓDŹ",
        "93334": "ŁÓDŹ",
        "93335": "ŁÓDŹ",
        "93337": "ŁÓDŹ",
        "93338": "ŁÓDŹ",
        "93339": "ŁÓDŹ",
        "93340": "ŁÓDŹ",
        "93341": "ŁÓDŹ",
        "93342": "ŁÓDŹ",
        "93344": "ŁÓDŹ",
        "93345": "ŁÓDŹ",
        "93346": "ŁÓDŹ",
        "93347": "ŁÓDŹ",
        "93348": "ŁÓDŹ",
        "93349": "ŁÓDŹ",
        "93350": "ŁÓDŹ",
        "93351": "ŁÓDŹ",
        "93352": "ŁÓDŹ",
        "93353": "ŁÓDŹ",
        "93354": "ŁÓDŹ",
        "93355": "ŁÓDŹ",
        "93356": "ŁÓDŹ",
        "93357": "ŁÓDŹ",
        "93358": "ŁÓDŹ",
        "93359": "ŁÓDŹ",
        "93360": "ŁÓDŹ",
        "93361": "ŁÓDŹ",
        "93362": "ŁÓDŹ",
        "93363": "ŁÓDŹ",
        "93364": "ŁÓDŹ",
        "93365": "ŁÓDŹ",
        "93367": "ŁÓDŹ",
        "93368": "ŁÓDŹ",
        "93369": "ŁÓDŹ",
        "93370": "ŁÓDŹ",
        "93371": "ŁÓDŹ",
        "93372": "ŁÓDŹ",
        "93373": "ŁÓDŹ",
        "93374": "ŁÓDŹ",
        "93376": "ŁÓDŹ",
        "93377": "ŁÓDŹ",
        "93378": "ŁÓDŹ",
        "93379": "ŁÓDŹ",
        "93380": "ŁÓDŹ",
        "93385": "ŁÓDŹ",
        "93401": "ŁÓDŹ",
        "93402": "ŁÓDŹ",
        "93403": "ŁÓDŹ",
        "93404": "ŁÓDŹ",
        "93405": "ŁÓDŹ",
        "93406": "ŁÓDŹ",
        "93408": "ŁÓDŹ",
        "93409": "ŁÓDŹ",
        "93410": "ŁÓDŹ",
        "93411": "ŁÓDŹ",
        "93412": "ŁÓDŹ",
        "93413": "ŁÓDŹ",
        "93414": "ŁÓDŹ",
        "93415": "ŁÓDŹ",
        "93418": "ŁÓDŹ",
        "93419": "ŁÓDŹ",
        "93420": "ŁÓDŹ",
        "93423": "ŁÓDŹ",
        "93424": "ŁÓDŹ",
        "93425": "ŁÓDŹ",
        "93426": "ŁÓDŹ",
        "93427": "ŁÓDŹ",
        "93428": "ŁÓDŹ",
        "93429": "ŁÓDŹ",
        "93430": "ŁÓDŹ",
        "93431": "ŁÓDŹ",
        "93432": "ŁÓDŹ",
        "93433": "ŁÓDŹ",
        "93434": "ŁÓDŹ",
        "93435": "ŁÓDŹ",
        "93436": "ŁÓDŹ",
        "93438": "ŁÓDŹ",
        "93439": "ŁÓDŹ",
        "93440": "ŁÓDŹ",
        "93441": "ŁÓDŹ",
        "93442": "ŁÓDŹ",
        "93443": "ŁÓDŹ",
        "93446": "ŁÓDŹ",
        "93447": "ŁÓDŹ",
        "93448": "ŁÓDŹ",
        "93449": "ŁÓDŹ",
        "93450": "ŁÓDŹ",
        "93451": "ŁÓDŹ",
        "93452": "ŁÓDŹ",
        "93453": "ŁÓDŹ",
        "93454": "ŁÓDŹ",
        "93457": "ŁÓDŹ",
        "93458": "ŁÓDŹ",
        "93459": "ŁÓDŹ",
        "93460": "ŁÓDŹ",
        "93463": "ŁÓDŹ",
        "93464": "ŁÓDŹ",
        "93465": "ŁÓDŹ",
        "93466": "ŁÓDŹ",
        "93467": "ŁÓDŹ",
        "93468": "ŁÓDŹ",
        "93469": "ŁÓDŹ",
        "93472": "ŁÓDŹ",
        "93473": "ŁÓDŹ",
        "93474": "ŁÓDŹ",
        "93475": "ŁÓDŹ",
        "93476": "ŁÓDŹ",
        "93478": "ŁÓDŹ",
        "93479": "ŁÓDŹ",
        "93480": "ŁÓDŹ",
        "93481": "ŁÓDŹ",
        "93482": "ŁÓDŹ",
        "93485": "ŁÓDŹ",
        "93486": "ŁÓDŹ",
        "93487": "ŁÓDŹ",
        "93490": "ŁÓDŹ",
        "93491": "ŁÓDŹ",
        "93492": "ŁÓDŹ",
        "93493": "ŁÓDŹ",
        "93494": "ŁÓDŹ",
        "93501": "ŁÓDŹ",
        "93502": "ŁÓDŹ",
        "93503": "ŁÓDŹ",
        "93504": "ŁÓDŹ",
        "93505": "ŁÓDŹ",
        "93506": "ŁÓDŹ",
        "93509": "ŁÓDŹ",
        "93510": "ŁÓDŹ",
        "93513": "ŁÓDŹ",
        "93515": "ŁÓDŹ",
        "93516": "ŁÓDŹ",
        "93519": "ŁÓDŹ",
        "93520": "ŁÓDŹ",
        "93521": "ŁÓDŹ",
        "93522": "ŁÓDŹ",
        "93523": "ŁÓDŹ",
        "93524": "ŁÓDŹ",
        "93525": "ŁÓDŹ",
        "93526": "ŁÓDŹ",
        "93530": "ŁÓDŹ",
        "93531": "ŁÓDŹ",
        "93533": "ŁÓDŹ",
        "93534": "ŁÓDŹ",
        "93535": "ŁÓDŹ",
        "93536": "ŁÓDŹ",
        "93539": "ŁÓDŹ",
        "93540": "ŁÓDŹ",
        "93541": "ŁÓDŹ",
        "93542": "ŁÓDŹ",
        "93545": "ŁÓDŹ",
        "93546": "ŁÓDŹ",
        "93547": "ŁÓDŹ",
        "93548": "ŁÓDŹ",
        "93549": "ŁÓDŹ",
        "93552": "ŁÓDŹ",
        "93553": "ŁÓDŹ",
        "93554": "ŁÓDŹ",
        "93557": "ŁÓDŹ",
        "93558": "ŁÓDŹ",
        "93559": "ŁÓDŹ",
        "93562": "ŁÓDŹ",
        "93563": "ŁÓDŹ",
        "93564": "ŁÓDŹ",
        "93566": "ŁÓDŹ",
        "93569": "ŁÓDŹ",
        "93570": "ŁÓDŹ",
        "93571": "ŁÓDŹ",
        "93574": "ŁÓDŹ",
        "93575": "ŁÓDŹ",
        "93578": "ŁÓDŹ",
        "93579": "ŁÓDŹ",
        "93582": "ŁÓDŹ",
        "93583": "ŁÓDŹ",
        "93586": "ŁÓDŹ",
        "93588": "ŁÓDŹ",
        "93589": "ŁÓDŹ",
        "93590": "ŁÓDŹ",
        "93610": "ŁÓDŹ",
        "93611": "ŁÓDŹ",
        "93612": "ŁÓDŹ",
        "93613": "ŁÓDŹ",
        "93614": "ŁÓDŹ",
        "93615": "ŁÓDŹ",
        "93616": "ŁÓDŹ",
        "93617": "ŁÓDŹ",
        "93618": "ŁÓDŹ",
        "93619": "ŁÓDŹ",
        "93620": "ŁÓDŹ",
        "93621": "ŁÓDŹ",
        "93622": "ŁÓDŹ",
        "93623": "ŁÓDŹ",
        "93624": "ŁÓDŹ",
        "93631": "ŁÓDŹ",
        "93632": "ŁÓDŹ",
        "93633": "ŁÓDŹ",
        "93635": "ŁÓDŹ",
        "93636": "ŁÓDŹ",
        "93638": "ŁÓDŹ",
        "93640": "ŁÓDŹ",
        "93641": "ŁÓDŹ",
        "93642": "ŁÓDŹ",
        "93643": "ŁÓDŹ",
        "93645": "ŁÓDŹ",
        "93646": "ŁÓDŹ",
        "93647": "ŁÓDŹ",
        "93648": "ŁÓDŹ",
        "93649": "ŁÓDŹ",
        "94001": "ŁÓDŹ",
        "94002": "ŁÓDŹ",
        "94003": "ŁÓDŹ",
        "94004": "ŁÓDŹ",
        "94005": "ŁÓDŹ",
        "94006": "ŁÓDŹ",
        "94007": "ŁÓDŹ",
        "94010": "ŁÓDŹ",
        "94011": "ŁÓDŹ",
        "94012": "ŁÓDŹ",
        "94014": "ŁÓDŹ",
        "94015": "ŁÓDŹ",
        "94016": "ŁÓDŹ",
        "94017": "ŁÓDŹ",
        "94020": "ŁÓDŹ",
        "94021": "ŁÓDŹ",
        "94022": "ŁÓDŹ",
        "94023": "ŁÓDŹ",
        "94024": "ŁÓDŹ",
        "94025": "ŁÓDŹ",
        "94028": "ŁÓDŹ",
        "94029": "ŁÓDŹ",
        "94030": "ŁÓDŹ",
        "94031": "ŁÓDŹ",
        "94032": "ŁÓDŹ",
        "94035": "ŁÓDŹ",
        "94036": "ŁÓDŹ",
        "94037": "ŁÓDŹ",
        "94038": "ŁÓDŹ",
        "94039": "ŁÓDŹ",
        "94040": "ŁÓDŹ",
        "94041": "ŁÓDŹ",
        "94042": "ŁÓDŹ",
        "94043": "ŁÓDŹ",
        "94044": "ŁÓDŹ",
        "94045": "ŁÓDŹ",
        "94046": "ŁÓDŹ",
        "94047": "ŁÓDŹ",
        "94048": "ŁÓDŹ",
        "94049": "ŁÓDŹ",
        "94050": "ŁÓDŹ",
        "94051": "ŁÓDŹ",
        "94052": "ŁÓDŹ",
        "94053": "ŁÓDŹ",
        "94054": "ŁÓDŹ",
        "94055": "ŁÓDŹ",
        "94056": "ŁÓDŹ",
        "94058": "ŁÓDŹ",
        "94060": "ŁÓDŹ",
        "94101": "ŁÓDŹ",
        "94102": "ŁÓDŹ",
        "94103": "ŁÓDŹ",
        "94104": "ŁÓDŹ",
        "94105": "ŁÓDŹ",
        "94106": "ŁÓDŹ",
        "94107": "ŁÓDŹ",
        "94108": "ŁÓDŹ",
        "94109": "ŁÓDŹ",
        "94110": "ŁÓDŹ",
        "94111": "ŁÓDŹ",
        "94112": "ŁÓDŹ",
        "94113": "ŁÓDŹ",
        "94114": "ŁÓDŹ",
        "94115": "ŁÓDŹ",
        "94116": "ŁÓDŹ",
        "94117": "ŁÓDŹ",
        "94118": "ŁÓDŹ",
        "94119": "ŁÓDŹ",
        "94120": "ŁÓDŹ",
        "94121": "ŁÓDŹ",
        "94122": "ŁÓDŹ",
        "94123": "ŁÓDŹ",
        "94124": "ŁÓDŹ",
        "94125": "ŁÓDŹ",
        "94126": "ŁÓDŹ",
        "94127": "ŁÓDŹ",
        "94128": "ŁÓDŹ",
        "94129": "ŁÓDŹ",
        "94130": "ŁÓDŹ",
        "94131": "ŁÓDŹ",
        "94132": "ŁÓDŹ",
        "94133": "ŁÓDŹ",
        "94134": "ŁÓDŹ",
        "94201": "ŁÓDŹ",
        "94202": "ŁÓDŹ",
        "94203": "ŁÓDŹ",
        "94204": "ŁÓDŹ",
        "94205": "ŁÓDŹ",
        "94208": "ŁÓDŹ",
        "94209": "ŁÓDŹ",
        "94212": "ŁÓDŹ",
        "94213": "ŁÓDŹ",
        "94214": "ŁÓDŹ",
        "94215": "ŁÓDŹ",
        "94216": "ŁÓDŹ",
        "94217": "ŁÓDŹ",
        "94218": "ŁÓDŹ",
        "94221": "ŁÓDŹ",
        "94222": "ŁÓDŹ",
        "94223": "ŁÓDŹ",
        "94224": "ŁÓDŹ",
        "94225": "ŁÓDŹ",
        "94226": "ŁÓDŹ",
        "94227": "ŁÓDŹ",
        "94230": "ŁÓDŹ",
        "94231": "ŁÓDŹ",
        "94232": "ŁÓDŹ",
        "94233": "ŁÓDŹ",
        "94234": "ŁÓDŹ",
        "94235": "ŁÓDŹ",
        "94236": "ŁÓDŹ",
        "94237": "ŁÓDŹ",
        "94238": "ŁÓDŹ",
        "94239": "ŁÓDŹ",
        "94240": "ŁÓDŹ",
        "94241": "ŁÓDŹ",
        "94242": "ŁÓDŹ",
        "94243": "ŁÓDŹ",
        "94244": "ŁÓDŹ",
        "94245": "ŁÓDŹ",
        "94246": "ŁÓDŹ",
        "94247": "ŁÓDŹ",
        "94248": "ŁÓDŹ",
        "94249": "ŁÓDŹ",
        "94250": "ŁÓDŹ",
        "94251": "ŁÓDŹ",
        "94252": "ŁÓDŹ",
        "94253": "ŁÓDŹ",
        "94254": "ŁÓDŹ",
        "94255": "ŁÓDŹ",
        "94256": "ŁÓDŹ",
        "94257": "ŁÓDŹ",
        "94258": "ŁÓDŹ",
        "94259": "ŁÓDŹ",
        "94260": "ŁÓDŹ",
        "94261": "ŁÓDŹ",
        "94262": "ŁÓDŹ",
        "94263": "ŁÓDŹ",
        "94264": "ŁÓDŹ",
        "94265": "ŁÓDŹ",
        "94266": "ŁÓDŹ",
        "94267": "ŁÓDŹ",
        "94268": "ŁÓDŹ",
        "94269": "ŁÓDŹ",
        "94270": "ŁÓDŹ",
        "94271": "ŁÓDŹ",
        "94272": "ŁÓDŹ",
        "94273": "ŁÓDŹ",
        "94274": "ŁÓDŹ",
        "94275": "ŁÓDŹ",
        "94276": "ŁÓDŹ",
        "94277": "ŁÓDŹ",
        "94278": "ŁÓDŹ",
        "94279": "ŁÓDŹ",
        "94280": "ŁÓDŹ",
        "94281": "ŁÓDŹ",
        "94282": "ŁÓDŹ",
        "94283": "ŁÓDŹ",
        "94284": "ŁÓDŹ",
        "94285": "ŁÓDŹ",
        "94286": "ŁÓDŹ",
        "94287": "ŁÓDŹ",
        "94290": "ŁÓDŹ",
        "94291": "ŁÓDŹ",
        "94292": "ŁÓDŹ",
        "94301": "ŁÓDŹ",
        "94302": "ŁÓDŹ",
        "94303": "ŁÓDŹ",
        "94304": "ŁÓDŹ",
        "94305": "ŁÓDŹ",
        "94306": "ŁÓDŹ",
        "94307": "ŁÓDŹ",
        "94308": "ŁÓDŹ",
        "94310": "ŁÓDŹ",
        "94311": "ŁÓDŹ",
        "94312": "ŁÓDŹ",
        "94313": "ŁÓDŹ",
        "94314": "ŁÓDŹ",
        "94315": "ŁÓDŹ",
        "94316": "ŁÓDŹ",
        "94317": "ŁÓDŹ",
        "94319": "ŁÓDŹ",
        "94324": "ŁÓDŹ",
        "94325": "ŁÓDŹ",
        "94326": "ŁÓDŹ",
        "94327": "ŁÓDŹ",
        "94328": "ŁÓDŹ",
        "94329": "ŁÓDŹ",
        "94330": "ŁÓDŹ",
        "94331": "ŁÓDŹ",
        "94332": "ŁÓDŹ",
        "94333": "ŁÓDŹ",
        "94334": "ŁÓDŹ",
        "94401": "ŁÓDŹ",
        "94402": "ŁÓDŹ",
        "94403": "ŁÓDŹ",
        "94404": "ŁÓDŹ",
        "94405": "ŁÓDŹ",
        "94406": "ŁÓDŹ",
        "94407": "ŁÓDŹ",
        "94408": "ŁÓDŹ",
        "94409": "ŁÓDŹ",
        "94410": "ŁÓDŹ",
        "94411": "ŁÓDŹ",
        "94412": "ŁÓDŹ",
        "94413": "ŁÓDŹ",
        "94414": "ŁÓDŹ",
        "95001": "ZGIERZ",
        "95002": "ZGIERZ",
        "95006": "ŁÓDŹ",
        "95010": "STRYKÓW",
        "95011": "ZGIERZ",
        "95015": "ZGIERZ",
        "95016": "ZGIERZ",
        "95020": "ŁÓDŹ",
        "95030": "ŁÓDŹ",
        "95035": "OZORKÓW",
        "95036": "OZORKÓW",
        "95037": "OZORKÓW",
        "95039": "ZGIERZ",
        "95040": "KOLUSZKI",
        "95041": "ŁÓDŹ",
        "95042": "KOLUSZKI",
        "95043": "ZGIERZ",
        "95045": "ZGIERZ",
        "95047": "BRZEZINY",
        "95050": "PABIANICE",
        "95054": "PABIANICE",
        "95060": "BRZEZINY",
        "95061": "BRZEZINY",
        "95063": "BRZEZINY",
        "95069": "ALEKSANDRÓW ŁÓDZKI",
        "95070": "ALEKSANDRÓW ŁÓDZKI",
        "95071": "ZGIERZ",
        "95073": "ZGIERZ",
        "95080": "ŁÓDŹ",
        "95081": "PABIANICE",
        "95082": "PABIANICE",
        "95083": "PABIANICE",
        "95100": "ZGIERZ",
        "95101": "ZGIERZ",
        "95102": "ZGIERZ",
        "95103": "ZGIERZ",
        "95110": "ZGIERZ",
        "95200": "PABIANICE",
        "95201": "PABIANICE",
        "95202": "PABIANICE",
        "95204": "PABIANICE",
        "95205": "PABIANICE",
        "96100": "SKIERNIEWICE",
        "96101": "SKIERNIEWICE",
        "96102": "SKIERNIEWICE",
        "96103": "SKIERNIEWICE",
        "96104": "SKIERNIEWICE",
        "96106": "SKIERNIEWICE",
        "96110": "CZĘSTOCHOWA",
        "96111": "SKIERNIEWICE",
        "96115": "SKIERNIEWICE",
        "96116": "SKIERNIEWICE",
        "96124": "SKIERNIEWICE",
        "96126": "SKIERNIEWICE",
        "96127": "SKIERNIEWICE",
        "96128": "SKIERNIEWICE",
        "96130": "SKIERNIEWICE",
        "96200": "RAWA MAZOWIECKA",
        "96201": "RAWA MAZOWIECKA",
        "96206": "RAWA MAZOWIECKA",
        "96208": "RAWA MAZOWIECKA",
        "96214": "RAWA MAZOWIECKA",
        "96230": "RAWA MAZOWIECKA",
        "96232": "RAWA MAZOWIECKA",
        "96300": "ŻYRARDÓW",
        "96301": "ŻYRARDÓW",
        "96302": "ŻYRARDÓW",
        "96304": "ŻYRARDÓW",
        "96313": "GRODZISK MAZOWIECKI",
        "96314": "GRODZISK MAZOWIECKI",
        "96315": "ŻYRARDÓW",
        "96316": "GRODZISK MAZOWIECKI",
        "96317": "ŻYRARDÓW",
        "96320": "MSZCZONÓW",
        "96321": "GRODZISK MAZOWIECKI",
        "96323": "ŻYRARDÓW",
        "96325": "ŻYRARDÓW",
        "96330": "ŻYRARDÓW",
        "96332": "ŻYRARDÓW",
        "96500": "SOCHACZEW",
        "96501": "SOCHACZEW",
        "96502": "SOCHACZEW",
        "96503": "SOCHACZEW",
        "96504": "SOCHACZEW",
        "96505": "SOCHACZEW",
        "96512": "SOCHACZEW",
        "96513": "SOCHACZEW",
        "96514": "SOCHACZEW",
        "96515": "TERESIN",
        "96516": "SOCHACZEW",
        "96520": "SOCHACZEW",
        "96521": "SOCHACZEW",
        "97200": "TOMASZÓW MAZOWIECKI",
        "97201": "TOMASZÓW MAZOWIECKI",
        "97203": "TOMASZÓW MAZOWIECKI",
        "97204": "TOMASZÓW MAZOWIECKI",
        "97212": "TOMASZÓW MAZOWIECKI",
        "97213": "TOMASZÓW MAZOWIECKI",
        "97215": "TOMASZÓW MAZOWIECKI",
        "97216": "TOMASZÓW MAZOWIECKI",
        "97217": "TOMASZÓW MAZOWIECKI",
        "97220": "TOMASZÓW MAZOWIECKI",
        "97221": "TOMASZÓW MAZOWIECKI",
        "97225": "TOMASZÓW MAZOWIECKI",
        "97226": "TOMASZÓW MAZOWIECKI",
        "97280": "TOMASZÓW MAZOWIECKI",
        "97300": "PIOTRKÓW TRYBUNALSKI",
        "97301": "PIOTRKÓW TRYBUNALSKI",
        "97302": "PIOTRKÓW TRYBUNALSKI",
        "97303": "PIOTRKÓW TRYBUNALSKI",
        "97306": "PIOTRKÓW TRYBUNALSKI",
        "97308": "PIOTRKÓW TRYBUNALSKI",
        "97309": "PIOTRKÓW TRYBUNALSKI",
        "97310": "PIOTRKÓW TRYBUNALSKI",
        "97312": "PIOTRKÓW TRYBUNALSKI",
        "97318": "PIOTRKÓW TRYBUNALSKI",
        "97319": "TOMASZÓW MAZOWIECKI",
        "97320": "WOLBÓRZ",
        "97330": "PIOTRKÓW TRYBUNALSKI",
        "97340": "PIOTRKÓW TRYBUNALSKI",
        "97350": "PIOTRKÓW TRYBUNALSKI",
        "97352": "PIOTRKÓW TRYBUNALSKI",
        "97360": "RADOMSKO",
        "97371": "PIOTRKÓW TRYBUNALSKI",
        "97400": "BEŁCHATÓW",
        "97403": "BEŁCHATÓW",
        "97406": "BEŁCHATÓW",
        "97407": "BEŁCHATÓW",
        "97408": "BEŁCHATÓW",
        "97409": "BEŁCHATÓW",
        "97410": "BEŁCHATÓW",
        "97413": "BEŁCHATÓW",
        "97415": "BEŁCHATÓW",
        "97420": "BEŁCHATÓW",
        "97425": "BEŁCHATÓW",
        "97427": "BEŁCHATÓW",
        "97438": "RUSIEC",
        "97500": "RADOMSKO",
        "97501": "RADOMSKO",
        "97503": "RADOMSKO",
        "97504": "RADOMSKO",
        "97505": "RADOMSKO",
        "97510": "PIOTRKÓW TRYBUNALSKI",
        "97512": "RADOMSKO",
        "97515": "RADOMSKO",
        "97524": "RADOMSKO",
        "97525": "RADOMSKO",
        "97532": "RADOMSKO",
        "97540": "RADOMSKO",
        "97545": "RADOMSKO",
        "97561": "RADOMSKO",
        "97565": "RADOMSKO",
        "97570": "RADOMSKO",
        "98100": "ŁASK (NET)",
        "98105": "ŁASK",
        "98113": "ŁASK (NET)",
        "98160": "ŁASK (NET)",
        "98161": "ZDUŃSKA WOLA",
        "98170": "ŁASK (NET)",
        "98200": "SIERADZ",
        "98202": "SIERADZ",
        "98204": "SIERADZ",
        "98209": "SIERADZ",
        "98210": "SIERADZ",
        "98215": "SIERADZ",
        "98220": "ZDUŃSKA WOLA",
        "98230": "ZDUŃSKA WOLA",
        "98231": "ZDUŃSKA WOLA",
        "98235": "BŁASZKI",
        "98240": "ZDUŃSKA WOLA",
        "98260": "SIERADZ",
        "98270": "SIERADZ",
        "98273": "SIERADZ",
        "98275": "SIERADZ",
        "98277": "SIERADZ",
        "98285": "SIERADZ",
        "98290": "SIERADZ",
        "98300": "WIELUŃ",
        "98303": "WIELUŃ",
        "98305": "WIELUŃ",
        "98310": "WIELUŃ",
        "98311": "WIELUŃ",
        "98313": "WIELUŃ",
        "98320": "WIELUŃ",
        "98324": "WIELUŃ",
        "98330": "PAJĘCZNO",
        "98331": "PAJĘCZNO",
        "98332": "PAJĘCZNO",
        "98335": "WIELUŃ",
        "98337": "PAJĘCZNO",
        "98338": "PAJĘCZNO",
        "98345": "WIELUŃ",
        "98346": "WIELUŃ",
        "98350": "WIELUŃ",
        "98354": "PAJĘCZNO",
        "98355": "PAJĘCZNO",
        "98358": "PAJĘCZNO",
        "98360": "WIERUSZÓW",
        "98400": "WIERUSZÓW",
        "98405": "WIERUSZÓW",
        "98410": "WIERUSZÓW",
        "98420": "WIERUSZÓW",
        "98430": "WIERUSZÓW",
        "98432": "WIERUSZÓW",
        "99100": "ŁĘCZYCA",
        "99101": "ŁĘCZYCA",
        "99104": "ŁĘCZYCA (NET)",
        "99105": "ŁĘCZYCA (NET)",
        "99106": "ŁĘCZYCA (NET)",
        "99107": "ŁĘCZYCA (NET)",
        "99120": "ŁĘCZYCA",
        "99122": "ŁĘCZYCA",
        "99140": "ŁĘCZYCA",
        "99142": "ŁĘCZYCA",
        "99150": "ŁĘCZYCA (NET)",
        "99151": "ŁĘCZYCA",
        "99200": "PODDĘBICE",
        "99205": "PODDĘBICE",
        "99207": "PODDĘBICE",
        "99210": "PODDĘBICE (NET)",
        "99220": "PODDĘBICE",
        "99232": "PODDĘBICE",
        "99235": "PODDĘBICE",
        "99300": "KUTNO",
        "99301": "KUTNO",
        "99302": "KUTNO",
        "99306": "KUTNO",
        "99307": "KUTNO",
        "99308": "KUTNO",
        "99310": "KUTNO",
        "99311": "KUTNO",
        "99312": "KUTNO",
        "99313": "KUTNO",
        "99314": "KUTNO",
        "99316": "KUTNO",
        "99319": "KUTNO",
        "99320": "KUTNO",
        "99322": "KUTNO",
        "99323": "KUTNO",
        "99331": "KUTNO",
        "99332": "KUTNO",
        "99333": "KUTNO",
        "99335": "ŁĘCZYCA (NET)",
        "99340": "KROŚNIEWICE",
        "99350": "KUTNO",
        "99352": "KUTNO",
        "99400": "ŁOWICZ",
        "99401": "ŁOWICZ",
        "99402": "ŁOWICZ",
        "99412": "ŁOWICZ",
        "99413": "ŁOWICZ",
        "99414": "ŁOWICZ",
        "99416": "ŁOWICZ",
        "99417": "SKIERNIEWICE",
        "99418": "ŁOWICZ",
        "99420": "ŁOWICZ",
        "99423": "ŁOWICZ",
        "99434": "ŁOWICZ",
        "99436": "ŁOWICZ",
        "99440": "ŁOWICZ",
        "99999": "NIEZNANA LOKALIZACJA",
    }
    return function (zipCode) {
        if (zipCode) {
            zipCode = zipCode.replaceAll('-', '')
        }
        if (zipCode in mainCareLocationByZipCode) {
            return mainCareLocationByZipCode[zipCode];
        } else {
            return '';
        }
    }
})
